/*! Skills Lab — © School House Learning Centre (shlc-tutor.co.uk). All rights reserved.
    Not licensed for reuse, redistribution, resale or derivative works.
    Enquiries: info@shlc-tutor.co.uk  ·  build SHLC-SL-7Q4M2 */
/* ============================================================
   SKILLS LAB · core
   Registry for skill modules, the full-screen shell and its four
   screens (library, practise, teach, board), progress in
   localStorage, dark/light theme. Skill modules register with
   SL.register({...}) and provide make(level, ctx) + teach(host, q, api).
   RULE for teach renderers: all() paints the FINISHED state in one go, no
   replayed animation at speed. Answer only must never flicker through steps.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- host lock ----------
     The lab only starts on our own hostnames. Anywhere else it returns before
     anything is defined, so window.SL never exists; every engine opens with
     `var SL = window.SL; if (!SL) return;` and so no-ops in silence too.
     No thrown error and no message: a lifted copy simply does nothing.
     Allowed: shlc-tutor.co.uk and its subdomains, the store's own myshopify
     host (theme previews), localhost/127.0.0.1 and file:// (empty hostname,
     the local harness). */
  try {
    var _host = String(location.hostname || '').toLowerCase();
    if (!(/(^|\.)shlc-tutor\.co\.uk$/.test(_host)
          || _host === 'c44a55-2.myshopify.com'
          || _host === 'localhost' || _host === '127.0.0.1'
          || _host === '')) return;
  } catch (e) { return; }

  /* Build fingerprint. Deliberately distinctive and carried by any wholesale
     copy of this file: it is what identifies our code in a takedown notice.
     Do not change it without a note in project_shlc_skills_lab_code_protection. */
  var SL_BUILD = 'SHLC-SL-7Q4M2';
  try { window.SL_BUILD = SL_BUILD; } catch (e) {}

  var MINUS = '−';
  function ri(a, b) { return a + Math.floor(Math.random() * (b - a + 1)); }
  function pick(a) { return a[Math.floor(Math.random() * a.length)]; }
  function chance(p) { return Math.random() < p; }
  function shuffle(a) { var i, j, t; for (i = a.length - 1; i > 0; i--) { j = Math.floor(Math.random() * (i + 1)); t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function lsGet(k, d) { try { var v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function narrow() { try { return window.innerWidth <= 640; } catch (e) { return false; } }
  /* the badge, from the CDN copy the rest of the storefront already uses, so it
     costs the page nothing and cannot drift from the site logo. It never renders
     below 40px: the ring text turns to mush and a mushy badge is worse than none. */
  var LOGO_SRC = 'https://shlc-tutor.co.uk/cdn/shop/files/Maths_Online_Tutor_Logo.png?v=1771190336&width=200';
  function logoHTML(cls) { return '<img class="sl-logo' + (cls ? ' ' + cls : '') + '" src="' + LOGO_SRC + '" width="200" height="200" alt="School House Learning Centre">'; }
  function $(id) { return document.getElementById(id); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html !== undefined) e.innerHTML = html; return e; }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  var reduceMotion = false, motionMQ = null;
  try { motionMQ = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)'); reduceMotion = !!(motionMQ && motionMQ.matches); } catch (e) {}
  /* the preference can change while the page is open, so it is read live */
  try { if (motionMQ && motionMQ.addEventListener) motionMQ.addEventListener('change', function (ev) { reduceMotion = !!ev.matches; if (window.SL) window.SL.reduceMotion = reduceMotion; }); } catch (e) {}

  /* ---------- icons: stroke SVG on a 24 grid, one style ---------- */
  function svg(paths) { return '<svg class="ico" viewBox="0 0 24 24" aria-hidden="true">' + paths + '</svg>'; }
  /* The sticker icons (GPT image gen, Aadam 2026-09-15: "yes use these, much better"). One sprite, a cell
     per key, in the order of skill-lab/icons/lab-c-v1/. The element keeps class "ico" so every place that
     sizes an icon sizes the sticker too; skills-lab.css (STICKER ICONS) draws the cell. Anything with no
     cell here keeps its line icon, so a new skill is never iconless. */
  var STK = { teach: 0, practise: 1, speed: 2, board: 3, turn: 4, 'count-together': 5,
    'counting-in-steps': 6, 'place-value': 7, 'more-or-less': 8, 'reading-writing-numbers': 9,
    'comparing-ordering-numbers': 10, 'multiply-divide-by-10-100-1000': 11, 'roman-numerals': 12, 'negative-numbers': 13,
    'expanding-single-brackets': 14, 'expanding-double-brackets': 15, 'expanding-triple-brackets': 16, 'expanding-surd-brackets': 17,
    'completing-the-square': 18, 'factorising-quadratics': 19, 'quadratic-formula': 20,
    'linear-nth-term': 21, 'quadratic-sequences': 22,
    /* sprite v5 (2026-09-25): a sticker for every skill that had none, and the GCSE past papers row */
    'times-tables': 23, 'grid-multiplication': 24, 'column-multiplication': 25, 'short-division': 26,
    'mult-div-decimals': 27, 'recurring-decimals': 28, 'simplifying-surds': 29, 'rationalising': 30,
    'simplifying-algebraic-fractions': 31, 'mult-div-algebraic-fractions': 32, 'add-sub-algebraic-fractions': 33,
    'algebraic-fraction-equations': 34, 'solving-quadratics-factorising': 35, 'rearranging-formulae': 36,
    'algebraic-proof': 37, papers: 38 };
  /* A skill added after 2026-09-25 names its own cell (`sticker: 39` on its register object, carried
     by the manifest), so a new sticker never needs a core push: the sprite and its row count live in
     the stickers css block, which ship.py splices like any other. */
  function stk(key, fallback, cell) {
    var i = STK[key]; if (i === undefined) i = cell;
    if (typeof i !== 'number' || i < 0) return fallback || '';
    return '<i class="ico sl-stk" style="--sx:' + (i % 5) + ';--sy:' + Math.floor(i / 5) + '" aria-hidden="true"></i>';
  }
  var ICON = {
    cross: svg('<path d="M6 6l12 12M18 6L6 18"/>'),
    refresh: svg('<path d="M20 12a8 8 0 1 1-2.4-5.7"/><path d="M20 4v5h-5"/>'),
    dice: svg('<rect x="4" y="4" width="16" height="16" rx="3.5"/><circle cx="9" cy="9" r="1.1" fill="currentColor" stroke="none"/><circle cx="15" cy="9" r="1.1" fill="currentColor" stroke="none"/><circle cx="9" cy="15" r="1.1" fill="currentColor" stroke="none"/><circle cx="15" cy="15" r="1.1" fill="currentColor" stroke="none"/>'),
    tick: svg('<path d="M5 12.5l4.5 4.5L19 7.5"/>'),
    sun: svg('<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2.5M12 19v2.5M2.5 12H5M19 12h2.5M5.3 5.3l1.8 1.8M16.9 16.9l1.8 1.8M5.3 18.7l1.8-1.8M16.9 7.1l1.8-1.8"/>'),
    moon: svg('<path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z"/>'),
    search: svg('<circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/>'),
    plus: svg('<path d="M12 5v14M5 12h14"/>'),
    minus: svg('<path d="M5 12h14"/>'),
    chevR: svg('<path d="M9 6l6 6-6 6"/>'),
    chevL: svg('<path d="M15 6l-6 6 6 6"/>'),
    chevD: svg('<path d="M6 9l6 6 6-6"/>'),
    print: svg('<path d="M7 8V4h10v4"/><rect x="4" y="8" width="16" height="9" rx="2"/><path d="M7 13h10v7H7z"/>'),
    expand: svg('<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>'),
    link: svg('<path d="M10.5 13.5a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1.4 1.4"/><path d="M13.5 10.5a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1.4-1.4"/>'),
    eye: svg('<path d="M2.5 12s3.5-6.5 9.5-6.5 9.5 6.5 9.5 6.5-3.5 6.5-9.5 6.5S2.5 12 2.5 12z"/><circle cx="12" cy="12" r="2.8"/>'),
    eyeOff: svg('<path d="M3 3l18 18"/><path d="M10 5.8A10 10 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17 17 0 0 1-3.2 3.9M6.6 6.6C4 8.4 2.5 12 2.5 12s3.5 6.5 9.5 6.5c1.6 0 3-.4 4.2-1"/>'),
    steps: svg('<path d="M4 18h5v-4h5v-4h5V6"/>'),
    board: svg('<rect x="3" y="4" width="18" height="12" rx="2"/><path d="M12 16v4M8 20h8"/>'),
    list: svg('<path d="M8 6h12M8 12h12M8 18h12"/><circle cx="4.5" cy="6" r="1" fill="currentColor" stroke="none"/><circle cx="4.5" cy="12" r="1" fill="currentColor" stroke="none"/><circle cx="4.5" cy="18" r="1" fill="currentColor" stroke="none"/>'),
    play: svg('<path d="M7.5 4.5l12 7.5-12 7.5z"/>'),
    pause: svg('<path d="M9 5v14M15 5v14"/>'),
    sliders: svg('<path d="M4 7h10M18 7h2M4 17h4M12 17h8M4 12h16"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/>'),
    trophy: svg('<path d="M7.5 4h9v5a4.5 4.5 0 0 1-9 0V4z"/><path d="M7.5 6H4.5a3 3 0 0 0 3 4"/><path d="M16.5 6h3a3 3 0 0 1-3 4"/><path d="M12 13.5V17"/><path d="M8.5 20h7"/>'),
    /* the favourite star, hollow and filled from the same path so the two
       states sit on exactly the same outline and nothing shifts on a tap */
    star: svg('<path d="M12 3.6l2.55 5.17 5.7.83-4.13 4.02.98 5.68L12 16.62l-5.1 2.68.98-5.68L3.75 9.6l5.7-.83z"/>'),
    starOn: svg('<path d="M12 3.6l2.55 5.17 5.7.83-4.13 4.02.98 5.68L12 16.62l-5.1 2.68.98-5.68L3.75 9.6l5.7-.83z" fill="currentColor"/>'),
    /* Negatives: a minus in a circle. A number line was tried three ways and
       none of them survived 16px - an arrowhead and ticks fused into a blob, and
       a zero tick crossing the axis drew a plus sign, the one thing this icon
       must not say. One shape, unmistakable at every size. */
    /* counting: a line with two EQUAL hops - the same jump made again, which is
       what repeated addition is. One hop and three beads read as a blob at 16px. */
    count: svg('<path d="M2.5 18.5h19"/><path d="M5 18.5q4-9 8 0"/><path d="M13 18.5q4-9 8 0"/><path d="M5 16.5v4M13 16.5v4M21 16.5v4"/>'),
    numberline: svg('<circle cx="12" cy="12" r="8.5"/><path d="M7.8 12h8.4"/>'),
    arcs: svg('<path d="M4 16c2-8 8-8 10 0"/><path d="M10 16c2-8 8-8 10 0"/>'),
    /* One icon per bracket skill: one pair of brackets, and a countable dot for
       each bracket in the question. Drawing the pairs side by side was the first
       try and it failed - two adjacent parentheses close into a lens, so ()()
       read as an X and ()()() as a row of Xs. Each parenthesis is a single
       circular arc (A command), so the halves mirror exactly at 16px and 22px. */
    bracket1: svg('<path d="M7.5 4.5A17 17 0 0 0 7.5 19.5"/><path d="M16.5 4.5A17 17 0 0 1 16.5 19.5"/><circle cx="12" cy="12" r="1.9" fill="currentColor" stroke="none"/>'),
    bracket2: svg('<path d="M7.5 4.5A17 17 0 0 0 7.5 19.5"/><path d="M16.5 4.5A17 17 0 0 1 16.5 19.5"/><circle cx="10.2" cy="12" r="1.7" fill="currentColor" stroke="none"/><circle cx="13.8" cy="12" r="1.7" fill="currentColor" stroke="none"/>'),
    bracket3: svg('<path d="M7.5 4.5A17 17 0 0 0 7.5 19.5"/><path d="M16.5 4.5A17 17 0 0 1 16.5 19.5"/><circle cx="9" cy="12" r="1.5" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none"/><circle cx="15" cy="12" r="1.5" fill="currentColor" stroke="none"/>'),
    wand: svg('<path d="M4 20L15 9"/><path d="M14 4l.9 2.1L17 7l-2.1.9L14 10l-.9-2.1L11 7l2.1-.9z"/>'),
    clock: svg('<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>'),
    flag: svg('<path d="M5 21V4"/><path d="M5 4h13l-3 4.5 3 4.5H5"/>'),
    /* Speed: the sound toggle and the pad's delete key */
    sound: svg('<path d="M4 9.5h3.5L12 5.5v13L7.5 14.5H4z"/><path d="M15.5 9.5a4 4 0 0 1 0 5"/><path d="M18 7a7.5 7.5 0 0 1 0 10"/>'),
    mute: svg('<path d="M4 9.5h3.5L12 5.5v13L7.5 14.5H4z"/><path d="M16 10l4.5 4.5M20.5 10L16 14.5"/>'),
    del: svg('<path d="M9 5.5h9.5a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H9L3.5 12z"/><path d="M12.5 9.5l5 5M17.5 9.5l-5 5"/>'),
    arrowR: svg('<path d="M4 12h15"/><path d="M13 6l6 6-6 6"/>'),
    book: svg('<path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v15H6.5A2.5 2.5 0 0 0 4 20.5z"/><path d="M4 18.5A2.5 2.5 0 0 1 6.5 16H20"/>'),
    root: svg('<path d="M2.5 13.2L5.6 12.1L9.1 19.5L14.4 4.5H21.5"/>'),
    grid: svg('<rect x="4" y="4" width="6.5" height="6.5" rx="1.5"/><rect x="13.5" y="4" width="6.5" height="6.5" rx="1.5"/><rect x="4" y="13.5" width="6.5" height="6.5" rx="1.5"/><rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.5"/>'),
    /* compare: a less-than and a greater-than side by side; shift: three digit cards with an arrow one place left; roman: XII */
    compare: svg('<path d="M10 6L4 12l6 6"/><path d="M14 6l6 6-6 6"/>'),
    shift: svg('<rect x="3" y="12" width="5" height="7" rx="1.2"/><rect x="9.5" y="12" width="5" height="7" rx="1.2"/><rect x="16" y="12" width="5" height="7" rx="1.2"/><path d="M17 6H7"/><path d="M10 3L7 6l3 3"/>'),
    roman: svg('<path d="M4 6l6 12M10 6L4 18"/><path d="M14 6v12"/><path d="M19 6v12"/>')
  };

  /* the old hand-picked palette. Still here as the fallback for a skill that
     is in no family yet - see FAMILIES below, which is where colour comes from. */
  var COLOURS = {
    blue: { col: 'var(--brand-lite)', tint: 'var(--brand-tint)' },
    orange: { col: 'var(--accent-text)', tint: 'var(--accent-tint)' },
    violet: { col: 'var(--left)', tint: 'var(--left-d)' },
    green: { col: 'var(--ok-text)', tint: 'var(--ok-d)' },
    gold: { col: 'var(--gold)', tint: 'var(--gold-d)' }
  };

  /* ============================================================
     COLOUR: ONE HUE PER FAMILY
     A skill's colour used to be typed into its module by hand, which meant
     nothing: seven of the first twelve skills were the same blue and the
     colour told a pupil nothing at all. It is DERIVED now. Each FAMILY takes
     the next hue in HUES, and the skills inside a family share that hue at
     different shades. So a mixed board says at a glance which columns are the
     same kind of thing, a new skill never needs a colour decision, and two
     neighbours cannot clash by accident.

     THE ORDER OF THIS LIST IS THE HUE ORDER. Moving a family repaints it
     everywhere - tiles, board heads, mix chips, question card edges - so add
     new families at the END unless you mean to repaint. The order of the
     skills INSIDE a family is its shade order: the first member is the hue
     itself, and later members are mixed towards --shade-to (white on the dark
     theme, near-black on the light one) so they stay readable in both.
     ============================================================ */
  var FAMILIES = [
    { id: 'counting', skills: ['counting-in-steps'] },
    /* what the digits mean, and what happens when they move */
    { id: 'place-value', skills: ['place-value', 'more-or-less', 'multiply-divide-by-10-100-1000'] },
    /* writing a number down, in words or in someone else's numerals */
    { id: 'numerals', skills: ['reading-writing-numbers', 'roman-numerals'] },
    { id: 'comparing', skills: ['comparing-ordering-numbers'] },
    { id: 'negatives', skills: ['negative-numbers'] },
    { id: 'brackets', skills: ['expanding-single-brackets', 'expanding-double-brackets', 'expanding-triple-brackets', 'expanding-surd-brackets'] },
    { id: 'completing-the-square', skills: ['factorising-quadratics', 'completing-the-square', 'quadratic-formula', 'solving-quadratics-factorising'] },
    { id: 'sequences', skills: ['linear-nth-term', 'quadratic-sequences'] },
    { id: 'simplifying-surds', skills: ['simplifying-surds', 'rationalising'] },
    { id: 'simplifying-algebraic-fractions', skills: ['simplifying-algebraic-fractions', 'mult-div-algebraic-fractions', 'add-sub-algebraic-fractions'] },
    { id: 'equations', skills: ['algebraic-fraction-equations', 'rearranging-formulae', 'solving-equations', 'equations-with-squares', 'simultaneous-equations', 'simultaneous-nonlinear'] },
    { id: 'proof', skills: ['algebraic-proof'] },
    { id: 'recurring-decimals', skills: ['recurring-decimals'] },
    { id: 'written-methods', skills: ['times-tables', 'grid-multiplication', 'column-multiplication', 'short-division'] },
    { id: 'decimals-calc', skills: ['mult-div-decimals'] },
    { id: 'indices', skills: ['laws-of-indices', 'negative-fractional-indices', 'standard-form'] },
    { id: 'graphs', skills: ['plotting-linear', 'gradient-equation-of-line'] },
    { id: 'squares-cubes', skills: ['squares-cubes-roots'] },
    { id: 'fractions', skills: ['fraction-of-amount', 'equivalent-fractions', 'improper-mixed', 'add-sub-fractions', 'mult-div-fractions'] },
    { id: 'expressions', skills: ['order-of-operations', 'substitution'] },
    { id: 'triangles', skills: ['pythagoras', 'trigonometry', 'sine-cosine-rules'] },
    { id: 'rounding', skills: ['rounding-whole-numbers', 'rounding-decimals', 'significant-figures', 'estimation'] },
    /* WIRE: new families go above this line */
  ];
  /* eight hues, ordered so consecutive families sit far apart on the wheel */
  var HUES = ['--t2', '--t1', '--t3', '--t4', '--t5', '--t7', '--t6', '--t8'];
  /* How much of the hue each member keeps; the rest is --shade-to. The first
     ramp tried was gentle (100/82/68/56) and four brackets read as four
     identical teal cards - the whole point of a shade is that you can SEE it,
     and mixing towards white on the dark theme (or towards near-black on the
     light one) only ever adds contrast, never takes it away. The band's tint
     steps down with it, so the ladder is legible even at a glance. */
  var SHADES = [100, 80, 62, 48];
  var TINTS = [19, 16, 14, 12];
  var FAMILY_COLOUR = (function () {
    var out = {};
    FAMILIES.forEach(function (f, i) {
      var hue = 'var(' + HUES[i % HUES.length] + ')';
      f.skills.forEach(function (id, j) {
        var k = Math.min(j, SHADES.length - 1), pct = SHADES[k];
        var col = pct >= 100 ? hue : 'color-mix(in oklab, ' + hue + ' ' + pct + '%, var(--shade-to))';
        out[id] = { col: col, tint: 'color-mix(in srgb, ' + col + ' ' + TINTS[k] + '%, transparent)' };
      });
    });
    return out;
  })();

  /* ---------- registry ---------- */
  /* The registry starts from the MANIFEST: one light entry per skill (name,
     strand, stage, colour, icon, levels with names and examples, aliases,
     blurb, which asset holds its engine and which kits that asset needs),
     written by build.py from the modules themselves. Those entries are STUBS:
     they carry everything the library and the skill screen show and none of
     the engine. The engine (make, teach, fields, chorus) arrives when the
     module's asset is loaded, and SL.register then replaces the stub in place,
     keeping the library order. A page that loads every module up front (the
     harness with ?eager=1) simply never has stubs. */
  var registry = {}, order = [], loading = {}, loaded = {};
  (window.SL_MANIFEST || []).forEach(function (m) { m.stub = true; if (!registry[m.id]) order.push(m.id); registry[m.id] = m; });
  function loadAsset(file) {
    if (loaded[file]) return Promise.resolve();
    if (loading[file]) return loading[file];
    var url = (window.SL_ASSETS || {})[file];
    if (!url) return Promise.reject(new Error('no asset for ' + file));
    loading[file] = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = url; s.async = true;
      s.onload = function () { loaded[file] = 1; delete loading[file]; resolve(); };
      s.onerror = function () { delete loading[file]; try { s.parentNode.removeChild(s); } catch (e) {} reject(new Error('failed ' + file)); };
      document.head.appendChild(s);
    });
    return loading[file];
  }
  /* A board does not have its final width the moment it is mounted: the shell is
     still animating in and the fonts are still loading. A drawing that measures
     the box then is laid out into a fraction of it and STAYS there, because
     nothing after that fires a resize. Every engine used to guess at a 30ms
     timer; this watches the box instead and lays out again whenever its width
     really moves. Returns the stop function to call from destroy. */
  function watchWidth(el, fn) {
    var last = el.clientWidth, ro;
    if (window.ResizeObserver) {
      ro = new ResizeObserver(function () {
        var w = el.clientWidth;
        if (!w || Math.abs(w - last) < 2) return;
        last = w; fn(w);
      });
      ro.observe(el);
      return function () { ro.disconnect(); };
    }
    var t = setTimeout(function () { fn(el.clientWidth); }, 30);
    return function () { clearTimeout(t); };
  }
  var SL = window.SL = {
    MINUS: MINUS, ri: ri, pick: pick, chance: chance, shuffle: shuffle, esc: esc, el: el, lsGet: lsGet, lsSet: lsSet,
    watchWidth: watchWidth,
    ICON: ICON, reduceMotion: reduceMotion,
    register: function (skill) { if (!registry[skill.id]) order.push(skill.id); registry[skill.id] = skill; },
    skills: function () { return order.map(function (id) { return registry[id]; }); },
    get: function (id) { return registry[id]; },
    ready: function (id) { var m = registry[id]; return !!(m && !m.stub); },
    /* load the engines for these skills, kits first, one fetch per asset however
       many skills share it; resolves once every one of them has registered */
    ensure: function (ids) {
      return Promise.all(ids.map(function (id) {
        var m = registry[id];
        if (!m) return Promise.reject(new Error('unknown skill ' + id));
        if (!m.stub) return Promise.resolve(m);
        return Promise.all((m.needs || []).map(loadAsset)).then(function () { return loadAsset(m.file); }).then(function () {
          if (registry[id].stub) throw new Error('module did not register ' + id);
          return registry[id];
        });
      }));
    }
  };

  /* MATHS NEVER BREAKS ACROSS TWO LINES (Aadam, 2026-10-30: "not have a little bracket on a separate line or an
     equation ever going over two lines"). A side note, caption or side sum that wraps may break only between words or
     after a clause (", so", ":"), never inside a run of maths: "7(f −" / "3)", "= d² +" / "d − 2" and "6 × 3 = 18, so
     60 × 3 =" / "180" were all on the live board (wrapscan, 2026-10-30). SL.glue(root) wraps each run of maths tokens in
     a nowrap .sl-mr, and a short last word ("by 3", "gives ?", "round up") goes with the word before it, so no line
     holds only a bracket or a number. A run wider than its box may break before an "=" only, then wraps as before.
     Idempotent: a box is done again only when its text changes, so the pen's word spans never move. */
  var GLUE_WORDS = /^(?:by|of|is|to|up|in|on|at|it|an|as|or|if|so|be|we|do|no|and|the|its|are|has|for|not|one|two)$/i;
  var GLUE_MATHW = /^(?:remainder|sin|cos|tan|cm|mm|km|kg|ml|m|g|l|r)[²³,.;:]?$/i;
  function glueKind(t) {
    var s = t.replace(/[.,;:!]+$/, '');
    if (!s) return 'op';
    if (GLUE_MATHW.test(s)) return 'm';
    if (/[A-Za-z]{2,}/.test(s) && (GLUE_WORDS.test(s) || /[A-Za-z]{4,}/.test(s) || /^[A-Za-z]{3}$/.test(s))) return 'w';
    return 'm';
  }
  /* does the box run onto a second row? Two pieces share a row when they overlap by 30% of the smaller one's height, so
     a stacked fraction, a power or a raised arrow is still on its line (a middle-inside test split "→ −71" in two). A box on one row is left exactly as the kit drew it. */
  function glueRows(box) {
    var rg = document.createRange(), rows = [];
    rg.selectNodeContents(box);
    Array.prototype.forEach.call(rg.getClientRects(), function (b) {
      if (b.width < 0.5 || b.height < 0.5) return;
      var hit = null;
      rows.forEach(function (r) {
        var ov = Math.min(r.b, b.bottom) - Math.max(r.t, b.top);
        if (!hit && ov > 0.3 * Math.min(r.b - r.t, b.height)) hit = r;
      });
      if (hit) { hit.t = Math.min(hit.t, b.top); hit.b = Math.max(hit.b, b.bottom); } else rows.push({ t: b.top, b: b.bottom });
    });
    return rows.length;
  }
  function glueBox(box) {
    /* what shows, not the pen's hidden copies of the words (.hw-tx), or the pen's own wrap would look like new text */
    var sig = box.innerText !== undefined ? box.innerText : box.textContent;
    if (box.getAttribute('data-glue') === String(sig.length) + ':' + sig.slice(0, 40)) return;
    /* a box of rows (a pairs table, a list) is not a line of text: only a flex ROW's children are pieces of one line */
    var bd = getComputedStyle(box), rowFlex = /flex/.test(bd.display) && !/column/.test(bd.flexDirection);
    if (!rowFlex && Array.prototype.some.call(box.children, function (c) { var d = getComputedStyle(c).display; return d !== 'none' && d !== 'contents' && !/^inline/.test(d); })) return;
    if (/flex/.test(bd.display) && !rowFlex) return;
    if (glueRows(box) < 2) return;
    box.setAttribute('data-glue', String(sig.length) + ':' + sig.slice(0, 40));
    var toks = [];
    Array.prototype.slice.call(box.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var parts = n.textContent.split(/([ \t\n]+)/), at = 0;
        parts.forEach(function (p) { if (p) toks.push({ n: n, a: at, b: at + p.length, sp: /^[ \t\n]+$/.test(p), t: p }); at += p.length; });
        return;
      }
      if (n.nodeType !== 1) return;
      var cs = getComputedStyle(n);
      if (cs.display === 'none' || cs.position === 'absolute') { toks.push({ el: n, hid: true, t: '' }); return; }
      var t = (n.textContent || '').trim();
      if (cs.display === 'inline' && /[A-Za-z]{4,}/.test(t) && / /.test(t)) { glueBox(n); toks.push({ el: n, t: t, k: 'w' }); return; }
      /* an inline span that is all maths ("q² + 6q + 5") is one piece: it must not break inside either */
      if (cs.display === 'inline' && / /.test(t) && glueKind(t.replace(/ /g, '')) === 'm' && !/[A-Za-z]{3,}/.test(t)) n.classList.add('sl-mr');
      toks.push({ el: n, t: t || '\u25A1' });
    });
    toks.forEach(function (k) {
      if (k.sp || k.hid) return;
      if (!k.k) k.k = glueKind(k.t);
      k.end = /[,;:]$/.test(k.t) || k.t === '·';
    });
    var vis = toks.filter(function (k) { return !k.sp && !k.hid; });
    if (vis.length < 2) return;
    var bcs = getComputedStyle(box), flex = /flex/.test(bcs.display) ? ((parseFloat(bcs.columnGap) || 0) > 0 ? 'gap' : 'row') : '';
    /* runs: maths tokens with only spaces between them, ended after a clause mark */
    var runs = [], cur = null;
    vis.forEach(function (k) {
      if (k.k !== 'w') { if (!cur) { cur = [k]; runs.push(cur); } else cur.push(k); if (k.end) cur = null; }
      else cur = null;
    });
    /* a short joining word goes with the maths after it ("so 60 × 3 = 180", "by (t − 2)"), never left alone between */
    runs.forEach(function (r) {
      var i = vis.indexOf(r[0]), w = vis[i - 1];
      if (w && w.k === 'w' && w.t.length <= 3 && GLUE_WORDS.test(w.t) && !runs.some(function (q) { return q.indexOf(w) >= 0; })) r.unshift(w);
    });
    /* a short number that opens the note stays with the word after it ("10 rows of 8", never "10" alone on a line) */
    if (!flex && vis.length > 2 && vis[0].k !== 'w' && vis[0].t.length <= 3 && vis[1].k === 'w') {
      var r0 = runs.filter(function (r) { return r.indexOf(vis[0]) >= 0; })[0];
      if (r0 && r0.length === 1) r0.push(vis[1]); else if (!r0) runs.unshift([vis[0], vis[1]]);
    }
    /* a sign named in a sentence ("The − multiplies every term") stays with the word after it */
    runs.forEach(function (r) {
      if (r.length !== 1 || !/^[+\u2212\u00D7\u00F7]$/.test(r[0].t)) return;
      var w = vis[vis.indexOf(r[0]) + 1];
      if (w && w.k === 'w') r.push(w);
    });
    /* no orphan: a short last piece (or a short last run, "12.") goes with the piece before it */
    var last = vis[vis.length - 1];
    var lastRun = runs.filter(function (r) { return r.indexOf(last) >= 0; })[0], unit = lastRun || [last];
    var before = vis[vis.indexOf(unit[0]) - 1];
    if (before && unit.map(function (k) { return k.t; }).join('').length <= 3) {
      var beforeRun = runs.filter(function (r) { return r.indexOf(before) >= 0; })[0];
      if (beforeRun) { if (lastRun) runs.splice(runs.indexOf(lastRun), 1); beforeRun.push.apply(beforeRun, unit); }
      else if (lastRun) lastRun.unshift(before);
      else runs.push([before, last]);
    }

    /* last run first: wrapping splits the shared text nodes, and the earlier offsets stay good only this way round */
    runs.slice().reverse().forEach(function (r) {
      if (r.length < 2) return;
      var i0 = toks.indexOf(r[0]), i1 = toks.indexOf(r[r.length - 1]);
      glueWrap(box, toks.slice(i0, i1 + 1), flex);
    });
    glueFit(box);
  }
  function glueWrap(box, seq, flex) {
    var a = seq[0], z = seq[seq.length - 1], rg = document.createRange(), sp = document.createElement('span');
    if (a.el) rg.setStartBefore(a.el); else rg.setStart(a.n, a.a);
    if (z.el) rg.setEndAfter(z.el); else rg.setEnd(z.n, z.b);
    sp.className = flex === 'gap' ? 'sl-mr is-flex' : 'sl-mr';
    try { rg.surroundContents(sp); } catch (e) { return; }
    /* a flex row drops a space that ends or starts a text run beside an element: keep them as no-break spaces */
    if (!flex) return;
    var p = sp.previousSibling, n = sp.nextSibling;
    if (p && p.nodeType === 3) p.textContent = p.textContent.replace(/[ \t\n]+$/, '\u00A0');
    if (n && n.nodeType === 3) n.textContent = n.textContent.replace(/^[ \t\n]+/, '\u00A0');
  }
  /* a run wider than its box: it may break before an "=" only (each "= ..." stays whole), every other space in it
     turns no-break; a piece still too wide then breaks where a line normally would */
  function glueFit(box) {
    var cs = getComputedStyle(box), room = box.getBoundingClientRect().width - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    if (room < 20) return;
    /* the box itself may grow past the board (a side sum beside a short division): the board's edge counts too */
    var bd = box.closest('.sl-teach-board'), raw = SL.rawRect || function (e) { return e.getBoundingClientRect(); }, br = bd && raw(bd);
    Array.prototype.slice.call(box.children).forEach(function (r) {
      if (!r.classList.contains('sl-mr')) return;
      var rr = raw(r), past = br && (rr.right > br.right - 2 || rr.left < br.left + 2);
      if (!past && r.getBoundingClientRect().width <= room + 1) return;
      r.classList.add('is-split');
      var w = document.createTreeWalker(r, NodeFilter.SHOW_TEXT), t;
      while ((t = w.nextNode())) t.textContent = t.textContent.replace(/ (?![=])/g, '\u00A0');
    });
  }
  /* skipPen: core's pass after a press leaves a board the pen writes on (.hw-on) alone; the pen glues before it wraps
     its words, and a change after that moves ink it has measured, so it writes it again */
  SL.glue = function (root, skipPen) {
    if (!root || !root.querySelectorAll) return;
    if (skipPen && (root.classList.contains('hw-on') || root.querySelector('.hw-on'))) return;
    var list = [root].concat(Array.prototype.slice.call(root.querySelectorAll('*')));
    list.reverse().forEach(function (e) {
      if (e.nodeType !== 1 || e.closest('svg, .sl-mr, input, textarea, button')) return;
      var has = false, kids = e.children.length, len = (e.textContent || '').trim().length;
      for (var c = e.firstChild; c; c = c.nextSibling) if (c.nodeType === 3 && c.textContent.trim()) { has = true; break; }
      /* a note built only of spans (a caption's chips and words, a sum's tokens) is a box too: short, no block inside */
      if (!has && !(kids >= 2 && len <= 240 && !e.querySelector('div, p, li, table, .cs-line, .cs-aside, .cs-note'))) return;
      var cs = getComputedStyle(e);
      /* an inline span is a box only where its parent is not one (a conclusion sentence alone in its line) */
      if (cs.display === 'inline' && e.parentElement && e.parentElement !== root && e.parentElement.childNodes.length > 1) return;
      if (cs.display === 'none' || /grid|table/.test(cs.display) || /^(nowrap|pre)$/.test(cs.whiteSpace)) return;
      try { glueBox(e); } catch (err) {}
    });
  };
  /* every Teach model, the zoom probe's and the real one: glued after each move, so the probe measures what shows */
  function glueTeach(r, host) {
    if (!r) return r;
    ['next', 'back', 'all', 'seek', 'more'].forEach(function (k) {
      var f = r[k]; if (typeof f !== 'function') return;
      r[k] = function () { var x = f.apply(r, arguments); SL.glue(host, true); return x; };
    });
    SL.glue(host, true);
    var tq = document.querySelector('#slShell .sl-teach-q');
    if (tq && host.id === 'slTBoard') SL.glue(tq);
    return r;
  }

  var STRANDS = {
    secondary: [
      { id: 'number', name: 'Number' }, { id: 'algebra', name: 'Algebra' }, { id: 'ratio', name: 'Ratio & proportion' },
      { id: 'geometry', name: 'Geometry' }, { id: 'statistics', name: 'Statistics & probability' }
    ],
    primary: [
      { id: 'p-number', name: 'Number & place value' }, { id: 'p-calc', name: 'Calculation' },
      { id: 'p-fdp', name: 'Fractions, decimals & percentages' }, { id: 'p-measure', name: 'Measure' }, { id: 'p-shape', name: 'Shape & position' }
    ]
  };

  /* ============================================================
     THE LEARNING ORDER
     A shelf listed itself in whatever order the modules happened to be
     wired in, which is not an order anybody learns in. One list per
     strand, written as the order a pupil should MEET the skills, and the
     library sorts by it everywhere: the shelf, the search results and the
     mix. A skill that is not named here still shows - it falls to the end
     of its strand - and `build.py` prints a warning naming it, so a new
     skill is never quietly left at the bottom.
     WHEN YOU ADD A SKILL: put its id in the list, next to the skill it
     builds on, not at the end.
     ============================================================ */
  var LEARN_ORDER = {
    /* Primary number: count, then read what the digits mean, then move
       around the number line, then read and compare, then shift the digits.
       Roman numerals are a side branch, so they come last. */
    'p-number': [
      'counting-in-steps',
      'place-value',
      'rounding-whole-numbers',
      'more-or-less',
      'reading-writing-numbers',
      'comparing-ordering-numbers',
      'multiply-divide-by-10-100-1000',
      'substitution',
      'linear-nth-term',
      'solving-equations',
      'roman-numerals'
    ],
    /* Primary calculation: the four written methods in teaching order. Tables first,
       because every one of them is a table fact repeated. */
    'p-calc': [
      'times-tables',
      'order-of-operations',
      'squares-cubes-roots',
      'grid-multiplication',
      'column-multiplication',
      'short-division',
      'estimation'
    ],
    'p-fdp': [
      'equivalent-fractions',
      'improper-mixed',
      'add-sub-fractions',
      'mult-div-fractions',
      'fraction-of-amount',
      'mult-div-decimals',
      'rounding-decimals'
    ],
    'p-measure': [],
    'p-shape': [],
    /* Secondary number: what the digits mean, then the four written methods in the
       order they are taught (tables, the grid that explains multiplication, the column
       that does it quickly, division, then the same two methods with decimals), then
       the line carried past zero and the harder number work. The written methods sit
       here and not at the end: they stand on place value and on multiplying by powers
       of ten, and everything below them stands on the written methods. */
    'number': [
      'place-value',
      'rounding-whole-numbers',
      'more-or-less',
      'reading-writing-numbers',
      'comparing-ordering-numbers',
      'multiply-divide-by-10-100-1000',
      'times-tables',
      'grid-multiplication',
      'column-multiplication',
      'short-division',
      'equivalent-fractions',
      'improper-mixed',
      'add-sub-fractions',
      'mult-div-fractions',
      'fraction-of-amount',
      'mult-div-decimals',
      'rounding-decimals',
      'significant-figures',
      'estimation',
      'negative-numbers',
      'order-of-operations',
      'laws-of-indices',
      'negative-fractional-indices',
      'standard-form',
      'recurring-decimals',
      'simplifying-surds',
      'rationalising'
    ],
    /* Algebra: one bracket, two, three, then the same expansion with surds. */
    'algebra': [
      'substitution',
      'expanding-single-brackets',
      'expanding-double-brackets',
      'expanding-triple-brackets',
      'expanding-surd-brackets',
      'solving-equations',
      'equations-with-squares',
      'rearranging-formulae',
      'plotting-linear',
      'gradient-equation-of-line',
      'simultaneous-equations',
      'linear-nth-term',
      'quadratic-sequences',
      'factorising-quadratics',
      'solving-quadratics-factorising',
      'completing-the-square',
      'quadratic-formula',
      'simultaneous-nonlinear',
      'simplifying-algebraic-fractions',
      'mult-div-algebraic-fractions',
      'add-sub-algebraic-fractions',
      'algebraic-fraction-equations',
      'algebraic-proof'
    ],
    'ratio': [],
    'geometry': [
      'pythagoras',
      'trigonometry',
      'sine-cosine-rules'
    ],
    'statistics': []
  };

  /* ============================================================
     THE APP
     A skill is a destination: Skills → skill → level → activity.
     Mixed practice is the only place with a basket.
     ============================================================ */
  function boot() {
    var root = $('slRoot');
    if (!root) return;
    var shell = $('slShell');
    var PLANNED = window.SL_PLANNED || {};
    var K = 'shlc_sl_v2';

    var S = {
      theme: 'dark', stage: 'secondary', strand: 'algebra', search: '', showPlanned: false, libZoom: 3,
      view: 'skills', skill: null, mix: [], levels: {}, sel: {}, prog: {},
      screen: 'library', from: 'skills', set: [], setN: 10, prOne: -1, typed: false,
      /* the question drawer starts open on a laptop and CLOSED on a phone: under
         640px it is a 40vh block stacked above the board, and on a 390 wide
         screen it pushed the model right off the bottom of the page */
      teach: { i: 0, r: null, mode: 'step', done: false, listOpen: !narrow(), lvOpen: false, back: null, opts: {} },
      /* Your turn: one question at a time, answered on the model. cp is the
         current question's checkpoints, marks what the pupil did with each on
         the FIRST try, and log the whole run, which is what the results read. */
      turn: { i: 0, r: null, phase: 'play', cp: [], marks: [], at: 0, log: [], t0: 0, ms: 0, ended: false },
      board: { cols: [], ans: false, layout: 'mix', mixLayout: 'skill', n: 16, tab: 0 },
      /* Speed: the shape of a run, and the sound that goes with it */
      speed: { shape: 'race', n: 10, secs: 120 }, sound: true,
      strandPicked: false, libMore: false,
      /* first open only: who is here, what for, what they want first, and
         how far through the walkthrough they are */
      intro: { done: false, who: null, goal: null, first: null, step: 0 },
      /* the skills saved to Favourites, newest first, by id */
      fav: [],
      /* GCSE past papers: the questions already walked through (by id) and the strand chip picked */
      pwSeen: {}, pwStrand: ''
    };

    /* ---------- storage ---------- */
    function save() {
      syncHash(false);
      lsSet(K, { theme: S.theme, stage: S.stage, strand: S.strand, skill: S.skill, mix: S.mix, fav: S.fav, levels: S.levels, sel: S.sel, prog: S.prog, typed: S.typed, libZoom: S.libZoom, teachOpts: S.teach.opts, chorus: S.chorus, sound: S.sound, speed: S.speed, pwSeen: S.pwSeen, intro: { done: S.intro.done, who: S.intro.who, goal: S.intro.goal, first: S.intro.first }, board: { layout: S.board.layout, mixLayout: S.board.mixLayout, n: S.board.n } });
    }
    (function load() {
      var d = lsGet(K, null) || lsGet('shlc_sl_v1', null);
      if (!d) return;
      if (d.theme === 'light' || d.theme === 'dark') S.theme = d.theme;
      if (d.stage === 'primary' || d.stage === 'secondary') S.stage = d.stage;
      if (typeof d.strand === 'string') S.strand = d.strand;
      if (d.skill && SL.get(d.skill)) S.skill = d.skill;
      if (Array.isArray(d.mix)) S.mix = d.mix.filter(function (m) { return m && SL.get(m.id); });
      /* favourites keep their raw ids: a skill module can register after this
         runs, and filtering here would quietly throw the saved skill away */
      if (Array.isArray(d.fav)) S.fav = d.fav.filter(function (id) { return typeof id === 'string'; });
      if (d.levels && typeof d.levels === 'object') S.levels = d.levels;
      if (d.sel && typeof d.sel === 'object') S.sel = d.sel;
      if (d.prog && typeof d.prog === 'object') S.prog = d.prog;
      S.typed = d.typed === true;
      if (d.teachOpts && typeof d.teachOpts === 'object') S.teach.opts = d.teachOpts;
      /* 0..6, see LIB_ZOOMS (a literal here: this runs before that list is assigned) */
      if (typeof d.libZoom === 'number' && d.libZoom >= 0 && d.libZoom <= 6) S.libZoom = Math.round(d.libZoom);
      S.chorus = d.chorus && typeof d.chorus === 'object' ? d.chorus : {};
      if (d.sound === false) S.sound = false;
      if (d.pwSeen && typeof d.pwSeen === 'object') S.pwSeen = d.pwSeen;
      if (d.speed && typeof d.speed === 'object') {
        if (d.speed.shape === 'race' || d.speed.shape === 'clock') S.speed.shape = d.speed.shape;
        /* SPEED SLIDERS (2026-09-21): a length saved before the sliders (5 questions, 30 seconds,
           1½ minutes) snaps to the nearest stop in range. spSnap is a declaration further down. */
        var sN = spSnap('race', d.speed.n), sS = spSnap('clock', d.speed.secs);
        if (sN) S.speed.n = sN;
        if (sS) S.speed.secs = sS;
      }
      if (d.intro && typeof d.intro === 'object') {
        S.intro.done = d.intro.done === true;
        ['who', 'goal', 'first'].forEach(function (k) { if (typeof d.intro[k] === 'string') S.intro[k] = d.intro[k]; });
      }
      /* someone who used the lab before the walkthrough existed has already
         found their way round: progress or a saved skill counts as done */
      else if (d.skill || (d.fav && d.fav.length) || (d.prog && Object.keys(d.prog).length)) S.intro.done = true;
      if (d.board) { if (d.board.layout === 'diff' || d.board.layout === 'mix') S.board.layout = d.board.layout; if (d.board.mixLayout === 'mixed' || d.board.mixLayout === 'skill') S.board.mixLayout = d.board.mixLayout; if ([8, 16, 24].indexOf(d.board.n) >= 0) S.board.n = d.board.n; }
    })();

    /* ============================================================
       GA4
       The Shopify Google & YouTube pixel puts gtag on the page itself
       (window.gtag, dataLayer), so an event here lands in G-42RVT4XQGJ with
       no tag of our own and no extra bytes. Nothing about a pupil goes with
       it: a skill id, a level number, a count. If gtag is missing, as it is
       in the harness, every call is a no-op that still writes to
       window.__SL_TRACK_LOG, which is how a flow is checked without GA4.
       Custom parameters need registering as custom dimensions in GA4 admin
       before they show up in reports - the events themselves arrive anyway.
       ============================================================ */
    var TRACK_LOG_MAX = 80;
    function track(name, params) {
      var p = {}, k, v;
      for (k in (params || {})) {
        v = params[k];
        if (v === null || v === undefined || v === '') continue;
        p[k] = typeof v === 'string' ? v.slice(0, 100) : v;
      }
      try {
        var log = window.__SL_TRACK_LOG = window.__SL_TRACK_LOG || [];
        log.push({ e: name, p: p, t: Date.now() });
        if (log.length > TRACK_LOG_MAX) log.shift();
      } catch (err) {}
      /* belt and braces on the theme's internal-traffic marker: the layout sets
         traffic_type globally for a marked browser, and this stamps the lab's
         own events too, so they are dropped by the GA4 filter either way */
      if (window.__shlcInternal) p.traffic_type = 'internal';
      /* send_to names GA4 alone. Without it the event also goes to the Ads and
         Merchant Center containers the Shopify pixel configures on the same
         gtag, which have no use for a level number and list it as a conversion
         candidate. */
      p.send_to = 'G-42RVT4XQGJ';
      try { if (typeof window.gtag === 'function') window.gtag('event', name, p); } catch (err) {}
    }
    /* one per skill and level for the life of the page, and one per dealt set */
    var trackedSecure = {}, trackedSet = null, trackedTour = false, trackedWait = false;
    function levelsOf(sk) { try { return selLevels(sk).join(','); } catch (err) { return ''; } }

    /* ---------- helpers on skills ---------- */
    /* the levels a skill is set to: one or several, never none. skillLevel is the lowest */
    function selLevels(sk) {
      var a = S.sel[sk.id];
      if (!Array.isArray(a) || !a.length) { var n = S.levels[sk.id]; a = [(typeof n === 'number' && n >= 1 && n <= sk.levels.length) ? n : 1]; }
      a = a.filter(function (x) { return typeof x === 'number' && x >= 1 && x <= sk.levels.length; }).sort(function (x, y) { return x - y; });
      return a.length ? a : [1];
    }
    function skillLevel(sk) { return selLevels(sk)[0]; }
    function setSel(sk, arr) { var a = arr.filter(function (x, i, xs) { return xs.indexOf(x) === i; }).sort(function (x, y) { return x - y; }); if (!a.length) return; S.sel[sk.id] = a; S.levels[sk.id] = a[0]; save(); }
    function setLevel(sk, n) { setSel(sk, [Math.max(1, Math.min(sk.levels.length, n))]); }
    function toggleSel(sk, n) { var a = selLevels(sk); if (a.indexOf(n) >= 0) { if (a.length === 1) return; a = a.filter(function (x) { return x !== n; }); } else a.push(n); setSel(sk, a); }
    function levelWord(sk) { var a = selLevels(sk); if (a.length === 1) return 'Level ' + a[0] + ': ' + levelName(sk, a[0]); return 'Levels ' + (a.length === 2 ? a.join(' and ') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]); }
    /* the family's hue and shade; the module's own `colour:` is only the
       fallback for a skill nobody has put in a family yet */
    function colourOf(sk) { return (sk && FAMILY_COLOUR[sk.id]) || COLOURS[sk && sk.colour] || COLOURS.blue; }
    function skIcon(sk) { return sk ? stk(sk.id, ICON[sk.icon] || '', sk.sticker) : ''; }
    function tagHTML(sk) { var c = colourOf(sk); return '<span class="sl-tag" style="color:' + c.col + ';background:' + c.tint + '">' + skIcon(sk) + esc(sk.short || sk.name) + '</span>'; }
    function levelName(sk, n) { var L = sk.levels[n - 1]; return L ? L.name : ''; }
    /* The level that deals from all the others. Aadam, 2026-09-15: "remove all mixed levels from
       teaching mode as not needed", and "in practice always show the Mixed level as 'Mixed' so you
       can see clearly". Known by its id or by "mixed" in its name (Everything mixed, Mixed and checked). */
    function isMixLevel(sk, n) { var L = sk && sk.levels && sk.levels[n - 1]; return !!L && (L.levelId === 'mixed' || /\bmixed\b/i.test(L.name || '')); }
    /* MIXED LEVEL CHIP FITS ITS WORD (2026-09-21): the chip builders add sl-chip--mix so the CSS can let it grow */
    function chipText(sk, n) { return isMixLevel(sk, n) ? 'Mixed' : String(n); }
    /* Teach deals from the chosen levels without the mixed one; if that was the only one chosen,
       the level below it. True when anything changed. */
    function stripMixForTeach() {
      var changed = false;
      activeSkills().forEach(function (sk) {
        var a = selLevels(sk), b = a.filter(function (k) { return !isMixLevel(sk, k); }), k;
        if (b.length === a.length) return;
        if (!b.length) for (k = sk.levels.length; k >= 1; k--) if (!isMixLevel(sk, k)) { b = [k]; break; }
        if (b.length) { setSel(sk, b); changed = true; }
      });
      return changed;
    }
    /* what a level chip says on hover: its name and a question like the ones it deals */
    /* the attributes that drive the pill: what the level is, and one question from it */
    /* ONE example, never two. Levels written with a second example after a
       double space get cut back here, so nothing has to be trusted to stay short. */
    function oneEg(eg) { return String(eg || '').split(/,\s\s+/)[0].trim(); }
    function tipAttrs(sk, n) {
      var L = sk.levels[n - 1]; if (!L) return '';
      return ' data-tip="' + esc('Level ' + n + ': ' + L.name) + '"' + (L.eg ? ' data-tipeg="' + esc(oneEg(L.eg)) + '"' : '');
    }
    function levelEg(sk, n) { var L = sk.levels[n - 1]; return L ? oneEg(L.eg) : ''; }
    /* a skill can span both stages (stage: 'both'): it lists under its secondary strand
       and under `pstrand` in the primary list, same name in both (Aadam, 2026-09-09) */
    function strandOf(sk, stage) { return (stage === 'primary' && sk.pstrand) ? sk.pstrand : sk.strand; }
    function inStage(sk, stage) { var s = sk.stage || 'secondary'; return !stage || s === stage || (s === 'both' && (stage === 'secondary' || !!sk.pstrand)); }
    /* where a skill sits in its strand's learning order; unlisted skills go
       to the end, in the order they registered, never dropped */
    function learnIndex(sk, stage) {
      var list = LEARN_ORDER[strandOf(sk, stage)] || [], i = list.indexOf(sk.id);
      return i < 0 ? 900 : i;
    }
    function strandRank(sk, stage) {
      var st = strandOf(sk, stage), list = STRANDS[stage] || STRANDS.secondary, i;
      for (i = 0; i < list.length; i++) if (list[i].id === st) return i;
      return 90;
    }
    /* indexed once per registry size: the library asks every strand for its count on every render */
    var readyMemo = {}, readyMemoN = -1;
    function readySkills(strand, stage) {
      var all = SL.skills(), k = (strand || '') + '|' + (stage || '');
      if (readyMemoN !== all.length) { readyMemo = {}; readyMemoN = all.length; }
      if (!readyMemo[k]) {
        var reg = {}; all.forEach(function (sk, i) { reg[sk.id] = i; });
        readyMemo[k] = all.filter(function (sk) { return inStage(sk, stage) && (!strand || strandOf(sk, stage) === strand); })
          .sort(function (a, b) {
            return (strandRank(a, stage) - strandRank(b, stage)) || (learnIndex(a, stage) - learnIndex(b, stage)) || (reg[a.id] - reg[b.id]);
          });
      }
      return readyMemo[k];
    }
    /* The planned list is the Mr Carter crawl, and it still holds the names of
       skills that have since been BUILT - so "Negative numbers" showed as a tile
       AND as planned. Every skill added from here would have done the same, so
       the planned list is filtered against what is registered: the skill's name,
       its short name and its aliases, loosely matched. */
    function plainName(x) { return String(x || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim(); }
    var builtNames = null;
    function isBuilt(name) {
      if (!builtNames) {
        builtNames = {};
        SL.skills().forEach(function (sk) {
          [sk.name, sk.short].concat(sk.aliases || []).forEach(function (n) { if (n) builtNames[plainName(n)] = 1; });
        });
      }
      return !!builtNames[plainName(name)];
    }
    var planMemo = {};
    function plannedFor(strand) { if (!planMemo[strand]) planMemo[strand] = (PLANNED[strand] || []).filter(function (n) { return !isBuilt(n); }); return planMemo[strand]; }
    function curSkill() { return S.skill ? SL.get(S.skill) : null; }
    function mixSkills() { return S.mix.map(function (m) { return SL.get(m.id); }).filter(Boolean); }
    function inMix(sk) { return S.mix.some(function (m) { return m.id === sk.id; }); }
    /* Favourites: one list, kept across both stages, newest first. It is the
       pupil's own shelf, so a skill saved in Secondary still shows when the
       switch is on Primary - the list is theirs, not the stage's. */
    function isFav(sk) { return sk && S.fav.indexOf(sk.id) >= 0; }
    function toggleFav(sk) { var i = S.fav.indexOf(sk.id); if (i >= 0) S.fav.splice(i, 1); else S.fav.unshift(sk.id); save(); }
    function favSkills() { return S.fav.map(function (id) { return SL.get(id); }).filter(Boolean); }
    /* the skills a set or a board is dealt from: the one skill, or the mixed basket */
    function activeSkills() { return S.from === 'mixed' ? mixSkills() : (curSkill() ? [curSkill()] : []); }
    /* A skill whose answer can only be REVEALED cannot be raced. An algebraic proof is a page
       of working, not something a child types on a keypad against a clock (Aadam, 2026-09-24,
       "keep algebraic proof out of speed"). `speed: false` on the register object says so, and
       it is JSON-clean, so a manifest STUB carries it and the Speed card is gone before the
       engine has loaded - the same rule as gating Your turn on `turnName` and never on `turn`.
       Gate on this, never on what make() happens to deal: sampling a stub has no make(). */
    function canRace(sk) { return !!sk && sk.speed !== false; }
    function raceSkills() { return activeSkills().filter(canRace); }
    function matches(q, name, aliases) { q = q.trim().toLowerCase(); if (!q) return true; if (name.toLowerCase().indexOf(q) >= 0) return true; return (aliases || []).some(function (a) { return a.toLowerCase().indexOf(q) >= 0; }); }

    /* ---------- theme ---------- */
    /* A theme switch used to snap. For the third of a second after the toggle
       every colour on the page may transition (the is-theming class, see the
       MOTION block in the CSS) and the sun or moon turns in. The class comes
       off again so nothing else is slowed by it. */
    var themeFx = false, themeT = null;
    function applyTheme() {
      root.setAttribute('data-theme', S.theme);
      document.documentElement.classList.toggle('sl-dark', S.theme === 'dark');
      document.documentElement.classList.toggle('sl-light', S.theme === 'light');
      each(document.querySelectorAll('[data-sl-theme]'), function (b) {
        b.innerHTML = S.theme === 'dark' ? ICON.sun : ICON.moon;
        b.classList.toggle('is-spin', themeFx);
        b.setAttribute('aria-label', S.theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
        b.removeAttribute('title');
        b.setAttribute('data-tip', S.theme === 'dark' ? 'Light mode' : 'Dark mode');
        b.setAttribute('data-tipsub', S.theme === 'dark' ? 'A white page, for a bright room or for printing.' : 'A dark page, easier on the eyes on a screen.');
      });
      if (themeFx) {
        themeFx = false;
        root.classList.add('is-theming'); document.documentElement.classList.add('sl-theming');
        clearTimeout(themeT);
        themeT = setTimeout(function () { root.classList.remove('is-theming'); document.documentElement.classList.remove('sl-theming'); }, 420);
      }
    }
    function toggleTheme() { S.theme = S.theme === 'dark' ? 'light' : 'dark'; save(); themeFx = !reduceMotion; applyTheme(); }
    function themeBtn() { return '<button type="button" class="sl-iconbtn" data-sl-theme></button>'; }

    /* ---------- scroll lock + inert page ---------- */
    var lockY = 0, isLocked = false, inerted = [];
    function lockScroll() {
      if (isLocked) return;
      lockY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.documentElement.classList.add('sl-lock');
      var b = document.body.style; b.position = 'fixed'; b.top = (-lockY) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
      isLocked = true;
    }
    function unlockScroll() {
      if (!isLocked) return;
      var b = document.body.style; b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
      document.documentElement.classList.remove('sl-lock');
      isLocked = false;
      window.scrollTo(0, lockY);
      setTimeout(function () { window.scrollTo(0, lockY); }, 0);
    }
    /* everything that is not on the path from body to the shell goes inert while it is open */
    function setInert(on) {
      if (!on) { inerted.forEach(function (e) { e.inert = false; e.removeAttribute('aria-hidden'); }); inerted = []; return; }
      var node = shell;
      while (node && node !== document.body) {
        var parent = node.parentNode;
        if (!parent) break;
        Array.prototype.forEach.call(parent.children, function (sib) {
          if (sib !== node && sib.tagName !== 'SCRIPT' && sib.tagName !== 'STYLE') { sib.inert = true; sib.setAttribute('aria-hidden', 'true'); inerted.push(sib); }
        });
        node = parent;
      }
    }

    /* ============================================================
       SHELL
       ============================================================ */
    shell.setAttribute('role', 'dialog'); shell.setAttribute('aria-modal', 'true'); shell.setAttribute('aria-label', 'Skills Lab'); shell.setAttribute('tabindex', '-1');
    shell.innerHTML =
      '<div class="sl-top" id="slTop"></div>' +
      '<div class="sl-body">' +
        ['slWelcome', 'slLibrary', 'slMixed', 'slSkill', 'slBoardSetup', 'slSpeedSetup', 'slPractise', 'slTeach', 'slTurn', 'slBoard', 'slSpeed', 'slPapers', 'slChecklist'].map(function (id) { return '<div class="sl-screen" id="' + id + '"></div>'; }).join('') +
      '</div>';
    var elTop = $('slTop'), elBody = shell.querySelector('.sl-body');
    var SCREEN_ID = { welcome: 'slWelcome', library: 'slLibrary', mixed: 'slMixed', skill: 'slSkill', boardsetup: 'slBoardSetup', speedsetup: 'slSpeedSetup', practise: 'slPractise', teach: 'slTeach', turn: 'slTurn', board: 'slBoard', speed: 'slSpeed', papers: 'slPapers', checklist: 'slChecklist' };

    /* ============================================================
       MOTION
       Every screen is rebuilt with innerHTML, so a CSS transition on a
       selected control never fires: the old button is gone and the new one
       is born already selected. So a render is bracketed. Before it, the
       selected controls are measured; after it, each fresh one is told where
       its predecessor was. A single-choice control (a segmented pill, the
       strand list, the teach list, the board tabs) slides from there. A
       multi-choice control (level chips and rows, tiles in a mix, switches)
       that has just come on pops, and one that has just gone off is told so.
       The MOTION block at the foot of skills-lab.css does the drawing.
       FX carries one-shot notes from a click to the next render (which card
       was just revealed, marked or swapped) and is wiped once used.
       ============================================================ */
    var MO = (function () {
      var SLIDE = '.sl-seg, .sl-strand, .sl-rrow[data-tq], .sl-btabs .sl-chip';
      var POP = '.sl-chip--lvl, .sl-chip--alllvl, .sl-lvlrow, .sl-tile[data-skill], .sl-toggle';
      var NEW = '.sl-mixchip';
      /* a control is measured against the box it slides inside (its segwrap,
         its rail, its list), never the viewport: a teach model can move the
         whole mode switch after it mounts, and the pill must still travel one
         slot along its track, not across the screen */
      var GROUPBOX = '.sl-segwrap, .sl-teach-rail-q, .sl-btabs, .sl-rail';
      var ON = /(^|\s)(is-on|is-now|sl-chip--now)(\s|$)/;
      function isOn(e) { return ON.test(e.className); }
      function skip(name) { return name.indexOf('data-') !== 0 || name === 'data-tip' || name === 'data-tipeg' || name === 'data-tipsub'; }
      function dataKey(e) { var out = [], a = e.attributes, i; for (i = 0; i < a.length; i++) if (!skip(a[i].name)) out.push(a[i].name + '=' + a[i].value); return out.join('|'); }
      /* the track a single-choice control slides along: named on the wrapper
         where there is one (data-mo-group), else the control's first data
         attribute, scoped to the topic or mix chip it sits in */
      function groupOf(e) {
        var g = e.closest('[data-mo-group]'), name = g ? g.getAttribute('data-mo-group') : null, a = e.attributes, i;
        if (!name) for (i = 0; i < a.length; i++) if (!skip(a[i].name)) { name = a[i].name; break; }
        return (name || e.id || '') + '@' + scopeOf(e);
      }
      function scopeOf(e) { var s = e.closest('[data-topic],[data-mix]'); return s ? (s.getAttribute('data-topic') || s.getAttribute('data-mix')) : ''; }
      function keyOf(e) { return (e.id ? '#' + e.id : e.className.split(' ')[0]) + '@' + scopeOf(e) + '|' + dataKey(e); }
      function rect(e) {
        var r = e.getBoundingClientRect(); if (!r.width) return null;
        var g = e.closest(GROUPBOX), b = g ? g.getBoundingClientRect() : { left: 0, top: 0 };
        return { left: r.left - b.left, top: r.top - b.top, width: r.width, height: r.height };
      }
      function snap(root) {
        if (reduceMotion) return;
        var s = { slide: {}, on: {}, had: {} };
        each(root.querySelectorAll(SLIDE), function (e) { var r; if (isOn(e) && (r = rect(e))) s.slide[groupOf(e)] = { key: keyOf(e), r: r }; });
        each(root.querySelectorAll(POP), function (e) { s.on[keyOf(e)] = isOn(e); });
        each(root.querySelectorAll(NEW), function (e) { s.had[keyOf(e)] = 1; });
        root.__mo = s;
      }
      function play(root) {
        var s = root.__mo; root.__mo = null; if (!s) return;
        each(root.querySelectorAll(SLIDE), function (e) {
          if (!isOn(e)) return;
          var old = s.slide[groupOf(e)], r;
          if (!old || old.key === keyOf(e) || !(r = rect(e))) return;
          e.style.setProperty('--fx', (old.r.left - r.left).toFixed(1) + 'px');
          e.style.setProperty('--fy', (old.r.top - r.top).toFixed(1) + 'px');
          e.style.setProperty('--fw', (old.r.width / r.width).toFixed(3));
          e.style.setProperty('--fh', (old.r.height / r.height).toFixed(3));
          e.classList.add('is-slide');
        });
        each(root.querySelectorAll(POP), function (e) {
          var was = s.on[keyOf(e)], now = isOn(e);
          if (was === undefined || was === now) return;
          e.classList.add(now ? 'is-pop' : 'is-unpop');
        });
        each(root.querySelectorAll(NEW), function (e) { if (!s.had[keyOf(e)]) e.classList.add('is-new'); });
      }
      return { snap: snap, play: play, keyOf: keyOf };
    })();
    /* render through here and the selected controls carry their motion over.
       `after` runs before the measuring pass: anything that changes the layout
       once the markup is in (mounting a teach model fills the step bar and
       shifts the mode switch) has to happen first, or the pill measures a
       position it is about to leave. */
    var SCROLLERS = '.sl-scroll, .sl-rail, .sl-teach-rail-q, .sl-strands', lastPaint = 0;
    /* a render puts the keyboard back where it was by calling focus(), which
       fires focusin. That is not a pupil reaching a control, so no tooltip. */
    var focusRestore = false;
    function focusKey(e) { return e && e !== document.body && e !== shell ? { tag: e.tagName, key: MO.keyOf(e) } : null; }
    function paint(host, html, after) {
      /* a render must not throw a pupil back to the top of the list, nor drop
         the keyboard's place: the scrollers' positions and the focused control
         are found again in the new markup */
      var t0 = (window.performance && performance.now) ? performance.now() : 0;
      var ae = document.activeElement, fk = (ae && host.contains(ae)) ? focusKey(ae) : null, saved = [];
      each(host.querySelectorAll(SCROLLERS), function (sc, i) { if (sc.scrollTop || sc.scrollLeft) saved.push({ i: i, top: sc.scrollTop, left: sc.scrollLeft }); });
      MO.snap(host);
      host.innerHTML = html;
      if (after) after();
      /* PHONE LIBRARY + MIXED TRAY + LEVEL TICK SCROLL (2026-09-21): the scrollers are scroll-behavior:smooth, so writing the old
         position back started a glide from 0 on the NEW list, and the scrollLeft write straight
         after it cancelled the glide: a phone ticking a level row was thrown back to the top.
         Put the position back instantly. */
      if (saved.length) { var scs = host.querySelectorAll(SCROLLERS); saved.forEach(function (s) { var sc = scs[s.i]; if (!sc) return; var sb = sc.style.scrollBehavior; sc.style.scrollBehavior = 'auto'; sc.scrollTop = s.top; sc.scrollLeft = s.left; sc.style.scrollBehavior = sb; }); }
      if (fk && !host.contains(document.activeElement)) {
        var hit = null; each(host.querySelectorAll(fk.tag), function (c) { if (!hit && MO.keyOf(c) === fk.key) hit = c; });
        if (hit) { focusRestore = true; try { hit.focus({ preventScroll: true }); } catch (e) { try { hit.focus(); } catch (e2) {} } focusRestore = false; }
      }
      MO.play(host);
      if (t0) lastPaint = performance.now() - t0;
    }
    /* restart a one-shot animation on a node that is patched in place */
    function refresh(node) { if (reduceMotion || !node) return; node.classList.remove('is-fresh'); void node.offsetWidth; node.classList.add('is-fresh'); }
    function diffCount(a, b) { if (a.length !== b.length) return Math.max(a.length, b.length); var n = 0, i; for (i = 0; i < a.length; i++) if (a[i] !== b[i]) n++; return n; }
    var FX = {};
    /* how deep each screen sits: going deeper slides in from the right, coming back from the left */
    var DEPTH = { welcome: 0, library: 0, mixed: 1, skill: 2, boardsetup: 3, speedsetup: 3, practise: 3, teach: 4, turn: 4, board: 4, speed: 4, papers: 3, checklist: 1 };
    var entering = false, opening = false;

    /* ---------- loading a skill's engine ----------
       The library and the skill screen run on the manifest alone. The first
       time an activity needs a skill's engine (Practise, Teach, Board, a deep
       link) its asset is fetched: the control that was pressed goes busy, and
       the screen only changes once every needed module has registered. A load
       that fails says so in a toast with a retry; a load overtaken by another
       navigation is dropped. */
    var loadTok = 0, lastLoad = null;
    function busy(btn, on, label) {
      if (!btn) return;
      btn.classList.toggle('is-busy', !!on); btn.setAttribute('aria-busy', on ? 'true' : 'false');
      if (on) { btn.disabled = true; if (label) { btn.setAttribute('data-label', btn.innerHTML); btn.innerHTML = ICON.refresh + esc(label); } }
      else { btn.disabled = false; if (btn.hasAttribute('data-label')) { btn.innerHTML = btn.getAttribute('data-label'); btn.removeAttribute('data-label'); } }
    }
    var loadLineT = 0;
    function withSkills(ids, btn, go, labelled) {
      ids = ids.filter(Boolean);
      if (ids.every(SL.ready)) { go(); return; }
      var tok = ++loadTok, n = ids.filter(function (id) { return !SL.ready(id); }).length;
      lastLoad = { ids: ids, go: go };
      busy(btn, true, labelled ? (n > 1 ? 'Preparing ' + n + ' skills' : 'Loading') : null);
      /* SMOOTH LOADING (2026-10-18): a slow load draws a thin line across the top (smooth-load.css) */
      clearTimeout(loadLineT); loadLineT = setTimeout(function () { if (tok === loadTok) shell.classList.add('is-loading'); }, 120);
      function unline() { clearTimeout(loadLineT); shell.classList.remove('is-loading'); }
      SL.ensure(ids).then(function () {
        if (tok !== loadTok) return;
        unline(); busy(btn, false); go();
      }, function () {
        if (tok !== loadTok) return;
        unline(); busy(btn, false);
        toast('That skill did not load. Check the connection and try again.', 'Try again', function () { var L = lastLoad; if (L) withSkills(L.ids, null, L.go); });
      });
    }
    var toastEl = null, toastT = null;
    function toast(msg, action, fn) {
      if (!toastEl) { toastEl = el('div', 'sl-toast'); toastEl.setAttribute('role', 'status'); shell.appendChild(toastEl); }
      toastEl.innerHTML = '<span>' + esc(msg) + '</span>' + (action ? '<button type="button" class="sl-btn sl-btn--sm" id="slToastGo">' + esc(action) + '</button>' : '');
      toastEl.classList.add('is-on');
      var go = $('slToastGo'); if (go) go.onclick = function () { hideToast(); if (fn) fn(); };
      clearTimeout(toastT); toastT = setTimeout(hideToast, action ? 8000 : 3500);
    }
    function hideToast() { if (toastEl) toastEl.classList.remove('is-on'); clearTimeout(toastT); }

    /* Keys. One handler, per screen, and it stands down whenever the focus is in
       a field or on a button so Space and Enter still do the obvious thing. */
    /* SHORTER SHORTCUTS (2026-09-21). Aadam: "more concise - repetitive ones don't have to appear so many
       times". A key that does the same job on every screen is listed once, under Everywhere; a screen lists
       only what is its own. R gives new questions on the board as well (N still works there), and / opens
       this list as well as ?. A row's keys can be a list: one kbd each. */
    var KEYS = [
      /* SMARTBOARD KEYS (Aadam, 2026-09-21): N gives new questions on every screen, C marks a card
         correct and X marks it missed (Y and N used to), so copying a link moved from C to L */
      ['Everywhere', [['Space', 'Next card, step or question'], ['A', 'Show the answers'], ['N', 'New questions'],
                      ['Esc', 'Back'], ['F', 'Full screen'], ['L', 'Copy a link to this'], [['?', '/'], 'This list']]],
      ['Practise',   [[['←', '→'], 'Previous or next card'], [['C', '1'], 'Mark it correct'], [['X', '2'], 'Mark it missed'],
                      ['H', 'Hide the answers'], ['S', 'Show the steps']]],
      ['Teach',      [[['←', '→'], 'Back or forward a step'], [['↑', '↓'], 'Previous or next question'], ['R', 'A new one for this question']]],
      ['Board',      [['Space', 'Show or hide the answers'], ['T', 'Start or stop the timer']]],
      /* WHITEBOARD (2026-10-16) */
      ['Whiteboard', [['W', 'Open or close it (a blank one from the library)'], [['V', 'P', 'H', 'L', 'A', 'K', 'E'], 'Select, pen, highlighter, line, arrow, laser, rub out'],
                      ['Shift', 'Hold while you draw for a straight line'], ['Hold still', 'At the end of a rough line, curve or shape: it turns neat'],
                      [['E', 'K'], 'Hold to rub out or point, let go to go back'], [['1', '6'], 'Pen colours (tap the one in use to change it)'],
                      [['[', ']'], 'Thinner or thicker'], ['N', 'New question (a new page on a blank board)'], ['Shift N', 'New set of questions'],
                      ['G', 'Dots, squares, lines or plain paper'], ['Tab', 'Hide or show the tools'],
                      [['Ctrl C', 'Ctrl V'], 'Copy and paste (a picture pastes onto the board)'], ['Ctrl D', 'Copy what is picked'],
                      [['Delete', '←'], 'Delete or nudge what is picked'], [['Ctrl Z', 'Ctrl Y'], 'Undo or redo'], ['Space', 'Hold to see the answer']]],
      ['Your turn',  [[['1', '2'], 'Pick the left or right choice']]],
      ['Speed',      [[['0-9', '.', '-'], 'Type your answer'], ['⌫', 'Rub one out'], ['1-6', 'Pick an option'],
                      ['M', 'Sound on or off'], ['Esc', 'Pause']]]
    ];
    var keysOpen = false;
    function keysHTML() {
      return '<div class="sl-keys-card" role="dialog" aria-label="Keyboard shortcuts"><div class="sl-keys-head"><b>Keyboard shortcuts</b>' +
        '<button type="button" class="sl-iconbtn" id="slKeysX" aria-label="Close">' + ICON.cross + '</button></div>' +
        '<div class="sl-keys-cols">' + KEYS.map(function (g) {
          return '<div class="sl-keys-grp"><div class="sl-sect">' + g[0] + '</div>' + g[1].map(function (r) {
            return '<div class="sl-keys-row"><span class="sl-keys-k">' + [].concat(r[0]).map(function (x) { return '<kbd>' + x + '</kbd>'; }).join('') + '</span><span>' + r[1] + '</span></div>';
          }).join('') + '</div>';
        }).join('') + '</div></div>';
    }
    function toggleKeys(on) {
      keysOpen = (on === undefined) ? !keysOpen : !!on;
      var w = $('slKeys');
      if (!w) { w = el('div', 'sl-keys'); w.id = 'slKeys'; shell.appendChild(w); }
      w.innerHTML = keysOpen ? keysHTML() : '';
      w.classList.toggle('is-on', keysOpen);
    }

    /* The browser's own tooltip is grey OS chrome, shows one line of plain text
       and takes a second to appear. A level chip has to say what the questions
       ARE, so it gets a proper pill: the plain-English name, then an example. */
    var tipEl = null, tipFor = null;
    function tipNode() {
      if (tipEl) return tipEl;
      tipEl = el('div', 'sl-tip');
      tipEl.setAttribute('role', 'tooltip');
      shell.appendChild(tipEl);
      return tipEl;
    }
    function showTip(t) {
      var name = t.getAttribute('data-tip'); if (!name) return;
      var eg = t.getAttribute('data-tipeg') || '', sub = t.getAttribute('data-tipsub') || '';
      var n = tipNode();
      /* Aadam, 2026-09-15: hover states "easier to understand and not overly complicated". One
         line: what it is, and its key when it has one. The sentence under it has gone, except where
         the tip IS the information (a bar on the Speed chart says which question it was). */
      var key = (sub.match(/Key:\s*(\S+)\s*$/) || [])[1] || '', keep = t.hasAttribute('data-tipkeep');
      n.classList.toggle('is-row', !eg && !keep);
      n.innerHTML = '<b>' + esc(name) + '</b>' + (eg ? '<span class="sl-expr">' + eg + '</span>' : '') +
        (keep && sub ? '<span class="sl-tipsub">' + esc(sub) + '</span>' : '') +
        (key ? '<kbd class="sl-tipkey">' + esc(key) + '</kbd>' : '');
      n.classList.add('is-on');
      var r = (SL.rawRect || function (x) { return x.getBoundingClientRect(); })(t), w = n.offsetWidth, h = n.offsetHeight;
      var left = Math.round(r.left + r.width / 2 - w / 2);
      left = Math.max(8, Math.min(left, window.innerWidth - w - 8));
      var top = Math.round(r.bottom + 8);
      if (top + h > window.innerHeight - 8) top = Math.round(r.top - h - 8);
      n.style.left = left + 'px'; n.style.top = top + 'px';
      tipFor = t;
    }
    function hideTip() { if (tipEl) tipEl.classList.remove('is-on'); tipFor = null; }
    shell.addEventListener('mouseover', function (e) {
      var t = e.target.closest ? e.target.closest('[data-tip]') : null;
      if (t && t !== tipFor) showTip(t); else if (!t && tipFor) hideTip();
    });
    shell.addEventListener('mouseout', function (e) {
      var t = e.target.closest ? e.target.closest('[data-tip]') : null;
      if (t && t === tipFor && !t.contains(e.relatedTarget)) hideTip();
    });
    /* a pill on FOCUS is for the keyboard. The shell focuses its first control
       the moment it opens, and a tooltip hanging open over the rail on load
       reads as a stuck panel, so a mouse focus does not raise one.
       A deep link opens the shell before anything has been pressed, and with no
       input yet :focus-visible MATCHES a scripted focus, so "Back to board setup"
       hung over the first column head on every board link. A tab opened in the
       background gets that focusin late, when it is first shown, so a flag round
       the call is not enough: after the shell opens, no pill on focus until a key
       is pressed (a modifier alone, as in cmd-tab, does not count). */
    var openQuiet = false;
    document.addEventListener('keydown', function (e) {
      if (!/^(Shift|Meta|Control|Alt|AltGraph|OS|CapsLock)$/.test(e.key || '')) openQuiet = false;
    }, true);
    shell.addEventListener('focusin', function (e) {
      if (focusRestore || openQuiet) return;
      var t = e.target.closest ? e.target.closest('[data-tip]') : null;
      if (!t) { hideTip(); return; }
      var kb = true; try { kb = t.matches(':focus-visible'); } catch (err) {}
      if (kb) showTip(t); else hideTip();
    });
    shell.addEventListener('focusout', hideTip);
    shell.addEventListener('click', hideTip, true);
    shell.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null;
      if (t && t.id === 'slKeysX') { toggleKeys(false); return; }
      /* the button that OPENED the panel is not an outside click: the top bar
         handler runs first, so by the time this one sees the same click the
         panel is already open and closing it here made the button look dead */
      if (t && t.id === 'slKeysBtn') return;
      if (keysOpen && !(e.target.closest && e.target.closest('.sl-keys-card'))) toggleKeys(false);
    });
    window.addEventListener('scroll', hideTip, true);

    /* Paper: the shell sits deep inside the theme's wrappers, and a print rule
       cannot say "hide everything except this element's ancestors". So the chain
       from the shell up to <body> is tagged while the app is open, and the print
       sheet hides every sibling of that chain. */
    function markPrintPath(on) {
      var e = shell.parentElement;
      while (e && e !== document.body) { e.classList.toggle('sl-printpath', !!on); e = e.parentElement; }
    }
    var closing = null;
    function openShell(screen, noWel) {
      if (closing) { clearTimeout(closing); closing = null; shell.classList.remove('is-closing'); shell.inert = false; }
      shell.classList.add('is-on'); shell.setAttribute('aria-hidden', 'false');
      root.classList.add('app-open');
      lockScroll(); setInert(true); markPrintPath(true);
      opening = true;
      track('lab_open', {
        entry: /^#(play|library|skills|mixed|skill|practise|teach|turn|board|speed|whiteboard)/.test(location.hash || '') ? 'deep_link' : 'button',
        returning: S.intro.done ? 'yes' : 'no',
        who: S.intro.who, goal: S.intro.goal
      });
      /* a deep link opens what it names; only the plain Open button, which
         asks for the library, ever meets the walkthrough */
      show((!screen || screen === 'library') && !S.intro.done && !noWel ? 'welcome' : (screen || 'library'));
      setTimeout(function () { openQuiet = true; var f = elTop.querySelector('button'); if (f) f.focus(); else shell.focus(); }, 30);
    }
    /* the shell settles out over a sixth of a second, then really closes */
    function closeShell() {
      if (closing) return;
      loadTok++; hideToast(); clearTimeout(cascadeT); clearTimeout(searchTimer);
      if (reduceMotion) { closeNow(); return; }
      /* nothing may act on the app while it settles out */
      shell.classList.add('is-closing'); shell.inert = true;
      closing = setTimeout(closeNow, 170);
    }
    function closeNow() {
      closing = null; shell.classList.remove('is-closing'); shell.inert = false;
      destroyTeach();
      shell.classList.remove('is-on'); shell.setAttribute('aria-hidden', 'true');
      root.classList.remove('app-open');
      setInert(false); unlockScroll(); markPrintPath(false); toggleKeys(false); stopTimer(); destroyChorus(); destroyTurn(); spReset(); clearOut(); welFormRestore();
      if (window.history && history.replaceState && location.hash) {
        try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      }
      var o = $('slOpen'); if (o) o.focus();
    }
    function destroyTeach() { if (S.teach.r) { try { S.teach.r.destroy(); } catch (e) {} S.teach.r = null; } }
    function destroyTurn() { if (S.turn.r) { try { S.turn.r.destroy(); } catch (e) {} S.turn.r = null; } }
    /* The screen that is LEAVING goes with the one arriving: it is held over
       the body for a fifth of a second, pushed the other way and faded, so a
       skill slides in over the library instead of replacing it in one frame.
       Only the still screens do this. A board, a run or a teach model carries
       measuring rigs that must not be asked to lay out twice, and a second copy
       of one on the stage would refit the live one underneath it. */
    var OUT_OK = { welcome: 1, library: 1, mixed: 1, skill: 1, boardsetup: 1, speedsetup: 1 };
    var outEl = null, outT = null;
    function clearOut() {
      if (!outEl) return;
      outEl.classList.remove('is-out', 'is-on'); outEl.removeAttribute('data-out'); outEl = null;
      clearTimeout(outT);
    }
    /* The leaving screen KEEPS is-on while it goes, and is-out takes it out of
       the flow instead. Dropping is-on first put it through display: none in
       the same style pass, and the animation Chrome then made on it stayed
       play-pending for ever: the class was right, the screen never moved. */
    function screenOut(prev, dir) {
      clearOut();
      var e = prev ? $(SCREEN_ID[prev]) : null;
      if (reduceMotion || !e || !OUT_OK[prev] || dir === 'none') { if (e) e.classList.remove('is-on'); return; }
      outEl = e; e.classList.add('is-out'); e.setAttribute('data-out', dir);
      outT = setTimeout(clearOut, 300);
    }
    function show(name) {
      if (S.screen === 'teach' && name !== 'teach') { destroyTeach(); destroyChorus(); }
      if (S.screen === 'papers' && name !== 'papers') destroyPapers();
      if (S.screen === 'turn' && name !== 'turn') destroyTurn();
      if (S.screen === 'board' && name !== 'board') stopTimer();
      if (S.screen === 'speed' && name !== 'speed') spReset();
      var prev = S.screen;
      hideTip();
      if (prev === 'welcome' && name !== 'welcome') welFormRestore();
      S.screen = name; loadTok++;
      /* TEACH ON EVERY PHONE (2026-10-19): the question list and the levels are sheets there, shut on arrival */
      if (name === 'teach' && narrow()) { S.teach.listOpen = false; S.teach.lvOpen = false; }
      if (name === 'library' || name === 'mixed') clFrom = false; else if (name === 'checklist') clFrom = true;
      var dir = (opening || reduceMotion || name === prev) ? 'none' : (DEPTH[name] >= DEPTH[prev] ? 'fwd' : 'back');
      elBody.setAttribute('data-dir', dir);
      opening = false; entering = true;
      syncHash(prev !== name);
      Object.keys(SCREEN_ID).forEach(function (k) { if (k !== prev) $(SCREEN_ID[k]).classList.remove('is-on'); });
      $(SCREEN_ID[name]).classList.add('is-on');
      screenOut(prev === name ? null : prev, dir);
      var r = { welcome: renderWelcome, library: renderLibrary, mixed: renderMixed, skill: renderSkill, boardsetup: renderBoardSetup, speedsetup: renderSpeedSetup, practise: renderPractise, teach: renderTeach, turn: renderTurn, board: renderBoard, speed: renderSpeed, papers: renderPapers, checklist: renderChecklist }[name];
      r();
      renderTop();
      entering = false;
      var sc = $(SCREEN_ID[name]).querySelector('.sl-scroll'); if (sc) sc.scrollTop = 0;
      if (name !== prev) trackScreen(name);
    }
    /* what someone actually chose to do, named once per arrival */
    var ACTIVITY = { practise: 1, teach: 1, board: 1, speed: 1, turn: 1 };
    function trackScreen(name) {
      var sk = curSkill();
      if (name === 'skill' && sk) { track('skill_open', { skill: sk.id, strand: strandOf(sk, S.stage), stage: S.stage, levels: levelsOf(sk) }); return; }
      if (name === 'mixed') { track('mix_open', { mix_size: S.mix.length }); return; }
      if (!ACTIVITY[name]) return;
      track('activity_start', {
        activity: name, skill: S.from === 'mixed' ? 'mixed' : (sk ? sk.id : ''),
        levels: S.from === 'mixed' ? '' : (sk ? levelsOf(sk) : ''),
        mix_size: S.from === 'mixed' ? mixSkills().length : 1,
        stage: S.stage
      });
    }
    /* where "back" and "Change skill" go from an activity */
    function backTarget() { return S.from === 'mixed' ? 'mixed' : 'skill'; }
    /* the steps screen returns to whatever opened it: practise, or the skill */
    function backFromTeach() { return S.teach.back === 'practise' && S.set.length ? 'practise' : backTarget(); }
    function changeSkill() { S.from = 'skills'; show(libHome()); }

    /* ---------- top bar ---------- */
    function titleHTML() {
      var sk = curSkill();
      var it = S.screen === 'teach' && S.set[S.teach.i];
      /* TEACH ON EVERY PHONE (2026-10-19): the level line is the button that opens the levels sheet (the chips
         row is gone there), so the level NAME, which the chips never showed and this line cut off, is one tap away */
      var lvBtn = function (label, full) { return '<button type="button" class="sl-lvlbtn" id="slLvlBtn" aria-expanded="' + (S.teach.lvOpen ? 'true' : 'false') + '" aria-label="' + esc(full) + '">' + esc(label) + ICON.chevD + '</button>'; };
      if (S.from === 'mixed') return '<span class="sl-title"><b>Mixed practice</b>' + (it && narrow() ? lvBtn('Levels', 'Levels') : '<span>' + mixSkills().length + ' skills</span>') + '</span>';
      if (!sk) return '';
      var sub = it ? 'Level ' + it.level + ': ' + levelName(it.skill, it.level) : levelWord(sk);
      if (it && narrow()) return '<span class="sl-title"><b>' + esc(it.skill.name) + '</b>' + lvBtn('Level ' + it.level, sub) + '</span>';
      return '<span class="sl-title"><b>' + esc(it ? it.skill.name : sk.name) + '</b><span>' + esc(sub) + '</span></span>';
    }
    function renderTop() {
      var h = '';
      /* The tooltip pill, not the browser's own: title= is grey OS chrome that
         takes a second to show and cannot say a second line. Every control in
         this bar is an icon, so every one of them says what it does and what
         key does the same thing. A control with data-tip must NOT also carry a
         title, or the OS tooltip turns up underneath it. */
      var full = '<button type="button" class="sl-iconbtn" id="slCopyLink" aria-label="Copy a link to this" data-tip="Copy a link" data-tipsub="A link that opens this skill at these levels. Key: L">' + ICON.link + '</button>' +
        '<button type="button" class="sl-iconbtn hide-sm" id="slKeysBtn" aria-label="Keyboard shortcuts" data-tip="Keyboard shortcuts" data-tipsub="Every key the app listens for. Key: ? or /"><span class="sl-kbd">?</span></button>' +
        '<button type="button" class="sl-iconbtn" id="slFull" aria-label="Full screen" data-tip="Full screen" data-tipsub="Fill the whole screen, for the front of a class. Key: F">' + ICON.expand + '</button>';
      var back = function (id, label) { return '<button type="button" class="sl-iconbtn" id="' + id + '" aria-label="' + label + '" data-tip="' + label + '" data-tipsub="Key: Esc">' + ICON.chevL + '</button>'; };
      var TIP = function (name, sub) { return ' data-tip="' + name + '" data-tipsub="' + sub + '"'; };
      if (S.screen === 'welcome') {
        h = '<button type="button" class="sl-iconbtn" id="slClose" aria-label="Close Skills Lab" data-tip="Close" data-tipsub="Leave the Skills Lab and go back to the page. Key: Esc">' + ICON.cross + '</button>' +
          '<h1 class="sl-wordmark">Maths Skills <span>Lab</span></h1>' +
          '<div class="sl-spacer"></div>' +
          welSkipHTML() + themeBtn();
      } else if (S.screen === 'library' || S.screen === 'mixed' || S.screen === 'checklist') {
        h = '<button type="button" class="sl-iconbtn" id="slClose" aria-label="Close Skills Lab" data-tip="Close" data-tipsub="Leave the Skills Lab and go back to the page. Key: Esc">' + ICON.cross + '</button>' +
          '<h1 class="sl-wordmark">Maths Skills <span>Lab</span></h1><div class="sl-vbar"></div>' +
          '<div class="sl-segwrap" role="tablist" data-mo-group="view"><button type="button" role="tab" class="sl-seg' + (S.screen === 'library' ? ' is-on' : '') + '" data-view="skills">' + ICON.book + 'Skills</button>' +
          '<button type="button" role="tab" class="sl-seg' + (S.screen === 'mixed' ? ' is-on' : '') + '" data-view="mixed">' + ICON.grid + 'Mixed practice</button>' +
          '<button type="button" role="tab" class="sl-seg' + (S.screen === 'checklist' ? ' is-on' : '') + '" data-view="checklist">' + ICON.list + 'Checklist</button></div>' +
          '<div class="sl-spacer"></div>' + (S.screen === 'checklist' ? '' : searchTopHTML() + zoomHTML()) +
          '<button type="button" class="sl-btn sl-btn--sm sl-btn--cta sl-wbopen" id="slWbBlank"' + TIP('Whiteboard', 'A blank board to draw on, no questions. Key: W') + '>' + WB.pen + '<span class="po-lbl hide-sm">Whiteboard</span></button>' +
          '<div class="sl-vbar hide-sm"></div>' + full + themeBtn();
      } else if (S.screen === 'papers') {
        h = back('slBackLib', 'Back to skills') + '<h1 class="sl-wordmark hide-sm">Maths Skills <span>Lab</span></h1><span class="sl-title show-sm"><b>Past papers</b></span><div class="sl-spacer"></div>' + full + themeBtn();
      } else if (S.screen === 'skill') {
        h = back('slBackLib', 'Back to skills') + '<h1 class="sl-wordmark hide-sm">Maths Skills <span>Lab</span></h1><div class="sl-spacer"></div>' +
          '<button type="button" class="sl-btn sl-btn--sm sl-allbtn" id="slChange"' + TIP('All skills', 'See every skill in the Lab and pick another.') + '>' + ICON.book + '<span class="sl-allsk">All skills</span></button>' + full + themeBtn();
      } else if (S.screen === 'boardsetup') {
        h = back('slBackSkill', 'Back to the skill') + titleHTML() + '<div class="sl-spacer"></div>' + full + themeBtn();
      } else if (S.screen === 'practise') {
        var marked = S.set.filter(function (it) { return it.state === 'ok' || it.state === 'miss'; }).length;
        var ok = S.set.filter(function (it) { return it.state === 'ok'; }).length;
        var done = S.set.filter(function (it) { return it.state !== 'hid'; }).length;
        /* ONE BAR (Aadam, 2026-09-16): the level chips and Type the answer used to sit in a strip of
           their own under this bar, saying what the title already says. They live here now, Print and
           Change skill are icons, and Hide answers is an icon beside Show all answers. */
        h = back('slBackSkill', S.prOne >= 0 ? 'Back to all cards' : 'Back') + titleHTML() +
          '<div class="sl-prchips">' + activeSkills().map(function (sk) { return topicHTML(sk, 0); }).join('') + '</div>' +
          '<button type="button" class="sl-toggle' + (S.typed ? ' is-on' : '') + '" id="slTyped" aria-pressed="' + (S.typed ? 'true' : 'false') + '"' + TIP('Type the answer', 'Type it in instead of turning the card over.') + '><i></i>Type the answer</button>' +
          '<div class="sl-spacer"></div>' +
          '<span class="sl-mini' + (FX.count ? ' is-pop' : '') + '"' + TIP('Your marking', 'How many you have marked right, out of the ones you have marked.') + '><span class="num lg">' + ok + ' correct · ' + marked + ' marked</span><span class="num sm" aria-hidden="true">' + ICON.tick + ok + '/' + marked + '</span></span>' +
          '<span class="sl-mini hide-sm"' + TIP('How far through', 'How many of the ' + S.set.length + ' you have looked at.') + '><span class="num">' + done + ' of ' + S.set.length + ' done</span></span>' +
          (anyHidden() ? '<button type="button" class="sl-btn sl-btn--sm" id="slRevealAll"' + TIP('Show all answers', 'Turns every card over at once. Marking you have already done stays.') + '>' + ICON.eye + 'Show all answers</button>' : '') +
          (anyShown() ? '<button type="button" class="sl-iconbtn" id="slHideAll" aria-label="Hide answers"' + TIP('Hide answers', 'Puts every answer back. Your ticks stay.') + '>' + ICON.eyeOff + '</button>' : '') +
          '<button type="button" class="sl-iconbtn hide-sm" id="slPrintSet" aria-label="Print"' + TIP('Print', 'An A4 sheet of these questions with room to work.') + '>' + ICON.print + '</button>' +
          '<button type="button" class="sl-btn sl-btn--sm" id="slNewSet"' + TIP('New ' + S.setN, S.setN + ' fresh questions at the same levels. Your marking is cleared. Key: N') + '>' + ICON.refresh + 'New ' + S.setN + '</button>' +
          (S.from === 'mixed' ? '<button type="button" class="sl-iconbtn" id="slChange" aria-label="Change mix"' + TIP('Change mix', 'Back to the mix to pick again.') + '>' + ICON.book + '</button>' : '<button type="button" class="sl-btn sl-btn--sm sl-allbtn" id="slChange"' + TIP('All skills', 'See every skill in the Lab and pick another.') + '>' + ICON.book + '<span class="sl-allsk">All skills</span></button>') + full + themeBtn();
      } else if (S.screen === 'teach') {
        h = back('slBackSkill', 'Back') + titleHTML() + '<div class="sl-spacer"></div>' +
          (chorusOK() ? '<button type="button" class="sl-toggle' + (S.teach.chorus ? ' is-on' : '') + '" id="slChorusBtn" aria-pressed="' + (S.teach.chorus ? 'true' : 'false') + '"' + TIP(esc(curSkill().chorusName || 'Count together'), '') + '><i></i>' + esc(curSkill().chorusName || 'Count together') + '</button><div class="sl-vbar"></div>' : '') +
          '<div class="sl-segwrap hide-sm"><button type="button" class="sl-seg is-on">' + ICON.steps + 'Teach</button><button type="button" class="sl-seg" id="slTeachPractise"' + TIP('Practise', 'The same questions as a set to work through and mark.') + '>' + ICON.list + 'Practise</button></div>' +
          '<button type="button" class="sl-btn sl-btn--sm sl-allbtn" id="slChange"' + TIP('All skills', 'See every skill in the Lab and pick another.') + '>' + ICON.book + '<span class="sl-allsk">All skills</span></button>' + full + themeBtn();
      } else if (S.screen === 'speedsetup') {
        h = back('slBackSkill', 'Back to the skill') + titleHTML() + '<div class="sl-spacer"></div>' + full + themeBtn();
      } else if (S.screen === 'speed') {
        var running = SP.phase !== 'done';
        h = back('slSpQuit', running ? 'End the run' : 'Back') + titleHTML() + '<div class="sl-spacer"></div>' +
          (running ? spRunTopHTML() +
            '<button type="button" class="sl-iconbtn hide-sm" id="slFull" aria-label="Full screen" data-tip="Full screen" data-tipsub="Key: F">' + ICON.expand + '</button>'
            : full) + themeBtn();
      } else if (S.screen === 'turn') {
        var uOK = S.turn.log.filter(function (x) { return x.ok; }).length;
        h = back('slBackSkill', 'Back') + titleHTML() + '<div class="sl-spacer"></div>' +
          /* the pips in the rail already say what happened to each question, so
             the phone drops the chip rather than wrapping the bar to two rows */
          (S.turn.phase === 'play' ? '<span class="sl-mini hide-sm' + (FX.count ? ' is-pop' : '') + '"' + TIP('Right first time', 'Questions where every decision was right on the first try.') + '><span class="num">' + uOK + ' right first time</span></span>' +
            '<span class="sl-mini hide-sm"' + TIP('How far through', 'Which question you are on.') + '><span class="num">' + Math.min(S.turn.i + 1, S.set.length) + ' of ' + S.set.length + '</span></span>' : '') +
          '<button type="button" class="sl-btn sl-btn--sm sl-ulabel" id="slUAgain"' + TIP('Start again', 'Ten fresh questions at the same levels. Key: N') + '>' + ICON.refresh + '<span>Start again</span></button>' +
          '<button type="button" class="sl-btn sl-btn--sm sl-allbtn" id="slChange"' + TIP('All skills', 'See every skill in the Lab and pick another.') + '>' + ICON.book + '<span class="sl-allsk">All skills</span></button>' + full + themeBtn();
      } else if (S.screen === 'board') {
        /* Show answers moved to the right-hand end, as a button that says what it will do
           (Aadam, 2026-09-15: "move the show answers button to more clear place on the right") */
        h = back('slBackSetup', 'Back to board setup') + titleHTML() + '<div class="sl-spacer"></div>' +
          '<span id="slTimerWrap"></span><div class="sl-vbar"></div>' +
          '<button type="button" class="sl-btn sl-btn--sm" id="slBoardNew"' + TIP('New set', 'Key: N') + '>' + ICON.refresh + 'New set</button>' +
          '<button type="button" class="sl-btn sl-btn--sm hide-sm" id="slBoardPrintQ"' + TIP('Print questions', '') + '>' + ICON.print + 'Print questions</button>' +
          '<button type="button" class="sl-btn sl-btn--sm hide-sm" id="slBoardPrintA"' + TIP('Print with answers', '') + '>' + ICON.print + 'With answers</button>' +
          '<div class="sl-vbar"></div>' +
          '<button type="button" class="sl-btn sl-btn--sm sl-bansbtn' + (S.board.ans ? ' is-on' : '') + '" id="slBoardAns" aria-pressed="' + (S.board.ans ? 'true' : 'false') + '"' + TIP(S.board.ans ? 'Hide answers' : 'Show answers', 'Key: Space') + '>' + (S.board.ans ? ICON.eyeOff + 'Hide answers' : ICON.eye + 'Show answers') + '</button>' +
          full + themeBtn();
      }
      elTop.classList.toggle('is-enter', entering);
      elTop.classList.toggle('is-run', S.screen === 'speed' && SP.phase !== 'done');
      elTop.classList.toggle('is-pr', S.screen === 'practise');
      elTop.classList.toggle('is-lib', S.screen === 'library' || S.screen === 'mixed' || S.screen === 'checklist');
      paint(elTop, h); FX.count = false;
      if (S.screen === 'board') paintTimer();
      applyTheme();
      fitTop();
    }
    /* one row or not: offsetTop ignores the slide-in transform, so an entering bar does not read as wrapped */
    function topWraps() {
      var tops = [], kids = elTop.children, i, k;
      for (i = 0; i < kids.length; i++) { k = kids[i]; if (k.offsetParent !== null && k.offsetWidth) tops.push(k.offsetTop + k.offsetHeight / 2); }
      return tops.length > 1 && Math.max.apply(null, tops) - Math.min.apply(null, tops) > 20;
    }
    function fitTop() {
      if (!elTop) return;
      elTop.classList.remove('is-tight');
      if (window.innerWidth <= 860) return;
      if (topWraps()) elTop.classList.add('is-tight');
    }
    var fitTopT = null;
    window.addEventListener('resize', function () { clearTimeout(fitTopT); fitTopT = setTimeout(fitTop, 120); });
    try { document.fonts.ready.then(function () { fitTop(); }); document.fonts.addEventListener('loadingdone', function () { fitTop(); }); } catch (err) {}
    function toggleFull() { try { if (document.fullscreenElement) document.exitFullscreen(); else shell.requestFullscreen(); } catch (err) {} }
    elTop.addEventListener('keydown', function (e) {
      if (!e.target || e.target.id !== 'slTimerIn') return;
      if (e.key === 'Enter') { e.preventDefault(); commitTimer(e.target.value); }
      if (e.key === 'Escape') { e.preventDefault(); TM.editing = false; paintTimer(); }
    });
    elTop.addEventListener('focusout', function (e) {
      if (e.target && e.target.id === 'slTimerIn') commitTimer(e.target.value);
    });
    elTop.addEventListener('input', function (e) {
      var t = e.target; if (!t) return;
      if (t.id === 'slSearch') { onSearch(e, rerenderLib); return; }
      if (t.getAttribute && t.getAttribute('data-slider') === 'libzoom') setLibZoom(Number(t.value), false);
    });
    elTop.addEventListener('change', function (e) {
      var t = e.target; if (t && t.getAttribute && t.getAttribute('data-slider') === 'libzoom') setLibZoom(Number(t.value), true);
    });
    elTop.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null;
      if (!t) return;
      if (t.hasAttribute('data-clearsearch')) { S.search = ''; S.libMore = false; rerenderLib(); syncSearchBox(); var si = $('slSearch'); if (si) si.focus(); return; }
      if (t.hasAttribute('data-libzoom')) { setLibZoom(libZoomAt() + Number(t.getAttribute('data-libzoom')), true); return; }
      if (t.hasAttribute('data-sl-theme')) { toggleTheme(); return; }
      if (t.id === 'slClose') { closeShell(); return; }
      if (t.getAttribute('data-view')) { show({ mixed: 'mixed', checklist: 'checklist' }[t.getAttribute('data-view')] || 'library'); return; }
      if (t.id === 'slWelSkip') { welDone(welStep() >= 3); return; }
      if (t.id === 'slBackLib') { show(libHome()); return; }
      if (t.id === 'slBackSkill' && S.screen === 'practise' && S.prOne >= 0) { toWall(); return; }
      if (t.id === 'slBackSkill') { show(S.screen === 'teach' ? backFromTeach() : backTarget()); return; }
      if (t.id === 'slBackSetup') { show(S.from === 'mixed' ? 'mixed' : 'boardsetup'); return; }
      /* Back out of a run that has answers in it goes to the RESULTS, not to
         nothing: the seconds are the point, and throwing them away silently
         because someone reached for the arrow is a bad trade. */
      if (t.id === 'slSpQuit') { if (SP.phase === 'play' && SP.log.length) spFinish(true); else { spReset(); show('speedsetup'); } return; }
      if (t.id === 'slSpSnd') { toggleSound(); renderTop(); return; }
      if (t.id === 'slSpPause') { spPause(true); return; }
      if (t.id === 'slChange') { if (S.from === 'mixed') show('mixed'); else changeSkill(); return; }
      if (t.id === 'slLvlBtn') { S.teach.lvOpen = !S.teach.lvOpen; if (S.teach.lvOpen) S.teach.listOpen = false; phoneSheetSync(); return; }
      var prTopic = t.closest ? t.closest('.sl-prchips .sl-topic') : null;
      if (prTopic && t.getAttribute('data-togglelvl')) {
        var psk = SL.get(prTopic.getAttribute('data-topic'));
        if (partlyMarked() && !window.confirm('Change the levels and deal fresh questions? The marks on this set will go.')) return;
        toggleSel(psk, Number(t.getAttribute('data-togglelvl')));
        redealSkill(psk); renderPractise(); renderTop(); return;
      }
      if (t.id === 'slTyped') { S.typed = !S.typed; save(); renderPractise(); renderTop(); return; }
      if (t.id === 'slRevealAll') { revealAll(); return; }
      if (t.id === 'slPrintSet') { printSet(); return; }
      if (t.id === 'slHideAll') { hideAll(); return; }
      if (t.id === 'slNewSet') { if (partlyMarked() && !window.confirm('Start a fresh ' + S.setN + '? The marks on this set will go.')) return; buildSet(); renderPractise(); renderTop(); return; }
      if (t.id === 'slTeachPractise') { S.teach.back = 'practise'; show('practise'); return; }
      if (t.id === 'slUAgain') { startTurn(); renderTurn(); renderTop(); return; }
      if (t.id === 'slCopyLink') { copyLink(); return; }
      if (t.id === 'slFull') { toggleFull(); return; }
      if (t.id === 'slWbBlank') { WB.openBlank(); return; }
      if (t.id === 'slKeysBtn') { toggleKeys(true); return; }
      if (t.id === 'slTimerFace') { TM.editing = true; paintTimer(); return; }
      if (t.id === 'slTimerGo') { toggleTimer(); return; }
      if (t.id === 'slTimerRe') { resetTimer(); return; }
      if (t.id === 'slChorusBtn') { S.teach.chorus = !S.teach.chorus; save(); renderTeach(); renderTop(); return; }
      if (t.id === 'slBoardAns') { setAllAns(!S.board.ans); paintAns(); renderTop(); return; }
      if (t.id === 'slBoardNew') { buildBoard(); renderBoard(); renderTop(); return; }
      if (t.id === 'slBoardPrintQ') { printBoard(false); return; }
      if (t.id === 'slBoardPrintA') { printBoard(true); return; }
    });
    /* the practise set as a worksheet: questions only, with room to write */
    function printSet() {
      var skP = curSkill();
      track('practise_print', { skill: S.from === 'mixed' ? 'mixed' : (skP ? skP.id : ''), question_count: S.set.length });
      document.documentElement.classList.add('sl-printing');
      elPr.classList.add('is-printing');
      setTimeout(function () {
        window.print();
        document.documentElement.classList.remove('sl-printing');
        elPr.classList.remove('is-printing');
      }, 80);
    }
    function printBoard(withAnswers) {
      var sk0 = curSkill();
      track('board_print', { with_answers: withAnswers ? 'yes' : 'no', skill: S.from === 'mixed' ? 'mixed' : (sk0 ? sk0.id : ''), question_count: S.board.n });
      var was = S.board.ans; setAllAns(withAnswers);
      document.documentElement.classList.add('sl-printing');
      renderBoard();
      setTimeout(function () {
        window.print();
        document.documentElement.classList.remove('sl-printing');
        setAllAns(was); renderBoard(); renderTop();
      }, 80);
    }

    /* ============================================================
       WELCOME
       The first open only. Three questions (who, what for, what first),
       then a starting point, then three cards about the activities those
       answers point at. Skippable at every step from the bar, from Escape
       and from the last question; re-openable from the rail foot. A deep
       link never meets it: a shared link opens what it names.
       ============================================================ */
    var elWel = $('slWelcome');
    /* The walkthrough, redesigned 2026-09-15 from the onboarding canvas: big
       tiles that move on by themselves, one short line a screen, and a working
       demo on every activity card. Three questions -> three cards for the role
       (the first names the first skill) -> the waitlist. */
    var WL_SVG = {
      family: svg('<circle cx="8.5" cy="7" r="3"/><path d="M3.5 20v-1.5a5 5 0 0 1 10 0V20"/><circle cx="17" cy="10.5" r="2.2"/><path d="M14.5 20v-1a3 3 0 0 1 6 0v1"/>'),
      pencil: svg('<path d="M4 20l1.2-4.6L15.8 4.8a2 2 0 0 1 2.8 0l.6.6a2 2 0 0 1 0 2.8L8.6 18.8z"/><path d="M13.5 7l3.5 3.5"/>'),
      checks: svg('<path d="M9.5 6H20M9.5 12H20M9.5 18H20"/><path d="M3.5 6l1.5 1.5L7 4.8M3.5 12l1.5 1.5L7 10.8"/><path d="M4.5 18h.01"/>'),
      mail: svg('<rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="M4 7l8 6 8-6"/>'),
      arrowL: svg('<path d="M20 12H5M11 6l-6 6 6 6"/>'),
      arrowD: svg('<path d="M12 4v15M6 13l6 6 6-6"/>')
    };
    var WEL_OPTS = {
      who: [
        { id: 'parent', icon: WL_SVG.family, name: 'Parent or carer', hue: 'gold' },
        { id: 'tutor', icon: ICON.board, name: 'Tutor or teacher', hue: '' },
        { id: 'pupil', icon: WL_SVG.pencil, name: 'Student', hue: 'green' }
      ],
      goal: [
        { id: '11plus', big: '11+', sub: 'Entrance exam', hue: 'gold', stage: 'primary' },
        { id: 'sats', big: 'SATs', sub: 'Year 6', hue: 'purple', stage: 'primary' },
        { id: 'gcse', big: 'GCSE', sub: 'Years 10 and 11', hue: '', stage: 'secondary' },
        { id: 'general', icon: ICON.book, name: 'Practice', sub: 'No exam', hue: '', stage: 'primary' }
      ],
      /* what they can pick first is the role's own three cards, so the tour
         always keeps all three of them */
      first: [
        { id: 'teach', icon: ICON.steps, name: 'Show me how', hue: '' },
        { id: 'practise', icon: WL_SVG.checks, name: 'Try questions', hue: 'green' },
        { id: 'levels', icon: ICON.trophy, name: 'See progress', hue: 'gold' },
        { id: 'board', icon: ICON.board, name: 'Teach a group', hue: 'purple' },
        { id: 'mixed', icon: ICON.grid, name: 'Mix skills', hue: 'green' },
        { id: 'speed', icon: ICON.clock, name: 'Beat the clock', hue: 'gold' }
      ]
    };
    /* ONBOARDING V3 (2026-10-27, Aadam: "show more of the features ... optional ... they have the compulsory
       questions", "keep the text simple"). Two questions they must answer, then Ready: start the first skill
       or take an optional look round all nine features. The email is asked on the page before the lab opens. */
    var WEL_Q = [
      { key: 'who', title: 'Who\'s using it?' },
      { key: 'goal', title: 'What\'s it for?' }
    ];
    var TOUR = {
      teach: { icon: ICON.steps, name: 'Show me how', short: 'Show me how', stk: [0, 0], line: '' },
      practise: { icon: WL_SVG.checks, name: 'Try questions', short: 'Questions', stk: [1, 0], line: 'Turn a card, then mark it' },
      speed: { icon: ICON.clock, name: 'Beat the clock', short: 'Speed race', stk: [2, 0], line: 'Answer 4 as fast as you can' },
      board: { icon: ICON.board, name: 'Teach a group', short: 'Class board', stk: [0, 1], line: 'Questions for the big screen' },
      mixed: { icon: ICON.grid, name: 'Mix skills', short: 'Mix skills', stk: [1, 1], line: 'Tick 2 or more skills' },
      levels: { icon: ICON.trophy, name: 'See progress', short: 'Progress', stk: [2, 1], line: 'Get 8 right to pass a level' },
      hand: { icon: WL_SVG.pencil, name: 'Handwritten', short: 'Handwritten', stk: [0, 2], line: 'The working, written by pen' },
      wboard: { icon: ICON.board, name: 'Whiteboard', short: 'Whiteboard', stk: [1, 2], line: 'A blank board to draw on' },
      print: { icon: ICON.board, name: 'Print', short: 'Print', stk: [2, 2], line: 'A sheet to do on paper' }
    };
    /* every feature, the ones that matter most to that person first */
    var TOUR_FOR = {
      parent: ['teach', 'practise', 'levels', 'hand', 'print', 'speed', 'mixed', 'wboard', 'board'],
      tutor: ['board', 'teach', 'hand', 'wboard', 'mixed', 'print', 'practise', 'speed', 'levels'],
      pupil: ['practise', 'speed', 'teach', 'levels', 'hand', 'mixed', 'wboard', 'print', 'board']
    };
    function wlStk(k, cls) { var c = TOUR[k].stk; return '<span class="wo-stk' + (cls ? ' ' + cls : '') + '" style="--sx:' + c[0] + ';--sy:' + c[1] + '" aria-hidden="true"></span>'; }
    var WL_M = '−';
    /* the demos are written by hand, checked, and chosen by stage: they show
       how an activity works, so they never wait on an engine to load */
    var WSETS = {
      count: {
        teach: { expr: '5 + 5 + 5 + 5', ans: '20', lo: 0, hi: 20, every: 5, line: 'Start at 5, then add 5', hopLabel: '+5', steps: [
          { cap: 'Start at 5', btn: 'Start at 5', pill: '5', at: 5, hops: [] },
          { cap: '5 + 5 = 10', btn: 'Add 5', pill: '10', at: 10, hops: [[5, 10]] },
          { cap: '10 + 5 = 15', btn: 'Add 5', pill: '15', at: 15, hops: [[5, 10], [10, 15]] },
          { cap: '15 + 5 = 20', btn: 'Add 5', pill: '20', at: 20, hops: [[5, 10], [10, 15], [15, 20]], done: true }
        ] },
        practise: [['5 + 5 + 5', '15'], ['3 + 3 + 3 + 3', '12'], ['40 ' + WL_M + ' 10 ' + WL_M + ' 10', '20']],
        speed: [
          { q: '2 + 2 + 2', a: '6', ch: ['4', '6', '8'] },
          { q: '10 + 10 + 10 + 10', a: '40', ch: ['30', '40', '50'] },
          { q: '4 + 4 + 4', a: '12', ch: ['12', '16', '8'] },
          { q: '25 ' + WL_M + ' 5 ' + WL_M + ' 5', a: '15', ch: ['20', '15', '10'] }
        ],
        board: [
          ['Level 1', [['2 + 2 + 2 + 2', '8'], ['10 + 10 + 10', '30'], ['5 + 5 + 5', '15']]],
          ['Level 2', [['3 + 3 + 3', '9'], ['4 + 4 + 4 + 4', '16'], ['3 + 3 + 3 + 3', '12']]],
          ['Level 3', [['7 + 7 + 7', '21'], ['6 + 6 + 6 + 6', '24'], ['9 + 9 + 9', '27']]]
        ],
        mixed: [
          { id: 'counting-in-steps', name: 'Counting', qs: [['5 + 5 + 5', '15'], ['4 + 4 + 4', '12']] },
          { id: 'place-value', name: 'Place value', qs: [['Value of the 4 in 47', '40'], ['Value of the 3 in 356', '300']] },
          { id: 'more-or-less', name: 'More or less', qs: [['10 more than 356', '366'], ['100 less than 725', '625']] }
        ],
        levelNames: ['Up in 2s, 5s and 10s', 'Up in 3s and 4s', 'Up in 6s, 7s, 8s and 9s', 'Down in 2s, 5s and 10s', 'Missing starting number']
      },
      neg: {
        teach: { expr: '1 ' + WL_M + ' 6', ans: WL_M + '5', lo: -7, hi: 3, every: 1, line: 'Start at 1, then subtract 6', hopLabel: '', steps: [
          { cap: 'Subtract, so move left', btn: 'Start at 1', pill: '1', at: 1, hops: [], arrow: true },
          { cap: '6 jumps left lands on ' + WL_M + '5', btn: 'Jump 6', pill: WL_M + '5', at: -5, hops: [[1, 0], [0, -1], [-1, -2], [-2, -3], [-3, -4], [-4, -5]], done: true, stagger: true }
        ] },
        practise: [['2 ' + WL_M + ' 7', WL_M + '5'], [WL_M + '3 + 8', '5'], [WL_M + '4 ' + WL_M + ' 5', WL_M + '9']],
        speed: [
          { q: '3 ' + WL_M + ' 5', a: WL_M + '2', ch: ['2', WL_M + '2', WL_M + '8'] },
          { q: WL_M + '1 ' + WL_M + ' 4', a: WL_M + '5', ch: [WL_M + '3', WL_M + '5', '5'] },
          { q: WL_M + '6 + 2', a: WL_M + '4', ch: [WL_M + '4', WL_M + '8', '4'] },
          { q: '0 ' + WL_M + ' 7', a: WL_M + '7', ch: ['7', WL_M + '6', WL_M + '7'] }
        ],
        board: [
          ['Level 1', [['8 ' + WL_M + ' 15', WL_M + '7'], ['3 ' + WL_M + ' 9', WL_M + '6'], ['6 ' + WL_M + ' 10', WL_M + '4']]],
          ['Level 2', [[WL_M + '5 ' + WL_M + ' 9', WL_M + '14'], [WL_M + '16 + 4', WL_M + '12'], [WL_M + '3 + 11', '8']]],
          ['Level 3', [['5 + (' + WL_M + '12)', WL_M + '7'], [WL_M + '9 + (' + WL_M + '7)', WL_M + '16'], ['4 + (' + WL_M + '3)', '1']]]
        ],
        mixed: [
          { id: 'negative-numbers', name: 'Negatives', qs: [[WL_M + '4 ' + WL_M + ' 5', WL_M + '9'], ['2 ' + WL_M + ' 8', WL_M + '6']] },
          { id: 'place-value', name: 'Place value', qs: [['Value of the 3 in 3,074', '3,000'], ['Value of the 7 in 2.47', '0.07']] },
          { id: 'multiply-divide-by-10-100-1000', name: '× and ÷ by 10', qs: [['3.2 × 10', '32'], ['450 ÷ 10', '45']] }
        ],
        levelNames: ['Subtract past zero', 'Start on a negative number', 'Add a negative number', 'Subtract a negative number', 'Add and subtract, all kinds']
      }
    };
    function welWho() { return S.intro.who || 'parent'; }
    function welOpt(key, id) { return WEL_OPTS[key].filter(function (o) { return o.id === (id || S.intro[key]); })[0] || null; }
    /* the goal picks the stage (Practice, with no exam, counts as primary) */
    function welStage() { var g = welOpt('goal'); return (g && g.stage) || S.stage; }
    /* what they get dropped into at the end: the first ready skill of that
       stage in learning order, or anything ready if the stage has nothing yet */
    function welRec() {
      var list = readySkills(null, welStage());
      /* most of the library is primary number, and "both" skills sort first, so
         a GCSE answer landed on place value. Prefer a skill that is secondary
         and nothing else, and only fall back to the head of the list. */
      if (welStage() === 'secondary') {
        var only = list.filter(function (sk) { return (sk.stage || 'secondary') === 'secondary'; });
        if (only.length) list = only;
      }
      if (!list.length) list = readySkills(null, S.stage);
      if (!list.length) list = SL.skills().filter(function (sk) { return !sk.stub; });
      /* readySkills is memoised and a stub is replaced IN PLACE when its engine
         registers, so the list holds the stale object: read the skill back from
         the registry */
      return (list[0] && SL.get(list[0].id)) || null;
    }
    function welSet() { return WSETS[welStage() === 'secondary' ? 'neg' : 'count']; }
    /* the level ladder shows the recommended skill's own first five levels */
    function welLevelNames() {
      var sk = welRec();
      return (sk && sk.levels && sk.levels.length >= 5) ? sk.levels.slice(0, 5).map(function (L) { return L.name; }) : welSet().levelNames;
    }
    /* three cards: what they said they wanted first, then the rest of the set
       for whoever they said they are */
    function tourKeys() { return (TOUR_FOR[welWho()] || TOUR_FOR.parent).slice(); }
    /* the questions, the three cards (the first one names the first skill), and the waitlist last */
    function welSteps() { return 3 + tourKeys().length; }
    function welStep() { return Math.max(0, Math.min(welSteps() - 1, S.intro.step || 0)); }

    /* demo state lives for the page, not in storage: it is a toy, not progress */
    var WD = null, welPT = null, welST = null, welLT = null, welIV = null, welLast = -1, welLoading = false;
    function wdFresh() {
      return { fx: {}, tStep: 0, markAt: null, pr: [0, 0, 0], sp: 'ready', spI: 0, spT0: 0, spEnd: 0, spFinal: 0, spMiss: [false, false, false, false],
        spBest: 0, spIsBest: false, spPick: '', spOk: '', spLock: false, bdAll: false, bdOpen: [], bdLevel: 0, mx: [true, true, false], lv: 2, lvFill: false, lvTouched: false };
    }
    function wd() { if (!WD) WD = wdFresh(); return WD; }
    /* every timer the walkthrough owns, stopped whenever the screen moves on */
    function welClear() {
      clearTimeout(welPT); clearTimeout(welST); clearTimeout(welLT);
      if (welIV) { clearInterval(welIV); welIV = null; }
      if (WD) { if (WD.sp === 'run') WD.sp = 'ready'; WD.spLock = false; WD.spOk = ''; WD.spPick = ''; WD.lvFill = false; }
    }
    function wlFmt(v) { return v < 0 ? WL_M + Math.abs(v) : String(v); }
    function welClockText() {
      var d = wd(), el = d.sp === 'run' ? (d.spFinal || Date.now() - d.spT0) : d.sp === 'end' ? d.spEnd : 0;
      return (el / 1000).toFixed(1);
    }

    function welTileHTML(key, o) {
      var on = S.intro[key] === o.id;
      return '<button type="button" class="wl-tile' + (o.hue ? ' hue-' + o.hue : '') + (on ? ' is-on' : '') + '" data-welpick="' + key + ':' + o.id + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
        (o.big ? '<span class="wl-big">' + esc(o.big) + '</span>' : '<span class="wl-ico">' + o.icon + '</span>') +
        '<span class="wl-t">' + (o.name ? '<span class="wl-name">' + esc(o.name) + '</span>' : '') + (o.sub ? '<span class="wl-sub">' + esc(o.sub) + '</span>' : '') + '</span>' +
        '<span class="wl-go" aria-hidden="true"><span class="go-a">' + ICON.chevR + '</span><span class="go-t">' + ICON.tick + '</span></span></button>';
    }
    function welQuestionHTML(i) {
      var Q = WEL_Q[i], opts = WEL_OPTS[Q.key];
      if (Q.key === 'first') opts = (TOUR_FOR[welWho()] || TOUR_FOR.parent).map(function (id) { return welOpt('first', id); });
      return '<h2 class="wl-h">' + esc(Q.title) + '</h2>' +
        '<div class="wl-tiles wl-tiles--' + opts.length + '">' + opts.map(function (o) { return welTileHTML(Q.key, o); }).join('') + '</div>';
    }
    /* the first card names the skill that Start will open, above its demo */
    function welSkillHTML() {
      var sk = welRec(); if (!sk) return '';
      var col = colourOf(sk);
      return '<div class="wl-skill"><span class="wl-skill-ico" style="color:' + col.col + ';background:' + col.tint + '">' + skIcon(sk) + '</span>' +
        '<span class="wl-skill-t">Your first skill: <b>' + esc(sk.name) + '</b></span><span class="wl-skill-n">' + sk.levels.length + ' levels</span></div>';
    }
    /* Ready: the first skill is the big button; the nine features underneath are an optional look round */
    function welReadyHTML() {
      var sk = welRec(), keys = tourKeys(), col = sk ? colourOf(sk) : null;
      return '<p class="wo-kick"><span class="wo-kick-t">' + ICON.tick + '</span>You\'re all set</p>' +
        '<h2 class="wl-h">Start here</h2>' +
        (sk ? '<button type="button" class="wo-start" data-wel="done" style="--sk:' + col.col + ';--skt:' + col.tint + '">' +
          '<span class="wo-start-ico">' + skIcon(sk) + '</span>' +
          '<span class="wo-start-t"><b>' + esc(sk.name) + '</b><i>' + sk.levels.length + ' levels</i></span>' +
          '<span class="wo-start-go">Start' + ICON.chevR + '</span></button>' : '') +
        '<div class="wo-more"><p class="wo-more-h">Or look round first</p><div class="wo-feats">' +
        keys.map(function (k, i) { return '<button type="button" class="wo-feat" data-weltour="' + i + '" style="--i:' + i + '">' + wlStk(k) + '<span>' + esc(TOUR[k].short) + '</span></button>'; }).join('') +
        '</div></div>';
    }
    function welCardHTML(k) {
      var T = TOUR[k], line = k === 'teach' ? welSet().teach.line : T.line;
      return '<div class="wl-head wo-head">' + wlStk(k, 'wo-stk--lg') + '<h2 class="wl-h">' + esc(T.name) + '</h2></div>' +
        '<p class="wl-line">' + esc(line) + '</p>' +
        '<div class="wl-demo' + (k === 'levels' ? ' wl-demo--narrow' : '') + '" id="slWelDemo" data-kind="' + k + '">' + welDemoHTML(k) + '</div>';
    }
    /* NO ONE IS STUCK (2026-10-27): anyone may leave the walkthrough at any step, the two questions included */
    function welCanSkip() { return true; }
    function welSkipKey() { return welStep() >= 3 ? 'tour' : 'all'; }
    function welSkipHTML() {
      var k = welSkipKey();
      return '<button type="button" class="sl-btn sl-btn--sm ' + (k === 'tour' ? 'sl-btn--ghost' : 'wo-skipall') + '" id="slWelSkip" data-tip="' + (k === 'tour' ? 'Skip tour' : 'Skip to the Lab') + '" data-tipsub="' + (k === 'tour' ? 'Start your first skill now.' : 'Straight to every skill.') + '">' + (k === 'tour' ? 'Skip tour' : '<span class="wo-sk-l">Skip to the Lab</span><span class="wo-sk-s">Skip</span>' + ICON.chevR) + '</button>';
    }
    var welTopKey = '';

    /* ---------- the demos: each one is a few taps, and it is the explanation ---------- */
    function welDemoHTML(k) {
      var D = welSet(), d = wd();
      var again = function (cap, label) { return '<div class="wo-dbar"><span class="wo-dcap">' + cap + '</span><button type="button" class="sl-btn wl-dbtn" data-wd="replay">' + label + '</button></div>'; };
      if (k === 'hand') {
        var hl = welStage() === 'secondary' ? ['3x + 5 = 20', '3x = 15', 'x = 5'] : ['5 + 5 + 5', '= 10 + 5', '= 15'];
        var real = !!(SL.kits && SL.kits.hw && SL.kits.hw.svg);
        return '<div class="wo-hw' + (real ? ' is-real' : '') + '">' + hl.map(function (t, i) { return '<div class="wo-hw-l' + (i === hl.length - 1 ? ' is-ans' : '') + '" style="--d:' + i + '" data-hw="' + esc(t) + '"><span>' + esc(t) + '</span></div>'; }).join('') + '</div>' +
          again('Turn on Handwritten in Teach', 'Write it again');
      }
      if (k === 'wboard') {
        return '<div class="wo-wb"><div class="wo-wb-tools">' + ['Pen', 'Text', 'Shapes', 'Graph', 'Calculator'].map(function (t, i) { return '<span class="wo-tool' + (i === 0 ? ' is-on' : '') + '" style="--d:' + i + '">' + t + '</span>'; }).join('') + '</div>' +
          '<svg class="wo-wb-svg" viewBox="0 0 400 170" aria-hidden="true"><path class="wo-ax" d="M40 150H384M56 162V12"/><path class="wo-ink" pathLength="1" d="M66 142 C150 124 236 82 372 24"/><circle class="wo-ink wo-ink2" pathLength="1" cx="214" cy="88" r="17"/></svg></div>' +
          again('Press W in the lab', 'Draw again');
      }
      if (k === 'print') {
        var rows = D.board[0][1].concat(D.board[1][1]).slice(0, 6), rk = welRec();
        return '<div class="wo-pr"><div class="wo-pr-slot"></div><div class="wo-pr-sheet"><div class="wo-pr-h">' + esc(rk ? rk.name : 'Practice') + ' · Level 1</div>' +
          rows.map(function (r, i) { return '<div class="wo-pr-row" style="--d:' + i + '"><span class="wo-pr-n">' + (i + 1) + '</span><span class="sl-expr">' + esc(r[0]) + '</span><span class="wo-pr-gap"></span></div>'; }).join('') + '</div></div>' +
          again('Print it from Practise', 'Print again');
      }
      if (k === 'teach') {
        var T = D.teach, tk = Math.min(d.tStep, T.steps.length), st = tk > 0 ? T.steps[tk - 1] : null, prevN = tk > 1 ? T.steps[tk - 2].hops.length : 0;
        var X = function (v) { return 4 + ((v - T.lo) / (T.hi - T.lo)) * 92; };
        var ticks = '', v;
        for (v = T.lo; v <= T.hi; v++) {
          var lab = v % T.every === 0 ? wlFmt(v) : '';
          ticks += '<div class="wl-tick' + (v === 0 ? ' is-zero' : '') + (lab ? ' is-maj' : '') + (st && st.at === v ? ' is-at' : '') + (tk === 0 && v === T.steps[0].at ? ' is-start' : '') + '" style="left:' + X(v) + '%"><span>' + lab + '</span></div>';
        }
        var hops = st ? st.hops.map(function (h, i) {
          var a = Math.min(h[0], h[1]), b = Math.max(h[0], h[1]), isNew = i >= prevN;
          return '<div class="wl-hop' + (isNew ? ' is-new' : '') + '" style="left:' + X(a) + '%;width:' + (X(b) - X(a)) + '%;animation-delay:' + (isNew && st.stagger ? (i - prevN) * 130 : 0) + 'ms"><b>' + T.hopLabel + '</b></div>';
        }).join('') : '';
        var pills = T.steps.map(function (s, i) { return '<span class="wl-pill' + ((st && st.done) || i < tk - 1 ? ' is-done' : i === tk - 1 ? ' is-now' : '') + '">' + s.pill + '</span>'; }).join('');
        var marker = '';
        if (st) {
          var to = X(st.at), from = d.markAt === null ? to : d.markAt;
          marker = '<div class="wl-marker" style="left:' + from + '%;transition-delay:' + (st.stagger ? (st.hops.length - prevN) * 130 : 0) + 'ms" data-to="' + to + '%">' +
            '<span class="wl-dot' + (d.markAt === null ? ' is-new' : '') + '"></span>' + (st.arrow ? '<span class="wl-arrow">' + WL_SVG.arrowL + '</span>' : '') + '</div>';
          d.markAt = to;
        } else d.markAt = null;
        var btn = !st ? T.steps[0].btn : st.done ? 'Start again' : T.steps[tk].btn;
        return '<div class="wl-nl-top"><div class="wl-expr">' + T.expr + (st && st.done ? '<span class="wl-ans">&nbsp;= ' + T.ans + '</span>' : '') + '</div><div class="wl-pills">' + pills + '</div></div>' +
          '<div class="wl-nl"><div class="wl-axis"></div>' + ticks + hops + marker + '</div>' +
          '<div class="wl-nl-foot"><div class="wl-cap" aria-live="polite">' + (st ? st.cap : '') + '</div>' +
          '<button type="button" class="sl-btn wl-dbtn wl-dbtn--now' + (tk === 0 ? ' is-hint' : '') + '" data-wd="step">' + btn + '</button></div>';
      }
      if (k === 'practise') {
        var rights = 7, marked = 0, openPr = d.pr.indexOf(1), nextPr = openPr >= 0 ? openPr : d.pr.indexOf(0), pips = '', j;
        d.pr.forEach(function (x) { if (x >= 2) marked++; if (x === 2) rights++; });
        var toGo = 3 - marked;
        for (j = 0; j < 10; j++) {
          var pv = j < 7 ? 2 : d.pr[j - 7];
          pips += '<i class="wl-pip' + (pv === 2 ? ' is-ok' : pv === 3 ? ' is-bad' : '') + (j >= 7 && d.fx.prPop === j - 7 ? ' is-pop' : '') + '"></i>';
        }
        var cards = D.practise.map(function (q, i) {
          var s = d.pr[i], body;
          if (s === 0) body = '<button type="button" class="wl-check" data-wd="pr-open" data-i="' + i + '">Show answer</button>';
          else if (s === 1) body = '<div class="wl-a' + (d.fx.open === i ? ' is-new' : '') + '">' + q[1] + '</div><div class="wl-marks' + (d.fx.open === i ? ' is-new' : '') + '">' +
            '<button type="button" class="wl-mark wl-mark--ok" data-wd="pr-ok" data-i="' + i + '" aria-label="I got it right">' + ICON.tick + '</button>' +
            '<button type="button" class="wl-mark wl-mark--bad" data-wd="pr-bad" data-i="' + i + '" aria-label="I got it wrong">' + ICON.cross + '</button></div>';
          else body = '<div class="wl-a">' + q[1] + '</div><button type="button" class="wl-res ' + (s === 2 ? 'wl-res--ok' : 'wl-res--bad') + (d.fx.prPop === i ? ' is-new' : '') + '" data-wd="pr-open" data-i="' + i + '" aria-label="Change mark">' + (s === 2 ? ICON.tick : ICON.cross) + '</button>';
          return '<div class="wl-card' + ['', '', ' is-right', ' is-wrong'][s] + (i === nextPr ? ' is-next' : '') + '"><div class="wl-q">' + q[0] + '</div>' + body + '</div>';
        }).join('');
        return '<div class="wl-cards">' + cards + '</div>' +
          '<div class="wl-pr-foot"><div class="wl-pips">' + pips + '</div><div class="wl-score">' + (toGo > 0 ? rights + ' right, ' + toGo + ' to mark' : rights + ' of 10 right') + '</div>' +
          (rights >= 8 ? '<span class="wl-gold' + (d.fx.prPop !== undefined ? ' is-new' : '') + '">' + ICON.trophy + 'Secure</span>' : '') +
          (toGo === 0 ? '<button type="button" class="sl-btn sl-btn--ghost wl-dbtn" data-wd="pr-reset">Try again</button>' : '') + '</div>';
      }
      if (k === 'speed') {
        var SQ = D.speed, sq = SQ[Math.min(d.spI, SQ.length - 1)];
        var spp = SQ.map(function (q, i) {
          return '<i class="wl-sppip' + (d.sp === 'ready' ? '' : (d.sp === 'end' || i < d.spI) ? (d.spMiss[i] ? ' is-bad' : ' is-ok') : i === d.spI ? (d.spOk ? (d.spMiss[i] ? ' is-bad' : ' is-ok') : (d.spMiss[i] ? ' is-bad' : ' is-now')) : '') + '"></i>';
        }).join('');
        var mid;
        if (d.sp === 'ready') mid = '<button type="button" class="sl-btn wl-dbtn wl-dbtn--now wl-gobtn" data-wd="sp-go">Go</button>' + (d.spBest ? '<span class="wl-chip">Best ' + (d.spBest / 1000).toFixed(1) + ' s</span>' : '');
        else if (d.sp === 'run') mid = '<div class="wl-spq' + (d.fx.shake ? ' wl-shake' : '') + '">' + sq.q + '</div><div class="wl-choices">' +
          sq.ch.map(function (v, i) { return '<button type="button" class="wl-choice' + (d.spOk === v ? ' is-ok' : d.spPick === v ? ' is-miss' : '') + '" data-wd="sp-pick" data-i="' + i + '">' + v + '</button>'; }).join('') + '</div>';
        else mid = '<div class="wl-bigtime">' + (d.spEnd / 1000).toFixed(1) + ' s</div>' +
          (d.spIsBest ? '<span class="wl-gold is-new">' + ICON.star + 'New best</span>'
            : d.spMiss.indexOf(true) >= 0 ? '<span class="wl-chip">' + d.spMiss.filter(function (x) { return !x; }).length + ' of ' + SQ.length + ' right first time</span>'
            : '<span class="wl-chip">Best ' + (d.spBest / 1000).toFixed(1) + ' s</span>') +
          '<button type="button" class="sl-btn wl-dbtn wl-dbtn--now" data-wd="sp-go">Try again</button>';
        return '<div class="wl-sp-top"><div class="wl-clock">' + ICON.clock + '<b><span id="slWelClock">' + welClockText() + '</span><span class="wl-unit"> s</span></b></div>' +
          '<div class="wl-sppips' + (d.sp === 'ready' ? ' is-ready' : '') + '">' + spp + '</div></div><div class="wl-sp-mid">' + mid + '</div>';
      }
      if (k === 'board') {
        var any = d.bdAll || d.bdOpen.length > 0;
        var tabs = '<div class="wl-bd-tabs">' + D.board.map(function (col, ci) {
          return '<button type="button" class="wl-bd-tab' + (ci === d.bdLevel ? ' is-on' : '') + '" data-wd="bd-tab" data-i="' + ci + '">' + col[0] + '</button>';
        }).join('') + '</div>';
        var cols = D.board.map(function (col, ci) {
          return '<div class="wl-bd-col' + (ci === d.bdLevel ? ' is-sel' : '') + '"><div class="wl-bd-h">' + col[0] + '</div>' + col[1].map(function (it, ii) {
            var idx = ci * 3 + ii, open = d.bdAll || d.bdOpen.indexOf(idx) >= 0;
            return '<button type="button" class="wl-bd-q' + (open ? ' is-open' : '') + (!any && ii === 0 && ci === d.bdLevel ? ' is-hint' : '') + ((d.fx.bd === idx || (d.fx.bdAll && open)) ? ' is-new' : '') + '" data-wd="bd-q" data-i="' + idx + '" aria-expanded="' + (open ? 'true' : 'false') + '">' +
              '<span>' + it[0] + '</span><span class="wl-bd-r"><span class="wl-eye">' + ICON.eye + '</span><span class="wl-bd-a">' + it[1] + '</span></span></button>';
          }).join('') + '</div>';
        }).join('');
        return tabs + '<div class="wl-bd-cols">' + cols + '</div><div class="wl-bd-foot"><button type="button" class="sl-btn wl-dbtn' + (d.bdAll ? ' sl-btn--ghost' : ' sl-btn--on') + '" data-wd="bd-all">' + ICON.eye + (d.bdAll ? 'Hide all answers' : 'Show all answers') + '</button></div>';
      }
      if (k === 'mixed') {
        var M = D.mixed, sel = M.filter(function (m, i) { return d.mx[i]; }), rows = '', r;
        var colOf = function (m) { return colourOf(SL.get(m.id) || { colour: 'blue' }); };
        for (r = 0; r < 4; r++) {
          var mm = sel[r % sel.length], mq = mm.qs[Math.floor(r / sel.length) % mm.qs.length], mc = colOf(mm);
          rows += '<div class="wl-mx-row' + (d.fx.mx ? ' is-new' : '') + '" style="border-left-color:' + mc.col + '"><span class="wl-mx-q">' + mq[0] + '</span><span class="wl-mx-tag" style="color:' + mc.col + ';background:' + mc.tint + '">' + esc(mm.name) + '</span></div>';
        }
        return '<div class="wl-mx-chips">' + M.map(function (m, i) {
          return '<button type="button" class="wl-mx-chip' + (d.mx[i] ? ' is-on' : '') + (d.fx.mxBlock === i ? ' wl-shake' : '') + '" style="color:' + colOf(m).col + '" aria-pressed="' + (d.mx[i] ? 'true' : 'false') + '" data-wd="mx" data-i="' + i + '">' +
            '<span class="wl-mx-box">' + ICON.tick + '</span><span class="wl-mx-name">' + esc(m.name) + '</span></button>';
        }).join('') + '</div><div class="wl-mx-flow" aria-hidden="true">' + WL_SVG.arrowD + '</div><div class="wl-mx-rows">' + rows + '</div>';
      }
      if (k === 'levels') {
        var LN = welLevelNames(), lp = '', q2;
        for (q2 = 0; q2 < 8; q2++) lp += '<i class="wl-lvpip' + (q2 < 7 ? ' is-ok' : q2 === 7 ? (d.lvFill ? ' is-ok is-pop' : ' is-next') : '') + '"></i>';
        return '<div class="wl-lv-list">' + LN.map(function (name, i) {
          return '<div class="wl-lv-row' + (i < d.lv ? ' is-done' : i === d.lv ? ' is-now' : ' is-later') + (i === d.fx.lvPop ? ' is-pop' : '') + '"><span class="wl-lv-n">' + (i + 1) + '</span><span class="wl-lv-name">' + esc(name) + '</span>' +
            (i === d.lv ? '<span class="wl-lv-next">Up next</span>' : '') + (i < d.lv ? '<span class="wl-lv-ok">' + ICON.tick + '</span>' : '') + '</div>';
        }).join('') + '</div>' +
          '<div class="wl-lv-foot"><div class="wl-lv-status"><div class="wl-lv-count">' + d.lv + ' of ' + LN.length + ' secure</div>' + (d.lv < LN.length ? '<div class="wl-lvpips">' + lp + '</div>' : '') + '</div>' +
          '<button type="button" class="sl-btn wl-dbtn wl-dbtn--now' + (d.lv === 2 && !d.lvTouched ? ' is-hint' : '') + '" data-wd="lv"' + (d.lvFill ? ' disabled aria-busy="true"' : '') + '>' + (d.lv >= LN.length ? 'Start again' : 'Get the 8th right') + '</button></div>';
      }
      return '';
    }
    /* the marker is drawn where it was and then sent to where it goes, so a
       rebuilt line still shows the jump */
    /* REAL PEN: the Handwritten card writes its lines the way Teach does: the kit's stroke font, stroke by stroke,
       with the kit's pen riding the tip at the kit's speed. No kit yet: the plain wipe shows, the kit is fetched,
       and the card repaints with the pen once it lands. */
    var welHwRaf = 0, welHwAsk = false;
    function welHwRun(host) {
      cancelAnimationFrame(welHwRaf); welHwRaf = 0;
      var box = host && host.querySelector('.wo-hw'); if (!box) return;
      var HW = SL.kits && SL.kits.hw;
      if (!HW || !HW.svg) {
        if (!welHwAsk) { welHwAsk = true; SL.ensure(['solving-equations']).then(function () { var h = $('slWelDemo'); if (h && h.getAttribute('data-kind') === 'hand') welPaintDemo(); }, function () {}); }
        return;
      }
      var steps = [], t = 250;
      Array.prototype.forEach.call(box.querySelectorAll('.wo-hw-l'), function (ln, i) {
        var svg = HW.svg(ln.getAttribute('data-hw'), 'wel' + i); if (!svg) return;
        ln.firstChild.innerHTML = svg;
        if (i) t += 260;
        Array.prototype.forEach.call(ln.querySelectorAll('svg.hw-s > g > g'), function (gl, k) {
          if (k) t += 70;
          Array.prototype.forEach.call(gl.querySelectorAll('path'), function (pa, j) {
            if (j) t += 45;
            var L = pa.getTotalLength(), d = Math.max(50, L / HW.SPEED);
            pa.style.strokeDasharray = L + ' ' + (L + 400); pa.style.strokeDashoffset = String(L + 1);
            steps.push({ p: pa, L: L, t0: t, d: d }); t += d;
          });
        });
      });
      if (!steps.length) return;
      if (reduceMotion) { steps.forEach(function (st) { st.p.style.strokeDashoffset = '0'; }); return; }
      var pen = document.createElement('span'); pen.className = 'hw-pen'; pen.setAttribute('aria-hidden', 'true');
      pen.style.backgroundImage = 'url(' + HW.PEN + ')';
      pen.style.setProperty('--pw', Math.round(Math.max(48, Math.min(120, parseFloat(getComputedStyle(box.querySelector('.wo-hw-l')).fontSize) * 2.1))) + 'px');
      box.appendChild(pen);
      var ease = function (f) { return f < 0.5 ? 2 * f * f : 1 - Math.pow(-2 * f + 2, 2) / 2; }, start = performance.now(), total = t + 300;
      function frame(now) {
        if (!box.isConnected) return;
        var el = now - start, cur = -1, i, st, f;
        for (i = 0; i < steps.length; i++) {
          st = steps[i]; f = Math.max(0, Math.min(1, (el - st.t0) / st.d));
          if (el >= st.t0) cur = i;
          if (st.f === f) continue; st.f = f;
          st.p.style.strokeDashoffset = f >= 1 ? '0' : String(st.L * (1 - ease(f)) + (f <= 0 ? 1 : 0));
        }
        if (cur >= 0 && el < total) {
          st = steps[cur]; f = Math.min(1, (el - st.t0) / st.d);
          var m = st.p.getScreenCTM(), b = box.getBoundingClientRect(), q = st.p.getPointAtLength(st.L * ease(f));
          if (m) pen.style.transform = 'translate(' + (m.a * q.x + m.c * q.y + m.e - b.left) + 'px,' + (m.b * q.x + m.d * q.y + m.f - b.top) + 'px)';
          pen.style.opacity = '1';
        }
        if (el >= total) { pen.style.transition = 'opacity .3s ease'; pen.style.opacity = '0'; return; }
        welHwRaf = requestAnimationFrame(frame);
      }
      welHwRaf = requestAnimationFrame(frame);
    }
    function welAfterDemo(host) {
      if (host && host.getAttribute('data-kind') === 'hand') welHwRun(host);
      var mk = host && host.querySelector('.wl-marker[data-to]');
      if (mk) { void mk.offsetWidth; mk.style.left = mk.getAttribute('data-to'); }
      if (WD) WD.fx = {};
    }
    function welPaintDemo() {
      var host = $('slWelDemo'); if (!host || !WD) return;
      var ae = document.activeElement, fa = (ae && host.contains(ae)) ? ae.getAttribute('data-wd') : null, fi = fa ? ae.getAttribute('data-i') : null;
      host.innerHTML = welDemoHTML(host.getAttribute('data-kind'));
      welAfterDemo(host);
      if (fa) {
        var hit = host.querySelector('[data-wd="' + fa + '"]' + (fi !== null ? '[data-i="' + fi + '"]' : '')) || (fi !== null ? host.querySelector('[data-i="' + fi + '"]') : null) || host.querySelector('[data-wd]');
        if (hit) { try { hit.focus({ preventScroll: true }); } catch (e) {} }
      }
    }
    function welDemo(t) {
      var act = t.getAttribute('data-wd'), i = +t.getAttribute('data-i'), d = wd(), D = welSet();
      if (act === 'replay') { welPaintDemo(); return; }
      if (act === 'step') { d.tStep = d.tStep >= D.teach.steps.length ? 0 : d.tStep + 1; }
      else if (act === 'pr-open') { d.pr[i] = 1; d.fx.open = i; }
      else if (act === 'pr-ok' || act === 'pr-bad') { d.pr[i] = act === 'pr-ok' ? 2 : 3; d.fx.prPop = i; }
      else if (act === 'pr-reset') { d.pr = [0, 0, 0]; }
      else if (act === 'sp-go') {
        welClear();
        d.sp = 'run'; d.spI = 0; d.spT0 = Date.now(); d.spFinal = 0; d.spMiss = [false, false, false, false]; d.spIsBest = false; d.spPick = ''; d.spOk = ''; d.spLock = false;
        welIV = setInterval(function () { var el = $('slWelClock'); if (el && WD && WD.sp === 'run') el.textContent = welClockText(); else { clearInterval(welIV); welIV = null; } }, 100);
      }
      else if (act === 'sp-pick') {
        if (d.sp !== 'run' || d.spLock) return;
        var SQ = D.speed, q = SQ[d.spI], v = q.ch[i];
        if (v !== q.a) { d.spMiss[d.spI] = true; d.spPick = v; d.fx.shake = true; }
        else {
          var last = d.spI >= SQ.length - 1, el = Date.now() - d.spT0;
          if (last && welIV) { clearInterval(welIV); welIV = null; }
          d.spOk = v; d.spPick = ''; d.spLock = true; d.spFinal = last ? el : 0;
          clearTimeout(welST);
          welST = setTimeout(function () {
            d.spOk = ''; d.spLock = false;
            /* only a round with no misses can set a best time */
            if (last) { var clean = d.spMiss.indexOf(true) < 0; d.spIsBest = clean && (!d.spBest || el < d.spBest); if (d.spIsBest) d.spBest = el; d.spEnd = el; d.sp = 'end'; d.spFinal = 0; }
            else d.spI++;
            welPaintDemo();
          }, 240);
        }
      }
      else if (act === 'bd-q') {
        if (d.bdAll) { d.bdAll = false; d.bdOpen = [0, 1, 2, 3, 4, 5, 6, 7, 8].filter(function (x) { return x !== i; }); }
        else { var at = d.bdOpen.indexOf(i); if (at >= 0) d.bdOpen.splice(at, 1); else { d.bdOpen.push(i); d.fx.bd = i; } }
      }
      else if (act === 'bd-all') { d.bdAll = !d.bdAll; d.bdOpen = []; d.fx.bdAll = d.bdAll; }
      else if (act === 'bd-tab') { d.bdLevel = i; }
      else if (act === 'mx') {
        if (d.mx[i] && d.mx.filter(Boolean).length <= 2) d.fx.mxBlock = i;
        else { d.mx[i] = !d.mx[i]; d.fx.mx = true; }
      }
      else if (act === 'lv') {
        if (d.lvFill) return;
        d.lvTouched = true;
        if (d.lv >= welLevelNames().length) d.lv = 0;
        else {
          d.lvFill = true;
          clearTimeout(welLT);
          welLT = setTimeout(function () { d.fx.lvPop = d.lv; d.lv++; d.lvFill = false; welPaintDemo(); }, 550);
        }
      }
      welPaintDemo();
    }

    /* The waitlist form is the REAL Shopify customer form from the page, moved
       into the card and moved back afterwards. A clone would lose the listener
       the storefront captcha script attached to it, and the post would die on a
       missing token (see the contact-form note in memory). */
    var ntForm = null, ntHome = null;
    function welFormMount() {
      var host = $('slWelForm'); if (!host) return;
      if (!ntForm) {
        ntForm = root.querySelector('.nt-form');
        if (!ntForm) { host.innerHTML = '<p class="wl-note">The sign-up is on the page behind this.</p>'; return; }
        ntHome = ntForm.parentNode;
      }
      if (ntForm.parentNode !== host) host.appendChild(ntForm);
      /* the submit reloads the page, so the event has to go on the way out */
      if (!ntForm.__slTracked) {
        ntForm.__slTracked = 1;
        ntForm.addEventListener('submit', function () { S.intro.done = true; S.intro.step = 0; save(); try { sessionStorage.setItem('sl_wel_posted', '1'); } catch (e) {} track('tour_waitlist_submit', { who: S.intro.who, goal: S.intro.goal }); });
      }
    }
    function welFormHome() { if (ntForm && ntHome && ntForm.parentNode !== ntHome) ntHome.appendChild(ntForm); }
    /* called whenever the walkthrough is left or the shell closes */
    function welFormRestore() { welFormHome(); welClear(); clearTimeout(welIdleT); elTop.classList.remove('is-wel'); }
    /* Next asks for attention when nobody moves on: a few quiet seconds and it
       bounces (on a question, the tiles do). Any tap or key starts the wait again,
       and a speed run in progress is never interrupted. */
    var welIdleT = null;
    function welIdleArm() {
      clearTimeout(welIdleT);
      var m = elWel.querySelector('.wl-main');
      if (m) m.classList.remove('is-nudge');
      if (S.screen !== 'welcome') return;
      welIdleT = setTimeout(function nudge() {
        if (S.screen !== 'welcome') return;
        if (WD && WD.sp === 'run') { welIdleT = setTimeout(nudge, 2000); return; }
        var mm = elWel.querySelector('.wl-main');
        if (mm) mm.classList.add('is-nudge');
      }, welStep() < 2 ? 6000 : 5000);
    }
    function welNotifyHTML() {
      if (welPosted) return '<span class="wl-mailico is-done">' + ICON.tick + '</span><h2 class="wl-h">You\'re on the list</h2>' +
        '<p class="wl-line">' + (S.intro.who === 'pupil' ? 'We\'ll tell them when it\'s ready' : 'We\'ll tell you when the full lab is ready') + '</p>';
      return '<span class="wl-mailico">' + WL_SVG.mail + '</span><h2 class="wl-h">Want more skills?</h2>' +
        '<p class="wl-line">' + (S.intro.who === 'pupil' ? 'Ask an adult to add their email, and we\'ll tell them when it\'s ready' : 'Add your email and we\'ll tell you when the full lab is ready') + '</p>' +
        '<div class="wl-form" id="slWelForm"></div>';
    }
    function renderWelcome() {
      var step = welStep(), keys = tourKeys(), n = welSteps(), sk = welRec();
      var body, last = step === n - 1, i;
      /* the form is inside the card, so a repaint would tear the real node out
         of the page: it goes home before every paint and comes back after */
      welFormHome();
      wd();
      if (step < 2) body = welQuestionHTML(step);
      else if (step === 2) body = welReadyHTML();
      else body = welCardHTML(keys[step - 3]);
      /* done is recorded by Start, Skip, Escape or the waitlist submit, never by
         merely arriving: someone who closes on the last step sees it again */
      if (!trackedTour) { trackedTour = true; track('tour_start', { returning: S.intro.who ? 'yes' : 'no' }); }
      if (step === 2 && !trackedWait) { trackedWait = true; track('tour_ready_view', { who: S.intro.who, goal: S.intro.goal }); }
      var same = step === welLast;
      var wdir = (welLast < 0 || reduceMotion || same) ? '' : (step > welLast ? ' is-fwd' : ' is-back');
      welLast = step;
      /* a new step starts at the top; paint would otherwise put the old scroll back */
      if (!same) { var sc0 = elWel.querySelector('.wl-scroll'); if (sc0) sc0.scrollTop = 0; }
      var segs = '', inTour = step >= 3, segN = inTour ? keys.length : 2, segAt = inTour ? step - 3 : step;
      for (i = 0; i < segN; i++) segs += '<i class="' + (i === segAt ? 'is-now' : (i < segAt ? 'is-done' : '')) + '"></i>';
      var barLabel = inTour ? 'Feature ' + (step - 2) + ' of ' + keys.length : step < 2 ? 'Question ' + (step + 1) + ' of 2' : 'Both questions done';
      /* a question moves on by itself, so it never shows Next */
      var showNext = step >= 2;
      var longLabel = last ? (sk ? 'Start ' + esc(sk.short || sk.name) : 'Open the skills') : (step === 2 ? 'Look round' : 'Next'), shortLabel = last ? 'Start' : (step === 2 ? 'Look round' : 'Next');
      /* the recommended skill's engine is fetched quietly while they look round,
         so Start opens it without a wait */
      if (step >= 3 && sk && !SL.ready(sk.id) && !welLoading) {
        welLoading = true;
        SL.ensure([sk.id]).then(function () { welLoading = false; }, function () { welLoading = false; });
      }
      return paint(elWel, '<div class="sl-main wl-main' + (step === 2 ? ' is-ready' : inTour ? ' is-tour' : ' is-q') + '"><div class="sl-scroll wl-scroll"><div class="wl-stage' + (entering ? ' is-enter' : '') + '">' +
        '<section class="wl-screen' + wdir + (same ? ' is-still' : '') + '">' + body + '</section></div></div>' +
        '<div class="wl-nav">' +
          '<div class="wl-nav-l">' + (step ? '<button type="button" class="sl-btn sl-btn--ghost wl-nbtn" data-wel="back">' + ICON.chevL + 'Back</button>' : '') + '</div>' +
          '<div class="wl-bar" role="img" aria-label="' + barLabel + '">' + segs + '</div>' +
          '<div class="wl-nav-r">' + (showNext ? '<button type="button" class="sl-btn ' + (step === 2 ? 'sl-btn--ghost wl-nbtn' : 'sl-btn--cta wl-cta') + '" data-wel="' + (last ? 'done' : 'next') + '"><span class="wl-long">' + longLabel + '</span><span class="wl-short">' + shortLabel + '</span>' + ICON.chevR + '</button>' : '') + '</div>' +
        '</div></div>', function () {
          welAfterDemo($('slWelDemo')); welIdleArm(); elTop.classList.add('is-wel');
          var tk = welSkipKey(); if (tk !== welTopKey) { welTopKey = tk; renderTop(); }
        });
    }
    /* A waitlist sign-up posts the page, and Shopify reloads it with its thank-you
       line (.nt-ok) in the form. The submit left a flag in this tab: open the lab
       again on the last step and say it worked, rather than dropping them on the
       page. No flag, or no thank-you line (a failed post), and nothing happens. */
    var welPosted = false;
    /* THE EMAIL GATE (2026-10-27) is on the page: a sign-up posts it and Shopify reloads it with its
       thank-you line in the form (.sl-gate-ok). The submit left a flag in this tab, so the lab opens
       by itself instead of leaving them on the page. */
    try {
      if (sessionStorage.getItem('sl_gate_posted') && root.querySelector('.sl-gate-ok')) setTimeout(function () { openShell(); }, 0);
      sessionStorage.removeItem('sl_gate_posted');
    } catch (e) {}
    function welGo(step) { welClear(); S.intro.step = Math.max(0, Math.min(welSteps() - 1, step)); save(); renderWelcome(); }
    /* an answer shows as chosen for a moment, then moves on by itself */
    function welPick(pair) {
      var bits = String(pair).split(':'), key = bits[0], val = bits[1];
      if (!WEL_OPTS[key]) return;
      var was = S.intro[key], at = welStep();
      S.intro[key] = val;
      track('tour_answer', { question: key, answer: val });
      if (key === 'who' && was !== val) S.intro.first = null;
      if (key === 'goal') {
        var g = welOpt('goal', val);
        if (g && g.stage) { S.stage = g.stage; S.strand = ''; S.strandPicked = false; S.libMore = false; }
        if (was !== val) WD = null;
      }
      save();
      renderWelcome();
      clearTimeout(welPT);
      welPT = setTimeout(function () { if (S.screen === 'welcome' && welStep() === at) welGo(at + 1); }, 650);
    }
    /* the end of the walkthrough, and the Skip that stands in for it: the
       questions already answered are kept either way, and it never runs again */
    function welDone(start) {
      var wasStep = welStep();
      welClear();
      track('tour_finish', {
        outcome: start ? 'complete' : 'skip', step: wasStep,
        who: S.intro.who, goal: S.intro.goal, first: S.intro.first
      });
      S.intro.done = true; S.intro.step = 0; welLast = -1; WD = null;
      var sk = start ? welRec() : null;
      if (sk) {
        S.skill = sk.id; S.from = 'skills'; S.strand = strandOf(sk, S.stage); S.strandPicked = true;
        save(); show('skill'); return;
      }
      save(); show('library');
    }
    elWel.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null; if (!t) return;
      var pick = t.getAttribute('data-welpick');
      if (pick) { welPick(pick); return; }
      var tour = t.getAttribute('data-weltour');
      if (tour !== null) { welGo(3 + (+tour)); return; }
      if (t.hasAttribute('data-wd')) { welDemo(t); return; }
      var act = t.getAttribute('data-wel');
      if (act === 'back') { welGo(welStep() - 1); return; }
      if (act === 'next') { welGo(welStep() + 1); return; }
      if (act === 'done') { welDone(true); return; }
    });
    ['pointerdown', 'keydown', 'input'].forEach(function (ev) { elWel.addEventListener(ev, welIdleArm, true); });

    /* ============================================================
       LIBRARY (Skills): stage, search, strands, single-choice cards
       ============================================================ */
    var elLib = $('slLibrary');
    /* The example on a card is dealt by the skill's own generator, not a string
       written by hand that can drift from what the engine actually produces. One
       per skill and level, held for the session so it does not flicker on every
       render, with the authored eg as the fallback if a generator throws. */
    var EG = {};
    /* THE LINE ON A CARD. Not a question the engine dealt: the one line that
       says what the skill IS at a glance (Aadam 2026-09-16: "show answers or
       the main thing from the skill, something that shows exactly what the
       skill is, easily recognisable, each one different"). Mostly the ANSWER -
       the thing the skill produces - except where a bare answer says nothing:
       expanding is the bracket you are handed, and a skill whose answer is a
       plain number keeps the statement it belongs to. A skill with no line here
       falls back to a real question. Level 1 only: once a level is picked the
       card shows a specimen of THAT level. */
    function cardRad(n) { return '<span class="eb-srd"><svg class="eb-rad" viewBox="0 0 24 40" aria-hidden="true"><path d="M2 23 L7 21 L12 36 L22.4 2.4"/></svg><span>' + n + '</span></span>'; }
    function cardRt(inner) { return '<span class="cs-rt"><svg viewBox="0 0 24 40" preserveAspectRatio="none" aria-hidden="true"><path d="M2 23 L7 21 L12 37 L22.4 2"/></svg><span class="cs-rin">' + inner + '</span></span>'; }
    /* .cs-fr sets .66em for a fraction inside a line of working; on a card the
       formula IS the line, so it comes back up to nearly full size */
    function cardFr(top, bot) { return '<span class="cs-fr" style="font-size:.84em"><span>' + top + '</span><span>' + bot + '</span></span>'; }
    /* A card line that is too long for one line breaks at the = or the → that
       joins its two halves, and nowhere else: '(x + 2)(x + 5)' over
       '= x² + 7x + 10'. Inside a half the space AFTER an operator is nailed
       shut, so if a half has to wrap as well it still breaks in front of the
       operator, never behind it. */
    function nbOps(s) { return s.replace(/([+−=×<>→])\s/g, '$1 '); }
    function cardLine(s) {
      var i = s.indexOf(' = '); if (i < 0) i = s.indexOf(' → ');
      return i < 0 || s.length <= 22 ? nbOps(s) : nbOps(s.slice(0, i)) + '<br>' + nbOps(s.slice(i + 1));
    }
    var CARD_EG = {
      /* the answer */
      'factorising-quadratics': cardLine('(x + 3)(x + 4)'),
      'completing-the-square': cardLine('(x + 4)² − 13'),
      'linear-nth-term': cardLine('3n + 2'),
      'quadratic-sequences': cardLine('n² + 2n + 3'),
      /* the formula itself, as it is written */
      'quadratic-formula': nbOps('x = ') + cardFr(nbOps('−b ± ') + cardRt(nbOps('b² − 4ac')), '2a'),
      /* expanding: the bracket you are handed IS the skill */
      'expanding-single-brackets': cardLine('3(x + 4)'),
      'expanding-double-brackets': cardLine('(x + 2)(x + 5)'),
      'expanding-triple-brackets': cardLine('(x + 1)(x + 2)(x + 3)'),
      'expanding-surd-brackets': cardLine('R(R + 3)').split('R').join(cardRad(2)),
      /* a plain number on its own says nothing, so these keep the statement */
      'negative-numbers': cardLine('8 − 15 = −7'),
      'counting-in-steps': cardLine('0, 5, 10, 15, 20'),
      'place-value': cardLine('the 7 in 3,724 = 700'),
      'more-or-less': cardLine('10 more than 246 = 256'),
      'multiply-divide-by-10-100-1000': cardLine('46 × 10 = 460'),
      'reading-writing-numbers': cardLine('47 = forty-seven'),
      'comparing-ordering-numbers': cardLine('0.5 > 0.455'),
      'roman-numerals': cardLine('XIV = 14')
    };
    function egFor(sk, level) {
      if ((level || 1) === 1 && CARD_EG[sk.id]) return CARD_EG[sk.id];
      if (typeof sk.make !== 'function') return firstEg(levelEg(sk, level || 1) || sk.eg);
      var key = sk.id + '|' + (level || 1);
      if (EG[key]) return EG[key];
      var html = null;
      try { html = sk.make(level || 1, { seen: {}, shapeSeen: {}, last: null }).html; } catch (err) { html = null; }
      EG[key] = html || firstEg(sk.eg);
      return EG[key];
    }
    /* one example, not the whole list: the fallback shows a single specimen.
       Examples in an eg are separated by a comma AND spaces ('3(x + 4),  x(2x
       − 5)'); a plain comma belongs INSIDE the example - a sequence, a list of
       steps - so splitting on it cut '5, 8, 11, 14, …' down to '5' on the
       sequences cards. Only split on a separator that is not inside a tag. */
    function firstEg(html) {
      var parts = String(html || '').split(/,\s\s+/);
      if (parts.length < 2) return html;
      var head = parts[0];
      if ((head.split('<').length - 1) !== (head.split('>').length - 1)) return html;
      return head.trim();
    }
    /* The library tile: the topic colour takes the head of the card with the
       skill's own icon, and one real question sits on the panel underneath. The
       name reserves two lines whether it needs them or not, so the bands, the
       panels and the card edges line up across a row. */
    function cardHTML(sk, pick, i) {
      var on = pick && inMix(sk), c = colourOf(sk);
      var right = pick
        ? '<span class="sl-check' + (on ? ' is-on' : '') + '">' + ICON.tick + '</span>'
        : '<span class="tgo">' + ICON.chevR + '</span>';
      /* the star cannot live INSIDE the tile - a button inside a button is not
         valid and the click would have nowhere to go - so the pair sits in a
         wrapper and the star is laid over the card's corner */
      return '<div class="sl-tilewrap" style="--c:' + c.col + ';--ct:' + c.tint + ';--i:' + (i || 0) + '">' +
        '<button type="button" class="sl-tile sl-tile--card' + (on ? ' is-on' : '') + '" data-skill="' + sk.id + '"' + (pick ? ' aria-pressed="' + (on ? 'true' : 'false') + '"' : '') + '>' +
        '<div class="tband tband--title">' + skIcon(sk) + '<span class="tname">' + esc(sk.name) + '</span>' + right + '</div>' +
        '<div class="tbody"><div class="tspec"><span class="sl-expr">' + egFor(sk, 1) + '</span></div></div></button>' +
        favBtn(sk) + '</div>';
    }
    /* one control, two places: the corner of a library tile and the head of the
       skill card. It says what it does in the pill, because a star on its own
       is only obvious once you have used it. */
    function favBtn(sk, big) {
      var f = isFav(sk);
      return '<button type="button" class="sl-fav' + (big ? ' sl-fav--big' : '') + (f ? ' is-on' : '') + '" data-fav="' + sk.id +
        '" aria-pressed="' + (f ? 'true' : 'false') + '" aria-label="' + (f ? 'Remove ' + esc(sk.name) + ' from favourites' : 'Save ' + esc(sk.name) + ' to favourites') + '">' +
        (f ? ICON.starOn : ICON.star) + '</button>';
    }
    function libraryBody(pick) {
      var strands = STRANDS[S.stage], q = S.search;
      var strand = (S.strand === FAVID || S.strand === ALLID || strands.some(function (s) { return s.id === S.strand; })) ? S.strand : strands[0].id;
      if (strand !== FAVID && strand !== ALLID && !readySkills(strand, S.stage).length && !S.strandPicked) { var first = strands.filter(function (s) { return readySkills(s.id, S.stage).length; })[0]; if (first) strand = first.id; }
      S.strand = strand;
      var searching = !!q.trim();
      var favView = strand === FAVID && !searching, allView = strand === ALLID && !searching;
      var ready = (favView ? favSkills() : (searching || allView ? readySkills(null, S.stage) : readySkills(strand, S.stage))).filter(function (sk) { return matches(q, sk.name, sk.aliases); });
      var planned = favView ? [] : (searching || allView
        ? [].concat.apply([], strands.map(function (s) { return plannedFor(s.id).filter(function (n) { return matches(q, n); }); }))
        : plannedFor(strand));
      var strandName = searching ? 'Search: ' + q.trim() : favView ? 'Favourites' : allView ? 'All skills' : strands.filter(function (s) { return s.id === strand; })[0].name;
      /* the tiles deal in only when the shelf itself changes (stage, strand,
         search), never when a tile is ticked or the planned list is opened */
      var sig = S.stage + '|' + strand + '|' + (pick ? 1 : 0), enter = entering || (!searching && libSig[pick ? 1 : 0] !== sig);
      libSig[pick ? 1 : 0] = sig;

      var stage = '<div class="sl-segwrap" role="tablist" aria-label="Stage" data-mo-group="stage"><button type="button" role="tab" class="sl-seg' + (S.stage === 'primary' ? ' is-on' : '') + '" data-stage="primary">Primary</button>' +
        '<button type="button" role="tab" class="sl-seg' + (S.stage === 'secondary' ? ' is-on' : '') + '" data-stage="secondary">Secondary</button></div>';
      /* the search box lives in the top bar now (searchTopHTML) */
      var nfav = favSkills().length;
      var favRow = '<button type="button" class="sl-rrow sl-strand sl-strand--fav' + (favView ? ' is-now' : '') + (nfav ? '' : ' is-quiet') + '" data-strand="' + FAVID + '">' +
        (nfav ? ICON.starOn : ICON.star) + '<span class="rq">Favourites</span><span class="rside">' + (nfav ? nfav + ' saved' : 'none yet') + '</span>' + (favView ? '' : ICON.chevR) + '</button>';
      var nAll = readySkills(null, S.stage).length;
      var allRow = '<button type="button" class="sl-rrow sl-strand sl-strand--all' + (allView ? ' is-now' : '') + '" data-strand="' + ALLID + '">' +
        '<span class="rq">All skills</span><span class="rcount">' + nAll + '</span>' + (allView ? '' : ICON.chevR) + '</button>';
      var rail = '<div class="sl-rail-top">' + stage + favRow + papersRow() + '</div><div class="sl-rail-title">Strands</div><div class="sl-strands">' + allRow + strands.map(function (s) {
        var r = readySkills(s.id, S.stage).length, p = plannedFor(s.id).length;
        var now = s.id === strand && !searching;
        return '<button type="button" class="sl-rrow sl-strand' + (now ? ' is-now' : '') + (r ? '' : ' is-quiet') + '" data-strand="' + s.id + '">' +
          '<span class="rq">' + esc(s.name) + '</span>' +
          (r ? '<span class="rcount">' + r + '</span>' : '<span class="rside">soon</span>') +
          (now || !r ? '' : ICON.chevR) + '</button>';
      }).join('') + '</div>' + railFootHTML();

      var cont = '';
      /* a big shelf is paged: two dozen tiles, then one chip for the rest, so a
         fifty-skill strand never mounts or animates fifty cards at once */
      var PAGE = 24, shown = S.libMore || allView ? ready : ready.slice(0, PAGE);
      var grid = allView ? allShelfHTML(strands, pick) : shown.map(function (sk, i) { return cardHTML(sk, pick, i); }).join('');
      if (ready.length > shown.length) grid += '<button type="button" class="sl-chip sl-chip--more" id="slLibMore" style="grid-column:1/-1;justify-self:center">' + ICON.chevD + 'Show the other ' + (ready.length - shown.length) + '</button>';
      if (!grid) {
        var where = strands.filter(function (s) { return readySkills(s.id, S.stage).length; }).map(function (s) { return s.name + ' (' + readySkills(s.id, S.stage).length + ')'; }).join(', ');
        grid = '<div class="sl-empty" style="grid-column:1/-1">' + (favView ? 'Nothing saved yet. Tap the star in the corner of any skill and it lands here.' : (searching ? 'No ready skill matches.' : 'Nothing in ' + esc(strandName) + ' yet.') + (where ? ' Ready now: ' + esc(where) + '.' : '')) + '</div>';
      }
      var plannedLine = planned.length
        ? '<div class="sl-planned"><button type="button" class="sl-chip" id="slTogglePlanned" aria-expanded="' + (S.showPlanned ? 'true' : 'false') + '">' + ICON.clock + (S.showPlanned || searching ? (searching ? planned.length + ' planned match' + (planned.length === 1 ? '' : 'es') : 'Hide the ' + planned.length + ' planned') : planned.length + ' more planned') + '</button>' +
          (S.showPlanned || searching ? '<div class="sl-planned-list">' + planned.map(function (n) { return '<span class="sl-chip" style="cursor:default">' + esc(n) + '</span>'; }).join('') + '</div>' : '') + '</div>'
        : '';
      var sub = favView ? 'The skills you have saved. Tap a star to take one out.'
        : allView && !pick ? 'Every skill that is ready, strand by strand, in the order they are learnt.'
        : pick ? 'Choose 2 to 6 skills. Ten questions, taken from each in turn at the levels you pick.'
        : 'Pick a skill, choose its level, then teach it, practise it or put it on the board.';
      return '<div class="sl-rail">' + rail + '</div><div class="sl-main"><div class="sl-scroll"><div class="sl-lib-main">' + cont +
        '<div class="sl-lib-head"><div><h2>' + esc(strandName) + '</h2><div class="sub">' + sub + '</div></div></div>' +
        '<div class="sl-grid' + (enter ? ' is-enter' : '') + '" style="--lz:' + LIB_ZOOMS[libZoomAt()] + '">' + grid + '</div>' + plannedLine + '</div></div>' + (pick ? mixedTray() : '') + '</div>';
    }
    /* the foot of the rail. The column is taller than five strands on any
       laptop, and an empty third of it says nothing; this says what is in the
       Lab today and that it is still growing. */
    function railFootHTML() {
      var here = readySkills(null, S.stage), n = here.length;
      var other = readySkills(null, S.stage === 'primary' ? 'secondary' : 'primary').filter(function (sk) { return here.indexOf(sk) < 0; }).length;
      return '<div class="sl-rail-foot">' +
        '<b>' + n + ' skill' + (n === 1 ? '' : 's') + ' ready</b>' +
        '<span>' + (other ? other + ' more in ' + (S.stage === 'primary' ? 'Secondary' : 'Primary') + '. ' : '') + 'New ones land every week.</span>' +
        '<button type="button" class="sl-linkbtn" data-welopen="1">Show me around</button></div>';
    }
    var libSig = {}, FAVID = '_fav', ALLID = '_all';
    /* ALL SKILLS (2026-09-25): every strand's ready skills under its own heading, in learning order. The
       headings sit in the same grid (full width), so the tile zoom and the deal-in stagger carry on across
       them. A big lab caps each strand at 8 with a chip into the strand itself. */
    function allShelfHTML(strands, pick) {
      var total = readySkills(null, S.stage).length, cap = total > 48 ? 8 : 0, k = 0;
      return strands.map(function (s) {
        var list = readySkills(s.id, S.stage); if (!list.length) return '';
        var show = cap ? list.slice(0, cap) : list;
        var cards = show.map(function (sk) { return cardHTML(sk, pick, k++); }).join('');
        if (list.length > show.length) cards += '<button type="button" class="sl-chip sl-chip--more" data-strand="' + s.id + '" style="grid-column:1/-1;justify-self:center">' + ICON.chevR + 'All ' + list.length + ' in ' + esc(s.name) + '</button>';
        return '<h3 class="sl-libsec"><button type="button" class="sl-libsec-go" data-strand="' + s.id + '">' + esc(s.name) + ICON.chevR + '</button><span class="rcount">' + list.length + '</span></h3>' + cards;
      }).join('');
    }
    /* Zoom for the skill tiles: a step scales the whole tile (type, icon, example) and so how many fit in a
       row. 1 is the size the shelf was designed at; smaller fits more in a row, bigger fewer. */
    var LIB_ZOOMS = [0.7, 0.8, 0.9, 1, 1.15, 1.3, 1.5];
    function libZoomAt() { var z = Math.round(S.libZoom); return z >= 0 && z < LIB_ZOOMS.length ? z : 3; }
    function searchTopHTML() {
      var q = S.search || '', live = !!q.trim();
      return '<label class="sl-input sl-search sl-topsearch' + (live ? ' is-live' : '') + '">' + ICON.search +
        '<input type="search" id="slSearch" placeholder="Search skills" value="' + esc(q) + '" aria-label="Search skills">' +
        '<button type="button" class="sl-searchx" data-clearsearch="1" aria-label="Clear the search" data-tip="Clear search">' + ICON.cross + '</button></label>';
    }
    function zoomHTML() {
      var z = libZoomAt(), n = LIB_ZOOMS.length - 1;
      return '<div class="sl-zoom hide-sm" style="--p:' + (z / n) + '">' +
        '<button type="button" class="sl-iconbtn sl-zoombtn" data-libzoom="-1" aria-label="Smaller tiles, more in a row" data-tip="Smaller tiles"' + (z === 0 ? ' disabled' : '') + '>' + ICON.minus + '</button>' +
        '<input type="range" class="sl-range" min="0" max="' + n + '" step="1" value="' + z + '" data-slider="libzoom" aria-label="Tile size">' +
        '<button type="button" class="sl-iconbtn sl-zoombtn" data-libzoom="1" aria-label="Bigger tiles, fewer in a row" data-tip="Bigger tiles"' + (z === n ? ' disabled' : '') + '>' + ICON.plus + '</button></div>';
    }
    /* the box is in the top bar, which a shelf re-render does not repaint, so it is brought in line by hand */
    function syncSearchBox() {
      var inp = $('slSearch'); if (!inp) return;
      if (inp.value !== (S.search || '')) inp.value = S.search || '';
      var lab = inp.closest('.sl-topsearch'); if (lab) lab.classList.toggle('is-live', !!(S.search || '').trim());
    }
    function rerenderLib() { if (S.screen === 'mixed') renderMixed(); else if (S.screen === 'library') renderLibrary(); }
    function setLibZoom(z, repaintTop) {
      S.libZoom = Math.max(0, Math.min(LIB_ZOOMS.length - 1, z));
      Array.prototype.forEach.call(document.querySelectorAll('#slShell .sl-grid'), function (g) { g.style.setProperty('--lz', LIB_ZOOMS[S.libZoom]); });
      var w = document.querySelector('#slShell .sl-zoom');
      if (w) {
        w.style.setProperty('--p', S.libZoom / (LIB_ZOOMS.length - 1));
        var r = w.querySelector('input'); if (r && Number(r.value) !== S.libZoom) r.value = S.libZoom;
        var b = w.querySelectorAll('.sl-zoombtn'); if (b.length === 2) { b[0].disabled = S.libZoom === 0; b[1].disabled = S.libZoom === LIB_ZOOMS.length - 1; }
      }
      if (repaintTop) save();
    }
    /* PHONE (2026-09-25): under 861px the rail is one sideways row, and the strand on show could sit off
       its right edge with nothing to say it was there: bring it into view whenever the shelf changes */
    function railToNow(host) {
      if (window.innerWidth > 860) return;
      var r = host.querySelector('.sl-rail'), n = r && r.querySelector('.sl-strand.is-now');
      if (!r || !n) return;
      var rb = r.getBoundingClientRect(), nb = n.getBoundingClientRect();
      if (nb.left >= rb.left && nb.right <= rb.right - 40) return;
      var sb = r.style.scrollBehavior; r.style.scrollBehavior = 'auto';
      r.scrollLeft += nb.left - rb.left - Math.max(12, (rb.width - nb.width) / 2);
      r.style.scrollBehavior = sb;
    }
    function renderLibrary() { var was = libSig[0]; paint(elLib, libraryBody(false)); if (was !== libSig[0]) { shelfTop(elLib); railToNow(elLib); } pwPrefetch(); }
    /* PHONE LIBRARY + MIXED TRAY + LEVEL TICK SCROLL (2026-09-21): a different shelf starts at its top */
    function shelfTop(host) { var sc = host.querySelector('.sl-main > .sl-scroll'); if (!sc || !sc.scrollTop) return; var sb = sc.style.scrollBehavior; sc.style.scrollBehavior = 'auto'; sc.scrollTop = 0; sc.style.scrollBehavior = sb; }
    function libClick(e, pick) {
      var t = e.target.closest ? e.target.closest('button') : null;
      if (!t) return false;
      if (t.getAttribute('data-stage')) { S.stage = t.getAttribute('data-stage'); S.strandPicked = false; S.strand = ''; S.libMore = false; save(); return true; }
      if (t.getAttribute('data-papers')) { S.papersQ = ''; save(); show('papers'); return false; }
      if (t.getAttribute('data-strand')) { S.strand = t.getAttribute('data-strand'); S.strandPicked = true; S.search = ''; S.libMore = false; save(); return true; }
      if (t.getAttribute('data-fav')) { toggleFav(SL.get(t.getAttribute('data-fav'))); return true; }
      if (t.getAttribute('data-clearsearch')) { S.search = ''; S.libMore = false; return true; }
      if (t.id === 'slLibMore') { S.libMore = true; return true; }
      if (t.id === 'slTogglePlanned') { S.showPlanned = !S.showPlanned; return true; }
      if (t.getAttribute('data-skill')) {
        var sk = SL.get(t.getAttribute('data-skill'));
        if (pick) { toggleMix(sk); return true; }
        S.skill = sk.id; S.from = 'skills'; save(); show('skill'); return false;
      }
      return false;
    }
    elLib.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button') : null;
      if (b && b.getAttribute('data-welopen')) { S.intro.step = 0; show('welcome'); return; }
      if (libClick(e, false)) { renderLibrary(); syncSearchBox(); }
    });
    var searchTimer = null;
    function onSearch(e, rerender) {
      if (!e.target || e.target.id !== 'slSearch' || e.isComposing) return;
      S.search = e.target.value; S.libMore = false;
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        var pos = e.target.selectionStart;
        rerender(); syncSearchBox();
        var inp = $('slSearch'); if (inp) { inp.focus(); try { inp.setSelectionRange(pos, pos); } catch (err) {} }
      }, 120);
    }
    elLib.addEventListener('input', function (e) { onSearch(e, renderLibrary); });

    /* ============================================================
       MIXED PRACTICE: the basket
       ============================================================ */
/* SLPW: GCSE past papers */
    /* ============================================================
       GCSE PAST PAPERS: the hardest questions
       A real paper's last questions, taught the way a skill is taught: one
       press is one idea, the inputs light before the result, and the question
       itself lights up so a pupil sees where every number came from. The
       walkthroughs live in the papers kit, which is fetched the first time
       this screen is opened; the engine owns its own stage inside the screen.
       ============================================================ */
    var elPapers = $('slPapers'), pwApi = null;
    function destroyPapers() { if (pwApi) { try { pwApi.destroy(); } catch (e) {} pwApi = null; } }
    function papersKit() { return (window.SL && SL.kits && SL.kits.papers) || null; }
    /* the count is the kit's own list, never a number typed here (it said 10 while 15 were live); until the
       kit has loaded the row shows a chevron instead, and on a laptop the kit is fetched once the shelf is idle */
    function papersRow() {
      if (S.stage !== 'secondary') return '';
      var k = papersKit(), n = k ? k.list().length : 0;
      return '<button type="button" class="sl-rrow sl-strand sl-pwrow' + (S.screen === 'papers' ? ' is-now' : '') +
        '" data-papers="1">' + stk('papers', '') + '<span class="rq">GCSE past papers</span>' + (n ? '<span class="rcount">' + n + '</span>' : ICON.chevR) + '</button>';
    }
    var pwPre = false, pwEnter = true;
    function pwPrefetch() {
      if (pwPre || papersKit() || S.stage !== 'secondary' || narrow()) return;
      pwPre = true;
      var go = function () {
        loadAsset('skills-lab-kit-papers.js').then(function () {
          if (S.screen !== 'library' && S.screen !== 'mixed') return;
          each(document.querySelectorAll('#slShell .sl-pwrow'), function (r) { r.outerHTML = papersRow(); });
        }, function () { pwPre = false; });
      };
      if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 5000 }); else setTimeout(go, 2500);
    }
    var PW_STRANDS = [['number', 'Number'], ['algebra', 'Algebra'], ['ratio', 'Ratio & proportion'], ['geometry', 'Geometry'], ['statistics', 'Probability & statistics']];
    var PW_HUE = { number: '--t2', algebra: '--t1', ratio: '--t3', geometry: '--t4', statistics: '--t5' };
    /* a question's strand: the kit's own when a row carries one, else read from the topic. Algebra is tried
       before geometry so a tangent's EQUATION and a transformed GRAPH land in algebra, as the spec puts them. */
    function pwStrand(r) {
      if (r.strand && PW_HUE[r.strand]) return r.strand;
      var t = String(r.topic || '').toLowerCase();
      if (/probab|colour|dice|spinner|coin|tree diagram|venn|mean|median|histogram|cumulative|frequency/.test(t)) return 'statistics';
      if (/ratio|proportion|percent|speed|density|pressure|compound|growth|decay|interest/.test(t)) return 'ratio';
      if (/tangent|graph|function|equation|inequalit|algebra|sequence|quadratic|simultaneous|formula|iteration|expression|factoris|expand|proof/.test(t)) return 'algebra';
      if (/vector|angle|circle|trig|triangle|area|volume|similar|congruen|shape|polygon|octagon|hexagon|bearing|pythag|sine|cosine|arc|sector|cone|sphere|prism|pyramid|cylinder|transformation|loci|construct/.test(t)) return 'geometry';
      return 'number';
    }
    function pwStrandName(id) { for (var i = 0; i < PW_STRANDS.length; i++) if (PW_STRANDS[i][0] === id) return PW_STRANDS[i][1]; return ''; }
    function cap1(s) { s = String(s || '').trim(); return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
    function papersListHTML() {
      var k = papersKit();
      if (!k) return '<div class="sl-scroll"><div class="sl-pwload">Opening the past paper questions...</div></div>';
      /* one block per paper: the question numbers repeat between papers, so the
         paper has to be on screen above them, and the id carries it. The strand
         chips (All first) only thin the cards out; the papers stay in order.
         Built to grow (2026-09-25): a calculator filter appears once there are
         both kinds, a search box once there are more than 24 questions, and a
         paper's heading folds its cards away (every paper starts folded once
         there are more than four). Tiers are never named (house rule 3). */
      var rows = k.list(), papers = k.papers ? k.papers() : [k.paper], body = '', idx = 0;
      var calcOf = function (r) { var p = paperById(r.paperId); return /non.?calc/i.test(p && p.sub || '') ? 'non' : 'calc'; };
      var paperById = function (id) { for (var i = 0; i < papers.length; i++) if (papers[i].id === id) return papers[i]; return null; };
      var want = S.pwStrand && rows.some(function (r) { return pwStrand(r) === S.pwStrand; }) ? S.pwStrand : '';
      var kinds = { calc: 0, non: 0 }; rows.forEach(function (r) { kinds[calcOf(r)]++; });
      var calcWant = kinds.calc && kinds.non && (S.pwCalc === 'calc' || S.pwCalc === 'non') ? S.pwCalc : '';
      var qq = rows.length > 24 ? String(S.pwFind || '').trim().toLowerCase() : '';
      var keep = function (r) { return (!want || pwStrand(r) === want) && (!calcWant || calcOf(r) === calcWant) && (!qq || String(r.topic).toLowerCase().indexOf(qq) >= 0); };
      var seen = S.pwSeen || {}, nSeen = rows.filter(function (r) { return seen[r.q]; }).length;
      var chip = function (id, label, n) {
        var on = want === id;
        return '<button type="button" role="tab" class="sl-chip sl-pwchip' + (on ? ' sl-chip--now' : '') + '" data-pwstrand="' + id + '" aria-selected="' + (on ? 'true' : 'false') + '"' +
          (id ? ' style="--c:var(' + PW_HUE[id] + ')"><i></i>' : '>') + label + '<b class="num">' + n + '</b></button>';
      };
      var cchip = function (id, label) {
        var on = calcWant === id;
        return '<button type="button" class="sl-chip sl-pwchip sl-pwcalc' + (on ? ' sl-chip--now' : '') + '" data-pwcalc="' + id + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + label + '</button>';
      };
      var chips = '<div class="sl-pwchips" role="tablist" aria-label="Strand">' + chip('', 'All', rows.length) +
        PW_STRANDS.map(function (s) { var n = rows.filter(function (r) { return pwStrand(r) === s[0]; }).length; return n ? chip(s[0], s[1], n) : ''; }).join('') + '</div>';
      /* the calculator filter is its own row: on a phone the strand row scrolls, and this must never hide off its edge */
      var calcs = kinds.calc && kinds.non ? '<div class="sl-pwchips sl-pwcalcs" aria-label="Calculator">' + cchip('non', 'Non‑calculator') + cchip('calc', 'Calculator') + '</div>' : '';
      var find = rows.length > 24 ? '<label class="sl-input sl-search sl-pwfind">' + ICON.search + '<input type="search" id="slPwFind" placeholder="Find a topic" value="' + esc(S.pwFind || '') + '" aria-label="Find a topic"></label>' : '';
      var fold = S.pwFold || (S.pwFold = {}), many = papers.length > 4, shown = 0;
      papers.forEach(function (p) {
        var mine = rows.filter(function (r) { return r.paperId === p.id && keep(r); });
        if (!mine.length) return;
        shown += mine.length;
        var m = /^(.*?),\s*(Paper\s.+)$/.exec(p.name || ''), meta = [m ? m[1] : ''].concat(String(p.sub || '').split(/,\s*/))
          .filter(function (s) { return s && !/\btier\b/i.test(s); }).map(function (s) { return cap1(s).replace(/-/g, '‑'); });
        var closed = fold[p.id] === undefined ? many && !qq : fold[p.id];
        var pSeen = mine.filter(function (r) { return seen[r.q]; }).length;
        var cards = closed ? '' : mine.map(function (r) {
          var st = pwStrand(r), done = !!seen[r.q];
          return '<button type="button" class="sl-pwcard' + (done ? ' is-seen' : '') + '" data-pwopen="' + esc(r.q) + '" style="--c:var(' + PW_HUE[st] + ');--i:' + (idx++) + '">' +
            '<span class="pwc-top"><span class="sl-pwq">Q' + esc(r.num || r.q) + '</span><span class="pwc-marks">' + esc(r.marks) + '</span></span>' +
            '<span class="sl-pwtopic">' + esc(r.topic) + '</span>' +
            '<span class="pwc-strand"><i></i>' + esc(pwStrandName(st)) + '</span>' +
            '<span class="pwc-foot"><span class="sl-pwgo">' + (done ? ICON.tick + 'Walked through' : ICON.play + 'Walk through it') + '</span><span class="sl-pwmeta">' + r.steps + ' steps</span></span></button>';
        }).join('');
        body += '<section class="sl-pwsec' + (closed ? ' is-folded' : '') + '"><button type="button" class="sl-pwpaper" data-pwfold="' + esc(p.id) + '" aria-expanded="' + (closed ? 'false' : 'true') + '">' +
          '<h3>' + esc(m ? m[2] : p.name) + '</h3><span class="pwp-meta">' + esc(meta.join(' · ')) + '</span>' +
          '<span class="pwp-count">' + mine.length + ' question' + (mine.length === 1 ? '' : 's') + (pSeen ? ' · ' + pSeen + ' done' : '') + '</span>' + ICON.chevD + '</button>' +
          (closed ? '' : '<div class="sl-pwgrid">' + cards + '</div>') + '</section>';
      });
      if (!shown) body = '<div class="sl-empty">No question matches. <button type="button" class="sl-linkbtn" data-pwreset="1">Show them all</button></div>';
      var prog = nSeen ? '<div class="sl-pwprog" style="--p:' + (nSeen / rows.length) + '"><span><i></i></span>' + nSeen + ' of ' + rows.length + ' walked through</div>' : '';
      var enter = pwEnter; pwEnter = false;
      return '<div class="sl-scroll"><div class="sl-pwlist' + (enter ? ' is-enter' : '') + '"><div class="sl-pwhead"><h2>GCSE past papers</h2>' +
        '<p>The hardest questions from real papers, taught one press at a time. Every one can be rerolled with new numbers.</p>' + prog + find + '<div class="sl-pwfilters">' + chips + calcs + '</div></div>' +
        body + '</div></div>';
    }
    function papersFail() { destroyPapers(); paint(elPapers, '<div class="sl-scroll"><div class="sl-pwload">That did not load. Check the connection and try again.</div></div>'); }
    function renderPapers() {
      var want = S.papersQ || '';
      if (!want) {
        destroyPapers(); pwEnter = true;
        paint(elPapers, papersListHTML());
        if (!papersKit()) loadAsset('skills-lab-kit-papers.js').then(function () {
          if (S.screen === 'papers' && !S.papersQ) paint(elPapers, papersListHTML());
        }, papersFail);
        return;
      }
      paint(elPapers, '<div class="sl-pwhost" id="slPwHost"></div>');
      loadAsset('skills-lab-kit-papers.js').then(function () {
        if (S.screen !== 'papers' || (S.papersQ || '') !== want) return;
        var k = papersKit(), host = $('slPwHost');
        if (!k || !host) return papersFail();
        destroyPapers();
        var got = k.has(want) ? want : k.list()[0].q;
        if (!S.pwSeen) S.pwSeen = {};
        if (!S.pwSeen[got]) { S.pwSeen[got] = 1; save(); }
        pwApi = k.mount(host, { q: k.has(want) ? want : k.list()[0].q, onList: function () { S.papersQ = ''; save(); renderPapers(); renderTop(); } });
      }, papersFail);
    }
    elPapers.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button') : null;
      if (b && b.hasAttribute('data-pwstrand')) { S.pwStrand = b.getAttribute('data-pwstrand'); pwEnter = true; paint(elPapers, papersListHTML()); return; }
      if (b && b.hasAttribute('data-pwcalc')) { var cv = b.getAttribute('data-pwcalc'); S.pwCalc = S.pwCalc === cv ? '' : cv; pwEnter = true; paint(elPapers, papersListHTML()); return; }
      if (b && b.getAttribute('data-pwfold')) { var fid = b.getAttribute('data-pwfold'), sec = b.closest('.sl-pwsec'); S.pwFold = S.pwFold || {}; S.pwFold[fid] = !(sec && sec.classList.contains('is-folded')); paint(elPapers, papersListHTML()); return; }
      if (b && b.getAttribute('data-pwreset')) { S.pwStrand = ''; S.pwCalc = ''; S.pwFind = ''; paint(elPapers, papersListHTML()); return; }
      if (b && b.getAttribute('data-pwopen')) { S.papersQ = b.getAttribute('data-pwopen'); save(); renderPapers(); renderTop(); }
    });

    var pwFindT = null;
    elPapers.addEventListener('input', function (e) {
      if (!e.target || e.target.id !== 'slPwFind' || e.isComposing) return;
      S.pwFind = e.target.value; clearTimeout(pwFindT);
      pwFindT = setTimeout(function () {
        var pos = e.target.selectionStart; paint(elPapers, papersListHTML());
        var i = $('slPwFind'); if (i) { i.focus(); try { i.setSelectionRange(pos, pos); } catch (er) {} }
      }, 140);
    });
    var elMix = $('slMixed');
    function toggleMix(sk) {
      if (inMix(sk)) S.mix = S.mix.filter(function (m) { return m.id !== sk.id; });
      else if (S.mix.length < 6) S.mix.push({ id: sk.id });
      save();
    }
    /* every level as its own chip, the way the practise rail does it. The old
       minus/plus stepper moved the whole selection up and down, which is not how
       anyone picks levels, and it broke when the level arrows were removed. */
    function lvlChipsHTML(sk, extra) {
      var sel = selLevels(sk), all = sel.length === sk.levels.length;
      var chips = sk.levels.map(function (L, i) {
        var k = i + 1, on = sel.indexOf(k) >= 0;
        return '<button type="button" class="sl-chip sl-chip--lvl num' + (isMixLevel(sk, k) ? ' sl-chip--mix' : '') + (on ? ' sl-chip--now' : '') +
          '" data-togglelvl="' + k + '" aria-pressed="' + (on ? 'true' : 'false') + '"' + tipAttrs(sk, k) + '>' + chipText(sk, k) + '</button>';
      }).join('');
      return '<div class="sl-lvlchips">' + chips +
        (extra ? '<button type="button" class="sl-chip sl-chip--alllvl' + (all ? ' sl-chip--now' : '') + '" data-alllvl="1" title="' +
          (all ? 'Back to level 1 only' : 'Use every level') + '">All</button>' : '') + '</div>';
    }
    function mixChipHTML(sk, i) {
      var c = colourOf(sk), n = mixSkills().length;
      /* the exact share this skill gets, not an approximation: the set is dealt
         round robin, so the first few skills carry the remainder */
      var base = n ? Math.floor(S.setN / n) : 0, per = base + ((i || 0) < S.setN - base * n ? 1 : 0);
      return '<div class="sl-mixchip" data-mix="' + sk.id + '" style="--c:' + c.col + ';--ct:' + c.tint + '"><span class="mico">' + skIcon(sk) + '</span><span class="mname">' + esc(sk.name) + '</span>' +
        lvlChipsHTML(sk, true) +
        '<span class="rside hide-sm" title="How many of the ' + S.setN + ' questions come from this skill"><b class="num">' + per + '</b> question' + (per === 1 ? '' : 's') + '</span>' +
        '<button type="button" class="sl-iconbtn rm" data-rm="1" aria-label="Remove ' + esc(sk.name) + '">' + ICON.cross + '</button></div>';
    }
    function mixedTray() {
      var n = S.mix.length, okN = n >= 2;
      return '<div class="sl-tray"><div class="sl-tray-head"><span class="sl-sect">Your selection</span>' +
        '<span class="sub">' + (n ? n + ' of 6 skills' + (okN ? ' · ' + S.setN + ' questions, taken from each in turn' : ' · pick at least 2') : 'Tick 2 to 6 skills above') + '</span>' +
        '<div class="sl-tray-ctas"><div class="sl-segwrap sl-mixlay" data-mo-group="mixlay" title="How the board deals these skills"><button type="button" class="sl-seg' + (S.board.mixLayout === 'skill' ? ' is-on' : '') + '" data-mixlay="skill">One skill per column</button>' +
        '<button type="button" class="sl-seg' + (S.board.mixLayout === 'mixed' ? ' is-on' : '') + '" data-mixlay="mixed">All mixed</button></div>' +
        '<button type="button" class="sl-btn" id="slMixBoard"' + (okN ? '' : ' disabled') + '>' + ICON.board + 'Board</button>' +
        '<button type="button" class="sl-btn" id="slMixSpeed"' + (okN ? '' : ' disabled') + '>' + ICON.clock + 'Speed</button>' +
        '<button type="button" class="sl-btn sl-btn--cta" id="slMixPractise" style="padding:13px 20px;font-size:16px"' + (okN ? '' : ' disabled') + '>' + ICON.play + 'Mixed practise</button></div></div>' +
        (n ? '<div class="sl-tray-chips">' + mixSkills().map(mixChipHTML).join('') + '</div>' : '') + '</div>';
    }
    function renderMixed() { var was = libSig[1]; paint(elMix, libraryBody(true)); if (was !== libSig[1]) { shelfTop(elMix); railToNow(elMix); } }
    elMix.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null;
      if (!t) return;
      var chip = t.closest('.sl-mixchip');
      if (chip) {
        var sk = SL.get(chip.getAttribute('data-mix'));
        if (t.getAttribute('data-rm')) { toggleMix(sk); renderMixed(); return; }
        if (levelClick(t, sk)) { renderMixed(); return; }
        return;
      }
      if (t.getAttribute('data-mixlay')) { S.board.mixLayout = t.getAttribute('data-mixlay'); save(); renderMixed(); return; }
      if (t.id === 'slMixPractise') { withSkills(S.mix.map(function (m) { return m.id; }), t, function () { S.from = 'mixed'; buildSet(); show('practise'); }, true); return; }
      if (t.id === 'slMixBoard') { withSkills(S.mix.map(function (m) { return m.id; }), t, function () { S.from = 'mixed'; buildBoard(); show('board'); }, true); return; }
      if (t.id === 'slMixSpeed') { S.from = 'mixed'; show('speedsetup'); return; }
      if (libClick(e, true)) { renderMixed(); syncSearchBox(); }
    });
    elMix.addEventListener('input', function (e) { onSearch(e, renderMixed); });

    /* ============================================================
       LEVEL PICKER, shared by the skill screen, board setup and practise
       ============================================================ */
    /* max: the most levels that may be ticked at once (the board fits three columns) */
    function levelCap(sk, max) { return max ? Math.min(max, sk.levels.length) : sk.levels.length; }
    function levelListHTML(sk, compact, max) {
      var sel = selLevels(sk), full = max && sel.length >= max;
      var cap = levelCap(sk, max), allOn = sel.length >= cap;
      var bar = '<div class="sl-lvlbar"><button type="button" class="sl-chip sl-chip--alllvl' + (allOn ? ' sl-chip--now' : '') + '" data-alllvl="1">' +
        (allOn ? 'Clear, back to level 1' : 'Select all ' + cap) + '</button></div>';
      return bar + '<div class="sl-lvllist' + (compact ? ' sl-lvllist--compact' : '') + '" role="group" aria-label="Levels">' + sk.levels.map(function (L, i) {
        var k = i + 1, on = sel.indexOf(k) >= 0, off = full && !on;
        return '<button type="button" class="sl-rrow sl-lvlrow' + (on ? ' is-now' : '') + (off ? ' is-off' : '') + '" style="--i:' + (k - 1) + '" data-togglelvl="' + k + '" aria-pressed="' + (on ? 'true' : 'false') + '"' + (off ? ' disabled' : '') + '><span class="sl-check' + (on ? ' is-on' : '') + '">' + ICON.tick + '</span><span class="rq"><span class="lname">' + k + '. ' + esc(L.name) + '</span><span class="leg sl-expr">' + oneEg(L.eg) + '</span></span>' + '</button>';
      }).join('') + '</div>';
    }
    function levelNowHTML(sk) {
      var sel = selLevels(sk), n = sk.levels.length, lo = sel[0];
      var body = sel.length === 1
        ? '<b class="num">Level ' + lo + ' of ' + n + '</b><span>' + esc(levelName(sk, lo)) + '</span><span class="sl-expr leg">Questions such as ' + levelEg(sk, lo) + '</span>'
        : '<b class="num">' + sel.length + ' levels of ' + n + '</b><span>' + esc(levelWord(sk).replace('Levels ', 'Levels ')) + '</span><span class="leg">Questions from each, taken in turn. Tap a level below to add or remove it.</span>';
      return '<div class="sl-lvlnow"><div class="lvbody">' + body + '</div></div>';
    }
    function levelClick(t, sk, max) {
      if (t.getAttribute('data-alllvl')) {
        var cap = levelCap(sk, max), every = [], i;
        for (i = 1; i <= cap; i++) every.push(i);
        setSel(sk, selLevels(sk).length >= cap ? [1] : every);
        return true;
      }
      if (t.getAttribute('data-togglelvl')) {
        var k = Number(t.getAttribute('data-togglelvl'));
        if (max && selLevels(sk).indexOf(k) < 0 && selLevels(sk).length >= max) return true;
        toggleSel(sk, k); return true;
      }
      return false;
    }

    /* ============================================================
       SKILL: name → level → activity
       ============================================================ */
    var elSk = $('slSkill');
    function renderSkill() {
      var sk = curSkill(); if (!sk) { show('library'); return; }
      var n = sk.levels.length, c = colourOf(sk), sel = selLevels(sk);
      paint(elSk, '<div class="sl-main"><div class="sl-scroll"><div class="sl-skill' + (entering ? ' is-enter' : '') + '">' +
        '<div class="sl-skill-info">' +
          '<div class="sl-skill-card" style="--c:' + c.col + ';--ct:' + c.tint + '">' +
            '<div class="tband tband--title">' + skIcon(sk) + '<h2 class="tname">' + esc(sk.name) + '</h2>' + favBtn(sk, true) +
'</div>' +
            '<div class="sl-skill-body"><p>' + esc(sk.blurb || '') + '</p>' +
            '<div class="tspec"><span class="sl-expr">' + egFor(sk, sel[0]) + '</span></div></div></div>' +
          '<div class="sl-lvlpick"><div class="sl-sect">Level</div>' + levelNowHTML(sk) +
            '<div class="sl-lvlnote">Tick more than one level to practise them together.</div>' +
            levelListHTML(sk, false) + '</div>' +
        '</div>' +
        '<div class="sl-skill-do"><div class="sl-sect">What would you like to do?</div>' +
          '<button type="button" class="sl-act" data-act="teach" style="--c:' + c.col + '">' + stk('teach', ICON.steps) + '<b>Teach</b><span>Work through one model step by step.</span></button>' +
          '<button type="button" class="sl-act" data-act="practise" style="--c:' + c.col + '">' + stk('practise', ICON.list) + '<b>Practise</b><span>Ten questions to work out and mark.</span></button>' +
          /* only a skill whose model can be ANSWERED offers this one */
          (sk.turnName ? '<button type="button" class="sl-act" data-act="turn" style="--c:' + c.col + '">' + stk('turn', ICON.flag) + '<b>' + esc(sk.turnName || 'Your turn') + '</b><span>' + esc(sk.turnBlurb || 'Answer on the model itself, step by step.') + '</span></button>' : '') +
          /* only a skill whose answer can be TYPED or TAPPED offers this one */
          (canRace(sk) ? '<button type="button" class="sl-act" data-act="speed" style="--c:' + c.col + '">' + stk('speed', ICON.clock) + '<b>Speed</b><span>Questions against the clock, timed one by one.</span></button>' : '') +
          '<button type="button" class="sl-act" data-act="board" style="--c:' + c.col + '">' + stk('board', ICON.board) + '<b>Board</b><span>A set of questions on the screen for a class.</span></button>' +
        '</div></div></div></div>');
    }
    elSk.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null; if (!t) return;
      var sk = curSkill(); if (!sk) return;
      if (t.getAttribute('data-fav')) { toggleFav(SL.get(t.getAttribute('data-fav'))); renderSkill(); return; }
      if (levelClick(t, sk)) { renderSkill(); return; }
      var act = t.getAttribute('data-act');
      if (act === 'practise') withSkills([sk.id], t, function () { S.from = 'skills'; buildSet(); show('practise'); });
      if (act === 'teach') withSkills([sk.id], t, function () { S.from = 'skills'; buildSet(); S.teach.i = 0; S.teach.back = null; show('teach'); });
      if (act === 'speed') { if (!canRace(sk)) return; S.from = 'skills'; show('speedsetup'); }
      if (act === 'turn') withSkills([sk.id], t, function () { S.from = 'skills'; startTurn(); show('turn'); });
      if (act === 'board') { S.from = 'skills'; show('boardsetup'); }
    });

    /* ============================================================
       BOARD SETUP
       ============================================================ */
    var elBs = $('slBoardSetup');
    /* Choosing how many, or how long, is a slider (Aadam, 2026-09-15), but only onto stops that make
       sense: no 27 questions, no 3 minutes 32. The readout sits over the track and every stop is
       named under it, and a stop can be clicked. The choice is taken when the thumb is let go. */
    function sliderHTML(key, stops, cur, big, small) {
      var i = stops.indexOf(cur), n = stops.length - 1;
      if (i < 0) i = 0;
      return '<div class="sl-slider" style="--p:' + (n ? i / n : 0) + '">' +
        '<output class="sl-slval num">' + big(stops[i]) + '</output>' +
        '<input type="range" class="sl-range" min="0" max="' + n + '" step="1" value="' + i + '" data-slider="' + key + '" aria-valuetext="' + esc(big(stops[i])) + '">' +
        '<div class="sl-slticks">' + stops.map(function (v, k) {
          return '<button type="button" class="sl-slstop num' + (k === i ? ' is-on' : '') + '" style="--k:' + (n ? k / n : 0) + '" data-slstop="' + k + '" tabindex="-1">' + small(v) + '</button>';
        }).join('') + '</div></div>';
    }
    /* while the thumb moves, the readout and the fill follow it */
    function sliderMove(inp, stops, big) {
      var wrap = inp.closest('.sl-slider'), k = Number(inp.value), n = stops.length - 1;
      if (!wrap) return;
      wrap.style.setProperty('--p', n ? k / n : 0);
      var o = wrap.querySelector('.sl-slval'); if (o) o.textContent = big(stops[k]);
      inp.setAttribute('aria-valuetext', big(stops[k]));
      Array.prototype.forEach.call(wrap.querySelectorAll('.sl-slstop'), function (b, j) { b.classList.toggle('is-on', j === k); });
    }
    var BOARD_N = [8, 16, 24];
    function boardNWords(v) { return v + ' questions'; }
    /* BOARD SETUP (2026-09-16, Aadam's pick): levels, layout and how many on the left; on the right
       the board itself, dealt, fitted at full size and scaled down, so what is on the setup is what
       the class gets. Show the board opens those questions; Deal again deals them afresh. */
    function boardSigFor(sk) { return [sk.id, selLevels(sk).join(','), S.board.layout, S.board.n].join('|'); }
    function bsMini(per) {
      var W = [78, 56, 88, 64, 72, 50];
      return '<span class="sl-mb" aria-hidden="true">' + [0, 1, 2].map(function (c) {
        return '<span class="mb-col"><i class="mb-h' + (per ? '' : ' is-plain') + '" style="--d:var(--t' + (c + 1) + ')"></i>' + [0, 1, 2, 3].map(function (r) {
          return '<i class="mb-l" style="--w:' + W[(r * 3 + c) % 6] + '%;--d:var(--t' + ((per ? c : r + c) % 3 + 1) + ')"></i>';
        }).join('') + '</span>';
      }).join('') + '</span>';
    }
    function renderBoardSetup() {
      var sk = curSkill(); if (!sk) { show('library'); return; }
      var sel = selLevels(sk), n = sk.levels.length, diff = S.board.layout === 'diff';
      var cols = diff ? diffLevels(sk) : [];
      var chosen = sel.length === 1 ? 'Level ' + sel[0] : (sel.length === n ? 'All ' + n + ' chosen' : sel.length + ' chosen');
      var lay = function (key, name, sub, per) {
        var on = S.board.layout === key;
        return '<button type="button" class="sl-bslay' + (on ? ' is-on' : '') + '" data-layout="' + key + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + bsMini(per) + '<b>' + name + '</b><span>' + sub + '</span></button>';
      };
      var countRow = diff
        ? '<span class="sl-lvlnote">Eight questions in each column, up to three levels.' + (sel.length === 1 ? ' One level chosen, so the two above it fill the other columns.' : '') + '</span>'
        : '<span class="sl-bsh sl-bsh--sm">Questions</span><div class="sl-segwrap sl-bsn" data-mo-group="bcount">' + BOARD_N.map(function (v) {
            return '<button type="button" class="sl-seg num' + (v === S.board.n ? ' is-on' : '') + '" data-bn="' + v + '">' + v + '</button>';
          }).join('') + '</div>';
      var prevSub = diff ? 'Levels ' + cols.join(', ') : (sel.length === 1 ? 'Level ' + sel[0] : 'Levels ' + sel.join(', ') + ', taken in turn');
      paint(elBs, '<div class="sl-main"><div class="sl-scroll"><div class="sl-bsetup' + (entering ? ' is-enter' : '') + (n > 9 ? ' is-many' : '') + '">' +
        '<div class="sl-bsleft">' +
          '<div class="sl-bshead"><h2 class="sl-bsh">Levels</h2><span class="sl-bssub">' + chosen + '</span></div>' +
          levelListHTML(sk, true, diff ? 3 : 0) +
          '<div class="sl-bshead"><h2 class="sl-bsh">Layout</h2></div>' +
          '<div class="sl-bslays">' + lay('mix', 'Mixed', 'Levels taken in turn', false) + lay('diff', 'One column per level', 'A column for each level', true) + '</div>' +
          '<div class="sl-bsrow">' + countRow + '</div>' +
        '</div>' +
        '<div class="sl-bsright">' +
          '<div class="sl-bshead"><h2 class="sl-bsh">Preview</h2><span class="sl-bssub">' + prevSub + '</span><span class="sl-bs-sp"></span>' +
            '<button type="button" class="sl-btn sl-btn--sm" id="slBsDeal">' + ICON.refresh + 'Deal again</button></div>' +
          '<div class="sl-bprev" id="slBsPrev"><span class="sl-bprev-wait">Dealing the board</span></div>' +
          '<div class="sl-bsgo"><span class="sl-lvlnote">Answers start hidden.</span><span class="sl-bs-sp"></span>' +
            '<button type="button" class="sl-btn sl-btn--cta" id="slBoardGo">' + ICON.board + 'Show the board</button></div>' +
        '</div>' +
      '</div></div></div>');
      bsPreview(false);
    }
    var bsTok = 0;
    /* deals when the board on hand was not dealt for these settings, then draws; loads the engine
       itself (not withSkills), so a Show the board press while it loads keeps its own token */
    function bsPreview(redeal) {
      var host = $('slBsPrev'), sk = curSkill(); if (!host || !sk) return;
      var tok = ++bsTok;
      var draw = function () {
        if (tok !== bsTok || S.screen !== 'boardsetup' || !host.isConnected) return;
        var s2 = curSkill(); if (!s2 || !s2.make) return;
        if (redeal || S.from !== 'skills' || !S.board.cols.length || S.board.cols.bsSig !== boardSigFor(s2)) { S.from = 'skills'; buildBoard(); }
        bsDraw(host);
      };
      if (SL.ready(sk.id)) draw();
      else SL.ensure([sk.id]).then(draw, function () { if (tok === bsTok && host.isConnected) host.innerHTML = '<span class="sl-bprev-wait">The preview did not load. Show the board still works.</span>'; });
    }
    /* the real board at the size the board screen will have, fitted there, then scaled into the box */
    function bsDraw(host) {
      var cols = S.board.cols;
      if (!host.clientWidth || !host.clientHeight || !cols.length) return;
      var diffBoard = S.board.layout === 'diff', headChips = !diffBoard && !cols.some(function (c) { return c.mixed; });
      var W = Math.max(720, elBody.clientWidth), H = Math.max(420, elBody.clientHeight - (headChips ? 0 : 54));
      host.innerHTML = '<div class="sl-bprev-fit"><div class="sl-bprev-stage" inert aria-hidden="true" style="width:' + W + 'px;height:' + H + 'px"><div class="sl-board-main">' +
        '<div class="sl-board-cols n' + Math.min(6, cols.length) + '">' + boardColsHTML(cols, undefined, headChips) + '</div>' + boardFootHTML(cols) + '</div></div></div>';
      var stage = host.querySelector('.sl-bprev-stage'), fit = host.firstChild;
      fitBoard(stage);
      var k = Math.min(host.clientWidth / W, host.clientHeight / H);
      stage.style.transform = 'scale(' + k.toFixed(4) + ')';
      fit.style.width = Math.floor(W * k) + 'px'; fit.style.height = Math.floor(H * k) + 'px';
    }
    /* the columns of a differentiated board: the chosen levels, or the chosen one and the two above it */
    function diffLevels(sk) {
      var sel = selLevels(sk), n = sk.levels.length;
      if (sel.length > 1) return sel.slice(0, 3);
      var levels = [];
      for (var m = sel[0]; m <= n && levels.length < 3; m++) levels.push(m);
      while (levels.length < 3 && levels[0] > 1) levels.unshift(levels[0] - 1);
      return levels;
    }
    elBs.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null; if (!t) return;
      var sk = curSkill(); if (!sk) return;
      if (t.getAttribute('data-layout')) {
        S.board.layout = t.getAttribute('data-layout');
        /* one column per level shows three at most, so trim the choice to match */
        if (S.board.layout === 'diff' && selLevels(sk).length > 3) setSel(sk, selLevels(sk).slice(0, 3));
        save(); renderBoardSetup(); return;
      }
      if (t.hasAttribute('data-bn')) { S.board.n = Number(t.getAttribute('data-bn')) || S.board.n; save(); renderBoardSetup(); return; }
      if (levelClick(t, sk, S.board.layout === 'diff' ? 3 : 0)) { renderBoardSetup(); return; }
      if (t.id === 'slBsDeal') { bsPreview(true); return; }
      if (t.id === 'slBoardGo') withSkills([sk.id], t, function () {
        S.from = 'skills';
        if (!S.board.cols.length || S.board.cols.bsSig !== boardSigFor(curSkill())) buildBoard();
        else { setAllAns(false); S.board.tab = 0; }
        show('board');
      }, true);
    });

    /* ============================================================
       SETS
       ============================================================ */
    function makeItem(sk, lvl, ctx) { return { skill: sk, level: lvl, q: sk.make(lvl, ctx), state: 'hid' }; }
    /* where a question sits among the earlier questions of its skill and level, so a skill whose sets
       climb in a fixed order (quadratic formula) re-deals the SAME step when one question is refreshed (2026-09-15) */
    function slotIn(list, i) {
      var it = list[i], n = 0;
      for (var j = 0; j < i; j++) if (list[j] && list[j].skill === it.skill && list[j].level === it.level) n++;
      return n;
    }
    /* count questions for one skill, its chosen levels taken in turn */
    function dealFor(sk, count, ctx) {
      var levels = selLevels(sk), out = [];
      ctx = ctx || { seen: {}, shapeSeen: {}, last: null };
      for (var k = 0; k < count; k++) out.push(makeItem(sk, levels[k % levels.length], ctx));
      return out;
    }
    function buildSet() {
      var sks = activeSkills(), n = S.setN, queues = [], items = [];
      if (!sks.length) { S.set = []; return; }
      var per = Math.floor(n / sks.length), rem = n - per * sks.length;
      sks.forEach(function (sk, i) { queues.push(dealFor(sk, per + (i < rem ? 1 : 0))); });
      /* taken in turn: skill 1, skill 2, skill 1, skill 2 ... */
      for (var k = 0; items.length < n; k++) { var q = queues[k % queues.length]; if (q.length) items.push(q.shift()); else if (queues.every(function (x) { return !x.length; })) break; }
      S.set = items; S.prOne = -1;
    }
    function redealSkill(sk) {
      var count = S.set.filter(function (it) { return it.skill === sk; }).length, fresh = dealFor(sk, count), i = 0;
      S.set = S.set.map(function (it) { return it.skill === sk ? fresh[i++] : it; });
      S.prOne = -1;
    }
    function partlyMarked() { return S.set.some(function (it) { return it.state === 'ok' || it.state === 'miss'; }) && S.set.some(function (it) { return it.state !== 'ok' && it.state !== 'miss'; }); }
    function mark(it, got) {
      if (it.state === 'ok' || it.state === 'miss') return;
      it.state = got ? 'ok' : 'miss';
      var p = S.prog[it.skill.id] = S.prog[it.skill.id] || {};
      var r = p[it.level] = p[it.level] || { n: 0, ok: 0 };
      r.n++; if (got) r.ok++;
      FX.mark = S.set.indexOf(it); FX.count = true;
      trackSecure(it.skill, it.level, r);
      trackSet();
      save();
    }
    /* the rule the app tells people: ten marked at eight out of ten */
    function trackSecure(sk, level, r) {
      if (!sk || !r || r.n < 10 || r.ok / r.n < 0.8) return;
      var k = sk.id + '|' + level;
      if (trackedSecure[k]) return;
      trackedSecure[k] = 1;
      track('level_secure', { skill: sk.id, level: level, marked: r.n, correct: r.ok });
    }
    /* every question in the dealt set marked, once per deal */
    function trackSet() {
      if (!S.set.length || S.set.some(function (x) { return x.state !== 'ok' && x.state !== 'miss'; })) return;
      var sig = S.set.length + '|' + (S.set[0].key || S.set[0].q && S.set[0].q.key || '');
      if (trackedSet === sig) return;
      trackedSet = sig;
      track('set_marked', {
        skill: S.from === 'mixed' ? 'mixed' : (S.set[0].skill ? S.set[0].skill.id : ''),
        correct: S.set.filter(function (x) { return x.state === 'ok'; }).length,
        question_count: S.set.length
      });
    }

    /* ============================================================
       PRACTISE
       ============================================================ */
    var elPr = $('slPractise');
    function topicHTML(sk, max) {
      var c = colourOf(sk), sel = selLevels(sk), count = S.set.filter(function (it) { return it.skill === sk; }).length;
      var cap = max ? Math.min(max, sk.levels.length) : 0;
      var chips = sk.levels.map(function (L, i) {
        var k = i + 1, on = sel.indexOf(k) >= 0;
        if (S.screen === 'teach' && isMixLevel(sk, k)) return '';
        /* one column per level fits three, so a fourth is shown but not takeable */
        var off = cap && !on && sel.length >= cap;
        return '<button type="button" class="sl-chip sl-chip--lvl num' + (isMixLevel(sk, k) ? ' sl-chip--mix' : '') + (on ? ' sl-chip--now' : '') + (off ? ' is-off' : '') + '" data-togglelvl="' + k + '" aria-pressed="' + (on ? 'true' : 'false') + '"' + tipAttrs(sk, k) + '>' + chipText(sk, k) + '</button>';
      }).join('');
      return '<div class="sl-topic" data-topic="' + sk.id + '"><div class="thead"><span style="color:' + c.col + ';display:grid">' + skIcon(sk) + '</span><span class="tname">' + esc(sk.name) + '</span>' + (S.screen === 'practise' && S.from === 'mixed' ? '<span class="tcount">' + count + ' of ' + S.set.length + '</span>' : '') + '</div>' +
        '<div class="sl-lvlchips">' + chips + '</div>' +
        '<span class="tlname">' + esc(levelWord(sk)) + (sel.length > 1 ? ', in turn' : '') + '</span></div>';
    }
    /* On the board the strip was a whole band of chrome across the top - two
       rows of it with four skills - saying the same thing every column head
       already said. The chips move INTO the head, so the control sits on the
       thing it changes and the questions get the height back. It only works
       when a column IS one skill: a differentiated board is one skill at three
       levels, and a mixed column has no single skill, so those keep the strip. */
    function headChipsHTML(sk) {
      var sel = selLevels(sk);
      return '<div class="sl-topic sl-topic--bhead" data-topic="' + sk.id + '"><div class="sl-lvlchips">' + sk.levels.map(function (L, i) {
        var k = i + 1, on = sel.indexOf(k) >= 0;
        return '<button type="button" class="sl-chip sl-chip--lvl num' + (isMixLevel(sk, k) ? ' sl-chip--mix' : '') + (on ? ' sl-chip--now' : '') + '" data-togglelvl="' + k + '" aria-pressed="' + (on ? 'true' : 'false') + '"' + tipAttrs(sk, k) + '>' + chipText(sk, k) + '</button>';
      }).join('') + '</div></div>';
    }
    /* the level strip practise carries, reused by teach and by the board so a
       level can be changed where the questions are, not two screens back */
    function lvlStripHTML(tail, max) {
      return '<div class="sl-prbar">' + activeSkills().map(function (sk) { return topicHTML(sk, max); }).join('') +
        '<div class="sl-prbar-sp"></div>' + (tail || '') + '</div>';
    }
    /* Typing an answer. A plain number is one box. Anything else used to fall
       straight through - the toggle went on and every algebra card stayed
       tap-to-reveal, which read as the feature being broken - so a skill can now
       say how its answer splits with fields(q): the brackets skills hand back one
       box per COEFFICIENT with the x term printed beside it, so the pupil types
       the numbers and the shape of the answer is given to them. */
    function typeFields(it) {
      var sk = it.skill, fs = null;
      if (sk && typeof sk.fields === 'function') { try { fs = sk.fields(it.q); } catch (err) { fs = null; } }
      if (fs && fs.length) return fs;
      if (/^[\u2212-]?\d+(?:\.\d+)?$/.test(String(it.q.ansText || '').trim())) return [{ ans: String(it.q.ansText).trim(), w: 5 }];
      return null;
    }
    function canType(it) { return !!typeFields(it); }
    /* what counts as the same answer: numbers by VALUE (commas, spaces, a leading
       point, trailing decimal zeros and the minus glyph all forgiven), text by
       letters (case, spaces and hyphens forgiven), plus any string the skill lists
       in accepted, plus a skill's own norm() on the field (2026-09-09) */
    function canon(x) {
      var s = String(x === null || x === undefined ? '' : x).trim().toLowerCase().replace(/[\u2212\u2013\u2014]/g, '-').replace(/[,\s]/g, '').replace(/^\+/, '');
      if (/^-?(?:\d+\.?\d*|\.\d+)$/.test(s)) {
        var neg = s.charAt(0) === '-'; if (neg) s = s.slice(1);
        var parts = s.split('.'), ip = (parts[0] || '').replace(/^0+(?=\d)/, '') || '0', fp = (parts[1] || '').replace(/0+$/, '');
        return (neg && (ip !== '0' || fp) ? '-' : '') + ip + (fp ? '.' + fp : '');
      }
      return s.replace(/-/g, '');
    }
    function sameAnswer(a, b, accepted, norm) {
      if (typeof norm === 'function') { try { var na = norm(String(a || '')); if (na === '') return false; if (na === norm(String(b || ''))) return true; return (accepted || []).some(function (x) { return norm(String(x)) === na; }); } catch (err) {} }
      var ca = canon(a); if (ca === '') return false;
      if (ca === canon(b)) return true;
      return (accepted || []).some(function (x) { return canon(x) === ca; });
    }
    /* a skill can judge the whole typed answer itself with checkFields(q, vals) -> true/false
       (factorising: the two brackets may come in either order, so their boxes swap
       together, which box-by-box marking cannot see) (2026-09-15) */
    function fieldsRight(it, fs, vals, acc) {
      var sk = it && it.skill;
      if (sk && typeof sk.checkFields === 'function') { try { var r = sk.checkFields(it.q, vals); if (r === true || r === false) return r; } catch (err) {} }
      return fs.every(function (f, j) { return sameAnswer(vals[j], f.ans, f.accepted || acc || null, f.norm); });
    }
    /* PHONE ROUND: TYPE-IN + WALL FIT (2026-09-23). A phone's number pad has no minus key, so a box whose answer may be
       negative used to force the alphabet keyboard on the child and hide half the question behind it.
       A field marked sign: true prints the operator as a BUTTON instead - it starts at + and a tap
       (or typing - into the box) turns it into a minus - so the box only ever holds the size of the
       number and the keyboard can stay numeric. Aadam, 2026-09-23, on the sequences skills: "the +
       should already be there and it changes to a minus if they choose it". */
    function signHTML(i, j, lead) {
      return '<button type="button" class="af-sign' + (lead ? ' is-lead' : '') + '" data-sign="' + i + ':' + j + '" data-v="+"' +
        ' aria-label="Plus or minus for box ' + (j + 1) + ', tap to change" aria-pressed="false">+</button>';
    }
    /* FRACTION FIELDS (2026-09-25, Aadam: "use the actual divide symbol not forward slash"). A module marks
       a denominator with op '/': that field and every field after it are the denominator, and the
       numerator is the field before it, or the bracketed group that field closes. The pair is drawn
       STACKED, numerator over a bar over denominator, never "[ ] / [ ]". The brackets that only grouped a
       side for the slash go (a product of brackets keeps its own), and the words in front of the
       numerator ("x =") and a plain lead (the space after a mixed number's whole part) stay outside.
       The algebraic fraction skills stack their boxes with their own grid (asf-fb / afr-m markers) and
       are left as they are. DOM order, and so tab order and data-af, never changes. */
    var FF_OPEN = /\(\s*$/, FF_CLOSE = /\)\s*$/;
    function fracView(fs) {
      var d = -1, j, n0, opens = 0, v;
      if (!fs || fs.length < 2 || fs.some(function (f) { return /asf-fb|afr-m/.test(f.pre || ''); })) return null;
      for (j = 1; j < fs.length; j++) if (fs[j].op === '/') { d = j; break; }
      if (d < 0) return null;
      n0 = d - 1;
      if (FF_CLOSE.test(fs[d - 1].after || '')) for (j = d - 1; j >= 0; j--) if (FF_OPEN.test(fs[j].pre || '')) { n0 = j; break; }
      /* a coefficient and its surd are ONE numerator term: [3] root[5] over [5], not 3 beside root 5 over 5 */
      if (n0 === d - 1 && n0 > 0 && fs[n0].op === ' ' && /cs-radtick|<svg/.test(fs[n0].pre || '')) n0--;
      v = fs.map(function (f) { return { pre: f.pre || '', after: f.after || '', out: '' }; });
      if (FF_OPEN.test(v[n0].pre) && FF_CLOSE.test(v[d - 1].after)) { v[n0].pre = v[n0].pre.replace(FF_OPEN, ''); v[d - 1].after = v[d - 1].after.replace(FF_CLOSE, ''); }
      for (j = d; j < fs.length; j++) if (FF_OPEN.test(v[j].pre)) opens++;
      if (opens === 1 && FF_OPEN.test(v[d].pre) && FF_CLOSE.test(v[fs.length - 1].after)) { v[d].pre = v[d].pre.replace(FF_OPEN, ''); v[fs.length - 1].after = v[fs.length - 1].after.replace(FF_CLOSE, ''); }
      if (v[n0].pre && !/<svg|class="[^"]*(rt|rad)/.test(v[n0].pre)) { v[n0].out = v[n0].pre; v[n0].pre = ''; }
      return { n0: n0, d: d, v: v };
    }
    /* piece(f, j, view) -> { lead, body }: the renderer's own markup for one box, handed the view's pre/after;
       outer(html) wraps the words moved out in front of the fraction in that renderer's own class */
    function stackFields(fs, piece, outer) {
      var fv = fracView(fs), j, p, out = '', num = '', den = '';
      if (!fv) return fs.map(function (f, j) { var q = piece(f, j, { pre: f.pre || '', after: f.after || '' }); return q.lead + q.body; }).join('');
      for (j = 0; j < fs.length; j++) {
        p = piece(fs[j], j, fv.v[j]);
        if (j < fv.n0) out += p.lead + p.body;
        else if (j === fv.n0) { out += (fs[j].sign ? '' : p.lead) + (fv.v[j].out ? (outer ? outer(fv.v[j].out) : fv.v[j].out) : ''); num += (fs[j].sign ? p.lead : '') + p.body; }
        else if (j < fv.d) num += p.lead + p.body;
        else if (j === fv.d) den += (fs[j].sign ? p.lead : '') + p.body;
        else den += p.lead + p.body;
      }
      return out + '<span class="sl-ffr"><span class="sl-ffr-n">' + num + '</span><span class="sl-ffr-d">' + den + '</span></span>';
    }
    function fieldsHTML(fs, i) {
      return '<span class="sl-ansfields">' + stackFields(fs, function (f, j, vw) {
        /* sign order (2026-10-03, Aadam "fix sign order"): words first, then the + / − button, then the box.
           A signed box's own op text ("or x =", ",", "x") is drawn too; a bare '+', ' ' or the '/' that
           starts a denominator is not (the button IS the operator there). */
        var sOp = f.sign && j && f.op && f.op !== '/' && f.op.trim() && f.op.trim() !== '+' ? '<span class="af-op">' + f.op + '</span>' : '';
        return { lead: f.sign ? sOp : j ? '<span class="af-op">' + (f.op || '+') + '</span>' : '', body:
          (vw.pre ? '<span class="af-t af-pre">' + vw.pre + '</span>' : '') + (f.sign ? signHTML(i, j, !j) : '') +
          '<input type="text" class="sl-ansin num" data-ans="' + i + '" data-af="' + j + '" style="width:' + ((f.w || 4) + 2) + 'ch"' +
          (f.sign ? ' data-signed="1" inputmode="decimal"' : ' inputmode="text"') + ' autocomplete="off" spellcheck="false" placeholder="?" aria-label="' +
          esc(fs.length > 1 ? 'Question ' + (i + 1) + ', box ' + (j + 1) + ' of ' + fs.length : 'Your answer for question ' + (i + 1)) + '">' +
          (vw.after ? '<span class="af-t">' + vw.after + '</span>' : '') };
      }, function (h) { return '<span class="af-t af-pre">' + h + '</span>'; }) + '</span>';
    }
    /* the sign button that belongs to a box, and the box's answer with that sign on the front */
    function signBtn(box) {
      if (!box || !box.getAttribute('data-signed')) return null;
      var root = box.closest ? box.closest('.sl-ansfields') : null;
      return root ? root.querySelector('.af-sign[data-sign="' + box.getAttribute('data-ans') + ':' + box.getAttribute('data-af') + '"]') : null;
    }
    function signOf(box) { var b = signBtn(box); return b ? (b.getAttribute('data-v') || '+') : ''; }
    function setSign(btn, v) {
      btn.setAttribute('data-v', v);
      btn.textContent = v === '-' ? MINUS_CH : '+';
      btn.classList.toggle('is-neg', v === '-');
      btn.setAttribute('aria-pressed', v === '-' ? 'true' : 'false');
    }
    /* a sign that reaches a signed box without a keydown (a phone keyboard, a paste, autofill) moves to the
       button too, so "-2" typed with the button on + reads −[2] (Aadam 2026-11-03: the button stayed on +) */
    document.addEventListener('input', function (e) {
      var box = e.target, btn = box && box.getAttribute ? signBtn(box) : null; if (!btn) return;
      var m = /^\s*([-−–+])\s*/.exec(box.value); if (!m) return;
      setSign(btn, m[1] === '+' ? '+' : '-');
      box.value = box.value.slice(m[0].length);
    }, true);
    function boxVal(box) {
      var v = String(box.value).trim();
      return v && signOf(box) === '-' ? '-' + v : v;
    }
    var MINUS_CH = '\u2212';
    function boxesFor(i) { return elPr.querySelectorAll('[data-ans="' + i + '"]'); }
    /* Enter walks to the next empty box, and only marks once they are all filled */
    /* a field with blank: true may be left empty (a coefficient of 1, no x term, a denominator
       of 1): the skill's checkFields reads the empty box. Enter walks past it; at least one
       box must be filled before the answer is marked. */
    function mustFill(fs, k) { return !(fs && fs[k] && fs[k].blank); }
    function typedNext(i, from) {
      var boxes = boxesFor(i), fs = S.set[i] ? typeFields(S.set[i]) : null, k, any = false;
      for (k = 0; k < boxes.length; k++) if (String(boxes[k].value).trim()) any = true;
      for (k = from + 1; k < boxes.length; k++) if (!String(boxes[k].value).trim() && (mustFill(fs, k) || !any)) { boxes[k].focus(); return true; }
      for (k = 0; k < boxes.length; k++) if (!String(boxes[k].value).trim() && (mustFill(fs, k) || !any)) { boxes[k].focus(); return true; }
      return false;
    }
    function checkTyped(i) {
      var it = S.set[i]; if (!it || it.state !== 'hid') return;
      var fs = typeFields(it); if (!fs) return;
      var boxes = boxesFor(i); if (!boxes.length) return;
      var vals = [], k;
      for (k = 0; k < boxes.length; k++) vals.push(boxVal(boxes[k]));
      for (k = 0; k < boxes.length; k++) if (!String(vals[k]).trim() && mustFill(fs, k)) { boxes[k].focus(); return; }
      if (!vals.some(function (v) { return String(v).trim(); })) { boxes[0].focus(); return; }
      var acc1 = fs.length === 1 && it.q.data && it.q.data.accepted;
      var got = fieldsRight(it, fs, vals, acc1);
      it.typed = vals.join(', ');
      it.typedHTML = stackFields(fs, function (f, j, vw) {
        /* PHONE ROUND: TYPE-IN + WALL FIT (2026-09-23): a signed box shows the sign it was given, not a printed + */
        var v = String(vals[j]).trim(), neg = v.charAt(0) === '-';
        if (f.sign && neg) v = v.slice(1);
        return { lead: f.sign ? (j || neg ? '<span class="eb-op">' + (neg ? MINUS_CH : '+') + '</span>' : '')
          : j ? '<span class="eb-op">' + (f.op || '+') + '</span>' : '',
          body: (vw.pre ? '<span class="eb-op">' + vw.pre + '</span>' : '') + '<span class="eb-tm">' + esc(v) + vw.after + '</span>' };
      }, function (h) { return '<span class="eb-op">' + h + '</span>'; });
      mark(it, got); if (!got) FX.shake = i;
      renderPractise(); renderTop();
      var nx = nextHidden();
      if (nx >= 0) { var el2 = elPr.querySelector('[data-ans="' + nx + '"]'); if (el2) el2.focus(); }
    }
    /* one question swapped for another, the rest of the set left alone */
    function freshQuestion(i) {
      var it = S.set[i]; if (!it) return;
      var ctx = { seen: {}, shapeSeen: {}, last: null };
      S.set.forEach(function (x, n) { if (n !== i && x.skill === it.skill && x.q && x.q.key) ctx.seen[x.q.key] = 1; });
      ctx.slot = slotIn(S.set, i);
      S.set[i] = makeItem(it.skill, it.level, ctx);
      FX.swap = i;
      renderPractise(); renderTop();
    }
    function choicesHTML(ch, i, picked, done) {
      var sym = ch.options.every(function (o) { return el('div', null, String(o)).textContent.trim().length <= 2; });
      return '<span class="sl-choices' + (done ? ' is-done' : '') + (sym ? ' is-sym' : '') + '">' + ch.options.map(function (o, k) {
        var cls = 'sl-choice' + (done && k === ch.answer ? ' is-right' : '') + (done && picked === k && k !== ch.answer ? ' is-wrong' : '');
        return '<button type="button" class="' + cls + '" data-choice="' + i + '" data-opt="' + k + '"' + (done ? ' disabled' : '') + '><b>' + 'ABCDEF'.charAt(k) + '</b><span>' + o + '</span></button>';
      }).join('') + '</span>';
    }
    function qcardHTML(it, i) {
      var hid = it.state === 'hid';
      var qn = it.state === 'ok' ? '<span class="sl-qn ok" aria-label="Right">' + ICON.tick + '</span>' : it.state === 'miss' ? '<span class="sl-qn miss" aria-label="Missed">' + ICON.cross + '</span>' : '<span class="sl-qn num">' + (i + 1) + '</span>';
      var stepBtn = '<button type="button" class="sl-qsteps" data-steps="' + i + '" aria-label="Steps for question ' + (i + 1) + '" data-tip="Show the steps">' + ICON.steps + '</button>' +
        '<button type="button" class="sl-qsteps sl-qfresh" data-fresh="' + i + '" aria-label="A different question ' + (i + 1) + '" data-tip="New question">' + ICON.refresh + '</button>';
      var ch = it.q.choice || null;
      var fs = hid && S.typed && !ch ? typeFields(it) : null;
      var side, typeIt = !!fs;
      /* a choice question: the options are the answer box. Tap one to mark; shown
         (Show all answers) lights the right one and offers Got it / Missed it. */
      if (ch && hid) side = choicesHTML(ch, i, null, false);
      else if (ch && it.state === 'shown') side = choicesHTML(ch, i, null, true) + '<div class="sl-vbar"></div><button type="button" class="sl-btn sl-btn--sm sl-btn--on" data-mark="1" data-i="' + i + '">' + ICON.tick + 'Got it</button><button type="button" class="sl-btn sl-btn--sm sl-btn--bad" data-mark="0" data-i="' + i + '">' + ICON.cross + 'Missed it</button>';
      else if (ch) side = choicesHTML(ch, i, it.picked, true);
      else if (typeIt) side = fieldsHTML(fs, i) +
        '<button type="button" class="sl-btn sl-btn--sm" data-check="' + i + '">' + ICON.tick + 'Check</button>';
      else if (hid) side = '<span class="sl-tapq">Tap to see the answer</span>';
      else if (it.state === 'shown') side = '<span class="sl-expr sl-ans">' + it.q.ansHTML + '</span><div class="sl-vbar"></div><button type="button" class="sl-btn sl-btn--sm sl-btn--on" data-mark="1" data-i="' + i + '">' + ICON.tick + 'Got it</button><button type="button" class="sl-btn sl-btn--sm sl-btn--bad" data-mark="0" data-i="' + i + '">' + ICON.cross + 'Missed it</button>';
      else side = (it.typed && it.state === 'miss' ? '<span class="sl-expr sl-ans bad sl-yours">' + (it.typedHTML || esc(it.typed)) + '</span>' : '') +
        '<span class="sl-expr sl-ans' + (it.state === 'miss' && !it.typed ? ' bad' : '') + '">' + it.q.ansHTML + '</span>';
      /* one-shot notes from the click that caused this render: --i places the
         card in a deal, --d places a reveal in a Show-all cascade */
      var newly = FX.newly && FX.newly[i] !== undefined;
      var fx = (FX.reveal === i || newly ? ' is-reveal' : '') + (FX.mark === i ? ' is-marked' : '') + (FX.swap === i ? ' is-swap' : '') +
        (FX.shake === i ? ' is-shake' : '') + (FX.hidden && FX.hidden[i] ? ' is-hide' : '');
      return '<div class="sl-qcard' + (hid ? ' is-hid' : '') + (typeIt ? ' is-typing' : '') + (it.state === 'shown' ? ' is-mark' : '') + fx + '" style="--c:' + colourOf(it.skill).col + ';--i:' + i + ';--d:' + (newly ? FX.newly[i] : 0) + '"' +
        (hid && !typeIt && !ch ? ' data-reveal="' + i + '" role="button" tabindex="0" aria-label="Question ' + (i + 1) + ', tap to see the answer"' : '') + '>' + qn + stepBtn +
        '<div class="sl-qmain">' + (S.from === 'mixed' ? tagHTML(it.skill) : '') + '<span class="sl-expr">' + it.q.html + '</span></div><div class="sl-qside">' + side + '</div></div>';
    }
    /* NOT practise any more (one bar, 2026-09-16): teach and the board still carry a strip */
    function prBarHTML() {
      return lvlStripHTML(
        '<button type="button" class="sl-toggle' + (S.typed ? ' is-on' : '') + '" id="slTyped" aria-pressed="' + (S.typed ? 'true' : 'false') + '" title="Type the answer instead of revealing it"><i></i>Type the answer</button>' +
        '<button type="button" class="sl-btn sl-btn--sm sl-btn--ghost" id="slChangeR">' + ICON.book + (S.from === 'mixed' ? 'Change mix' : 'All skills') + '</button>');
    }
    /* ============================================================
       PRACTISE CARDS + BOARD SETUP PREVIEW (2026-09-16)
       Aadam picked cards that open into one question. The wall is the set as
       clean cards: the number, the question, and the answer once it is marked.
       A tap opens that card as one big question with Show answer (or the
       typing boxes, or the choices), marking, the steps, a new question, and a
       strip along the foot to move between them. S.prOne is the open card,
       -1 the wall.
       ============================================================ */
    function qnHTML(it, i) {
      return it.state === 'ok' ? '<span class="sl-qn ok" aria-label="Right">' + ICON.tick + '</span>' : it.state === 'miss' ? '<span class="sl-qn miss" aria-label="Missed">' + ICON.cross + '</span>' : '<span class="sl-qn num">' + (i + 1) + '</span>';
    }
    function prFx(i) {
      var newly = FX.newly && FX.newly[i] !== undefined;
      return (FX.reveal === i || newly ? ' is-reveal' : '') + (FX.mark === i ? ' is-marked' : '') + (FX.swap === i ? ' is-swap' : '') + (FX.shake === i ? ' is-shake' : '');
    }
    function printRowHTML(it, i) {
      if (it.off) return '';
      return '<div class="sl-qcard"><span class="sl-qn num">' + (i + 1) + '</span><div class="sl-qmain">' + (S.from === 'mixed' ? tagHTML(it.skill) : '') + '<span class="sl-expr">' + it.q.html + '</span></div></div>';
    }
    /* CARD TAP + CARD TOOLS (2026-09-16). Aadam: the card is the button again, tap it to turn the
       answer over, tap it again to put it away. The three things you might do to a question sit in
       the top corner and only appear when the pointer is on the card (always, on a touch screen),
       so ten cards read as ten questions and nothing else. Hiding is about the QUESTION, not the
       answer: a hidden card is blank, so a class never sees it until it is shown again. */
    function pcardHTML(it, i) {
      var st = it.state, done = st === 'ok' || st === 'miss', newly = FX.newly && FX.newly[i] !== undefined;
      var off = !!it.off, n = i + 1;
      var tool = function (attr, label, tip, sub, icon) {
        return '<span class="wc-tool" ' + attr + ' role="button" tabindex="0" aria-label="' + label + '" data-tip="' + tip + '"' + (sub ? ' data-tipsub="' + sub + '"' : '') + '>' + icon + '</span>';
      };
      var tools = '<span class="wc-tools">' +
        (off ? '' :
          tool('data-wbq="' + i + '"', 'Question ' + n + ' on the whiteboard', 'Whiteboard', 'Work this question out on a board.', WB.pen) +
          tool('data-openq="' + i + '"', 'Open question ' + n, 'Open this question', 'The question on its own, with the steps and marking.', ICON.expand) +
          tool('data-fresh="' + i + '"', 'A different question ' + n, 'New question', 'Swaps this one for another at the same level.', ICON.refresh)) +
        tool('data-off="' + i + '"', (off ? 'Show question ' : 'Hide question ') + n, off ? 'Show this question' : 'Hide this question',
             off ? '' : 'Blanks the card, so the class does not see it.', off ? ICON.eye : ICON.eyeOff) +
        '</span>';
      var body = off
        ? '<span class="wc-q wc-blank"><span class="wc-hlab">' + ICON.eyeOff + 'Hidden</span></span><span class="wc-foot"></span>'
        : '<span class="wc-q"><span class="sl-expr">' + it.q.html + '</span></span>' +
          '<span class="wc-foot">' + (done || st === 'shown' ? '<span class="sl-expr sl-ans">' + it.q.ansHTML + '</span>' : '') + '</span>';
      var says = off ? 'Question ' + n + ', hidden. Show it'
        : st === 'ok' ? 'Question ' + n + ', right'
        : st === 'miss' ? 'Question ' + n + ', missed'
        : st === 'shown' ? 'Question ' + n + ', put the answer away'
        : 'Question ' + n + ', show the answer';
      return '<button type="button" class="sl-wallcard is-' + st + (off ? ' is-blank' : '') + prFx(i) + '" data-cardtap="' + i + '" style="--c:' + colourOf(it.skill).col + ';--i:' + i + ';--d:' + (newly ? FX.newly[i] : 0) + '" aria-label="' + says + '">' +
        '<span class="wc-top">' + qnHTML(it, i) + (S.from === 'mixed' && !off ? tagHTML(it.skill) : '') + tools + '</span>' +
        body + '</button>';
    }
    /* hidden is the tutor's own doing, so it survives a reveal or a mark; a fresh deal clears it
       because the item itself is new */
    function toggleOff(i) {
      var it = S.set[i]; if (!it) return;
      it.off = !it.off;
      renderPractise(); renderTop();
    }
    function wallHTML(enter) {
      var n = S.set.length, cols = Math.min(5, n);
      return '<div class="sl-pwall' + (enter ? ' is-enter' : '') + '" style="--cols:' + cols + ';--rows:' + Math.ceil(n / cols) + '">' + S.set.map(pcardHTML).join('') + '</div>';
    }
    function markBtnsHTML(i) {
      return '<span class="po-mark"><button type="button" class="sl-btn sl-btn--on" data-mark="1" data-i="' + i + '" data-tip="Got it" data-tipsub="Key: C">' + ICON.tick + 'Got it</button>' +
        '<button type="button" class="sl-btn sl-btn--bad" data-mark="0" data-i="' + i + '" data-tip="Missed it" data-tipsub="Key: X">' + ICON.cross + 'Missed it</button></span>';
    }
    function oneHTML(i, opened) {
      var it = S.set[i], n = S.set.length, st = it.state, ch = it.q.choice || null, done = st === 'ok' || st === 'miss';
      var fs = st === 'hid' && S.typed && !ch ? typeFields(it) : null, act;
      if (ch && st === 'hid') act = choicesHTML(ch, i, null, false);
      else if (ch && st === 'shown') act = choicesHTML(ch, i, null, true) + markBtnsHTML(i) + '<button type="button" class="sl-btn sl-btn--ghost po-hide" data-hide="' + i + '" aria-label="Hide this answer">' + ICON.eyeOff + '<span class="po-lbl">Hide</span></button>';
      else if (ch) act = choicesHTML(ch, i, it.picked, true);
      else if (fs) act = fieldsHTML(fs, i) + '<button type="button" class="sl-btn sl-btn--on po-check" data-check="' + i + '">' + ICON.tick + 'Check</button>';
      else if (st === 'hid') act = '<button type="button" class="po-show" data-reveal="' + i + '">' + ICON.eye + 'Show answer</button>';
      else if (st === 'shown') act = '<span class="sl-expr sl-ans">' + it.q.ansHTML + '</span>' + markBtnsHTML(i) + '<button type="button" class="sl-btn sl-btn--ghost po-hide" data-hide="' + i + '" aria-label="Hide this answer">' + ICON.eyeOff + '<span class="po-lbl">Hide</span></button>';
      else act = (it.typed && st === 'miss' ? '<span class="sl-expr sl-ans bad sl-yours">' + (it.typedHTML || esc(it.typed)) + '</span>' : '') +
        '<span class="sl-expr sl-ans' + (st === 'miss' ? ' bad' : ' ok') + '">' + it.q.ansHTML + '</span>';
      if (done) act += i < n - 1
        ? '<button type="button" class="sl-btn sl-btn--cta po-next" data-goto="' + (i + 1) + '">Next question' + ICON.chevR + '</button>'
        : '<button type="button" class="sl-btn sl-btn--cta po-next" data-wall="1">' + ICON.grid + 'All cards</button>';
      var tile = function (x, k) {
        var s = x.state;
        return '<button type="button" class="po-tile num' + (k === i ? ' is-now' : '') + (x.off ? ' is-blank' : '') + (s === 'ok' ? ' is-ok' : s === 'miss' ? ' is-miss' : s === 'shown' ? ' is-shown' : '') + '" data-goto="' + k + '" aria-label="Question ' + (k + 1) + (s === 'ok' ? ', right' : s === 'miss' ? ', missed' : '') + '"' + (k === i ? ' aria-current="true"' : '') + '>' +
          (s === 'ok' ? ICON.tick : s === 'miss' ? ICON.cross : '') + (k + 1) + '</button>';
      };
      return '<div class="sl-pone' + (opened ? ' is-cardopen' : '') + '">' +
        '<div class="po-meta"><span class="po-count num">Question <b>' + (i + 1) + '</b> of ' + n + '</span>' +
          (S.from === 'mixed' ? tagHTML(it.skill) : '') + '<span class="po-lvl">Level ' + it.level + ' · ' + esc(levelName(it.skill, it.level)) + '</span><span class="sl-bs-sp"></span>' +
          '<button type="button" class="sl-btn sl-btn--sm" data-wbq="' + i + '" data-tip="Whiteboard" data-tipsub="Key: W">' + WB.pen + '<span class="po-lbl">Whiteboard</span></button>' +
          '<button type="button" class="sl-btn sl-btn--sm" data-steps="' + i + '">' + ICON.steps + '<span class="po-lbl">Show the steps</span></button>' +
          '<button type="button" class="sl-btn sl-btn--sm" data-fresh="' + i + '">' + ICON.refresh + '<span class="po-lbl">New question</span></button></div>' +
        '<div class="po-stage"><div class="po-card is-' + st + prFx(i) + '" style="--c:' + colourOf(it.skill).col + '">' +
          '<div class="po-q"><span class="sl-expr">' + it.q.html + '</span></div>' +
          '<div class="po-act">' + act + '</div></div></div>' +
        '<div class="po-dock"><span class="po-dl"><button type="button" class="sl-btn po-all" data-wall="1">' + ICON.grid + '<span class="po-lbl">All cards</span></button></span>' +
          '<span class="po-nav"><button type="button" class="sl-iconbtn sl-iconbtn--sq po-arrow" data-goto="' + (i - 1) + '" aria-label="Previous question"' + (i ? '' : ' disabled') + '>' + ICON.chevL + '</button>' +
          /* PHONE ROUND 2: OPEN QUESTION FILLS THE SCREEN (2026-09-23): ten numbered tiles need about 460px, so on a phone half of
             them sat off the side behind the arrow. There the strip says where you are instead. */
          '<span class="po-pos num" aria-hidden="true"><b>' + (i + 1) + '</b> of ' + n + '</span>' +
          '<span class="po-tiles">' + S.set.map(tile).join('') + '</span>' +
          '<button type="button" class="sl-iconbtn sl-iconbtn--sq po-arrow" data-goto="' + (i + 1) + '" aria-label="Next question"' + (i < n - 1 ? '' : ' disabled') + '>' + ICON.chevR + '</button></span><span class="po-dr"></span></div>' +
        '</div>';
    }
    /* PHONE ROUND: TYPE-IN + WALL FIT (2026-09-23). The on-screen keyboard takes half a phone's screen, and the browser only
       scrolls a focused field into view when the PAGE scrolls - every Skills Lab screen scrolls inside
       a box, so a box low on the screen ended up behind the keyboard with nothing to do about it.
       On focus, once the keyboard has settled, the box is brought back above it. Does nothing where
       there is no keyboard (visualViewport unchanged), so a laptop is untouched. */
    function keepAbove(box) {
      if (!box || !window.visualViewport) return;
      setTimeout(function () {
        var vv = window.visualViewport, r = box.getBoundingClientRect(), over = r.bottom + 18 - (vv.offsetTop + vv.height), sc, sb;
        if (!(over > 0)) return;
        sc = box.closest ? box.closest('.po-stage, .sl-scroll, .sl-prscroll') : null;
        if (sc && sc.scrollHeight > sc.clientHeight + 2) { sb = sc.style.scrollBehavior; sc.style.scrollBehavior = 'auto'; sc.scrollTop += over; sc.style.scrollBehavior = sb; }
        else if (box.scrollIntoView) { try { box.scrollIntoView({ block: 'center' }); } catch (err) {} }
      }, 320);
    }
    elPr.addEventListener('focusin', function (e) {
      var b = e.target; if (b && b.classList && b.classList.contains('sl-ansin')) keepAbove(b);
    });
    function openCard(i) {
      if (!(i >= 0 && i < S.set.length)) return;
      S.prOne = i; renderPractise(); renderTop();
      /* the keyboard lands where the next press is: the typing box, or Show answer */
      var f = elPr.querySelector('.po-act [data-ans], .po-show');
      if (f) { try { f.focus({ preventScroll: true }); } catch (err) {} }
    }
    function toWall() {
      var was = S.prOne; S.prOne = -1; renderPractise(); renderTop();
      var c = elPr.querySelector('.sl-wallcard[data-cardtap="' + was + '"]');
      if (c) { try { c.focus({ preventScroll: true }); } catch (err) {} }
    }
    /* The type on a card, and on the open question, is as big as its box lets it be. A sum or an
       expression stays on one line down to 60% and only then wraps (a chain broken before a "+" is
       harder to add up); words wrap from the start. Every box searches at once, seven halvings a
       pass, so a pass costs seven layouts. A box that grows to fit (a phone's cards) is only held
       to its width. */
    var PFIT_MIN = 0.34;
    /* SMARTBOARD PRACTISE CARDS (2026-09-21): a board's answer strip is taller, so its answer can be read from the
       back. On a wall of tall questions (tables, long sentences) that height is worth more to the questions: when three
       or more cards' questions have had to shrink to their height, the strip goes back to its old height and the wall
       is fitted again. */
    /* PHONE ROUND: TYPE-IN + WALL FIT (2026-09-23). Aadam, 2026-09-23: "some of the place value ordering questions can't be
       seen properly - need to fix their layouts so they work with mobiles of different sizes".
       Two (or three) cards to a row is right for a sum and wrong for a table: a five-column table
       in a 170px card fitted its labels at 7px, and every skill with a note, a word problem or a
       chart under the question did the same. A card is measured, not guessed at: if its question's
       own type falls under 15px, or ANY text inside it under 10px, the card takes the whole row and
       is fitted again at that width; if it is still under, the card grows downwards, which a
       scrolling wall can afford and a fixed grid cannot. Nothing changes above 860px. */
    var PW_MAIN = 15, PW_LEAF = 10;
    function flowWall() { try { return window.innerWidth <= 860; } catch (e) { return false; } }
    /* a superscript index is a mark, not text to read: the 2 in x² is 0.6em by design and would
       otherwise drag every algebra card under the floor on its own */
    function isMark(e) {
      if (e.tagName === 'SUP' || e.tagName === 'SUB') return true;
      var va = window.getComputedStyle(e).verticalAlign;
      return va === 'super' || va === 'sub';
    }
    function leafMin(box) {
      var min = 99;
      each(box.querySelectorAll('*'), function (e) {
        if (e.children.length || !(e.textContent || '').trim()) return;
        if (!e.offsetWidth && !e.offsetHeight) return;
        var cs = window.getComputedStyle(e), f;
        if (cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return;
        if (isMark(e) || (e.parentNode && e.parentNode.nodeType === 1 && isMark(e.parentNode))) return;
        f = parseFloat(cs.fontSize); if (f && f < min) min = f;
      });
      return min;
    }
    /* 0 when the card reads, else how far under the floor it is (0.5 = half the size it needs) */
    function underFloor(q) {
      var ex = q.querySelector('.sl-expr'); if (!ex) return 0;
      var r = Math.min((parseFloat(window.getComputedStyle(ex).fontSize) || 99) / PW_MAIN, leafMin(q) / PW_LEAF);
      /* 0.999, not 0.995: a question at 14.94px sat inside the old half-percent slack, was never widened, and
         read 14.9px on a 390 phone (completing the square L10, "Solve 3x2 + 24x = -18" and longer, 2026-09-26) */
      return r < 0.999 ? Math.max(r, 0.2) : 0;
    }
    function phoneWall(wall) {
      var again = false;
      each(wall.querySelectorAll('.sl-wallcard'), function (c) {
        if (c.classList.contains('is-blank')) return;
        var q = c.querySelector('.wc-q'), ex = q && q.querySelector('.sl-expr'), r = q ? underFloor(q) : 0, k, need;
        if (!ex || !r) return;
        if (!c.classList.contains('is-wide')) { c.classList.add('is-wide'); again = true; return; }
        if (ex.classList.contains('is-sumline') && !c.classList.contains('is-wrapsum')) { c.classList.add('is-wrapsum'); again = true; return; }
        k = parseFloat(ex.style.getPropertyValue('--k')) || 1;
        /* a tenth over what it needs, so a card 0.1px under the floor still buys the room to
           clear it and the second fit is not a no-op */
        ex.style.setProperty('--k', (k * Math.min(2.4, 1.1 / r)).toFixed(3));
        need = Math.ceil(Math.max(ex.offsetHeight, ex.scrollHeight)) + 6;
        ex.style.setProperty('--k', k.toFixed(3));
        need = Math.min(Math.max(need, Math.ceil(q.clientHeight * 1.06)), Math.round((window.innerHeight || 700) * 0.62));
        if (need > q.clientHeight) { q.style.minHeight = need + 'px'; again = true; }
      });
      return again;
    }
    function fitPractise() {
      var wall = elPr.querySelector('.sl-pwall'), tall = 0, pass;
      if (wall) wall.classList.remove('is-tallq');
      if (wall && flowWall()) each(wall.querySelectorAll('.sl-wallcard'), function (c) {
        c.classList.remove('is-wide', 'is-wrapsum');
        var q = c.querySelector('.wc-q'); if (q) q.style.removeProperty('min-height');
      });
      fitCards();
      if (wall && flowWall()) {
        for (pass = 0; pass < 3 && phoneWall(wall); pass++) fitCards();
        /* the height was bought against the size the card WANTED; once it has been fitted at that
           height, give back whatever the question did not use, so a card is never mostly air */
        each(wall.querySelectorAll('.sl-wallcard.is-wide'), function (c) {
          var q = c.querySelector('.wc-q'), ex = q && q.querySelector('.sl-expr'), had, want;
          if (!q || !ex || !q.style.minHeight) return;
          had = parseFloat(q.style.minHeight) || 0;
          want = Math.ceil(Math.max(ex.offsetHeight, ex.scrollHeight)) + 8;
          if (want < had) q.style.minHeight = want + 'px';
        });
      }
      floorType(elPr);
      if (wall && window.innerWidth > 860) {
        each(wall.querySelectorAll('.wc-q'), function (b) {
          var ex = b.querySelector('.sl-expr'), k = ex ? parseFloat(ex.style.getPropertyValue('--k')) || 1 : 1;
          if (ex && k < 0.97 && ex.offsetHeight >= b.clientHeight * 0.85) tall++;
        });
        if (tall >= 3) { wall.classList.add('is-tallq'); fitCards(); }
      }
      watchPoQ();
    }
    /* the open question's box is what is left after its answer row, and that row can change after the fit (a web font
       landing re-wraps long choices), so the box is watched and the question fitted again when its height moves */
    var poRO = null, poH = 0;
    function watchPoQ() {
      if (!window.ResizeObserver) return;
      var q = elPr.querySelector('.po-q');
      if (!poRO) poRO = new ResizeObserver(function () {
        var q2 = elPr.querySelector('.po-q');
        if (q2 && Math.abs(q2.clientHeight - poH) > 2) { poH = q2.clientHeight; refitCards(); }
      });
      poRO.disconnect();
      if (q) { poH = q.clientHeight; poRO.observe(q); }
    }
    function fitCards() {
      var todo = [];
      /* SMARTBOARD PRACTISE CARDS (2026-09-21): kind = wq/wa (a card's question/answer), pq/pa (the open question's);
         a question drawn as patterns (matchsticks) is a picture, not a sentence, so it gets is-pics and no word sizing */
      function add(box, ex, useH, tight, kind) {
        if (!box || !ex) return;
        ex.style.removeProperty('--k'); ex.classList.remove('is-sumline', 'is-cswrap');
        if (tight || kind === 'pa') box.classList.remove('is-ans2');
        var pics = !!ex.querySelector('.sq-pats');
        var words = !pics && (!!ex.querySelector('.ct-words, .pt-words, .pv-w, .pv-two') || /[a-z]{3,}/i.test(ex.textContent.replace(/\b(?:sqrt|surd)\b/gi, '')));
        ex.classList.toggle('is-wordq', words); ex.classList.toggle('is-pics', pics);
        /* PHONE ROUND 3: TEACH + BOARD ON A PHONE (2026-09-23): a card marked is-wrapsum has already been given the whole row
           and its height and is STILL under the floor, so its sum is allowed to wrap between terms */
        if (!words && !(box.parentNode && box.parentNode.classList && box.parentNode.classList.contains('is-wrapsum'))) ex.classList.add('is-sumline');
        todo.push({ box: box, ex: ex, h: useH, words: words, pics: pics, tight: !!tight, kind: kind });
      }
      each(elPr.querySelectorAll('.sl-wallcard'), function (c) {
        add(c.querySelector('.wc-q'), c.querySelector('.wc-q > .sl-expr'), true, false, 'wq');
        add(c.querySelector('.wc-foot'), c.querySelector('.wc-foot > .sl-ans'), false, true, 'wa');
      });
      var po = elPr.querySelector('.po-card');
      if (po) {
        add(po.querySelector('.po-q'), po.querySelector('.po-q > .sl-expr'), true, false, 'pq');
        each(po.querySelectorAll('.po-act > .sl-ans'), function (a) { add(po.querySelector('.po-act'), a, false, false, 'pa'); });
      }
      todo = todo.filter(function (t) { return t.box.clientWidth > 0; });
      if (!todo.length) return;
      /* clientWidth counts the padding, and a tight row (the card's answer strip) also shares its
         width with the hide button, so both come off before anything is measured against it */
      function avail(t) {
        var cs = window.getComputedStyle(t.box), w = t.box.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
        if (t.tight) {
          var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0, ch = t.box.children, k;
          for (k = 0; k < ch.length; k++) if (ch[k] !== t.ex) w -= ch[k].offsetWidth + gap;
        }
        return Math.max(40, w);
      }
      /* SMARTBOARD PRACTISE CARDS: the content's own rectangle is measured too, since offsetHeight and scrollWidth
         round to whole pixels (a six-line question 1.6px taller than its card read as fitting) */
      function fits(t) {
        if (t.ex.scrollWidth > avail(t) + 1) return false;
        var rg = document.createRange(), r;
        rg.selectNodeContents(t.ex); r = rg.getBoundingClientRect();
        if (r.width > avail(t) + 0.5) return false;
        return !t.h || Math.max(t.ex.offsetHeight, r.height) <= innerH(t) + 0.5;
      }
      /* a wrapped answer on a card's strip: as wide as the strip, and at most t.lines lines (the strip grows) */
      function fitsLines(t) {
        if (t.ex.scrollWidth > avail(t) + 1) return false;
        var cs = window.getComputedStyle(t.ex), bs = window.getComputedStyle(t.box);
        var lh = parseFloat(cs.lineHeight) || (parseFloat(cs.fontSize) || 16) * 1.15;
        var inner = t.box.clientHeight - (parseFloat(bs.paddingTop) || 0) - (parseFloat(bs.paddingBottom) || 0);
        return t.ex.offsetHeight <= Math.min(inner, lh * t.lines) + 1;
      }
      /* a verb question wrapped (is-cswrap): fits as before, and every term after the verb is on one row */
      function fitsCsWrap(t) {
        if (!fits(t)) return false;
        var kids = t.ex.firstElementChild.children, a = null, r, k;
        for (k = 1; k < kids.length; k++) {
          r = kids[k].getBoundingClientRect(); if (!r.width) continue;
          if (!a) { a = r; continue; }
          if (r.top >= a.bottom - 1 || r.bottom <= a.top + 1) return false;
        }
        return true;
      }
      function search(list, floor, test, ceil) {
        list.forEach(function (t) { t.lo = floor(t); t.hi = ceil ? ceil(t) : 1; });
        for (var r = 0; r < 7; r++) {
          list.forEach(function (t) { t.k = (t.lo + t.hi) / 2; t.ex.style.setProperty('--k', t.k.toFixed(3)); });
          list.forEach(function (t) { if ((test || fits)(t)) t.lo = t.k; else t.hi = t.k; });
        }
        list.forEach(function (t) { t.ex.style.setProperty('--k', t.lo.toFixed(3)); });
      }
      /* SMARTBOARD PRACTISE CARDS (2026-09-21). Aadam: "imagine it will be on a smartboard ... if you can make it larger
         without obstructing do so". Type used to stop at its CSS size, so a short sum sat small in a big card. Whatever
         fits now GROWS until its box is nearly full (the box's side padding and a tenth of its height kept as air), up to
         a ceiling tied to the screen height, so "7 + 5" is big but not absurd; sentences stop sooner than sums. A box
         that grows with its content (the scrolling wall under 861px, the open card on a phone) keeps its CSS size. */
      var vh = window.innerHeight || 800, flow = !!(window.matchMedia && window.matchMedia('(max-width: 860px)').matches), phone = narrow();
      function innerH(t) {
        var bs = window.getComputedStyle(t.box);
        return t.box.getBoundingClientRect().height - (parseFloat(bs.borderTopWidth) || 0) - (parseFloat(bs.borderBottomWidth) || 0) -
          (parseFloat(bs.paddingTop) || 0) - (parseFloat(bs.paddingBottom) || 0);
      }
      function capOf(t) {
        /* PHONE ROUND 2: OPEN QUESTION FILLS THE SCREEN (2026-09-23): the open card now fills a phone's screen, so the
           question is allowed to grow into it - it is the one thing being looked at. The wall's
           cards still keep their CSS size when they flow, since there the space is the next card's. */
        var ih = innerH(t), c = t.kind === 'wq' ? (flow ? 0 : Math.min(vh * 0.1, ih * 0.34))
          : t.kind === 'wa' ? (flow ? 0 : ih * 0.64)
          : t.kind === 'pq' ? (phone ? Math.min(vh * 0.12, ih * 0.34) : Math.min(vh * 0.13, ih * 0.3))
          : t.kind === 'pa' ? (phone ? vh * 0.075 : vh * 0.092) : 0;
        return t.words ? c * 0.74 : c;
      }
      /* fits, with air: a question keeps a tenth of its box's height free and a one-line sum keeps off the card's
         sides (a sentence or a picture wraps, so it is only held to fitting); an answer stays off its strip's edges */
      function roomy(t) {
        if (!fits(t)) return false;
        var rg = document.createRange(), r, h;
        rg.selectNodeContents(t.ex); r = rg.getBoundingClientRect(); h = Math.max(t.ex.offsetHeight, r.height);
        if (t.h) return (t.words || t.pics || r.width <= avail(t) * 0.93) && h <= innerH(t) * 0.9;
        if (r.width > avail(t) * 0.94 + 1) return false;
        return t.kind !== 'wa' || h <= innerH(t) * 0.9 + 1;
      }
      function grow(list) {
        list = list.filter(function (t) {
          t.b = parseFloat(window.getComputedStyle(t.ex).fontSize) || 16; t.kmax = capOf(t) / t.b;
          return t.kmax > 1.03 && roomy(t);
        });
        if (list.length) search(list, function () { return 1; }, roomy, function (t) { return t.kmax; });
        list.forEach(function (t) { t.gf = t.b * t.lo; });
      }
      /* LONG ANSWERS ON TWO LINES (2026-09-21). Aadam: "if the answer is v long - fit onto two lines and make
         the text larger". A card's answer strip was one line, so a number in words shrank to the floor and was
         still cut off. A words answer that would have to shrink wraps instead: two lines, a third only when two
         would be under 15px, and more (up to six, on a phone's narrow card) only while it is under 13px (a
         263px card's twelve-word number is 10px on two lines). The strip grows to hold it, and this runs before the questions are fitted, so each
         question is sized to the space that is left. */
      function fitLong(t) {
        var k1, f1, fit1, base, room = innerH(t) - 12, lift;
        search([t], function () { return PFIT_MIN; });
        k1 = t.lo; fit1 = fits(t); base = (parseFloat(window.getComputedStyle(t.ex).fontSize) || 16) / k1;
        /* SMARTBOARD PRACTISE CARDS: n lines may be as big as n lines fill the strip's own height, so on a board the
           strip holds two big lines rather than one small one, and does not grow */
        lift = function (n) { return (t.kind === 'pa' ? phone : flow) ? 1 : Math.max(1, room / (n * 1.16) / base); };
        if (fit1 && k1 >= 0.8 && lift(2) <= k1 * 1.08) return;
        f1 = base * k1;
        t.box.classList.add('is-ans2');
        for (var n = 2; n <= 6; n++) {
          t.lines = n; search([t], function () { return PFIT_MIN; }, fitsLines, function () { return lift(n); });
          if (fitsLines(t) && base * t.lo >= (n === 2 ? 15 : 13)) break;
        }
        if (fit1 && base * t.lo <= f1 * 1.08) { t.box.classList.remove('is-ans2'); t.ex.style.setProperty('--k', k1.toFixed(3)); }
      }
      /* SMARTBOARD PRACTISE CARDS: a list of numbers ("980,000, 98,000, 9,800") wraps between its numbers like words do */
      var longs = todo.filter(function (t) { return (t.tight || t.kind === 'pa') && (t.words || /\d, /.test(t.ex.textContent)) && !fits(t); });
      longs.forEach(fitLong);
      todo = todo.filter(function (t) { return longs.indexOf(t) < 0; });
      /* answers first, because the open question's answer takes its room from the question */
      grow(todo.filter(function (t) { return !t.h; }));
      grow(todo.filter(function (t) { return t.h; }));
      /* ten cards read as one set: on the wall a short question stops at 1.2 times the middle size of its sort */
      ['s', 'w', 'p'].forEach(function (y) {
        var g = todo.filter(function (t) { return t.kind === 'wq' && (t.pics ? 'p' : t.words ? 'w' : 's') === y; }), fs, top;
        if (g.length < 3) return;
        fs = g.map(function (t) { return t.gf || t.b || 0; }).sort(function (a, b) { return a - b; });
        top = fs[Math.floor((fs.length - 1) / 2)] * 1.2;
        g.forEach(function (t) { if (t.gf && t.gf > top) t.ex.style.setProperty('--k', (t.lo * top / t.gf).toFixed(3)); });
      });
      var over = todo.filter(function (t) { return !fits(t); });
      if (!over.length) return;
      search(over, function (t) { return t.words ? PFIT_MIN : 0.6; });
      /* a sum that still does not fit at 60% on one line may wrap, and comes down again from there */
      var wrap = over.filter(function (t) { return !t.words && !fits(t); });
      wrap.forEach(function (t) { t.ex.classList.remove('is-sumline'); t.ex.style.removeProperty('--k'); });
      wrap = wrap.filter(function (t) { return !fits(t); });
      if (wrap.length) search(wrap, function () { return PFIT_MIN; });
      /* VERB QUESTIONS WRAP (2026-09-21). A cs-q question that opens with its verb ("Second difference and coefficient of
         n²", "nth term", "Which term of") and had to shrink hard, or never fitted, tries the verb on its own line
         with the terms under it, and keeps that when the type comes out bigger or one line never fitted. */
      var csw = over.filter(function (t) {
        var q = t.h && t.words ? t.ex.firstElementChild : null;
        return q && q.classList.contains('cs-q') && q.firstElementChild && q.firstElementChild.classList.contains('cs-verb') && (t.lo < 0.8 || !fits(t));
      });
      if (!csw.length) return;
      csw.forEach(function (t) { t.k1 = t.lo; t.fit1 = fits(t); t.ex.classList.add('is-cswrap'); });
      search(csw, function () { return PFIT_MIN; }, fitsCsWrap);
      csw.forEach(function (t) {
        if (!t.fit1 || t.lo > t.k1 * 1.08) return;
        t.ex.classList.remove('is-cswrap'); t.ex.style.setProperty('--k', t.k1.toFixed(3));
      });
    }
    var cardFitT = null, prRO = null;
    function refitCards() {
      if (!shell.classList.contains('is-on')) return;
      clearTimeout(cardFitT);
      cardFitT = setTimeout(function () {
        if (S.screen === 'practise') fitPractise();
        else if (S.screen === 'boardsetup') { var h = $('slBsPrev'); if (h && S.board.cols.length) bsDraw(h); }
      }, 120);
    }
    /* the top bar wraps once its font lands, which takes height off the cards: watch the screen */
    function watchPractise() {
      if (prRO || !window.ResizeObserver) return;
      var lw = 0, lh = 0;
      prRO = new ResizeObserver(function () {
        var w = elPr.clientWidth, h = elPr.clientHeight;
        if (!w || (Math.abs(w - lw) < 2 && Math.abs(h - lh) < 2)) return;
        lw = w; lh = h; refitCards();
      });
      prRO.observe(elPr);
    }
    var prKeys = [], prWas = -2;
    function renderPractise() {
      if (!S.set.length) buildSet();
      /* a fresh deal (New 10, a level change) rises in; one swapped question, a
         reveal or a mark leaves the list where it is */
      var keys = S.set.map(function (it) { return it.q && it.q.key; }), enter = entering || diffCount(prKeys, keys) > 1;
      prKeys = keys;
      if (!(S.prOne < S.set.length)) S.prOne = -1;
      var switched = prWas !== S.prOne; prWas = S.prOne;
      /* the print sheet reads a plain list, rendered under the view and hidden on screen */
      var print = S.set.length ? '<div class="sl-qlist sl-prprint" aria-hidden="true">' + S.set.map(printRowHTML).join('') + '</div>' : '';
      var view = !S.set.length ? '<div class="sl-empty">Pick a skill first.</div>' : S.prOne >= 0 ? oneHTML(S.prOne, switched && !entering) : wallHTML(enter || switched);
      var sk0 = curSkill(), pT = S.from === 'mixed' ? 'Mixed practice' : esc(sk0 ? sk0.name : 'Skills Lab');
      var pS = S.from === 'mixed' ? mixSkills().map(function (x) { return esc(x.short || x.name); }).join(' · ') : esc(levelWord(sk0));
      var head = '<div class="sl-print-head">' + logoHTML('sl-logo--sheet') + '<div class="ph-l"><b>' + pT + '</b><span>' + pS + '</span></div>' +
        '<div class="ph-r"><span>Name</span><i></i><span>Date</span><i class="sm"></i></div></div>';
      paint(elPr, '<div class="sl-main"><div class="sl-scroll sl-prscroll">' + head + print + view + '</div></div>');
      if (narrow()) prPhoneFit();
      fitPractise(); watchPractise();
      FX.reveal = FX.mark = FX.swap = FX.shake = undefined; FX.newly = FX.hidden = null;
    }
    /* On a phone: bring the level in use into the chip row's view, and fit each
       card's sum on one line (shrinking to 70% at most, then it may wrap). A
       chain broken with a "+" at the start of its second line is harder to
       add up than a slightly smaller one. Sentences are left to wrap. */
    function prPhoneFit() {
      var row = elTop.querySelector('.sl-prchips .sl-lvlchips'), now = row && row.querySelector('.sl-chip--now');
      if (row && now) row.scrollLeft = Math.max(0, now.offsetLeft - row.offsetLeft - row.clientWidth / 2 + now.offsetWidth / 2);
      each(elPr.querySelectorAll('.sl-qcard .sl-qmain > .sl-expr'), function (ex) {
        ex.style.fontSize = ''; ex.classList.remove('is-wrap', 'is-fit');
        if (ex.querySelector('.ct-words') || /[a-z]{3,}/i.test(ex.textContent.replace(/\b(?:sqrt|surd)\b/gi, ''))) return;
        ex.classList.add('is-fit');
        var room = ex.parentNode.clientWidth - 4, need = ex.scrollWidth;
        if (!room || need <= room) return;
        var f = Math.max(0.7, room / need);
        ex.style.fontSize = (parseFloat(getComputedStyle(ex).fontSize) * f).toFixed(1) + 'px';
        if (ex.scrollWidth > room + 1) ex.classList.add('is-wrap');
      });
    }
    function lastLive() {
      var i, hit = -1;
      for (i = 0; i < S.set.length; i++) if (S.set[i].state === 'shown') hit = i;
      if (hit < 0) for (i = 0; i < S.set.length; i++) if (S.set[i].state !== 'hid') hit = i;
      return hit;
    }
    function nextHidden() { for (var i = 0; i < S.set.length; i++) if (S.set[i].state === 'hid') return i; return -1; }
    function revealOne(i) {
      var it = S.set[i]; if (!it || it.state !== 'hid') return;
      it.state = 'shown'; FX.reveal = i;
      renderPractise(); renderTop();
    }
    function revealAll() {
      var d = 0; FX.newly = {};
      S.set.forEach(function (it, i) { if (it.state === 'hid') { it.state = 'shown'; FX.newly[i] = d++; } });
      renderPractise(); renderTop();
    }
    /* PRACTISE HIDE ONE + ONE BAR (2026-09-16)
       ONE question's answer put away again, the rest of the set left as it is (Aadam).
       Marked questions are not offered it: the tick is the record, and re-hiding one would leave a
       card that cannot be answered again. */
    function hideOne(i) {
      var it = S.set[i]; if (!it || it.state !== 'shown') return;
      it.state = 'hid'; FX.hidden = {}; FX.hidden[i] = 1;
      renderPractise(); renderTop();
    }
    /* put the answers away again. A question already marked keeps its answer and its tick. */
    function hideAll() {
      FX.hidden = {};
      S.set.forEach(function (it, i) { if (it.state === 'shown') { it.state = 'hid'; FX.hidden[i] = 1; } });
      renderPractise(); renderTop();
    }
    function anyHidden() { return S.set.some(function (it) { return it.state === 'hid'; }); }
    function anyShown() { return S.set.some(function (it) { return it.state === 'shown'; }); }
    elPr.addEventListener('click', function (e) {
      var tool = e.target.closest ? e.target.closest('[data-hide],[data-off],[data-openq],[data-fresh],[data-wbq]') : null;
      if (tool) {
        e.preventDefault(); e.stopPropagation();
        if (tool.hasAttribute('data-wbq')) { WB.open('practise', Number(tool.getAttribute('data-wbq'))); return; }
        if (tool.hasAttribute('data-hide')) hideOne(Number(tool.getAttribute('data-hide')));
        else if (tool.hasAttribute('data-off')) toggleOff(Number(tool.getAttribute('data-off')));
        else if (tool.hasAttribute('data-openq')) openCard(Number(tool.getAttribute('data-openq')));
        else freshQuestion(Number(tool.getAttribute('data-fresh')));
        return;
      }
      /* the card itself: the answer over, and back again */
      var tap = e.target.closest ? e.target.closest('[data-cardtap]') : null;
      if (tap) {
        var ti = Number(tap.getAttribute('data-cardtap')), tit = S.set[ti];
        if (!tit) return;
        if (tit.off) toggleOff(ti);
        /* PHONE ROUND: TYPE-IN + WALL FIT (2026-09-23). Aadam, 2026-09-23: "can't see it on the phone app". With typing on,
           the box lives on the open question, and the only way in was a hover-only tool - so on a
           phone Type the answer looked broken. A tap on a card that can be typed now OPENS it. */
        else if (tit.state === 'hid' && S.typed && canType(tit)) openCard(ti);
        else if (tit.state === 'hid') revealOne(ti);
        else if (tit.state === 'shown') hideOne(ti);
        else openCard(ti);
        return;
      }
      var t = e.target.closest ? e.target.closest('button') : null;
      if (!t) {
        var card = e.target.closest ? e.target.closest('.sl-qcard[data-reveal]') : null;
        if (card) revealOne(Number(card.getAttribute('data-reveal')));
        return;
      }
      if (t.hasAttribute('data-wall')) { toWall(); return; }
      if (t.hasAttribute('data-goto')) { openCard(Number(t.getAttribute('data-goto'))); return; }
      if (t.hasAttribute('data-reveal')) { revealOne(Number(t.getAttribute('data-reveal'))); return; }
      var topic = t.closest('.sl-topic');
      if (topic && t.getAttribute('data-togglelvl')) {
        var sk = SL.get(topic.getAttribute('data-topic'));
        if (partlyMarked() && !window.confirm('Change the levels and deal fresh questions? The marks on this set will go.')) return;
        toggleSel(sk, Number(t.getAttribute('data-togglelvl')));
        redealSkill(sk); renderPractise(); renderTop(); return;
      }
      if (t.id === 'slTyped') { S.typed = !S.typed; save(); renderPractise(); renderTop(); return; }
      if (t.hasAttribute('data-check')) { checkTyped(Number(t.getAttribute('data-check'))); return; }
      /* PHONE ROUND: TYPE-IN + WALL FIT (2026-09-23) */
      if (t.hasAttribute('data-sign')) {
        setSign(t, t.getAttribute('data-v') === '-' ? '+' : '-');
        var sb = t.parentNode.querySelector('.sl-ansin[data-af="' + t.getAttribute('data-sign').split(':')[1] + '"]');
        if (sb) { try { sb.focus({ preventScroll: true }); } catch (err) {} }
        return;
      }
      if (t.hasAttribute('data-choice')) {
        var ci = Number(t.getAttribute('data-choice')), ck = Number(t.getAttribute('data-opt')), cit = S.set[ci];
        if (cit && cit.state === 'hid' && cit.q.choice) { cit.picked = ck; var right = ck === cit.q.choice.answer; mark(cit, right); if (!right) FX.shake = ci; renderPractise(); renderTop(); }
        return;
      }
      if (t.hasAttribute('data-fresh')) { freshQuestion(Number(t.getAttribute('data-fresh'))); return; }
      if (t.id === 'slChangeR') { if (S.from === 'mixed') show('mixed'); else changeSkill(); return; }
      if (t.hasAttribute('data-mark')) { mark(S.set[Number(t.getAttribute('data-i'))], t.getAttribute('data-mark') === '1'); renderPractise(); renderTop(); return; }
      if (t.hasAttribute('data-steps')) { S.teach.i = Number(t.getAttribute('data-steps')); S.teach.back = 'practise'; show('teach'); return; }
    });
    elPr.addEventListener('keydown', function (e) {
      var hk = e.target.closest ? e.target.closest('[data-hide],[data-off],[data-openq],[data-fresh],[data-wbq]') : null;
      if (hk && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault(); e.stopPropagation();
        if (hk.hasAttribute('data-wbq')) { WB.open('practise', Number(hk.getAttribute('data-wbq'))); return; }
        if (hk.hasAttribute('data-hide')) hideOne(Number(hk.getAttribute('data-hide')));
        else if (hk.hasAttribute('data-off')) toggleOff(Number(hk.getAttribute('data-off')));
        else if (hk.hasAttribute('data-openq')) openCard(Number(hk.getAttribute('data-openq')));
        else freshQuestion(Number(hk.getAttribute('data-fresh')));
        return;
      }
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-ans')) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var qi = Number(e.target.getAttribute('data-ans')), fi = Number(e.target.getAttribute('data-af') || 0);
          if (!typedNext(qi, fi)) checkTyped(qi);
        }
        /* PHONE ROUND: TYPE-IN + WALL FIT (2026-09-23): a minus typed into a signed box moves the button, it is never
           typed into the box (so "-" and a - button can never both be counted) */
        else if ((e.key === '-' || e.key === '\u2212' || e.key === '+') && signBtn(e.target)) {
          e.preventDefault(); setSign(signBtn(e.target), e.key === '+' ? '+' : '-');
        }
        return;
      }
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest ? e.target.closest('.sl-qcard[data-reveal]') : null;
      if (!card || e.target.tagName === 'BUTTON') return;
      e.preventDefault(); revealOne(Number(card.getAttribute('data-reveal')));
    });

    /* ============================================================
       TEACH
       ============================================================ */
    var elTe = $('slTeach'), teachHost = null;
    /* Practise deals the set in turn: skill A, skill B, skill A... Teaching wants
       the opposite - work up the levels, easiest first - so teach walks its own
       order over the same set. Only the order changes, never the questions. */
    function teachOrder() {
      var idx = S.set.map(function (x, i) { return i; });
      var levels = {}, skills = {};
      S.set.forEach(function (x) { levels[x.level] = 1; skills[x.skill.id] = 1; });
      if (Object.keys(levels).length < 2 && Object.keys(skills).length < 2) return idx;
      return idx.sort(function (a, b) {
        var x = S.set[a], y = S.set[b];
        return (x.level - y.level) || x.skill.name.localeCompare(y.skill.name) || (a - b);
      });
    }
    function teachPos(order) { var p = order.indexOf(S.teach.i); return p < 0 ? 0 : p; }
    function renderTeach() {
      destroyChorus();
      /* Count together lives in Teach now, not Board (Aadam, 2026-09-15): the whole screen becomes the count */
      if (S.teach.chorus && chorusOK()) {
        destroyTeach();
        paint(elTe, '<div class="sl-main sl-teach-chorus"><div class="sl-chorus-host" id="slChorusHost"></div></div>', mountChorus);
        return;
      }
      /* the mixed level is not taught: Teach deals from the chosen levels without it */
      if (S.teach.back !== 'practise' && stripMixForTeach()) { buildSet(); S.teach.i = 0; }
      if (!S.set.length) buildSet();
      if (!S.set.length) { elTe.innerHTML = '<div class="sl-main"><div class="sl-empty">Pick a skill first.</div></div>'; return; }
      S.teach.i = Math.max(0, Math.min(S.set.length - 1, S.teach.i));
      var order = teachOrder(), pos = teachPos(order);
      var it = S.set[S.teach.i], sk = it.skill, lv = it.level, last = pos >= order.length - 1;
      var list = order.map(function (i) {
        var x = S.set[i];
        var tick = x.state === 'ok' ? '<span class="rtick">' + ICON.tick + '</span>' : x.state === 'miss' ? '<span class="rtick miss">' + ICON.cross + '</span>' : '';
        return '<div class="sl-rrowwrap"><button type="button" class="sl-rrow' + (i === S.teach.i ? ' is-now' : '') + '" data-tq="' + i + '"' + tipAttrs(x.skill, x.level) + '><span class="rnum num">' + (order.indexOf(i) + 1) + '</span><span class="rq sl-expr" style="font-weight:700">' + x.q.html + '</span>' + tick + '</button>' +
          '<button type="button" class="sl-qrefresh" data-refresh="' + i + '" aria-label="New question ' + (i + 1) + '" data-tip="New question">' + ICON.refresh + '</button></div>';
      }).join('');
      /* TEACH ON EVERY PHONE (2026-10-19): the Questions row and the level chips row go, and the board gets
         their height. Previous and next flank the question; a tap on the question opens the list (the rail)
         as a sheet; the top bar's level line opens the levels as a sheet (phoneSheetsHTML). Laptops and
         boards keep the rail and the chips as they were. */
      var ph = narrow();
      var prevBtn = '<button type="button" class="sl-iconbtn sl-iconbtn--sq" id="slTPrev" aria-label="Previous question" title="Previous question"' + (pos === 0 ? ' disabled' : '') + '>' + ICON.chevL + '</button>';
      var rail = '<button type="button" class="sl-rail-title sl-drawer" id="slListToggle" aria-expanded="' + (S.teach.listOpen ? 'true' : 'false') + '">Questions 1 to ' + S.set.length + ' ' + ICON.chevD + '</button>' +
        '<div class="sl-teach-rail-q' + (S.teach.listOpen ? '' : ' is-closed') + '">' + list +
          '<button type="button" class="sl-btn sl-btn--ghost sl-btn--sm" id="slTeachNewAll" style="margin-top:6px" data-tip="Refresh all questions" data-tipsub="Key: N">' + ICON.refresh + 'Refresh all questions</button></div>' +
        (ph ? '' : '<div class="navrow">' + prevBtn +
        '<button type="button" class="sl-btn" id="slTNext">' + (last ? 'New set' : 'Next in this set') + ICON.chevR + '</button></div>');
      var qnext = '<button type="button" class="sl-iconbtn sl-iconbtn--sq" id="slTNext" aria-label="' + (last ? 'New set' : 'Next question') + '" title="' + (last ? 'New set' : 'Next question') + '">' + ICON.chevR + '</button>';
      var qx = '<span class="sl-expr tqx">' + it.q.html + '</span>';
      var qrow = ph ? prevBtn + '<button type="button" class="sl-tqopen" id="slTQList" aria-expanded="' + (S.teach.listOpen ? 'true' : 'false') + '" aria-label="Questions 1 to ' + S.set.length + '">' + qx + ICON.chevD + '</button>' + qnext : qx;
      var mode = '<div class="sl-segwrap" data-mo-group="tmode"><button type="button" class="sl-seg' + (S.teach.mode === 'step' ? ' is-on' : '') + '" data-tmode="step">' + ICON.steps + 'Step by step</button><button type="button" class="sl-seg' + (S.teach.mode === 'answer' ? ' is-on' : '') + '" data-tmode="answer">' + ICON.eye + 'Answer only</button></div>';
      var main = '<div class="sl-teach-main">' +
        '<div class="sl-teach-head show-sm"><b>' + esc(sk.name) + '</b><span>Level ' + lv + ': ' + esc(levelName(sk, lv)) + '</span>' +
          (S.teach.back === 'practise' ? '<button type="button" class="sl-btn sl-btn--sm sl-btn--ghost" id="slBackPr">' + ICON.list + 'Back to practise</button>' : '<button type="button" class="sl-btn sl-btn--sm sl-btn--ghost" id="slChangeT">' + ICON.book + 'All skills</button>') + '</div>' +
        lvlStripHTML() +
        '<div class="sl-teach-bar">' + mode + teachOptsHTML(sk, lv) + '<div class="sl-steps" id="slTSteps"></div></div>' +
        /* the question itself, big, over the model: which one you are on was
           only readable in the list down the left, and on a phone the list is
           shut. It sits with the model, not in the chrome, so nobody has to
           look away from the thing they are working on. */
        '<div class="sl-teach-q' + (entering ? '' : ' is-fresh') + (String(it.q.text || '').length > 60 ? ' is-long' : '') + '"><span class="tqn num">' + (pos + 1) + ' of ' + order.length + '</span>' +
          qrow + '</div>' +
        '<div class="sl-teach-board is-enter" id="slTBoard"></div>' +
        '<div class="sl-teach-actions"><div class="row"><button type="button" class="sl-btn sl-btn--cta" id="slTCta">Next</button><button type="button" class="sl-btn" id="slTAll">' + ICON.eye + 'Show it all</button>' +
          '<button type="button" class="sl-btn sl-tWb" id="slTWb" data-tip="Whiteboard" data-tipsub="Work this question out on a board. Key: W">' + WB.pen + '<span class="po-lbl">Whiteboard</span></button></div>' +
        '<div class="sl-hint" id="slTHint"></div></div></div>';
      paint(elTe, '<div class="sl-rail sl-teach-rail' + (ph && S.teach.listOpen ? ' is-sheet' : '') + '">' + rail + '</div><div class="sl-main">' + main + '</div>' + (ph ? phoneSheetsHTML() : ''), mountTeach);
    }
    /* TEACH ON EVERY PHONE (2026-10-19): the two sheets and their scrims. The levels sheet is the library's own
       level list (number, name, example, ticked as the chips are) inside a .sl-topic, so the teach click handler
       above treats a row as a chip press. Scrims are buttons: the theme hides an empty div. */
    function phoneSheetsHTML() {
      var lv = !!S.teach.lvOpen;
      var sheet = activeSkills().map(function (sk) {
        var sel = selLevels(sk);
        return '<div class="sl-topic" data-topic="' + sk.id + '">' + (S.from === 'mixed' ? '<div class="thead"><span style="color:' + colourOf(sk).col + ';display:grid">' + skIcon(sk) + '</span><span class="tname">' + esc(sk.name) + '</span></div>' : '') +
          sk.levels.map(function (L, i) {
            var k = i + 1; if (isMixLevel(sk, k)) return '';
            var on = sel.indexOf(k) >= 0;
            return '<button type="button" class="sl-rrow sl-lvlrow' + (on ? ' is-now' : '') + '" data-togglelvl="' + k + '" aria-pressed="' + (on ? 'true' : 'false') + '"><span class="sl-check' + (on ? ' is-on' : '') + '">' + ICON.tick + '</span><span class="rq"><span class="lname">' + k + '. ' + esc(L.name) + '</span><span class="leg sl-expr">' + oneEg(L.eg) + '</span></span></button>';
          }).join('') + '</div>';
      }).join('');
      return '<button type="button" class="sl-scrim" id="slTQScrim" aria-label="Close the questions"' + (S.teach.listOpen ? '' : ' hidden') + '></button>' +
        '<button type="button" class="sl-scrim" id="slLvScrim" aria-label="Close the levels"' + (lv ? '' : ' hidden') + '></button>' +
        '<div class="sl-lvsheet" id="slLvSheet"' + (lv ? '' : ' hidden') + '><div class="sl-rail-title">Levels</div>' + sheet + '</div>';
    }
    /* open or shut a sheet without re-rendering Teach (a render remounts the model and restarts the walk) */
    function phoneSheetSync() {
      var open = !!S.teach.listOpen, lv = !!S.teach.lvOpen;
      var rail = elTe.querySelector('.sl-teach-rail'), rq = elTe.querySelector('.sl-teach-rail-q');
      if (rail) rail.classList.toggle('is-sheet', open);
      if (rq) rq.classList.toggle('is-closed', !open);
      [['slTQList', open], ['slListToggle', open], ['slLvlBtn', lv]].forEach(function (p) { var b = $(p[0]); if (b) b.setAttribute('aria-expanded', String(p[1])); });
      var s1 = $('slTQScrim'), s2 = $('slLvScrim'), ls = $('slLvSheet');
      if (s1) s1.hidden = !open;
      if (s2) s2.hidden = !lv;
      if (ls) ls.hidden = !lv;
    }
    /* a phone turned on its side (or a window dragged across 640) changes which Teach is drawn: draw it again,
       back at the same press */
    var wasNarrow = narrow();
    window.addEventListener('resize', function () {
      if (narrow() === wasNarrow) return;
      wasNarrow = narrow();
      if (S.screen !== 'teach' || S.teach.chorus) return;
      var r = S.teach.r, at = r && r.where ? r.where() : null, wasDone = S.teach.done;
      S.teach.listOpen = !wasNarrow; S.teach.lvOpen = false;
      renderTeach(); renderTop();
      var again = function () { var r2 = S.teach.r; if (!r2 || S.teach.mode === 'answer') return; if (wasDone) r2.all(); else if (at && r2.seek) r2.seek(at); };
      if (S.teach.fitting) { S.teach.afterMount = again; return; }
      again();
    });
    /* A skill can offer switches for its own model (brackets: Grid method), shown beside
       Step by step | Answer only. One saved setting per id, shared by every skill offering it. */
    /* a switch may name the levels it belongs to (place value's Blocks: levels 1 to 3, PLACE VALUE BLOCKS (2026-09-21)) */
    function teachOptsHTML(sk, lv) {
      return (sk.teachOpts || []).filter(function (o) { return !o.levels || o.levels.indexOf(lv) >= 0; }).map(function (o) {
        var on = !!S.teach.opts[o.id];
        return '<button type="button" class="sl-toggle sl-topt' + (on ? ' is-on' : '') + '" data-topt="' + esc(o.id) + '" aria-pressed="' + on + '"><i></i>' + esc(o.label) + '</button>';
      }).join('');
    }
    /* flipping one rebuilds the model in place and walks it back to where it was */
    function toggleTeachOpt(btn) {
      var id = btn.getAttribute('data-topt'), on = !S.teach.opts[id], r = S.teach.r;
      var at = r && r.where ? r.where() : null, wasDone = S.teach.done;
      S.teach.opts[id] = on; save();
      btn.classList.toggle('is-on', on); btn.setAttribute('aria-pressed', String(on));
      mountTeach();
      if (S.teach.fitting) { S.teach.afterMount = function () { var r2 = S.teach.r; if (!r2 || S.teach.mode === 'answer') return; if (wasDone) r2.all(); else if (at && r2.seek) r2.seek(at); }; return; }
      r = S.teach.r; if (!r || S.teach.mode === 'answer') return;
      if (wasDone) r.all(); else if (at && r.seek) r.seek(at);
    }

    /* ============================================================
       SMARTBOARD TEACH ZOOM (2026-09-21)
       Aadam: "check every teach and make them all as large as possible so it's clear and
       easy to see". The model is drawn at its own size inside a board that is zoomed up to
       fill the space. The zoom is found before the model shows: the model is mounted in its
       finished state (Show it all, no motion), measured, and the zoom is cut until the whole
       of it fits. Then the real model mounts at that zoom. A model that grows past the board
       later in its steps makes the zoom smaller, never bigger, so nothing jumps.
       Rects: inside a zoomed board getBoundingClientRect returns the UNZOOMED rect about the
       board's corner, because the engines draw arrows from rect differences and set them
       with unzoomed lengths. rawRect() is the real one.
       ============================================================ */
    var TZ = { host: null, z: 1, token: 0, qz: {}, qy: {}, lz: {}, ign: {}, mo: null, moT: null, ro: null, zmax: 2.6 };
    /* TEACH CENTRED: set the board's working down by a share of its inside (0 = where the model puts it) */
    function tzDown(host, frac) {
      var on = frac > 0 && TZ.host === host && tzOn(host);
      if (!on) { host.style.removeProperty('--ty'); host.classList.remove('is-ty'); return; }
      var cs = getComputedStyle(host), z = TZ.z || 1, hr = rawRect(host);
      var pad = ((parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.borderBottomWidth) || 0) + (parseFloat(cs.paddingBottom) || 0)) * z;
      host.style.setProperty('--ty', (frac * (hr.height - pad) / z).toFixed(1) + 'px'); host.classList.add('is-ty');
    }
    var RAW_RECT = Element.prototype.getBoundingClientRect.__slRaw || Element.prototype.getBoundingClientRect;
    function rawRect(el) { return RAW_RECT.call(el); }
    (function () {
      if (Element.prototype.getBoundingClientRect.__slRaw) return;
      var patched = function () {
        var r = RAW_RECT.call(this), h = TZ.host, z = TZ.z;
        if (z === 1 || !h || (this !== h && !h.contains(this))) return r;
        var o = RAW_RECT.call(h);
        return new DOMRect(o.left + (r.left - o.left) / z, o.top + (r.top - o.top) / z, r.width / z, r.height / z);
      };
      patched.__slRaw = RAW_RECT;
      Element.prototype.getBoundingClientRect = patched;
    })();
    SL.rawRect = rawRect; SL._tz = TZ; TZ.log = [];   /* _tz: the rigs read the zoom and the fit log */
    function tzFrame(fn) { var ran = false; function go() { if (!ran) { ran = true; fn(); } } requestAnimationFrame(go); setTimeout(go, 60); }
    function tzKey(it) { return it.skill.id + '|' + it.level + '|' + (it.q.key || it.q.text || '') + '|' + JSON.stringify(S.teach.opts || {}); }
    function tzSet(host, z) {
      z = Math.round(z * 1000) / 1000;
      host.style.setProperty('--tz', String(z));
      var on = Math.abs(z - 1) > 0.001;
      host.classList.toggle('is-tz', on);
      TZ.host = host; TZ.z = on ? z : 1;
    }
    /* a laptop-sized board or bigger, or, PHONE TEACH ZOOM (2026-10-19), a phone board 300px tall. The phone kept its
       own layout while its board was 208px (2026-09-23); the short-phone layout gives it 430px at 360x640 and 619 at
       392x850, and a small model then sat in a quarter of it (laws of indices L2 filled 27%). The same fit as the
       laptop's: the finished walk is measured, the board zoomed to fill it, centred, and shrunk when it is too big
       (the sketch presses). A phone on its side is not narrow() and keeps the laptop rule (its board is under 300);
       chorus keeps its own layout. */
    function tzOn(host) {
      if (S.teach.chorus) return false;
      var r = rawRect(host);
      if (narrow()) return r.height >= 300 && r.width >= 200;
      return r.width >= 640 && r.height >= 300;
    }
    /* the smallest zoom: 0.8 on a laptop (the kit's 15px floor shows at 12); 0.85 on a phone, so its 12px floor
       stays over 10px on screen (decisions.md: any text a child reads is at least 10px) */
    function tzMin() { return narrow() ? 0.85 : 0.8; }
    /* how much of the model fits, part by part (1 or more = all of it). 'box': everything drawn,
       against the board's inside. Each scroller (a chart or a number line that pans) by how far it
       would have to scroll, and '#clip': anything drawn past a scroller's or an svg's edge that no
       scrolling reaches (the end labels of a long number line). parts: path -> the smallest ratio
       seen, so one map can collect every step of a probe. */
    function tzRoom(host, parts, ext) {
      var z = TZ.host === host ? TZ.z : 1, hr = rawRect(host), cs = getComputedStyle(host);
      var bl = (parseFloat(cs.borderLeftWidth) || 0) + (parseFloat(cs.paddingLeft) || 0), br = (parseFloat(cs.borderRightWidth) || 0) + (parseFloat(cs.paddingRight) || 0);
      var bt = (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.paddingTop) || 0), bb = (parseFloat(cs.borderBottomWidth) || 0) + (parseFloat(cs.paddingBottom) || 0);
      var aw = hr.width - (bl + br) * z, ah = hr.height - (bt + bb) * z;
      var L = 1e9, T = 1e9, R = -1e9, B = -1e9, boxes = [], iT = 1e9, iB = -1e9, sT = 1e9, sB = -1e9;
      /* TEACH CENTRED: what is DRAWN (text, a picture, a box with a fill or a border), not the layout boxes
         round it, which run the board's full height */
      function inked(k, st) {
        if (k.namespaceURI !== 'http://www.w3.org/1999/xhtml' || /^(IMG|CANVAS|INPUT)$/.test(k.tagName)) return true;
        if (!k.children.length && (k.textContent || '').trim()) return true;
        if (st.backgroundImage !== 'none' || (st.backgroundColor && !/rgba\(.*,\s*0\)$|transparent/.test(st.backgroundColor))) return true;
        return (parseFloat(st.borderTopWidth) > 0 && st.borderTopStyle !== 'none') || (parseFloat(st.borderBottomWidth) > 0 && st.borderBottomStyle !== 'none');
      }
      function put(p, v) { if (!(v < 1)) v = 1; if (!(p in parts) || v < parts[p]) parts[p] = v; }
      /* TEACH ZOOM HOLDS UNDER CENTRING (2026-10-01): TEACH CENTRED sets the working down by --ty, and a
         model root that runs the board's full height then pokes --ty past the bottom. That is layout, not
         ink: counted as overflow it shrank the board 15% a check, the spill scaling with the zoom, down to
         0.8 (recurring decimals 7 to 9, non-linear simultaneous). The set-down is taken off the host's
         scroll height, and what is DRAWN, where it now sits, is held to the board's inside instead. */
      var ty = host.classList.contains('is-ty') ? (parseFloat(host.style.getPropertyValue('--ty')) || 0) : 0;
      if (host.scrollHeight - ty > host.clientHeight + 1) put('host', host.clientHeight / (host.scrollHeight - ty));
      if (host.scrollWidth > host.clientWidth + 1) put('host', host.clientWidth / host.scrollWidth);
      /* AN EQUATION NEVER GOES OVER TWO LINES (2026-10-30): a working line the kit had to shrink on its own (data-fit =
         its box over its width) is a fit that failed, so the probe tries a smaller zoom, where it fits at its own size
         and keeps one size through the walk (a line that changed size between presses was written again by the pen) */
      if (ext) Array.prototype.forEach.call(host.querySelectorAll('.wl-line[data-fit]'), function (L) { put('wrap', parseFloat(L.getAttribute('data-fit')) || 1); });
      /* TEACH CENTRED SEES THE WORKING (2026-10-18): ink inside a scroller is kept too (sT/sB, cut to the
         scroller's box cy; ext.st/ext.sb over the walk). Only ink outside one counted, and the working-lines kit
         draws its lines inside .cs-work (overflow auto): where a picture sat beside it (quadratic formula's
         formula card, completing the square's grid) only that picture was measured and centred, the working
         was set down 43% and ran off the bottom of the board. done() joins the two when the walk drew anything
         outside a scroller; a model drawn wholly inside one still keeps the module's own layout, as before. */
      (function walk(el, path, clip, cy) {
        var kids = el.children, i, k, r, st, p, html, sx, svg, box, ky, a, z2;
        for (i = 0; i < kids.length; i++) {
          k = kids[i]; p = path + '.' + i;
          st = getComputedStyle(k);
          if (st.display === 'none') continue;
          r = rawRect(k);
          if (r.width > 0.5 || r.height > 0.5) {
            if (!clip) { if (r.left < L) L = r.left; if (r.top < T) T = r.top; if (r.right > R) R = r.right; if (r.bottom > B) B = r.bottom; }
            else { if (r.left < clip.L) clip.L = r.left; if (r.right > clip.R) clip.R = r.right; }
            if ((ext || ty) && inked(k, st)) {
              a = cy ? Math.max(r.top, cy.t) : r.top; z2 = cy ? Math.min(r.bottom, cy.b) : r.bottom;
              if (z2 - a > 0.5) { if (!clip) { if (a < iT) iT = a; if (z2 > iB) iB = z2; } else { if (a < sT) sT = a; if (z2 > sB) sB = z2; } }
            }
          }
          html = k.namespaceURI === 'http://www.w3.org/1999/xhtml';
          sx = html && (st.overflowX !== 'visible' || st.overflowY !== 'visible');
          svg = !html && k.tagName.toLowerCase() === 'svg' && st.overflow !== 'visible';
          if (sx) {
            /* PHONE TEACH ZOOM, NUMBER LINES (2026-10-21): a box that scrolls sideways BY DESIGN (the number line's
               .nl-linescroll, or any element a module marks data-tz-scroll) is not a squeeze the zoom can ease. On a
               phone the line is 1138px in a 414px box, the box grows as the zoom comes down (counting-in-steps L8 at
               392: rho .46 at 2.6, .70 at 1.73, .96 at 1.26), so the "built in" test never saw it as built in and
               the fit stopped at 1.14 where the board takes 2. Its height, and anything drawn past what scrolling
               reaches (#clip), still count. phone-fit.md exempts such scrollers the same way. */
            var byDesign = k.hasAttribute('data-tz-scroll') || k.classList.contains('nl-linescroll');
            if (st.overflowX !== 'visible' && !byDesign && k.scrollWidth > k.clientWidth + 2 && k.clientWidth > 0) put(p, k.clientWidth / k.scrollWidth);
            if (st.overflowY !== 'visible' && k.scrollHeight > k.clientHeight + 2 && k.clientHeight > 0) put(p, k.clientHeight / k.scrollHeight);
          }
          /* what a scroller draws shows only inside its box, top to bottom, when it clips that way */
          ky = cy;
          if (svg || (sx && st.overflowY !== 'visible')) ky = { t: cy ? Math.max(cy.t, r.top) : r.top, b: cy ? Math.min(cy.b, r.bottom) : r.bottom };
          if (sx || svg) {
            box = { p: p, r: r, L: 1e9, R: -1e9, x: sx && st.overflowX !== 'visible', el: k };
            boxes.push(box);
            if (k.children.length) walk(k, p, box, ky);
          } else if (k.children.length) walk(k, p, clip, ky);
        }
      })(host, 'b', null, null);
      boxes.forEach(function (b) {
        if (!(b.R > b.L) || b.r.width < 1) return;
        var zz = TZ.host === host ? TZ.z : 1, reachL = b.r.left, reachR = b.r.right;
        if (b.x) { reachL -= b.el.scrollLeft * zz; reachR += Math.max(0, b.el.scrollWidth - b.el.clientWidth - b.el.scrollLeft) * zz; }
        var cut = Math.max(0, reachL - b.L) + Math.max(0, b.R - reachR);
        if (cut > 1.5) put(b.p + '#clip', b.r.width / (b.r.width + cut));
      });
      /* TEACH CENTRED (2026-09-25): the probe also keeps how high and how low anything is drawn, as a
         share of the board's inside, over every press of the walk */
      if (ext && iB > iT && ah > 0) { var it0 = hr.top + bt * z; ext.t = Math.min(ext.t, (iT - it0) / ah); ext.b = Math.max(ext.b, (iB - it0) / ah); }
      if (ext && sB > sT && ah > 0) { var is0 = hr.top + bt * z; ext.st = Math.min(ext.st, (sT - is0) / ah); ext.sb = Math.max(ext.sb, (sB - is0) / ah); }
      /* set down: nothing drawn, inside a scroller or not, may end up past the board's bottom */
      var iBB = Math.max(iB, sB);
      if (ty && iBB > Math.min(iT, sT) && ah > 0) { var ib0 = hr.top + bt * z; if (iBB - ib0 > ah + 1) put('host', ah / (iBB - ib0)); }
      if (R > L && aw > 0) put('box', aw / (R - L));
      if (B > T && ah > 0) put('box', ah / (B - T));
      return parts;
    }
    function tzRho(parts, ign) { var m = 1, p; for (p in parts) if (!(ign && ign[p]) && parts[p] < m) m = parts[p]; return m; }
    /* wait until the model has stopped changing: a few frames with the same size, or give up */
    function tzSettle(host, token, fn) {
      var last = '', same = 0, n = 0;
      function sig() { var r = 0; each(host.querySelectorAll('*'), function (e) { var b = rawRect(e); r += b.width * 3 + b.height * 7 + b.left; }); return Math.round(r) + ':' + host.scrollHeight + ':' + host.children.length; }
      (function tick() {
        if (token !== TZ.token) return;
        var s = sig(); n++;
        same = (s === last) ? same + 1 : 0; last = s;
        if ((same >= 2 && n >= 3) || n > 24) { fn(); return; }
        tzFrame(function () { setTimeout(tick, 0); });
      })();
    }
    function tzProbe(host, it, api, token, cb) {
      tzSet(host, 1);
      var box = rawRect(host), key = tzKey(it);
      /* PHONE TEACH ZOOM (2026-10-19): a phone's model is drawn at phone size (18 to 26px lines), so its cap goes by
         the board's height alone at the phone's scale: 430px gives the laptop's 2.6, a 300px board 1.9 */
      var zmax = narrow() ? Math.max(1, Math.min(TZ.zmax, box.height / 160)) : Math.max(1, Math.min(TZ.zmax, box.height / 250, box.width / 420));
      var ZMIN = tzMin();
      /* first guess: what this level needed last time (the questions of a level share a shape) */
      var lkey = it.skill.id + '|' + it.level + '|' + JSON.stringify(S.teach.opts || {});
      var z = TZ.lz[lkey] ? Math.min(zmax, TZ.lz[lkey] / 0.98) : zmax, t0 = Date.now();
      var atts = [], ign = TZ.ign[key] = {};
      var papi = { hint: function () {}, cta: function () {}, steps: function () {}, step: function () {}, done: function () {}, replace: function () {}, opt: api.opt, reduceMotion: true };
      /* 2% spare: the live model settles a hair bigger than the still one (a graph, a late badge) */
      function done(zz) {
        var a0 = null; atts.forEach(function (a) { if (a.ext && Math.abs(a.z - zz) < 1e-6) a0 = a; });
        /* PHONE TEACH ZOOM (2026-10-19): 4% on a phone. The live walk sits a few px taller than the probe's (the hint
           under the actions wraps and goes, the actions row), and on a 400px board 2% is 8px: equivalent fractions L3
           and the algebraic fractions L2 ran 3 to 6px over for the 750ms until the watcher caught them. */
        TZ.lz[lkey] = zz; zz = Math.max(ZMIN, zz * (narrow() ? 0.96 : 0.98)); TZ.qz[key] = zz;
        /* TEACH CENTRED (2026-09-25, Aadam: "yes centre the teach working"): the walk that fitted, scaled to
           the zoom it will show at, is set down so the FINISHED model sits in the middle of the board. It
           grows into that space press by press, so nothing moves; a model that centres itself comes out
           at about 0 and is left alone. */
        var ty = 0;
        if (a0 && a0.ext.b > a0.ext.t && a0.ext.sb > a0.ext.st) { a0.ext.t = Math.min(a0.ext.t, a0.ext.st); a0.ext.b = Math.max(a0.ext.b, a0.ext.sb); }
        if (a0 && a0.ext.b > a0.ext.t) { var s = zz / a0.z, tt = a0.ext.t * s, hh = (a0.ext.b - a0.ext.t) * s; ty = (1 - hh) / 2 - tt; if (!(ty > 0.03) || hh > 0.97) ty = 0; }
        TZ.qy[key] = ty;
        TZ.log.push('fit ' + zz.toFixed(3) + (ty ? ' down ' + (ty * 100).toFixed(0) + '%' : '') + ' in ' + (Date.now() - t0) + 'ms' + (Object.keys(ign).length ? ' ignoring ' + Object.keys(ign).join(' ') : '')); cb(zz);
      }
      /* after every look: a scroller that is just as squeezed at a much smaller zoom is squeezed by
         design (a note that never fits its column), so it stops counting; then lo = the biggest
         zoom that fitted, hi = the smallest that did not. A model that simply scales jumps straight
         to its size; one whose columns widen as the zoom comes down is halved towards lo instead.
         Below 1 is allowed down to ZMIN: a short laptop screen used to scroll the board and cut the
         caption off; a little smaller and whole is clearer. */
      function next(parts, ext) {
        var cur = { z: z, parts: parts, ext: ext }, p;
        /* built in: it barely got better although the zoom came down (a real squeeze eases by far
           more than 0.05 for each 1 of zoom) */
        atts.forEach(function (a) {
          var dz = a.z - z; if (dz < 0.05) return;
          for (p in parts) if (p !== 'box' && p !== 'host' && parts[p] < 0.995 && a.parts[p] !== undefined && parts[p] - a.parts[p] < 0.05 * dz + 0.003) ign[p] = 1;
        });
        atts.push(cur);
        var lo = null, hi = null, hiRho = 1, hiBox = false;
        atts.forEach(function (a) {
          var r = tzRho(a.parts, ign), w = '', q;
          for (q in a.parts) if (!ign[q] && (!w || a.parts[q] < a.parts[w])) w = q;
          if (r >= 0.995) { if (lo === null || a.z > lo) lo = a.z; } else if (hi === null || a.z < hi) { hi = a.z; hiRho = r; hiBox = w === 'box' || w === 'host'; }
        });
        if (lo !== null && hi !== null && hi <= lo) hi = null;
        if (TZ.log.length > 40) TZ.log.shift();
        var worst = ''; for (p in parts) if (!ign[p] && (!worst || parts[p] < parts[worst])) worst = p;
        TZ.log.push(it.skill.id + ' L' + it.level + ' z=' + z.toFixed(2) + ' rho=' + tzRho(parts, ign).toFixed(3) + ' ' + worst);
        if (hi === null) { done(lo); return; }
        /* nothing fitted yet: the model's own size (1) is what the page always showed */
        var fallback = lo !== null ? lo : (hi > 1 ? 1 : ZMIN);
        if (hi <= ZMIN + 0.01 || atts.length >= 6) { done(fallback); return; }
        if (lo !== null && hi - lo < 0.12) { done(lo); return; }
        /* the plain box scales straight with the zoom, so its estimate was already the answer */
        if (lo !== null && hiBox && lo >= hi * hiRho * 0.97) { done(lo); return; }
        var est = hi * hiRho * 0.985, floor = lo === null ? ZMIN : lo;
        z = (hiRho < 0.6 && !hiBox) ? Math.max(est, (floor + hi) / 2) : est;
        if (lo !== null && z <= lo + 0.03) z = (lo + hi) / 2;
        z = Math.max(ZMIN, Math.min(z, hi - 0.04));
        if (atts.some(function (a) { return Math.abs(a.z - z) < 0.02; })) { done(fallback); return; }
        attempt();
      }
      function attempt() {
        if (token !== TZ.token) return;
        tzSet(host, z); tzDown(host, 0); host.innerHTML = '';
        var saved = SL.reduceMotion, pr = null, fin = false, k = 0, parts = {}, ext = { t: 1e9, b: -1e9, st: 1e9, sb: -1e9 };
        papi.done = function () { fin = true; };
        SL.reduceMotion = true;
        try { pr = glueTeach(it.skill.teach(host, it.q, papi), host); } catch (e) { pr = null; TZ.log.push('probe threw: ' + (e && e.message)); }
        SL.reduceMotion = saved;
        if (!pr) { host.innerHTML = ''; done(1); return; }
        /* every step, not only the finished model: some models are widest half way (a grid
           beside the working), then tidy up at the end */
        function end() {
          try { if (pr.all) pr.all(); } catch (e) {}
          tzSettle(host, token, function () {
            try { tzRoom(host, parts, ext); } catch (e) { TZ.log.push('probe room threw: ' + (e && e.message)); }
            try { if (pr.destroy) pr.destroy(); } catch (e) {}
            host.innerHTML = '';
            if (token !== TZ.token) return;
            next(parts, ext);
          });
        }
        /* TEACH ZOOM HOLDS (2026-10-01): the model as it OPENS, before any press, is measured too. The walk
           measured only after each next(), and a working-lines question line is at its biggest before the
           first press (is-now, full size, wrapped): equations with squares level 4 opened 7% too wide and
           the watcher shrank it a second after it showed. */
        function step() {
          if (token !== TZ.token) { try { pr.destroy(); } catch (e) {} return; }
          if (fin || k >= 40 || !pr.next) { end(); return; }
          var saved2 = SL.reduceMotion; SL.reduceMotion = true;
          try { pr.next(); } catch (e) { fin = true; }
          SL.reduceMotion = saved2; k++;
          /* a measure that throws must never leave the board blank (the walk would stop here for good) */
          setTimeout(function () { setTimeout(function () { if (token === TZ.token) { try { tzRoom(host, parts, ext); } catch (e) { TZ.log.push('probe room threw: ' + (e && e.message)); } } step(); }, 0); }, 0);
        }
        setTimeout(function () { setTimeout(function () { if (token === TZ.token) { try { tzRoom(host, parts, ext); } catch (e) { TZ.log.push('probe room threw: ' + (e && e.message)); } } step(); }, 0); }, 0);
      }
      attempt();
    }
    /* a model that grows past the board later on: the zoom comes down to fit it, never up */
    function tzWatch(host, it) {
      if (TZ.mo) { TZ.mo.disconnect(); TZ.mo = null; }
      /* phones and short landscape screens keep their own layout, as before: no zoom, no guard */
      if (!window.MutationObserver || TZ.host !== host || !tzOn(host)) return;
      var key = tzKey(it);
      /* two looks, 450ms apart, must both find it too big: a pop or a slide in the middle of its
         animation is bigger for a moment and must not shrink the board for good */
      function over() {
        if (TZ.host !== host || !host.isConnected || TZ.z <= tzMin() + 0.001) return 1;
        var ps = tzRoom(host, {}), r = tzRho(ps, TZ.ign[key]), w = '', q;
        if (r < 0.99) { for (q in ps) if (!(TZ.ign[key] && TZ.ign[key][q]) && (!w || ps[q] < ps[w])) w = q; TZ.why = w + ' ' + r.toFixed(3); }
        return r;
      }
      function check() {
        var a = over(); if (a >= 0.99) return;
        setTimeout(function () {
          var b = over(); if (b >= 0.99) return;
          /* at most 15% at a time: a squeezed column widens again as the zoom comes down */
          var z0 = TZ.z; tzSet(host, Math.max(tzMin(), TZ.z * Math.max(a, b, 0.85) * 0.985)); TZ.qz[key] = TZ.z;
          /* PHONE TEACH ZOOM (2026-10-19): the 10px floor was applied at the old zoom; a leaf at 10.8px on screen
             then shows at 9.2 after a 15% shrink, so the floor runs again at the new one */
          floorSoon(elTe);
          if (TZ.log.length > 40) TZ.log.shift();
          TZ.log.push('watch ' + z0.toFixed(3) + ' -> ' + TZ.z.toFixed(3) + ' ' + (TZ.why || ''));
        }, 450);
      }
      TZ.mo = new MutationObserver(function () { if (TZ.moT) return; TZ.moT = setTimeout(function () { TZ.moT = null; check(); }, 300); });
      TZ.mo.observe(host, { subtree: true, childList: true, attributes: true, characterData: true });
      /* PHONE TEACH ZOOM (2026-10-19): the board's own height moves without a window resize (the hint under the
         actions wraps to two lines on one press and goes on the last). The kit refits its working to the shorter
         stage, but the set-down (--ty, TEACH CENTRED) kept the px found for the taller board, so a note at the bottom
         sat 2 to 4px past it until the watcher shrank the whole board for it. The set-down follows the board. */
      if (TZ.ro) { TZ.ro.disconnect(); TZ.ro = null; }
      if (window.ResizeObserver) { TZ.ro = new ResizeObserver(function () { if (TZ.host === host && host.isConnected) tzDown(host, TZ.qy[key] || 0); }); TZ.ro.observe(host); }
    }
    /* full screen (F) or a resized window: a model nobody has stepped yet is fitted again */
    var tzResizeT = null;
    window.addEventListener('resize', function () {
      clearTimeout(tzResizeT);
      tzResizeT = setTimeout(function () {
        /* RESIZE REFIT (2026-10-25): the zoom a level needed last time was found on the old board. As the probe's first
           guess it capped the fit on a bigger one (a guess that fits is taken, never grown): recurring decimals L7 opened
           at 360x640 and went to 390x844 at 1.24 where a fresh load fits 1.64, and its set-down doubled to 20%. */
        TZ.lz = {};
        if (S.screen !== 'teach' || S.teach.chorus || S.teach.fitting) return;
        var it = S.set[S.teach.i]; if (!it) return;
        var hb = $('slTBoard'); if (hb && !tzOn(hb)) { if (TZ.z !== 1) { delete TZ.qz[tzKey(it)]; mountTeach(); } return; }
        if (!S.teach.moved) { delete TZ.qz[tzKey(it)]; mountTeach(); return; }
        if (TZ.host && TZ.z > tzMin() + 0.001) { var rho = tzRho(tzRoom(TZ.host, {}), TZ.ign[tzKey(it)]); if (rho < 0.99) tzSet(TZ.host, Math.max(tzMin(), TZ.z * rho * 0.985)); }
      }, 260);
    });
    /* TEACH STRIP FITS (2026-09-22): the level strip and Step by step | Answer only share one row on a laptop
       or board, but at 1024 wide the chips ran on under the switch (levels 3 to 5 of three brackets could not
       be pressed). The one-row strip is kept wherever every level box clears the switch and the row is no
       taller than the switch on a row of its own would make it. Otherwise the shortest of these that fits:
         'n'   one row, without the skill's name beside its icon (the top bar names it, as on a phone);
         '2'   the switch on its own row under the strip;
         'n2'  both (a narrow window: the name would wrap onto three lines beside the chips).
       The name only goes when one skill is being taught (a mixed strip needs its names). Classes on the teach
       main: is-tbn, is-tb2; hunks/tb2.css does the rest. */
    var TB_MQ = null; try { TB_MQ = window.matchMedia('(min-width: 861px) and (min-height: 621px)'); } catch (e) {}
    function fitTeachBar() {
      var m = elTe && elTe.querySelector('.sl-teach-main'); if (!m) return false;
      var was = (m.classList.contains('is-tbn') ? 'n' : '') + (m.classList.contains('is-tb2') ? '2' : '');
      var bar = m.querySelector(':scope > .sl-prbar'), tb = m.querySelector(':scope > .sl-teach-bar');
      function set(c) { m.classList.toggle('is-tbn', c.indexOf('n') >= 0); m.classList.toggle('is-tb2', c.indexOf('2') >= 0); }
      /* over: on one row, a level box runs within 8px of the switch; on two, past the strip's own edge */
      function lay(c) {
        set(c);
        var t = rawRect(tb), b = rawRect(bar), lim = c.indexOf('2') >= 0 ? b.right + 1 : t.left - 8, over = false;
        each(bar.children, function (k) { var r = rawRect(k); if (r.width && r.right > Math.min(lim, window.innerWidth)) over = true; });
        return { c: c, over: over, h: Math.max(b.bottom, t.bottom) - Math.min(b.top, t.top) };
      }
      set('');
      if (!(TB_MQ && TB_MQ.matches && bar && tb && bar.offsetWidth && tb.offsetWidth)) return was !== '';
      var one = bar.querySelectorAll('.sl-topic').length === 1;
      var A = lay(''), T = lay('2'), best = null;
      if (!A.over && A.h <= T.h + 2) best = A;
      else [one && lay('n'), T, one && lay('n2')].forEach(function (L) { if (L && !L.over && (!best || L.h < best.h - 2)) best = L; });
      var pick = best ? best.c : (one ? 'n2' : '2');
      set(pick);
      return pick !== was;
    }
    /* the fonts landed after the mount: a model nobody has stepped yet is fitted again, as on a resize */
    function refitTeachBar() {
      if (!fitTeachBar() || S.screen !== 'teach' || S.teach.chorus) return;
      var it = S.set[S.teach.i]; if (!it) return;
      if (S.teach.fitting || !S.teach.moved) { delete TZ.qz[tzKey(it)]; mountTeach(); return; }
      if (TZ.host && TZ.z > tzMin() + 0.001) { var rho = tzRho(tzRoom(TZ.host, {}), TZ.ign[tzKey(it)]); if (rho < 0.99) tzSet(TZ.host, Math.max(tzMin(), TZ.z * rho * 0.985)); }
    }
    var tbResizeT = null;
    window.addEventListener('resize', function () { clearTimeout(tbResizeT); tbResizeT = setTimeout(function () { if (S.screen === 'teach') fitTeachBar(); }, 90); });
    try { document.fonts.ready.then(refitTeachBar); document.fonts.addEventListener('loadingdone', refitTeachBar); } catch (err) {}
    function mountTeach() {
      destroyTeach();
      fitTeachBar();
      /* PHONE ROUND 3: TEACH + BOARD ON A PHONE (2026-09-23): the model is built after the zoom fit, so the floor is applied
         once when the step settles and again when the model has finished arriving */
      floorSoon(elTe); setTimeout(function () { if (S.screen === 'teach') floorType(elTe); }, 900);
      var it = S.set[S.teach.i]; if (!it) return;
      teachHost = $('slTBoard'); teachHost.innerHTML = '';
      S.teach.done = false;
      var api = {
        hint: function (html) { var h = $('slTHint'); if (!h) return; h.innerHTML = html || ''; refresh(h); },
        cta: function (label) { var c = $('slTCta'); if (!c) return; c.innerHTML = label + ICON.arrowR; refresh(c); },
        /* no step chips in Teach, for any skill (Aadam, 2026-09-15: "remove these explanation
           pills everywhere not needed", then "all should lose their chips"). Skills still call
           steps() and step(); both do nothing now. */
        steps: function () { var s = $('slTSteps'); if (s) s.innerHTML = ''; },
        step: function (i, label) { var s = $('slTSteps'); if (!s) return; Array.prototype.forEach.call(s.querySelectorAll('.sl-step'), function (c, n) { c.classList.toggle('is-done', n < i); c.classList.toggle('is-now', n === i); if (n === i && label) c.innerHTML = label; }); },
        done: function () {
          S.teach.done = true;
          it.state = (it.state === 'ok' || it.state === 'miss') ? it.state : 'shown';
          var ord = teachOrder(); var c = $('slTCta'); if (c) c.innerHTML = (teachPos(ord) >= ord.length - 1 ? 'New set' : 'Next in this set') + ICON.arrowR;
          var a = $('slTAll'); if (a) a.disabled = true;
          var s = $('slTSteps'); if (s) Array.prototype.forEach.call(s.querySelectorAll('.sl-step'), function (c) { c.classList.add('is-done'); c.classList.remove('is-now'); });
        },
        replace: function (q) { it.q = q; it.state = 'hid'; var row = elTe.querySelector('[data-tq="' + S.teach.i + '"] .rq'); if (row) row.innerHTML = q.html; },
        opt: function (id) { return !!S.teach.opts[id]; },
        reduceMotion: reduceMotion
      };
      var a = $('slTAll'); if (a) a.disabled = false;
      /* SMARTBOARD TEACH ZOOM (2026-09-21): fit first, then the real model at that zoom */
      var host = teachHost, token = ++TZ.token, tkey = tzKey(it);
      if (TZ.mo) { TZ.mo.disconnect(); TZ.mo = null; }
      if (TZ.ro) { TZ.ro.disconnect(); TZ.ro = null; }
      S.teach.moved = false;
      function realMount(z) {
        tzSet(host, z); tzDown(host, TZ.qy[tkey] || 0);
        S.teach.r = glueTeach(it.skill.teach(host, it.q, api), host);
        if (S.teach.mode === 'answer') S.teach.r.all();
        tzWatch(host, it);
      }
      function finishMount(z) {
        S.teach.fitting = false;
        realMount(z);
        host.classList.remove('is-tzwait', 'is-tzprobe');
        /* PHONE TEACH ZOOM (2026-10-19): the floor passes above ran while the probe's model was up (1.3s for triple
           brackets, more for quadratic sequences) and pinned leaves that were then thrown away; the real model mounts
           here, so the floor runs again for it, once it settles and once more when it has finished arriving */
        if (narrow()) { floorSoon(elTe); setTimeout(function () { if (S.screen === 'teach') floorType(elTe); }, 900); }
        if (!reduceMotion) { host.classList.add('is-arrive'); setTimeout(function () { host.classList.remove('is-arrive'); }, 360); }
        var fn = S.teach.afterMount; S.teach.afterMount = null; if (fn) fn();
      }
      var waits = 0;
      function begin() {
        if (token !== TZ.token || host !== $('slTBoard')) return;
        fitTeachBar();
        if (!tzOn(host)) { finishMount(1); return; }
        if (TZ.qz[tkey]) { finishMount(TZ.qz[tkey]); return; }
        host.classList.add('is-tzprobe');
        tzProbe(host, it, api, token, function (z) { if (token === TZ.token && host === $('slTBoard')) finishMount(z); });
      }
      var r0 = rawRect(host);
      if (r0.width > 0 && r0.height > 0 && (!tzOn(host) || TZ.qz[tkey])) { S.teach.fitting = false; realMount(tzOn(host) ? TZ.qz[tkey] : 1); }
      else {
        /* the screen is not laid out yet the first time (or the zoom has to be found): wait for a sized board */
        S.teach.fitting = true; host.classList.add('is-tzwait');
        (function wait() {
          if (token !== TZ.token) return;
          var r = rawRect(host);
          if ((r.width > 0 && r.height > 0) || ++waits > 20) begin(); else tzFrame(wait);
        })();
      }
      /* on a phone the level chips are one sideways row: bring the level in use
         into view, or level 12 of 12 sits off the right edge */
      if (narrow()) {
        var chipRow = elTe.querySelector('.sl-prbar .sl-lvlchips'), nowChip = chipRow && chipRow.querySelector('.sl-chip--now');
        if (chipRow && nowChip) chipRow.scrollLeft = Math.max(0, nowChip.offsetLeft - chipRow.clientWidth / 2 + nowChip.offsetWidth / 2);
      }
    }
    /* Forward and back through the MODEL. Stepping back un-finishes the
       question: the CTA and the step chips are repainted by the renderer, but
       the finished flag and Show it all live out here. */
    /* STAGE GLIDE (2026-10-04, Aadam: "the animations between each move seem harsh and not smooth",
       "fix within all other skills"). Every press repaints some or all of a model, so a piece that only
       MOVED (a chart pushed down by a banner, a column made wider, a row that moved up) jumped there in one
       frame. Around every press of a skill that does not glide itself (r.glides): read where every piece on
       the board is, let the skill draw, then play each piece that is still there (the same node, or a node
       redrawn with the same unique words in the same place in the tree) from its old place to its new one.
       A piece slides by how far it moved RELATIVE to the nearest thing already sliding around it, so
       nothing slides twice. A piece running its own animation (a hop, a rise, a grid's own move) is left
       alone. Rects inside the board are read unzoomed (the patched getBoundingClientRect), the units a
       transform there is in. Never under reduced motion; Show it all never glides. */
    function stageGlide(host, go) {
      if (reduceMotion || !host || !host.animate) { go(); return; }
      var all = host.querySelectorAll('*');
      if (all.length > 1500) { go(); return; }
      function skip(e) { return (e.closest('svg') && e.tagName.toLowerCase() !== 'svg') || e.closest('.sl-teach-actions'); }
      function key(e) {
        var t = (e.textContent || '').trim(); if (!t || t.length > 40 || e.children.length > 6) return '';
        var a = '', q = e.parentElement;
        for (var h = 0; h < 3 && q && q !== host; h++, q = q.parentElement) a = ((q.getAttribute('class') || q.tagName) + '').split(' ')[0] + '>' + a;
        return a + e.tagName + '|' + ((e.getAttribute('class') || '') + '').split(' ')[0] + '|' + t;
      }
      var was = new Map(), oldKey = {}, cnt = {};
      Array.prototype.forEach.call(all, function (e) {
        if (skip(e)) return;
        was.set(e, e.getBoundingClientRect());
        var k = key(e); if (k) { cnt['o' + k] = (cnt['o' + k] || 0) + 1; oldKey[k] = e; }
      });
      go();
      var now = Array.prototype.filter.call(host.querySelectorAll('*'), function (e) { return !skip(e); });
      if (now.length > 1500) return;
      var at = new Map();
      now.forEach(function (e) { at.set(e, e.getBoundingClientRect()); var k = key(e); if (k) cnt['n' + k] = (cnt['n' + k] || 0) + 1; });
      var moved = new Map();
      now.forEach(function (e) {
        var o = was.get(e), k, n = at.get(e);
        if (!o) { k = key(e); var oe = k && cnt['o' + k] === 1 && cnt['n' + k] === 1 ? oldKey[k] : null; if (oe && !oe.isConnected) o = was.get(oe); }
        if (!o || !n || (!n.width && !n.height) || (!o.width && !o.height)) return;
        var mx = o.left - n.left, my = o.top - n.top;
        if (Math.abs(mx) > 700 || Math.abs(my) > 700) return;
        var p = e.parentElement, base = null;
        while (p && p !== host && !(base = moved.get(p))) p = p.parentElement;
        base = base || [0, 0];
        var rx = mx - base[0], ry = my - base[1];
        if (Math.abs(rx) < 1.5 && Math.abs(ry) < 1.5) return;
        if (e.getAnimations && e.getAnimations().length) return;
        if (getComputedStyle(e).display === 'inline') return;
        moved.set(e, [mx, my]);
        e.animate([{ transform: 'translate(' + rx + 'px,' + ry + 'px)' }, { transform: 'none' }], { duration: 300, easing: 'cubic-bezier(.22,.8,.25,1)', composite: 'add' });
      });
    }
    function teachAnim(d, held) {
      var r = S.teach.r; if (!r) return;
      S.teach.moved = true;
      /* PHONE ROUND 3: TEACH + BOARD ON A PHONE (2026-09-23): a model re-sizes its rows on every press, so the floor is
         re-applied once the step has settled */
      floorSoon(elTe);
      /* Right always carries on (Aadam, 2026-09-15: "should be able to continue with the right key -
         without having to press using the mouse"): the next step; once the question is done, whatever
         the model offers past it (Keep counting); and when there is nothing more, the next question */
      if (d > 0) {
        if (!S.teach.done) { if (r.glides) r.next(); else stageGlide(teachHost, function () { r.next(); }); return; }
        /* a HELD key (key repeat) runs the model to its answer and stops there; only a fresh press
           moves on (Aadam, 2026-09-16: "if you hold down right to go fast through the animation it
           shouldn't go to the next question - everywhere") */
        if (held) return;
        if (r.more && r.more()) return;
        /* Aadam, 2026-09-21: "pressing right on the keyboard should never go to
           the next question. should always stop at the final animation. they
           need to press down for next question - fix everywhere". Down
           (teachStep) and the Next button still move on; Right stops here. */
        return;
      }
      if (!r.back) return;
      /* un-finish BEFORE stepping back: a walk back that is still at or past the answer marks it done again */
      if (S.teach.done) { S.teach.done = false; var a = $('slTAll'); if (a) a.disabled = false; }
      if (r.glides) r.back(); else stageGlide(teachHost, function () { r.back(); });
    }
    /* step by POSITION in the teaching order, not by index into the set */
    function teachStep(d) {
      var order = teachOrder(), pos = teachPos(order) + d;
      if (pos >= order.length) { buildSet(); S.teach.i = teachOrder()[0] || 0; renderTeach(); renderTop(); return; }
      if (pos < 0) pos = 0;
      teachGo(order[pos]);
    }
    function teachGo(i) {
      if (i === undefined || i >= S.set.length) { buildSet(); i = teachOrder()[0] || 0; }
      S.teach.i = Math.max(0, i);
      renderTeach(); renderTop();
    }
    /* swap one question for a fresh one at the same skill and level, avoiding
       anything already in the set */
    function freshTeachQuestion(i) {
      i = (i === undefined) ? S.teach.i : i;
      var it = S.set[i]; if (!it) return;
      var ctx = { seen: {}, shapeSeen: {}, last: null };
      S.set.forEach(function (x, k) { if (k !== i && x.skill === it.skill) ctx.seen[x.q.key] = 1; });
      ctx.slot = slotIn(S.set, i);
      S.set[i] = makeItem(it.skill, it.level, ctx);
      renderTeach(); renderTop();
    }
    function freshTeachSet() {
      if (partlyMarked() && !window.confirm('Refresh every question? The marks on this set will go.')) return;
      buildSet();
      S.teach.i = Math.min(S.teach.i, S.set.length - 1);
      renderTeach(); renderTop();
    }
    elTe.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null;
      if (!t) return;
      var tTopic = t.closest('.sl-topic');
      if (tTopic) {
        var tsk = SL.get(tTopic.getAttribute('data-topic'));
        if (tsk && levelClick(t, tsk)) { redealSkill(tsk); S.teach.i = 0; renderTeach(); renderTop(); }
        return;
      }
      if (t.id === 'slTCta') { if (S.teach.fitting) return; if (S.teach.done || !S.teach.r) { teachStep(1); return; } S.teach.moved = true; var rr = S.teach.r; if (rr.glides) rr.next(); else stageGlide(teachHost, function () { rr.next(); }); return; }
      if (t.id === 'slTAll') { if (S.teach.r) { S.teach.moved = true; S.teach.r.all(); } return; }
      if (t.id === 'slTWb') { WB.open('teach', S.teach.i); return; }
      if (t.id === 'slTPrev') { teachStep(-1); return; }
      if (t.id === 'slTNext') { teachStep(1); return; }
      if (t.id === 'slTeachNewAll') { freshTeachSet(); return; }
      if (t.hasAttribute('data-refresh')) { freshTeachQuestion(Number(t.getAttribute('data-refresh'))); return; }
      if (t.id === 'slListToggle' || t.id === 'slTQList' || t.id === 'slTQScrim') { S.teach.listOpen = !S.teach.listOpen; if (narrow()) { if (S.teach.listOpen) S.teach.lvOpen = false; phoneSheetSync(); return; } renderTeach(); return; }
      if (t.id === 'slLvScrim') { S.teach.lvOpen = false; phoneSheetSync(); return; }
      if (t.id === 'slChangeT') { changeSkill(); return; }
      if (t.id === 'slBackPr') { show('practise'); return; }
      if (t.hasAttribute('data-topt')) { toggleTeachOpt(t); return; }
      if (t.getAttribute('data-tmode')) { S.teach.mode = t.getAttribute('data-tmode'); renderTeach(); return; }
      if (t.hasAttribute('data-tq')) { if (narrow()) S.teach.listOpen = false; teachGo(Number(t.getAttribute('data-tq'))); return; }
    });


    /* ============================================================
       YOUR TURN
       Practise asks for the answer. This asks for the DECISIONS that
       reach it, one at a time, on the model itself, and reports each
       on its first try. Ten questions where every step was right the
       first time is not the same as ten right answers, and the
       difference is the whole point: the results say WHICH decision
       is the one going wrong.
       ============================================================ */
    var elTu = $('slTurn'), turnHost = null, turnTick = null;

    function turnSkill() { var it = S.set[S.turn.i]; return it ? it.skill : curSkill(); }
    function startTurn() {
      destroyTurn();
      buildSet();
      S.turn.i = 0; S.turn.phase = 'play'; S.turn.log = []; S.turn.cp = []; S.turn.marks = [];
      S.turn.at = 0; S.turn.t0 = Date.now(); S.turn.ms = 0; S.turn.ended = false;
    }
    function turnElapsed() { return S.turn.phase === 'play' ? (Date.now() - S.turn.t0) : S.turn.ms; }
    function saidTime(ms) {
      var t = Math.max(0, Math.round(ms / 1000));
      if (t < 60) return t + ' seconds';
      var m = Math.floor(t / 60), sec = t % 60;
      return m + ' minute' + (m === 1 ? '' : 's') + (sec ? ' ' + sec + ' seconds' : '');
    }

    /* ---------- the parts that repaint on their own ---------- */
    function paintUSteps() {
      var b = $('slUSteps'); if (!b) return;
      b.innerHTML = S.turn.cp.map(function (c, i) {
        var m = S.turn.marks[i];
        var cls = 'sl-step' + (i === S.turn.at ? ' is-now' : '') + (m ? (m.ok ? ' is-done' : ' is-missed') : '');
        return (i ? '<span class="arr">' + ICON.chevR + '</span>' : '') + '<span class="' + cls + '">' + esc(c.name) + '</span>';
      }).join('');
    }
    function paintURail() {
      var r = $('slUCps'); if (!r) return;
      r.innerHTML = S.turn.cp.map(function (c, i) {
        var m = S.turn.marks[i];
        var icon = m ? (m.ok ? '<span class="rtick">' + ICON.tick + '</span>' : '<span class="rtick miss">' + ICON.cross + '</span>') : '<span class="rtick pend"></span>';
        return '<div class="sl-ucp' + (i === S.turn.at ? ' is-now' : '') + (m && !m.ok ? ' is-miss' : '') + '">' + icon + '<span>' + esc(c.diag || c.name) + '</span></div>';
      }).join('');
      var sc = $('slUScore');
      if (sc) {
        var got = S.turn.log.filter(function (x) { return x && x.ok; }).length, seen = S.turn.log.filter(Boolean).length;
        sc.innerHTML = seen ? '<b class="num">' + got + '</b><span>right first time, of ' + seen + '</span>'
          : '<span>Nothing marked yet</span>';
      }
      var p = $('slUPips');
      if (p) p.innerHTML = pipsHTML();
    }
    function pipsHTML() {
      var out = [], i;
      for (i = 0; i < S.set.length; i++) {
        var g = S.turn.log[i];
        out.push('<span class="sl-upip' + (g ? (g.ok ? ' is-ok' : ' is-miss') : (i === S.turn.i ? ' is-now' : '')) + '"></span>');
      }
      return out.join('');
    }

    /* ---------- one question ---------- */
    function mountTurn() {
      destroyTurn();
      var it = S.set[S.turn.i]; if (!it || !it.skill.turn) return;
      turnHost = $('slUBoard'); if (!turnHost) return;
      turnHost.innerHTML = '';
      S.turn.cp = []; S.turn.marks = []; S.turn.at = 0; S.turn.ended = false;
      var nx = $('slUNext'); if (nx) nx.hidden = true;
      var sh = $('slUShow'); if (sh) sh.disabled = false;
      var api = {
        steps: function (list) { S.turn.cp = list || []; S.turn.marks = []; paintUSteps(); paintURail(); },
        step: function (i) { S.turn.at = i; paintUSteps(); paintURail(); },
        prompt: function (html) { var e = $('slUPrompt'); if (!e) return; e.innerHTML = html || ''; refresh(e); },
        hint: function (html) { var e = $('slUHint'); if (!e) return; e.innerHTML = html || ''; if (html) refresh(e); },
        mark: function (i, ok, c) {
          S.turn.marks[i] = { name: (c && c.name) || '', diag: (c && c.diag) || (c && c.name) || '', ok: !!ok };
          paintUSteps(); paintURail();
        },
        done: function (ok) { finishTurnQ(!!ok); },
        reduceMotion: reduceMotion
      };
      S.turn.r = it.skill.turn(turnHost, it.q, api);
    }
    function finishTurnQ(ok) {
      if (S.turn.ended) return;
      S.turn.ended = true;
      /* the same progress a marked set feeds: a level is secure at 80% of ten,
         and a question answered right first time counts once, here or there */
      var it = S.set[S.turn.i];
      mark(it, ok);
      /* the run's own record: the results screen adds these up, so it keeps
         every checkpoint, not just the ones that went wrong */
      S.turn.log[S.turn.i] = {
        html: it.q.html, level: it.level, skill: it.skill.name, ok: ok,
        cps: S.turn.cp.map(function (c, i) { var m = S.turn.marks[i]; return { diag: (c && c.diag) || (c && c.name) || '', name: (c && c.name) || '', ok: !!(m && m.ok) }; }),
        missed: S.turn.cp.map(function (c, i) { var m = S.turn.marks[i]; return (m && !m.ok) ? ((c && c.name) || c.diag) : null; }).filter(Boolean)
      };
      paintURail(); renderTop();
      var last = S.turn.i >= S.set.length - 1;
      var nx = $('slUNext');
      if (nx) { nx.hidden = false; nx.innerHTML = (last ? 'See how you did' : 'Next question') + ICON.arrowR; refresh(nx); nx.focus(); }
      var sh = $('slUShow'); if (sh) sh.disabled = true;
    }
    function nextTurnQ() {
      if (S.turn.i >= S.set.length - 1) {
        S.turn.ms = Date.now() - S.turn.t0; S.turn.phase = 'done';
        destroyTurn(); renderTurn(); renderTop(); return;
      }
      S.turn.i++;
      renderTurn(); renderTop();
    }

    /* ---------- the screen ---------- */
    function renderTurn() {
      var sk = curSkill(); if (!sk || !sk.turn) { show('skill'); return; }
      if (!S.set.length) startTurn();
      if (!S.set.length) buildSet();
      if (S.turn.phase === 'done') { renderTurnResults(sk); return; }
      S.turn.i = Math.max(0, Math.min(S.set.length - 1, S.turn.i));
      var it = S.set[S.turn.i];
      var rail = '<div class="sl-rail-title">Question ' + (S.turn.i + 1) + ' of ' + S.set.length + '</div>' +
        '<div class="sl-upips" id="slUPips">' + pipsHTML() + '</div>' +
        '<div class="sl-ucps" id="slUCps"></div>' +
        '<div class="sl-uscore" id="slUScore"></div>';
      var main = '<div class="sl-teach-main sl-turn-main">' +
        lvlStripHTML() +
        '<div class="sl-teach-bar"><div class="sl-steps" id="slUSteps"></div></div>' +
        '<div class="sl-teach-q' + (entering ? '' : ' is-fresh') + '"><span class="tqn num">' + (S.turn.i + 1) + ' of ' + S.set.length + '</span>' +
          '<span class="sl-expr tqx">' + it.q.html + '</span></div>' +
        '<div class="sl-teach-board is-enter" id="slUBoard"></div>' +
        '<div class="sl-teach-actions sl-turn-foot">' +
          '<div class="sl-uprompt" id="slUPrompt"></div>' +
          '<div class="row"><button type="button" class="sl-btn sl-btn--cta" id="slUNext" hidden>Next question</button>' +
          '<button type="button" class="sl-btn sl-btn--ghost" id="slUShow" data-tip="Show me" data-tipsub="Stuck? The rest of this one counts as missed and the answer is drawn.">' + ICON.eye + 'Show me</button></div>' +
          '<div class="sl-hint" id="slUHint"></div>' +
        '</div></div>';
      paint(elTu, '<div class="sl-rail sl-turn-rail">' + rail + '</div><div class="sl-main">' + main + '</div>', function () { paintURail(); mountTurn(); });
    }

    /* ---------- the results, which are the reason this mode exists ---------- */
    function renderTurnResults(sk) {
      var n = S.turn.log.filter(function (x) { return x; }).length;
      var ok = S.turn.log.filter(function (x) { return x && x.ok; }).length;
      var order = [], by = {};
      S.turn.log.forEach(function (g) {
        if (!g || !g.cps) return;
        g.cps.forEach(function (c) {
          if (!by[c.diag]) { by[c.diag] = { n: 0, ok: 0 }; order.push(c.diag); }
          by[c.diag].n++; if (c.ok) by[c.diag].ok++;
        });
      });
      var bars = order.map(function (d) {
        var r = by[d], pc = r.n ? Math.round(r.ok / r.n * 100) : 0;
        return '<div class="sl-ubar' + (pc < 70 ? ' is-low' : '') + '"><span class="ubname">' + esc(d) + '</span>' +
          '<span class="ubtrack"><i style="width:' + pc + '%"></i></span>' +
          '<span class="ubnum num">' + r.ok + ' of ' + r.n + '</span></div>';
      }).join('');
      var rates = order.filter(function (d) { return by[d].n >= 2; })
        .map(function (d) { return { d: d, pc: by[d].ok / by[d].n, r: by[d] }; })
        .sort(function (x, y) { return x.pc - y.pc; });
      var low = rates.length ? rates[0] : null;
      var tied = low ? rates.filter(function (x) { return x.pc === low.pc; }) : [];
      var say = function (x) { return '<b>' + esc(x.d.charAt(0).toLowerCase() + x.d.slice(1)) + '</b>'; };
      var lead;
      if (!low) lead = '';
      else if (low.pc >= 0.8) lead = '<p class="sl-ulead">No single decision stands out as the weak one. Move up a level.</p>';
      else if (tied.length >= rates.length) lead = '<p class="sl-ulead">Every decision is going wrong at the moment, not one of them. Work through Teach at this level, then come back.</p>';
      else if (tied.length > 1) lead = '<p class="sl-ulead">' + tied.map(say).join(' and ') + ' are the ones to work on, ' + low.r.ok + ' of ' + low.r.n + ' right first time each.</p>';
      else lead = '<p class="sl-ulead">' + say(low) + ' is the one to work on: ' + low.r.ok + ' of ' + low.r.n + ' right first time. The rest came out better than that.</p>';
      var list = S.turn.log.map(function (g, i) {
        if (!g) return '';
        return '<li><span class="unum num">' + (i + 1) + '</span><span class="sl-expr uq">' + g.html + '</span>' +
          (g.ok ? '<span class="rtick">' + ICON.tick + '</span>'
                : '<span class="umiss">' + esc(g.missed.length >= (g.cps || []).length ? 'all ' + g.missed.length : g.missed.join(' · ')) + '</span>') + '</li>';
      }).join('');
      paint(elTu, '<div class="sl-main"><div class="sl-scroll"><div class="sl-ures' + (entering ? ' is-enter' : '') + '">' +
        '<h2>' + esc(sk.turnName || 'Your turn') + ': ' + esc(sk.name) + '</h2>' +
        '<div class="sl-uhead"><div class="uscore"><b class="num">' + ok + '</b><span>of ' + n + ' right first time</span></div>' +
          '<div class="utime"><b class="num">' + saidTime(S.turn.ms) + '</b><span>' + esc(levelWord(sk)) + '</span></div></div>' +
        '<div class="sl-sect">Every decision, on the first try</div>' + '<div class="sl-ubars">' + bars + '</div>' + lead +
        '<div class="sl-sect">The ten questions</div><ol class="sl-ulist">' + list + '</ol>' +
        '<div class="sl-urow">' +
          '<button type="button" class="sl-btn sl-btn--cta" id="slUAgain2">' + ICON.refresh + 'Ten more</button>' +
          '<button type="button" class="sl-btn" id="slUTeach">' + ICON.steps + 'Teach this level</button>' +
          '<button type="button" class="sl-btn" id="slUPractise">' + ICON.list + 'Practise</button>' +
          '<button type="button" class="sl-btn sl-btn--ghost" id="slUSkill">' + ICON.chevL + 'Back to the skill</button>' +
        '</div></div></div></div>');
    }

    elTu.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null; if (!t) return;
      var tTopic = t.closest('.sl-topic');
      if (tTopic) {
        var sk2 = SL.get(tTopic.getAttribute('data-topic'));
        if (sk2 && levelClick(t, sk2)) { startTurn(); renderTurn(); renderTop(); return; }
      }
      if (t.id === 'slUNext') { nextTurnQ(); return; }
      if (t.id === 'slUShow') { if (S.turn.r && S.turn.r.reveal) S.turn.r.reveal(); return; }
      if (t.id === 'slUAgain2') { startTurn(); renderTurn(); renderTop(); return; }
      if (t.id === 'slUTeach') { S.teach.i = 0; S.teach.back = null; show('teach'); return; }
      if (t.id === 'slUPractise') { show('practise'); return; }
      if (t.id === 'slUSkill') { show('skill'); return; }
    });

    /* ============================================================
       BOARD
       ============================================================ */
    var elBo = $('slBoard');

    /* ---------- board timer ----------
       Typed in words or in clock form: "4 mins", "3 min 30", "90s", "2:30", or a
       bare number meaning minutes. It counts down, turns red near the end and
       holds at TIME UP rather than running on into negatives. */
    var TM = { left: 300, set: 300, running: false, tick: null, editing: false };
    function parseTime(txt) {
      txt = String(txt == null ? '' : txt).trim().toLowerCase().replace(/\s+/g, ' ');
      if (!txt) return null;
      var m;
      if ((m = txt.match(/^(\d{1,3})\s*[:.]\s*(\d{1,2})$/))) return (+m[1]) * 60 + (+m[2]);
      if ((m = txt.match(/^(\d+)\s*(?:m|min|mins|minute|minutes)\s*(\d{1,2})\s*(?:s|sec|secs|second|seconds)?$/))) return (+m[1]) * 60 + (+m[2]);
      if ((m = txt.match(/^(\d+(?:\.\d+)?)\s*(?:s|sec|secs|second|seconds)$/))) return Math.round(+m[1]);
      if ((m = txt.match(/^(\d+(?:\.\d+)?)\s*(?:m|min|mins|minute|minutes)?$/))) return Math.round(+m[1] * 60);
      return null;
    }
    function clock(sec) {
      sec = Math.max(0, Math.round(sec));
      var m = Math.floor(sec / 60), r = sec % 60;
      return m + ':' + (r < 10 ? '0' : '') + r;
    }
    function stopTimer() { TM.running = false; if (TM.tick) { clearInterval(TM.tick); TM.tick = null; } }
    function startTimer() {
      if (TM.left <= 0) TM.left = TM.set;
      stopTimer(); TM.running = true;
      /* a deadline, not a countdown: a throttled background tab must not make five minutes run long */
      var endAt = Date.now() + TM.left * 1000;
      TM.tick = setInterval(function () {
        TM.left = Math.max(0, Math.round((endAt - Date.now()) / 1000));
        if (TM.left <= 0) { TM.left = 0; stopTimer(); }
        paintTimer();
      }, 250);
      paintTimer();
    }
    function toggleTimer() { if (TM.running) { stopTimer(); paintTimer(); } else startTimer(); }
    function resetTimer() { stopTimer(); TM.left = TM.set; paintTimer(); }
    function timerHTML() {
      return '<div class="' + timerClasses() + '" id="slTimer">' +
        (TM.editing
          ? '<input type="text" id="slTimerIn" class="tmin" value="' + clock(TM.left) + '" aria-label="Set the timer, for example 4 mins or 3 min 30" spellcheck="false" autocomplete="off">'
          : '<button type="button" class="tmface num" id="slTimerFace" data-tip="Set the time" data-tipsub="Click and type: 4 mins, 3 min 30, 90s or 2:30. It takes a new time while it is running.">' + (TM.left <= 0 ? "TIME UP" : clock(TM.left)) + '</button>') +
        '<button type="button" class="sl-iconbtn sl-iconbtn--sq" id="slTimerGo" aria-label="' + (TM.running ? 'Pause' : 'Start') + '" data-tip="' + (TM.running ? 'Pause' : 'Start') + '" data-tipsub="Key: T">' + (TM.running ? ICON.pause : ICON.play) + '</button>' +
        '<button type="button" class="sl-iconbtn sl-iconbtn--sq" id="slTimerRe" aria-label="Reset the timer" data-tip="Reset" data-tipsub="Back to the time you set.">' + ICON.refresh + '</button></div>';
    }
    /* The clock repaints every second. Rebuilding the whole strip each tick
       destroyed the input you were typing into - a second in, the caret went and
       the box reverted to the face - so a running timer could not be re-set.
       The full rebuild now happens only when the shape changes (face <-> input);
       every other paint just patches the text and the button states. */
    function timerClasses() {
      return 'sl-timer' + (TM.running ? ' is-run' : '') + (TM.left <= 0 ? ' is-up' : (TM.left <= 30 ? ' is-low' : ''));
    }
    function paintTimer() {
      var host = $('slTimerWrap'); if (!host) return;
      var box = host.querySelector('.sl-timer');
      var shaped = !!(box && (!!box.querySelector('#slTimerIn') === TM.editing));
      if (!shaped) {
        host.innerHTML = timerHTML();
        if (TM.editing) { var inp = $('slTimerIn'); if (inp) { inp.focus(); inp.select(); } }
        return;
      }
      box.className = timerClasses();
      if (!TM.editing) { var f = $('slTimerFace'); if (f) f.textContent = TM.left <= 0 ? 'TIME UP' : clock(TM.left); }
      var go = $('slTimerGo');
      if (go) {
        var lab = TM.running ? 'Pause' : 'Start';
        go.innerHTML = TM.running ? ICON.pause : ICON.play;
        go.setAttribute('aria-label', lab); go.removeAttribute('title');
        go.setAttribute('data-tip', lab); go.setAttribute('data-tipsub', 'Key: T');
      }
    }
    /* A running clock counts down to a DEADLINE fixed when it started, so
       writing a new time into the box changed TM.left and the next tick, a
       quarter of a second later, put the old time straight back - the box
       looked dead. A new time while it is running restarts it, which is the
       only way the deadline gets recomputed. */
    function commitTimer(txt) {
      var v = parseTime(txt), fresh = v !== null && v > 0;
      if (fresh) { TM.set = v; TM.left = v; }
      TM.editing = false;
      if (fresh && TM.running) { startTimer(); return; }
      paintTimer();
    }

    /* A skill whose questions carry a picture needs the room: half a column each.
       And past three columns the screen splits two rows deep, so each takes six
       questions rather than eight - otherwise the type drops below what reads
       from the back of a room. */
    function perCol(skills, ncol) {
      if (skills.some(function (sk) { return sk && sk.diagram; })) return 4;
      return (ncol >= 4) ? 6 : 8;
    }
    function buildBoard() {
      var cols = [];
      if (S.from === 'mixed') {
        var mix = mixSkills().slice(0, 6);
        if (S.board.mixLayout === 'mixed') {
          /* every column draws from all the skills in turn, so a column is a
             mixed set rather than one topic */
          var ncm = Math.max(1, Math.round(S.board.n / 8)), pcm = perCol(mix, ncm);
          for (var m = 0; m < ncm; m++) {
            var mitems = [], queues = mix.map(function (sk) { return dealFor(sk, pcm); });
            for (var z = 0; mitems.length < pcm; z++) { var qq = queues[z % queues.length]; if (qq.length) mitems.push(qq.shift()); else if (queues.every(function (x) { return !x.length; })) break; }
            cols.push({ skill: mix[0], mixed: mix, items: mitems, title: ncm > 1 ? 'Questions ' + (m * pcm + 1) + ' to ' + (m * pcm + pcm) : 'Mixed questions',
                        sub: mix.length + ' skills mixed', tab: (m * pcm + 1) + ' to ' + (m * pcm + pcm), offset: m * pcm });
          }
        } else {
          var per = perCol(mix, mix.length);
          mix.forEach(function (sk) { cols.push({ skill: sk, items: dealFor(sk, per), title: sk.name, sub: levelWord(sk), tab: sk.short || sk.name, level: skillLevel(sk) }); });
        }
      } else {
        var sk = curSkill(); if (!sk) { S.board.cols = []; return; }
        var pc = perCol([sk], S.board.layout === 'diff' ? 3 : Math.max(1, Math.round(S.board.n / 8)));
        if (S.board.layout === 'diff') {
          diffLevels(sk).forEach(function (L) { var ctx = { seen: {}, shapeSeen: {}, last: null }, items = []; for (var k = 0; k < pc; k++) items.push(makeItem(sk, L, ctx)); cols.push({ skill: sk, level: L, fixedLevel: L, items: items, title: 'Level ' + L, sub: levelName(sk, L), tab: 'Level ' + L }); });
        } else {
          var ncol = Math.max(1, Math.round(S.board.n / 8)), all = dealFor(sk, ncol * pc), sel = selLevels(sk);
          for (var c = 0; c < ncol; c++) cols.push({ skill: sk, level: sel[0], items: all.slice(c * pc, c * pc + pc), title: ncol > 1 ? 'Questions ' + (c * pc + 1) + ' to ' + (c * pc + pc) : sk.name, sub: levelWord(sk), tab: (c * pc + 1) + ' to ' + (c * pc + pc), offset: c * pc });
        }
      }
      S.board.cols = cols; S.board.tab = 0; S.board.ans = false;
      if (S.from !== 'mixed' && curSkill()) cols.bsSig = boardSigFor(curSkill());
    }
    /* one question again, same skill and level, nothing else on the board moves
       (Aadam, 2026-09-15: "on board can refresh individual questions") */
    function freshBoardQ(ci, k) {
      var c = S.board.cols[ci], it = c && c.items[k]; if (!it || !it.skill) return;
      var ctx = { seen: {}, shapeSeen: {}, last: null };
      S.board.cols.forEach(function (col) { col.items.forEach(function (x) { if (x.skill === it.skill && x.q) ctx.seen[x.q.key] = 1; }); });
      ctx.slot = slotIn(c.items, k);
      c.items[k] = makeItem(it.skill, it.level, ctx);
      FX.col = -1; bFresh = ci + '.' + k;
      renderBoard();
    }
    /* deal one column again, at whatever it was set to, leaving the rest alone */
    function redealCol(i) {
      var c = S.board.cols[i]; if (!c || !c.skill) return;
      var n = c.items.length, ctx = { seen: {}, shapeSeen: {}, last: null }, items = [], k;
      if (c.mixed) {
        var qs = c.mixed.map(function (sk) { return dealFor(sk, n); });
        for (k = 0; items.length < n; k++) { var q1 = qs[k % qs.length]; if (q1.length) items.push(q1.shift()); else if (qs.every(function (x) { return !x.length; })) break; }
      } else if (c.fixedLevel) { for (k = 0; k < n; k++) items.push(makeItem(c.skill, c.fixedLevel, ctx)); }
      else items = dealFor(c.skill, n, ctx);
      c.items = items; FX.col = i;
      renderBoard();
    }
    /* A skill can offer a whole-class count for the board - the projector doing
       the counting so the room chants along. Only when one skill is on: a mix
       has no single step to count in. */
    function chorusOK() { var sk = curSkill(); return S.from !== 'mixed' && !!(sk && sk.chorus); }
    var chorusR = null;
    function destroyChorus() { if (chorusR && chorusR.destroy) { try { chorusR.destroy(); } catch (err) {} } chorusR = null; }
    function mountChorus() {
      var sk = curSkill(), h = $('slChorusHost');
      if (!h || !sk || !sk.chorus) return;
      chorusR = sk.chorus(h, {
        state: (S.chorus && S.chorus[sk.id]) || {},
        save: function (st) { S.chorus = S.chorus || {}; S.chorus[sk.id] = st; save(); }
      });
    }
    /* the board's columns and foot, shared by the board and the setup preview (2026-09-16) */
    function boardColsHTML(cols, colFx, headChips) {
      return cols.map(function (c, i) {
        var col = colourOf(c.skill), off = c.offset || 0;
        /* the head carries a short title too, for fitHeads to swap in when the
           column is narrow: the skill's short name, or the range the tabs show */
        var short = c.title === c.skill.name ? (c.skill.short || c.title) : (c.tab || c.title);
        return '<div class="sl-card sl-bcol' + (i === S.board.tab ? ' is-tab' : '') + (colFx === i ? ' is-enter' : '') + '" style="--i:' + i + '"><div class="sl-bhead" style="background:' + col.tint + '"><span class="bname" style="color:' + col.col + '">' + skIcon(c.skill) +
          '<span class="btitle"><span class="bt-full">' + esc(c.title) + '</span><span class="bt-short">' + esc(short) + '</span></span></span>' +
          (headChips ? '<span class="blvl">' + esc(c.sub) + '</span>' + headChipsHTML(c.skill)
            : '<span class="sl-chip num" style="color:' + col.col + ';border-color:' + col.col + ';background:var(--surface);cursor:default">' + esc(c.sub) + '</span>') +
          '<button type="button" class="sl-bnew" data-bnew="' + i + '" aria-label="New questions for ' + esc(c.title) + '" data-tip="New questions" data-tipsub="Deals this column again. The other columns stay as they are.">' + ICON.refresh + '</button></div>' +
          c.items.map(function (it, k) { return '<button type="button" class="sl-brow' + (it.ans ? ' is-ans' : '') + '" data-brow="' + i + '.' + k + '" style="--i:' + k + ';--ci:' + i + '" aria-pressed="' + (it.ans ? 'true' : 'false') + '"><span class="bn">' + (off + k + 1) + '<span class="bfresh" data-bfresh="' + i + '.' + k + '" role="button" aria-label="A new question ' + (off + k + 1) + '" data-tip="New question">' + ICON.refresh + '</span></span>' + (c.mixed ? '<span class="bdot" style="background:' + colourOf(it.skill).col + '" title="' + esc(it.skill.name) + '"></span>' : '') + '<span class="sl-expr">' + it.q.html + (it.q.choice ? '<span class="sl-bopts">' + it.q.choice.options.map(function (o, k) { return '<i><b>' + 'ABCDEF'.charAt(k) + '</b>' + o + '</i>'; }).join('') + '</span>' : '') + '</span><span class="sl-expr sl-ans">' + it.q.ansHTML + '</span></button>'; }).join('') + '</div>';
      }).join('');
    }
    function boardFootHTML(cols) {
      return '<div class="sl-bfoot">' + logoHTML('sl-logo--foot') + '<span>shlc-tutor.co.uk/pages/skills-lab</span><span>' + (S.from === 'mixed' ? (cols[0] && cols[0].mixed ? cols[0].mixed : cols.map(function (c) { return c.skill; })).map(function (sk) { return esc(sk.short || sk.name) + ' L' + selLevels(sk).join(','); }).join(' · ') : esc(curSkill() ? curSkill().name : '') + ' · ' + (S.board.layout === 'diff' ? 'levels ' + cols.map(function (c) { return c.level; }).join(', ') : esc(levelWord(curSkill()).toLowerCase()))) + '</span></div>';
    }
    function renderBoard() {
      if (!S.board.cols.length) buildBoard();
      var cols = S.board.cols;
      /* a new set deals every column in; one refreshed column deals itself in;
         a tab change or the answers toggle leaves the board where it is */
      var colFx = FX.col; FX.col = undefined;
      var sig = cols.map(function (c) { return c.items.map(function (it) { return it.q && it.q.key; }).join(','); }).join('|');
      var enter = entering || (colFx === undefined && sig !== boardSig);
      boardSig = sig;
      var tabs = cols.length > 1 ? '<div class="sl-btabs show-sm" role="tablist">' + cols.map(function (c, i) { return '<button type="button" role="tab" class="sl-chip' + (i === S.board.tab ? ' sl-chip--now' : '') + '" data-btab="' + i + '" aria-selected="' + (i === S.board.tab ? 'true' : 'false') + '">' + esc(c.tab) + '</button>'; }).join('') + '</div>' : '';
      var diffBoard = S.from !== 'mixed' && S.board.layout === 'diff';
      var headChips = !diffBoard && !cols.some(function (c) { return c.mixed; });
      var html = boardColsHTML(cols, colFx, headChips);
      var foot = boardFootHTML(cols);
      var sk0 = curSkill();
      var pTitle = S.from === 'mixed' ? 'Mixed practice' : esc(sk0 ? sk0.name : 'Skills Lab');
      var pSub = S.from === 'mixed' ? cols.map(function (c) { return esc(c.skill.short || c.skill.name); }).join(' · ')
        : (S.board.layout === 'diff' ? 'Levels ' + cols.map(function (c) { return c.level; }).join(', ') : esc(levelWord(sk0)));
      var head = '<div class="sl-print-head">' + logoHTML('sl-logo--sheet') + '<div class="ph-l"><b>' + pTitle + '</b><span>' + pSub + (S.board.ans ? ' · answers' : '') + '</span></div>' +
        '<div class="ph-r"><span>Name</span><i></i><span>Date</span><i class="sm"></i></div></div>';
      var strip = headChips ? '' : lvlStripHTML('', diffBoard ? 3 : 0);
      paint(elBo, '<div class="sl-main">' + strip + '<div class="sl-board-main' + (S.board.ans ? ' show-ans' : '') + '">' + head + tabs + '<div class="sl-board-cols n' + Math.min(6, cols.length) + (enter ? ' is-enter' : '') + '">' + (html || '<div class="sl-empty">Pick a skill first.</div>') + '</div>' + foot + '</div></div>');
      fitBoard(); watchBoard();
      if (bFresh) { var fr = elBo.querySelector('[data-brow="' + bFresh + '"]'); if (fr) fr.classList.add('is-fresh'); bFresh = null; }
    }
    var boardSig = '', bFresh = null;
    /* A long answer ran off the end of its column: the question would not give
       way and the answer would not shrink, so the last terms were simply cut off.
       Each row now measures what it needs against the width it has, and a row
       that is too long shrinks its question AND its answer by the same factor,
       so a crowded row keeps the proportions every other row has. (It used to
       shrink the question to its floor first and the answer only after that,
       which left "Write the value of the 4 in 0.090034" at about 13px beside a
       24px answer; Aadam asked for the two to come down together, 2026-09-11.)
       Measured in one pass, written in the next, then checked once, because
       scaling type does not scale the row number or the gaps with it. */
    /* SMARTBOARD BOARD ROWS (2026-09-21). Aadam: "NEEDS TO BE MUCH LARGER TO BE ABLE TO SEE THEM".
       Rows were ~112px tall and ~620px wide on a 1920x1080 board of 24, yet the type sat at 18px:
       each skill's CSS caps its size with a vh clamp, and the fit below only ever shrank a row.
       growBoard finds, for every row, the biggest scale of its question AND answer (together, so
       the two keep their proportions) that keeps the ink inside the row's width and 96% of its
       height; a hidden answer keeps its room, so showing the answers moves nothing. Then a column
       takes one size so it reads tidy (the whole board, when one skill fills every column in the
       mixed layout): the biggest size that half the rows can take. The rest, the long ones, keep
       the biggest size they can take, which is smaller. No row is held below the size its skill's
       CSS gives it, so nothing reads smaller than it did before. A bisection over every row at once, so it
       costs about a dozen layouts. Rows that grow to fit their type (a phone board scrolls) are
       left to the shrink-only fit. */
    var GROW_LO = 0.3, GROW_HI = 8, GROW_H = 0.96, GROW_TIDY = 0.5, GROW_GAP = 0.5;
    function growBoard(rows) {
      var list = [];
      Array.prototype.forEach.call(rows, function (r) {
        var cs = window.getComputedStyle(r);
        if (!(parseFloat(cs.flexGrow) > 0) || cs.flexBasis === 'auto' || !r.offsetHeight) return;
        var q = r.querySelector('.sl-expr:not(.sl-ans)'); if (!q) return;
        list.push({ r: r, q: q, a: r.querySelector('.sl-ans'), col: r.parentNode, lo: GROW_LO, hi: GROW_HI,
          base: parseFloat(window.getComputedStyle(q).fontSize) || 16, ra: 1,
          pad: [(parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.borderLeftWidth) || 0), (parseFloat(cs.paddingRight) || 0) + (parseFloat(cs.borderRightWidth) || 0),
                (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.borderTopWidth) || 0), (parseFloat(cs.paddingBottom) || 0) + (parseFloat(cs.borderBottomWidth) || 0)] });
      });
      if (!list.length) return false;
      /* an answer never outgrows its question: a few skills cut the question's size for their long
         rows and left the answer's, so "51" stood half as big again as "Write LI in figures" */
      list.forEach(function (t) { var fa = t.a ? parseFloat(window.getComputedStyle(t.a).fontSize) : 0; t.fa = fa; if (fa > t.base) t.ra = t.base / fa; });
      /* the ink of a question or answer: its text, pictures and small inline pieces (a chip, a gap
         box), never a block box, which spans the whole row whatever the type (a two-line question's
         halves are blocks). Listed once per row. A hidden answer sits 6px to the right (it slides
         in), so its slide is taken off to measure where it will show. */
      function parts(el) {
        var out = [];
        (function walk(n) {
          for (var c = n.firstChild; c; c = c.nextSibling) {
            if (c.nodeType === 3) { if (/\S/.test(c.nodeValue)) out.push(c); continue; }
            if (c.nodeType !== 1) continue;
            var d = window.getComputedStyle(c).display, tag = c.tagName.toLowerCase();
            if (d === 'none') continue;
            if (tag === 'svg' || tag === 'img' || tag === 'canvas' || (!c.firstElementChild && d.indexOf('inline') === 0)) out.push(c);
            if (tag !== 'svg') walk(c);
          }
        })(el);
        return out;
      }
      var g = document.createRange();
      function ink(el, bits, slid) {
        if (!el || !el.offsetHeight || !bits.length) return null;
        var l = 1e9, r = -1e9, tp = 1e9, bt = -1e9;
        bits.forEach(function (n) {
          var b;
          if (n.nodeType === 3) { g.selectNodeContents(n); b = g.getBoundingClientRect(); } else b = n.getBoundingClientRect();
          if (!b.width && !b.height) return;
          l = Math.min(l, b.left); r = Math.max(r, b.right); tp = Math.min(tp, b.top); bt = Math.max(bt, b.bottom);
        });
        if (l > r) return null;
        var tx = 0;
        if (slid) { var m = /matrix\(([^)]+)\)/.exec(window.getComputedStyle(el).transform || ''); if (m) tx = parseFloat(m[1].split(',')[4]) || 0; }
        return { l: l - tx, r: r - tx, t: tp, b: bt };
      }
      list.forEach(function (t) { t.qb = parts(t.q); t.ab = t.a ? parts(t.a) : []; });
      function fits(t) {
        var rr = t.r.getBoundingClientRect();
        var L = rr.left + t.pad[0], R = rr.right - t.pad[1], T = rr.top + t.pad[2], B = rr.bottom - t.pad[3];
        var qi = ink(t.q, t.qb, false), ai = ink(t.a, t.ab, true);
        if (!qi) return true;
        var top = ai ? Math.min(qi.t, ai.t) : qi.t, bot = ai ? Math.max(qi.b, ai.b) : qi.b, mid = (T + B) / 2;
        if (Math.max(mid - top, bot - mid) > (B - T) * GROW_H / 2) return false;
        if (qi.l < L - 0.5 || qi.r > R + 0.5) return false;
        /* half the answer's size clear of the question, or at 60px "0.82 ÷ 1000 0.00082" reads as one sum */
        if (ai && (ai.r > R + 0.5 || qi.r > ai.l - Math.max(12, GROW_GAP * t.fa * t.k * t.ra))) return false;
        return true;
      }
      function put(t, k) { t.r.style.setProperty('--fitq', k.toFixed(3)); t.r.style.setProperty('--fita', (k * t.ra).toFixed(3)); }
      var i;
      for (i = 0; i < 9; i++) {
        list.forEach(function (t) { t.k = Math.sqrt(t.lo * t.hi); put(t, t.k); });
        list.forEach(function (t) { if (fits(t)) t.lo = t.k; else t.hi = t.k; });
      }
      /* one size per column (per board for a single skill laid out in turn), in real pixels,
         because two skills in a mixed column start from different sizes */
      var whole = S.from !== 'mixed' && S.board.layout !== 'diff', groups = [], keyOf = [];
      list.forEach(function (t) {
        var key = whole ? 0 : keyOf.indexOf(t.col);
        if (key < 0) { keyOf.push(t.col); key = keyOf.length - 1; }
        (groups[key] = groups[key] || []).push(t);
      });
      groups.forEach(function (g) {
        var px = g.map(function (t) { return t.lo * t.base; }).sort(function (x, y) { return x - y; });
        var P = px[Math.floor((px.length - 1) * GROW_TIDY)];
        g.forEach(function (t) { t.k = Math.min(t.lo, Math.max(1, P / t.base)); put(t, t.k); });
      });
      /* type does not always scale in step (a wrapped line can break differently), so check once
         more and take a little off any row that ended up over */
      for (i = 0; i < 3; i++) {
        var over = list.filter(function (t) { return t.k > GROW_LO && !fits(t); });
        if (!over.length) break;
        over.forEach(function (t) { t.k = Math.max(GROW_LO, t.k * 0.94); put(t, t.k); });
      }
      return true;
    }
    var FITQ_MIN = 0.6, FITA_MIN = 0.62;
    /* PHONE ROUND 3: TEACH + BOARD ON A PHONE (2026-09-23). The app sizes a model by shrinking its root, and every label inside
       it is em of that root, so a label can end up at 7px with nothing in its own rule to stop it.
       Under 861px every leaf of text still under PW_LEAF after a fit is pinned to PW_LEAF. Pins are
       cleared first, so a screen that grows gets its em sizes back. Never runs above 860px. */
    function zoomUp(e, root) {
      var z = 1, p, v;
      for (p = e; p && p !== root.parentElement; p = p.parentElement) { v = parseFloat(window.getComputedStyle(p).zoom); if (v && v !== 1) z *= v; }
      return z;
    }
    function floorType(root) {
      if (!root || !flowWall()) return;
      each(root.querySelectorAll('[data-slfloor]'), function (e) { e.style.removeProperty('font-size'); e.removeAttribute('data-slfloor'); });
      each(root.querySelectorAll('*'), function (e) {
        if (e.children.length || !(e.textContent || '').trim()) return;
        if (!e.offsetWidth && !e.offsetHeight) return;
        var cs = window.getComputedStyle(e), f;
        if (cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return;
        if (isMark(e) || (e.parentNode && e.parentNode.nodeType === 1 && isMark(e.parentNode))) return;
        /* PHONE TEACH ZOOM (2026-10-19): the size on screen is the computed size times every css zoom above the leaf:
           the Teach board's (--tz, now on a phone too) and a kit's own (the term table scales itself with zoom, so
           its "term" label at 14.7px computed showed at 9.2 under a 0.85 board). A label held at 12.5px / --tz would
           otherwise be pinned up to 25px at zoom 2.5, and at 0.85 an 11px leaf would pass while showing at 9.4. The
           pin rounds up a hair, or 10 / 0.85 = 11.76 showed at 9.99. */
        var zf = zoomUp(e, root);
        f = parseFloat(cs.fontSize) * zf;
        if (f && f < PW_LEAF) { e.style.fontSize = (PW_LEAF / zf + 0.05).toFixed(2) + 'px'; e.setAttribute('data-slfloor', '1'); }
      });
    }
    var floorT = null;
    function floorSoon(root) { clearTimeout(floorT); floorT = setTimeout(function () { floorType(root); }, 260); }
    /* TWO COLUMNS FOR LONG QUESTIONS (2026-10-04). From 641 to 1000 wide a board of three columns of eight
       sits three across (each ~250px by ~75px a row). That suits equations and short sums, but a worded
       question ("Closest to 55,000 from 1 3 6 9 0") came out at 7-9px there. Laid out two across with the
       third column full width under them (rows ~390-780px wide and ~37px tall) the same board read at
       12-21px. Which shape wins depends on the questions, so the board fits both and keeps two columns only
       when its text comes out clearly bigger (15%) with nothing outside its row. Aadam: "ok two columns for
       long questions". Only the real board, only in that band; everywhere else this is fitBoardOnce. */
    function twoBand() { try { return window.innerWidth >= 641 && window.innerWidth <= 1000; } catch (e) { return false; } }
    function boardScore(box) {
      var px = [], bad = 0, g = document.createRange();
      each(box.querySelectorAll('.sl-brow'), function (r) {
        var q = r.querySelector('.sl-expr:not(.sl-ans)'), a = r.querySelector('.sl-ans'), rr = r.getBoundingClientRect();
        if (!q || !r.offsetHeight) return;
        var tw = document.createTreeWalker(q, NodeFilter.SHOW_TEXT), n;
        while ((n = tw.nextNode())) {
          var pe = n.parentElement; if (!pe.offsetWidth && !pe.offsetHeight) continue;
          var f = parseFloat(window.getComputedStyle(pe).fontSize), k = n.nodeValue.replace(/\s/g, '').length;
          while (k-- > 0) px.push(f);
        }
        [q, a].forEach(function (el) {
          if (!el || !el.offsetHeight) return;
          g.selectNodeContents(el); var b = g.getBoundingClientRect();
          if (b.width && (b.top < rr.top - 1.5 || b.bottom > rr.bottom + 1.5 || b.left < rr.left - 1.5 || b.right > rr.right + 1.5)) bad++;
        });
      });
      px.sort(function (x, y) { return x - y; });
      return { px: px.length ? px[Math.floor(px.length / 2)] : 0, bad: bad };
    }
    function fitBoard(root) {
      root = root && root.querySelectorAll ? root : elBo;
      var box = root.querySelector('.sl-board-cols');
      if (!box || root !== elBo || !box.classList.contains('n3') || !twoBand()) {
        if (box) box.classList.remove('is-two');
        fitBoardOnce(root); return;
      }
      box.classList.remove('is-two'); fitBoardOnce(root);
      var three = boardScore(box);
      box.classList.add('is-two'); fitBoardOnce(root);
      var two = boardScore(box);
      if (two.bad <= three.bad && two.px > three.px * 1.15) return;
      box.classList.remove('is-two'); fitBoardOnce(root);
    }
    function fitBoardOnce(root) {
      root = root && root.querySelectorAll ? root : elBo;
      fitHeads(root);
      var rows = root.querySelectorAll('.sl-brow'); if (!rows.length) return;
      var plan = [];
      Array.prototype.forEach.call(rows, function (r) {
        r.style.removeProperty('--fitq'); r.style.removeProperty('--fita'); r.classList.remove('is-wrapq');
      });
      /* PHONE ROUND 3: TEACH + BOARD ON A PHONE (2026-09-23): a board row is ONE line that never wraps, which is right on a
         board and wrong on a phone - under 861px a question that would have to shrink past the fit's
         floor is allowed to wrap onto a second line instead of being cut off. The rows there are a
         scrolling column, so the height is free. */
      if (flowWall()) Array.prototype.forEach.call(rows, function (r) {
        var q = r.querySelector('.sl-expr:not(.sl-ans)'), a = r.querySelector('.sl-ans'), cs, avail, room, k, fixed = 0;
        if (!q) return;
        cs = window.getComputedStyle(r);
        avail = r.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
        for (k = 0; k < r.children.length; k++) if (r.children[k] !== q) fixed += r.children[k].offsetWidth + 8;
        room = avail - fixed;
        /* the CONTENT width, not the box: a flex row squeezes the question's box, so a question whose choice
           options run past it measured 322px of box against 492px of content and was never marked, and the
           options sat 142px outside the card (rearranging formulae at 430, 2026-09-25) */
        /* 2026-09-25 (polish round): and a phone row that would have to come down past 85% wraps instead of
           waiting for the fit's 0.6 floor (a row that landed between the two ran off its card at the floor) */
        if (room > 0 && Math.max(q.offsetWidth, q.scrollWidth) > room / 0.85) r.classList.add('is-wrapq');
      });
      if (growBoard(rows)) return;  /* SMARTBOARD BOARD ROWS (2026-09-21): a board that fills the screen grows its type */
      Array.prototype.forEach.call(rows, function (r) {
        var q = r.querySelector('.sl-expr:not(.sl-ans)'), a = r.querySelector('.sl-ans');
        if (!q) return;
        var cs = window.getComputedStyle(r);
        var avail = r.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
        var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0;
        var fixed = gap * Math.max(0, r.children.length - 1), k;
        /* margins too: a mixed column's colour dot has a 2px margin, and leaving it out put
           every fitted answer on those boards 2px into the row's padding */
        for (k = 0; k < r.children.length; k++) if (r.children[k] !== q && r.children[k] !== a) {
          var ck = window.getComputedStyle(r.children[k]);
          fixed += r.children[k].offsetWidth + (parseFloat(ck.marginLeft) || 0) + (parseFloat(ck.marginRight) || 0);
        }
        var room = avail - fixed, qw = q.offsetWidth, aw = a ? a.offsetWidth : 0;
        if (room <= 0 || qw + aw <= room) return;
        var s = room / (qw + aw), fq = Math.max(FITQ_MIN, s), fa = aw ? Math.max(FITA_MIN, s) : 1;
        plan.push({ r: r, q: q, a: a, room: room, fq: fq, fa: fa });
      });
      plan.forEach(function (p) {
        p.r.style.setProperty('--fitq', p.fq.toFixed(3));
        if (p.fa < 1) p.r.style.setProperty('--fita', p.fa.toFixed(3));
      });
      /* one check: type does not scale perfectly linearly, so trim what is left over */
      plan.forEach(function (p) {
        var got = p.q.offsetWidth + (p.a ? p.a.offsetWidth : 0);
        if (got <= p.room || !got) return;
        var k = p.room / got;
        p.r.style.setProperty('--fitq', Math.max(FITQ_MIN * 0.85, p.fq * k).toFixed(3));
        p.r.style.setProperty('--fita', Math.max(FITA_MIN * 0.85, p.fa * k).toFixed(3));
      });
      fitHeight(rows);
      floorType(root);
    }
    /* HEIGHT. The fit above is width only, so a question taller than its row (two lines, a
       list that wraps, a clock face) ran into the row below wherever rows are short: four to
       six skills sit two deep, six to a column, which leaves a row about 0.6 of the height
       every skill's face was sized for (measured 2026-09-11 on mixed boards: roman clocks
       27-66px over, place value's two-sentence rows 9-21px, comparing's lists and reading-
       writing's words up to 23px). Each row now measures the ink of its question and of its
       answer (a Range, which stands a little proud of the line boxes) around the middle of its
       own content box, and a row that stands too tall brings the two down together, as the
       width fit does, to the biggest type that fits. Rows that grow to fit (a phone board
       scrolls) are left alone. */
    var FITH_MIN = 0.35;
    function fitHeight(rows) {
      function reach(el, mid) {
        if (!el || !el.offsetHeight) return 0;
        var g = document.createRange(); g.selectNodeContents(el);
        var ink = g.getBoundingClientRect(), box = el.getBoundingClientRect();
        return Math.max(mid - Math.min(ink.top, box.top), Math.max(ink.bottom, box.bottom) - mid);
      }
      /* how far past its room a row stands: over 1 is too tall. `edge` keeps a row that is being
         fitted just inside its box; a row that fits as it is is never touched. */
      function over(r, edge) {
        var cs = window.getComputedStyle(r), rr = r.getBoundingClientRect();
        var top = rr.top + (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.paddingTop) || 0);
        var bot = rr.bottom - (parseFloat(cs.borderBottomWidth) || 0) - (parseFloat(cs.paddingBottom) || 0);
        var mid = (top + bot) / 2, half = (bot - top) / 2 - edge;
        if (half <= 0) return 0;
        return Math.max(reach(r.querySelector('.sl-expr:not(.sl-ans)'), mid), reach(r.querySelector('.sl-ans'), mid)) / half;
      }
      var todo = [];
      Array.prototype.forEach.call(rows, function (r) {
        var cs = window.getComputedStyle(r);
        if (!(parseFloat(cs.flexGrow) > 0) || cs.flexBasis === 'auto' || !r.offsetHeight) return;
        if (over(r, 0) > 1) todo.push({ r: r, fq: parseFloat(r.style.getPropertyValue('--fitq')) || 1, fa: parseFloat(r.style.getPropertyValue('--fita')) || 1, lo: 0, hi: 1 });
      });
      if (!todo.length) return;
      /* a wrapped list or sentence loses lines as its type comes down, so its height does not
         follow the type in step (one straight scale shrank "Largest first: 21,913, 448, ..." to
         7px on one line where two lines at 60% fitted). Each tall row finds the biggest type
         that fits by halving the gap seven times, every row at once, so it costs seven layouts. */
      function put(t, k) {
        t.r.style.setProperty('--fitq', Math.max(FITH_MIN, t.fq * k).toFixed(3));
        t.r.style.setProperty('--fita', Math.max(FITH_MIN, t.fa * k).toFixed(3));
      }
      for (var i = 0; i < 7; i++) {
        todo.forEach(function (t) { t.k = (t.lo + t.hi) / 2; put(t, t.k); });
        todo.forEach(function (t) { if (over(t.r, 0.3) > 1) t.hi = t.k; else t.lo = t.k; });
      }
      todo.forEach(function (t) { put(t, t.lo); });
    }
    var fitWait = null;
    function refitBoard() {
      if (S.screen !== 'board' || !shell.classList.contains('is-on')) return;
      clearTimeout(fitWait); fitWait = setTimeout(fitBoard, 120);
    }
    window.addEventListener('resize', refitBoard);
    window.addEventListener('resize', refitCards);
    try { if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', refitCards); } catch (err) {}
    /* The FIRST fit measured the rows in the fallback font (the board's heavy weights of the
       web font load the moment the board first uses them), or measured a board still 0 wide
       while the shell animated in and skipped every row. Nothing measured again until the
       window was resized, so on the live page a few answers ran off their column on every
       first load. The board now fits again when a web font finishes loading and whenever
       the columns' own width really moves. */
    try {
      if (document.fonts) {
        if (document.fonts.ready) document.fonts.ready.then(refitBoard);
        if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', refitBoard);
      }
    } catch (err) {}
    /* ...and when their HEIGHT moves: the height fit measured rows before the top bar had
       settled (it wraps to a second line once its font lands, or when a toggle re-renders it),
       the rows got shorter, and nothing fitted again, so a few stayed a pixel over. On a phone
       the columns scroll, so their height does not follow the rows and this cannot loop. */
    var stopBoardW = null, stopBoardH = null;
    function watchBoard() {
      if (stopBoardW) stopBoardW();
      if (stopBoardH) stopBoardH();
      var box = elBo.querySelector('.sl-board-cols');
      stopBoardW = box ? watchWidth(box, refitBoard) : null;
      stopBoardH = null;
      if (box && window.ResizeObserver) {
        var lastH = box.clientHeight, ro = new ResizeObserver(function () {
          var h = box.clientHeight;
          if (!h || Math.abs(h - lastH) < 2) return;
          lastH = h; refitBoard();
        });
        ro.observe(box);
        stopBoardH = function () { ro.disconnect(); };
      }
    }
    /* A column head is one row: the title, the level chips, the refresh. Three
       columns of a nine-level skill at 1280 wide asked the head for 80px more
       than it had, and the refresh - the one control every column keeps - was
       the part the column's edge cut off. The heads are measured like the rows,
       and the whole board steps down together so every head matches: first the
       short title (.hd-short), then smaller chips (.hd-small). Past that the
       CSS lets the title end in an ellipsis and the chips scroll under a fade,
       with the level being worked scrolled into view. Nothing pushes the
       refresh out. */
    function fitHeads(root) {
      var box = (root && root.querySelector ? root : elBo).querySelector('.sl-board-cols'); if (!box) return;
      var titles = box.querySelectorAll('.sl-bhead .btitle'), strips = box.querySelectorAll('.sl-bhead .sl-lvlchips');
      /* the title's own text against its box, in real (sub-pixel) widths: "Questions 1 to 8" ran 0.06px
         over a 125.75px box, scrollWidth rounded both to 126, and the head kept the long title with an
         ellipsis instead of stepping down to "1 to 8" (2026-09-25) */
      function over(el) { var r = document.createRange(); r.selectNodeContents(el); return r.getBoundingClientRect().width > el.getBoundingClientRect().width + 0.01; }
      function squeezed() {
        var k;
        for (k = 0; k < titles.length; k++) if (titles[k].scrollWidth > titles[k].clientWidth + 1 || over(titles[k])) return true;
        for (k = 0; k < strips.length; k++) if (strips[k].scrollWidth > strips[k].clientWidth + 1) return true;
        return false;
      }
      box.classList.remove('hd-short', 'hd-small');
      if (squeezed()) { box.classList.add('hd-short'); if (squeezed()) box.classList.add('hd-small'); }
      each(strips, function (s) {
        var on = s.querySelectorAll('.sl-chip--now'), first = s.firstElementChild;
        if (on.length && first && s.scrollWidth > s.clientWidth + 1) {
          var a = on[0], b = on[on.length - 1];
          s.scrollLeft = (a.offsetLeft + b.offsetLeft + b.offsetWidth) / 2 - first.offsetLeft - s.clientWidth / 2;
        } else s.scrollLeft = 0;
        chipFade(s);
      });
    }
    function chipFade(s) {
      var over = s.scrollWidth > s.clientWidth + 1;
      s.classList.toggle('is-fl', over && s.scrollLeft > 1);
      s.classList.toggle('is-fr', over && s.scrollLeft + s.clientWidth < s.scrollWidth - 1);
    }
    elBo.addEventListener('scroll', function (e) {
      var s = e.target; if (s.classList && s.classList.contains('sl-lvlchips')) chipFade(s);
    }, true);
    /* a mouse wheel turns up and down: over a strip that scrolls sideways it moves the chips */
    elBo.addEventListener('wheel', function (e) {
      var s = e.target.closest ? e.target.closest('.sl-bhead .sl-lvlchips') : null;
      if (!s || s.scrollWidth <= s.clientWidth + 1 || Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
      s.scrollLeft += e.deltaY * (e.deltaMode === 1 ? 16 : 1); e.preventDefault();
    }, { passive: false });
    /* the toolbar toggle sets every row at once; a row click sets just that one */
    function setAllAns(v) {
      S.board.ans = v; syncHash(false);
      S.board.cols.forEach(function (c) { c.items.forEach(function (it) { it.ans = v; }); });
    }
    /* The answers toggle used to rebuild the board, which threw away the rows
       the answers would have faded in on. Now it patches the rows in place, so
       they fade up one after another (is-cascade adds the row's own delay), and
       the class comes off once the cascade has run so a single row click is
       not delayed by it. */
    var cascadeT = null;
    function paintAns() {
      var cols = elBo.querySelector('.sl-board-cols'), main = elBo.querySelector('.sl-board-main');
      if (!cols) { renderBoard(); return; }
      if (main) main.classList.toggle('show-ans', S.board.ans);
      cols.classList.add('is-cascade');
      each(cols.querySelectorAll('.sl-brow'), function (r) {
        var p = r.getAttribute('data-brow').split('.'), col = S.board.cols[Number(p[0])], it = col && col.items[Number(p[1])], on = !!(it && it.ans);
        r.classList.toggle('is-ans', on); r.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      clearTimeout(cascadeT); cascadeT = setTimeout(function () { cols.classList.remove('is-cascade'); }, 1000);
    }
    elBo.addEventListener('click', function (e) {
      var fq = e.target.closest ? e.target.closest('[data-bfresh]') : null;
      if (fq) { var fp = fq.getAttribute('data-bfresh').split('.'); freshBoardQ(Number(fp[0]), Number(fp[1])); return; }
      var t = e.target.closest ? e.target.closest('button') : null; if (!t) return;
      var bTopic = t.closest('.sl-topic');
      if (bTopic) {
        var bsk = SL.get(bTopic.getAttribute('data-topic'));
        if (bsk && levelClick(t, bsk, (S.from !== 'mixed' && S.board.layout === 'diff') ? 3 : 0)) { buildBoard(); renderBoard(); renderTop(); }
        return;
      }
      if (t.hasAttribute('data-btab')) { S.board.tab = Number(t.getAttribute('data-btab')); renderBoard(); return; }
      if (t.hasAttribute('data-bnew')) { redealCol(Number(t.getAttribute('data-bnew'))); return; }
      if (t.hasAttribute('data-brow')) {
        var p = t.getAttribute('data-brow').split('.'), col = S.board.cols[Number(p[0])];
        if (!col) return;
        var it = col.items[Number(p[1])]; if (!it) return;
        it.ans = !it.ans;
        t.classList.toggle('is-ans', it.ans);
        t.setAttribute('aria-pressed', it.ans ? 'true' : 'false');
        return;
      }
    });

    /* ============================================================
       SPEED
       The fourth thing you can do with a skill. Practise is ten questions
       with the marking left to you; Speed is the same questions against a
       clock, typed on a keypad, with every answer TIMED so the results can
       say where the time actually went and which level is costing it.

       Two shapes, named the way the rest of the site names them:
         Race           - 10 to 50 questions, stopwatch, score is the time.
         Beat the clock - 1 to 10 minutes, endless questions, score is the
                          number right.

       Questions come from the SAME dealer as everything else. `dealFor` keeps
       its quota plan on the ctx it is handed (see counting.js `stateFor`), and
       a plan refills itself when it empties, so one long-lived ctx per skill
       keeps a level's mix right for a four-minute run. `ctx.seen` is the part
       that cannot run forever - after a hundred questions everything is seen
       and the generator falls back to a repeat - so each skill's ctx is
       replaced every ten questions. That is the rolling block: the quota is
       calibrated on ten, so it is dealt in tens.
       ============================================================ */
    var elSpS = $('slSpeedSetup'), elSp = $('slSpeed');
    var KSP = 'shlc_sl_speed_v1';
    /* SPEED SLIDERS (2026-09-21, Aadam: "change both to sliders, min 10 questions max 50, min 1 minute,
       max 10 minutes"). A Race is 10 to 50 questions in fives; Beat the clock is 1 to 10 whole minutes,
       kept in SECONDS so the runs and bests saved before still match. Anything else, from an old save or
       an old link, snaps to the nearest stop in range. Declarations, so load() can use them early. */
    function spRange(shape) { return shape === 'race' ? { lo: 10, hi: 50, step: 5, unit: 1 } : { lo: 60, hi: 600, step: 60, unit: 60 }; }
    function spSnap(shape, v) {
      var r = spRange(shape); v = Number(v);
      if (!isFinite(v) || v <= 0) return 0;
      return Math.min(r.hi, Math.max(r.lo, Math.round(v / r.step) * r.step));
    }
    function spStops(shape) { var r = spRange(shape), a = []; for (var v = r.lo; v <= r.hi; v += r.step) a.push(v); return a; }
    function spShapeName(shape) { return shape === 'race' ? 'Race' : 'Beat the clock'; }
    function spLenParts(shape, v) {
      if (shape === 'race') return { n: String(v), u: 'questions' };
      var m = v / 60;
      if (v < 60) return { n: String(v), u: 'seconds' };
      return { n: m % 1 ? Math.floor(m) + '½' : String(m), u: m === 1 ? 'minute' : 'minutes' };
    }

    /* ---------- what a run is while it is running ---------- */
    var SP = {
      on: false, phase: 'play', shape: 'race', len: 10,
      i: 0, item: null, log: [], deal: {}, turn: 0,
      t0: 0, paused: 0, pauseAt: 0, qAt: 0, tick: null,
      cd: 0, cdT: null, lock: null, entry: [], bi: 0, picked: null,
      stopped: false, run: null, prev: null, bestBefore: null, isBest: false
    };

    /* ---------- storage: runs and personal bests, on this device ---------- */
    function spStore() {
      var d = lsGet(KSP, null);
      if (!d || typeof d !== 'object') return { runs: [], best: {} };
      return { runs: Array.isArray(d.runs) ? d.runs : [], best: (d.best && typeof d.best === 'object') ? d.best : {} };
    }
    /* forty runs is a couple of months of use and about 8 KB */
    function spPut(st) { lsSet(KSP, { runs: st.runs.slice(0, 40), best: st.best }); }
    /* Two runs are comparable only when the shape, the length AND the exact
       skills and levels match - the Quick Maths rule. Ordering five numbers and
       typing "-7" are not the same job, so a mix never compares to one skill. */
    function spSig(shape, len, skills) {
      var parts = skills.map(function (sk) { return sk.id + ':' + selLevels(sk).join('.'); }).sort();
      return shape + '|' + len + '|' + parts.join(',');
    }
    function spCurSig() { return spSig(S.speed.shape, spLen(), raceSkills()); }
    function spLen() { return S.speed.shape === 'race' ? S.speed.n : S.speed.secs; }
    function spRunsFor(sig) { return spStore().runs.filter(function (r) { return r.sig === sig; }); }
    function spBestFor(sig) { var b = spStore().best[sig]; return b || null; }
    /* A Race is won on ACCURACY first and time second, and a Beat the clock on
       how many are right. Ranking a race on time alone makes guessing fast the
       winning move: 9 of 10 in 20s would beat 10 of 10 in 24s. */
    function spBetter(shape, run, best) {
      if (!best) return true;
      if (shape !== 'race') return run.ok > best.ok;
      if (run.ok !== best.ok) return run.ok > best.ok;
      return run.ms < best.ms;
    }

    /* ---------- sound: made in the browser, no files to ship ----------
       push.py only carries text assets, so every sound here is an oscillator.
       The context is created on the first press inside a gesture and resumed
       there too, because iOS starts it suspended. */
    var AC = null;
    function audio() {
      if (!S.sound) return null;
      try {
        if (!AC) { var C = window.AudioContext || window.webkitAudioContext; if (!C) return null; AC = new C(); }
        if (AC.state === 'suspended' && AC.resume) AC.resume();
        return AC;
      } catch (err) { return null; }
    }
    function tone(freq, at, dur, vol, type) {
      var a = audio(); if (!a) return;
      try {
        var o = a.createOscillator(), g = a.createGain(), t = a.currentTime + at;
        o.type = type || 'sine'; o.frequency.setValueAtTime(freq, t);
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(vol, t + 0.012);
        g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
        o.connect(g); g.connect(a.destination); o.start(t); o.stop(t + dur + 0.02);
      } catch (err) {}
    }
    var SOUND = {
      ok: function () { tone(660, 0, 0.09, 0.16); tone(990, 0.07, 0.11, 0.13); },
      bad: function () { tone(196, 0, 0.16, 0.13, 'square'); },
      tick: function () { tone(520, 0, 0.07, 0.09); },
      go: function () { tone(880, 0, 0.16, 0.15); },
      low: function () { tone(440, 0, 0.06, 0.08); },
      end: function () { tone(587, 0, 0.13, 0.14); tone(740, 0.11, 0.13, 0.14); tone(988, 0.22, 0.26, 0.14); }
    };
    function sfx(k) { if (S.sound && SOUND[k]) SOUND[k](); }
    function toggleSound() { S.sound = !S.sound; save(); if (S.sound) sfx('go'); }

    /* ---------- dealing, one question at a time ---------- */
    function freshCtx() { return { seen: {}, shapeSeen: {}, last: null }; }
    function spNext() {
      var sks = raceSkills(); if (!sks.length) return null;
      var sk = sks[SP.turn % sks.length]; SP.turn++;
      var d = SP.deal[sk.id] || (SP.deal[sk.id] = { ctx: freshCtx(), n: 0, k: 0 });
      if (d.n >= 10) { d.ctx = freshCtx(); d.n = 0; }
      d.n++;
      var levels = selLevels(sk);
      return makeItem(sk, levels[d.k++ % levels.length], d.ctx);
    }

    /* ---------- how a question is answered ----------
       Three kinds, and every question is one of them:
         choice - the options ARE the answer box, one tap
         pad    - numbers, so the keypad drives it
         text   - words (writing a number out), so a real input and the
                  device's own keyboard
       A skill with none of these cannot be raced, and the Speed card is not
       offered for it - see `canRace`. (There used to be a `spSkillOK` here that
       sampled make() to decide the same thing; it was never called, it could not
       work on a manifest stub, and the comment claiming it gated the card was
       wrong for as long as it sat there. Removed 2026-09-24.) */
    function spNumeric(f) { return f.type !== 'text' && /^[£$]?\s*[-−]?[\d.,\s]+p?$/.test(String(f.ans)); }
    function spInput(it) {
      if (!it) return null;
      if (it.q.choice) return { kind: 'choice', ch: it.q.choice };
      var fs = typeFields(it); if (!fs) return null;
      return { kind: fs.every(spNumeric) ? 'pad' : 'text', fs: fs };
    }

    /* ---------- the clock ----------
       A deadline, never a sum of intervals: a tab that sleeps stops firing and
       an accumulating clock loses whatever it slept through. */
    /* SP.t0 is only set when the 3, 2, 1 clears: before that nothing has been timed, so the
       clock reads 0:00 on a Race and the full length on Beat the clock, never Date.now() - 0 */
    function spElapsed() { if (!SP.on || SP.cd || !SP.t0) return 0; return (SP.pauseAt ? SP.pauseAt : Date.now()) - SP.t0 - SP.paused; }
    function spLeft() { return Math.max(0, SP.len * 1000 - spElapsed()); }
    function spClock(ms) {
      var t = Math.max(0, Math.round(ms / 1000));
      return Math.floor(t / 60) + ':' + ('0' + (t % 60)).slice(-2);
    }
    function spSecs(ms) { return (ms / 1000).toFixed(1) + 's'; }
    function spStopTick() { if (SP.tick) { clearInterval(SP.tick); SP.tick = null; } }
    function spStartTick() {
      spStopTick();
      var lowAt = -1;
      SP.tick = setInterval(function () {
        if (!SP.on || SP.phase !== 'play' || SP.pauseAt) return;
        if (SP.shape === 'clock') {
          var left = spLeft(), s = Math.ceil(left / 1000);
          if (s <= 5 && s !== lowAt) { lowAt = s; if (s > 0) sfx('low'); }
          if (left <= 0) { spFinish(false); return; }
        }
        spPaintClock();
      }, 100);
    }
    /* how far through: questions done in a Race, time used on the clock */
    function spProgress() {
      if (SP.shape === 'clock') return SP.t0 ? Math.min(100, spElapsed() / (SP.len * 1000) * 100) : 0;
      return SP.len ? Math.min(100, SP.i / SP.len * 100) : 0;
    }
    function spPaintClock() {
      var f = $('slSpFace'); if (!f) return;
      var ms = SP.shape === 'clock' ? spLeft() : spElapsed();
      f.textContent = spClock(ms);
      f.parentNode.classList.toggle('is-low', SP.shape === 'clock' && ms <= 10000);
      var pr = $('slSpProg');
      if (pr && SP.shape === 'clock') { pr.style.width = spProgress().toFixed(1) + '%'; pr.parentNode.classList.toggle('is-low', ms <= 10000); }
    }
    /* fit a sum on one line: shrink it to the width it has, down to half size,
       and only then let it wrap (centred). Words are left to wrap naturally. */
    function spFitQ() {
      var ex = elSp.querySelector('.sl-spexpr'); if (!ex || ex.classList.contains('is-words')) return;
      ex.style.fontSize = ''; ex.classList.remove('is-wrap');
      var room = ex.parentNode.clientWidth - 6, need = ex.scrollWidth;
      if (!room || need <= room) return;
      var base = parseFloat(getComputedStyle(ex).fontSize) || 40, f = Math.max(0.5, room / need);
      ex.style.fontSize = (base * f).toFixed(1) + 'px';
      if (ex.scrollWidth > room + 1) ex.classList.add('is-wrap');
    }
    window.addEventListener('resize', function () { if (S.screen === 'speed' && SP.phase === 'play') spFitQ(); });

    /* ---------- a run ---------- */
    function spReset() {
      spStopTick(); clearTimeout(SP.cdT); clearTimeout(SP.lock);
      SP.on = false; SP.phase = 'play'; SP.i = 0; SP.item = null; SP.log = [];
      SP.deal = {}; SP.turn = 0; SP.t0 = 0; SP.paused = 0; SP.pauseAt = 0; SP.qAt = 0;
      SP.cd = 0; SP.entry = []; SP.bi = 0; SP.picked = null; SP.stopped = false;
      SP.run = null; SP.prev = null; SP.bestBefore = null; SP.isBest = false;
    }
    /* The minus and point keys are decided once for the whole run, from a sample
       of what these levels deal - never per question. A minus key that turned
       up only when the answer was negative told the child the sign before they
       had worked anything out, and the pad changed shape between questions. */
    function spKeySet() {
      var neg = false, dot = false;
      raceSkills().forEach(function (sk) {
        selLevels(sk).forEach(function (lv) {
          var ctx = freshCtx();
          for (var t = 0; t < 14 && !(neg && dot); t++) {
            var it; try { it = makeItem(sk, lv, ctx); } catch (err) { continue; }
            var inp = spInput(it); if (!inp || inp.kind !== 'pad') continue;
            var all = inp.fs.map(function (f) { return String(f.ans); }).join(' ');
            if (/[-\u2212]/.test(all)) neg = true;
            if (/[.\u00a3]/.test(all)) dot = true;
          }
        });
      });
      return { neg: neg, dot: dot };
    }
    function spStart() {
      spReset();
      SP.keys = spKeySet();
      SP.on = true; SP.shape = S.speed.shape; SP.len = spLen();
      SP.sig = spCurSig(); SP.bestBefore = spBestFor(SP.sig);
      SP.skills = raceSkills().map(function (sk) { return { id: sk.id, levels: selLevels(sk) }; });
      SP.item = spNext();
      /* 3, 2, 1 - and nothing is timed or accepted until it clears */
      SP.cd = 3; spRender();
      (function step() {
        SP.cdT = setTimeout(function () {
          SP.cd--;
          if (SP.cd > 0) { sfx('tick'); spRender(); step(); return; }
          sfx('go');
          SP.cd = 0; SP.t0 = Date.now(); SP.qAt = SP.t0;
          spRender(); spStartTick();
        }, 850);
      })();
      sfx('tick');
    }
    function spArm() { SP.qAt = Date.now(); SP.entry = []; SP.bi = 0; SP.picked = null; }
    /* the answer is in: log it with its time, flash it, then move on */
    function spAnswer(got, typed, typedHTML) {
      if (!SP.on || SP.phase !== 'play' || SP.cd || SP.lock || SP.pauseAt) return;
      var it = SP.item, ms = Date.now() - SP.qAt;
      it.state = got ? 'ok' : 'miss'; it.typed = typed || ''; it.typedHTML = typedHTML || '';
      SP.log.push({ sk: it.skill.id, name: it.skill.short || it.skill.name, lv: it.level, ms: ms, ok: got, q: it.q.html, t: spPlain(it.q), a: it.q.ansHTML, typedHTML: typedHTML || '' });
      spProg(it, got);
      SP.i++;
      sfx(got ? 'ok' : 'bad');
      spRender();
      /* the flash is not thinking time: the next question's clock starts when
         the next question is on the screen, not when this one was answered */
      SP.lock = setTimeout(function () {
        SP.lock = null;
        if (SP.shape === 'race' && SP.i >= SP.len) { spFinish(false); return; }
        if (SP.shape === 'clock' && spLeft() <= 0) { spFinish(false); return; }
        SP.item = spNext(); spArm(); spRender();
      }, got ? 340 : 800);
    }
    /* q.text is written for machines: "(x - 3)^2", "-9(x + 7)", Write "nineteen". The results screen
       shows it to the child (the chart's tips, the three that took longest), so it gets the page's minus
       sign, squares and curly quotes. A hyphen only becomes a minus after a space or a bracket, so
       forty-six and 10-digit keep theirs. */
    var SP_SUP = { 0: '⁰', 1: '¹', 2: '²', 3: '³', 4: '⁴', 5: '⁵', 6: '⁶', 7: '⁷', 8: '⁸', 9: '⁹' };
    function spTidy(t) {
      return t.replace(/\^(\d+)/g, function (m, d) { return d.replace(/\d/g, function (c) { return SP_SUP[c]; }); })
        .replace(/(^|[\s(\[])-/g, '$1−')
        .replace(/"([^"]*)"/g, '“$1”');
    }
    function spPlain(q) {
      var t = String(q.text || '').trim();
      if (t) return spTidy(t);
      return el('div', null, q.html || '').textContent.replace(/\s+/g, ' ').trim();
    }
    /* Speed marks count towards a level the same way Practise does */
    function spProg(it, got) {
      var p = S.prog[it.skill.id] = S.prog[it.skill.id] || {};
      var r = p[it.level] = p[it.level] || { n: 0, ok: 0 };
      r.n++; if (got) r.ok++;
      trackSecure(it.skill, it.level, r);
      save();
    }
    function spPause(on) {
      if (!SP.on || SP.phase !== 'play' || SP.cd) return;
      if (on && !SP.pauseAt) { SP.pauseAt = Date.now(); spRender(); return; }
      if (!on && SP.pauseAt) { SP.paused += Date.now() - SP.pauseAt; SP.pauseAt = 0; spArm(); spRender(); }
    }
    function spFinish(stopped) {
      spStopTick(); clearTimeout(SP.lock); SP.lock = null;
      if (SP.pauseAt) { SP.paused += Date.now() - SP.pauseAt; SP.pauseAt = 0; }
      SP.stopped = !!stopped; SP.phase = 'done';
      var ok = SP.log.filter(function (r) { return r.ok; }).length;
      var run = {
        t: Date.now(), sig: SP.sig, shape: SP.shape, len: SP.len,
        n: SP.log.length, ok: ok, ms: spElapsed(), med: spMedian(SP.log.map(function (r) { return r.ms; })),
        x: stopped ? 1 : 0, from: S.from,
        skills: SP.skills, rows: SP.log.map(function (r) { return { sk: r.sk, lv: r.lv, ms: r.ms, ok: r.ok }; })
      };
      SP.run = run;
      var st = spStore();
      /* only a finished run compares, and only a finished run can be a best:
         quitting a 25 after 3 must not read as a personal best */
      SP.prev = st.runs.filter(function (r) { return r.sig === run.sig && !r.x; })[0] || null;
      if (!stopped && run.n) {
        SP.isBest = spBetter(SP.shape, run, st.best[run.sig]);
        if (SP.isBest) st.best[run.sig] = { ms: run.ms, ok: run.ok, n: run.n, t: run.t };
      }
      st.runs.unshift(run); spPut(st);
      sfx('end');
      spRender();
    }
    function spMedian(a) {
      if (!a.length) return 0;
      var b = a.slice().sort(function (x, y) { return x - y; }), m = b.length >> 1;
      return b.length % 2 ? b[m] : Math.round((b[m - 1] + b[m]) / 2);
    }

    /* ============================================================
       SPEED SETUP
       ============================================================ */
    function spHistHTML(sig) {
      var runs = spRunsFor(sig).slice(0, 5);
      if (!runs.length) return '<div class="sl-lvlnote">No runs at these levels yet.</div>';
      return '<div class="sl-splist">' + runs.map(function (r) {
        return '<div class="sl-sprow' + (r.x ? ' is-part' : '') + '"><b>' + (r.shape === 'race' ? spClock(r.ms) : r.ok + ' right') + '</b>' +
          '<span>' + (r.shape === 'race' ? r.ok + ' of ' + r.n + ' right' : 'in ' + spClock(r.len * 1000)) + (r.x ? ' · stopped early' : '') + '</span>' +
          '<i>' + spWhen(r.t) + '</i></div>';
      }).join('') + '</div>';
    }
    function spWhen(t) {
      var d = Date.now() - t, day = 86400000;
      if (d < 3600000) return Math.max(1, Math.round(d / 60000)) + ' min ago';
      if (d < day) return Math.round(d / 3600000) + 'h ago';
      if (d < 7 * day) return Math.round(d / day) + 'd ago';
      try { return new Date(t).toLocaleDateString(); } catch (e) { return ''; }
    }
    function spBestHTML(sig, shape) {
      var b = spBestFor(sig);
      if (!b) return '';
      return '<div class="sl-spbest">' + ICON.trophy + '<b>Your best</b><span>' +
        (shape === 'race' ? spClock(b.ms) + ' · ' + b.ok + ' of ' + b.n + ' right' : b.ok + ' right') + '</span></div>';
    }
    /* the level list starts open on a laptop and CLOSED on a phone: the levels
       were picked on the skill screen already, and twelve rows of them pushed
       the run's own settings 1,100px down */
    var spLvOpen = null;
    function renderSpeedSetup() {
      var sk = curSkill(), mixed = S.from === 'mixed';
      if (!mixed && !sk) { show('library'); return; }
      /* reached by a stale deep link or a back button after the card went: a skill that cannot
         be raced has no Speed screen to set up */
      if (!mixed && !canRace(sk)) { show('skill'); return; }
      var mixRace = mixSkills().filter(canRace), mixOut = mixSkills().filter(function (x) { return !canRace(x); });
      if (mixed && !mixRace.length) { show('library'); return; }
      if (spLvOpen === null) spLvOpen = !narrow();
      var who = mixed
        /* a basket may hold a skill that cannot be raced; say so in the same line rather than
           quietly dropping it, or the run looks like it lost questions. No new class: the
           stylesheet is shared and this needs nothing the span has not got. */
        ? '<div class="sl-spwho"><div><b>Mixed practice</b><span>' + mixRace.map(function (x) { return esc(x.short || x.name); }).join(' · ') +
            (mixOut.length ? '. Not in a race: ' + esc(mixOut.map(function (x) { return x.short || x.name; }).join(' · ')) + ', because their answers are revealed rather than typed' : '') +
            '</span></div></div>'
        : '<div class="sl-spwho"><div><b>' + esc(sk.name) + '</b><span>' + esc(levelWord(sk)) + '</span></div>' +
            '<button type="button" class="sl-btn sl-btn--sm sl-btn--ghost" id="slSpLv" aria-expanded="' + (spLvOpen ? 'true' : 'false') + '">' + (spLvOpen ? ICON.chevD + 'Hide levels' : ICON.sliders + 'Change levels') + '</button></div>';
      var lvList = !mixed && spLvOpen ? '<div class="sl-splvlist">' + levelListHTML(sk, true) + '</div>' : '';
      /* SPEED SLIDERS (2026-09-21): each card is one big slider, a big readout and one Start button.
         Moving a slider keeps that length at once (so it is there next time) and makes that card the
         one Your best and Recent runs below are for; the card used last carries the ring. */
      var opts = '<div class="sl-spgo">' + spCardHTML('race') + spCardHTML('clock') + '</div>' +
        '<div class="sl-spfoot"><span>Slide to set the length, then press Start</span>' +
          '<button type="button" class="sl-iconbtn' + (S.sound ? '' : ' is-off') + '" id="slSpSound" aria-pressed="' + (S.sound ? 'true' : 'false') + '" aria-label="Sound" data-tip="' + (S.sound ? 'Sound on' : 'Sound off') + '">' + (S.sound ? ICON.sound : ICON.mute) + '</button>' +
        '</div>';
      paint(elSpS, '<div class="sl-main"><div class="sl-scroll"><div class="sl-setup sl-spsetup' + (entering ? ' is-enter' : '') + '">' +
        '<h2>Speed</h2>' + who + opts + lvList +
        '<div class="sl-sphistwrap" id="slSpHist">' + spSetupHistHTML() + '</div>' +
        '</div></div></div>');
    }
    /* Your best and Recent runs for the length on the card being set */
    function spSetupHistHTML() {
      var sig = spCurSig(), hist = spRunsFor(sig).length, lw = spLenParts(S.speed.shape, spLen());
      return spBestHTML(sig, S.speed.shape) +
        (hist ? '<section class="sl-spsec"><span class="sl-sect">Recent runs: ' + spShapeName(S.speed.shape) + ', ' + lw.n + ' ' + lw.u + '</span>' + spHistHTML(sig) + '</section>' : '');
    }
    /* one card: the name, the readout, the slider with every stop named under it, and Start.
       The slider counts questions, or whole minutes; the state keeps seconds. */
    function spCardHTML(shape) {
      var race = shape === 'race', r = spRange(shape), v = spSnap(shape, race ? S.speed.n : S.speed.secs) || r.lo;
      var w = spLenParts(shape, v), span = r.hi - r.lo, name = spShapeName(shape);
      return '<div class="sl-sptapcol sl-spcard is-' + shape + (S.speed.shape === shape ? ' is-last' : '') + '" data-spcard="' + shape + '">' +
        '<div class="sl-sptaphead"><span class="sl-sptapicon">' + (race ? ICON.flag : ICON.clock) + '</span>' +
          '<div><b>' + name + '</b><span>' + (race ? 'Answer them all, fast' : 'Most right in the time') + '</span></div></div>' +
        '<div class="sl-slider sl-spslide" style="--p:' + ((v - r.lo) / span).toFixed(4) + '">' +
          '<output class="sl-spval" for="slSpRange-' + shape + '" aria-hidden="true"><b class="num">' + w.n + '</b><i>' + w.u + '</i></output>' +
          '<input type="range" class="sl-range" id="slSpRange-' + shape + '" min="' + r.lo / r.unit + '" max="' + r.hi / r.unit + '" step="' + r.step / r.unit + '" value="' + v / r.unit + '"' +
            ' data-spslide="' + shape + '" aria-label="' + name + ' length" aria-valuetext="' + w.n + ' ' + w.u + '">' +
          '<div class="sl-slticks">' + spStops(shape).map(function (s) {
            return '<button type="button" class="sl-slstop num' + (s === v ? ' is-on' : '') + '" style="--k:' + ((s - r.lo) / span).toFixed(4) + '" data-spstop="' + shape + ':' + s + '" tabindex="-1" aria-label="' + spLenParts(shape, s).n + ' ' + spLenParts(shape, s).u + '">' + s / r.unit + '</button>';
          }).join('') + '</div>' +
        '</div>' +
        '<button type="button" class="sl-btn sl-btn--cta sl-spstart" data-spgo="' + shape + '" aria-label="Start ' + name + ', ' + w.n + ' ' + w.u + '">' + ICON.play + '<span>Start</span></button>' +
      '</div>';
    }
    /* a slider moved (or a stop under it pressed): the readout, the fill and the stop names follow in
       place, so the focused slider keeps the focus and the arrow keys keep working */
    function spSlideSet(shape, v) {
      v = spSnap(shape, v); if (!v) return;
      var r = spRange(shape), w = spLenParts(shape, v), words = w.n + ' ' + w.u;
      if (shape === 'race') S.speed.n = v; else S.speed.secs = v;
      S.speed.shape = shape;
      var card = elSpS.querySelector('[data-spcard="' + shape + '"]');
      if (card) {
        var inp = card.querySelector('.sl-range'), wrap = card.querySelector('.sl-spslide'), o = card.querySelector('.sl-spval'), go = card.querySelector('[data-spgo]');
        if (inp) { if (Number(inp.value) !== v / r.unit) inp.value = String(v / r.unit); inp.setAttribute('aria-valuetext', words); }
        if (wrap) wrap.style.setProperty('--p', ((v - r.lo) / (r.hi - r.lo)).toFixed(4));
        if (o) o.innerHTML = '<b class="num">' + w.n + '</b><i>' + w.u + '</i>';
        each(card.querySelectorAll('.sl-slstop'), function (b) { b.classList.toggle('is-on', b.getAttribute('data-spstop') === shape + ':' + v); });
        if (go) go.setAttribute('aria-label', 'Start ' + spShapeName(shape) + ', ' + words);
      }
      each(elSpS.querySelectorAll('[data-spcard]'), function (c) { c.classList.toggle('is-last', c.getAttribute('data-spcard') === shape); });
      var h = $('slSpHist'); if (h) h.innerHTML = spSetupHistHTML();
      save();
    }
    elSpS.addEventListener('input', function (e) {
      var t = e.target, shape = t && t.getAttribute ? t.getAttribute('data-spslide') : null; if (!shape) return;
      spSlideSet(shape, Number(t.value) * spRange(shape).unit);
    });
    /* the arrow keys move a focused slider (the browser does that); Enter on it starts that card */
    elSpS.addEventListener('keydown', function (e) {
      var t = e.target, shape = t && t.getAttribute ? t.getAttribute('data-spslide') : null; if (!shape) return;
      if (e.key !== 'Enter' || e.repeat || e.metaKey || e.ctrlKey || e.altKey) return;
      e.preventDefault();
      var b = elSpS.querySelector('[data-spgo="' + shape + '"]'); if (b && !b.disabled) b.click();
    });
    elSpS.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null; if (!t) return;
      var sk = curSkill();
      var go = t.getAttribute('data-spgo');
      if (go) {
        /* the length on that card's slider, read back from the slider itself */
        var gshape = go === 'clock' ? 'clock' : 'race', gin = $('slSpRange-' + gshape);
        var gv = spSnap(gshape, gin ? Number(gin.value) * spRange(gshape).unit : (gshape === 'race' ? S.speed.n : S.speed.secs));
        S.speed.shape = gshape;
        if (gv) { if (gshape === 'race') S.speed.n = gv; else S.speed.secs = gv; }
        save();
        var race = raceSkills(); if (!race.length) return;
        withSkills(race.map(function (x) { return x.id; }), t, function () { spStart(); show('speed'); }, true);
        return;
      }
      var stop = t.getAttribute('data-spstop');
      if (stop) {
        var sp = stop.split(':'), sshape = sp[0] === 'clock' ? 'clock' : 'race';
        spSlideSet(sshape, Number(sp[1]));
        var sin = $('slSpRange-' + sshape); if (sin) { try { sin.focus({ preventScroll: true }); } catch (err) {} }
        return;
      }
      if (t.id === 'slSpSound') { toggleSound(); renderSpeedSetup(); return; }
      if (t.id === 'slSpLv') { spLvOpen = !spLvOpen; renderSpeedSetup(); return; }
      if (sk && levelClick(t, sk)) { renderSpeedSetup(); return; }
    });

    /* ============================================================
       THE RUN
       ============================================================ */
    /* what the entry looks like: one box per field, the live one lit */
    /* vals and state are for the moment after an answer: a right answer stays
       in its boxes lit green, and a miss puts the RIGHT answer in the boxes
       (the typed one is struck through on the line above), so the last thing
       the child sees at full size is the correct number, not their mistake */
    function spBoxesHTML(fs, vals, state) {
      return '<div class="sl-spboxes' + (fs.length > 1 ? ' is-many' : '') + '">' + stackFields(fs, function (f, j, vw) {
        var v = vals ? String(vals[j] == null ? '' : vals[j]) : (SP.entry[j] || '');
        var sOp = f.sign && f.op && f.op !== '/' && f.op.trim() && f.op.trim() !== '+' ? f.op : ' ';
        return { lead: j ? '<span class="af-op">' + (f.sign ? sOp : (f.op || '+')) + '</span>' : '', body: (vw.pre ? '<span class="af-t af-pre">' + vw.pre + '</span>' : '') +
          '<span class="sl-spbox' + (!state && j === SP.bi ? ' is-now' : '') + (v ? ' has-v' : '') + (state ? ' is-' + state : '') + '" data-spbox="' + j + '" style="min-width:' + ((f.w || 4) + 1) + 'ch">' +
          (v ? esc(v) : '<i>?</i>') + '</span>' + (vw.after ? '<span class="af-t">' + vw.after + '</span>' : '') };
      }, function (h) { return '<span class="af-t af-pre">' + h + '</span>'; }) + '</div>';
    }
    /* the keypad: 123 on top, the way a phone is, not a calculator. No submit
       key - a full answer checks itself, which is what makes a run fast. */
    function spPadHTML(fs, off) {
      var all = fs.map(function (f) { return String(f.ans); }).join(' '), K = SP.keys || {};
      /* the run's key set, plus this question's needs in case the sample missed
         one - a question the pad cannot type is worse than a rare hint */
      var neg = !!K.neg || /[-−]/.test(all), dot = !!K.dot || /[.]/.test(all), pound = /£/.test(all);
      var keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
      var last = [];
      if (neg) last.push(['-', '−']);
      if (dot || pound) last.push(['.', '.']);
      last.push(['0', '0']);
      last.push(['back', ICON.del]);
      return '<div class="sl-pad' + (off ? ' is-off' : '') + '">' +
        keys.map(function (k) { return '<button type="button" class="sl-key num" data-key="' + k + '">' + k + '</button>'; }).join('') +
        '<div class="sl-padlast" style="grid-template-columns:repeat(' + last.length + ',1fr)">' +
        last.map(function (k) { return '<button type="button" class="sl-key' + (k[0] === 'back' ? ' sl-key--fn' : ' num') + '" data-key="' + k[0] + '" aria-label="' + (k[0] === 'back' ? 'Delete' : k[0]) + '">' + k[1] + '</button>'; }).join('') +
        '</div></div>';
    }
    function spStageHTML() {
      var it = SP.item, inp = spInput(it), done = it.state === 'ok' || it.state === 'miss';
      var body;
      if (!inp) body = '<div class="sl-empty">This question cannot be raced.</div>';
      else if (inp.kind === 'choice') {
        var optText = inp.ch.options.map(function (o) { return el('div', null, String(o)).textContent.trim(); });
        var longOpt = optText.some(function (t) { return t.length > 12; });
        /* < > = are x-height glyphs: at a button's text size they read as specks */
        var symOpt = optText.every(function (t) { return t.length <= 2; });
        body = '<div class="sl-spchoices' + (done ? ' is-done' : '') + (longOpt ? ' is-long' : '') + (symOpt ? ' is-sym' : '') + (inp.ch.options.length > 2 && !longOpt ? ' is-3' : '') + '">' + inp.ch.options.map(function (o, k) {
          var cls = 'sl-choice' + (done && k === inp.ch.answer ? ' is-right' : '') + (done && SP.picked === k && k !== inp.ch.answer ? ' is-wrong' : '');
          return '<button type="button" class="' + cls + '" data-spopt="' + k + '"' + (done ? ' disabled' : '') + '><b>' + 'ABCDEF'.charAt(k) + '</b><span>' + o + '</span></button>';
        }).join('') + '</div>';
      } else if (inp.kind === 'text') {
        body = '<div class="sl-sptext">' +
          '<input type="text" id="slSpText" class="sl-ansin" autocomplete="off" spellcheck="false" placeholder="Type it, then Enter" aria-label="Your answer"' +
          (done ? ' disabled value="' + esc(String(it.typed || '')) + '"' : '') + '>' +
          '<button type="button" class="sl-btn sl-btn--cta" id="slSpCheck"' + (done ? ' disabled' : '') + '>' + ICON.tick + 'Check</button></div>';
      } else {
        var shown = !done ? null : (it.state === 'ok' ? SP.entry.slice() : inp.fs.map(function (f) { return String(f.ans).replace(/^\u2212/, '-'); }));
        body = spBoxesHTML(inp.fs, shown, done ? (it.state === 'ok' ? 'ok' : 'fix') : null) + spPadHTML(inp.fs, done);
      }
      var mark;
      if (!done) mark = '<div class="sl-spmark is-idle" aria-hidden="true"><span></span></div>';
      else if (it.state === 'ok') mark = '<div class="sl-spmark ok">' + ICON.tick + '<b>Right</b></div>';
      else if (inp && inp.kind === 'pad') mark = '<div class="sl-spmark miss">' + ICON.cross + '<b>You put <span class="sl-yours">' + (it.typedHTML || esc(it.typed || '')) + '</span></b></div>';
      else mark = '<div class="sl-spmark miss">' + ICON.cross + '<b>It was <span class="sl-spans">' + it.q.ansHTML + '</span></b></div>';
      /* a sentence wraps at a reading size; a sum stays on one line and is
         shrunk to fit (spFitQ), because a chain broken with a "+" at the start
         of the next line is harder to add up than a smaller one */
      var words = /[a-z]{3,}/i.test(spPlain(it.q).replace(/\b(?:sqrt|surd)\b/gi, ''));
      return '<div class="sl-spq' + (done ? ' is-' + it.state : '') + '" style="--c:' + colourOf(it.skill).col + '">' +
        (S.from === 'mixed' ? tagHTML(it.skill) : '') +
        '<div class="sl-spexpr sl-expr' + (words ? ' is-words' : '') + '">' + it.q.html + '</div>' + mark + '</div>' +
        '<div class="sl-spentry">' + body + '</div>';
    }
    function spRunTopHTML() {
      var right = SP.log.filter(function (r) { return r.ok; }).length;
      var ms = SP.shape === 'clock' ? spLeft() : spElapsed();
      return '' +
        '<div class="sl-sptimer' + (SP.shape === 'clock' && ms <= 10000 ? ' is-low' : '') + '">' + ICON.clock + '<b class="num" id="slSpFace">' + spClock(ms) + '</b></div>' +
        '<div class="sl-spstat"><b class="num">' + right + '</b><span>right</span></div>' +
        '<div class="sl-spstat sp-done"><b class="num">' + (SP.shape === 'race' ? SP.i + ' / ' + SP.len : String(SP.log.length)) + '</b><span>' + (SP.shape === 'race' ? 'done' : 'answered') + '</span></div>' +
        '<button type="button" class="sl-iconbtn" id="slSpSnd" aria-label="Sound on or off" data-tip="' + (S.sound ? 'Sound on' : 'Sound off') + '" data-tipsub="A blip for right, a buzz for wrong. Key: M">' + (S.sound ? ICON.sound : ICON.mute) + '</button>' +
        '<button type="button" class="sl-iconbtn" id="slSpPause" aria-label="Pause" data-tip="Pause" data-tipsub="The clock stops. Key: Esc">' + ICON.pause + '</button>';
    }
    function spPlayHTML() {
      var cd = SP.cd > 0;
      return '<div class="sl-main sl-run">' +
        '<div class="sl-spprog' + (SP.shape === 'clock' ? ' is-clock' : '') + '" aria-hidden="true"><i id="slSpProg" style="width:' + spProgress().toFixed(1) + '%"></i></div>' +
        '<div class="sl-runstage">' + spStageHTML() + '</div>' +
        (cd ? '<div class="sl-spover sl-spcd"><b class="num">' + SP.cd + '</b><span>Get ready</span></div>' : '') +
        (SP.pauseAt ? '<div class="sl-spover sl-sppause"><b>Paused</b><span>The clock has stopped.</span>' +
          '<div class="sl-sprow2"><button type="button" class="sl-btn sl-btn--cta" id="slSpResume">' + ICON.play + 'Carry on</button>' +
          '<button type="button" class="sl-btn sl-btn--ghost" id="slSpEnd">' + ICON.flag + 'End the run</button></div></div>' : '') +
        '</div>';
    }

    /* ============================================================
       RESULTS
       The point of the whole thing: not the score, the seconds.
       ============================================================ */
    /* WHERE THE TIME WENT. One column per question, height = seconds.
       Built to the dataviz rules: bars capped at 24px with the rest of the
       band left as air, 4px rounded tips square at the baseline, a real y-axis
       on clean seconds with solid hairline gridlines, the typical time as the
       one dashed line (it is a threshold, not a grid), a legend, and the
       slowest bar labelled with its value. Colour carries right or missed
       ONLY - height already says slow, and a third "slow" colour said it twice.
       Missed bars also carry a cross, so the state is never colour alone.
       Every mark is an <i>, never an empty <div>: Dawn hides div:empty. */
    function spTickLabel(ms) { var v = ms / 1000; return (v % 1 ? v.toFixed(1) : String(v)) + 's'; }
    function spChartHTML() {
      var n = SP.log.length, times = SP.log.map(function (r) { return r.ms; });
      var med = spMedian(times), real = Math.max.apply(null, times.concat([1]));
      /* one ten-second question flattened every other bar to a stub, so the
         scale stops at 3.5x the typical answer and anything past it is drawn
         full height with a break on top and its real time over it */
      var cap = Math.max(1, Math.min(real, Math.round(med * 3.5) || real));
      var STEPS = [200, 500, 1000, 2000, 5000, 10000, 15000, 30000, 60000], step = STEPS[STEPS.length - 1];
      for (var k = 0; k < STEPS.length; k++) if (cap / STEPS[k] <= 4) { step = STEPS[k]; break; }
      var top = Math.max(step, Math.ceil(cap / step) * step);
      /* a slowest bar only just past the top tick (4.1s on a 4s scale) is not an
         outlier worth a break mark, and the break read as a glitch: stretch the
         scale one tick instead */
      if (real > top && real <= top * 1.15) top += step;
      var pct = function (ms) { return Math.max(0, Math.min(100, ms / top * 100)); };
      var ticks = []; for (var t = 0; t <= top + 1; t += step) ticks.push(t);
      var slowI = times.indexOf(real), anyMiss = SP.log.some(function (r) { return !r.ok; });
      var every = n <= 12 ? 1 : (n <= 30 ? 5 : (n <= 100 ? 10 : (n <= 250 ? 25 : 50)));
      var cols = SP.log.map(function (r, i) {
        var h = pct(r.ms), over = r.ms > top, isTop = i === slowI;
        var edge = i === 0 ? ' is-first' : (i === n - 1 ? ' is-last' : '');
        return '<div class="sl-spcol' + (r.ok ? '' : ' is-bad') + (over ? ' is-over' : '') + (isTop ? ' is-top' : '') + edge + '" style="--h:' + h.toFixed(1) + '%"' +
          /* Aadam, 2026-09-23: the tip shows the question itself, not "Question 3 · Surds, level 2";
             the no-break spaces keep "· missed" on the line with the question's last word */
          ' data-tipkeep="1" data-tip="' + spSecs(r.ms) + '" data-tipsub="' + esc((r.t || 'Question ' + (i + 1)) + '\u00a0·\u00a0' + (r.ok ? 'right' : 'missed')) + '">' +
          (isTop ? '<b class="sl-spcap num">' + spSecs(r.ms) + '</b>' : '') +
          (r.ok ? '' : '<span class="sl-spx" aria-hidden="true">' + ICON.cross + '</span>') +
          '<i class="sl-spbar"></i>' +
          '<span class="sl-sr">Question ' + (i + 1) + ', ' + spSecs(r.ms) + ', ' + (r.ok ? 'right' : 'missed') + '</span></div>';
      }).join('');
      var xs = SP.log.map(function (r, i) {
        var q = i + 1, show = every === 1 || q === 1 || q % every === 0;
        return '<span>' + (show ? q : '') + '</span>';
      }).join('');
      return '<div class="sl-spchart' + (n > 60 ? ' is-dense' : '') + '">' +
        '<div class="sl-spyax" aria-hidden="true">' + ticks.map(function (v) { return '<span style="--y:' + pct(v).toFixed(1) + '%">' + spTickLabel(v) + '</span>'; }).join('') + '</div>' +
        '<div class="sl-spplot">' +
          ticks.map(function (v) { return '<i class="sl-spgl" style="--y:' + pct(v).toFixed(1) + '%"></i>'; }).join('') +
          '<i class="sl-spmed" style="--y:' + pct(med).toFixed(1) + '%"></i>' +
          '<div class="sl-spcols">' + cols + '</div>' +
        '</div>' +
        '<div class="sl-spxax" aria-hidden="true">' + xs + '</div>' +
        '<div class="sl-splegend">' +
          '<span><i class="sw sw-ok"></i>Right</span>' +
          (anyMiss ? '<span><i class="sw sw-bad"></i>Missed</span>' : '') +
          '<span><i class="sw sw-med"></i>Typical ' + spSecs(med) + '</span>' +
        '</div></div>';
    }
    function spByLevel() {
      var map = {}, out = [];
      SP.log.forEach(function (r) {
        var k = r.sk + '/' + r.lv;
        var e = map[k] || (map[k] = { sk: r.sk, name: r.name, lv: r.lv, n: 0, ok: 0, ms: [] });
        e.n++; if (r.ok) e.ok++; e.ms.push(r.ms);
      });
      Object.keys(map).forEach(function (k) { var e = map[k]; e.med = spMedian(e.ms); out.push(e); });
      return out.sort(function (a, b) { return b.med - a.med; });
    }
    /* What to do next: one short line and the button that does it. They are
       decided together, so the message never says "practise" over a Teach
       button. Short on purpose: it is read once, at the end of a run. */
    function spNextStep(worst) {
      var med = spMedian(SP.log.map(function (r) { return r.ms; }));
      var slowMiss = SP.log.filter(function (r) { return !r.ok && r.ms > med * 1.6; }).length;
      var slowRight = SP.log.filter(function (r) { return r.ok && r.ms > med * 1.6; }).length;
      var missed = SP.log.some(function (r) { return !r.ok; });
      var one = SP.skills && SP.skills.length === 1 ? SL.get(SP.skills[0].id) : null;
      var lvName = function (sk, n) { var nm = sk ? levelName(sk, n) : ''; return nm ? ': ' + nm : ''; };
      var teach = worst ? { kind: 'teach', sk: worst.sk, lv: worst.lv, label: (one ? 'Teach level ' + worst.lv + lvName(one, worst.lv) : 'Teach ' + worst.name + ', level ' + worst.lv) } : null;
      var prac = { kind: 'practise', label: 'Practise these levels' };
      if (!SP.log.length) return { msg: '', btn: null };
      if (slowMiss >= 2) return { msg: 'The ones you missed took longest. Watch the model first.', btn: teach };
      if (!missed && slowRight >= 3) return { msg: 'Every one right, but a few were slow. Race it again.', btn: null };
      if (!missed) {
        if (one) {
          var top = Math.max.apply(null, SP.skills[0].levels);
          if (top < one.levels.length) return { msg: 'Every one right. Try the next level up.', btn: { kind: 'up', sk: one.id, lv: top + 1, label: 'Race level ' + (top + 1) + lvName(one, top + 1) } };
        }
        return { msg: 'Every one right. Race it again to beat your time.', btn: null };
      }
      return { msg: 'You missed a few. Practise without the clock, then race again.', btn: prac };
    }
    function spDeltaHTML() {
      if (SP.stopped || !SP.prev || !SP.run.n) return '';
      var d, txt;
      if (SP.shape === 'race') {
        /* accuracy first, the same order a best is judged in: the score change
           leads and sets the colour, and the time only decides when the score
           is the same. "2.1s slower, and 1 more right" in red under a gold
           Personal best badge told the child two opposite things. */
        d = SP.prev.ms - SP.run.ms;
        var dk = SP.run.ok - SP.prev.ok, tpart = Math.abs(d) < 700 ? '' : (d > 0 ? spSecs(d) + ' faster' : spSecs(-d) + ' slower');
        if (dk !== 0) {
          txt = (dk > 0 ? dk + ' more right' : (-dk) + ' fewer right') + ' than last time' + (tpart ? ', ' + tpart + '.' : '.');
          return '<div class="sl-spdelta' + (dk > 0 ? ' is-up' : ' is-down') + '">' + txt + '</div>';
        }
        txt = tpart ? tpart + ' than last time.' : 'The same pace as last time.';
        return '<div class="sl-spdelta' + (d > 700 ? ' is-up' : (d < -700 ? ' is-down' : '')) + '">' + txt + '</div>';
      }
      d = SP.run.ok - SP.prev.ok;
      txt = d === 0 ? 'The same as last time.' : (d > 0 ? d + ' more right than last time.' : (-d) + ' fewer than last time.');
      return '<div class="sl-spdelta' + (d > 0 ? ' is-up' : (d < 0 ? ' is-down' : '')) + '">' + txt + '</div>';
    }
    function spResultHTML() {
      var r = SP.run, ok = r.ok, n = r.n, med = r.med, mixed = SP.skills && SP.skills.length > 1;
      var times = SP.log.map(function (x) { return x.ms; });
      var fast = Math.min.apply(null, times.concat([Infinity])), slowest = Math.max.apply(null, times.concat([0]));
      var half = Math.ceil(SP.log.length / 2);
      var pace = SP.log.length >= 6
        ? (spMedian(times.slice(half)) < spMedian(times.slice(0, half)) ? 'You sped up as you went.' : 'You slowed down as you went.')
        : '';
      var lv = spByLevel(), worst = lv[0];
      var hero = SP.shape === 'race' ? spClock(r.ms) : String(ok);
      var heroSub = SP.shape === 'race' ? ok + ' of ' + n + ' right' : 'right in ' + spClock(r.len * 1000);
      /* one line under the number, and only when it says something the badge
         and the number do not: "Your best yet" under a Personal best badge said
         the same thing twice, and "Run finished" said nothing */
      var title = SP.stopped ? 'Stopped early' : (!SP.isBest && ok === n && n ? 'Every one right' : '');
      var slow3 = SP.log.slice().sort(function (a, b) { return b.ms - a.ms; }).slice(0, 3);
      var lvName = function (e) { var sk = SL.get(e.sk), nm = sk ? levelName(sk, e.lv) : ''; return nm; };
      var step = spNextStep(worst);
      var body = !n ? '<div class="sl-empty">No questions answered.</div>' :
        '<div class="sl-spstats">' +
          '<div class="sl-spcell"><b class="num">' + spSecs(med) + '</b><span>typical</span></div>' +
          '<div class="sl-spcell"><b class="num">' + spSecs(fast) + '</b><span>fastest</span></div>' +
          '<div class="sl-spcell"><b class="num">' + spSecs(slowest) + '</b><span>slowest</span></div>' +
          '<div class="sl-spcell"><b class="num">' + Math.round(ok / n * 100) + '%</b><span>right</span></div>' +
        '</div>' +
        '<section class="sl-spsec"><div class="sl-sphead"><span class="sl-sect">Where the time went</span>' + (pace ? '<span class="sl-sppace">' + pace + '</span>' : '') + '</div>' + spChartHTML() + '</section>' +
        /* the recommendation sits under the chart, before the detail: it is the
           reason the screen exists, and on a phone the detail is a long scroll */
        (step.msg ? '<section class="sl-spnext"><span class="sl-sect">What to do next</span><p>' + esc(step.msg) + '</p>' +
          (step.btn ? '<button type="button" class="sl-btn sl-btn--ghost" id="' + ({ teach: 'slSpTeach', up: 'slSpUp', practise: 'slSpPrac' })[step.btn.kind] + '"' +
            (step.btn.sk ? ' data-sk="' + step.btn.sk + '" data-lv="' + step.btn.lv + '"' : '') + '>' +
            ({ teach: ICON.steps, up: ICON.arrowR, practise: ICON.list })[step.btn.kind] + '<span>' + esc(step.btn.label) + '</span></button>' : '') +
        '</section>' : '') +
        '<section class="sl-spsec"><span class="sl-sect">The three that took longest</span><div class="sl-splist">' + slow3.map(function (x) {
          return '<div class="sl-spslow' + (x.ok ? '' : ' is-miss') + '"><b class="num">' + spSecs(x.ms) + '</b>' +
            '<span class="sq">' + esc(x.t || '') + (mixed ? '<i>' + esc(x.name) + ' · level ' + x.lv + '</i>' : '') + '</span>' +
            '<span class="sv" aria-label="' + (x.ok ? 'Right' : 'Missed') + '">' + (x.ok ? ICON.tick : ICON.cross) + '</span></div>';
        }).join('') + '</div></section>' +
        '<section class="sl-spsec"><span class="sl-sect">How each level went</span><div class="sl-splist">' + lv.map(function (e) {
          var nm = lvName(e);
          return '<div class="sl-splv"><span class="ln num">' + e.lv + '</span>' +
            '<span class="lt"><b>' + esc(nm || ('Level ' + e.lv)) + '</b>' + (mixed ? '<i>' + esc(e.name) + '</i>' : '') + '</span>' +
            '<span class="ls num' + (e.ok === e.n ? ' is-all' : '') + '">' + e.ok + '/' + e.n + '</span>' +
            '<span class="lm num">' + spSecs(e.med) + '</span></div>';
        }).join('') + '</div></section>';
      return '<div class="sl-main sl-spres-wrap"><div class="sl-scroll"><div class="sl-spres' + (entering ? ' is-enter' : '') + '">' +
        '<div class="sl-sphero' + (SP.isBest ? ' is-best' : '') + '">' +
          (SP.isBest ? '<span class="sl-spbadge">' + ICON.trophy + 'Personal best</span>' : '') +
          '<b class="num">' + hero + '</b><span class="hs">' + esc(heroSub) + '</span>' +
          (title ? '<i>' + esc(title) + '</i>' : '') + spDeltaHTML() + '</div>' +
        body +
        '<section class="sl-spsec"><span class="sl-sect">Recent runs</span>' + spHistHTML(r.sig) + '</section>' +
        '</div></div>' +
        /* the two ways on stay in reach at the foot of the screen, outside the
           scroll: on a phone they sat 1,700px down under the detail */
        '<div class="sl-spacts">' +
          '<button type="button" class="sl-btn sl-btn--cta" id="slSpAgain">' + ICON.refresh + 'Go again</button>' +
          '<button type="button" class="sl-btn sl-btn--ghost" id="slSpBack">' + ICON.sliders + 'Change the run</button>' +
        '</div></div>';
    }
    function spRender() {
      if (SP.phase === 'done') { paint(elSp, spResultHTML()); renderTop(); return; }
      paint(elSp, spPlayHTML());
      spFitQ();
      var tx = $('slSpText'); if (tx && !SP.cd && !SP.pauseAt) { try { tx.focus(); } catch (e) {} }
      renderTop();
    }
    function renderSpeed() {
      if (!SP.on) { show(S.from === 'mixed' ? 'mixed' : 'skill'); return; }
      spRender();
    }

    /* ---------- pressing things ---------- */
    function spPad(k) {
      var it = SP.item, inp = it && spInput(it);
      if (!inp || inp.kind !== 'pad' || SP.cd || SP.lock || SP.pauseAt) return;
      var v = SP.entry[SP.bi] || '';
      if (k === 'back') {
        if (v) SP.entry[SP.bi] = v.slice(0, -1);
        else if (SP.bi > 0) { SP.bi--; SP.entry[SP.bi] = String(SP.entry[SP.bi] || '').slice(0, -1); }
        spPaintEntry(inp); return;
      }
      /* a minus only leads, a point only appears once */
      if (k === '-' && v) return;
      if (k === '.' && v.indexOf('.') >= 0) return;
      SP.entry[SP.bi] = v + k;
      spPaintEntry(inp);
      spTry(inp);
    }
    /* Auto-check, the Quick Maths rule: a right answer goes through the moment
       it is right, and a wrong one is only registered once the entry is as long
       as the answer - so a digit at a time cannot be brute-forced. */
    function spTry(inp) {
      var fs = inp.fs, j = SP.bi, f = fs[j], v = String(SP.entry[j] || '');
      var acc = fs.length === 1 && SP.item.q.data && SP.item.q.data.accepted;
      var right = sameAnswer(v, f.ans, f.accepted || acc || null, f.norm);
      if (right) {
        if (j < fs.length - 1) { SP.bi = j + 1; spPaintEntry(inp); return; }
        spDone(inp, true); return;
      }
      var want = String(f.ans).replace(/[^0-9]/g, '').length, got = v.replace(/[^0-9]/g, '').length;
      if (got >= want) {
        /* the box is full and wrong. With one box that ends the question; with
           several, the whole answer is judged once the last box is full. */
        if (j < fs.length - 1) { SP.bi = j + 1; spPaintEntry(inp); return; }
        spDone(inp, false);
      }
    }
    function spDone(inp, right) {
      var fs = inp.fs;
      var acc = fs.length === 1 && SP.item.q.data && SP.item.q.data.accepted;
      var got = fieldsRight(SP.item, fs, fs.map(function (f, j) { return SP.entry[j]; }), acc);
      var html = stackFields(fs, function (f, j, vw) {
        return { lead: j ? '<span class="eb-op">' + (f.sign ? ' ' : (f.op || '+')) + '</span>' : '', body: '<span class="eb-tm">' + esc(String(SP.entry[j] || '').trim()) + vw.after + '</span>' };
      }, function (h) { return '<span class="eb-op">' + h + '</span>'; });
      spAnswer(!!got, fs.map(function (f, j) { return SP.entry[j] || ''; }).join(', '), html);
    }
    /* only the boxes are repainted while typing: rebuilding the screen would
       take the keypad out from under the finger mid-press, and on a text
       question it would destroy the input the child is typing into */
    function spPaintEntry(inp) {
      var host = elSp.querySelector('.sl-spboxes'); if (!host) { spRender(); return; }
      var fresh = el('div', null, spBoxesHTML(inp.fs)).firstChild;
      host.parentNode.replaceChild(fresh, host);
    }
    elSp.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null; if (!t) return;
      if (t.id === 'slSpResume') { spPause(false); return; }
      if (t.id === 'slSpEnd') { spFinish(true); return; }
      if (t.hasAttribute('data-key')) { spPad(t.getAttribute('data-key')); return; }
      if (t.hasAttribute('data-spopt')) {
        var inp = spInput(SP.item); if (!inp || inp.kind !== 'choice' || SP.cd || SP.lock || SP.pauseAt) return;
        var k = Number(t.getAttribute('data-spopt'));
        SP.picked = k;
        spAnswer(k === inp.ch.answer, inp.ch.options[k], esc(String(inp.ch.options[k])));
        return;
      }
      if (t.id === 'slSpCheck') { spText(); return; }
      if (t.id === 'slSpAgain') { spStart(); return; }
      if (t.id === 'slSpBack') { spReset(); show('speedsetup'); return; }
      if (t.id === 'slSpPrac') {
        var runSk = (SP.skills || []).slice(), wasMixed = S.from === 'mixed';
        if (!runSk.length) return;
        spReset();
        withSkills(runSk.map(function (x) { return x.id; }), t, function () {
          runSk.forEach(function (x) { var k = SL.get(x.id); if (k) setSel(k, x.levels); });
          if (!wasMixed) { S.skill = runSk[0].id; S.from = 'skills'; }
          buildSet(); show('practise');
        }, true);
        return;
      }
      if (t.id === 'slSpUp') {
        var skU = SL.get(t.getAttribute('data-sk')), lvU = Number(t.getAttribute('data-lv'));
        if (!skU) return;
        spReset(); S.skill = skU.id; S.from = 'skills'; setSel(skU, [lvU]); show('speedsetup');
        return;
      }
      if (t.id === 'slSpTeach') {
        var sk2 = SL.get(t.getAttribute('data-sk')), lv = Number(t.getAttribute('data-lv'));
        if (!sk2) return;
        spReset();
        withSkills([sk2.id], t, function () {
          S.skill = sk2.id; S.from = 'skills'; setSel(sk2, [lv]);
          buildSet(); S.teach.i = 0; S.teach.back = null; show('teach');
        }, true);
      }
    });
    function spText() {
      var box = $('slSpText'); if (!box) return;
      var inp = spInput(SP.item); if (!inp || inp.kind !== 'text' || SP.cd || SP.lock || SP.pauseAt) return;
      var v = String(box.value || '').trim(); if (!v) return;
      SP.entry = [v];
      var f = inp.fs[0], acc = SP.item.q.data && SP.item.q.data.accepted;
      var got = sameAnswer(v, f.ans, f.accepted || acc || null, f.norm);
      spAnswer(got, v, '<span class="eb-tm">' + esc(v) + '</span>');
    }
    elSp.addEventListener('keydown', function (e) {
      if (e.target && e.target.id === 'slSpText' && e.key === 'Enter') { e.preventDefault(); spText(); }
    });

    /* ============================================================
       PAGE (launcher), keys, focus trap, deep links
       ============================================================ */
    /* The launcher shows one of three panels: Teach, Practise or Board.
       Class, never the hidden attribute: a display: rule out-specifies it. */
    function setLauncherAct(name) {
      each(root.querySelectorAll('[data-sl-act]'), function (b) {
        var on = b.getAttribute('data-sl-act') === name;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      each(root.querySelectorAll('[data-sl-demo]'), function (d) {
        d.classList.toggle('is-on', d.getAttribute('data-sl-demo') === name);
      });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null;
      if (!t || shell.contains(t)) return;
      if (t.hasAttribute('data-sl-theme')) { toggleTheme(); return; }
      if (t.hasAttribute('data-sl-act')) { setLauncherAct(t.getAttribute('data-sl-act')); return; }
      if (t.id === 'slOpen') { openShell('library'); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (!shell.classList.contains('is-on') || closing) return;
      /* WHITEBOARD (2026-10-16): while it is open its keys are the only keys; W opens it from Teach or Practise */
      if (WB.isOpen()) {
        if (keysOpen && e.key === 'Escape') { e.preventDefault(); toggleKeys(false); return; }
        if ((e.key === '?' || e.key === '/') && !(e.target && /^(INPUT|TEXTAREA)$/.test(e.target.tagName))) { e.preventDefault(); toggleKeys(!keysOpen); return; }
        WB.key(e);
        return;
      }
      if ((e.key === 'w' || e.key === 'W') && !e.metaKey && !e.ctrlKey && !e.altKey && (S.screen === 'teach' || S.screen === 'practise') && S.set.length &&
          !(e.target && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) && !keysOpen) { e.preventDefault(); WB.openHere(); return; }
      /* BLANK WHITEBOARD (2026-10-21): W from the library opens a board with no questions */
      if ((e.key === 'w' || e.key === 'W') && !e.metaKey && !e.ctrlKey && !e.altKey && (S.screen === 'library' || S.screen === 'mixed' || S.screen === 'checklist') &&
          !(e.target && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) && !keysOpen) { e.preventDefault(); WB.openBlank(); return; }
      if (e.key === 'Tab') {
        var f = Array.prototype.filter.call(shell.querySelectorAll('button:not([disabled]), input, [tabindex="0"]'), function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || !shell.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        return;
      }
      if (e.key === 'Escape') {
        e.preventDefault();
        if (keysOpen) { toggleKeys(false); return; }
        if (S.screen === 'welcome') { if (welCanSkip()) welDone(welStep() >= 3); else closeShell(); return; }
        if (S.screen === 'practise' && S.prOne >= 0) { toWall(); return; }
        if (S.screen === 'speed' && SP.phase !== 'done' && !SP.cd) { spPause(!SP.pauseAt); return; }
        if (S.screen === 'library' || S.screen === 'mixed' || S.screen === 'checklist') closeShell();
        else show(S.screen === 'skill' ? libHome() : (S.screen === 'teach' ? backFromTeach() : backTarget()));
        return;
      }
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      var tgt = e.target || {}, tag = tgt.tagName, typing = tag === 'INPUT' || tag === 'TEXTAREA' || tgt.isContentEditable;
      if ((e.key === '?' || e.key === '/') && !typing) { e.preventDefault(); toggleKeys(); return; }
      if (keysOpen) return;
      if (typing) return;
      var k = (e.key || '').toLowerCase();
      if (k === 'f') { e.preventDefault(); toggleFull(); return; }
      if (k === 'l') { e.preventDefault(); copyLink(); return; }
      var onButton = tag === 'BUTTON';
      if (S.screen === 'teach') {
        if (S.teach.chorus && chorusOK()) {
          if ((e.key === 'Enter' || e.key === ' ') && !onButton) { e.preventDefault(); var cg = elTe.querySelector('[data-cgo]'); if (cg) cg.click(); }
          /* the arrows rewind and step the count as well (Aadam: "so you can always rewind") */
          if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && chorusR && chorusR.step) { e.preventDefault(); chorusR.step(e.key === 'ArrowRight' ? 1 : -1); }
          return;
        }
        if ((e.key === 'Enter' || e.key === ' ') && !(onButton && tgt.id !== 'slTCta')) { e.preventDefault(); if (e.repeat && S.teach.done) return; var c = $('slTCta'); if (c) c.click(); return; }
        /* left and right walk the model - the arrows point along the working,
           so they move the working - and up and down change the question.
           These come BEFORE the button guard: pressing the CTA leaves it
           focused, and the arrows have to keep working after a press. */
        if (e.key === 'ArrowRight') { e.preventDefault(); teachAnim(1, e.repeat); return; }
        if (e.key === 'ArrowLeft') { e.preventDefault(); teachAnim(-1); return; }
        if (e.key === 'ArrowDown') { e.preventDefault(); teachStep(1); return; }
        if (e.key === 'ArrowUp') { e.preventDefault(); teachStep(-1); return; }
        /* A and R come before the button guard as well: pressing Next leaves it focused, and every
           later A or R was swallowed */
        if (k === 'a') { e.preventDefault(); if (S.teach.r) { S.teach.moved = true; S.teach.r.all(); } return; }
        if (k === 'r') { e.preventDefault(); freshTeachQuestion(); return; }
        if (k === 'n') { e.preventDefault(); freshTeachSet(); return; }
        return;
      }
      if (S.screen === 'turn') {
        var nb = $('slUNext');
        /* the CTA keeps focus after a press, so Space has to keep working on it */
        if ((e.key === 'Enter' || e.key === ' ') && nb && !nb.hidden) { e.preventDefault(); if (!e.repeat) nb.click(); return; }
        if (onButton) return;
        if (S.turn.phase === 'play' && (k === '1' || k === '2')) {
          var cb = elTu.querySelectorAll('.nl-cbtn');
          if (cb.length === 2) { e.preventDefault(); cb[k === '1' ? 0 : 1].click(); return; }
        }
        if (k === 'a') { e.preventDefault(); var sb = $('slUShow'); if (sb && !sb.disabled) sb.click(); return; }
        if (k === 'r' || k === 'n') { e.preventDefault(); startTurn(); renderTurn(); renderTop(); return; }
        return;
      }
      if (onButton && (e.key === ' ' || e.key === 'Enter')) return;
      if (S.screen === 'practise') {
        /* one card open: the arrows move along the ten, Space shows its answer and, once it is
           marked, moves on; on the wall Space opens the next card that has not been looked at */
        var one = S.prOne >= 0 ? S.set[S.prOne] : null;
        if (one && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) { e.preventDefault(); openCard(S.prOne + (e.key === 'ArrowRight' ? 1 : -1)); return; }
        if (one && (e.key === ' ' || e.key === 'Enter')) {
          e.preventDefault();
          if (one.state === 'hid') {
            if (one.q.choice) return;
            if (S.typed && canType(one)) { var obox = elPr.querySelector('[data-ans="' + S.prOne + '"]'); if (obox) obox.focus(); return; }
            revealOne(S.prOne); return;
          }
          if (one.state !== 'shown') openCard(S.prOne + 1);
          return;
        }
        if (one && (k === 'c' || k === '1' || k === 'x' || k === '2')) {
          if (one.state !== 'shown') return;
          e.preventDefault(); mark(one, k === 'c' || k === '1'); renderPractise(); renderTop(); return;
        }
        if (one && k === 's') { e.preventDefault(); S.teach.i = S.prOne; S.teach.back = 'practise'; show('teach'); return; }
        if (e.key === ' ' || e.key === 'Enter') {
          var nx = nextHidden(); if (nx < 0) return;
          e.preventDefault(); openCard(nx); return;
        }
        if (k === 'c' || k === '1' || k === 'x' || k === '2') {
          var li = lastLive(); if (li < 0 || S.set[li].state !== 'shown') return;
          e.preventDefault(); mark(S.set[li], k === 'c' || k === '1'); renderPractise(); renderTop(); return;
        }
        if (k === 'a') { e.preventDefault(); revealAll(); return; }
        if (k === 'h') { e.preventDefault(); hideAll(); return; }
        if (k === 'r' || k === 'n') { e.preventDefault(); var b = $('slNewSet'); if (b) b.click(); return; }
        if (k === 's') { var si = lastLive(); if (si < 0) si = 0; e.preventDefault(); S.teach.i = si; S.teach.back = 'practise'; show('teach'); return; }
        return;
      }
      /* a run is driven from the number row as well as the pad, so the keys
         come BEFORE the button guard: pressing a key leaves it focused and the
         next digit would otherwise be swallowed as a button press */
      if (S.screen === 'speed') {
        if (SP.phase === 'done') return;
        if (k === 'm') { e.preventDefault(); toggleSound(); spRender(); return; }
        if (e.key === 'Escape') { e.preventDefault(); spPause(!SP.pauseAt); return; }
        if (SP.pauseAt || SP.cd) return;
        var sIn = spInput(SP.item);
        if (!sIn) return;
        if (sIn.kind === 'choice') {
          var oi = '123456'.indexOf(e.key);
          if (oi >= 0 && oi < sIn.ch.options.length) { e.preventDefault(); SP.picked = oi; spAnswer(oi === sIn.ch.answer, sIn.ch.options[oi], esc(String(sIn.ch.options[oi]))); }
          return;
        }
        if (sIn.kind !== 'pad') return;
        if (/^[0-9]$/.test(e.key)) { e.preventDefault(); spPad(e.key); return; }
        if (e.key === '.') { e.preventDefault(); spPad('.'); return; }
        if (e.key === '-') { e.preventDefault(); spPad('-'); return; }
        if (e.key === 'Backspace') { e.preventDefault(); spPad('back'); return; }
        return;
      }
      if (S.screen === 'board') {
        if (e.key === ' ' || k === 'a') { e.preventDefault(); setAllAns(!S.board.ans); paintAns(); renderTop(); return; }
        if (k === 'n' || k === 'r') { e.preventDefault(); buildBoard(); renderBoard(); renderTop(); return; }
        if (k === 't') { e.preventDefault(); toggleTimer(); return; }
      }
    });
    /* ============================================================
       THE ADDRESS BAR
       The link names the screen, the skill and the LEVELS that are ticked, and
       carries the settings that change what you get, so a copied link opens
       exactly what the person copying it was looking at. Screen changes push a
       history entry (Back walks the screens); a setting change replaces one, or
       every level chip would be a step in the back button.
       ============================================================ */
    var routing = false, hashT = null;
    function levelsParam(sk) { return selLevels(sk).join(','); }
    function hashFor() {
      if (!shell.classList.contains('is-on')) return '';
      var sk = curSkill(), P = [], screen = S.screen;
      if (screen === 'welcome') return '';
      if (screen === 'papers') return '#papers' + (S.papersQ ? '/' + S.papersQ : '');
      if (screen === 'library') screen = 'skills';
      if (screen === 'boardsetup') screen = 'skill';
      if (screen === 'speedsetup') screen = 'speed';
      var h = '#' + screen;
      if (S.from === 'mixed') {
        var ids = mixSkills().map(function (x) { return x.id; });
        if (ids.length) P.push('mix=' + ids.join(','));
        mixSkills().forEach(function (x) { P.push('l.' + x.id + '=' + levelsParam(x)); });
        if (S.board.mixLayout !== 'mixed') P.push('mixlay=' + S.board.mixLayout);
      } else if (sk && screen !== 'skills' && screen !== 'mixed' && screen !== 'checklist') {
        h += '/' + sk.id + '/' + levelsParam(sk);
      } else if (sk && screen === 'skills') {
        P.push('sk=' + sk.id);
      }
      if (screen === 'practise' && S.typed) P.push('type=1');
      if (screen === 'speed') {
        P.push('shape=' + S.speed.shape);
        P.push('len=' + spLen());
      }
      if (screen === 'board') {
        if (S.board.layout !== 'mix') P.push('lay=' + S.board.layout);
        if (S.board.n !== 24) P.push('n=' + S.board.n);
        if (S.board.ans) P.push('ans=1');
      }
      if (screen === 'teach' && S.teach.chorus) {
        P.push('count=1');
        var C = (S.chorus && sk && S.chorus[sk.id]) || {};
        if (C.step) P.push('cs=' + C.step);
        if (C.start != null) P.push('cf=' + C.start);
        if (C.up === false) P.push('cd=back');
        if (C.tempo && C.tempo !== 'steady') P.push('ct=' + C.tempo);
      }
      if (S.theme !== 'dark') P.push('theme=' + S.theme);
      return h + (P.length ? '?' + P.join('&') : '');
    }
    function syncHash(push) {
      if (routing || !window.history || !history.replaceState) return;
      clearTimeout(hashT);
      hashT = setTimeout(function () {
        var h = hashFor(), url = location.pathname + location.search + h;
        if (h === (location.hash || '') && h !== '') return;
        try { history[push && h ? 'pushState' : 'replaceState'](null, '', url); } catch (e) {}
      }, push ? 0 : 140);
    }
    function copyLink() {
      var url = location.origin + location.pathname + location.search + hashFor();
      function ok() { toast('Link copied. It opens this skill at these levels.'); }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(url).then(ok, function () { prompt('Copy this link', url); }); return; }
      } catch (e) {}
      try { window.prompt('Copy this link', url); } catch (e) {}
    }
    /* ---------- reading one back ---------- */
    function paramsOf(hash) {
      var out = {}, i = hash.indexOf('?');
      if (i < 0) return out;
      hash.slice(i + 1).split('&').forEach(function (kv) {
        var j = kv.indexOf('='); if (j < 0) return;
        out[decodeURIComponent(kv.slice(0, j))] = decodeURIComponent(kv.slice(j + 1));
      });
      return out;
    }
    function levelsFrom(str, sk) {
      var a = String(str || '').split(',').map(Number).filter(function (n) { return n >= 1 && n <= sk.levels.length; });
      return a.length ? a : null;
    }
    function fromHash() {
      var hash = location.hash || '';
      var m = /^#(play|library|skills|mixed|skill|practise|teach|turn|board|speed|papers|checklist|whiteboard)(?:\/([a-z0-9-]+))?(?:\/([\d,]+))?/.exec(hash);
      if (!m) return false;
      var P = paramsOf(hash);
      routing = true;
      try {
        if (P.theme === 'light' || P.theme === 'dark') { S.theme = P.theme; applyTheme(); }
        var sk = SL.get(m[2] || P.sk || '');
        if (sk) {
          S.skill = sk.id; S.from = 'skills';
          var lv = levelsFrom(m[3], sk); if (lv) setSel(sk, lv);
        }
        /* a mixed link carries the tray and a level list per skill in it */
        if (P.mix) {
          var ids = P.mix.split(',').filter(function (id) { return SL.get(id); }).slice(0, 6);
          if (ids.length) { S.mix = ids.map(function (id) { return { id: id }; }); S.from = 'mixed'; }
          ids.forEach(function (id) {
            var x = SL.get(id), a2 = P['l.' + id] && levelsFrom(P['l.' + id], x);
            if (a2) setSel(x, a2);
          });
          if (P.mixlay === 'skill' || P.mixlay === 'mixed') S.board.mixLayout = P.mixlay;
        }
        if (P.type === '1') S.typed = true;
        if (P.shape === 'race' || P.shape === 'clock') S.speed.shape = P.shape;
        if (P.len) {
          /* SPEED SLIDERS (2026-09-21): a length from an old link (5 questions, 90 seconds) snaps into range */
          var pl = spSnap(S.speed.shape, P.len);
          if (pl && S.speed.shape === 'race') S.speed.n = pl;
          if (pl && S.speed.shape === 'clock') S.speed.secs = pl;
        }
        if (P.lay === 'diff' || P.lay === 'mix') S.board.layout = P.lay;
        if (P.n && [8, 16, 24].indexOf(Number(P.n)) >= 0) S.board.n = Number(P.n);
        S.teach.chorus = P.count === '1';
        if (S.teach.chorus && sk) {
          S.chorus = S.chorus || {};
          var C = S.chorus[sk.id] = S.chorus[sk.id] || {};
          if (P.cs) C.step = Number(P.cs);
          if (P.cf) C.start = Number(P.cf);
          if (P.cd) C.up = P.cd !== 'back';
          if (P.ct) C.tempo = P.ct;
        }
        save();
      } finally { routing = false; }
      if (m[1] === 'mixed' || (P.mix && m[1] === 'skills')) { openShell('mixed'); return true; }
      if (m[1] === 'skill' && sk) { openShell('skill'); return true; }
      /* a deep link into an activity: the skill screen opens at once from the
         manifest and the activity follows as soon as its engine has loaded */
      var into = function (go) { if (SL.ready(sk.id)) { go(true); return; } openShell('skill'); withSkills([sk.id], elSk.querySelector('.sl-act'), function () { go(false); }); };
      if (m[1] === 'practise' && sk) { into(function (direct) { buildSet(); if (direct) openShell('practise'); else show('practise'); }); return true; }
      if (m[1] === 'teach' && sk) { into(function (direct) { buildSet(); S.teach.i = 0; S.teach.back = null; if (direct) openShell('teach'); else show('teach'); }); return true; }
      /* a skill with no answerable model has no Your turn: the link lands on the skill */
      /* a stub is replaced IN PLACE when its engine registers, so the skill
         captured before the load is stale: read it back from the registry */
      if (m[1] === 'turn' && sk) { into(function (direct) { var s2 = SL.get(sk.id); if (!s2 || !s2.turn) { show('skill'); return; } startTurn(); if (direct) openShell('turn'); else show('turn'); }); return true; }
      if (m[1] === 'board' && sk) { into(function (direct) { buildBoard(); if (P.ans === '1') setAllAns(true); if (direct) openShell('board'); else show('board'); }); return true; }
      /* a skill whose answer is only revealed has no Speed: the link lands on the skill */
      if (m[1] === 'speed' && sk && !canRace(sk)) { openShell('skill'); return true; }
      if (m[1] === 'speed' && (sk || P.mix)) { openShell('speedsetup'); return true; }
      if (m[1] === 'papers') { S.papersQ = (m[2] && /^[a-z0-9-]+$/.test(m[2])) ? m[2] : ''; save(); openShell('papers'); return true; }
      if (m[1] === 'checklist') { openShell('checklist'); return true; }
      /* ROUND 11 (Aadam: "add direct link to whiteboard so you can go straight to it"): #whiteboard opens a blank board at
         once, over the library (a deep link, so no walkthrough); closing it leaves the library */
      if (m[1] === 'whiteboard') { if (!shell.classList.contains('is-on')) openShell('library', true); if (!WB.isOpen()) WB.openBlank(); return true; }
      openShell('library'); return true;
    }

    /* ============================================================
       WHITEBOARD (2026-10-16). Aadam: "add a whiteboard mode to the skills lab, within teach mode and practice
       mode, that pulls the question that you're looking at so you can work on it ... good for using on a
       smartboard and for 1-1 teaching". His picks from the design canvas (claude.ai/artifact/BUtSjpiHmFEtLBvCHs8pWe):
       six board colours, each with its OWN four pens; dots, squares or plain paper; only the teacher draws;
       icons with no words; pen, highlighter, line, arrow, laser pointer, rub out; number line, bar model, grid
       method, table and axes put on the board and grown with + and -, dragged by a handle and "made larger or
       smaller, pull from corner"; the questions down the side and the skill picker in the bar swap what is on
       the board. Ink and diagrams are kept per question (skill, level and the question's own key) for as long
       as the page is open, so going back to a question finds its working again; a refreshed question is new.
       Everything below is this block's own: the lab reaches it through WB.open / WB.openHere / WB.key.
       ROUND 2 (2026-10-16): every board with work is saved on the device with its question (localStorage
       shlc_sl_wb_boards, newest 60), and the Boards menu reopens one later, saves this board as a picture or every
       board in the set as a PDF (drawn by this block: no library). Aadam: "improve smoothness of laser": the
       pointer is eased, the trail is one tapered ribbon through a smoothed curve, not beaded segments.
       ============================================================ */
    var WB = (function () {
      var THEMES = [
        { id: 'night', name: 'Night', bg: '#0D1728', pat: 'rgba(91,175,214,.22)', pal: ['#F2F6FB', '#FF8054', '#5BAFD6', '#3DD68C', '#F5D451', '#FF7AB6', '#B48CFF', '#93A6C0'], pln: ['White', 'Orange', 'Blue', 'Green', 'Yellow', 'Pink', 'Purple', 'Grey'], pens: ['#F2F6FB', '#FF8054', '#5BAFD6', '#3DD68C'], pn: ['White', 'Orange', 'Blue', 'Green'], hl: 'rgba(245,196,81,.38)', fill: 'rgba(91,175,214,.12)', card: 'rgba(22,35,59,.95)', line: '#26395C', ink: '#F2F6FB', sub: '#93A6C0', laser: '255,90,78', dark: 1 },
        { id: 'white', name: 'Whiteboard', bg: '#FFFFFF', pat: '#CFDBE7', pal: ['#14202E', '#1F5FBF', '#D23B3B', '#0F8A4A', '#6D3FC0', '#C2570C', '#7A4A1E', '#00788A'], pln: ['Black', 'Blue', 'Red', 'Green', 'Purple', 'Orange', 'Brown', 'Teal'], pens: ['#14202E', '#1F5FBF', '#D23B3B', '#0F8A4A'], pn: ['Black', 'Blue', 'Red', 'Green'], hl: 'rgba(255,214,0,.42)', fill: 'rgba(31,95,191,.07)', card: '#F3F7FB', line: '#D3DEE9', ink: '#0F2337', sub: '#4E647C', laser: '229,50,45', dark: 0 },
        { id: 'book', name: 'Exercise book', bg: '#FBF8F0', pat: '#BFD5EA', pal: ['#3B4250', '#1D4E9E', '#C0392B', '#13804A', '#6A3FA0', '#B85410', '#7A5230', '#B0306A'], pln: ['Pencil', 'Blue', 'Red', 'Green', 'Purple', 'Orange', 'Brown', 'Pink'], pens: ['#3B4250', '#1D4E9E', '#C0392B', '#13804A'], pn: ['Pencil', 'Blue', 'Red', 'Green'], hl: 'rgba(255,214,0,.42)', fill: 'rgba(29,78,158,.07)', card: '#FFFFFF', line: '#D9D2C0', ink: '#2A2F38', sub: '#6B6455', laser: '229,50,45', dark: 0 },
        { id: 'chalk', name: 'Chalkboard', bg: '#1E3B2F', pat: 'rgba(244,241,232,.16)', pal: ['#F4F1E8', '#F7D774', '#F49AC1', '#9AD0F5', '#F8B26A', '#B8E68A', '#C9B3F5', '#FF9C8F'], pln: ['Chalk', 'Yellow', 'Pink', 'Blue', 'Orange', 'Green', 'Lilac', 'Coral'], pens: ['#F4F1E8', '#F7D774', '#F49AC1', '#9AD0F5'], pn: ['Chalk', 'Yellow', 'Pink', 'Blue'], hl: 'rgba(247,215,116,.32)', fill: 'rgba(244,241,232,.08)', card: 'rgba(20,42,33,.95)', line: '#35584A', ink: '#F4F1E8', sub: '#B9C9BF', laser: '255,107,94', dark: 1 },
        { id: 'sky', name: 'Sky', bg: '#E6F0FA', pat: '#B9CFE6', pal: ['#0F2337', '#B84A0C', '#6D4FD6', '#0F7A46', '#C62828', '#00707F', '#B5267A', '#7A4A1E'], pln: ['Navy', 'Orange', 'Purple', 'Green', 'Red', 'Teal', 'Pink', 'Brown'], pens: ['#0F2337', '#B84A0C', '#6D4FD6', '#0F7A46'], pn: ['Navy', 'Orange', 'Purple', 'Green'], hl: 'rgba(255,214,0,.45)', fill: 'rgba(46,127,168,.08)', card: '#FFFFFF', line: '#C7D8EA', ink: '#0F2337', sub: '#4E647C', laser: '229,50,45', dark: 0 },
        { id: 'black', name: 'Blackboard', bg: '#16171B', pat: 'rgba(255,255,255,.14)', pal: ['#FFFFFF', '#FFD54A', '#5CE1E6', '#FF7A70', '#7CE38B', '#C49BFF', '#FFA552', '#FF8AD8'], pln: ['White', 'Yellow', 'Cyan', 'Coral', 'Green', 'Purple', 'Orange', 'Pink'], pens: ['#FFFFFF', '#FFD54A', '#5CE1E6', '#FF7A70'], pn: ['White', 'Yellow', 'Cyan', 'Coral'], hl: 'rgba(255,213,74,.32)', fill: 'rgba(255,255,255,.06)', card: 'rgba(30,31,36,.96)', line: '#34363D', ink: '#FFFFFF', sub: '#A4A8B3', laser: '255,90,78', dark: 1 }
      ];
      var PATS = ['dots', 'squares', 'lines', 'plain'], SIZES = [3, 6, 11], STEPS = [1, 2, 5, 10, 0.5], KW = 'shlc_sl_wb';
      /* ROUND 5 (2026-10-22, Aadam: "highlighter should have different colours"): five highlighters on every board, each
         see-through enough to read the ink under it; a stroke keeps its own (hc), an older one the board's single hl */
      var HLN = ['Yellow', 'Pink', 'Green', 'Blue', 'Orange'];
      var HL5 = {
        dark: [['245,212,81', .4], ['255,122,182', .4], ['61,214,140', .36], ['91,175,214', .42], ['255,128,84', .4]],
        light: [['255,214,0', .45], ['255,105,180', .32], ['60,210,120', .34], ['80,170,255', .32], ['255,150,40', .38]],
        chalk: [['247,215,116', .34], ['244,154,193', .34], ['184,230,138', .32], ['154,208,245', .34], ['248,178,106', .34]]
      };
      function hlSet(t) { return HL5[t.id === 'chalk' ? 'chalk' : t.dark ? 'dark' : 'light']; }
      function hlRgba(k, t) { var c = hlSet(t || th())[k] || hlSet(t || th())[0]; return 'rgba(' + c[0] + ',' + c[1] + ')'; }
      function hlSolid(k, t) { return 'rgb(' + (hlSet(t || th())[k] || hlSet(t || th())[0])[0] + ')'; }
      var TOOLS = [['select', 'Select: drag a box round ink to move it', 'V'], ['pen', 'Pen', 'P'], ['hl', 'Highlighter', 'H'], ['line', 'Straight line', 'L'], ['arrow', 'Arrow', 'A'], ['laser', 'Laser pointer', 'K'], ['eraser', 'Rub out a line', 'E']];
      var I = {
        nub: '<svg class="ico" viewBox="0 0 18 18" aria-hidden="true"><path d="M15.5 6v5.5a4 4 0 0 1-4 4H6" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg>',
        pen: svg('<path d="M4 20l4-1 11-11-3-3L5 16l-1 4z"/><path d="M14 6l3 3"/>'),
        hl: svg('<path d="M9 11l-5 5v4h4l5-5"/><path d="M9 11l6-6 4 4-6 6z"/><path d="M14 21h6"/>'),
        line: svg('<path d="M5 19L19 5"/><circle cx="5" cy="19" r="1.6"/><circle cx="19" cy="5" r="1.6"/>'),
        arrow: svg('<path d="M5 19L19 5M10 5h9v9"/>'),
        laser: svg('<circle cx="12" cy="12" r="3.2" fill="currentColor"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2 2M16.7 16.7l2 2M5.3 18.7l2-2M16.7 7.3l2-2"/>'),
        eraser: svg('<path d="M7 21h10"/><path d="M5 15l9-9 5 5-8 8H7z"/><path d="M10 10l5 5"/>'),
        undo: svg('<path d="M9 14L4 9l5-5"/><path d="M4 9h10a6 6 0 010 12h-3"/>'),
        redo: svg('<path d="M15 14l5-5-5-5"/><path d="M20 9H10a6 6 0 000 12h3"/>'),
        trash: svg('<path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/>'),
        turn: svg('<path d="M20 11a8 8 0 1 0-2.3 5.7"/><path d="M20 4.5V11h-6.5"/>'),
        panel: svg('<path d="M4 5h16v14H4zM10 5v14"/>'),
        palette: svg('<path d="M12 3a9 9 0 100 18c1.4 0 2-1 2-2 0-1.4-1.2-1.6-1.2-2.8 0-1 .8-1.7 1.8-1.7H17a4 4 0 004-4c0-4.2-4-7.5-9-7.5z"/><circle cx="7.5" cy="11" r="1.2"/><circle cx="10.5" cy="7" r="1.2"/><circle cx="15" cy="7.5" r="1.2"/>'),
        move: svg('<path d="M12 3v18M3 12h18M9 6l3-3 3 3M9 18l3 3 3-3M6 9l-3 3 3 3M18 9l3 3-3 3"/>'),
        size: svg('<path d="M20 11v9h-9M20 20L11 11M4 13V4h9"/>'),
        full: svg('<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>'),
        flip: svg('<path d="M7 7h13l-4-4M17 17H4l4 4"/>'),
        copy: svg('<path d="M9 9h11v11H9z"/><path d="M5 15H4V4h11v1"/>'),
        jumps: '<svg class="ico" viewBox="0 0 32 24" aria-hidden="true"><path d="M2 20C6 6 14 6 16 20M16 20C18 6 26 6 30 20"/></svg>',
        jsize: '<svg class="ico" viewBox="0 0 32 24" aria-hidden="true"><path d="M2 20C6 2 26 2 30 20"/></svg>',
        len: '<svg class="ico" viewBox="0 0 32 24" aria-hidden="true"><path d="M2 12h28M4 7v10M16 7v10M28 7v10"/></svg>',
        bars: '<svg class="ico" viewBox="0 0 32 24" aria-hidden="true"><path d="M2 3h28v7H2zM2 14h18v7H2z"/></svg>',
        cols: svg('<path d="M3 4h18v16H3zM9 4v16M15 4v16"/>'),
        rows: svg('<path d="M3 4h18v16H3zM3 9.5h18M3 14.5h18"/>'),
        axes: svg('<path d="M12 2v20M2 12h20"/>'),
        boards: svg('<path d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><path d="M12 10v6M9 13l3 3 3-3"/>'),
        image: svg('<path d="M4 5h16v14H4z"/><circle cx="9" cy="10" r="1.8"/><path d="M4 17l5-5 4 4 2-2 5 5"/>'),
        file: svg('<path d="M6 3h9l4 4v14H6z"/><path d="M14 3v5h5M9 13h7M9 17h5"/>'),
        select: svg('<path d="M5 3.5l13 6.5-5.6 1.8L10.6 18z"/><path d="M12.6 12l5 5"/>'),
        keep: svg('<path d="M7 4h10v16l-5-4-5 4z"/>'),
        lock: svg('<rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 018 0v3"/>'),
        unlock: svg('<rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 017.6-1.8"/>'),
        fitb: svg('<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>'),
        reset: svg('<path d="M4 11a8 8 0 112.3 5.7"/><path d="M4 5v6h6"/>'),
        show: svg('<path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>'),
        text: svg('<path d="M5 7V4.5h14V7M12 4.5v15M9 19.5h6"/>'),
        lasso: svg('<path d="M6 15c-3-3-2-9 6-10s10 4 8 7-7 4-10 3" stroke-dasharray="3 3"/><path d="M7 15c1 2 0 4-2 5"/>'),
        clock: svg('<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>'),
        share: svg('<path d="M12 15V4M7.5 8.5L12 4l4.5 4.5M5 12v6.5A1.5 1.5 0 0 0 6.5 20h11a1.5 1.5 0 0 0 1.5-1.5V12"/>'),
        more: '<svg class="ico" viewBox="0 0 24 24" aria-hidden="true"><g fill="currentColor" stroke="none"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>',
        ruler: svg('<path d="M3 15L15 3l6 6L9 21z"/><path d="M7 11l2 2M10 8l2 2M13 5l2 2"/>'),
        timer: svg('<circle cx="12" cy="13.5" r="7.5"/><path d="M12 9.5v4l2.5 1.5M9.5 2.5h5"/>'),
        calc: svg('<rect x="5" y="3" width="14" height="18" rx="2.5"/><path d="M8 6.5h8v3.5H8zM8.5 14h.01M12 14h.01M15.5 14h.01M8.5 17.5h.01M12 17.5h.01M15.5 17.5h.01"/>'),
        grip: '<svg class="ico" viewBox="0 0 12 20" aria-hidden="true"><g fill="currentColor" stroke="none"><circle cx="3" cy="4" r="1.7"/><circle cx="9" cy="4" r="1.7"/><circle cx="3" cy="10" r="1.7"/><circle cx="9" cy="10" r="1.7"/><circle cx="3" cy="16" r="1.7"/><circle cx="9" cy="16" r="1.7"/></g></svg>',
        fitall: svg('<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/><rect x="9" y="9" width="6" height="6" rx="1"/>')
      };
      var INS = [
        ['nl', 'Number line', '<svg viewBox="0 0 62 34" aria-hidden="true"><path d="M4 18C10 4 22 4 26 18M26 18C30 4 42 4 46 18" class="a"/><path d="M2 26h58M6 21v10M26 21v10M46 21v10"/></svg>'],
        ['bar', 'Bar model', '<svg viewBox="0 0 62 34" aria-hidden="true"><path d="M3 4h56v14H3zM21.6 4v14M40.3 4v14M3 24v5h56v-5"/></svg>'],
        ['grid', 'Grid method', '<svg viewBox="0 0 62 34" aria-hidden="true"><path d="M16 3h44v28H16zM16 13h44M38 3v28" /><path d="M3 5l7 7M10 5l-7 7" class="a"/></svg>'],
        ['tbl', 'Table', '<svg viewBox="0 0 62 34" aria-hidden="true"><path d="M3 3h56v28H3zM3 12h56M3 21.5h56M21.6 3v28M40.3 3v28"/></svg>'],
        ['ax', 'Axes', '<svg viewBox="0 0 62 34" aria-hidden="true"><path d="M31 2v30M14 17h34M28 8h6M28 26h6M22 14v6M40 14v6"/></svg>'],
        ['graph', 'Graph of a line', '<svg viewBox="0 0 62 34" aria-hidden="true"><path d="M14 2v30h42"/><path d="M16 30L52 4" class="a"/></svg>']
      ];
      var saved = lsGet(KW, null) || {};
      var ci = function (v, lo, hi, d) { return typeof v === 'number' && v >= lo && v <= hi ? Math.round(v) : d; };
      var st = {
        open: false, from: 'teach', i: 0, theme: ci(saved.theme, 0, THEMES.length - 1, 0), pat: PATS.indexOf(saved.pat) >= 0 ? saved.pat : 'squares',
        tool: 'pen', col: ci(saved.col, 0, 5, 0), size: ci(saved.size, 0, 2, 1), side: saved.side !== false && !narrow(),
        menu: null, sel: null, peek: false, saved: null, card: { x: 24, y: 24, s: ci(saved.cardS * 100, 50, 250, 100) / 100 }, skQ: '', skPick: null,
        /* ROUND 4 (2026-10-21): six pen slots per board colour, any of them changed (null = the board's own); a blank board
           with pages and no questions; Tab hides the tools; the Select tool's picked ink and diagrams */
        cols: saved.cols && typeof saved.cols === 'object' ? saved.cols : {}, blank: null, bare: false, pick: null, colFor: -1,
        /* ROUND 5: the highlighter's colour, the line or arrow the shape button gives, where the tools sit, the calculator */
        hlc: ci(saved.hlc, 0, 4, 0), shape: saved.shape === 'arrow' ? 'arrow' : 'line', dock: dockOk(saved.dock), calc: false, calcAt: dockXY(saved.calcAt),
        /* ROUND 7: box or lasso, pen pressure and smoothing, the chime, and the ruler and timer while they are out */
        calcZ: typeof saved.calcZ === 'number' && saved.calcZ >= 0.45 && saved.calcZ <= 1.5 ? saved.calcZ : null, selMode: saved.selMode === 'lasso' ? 'lasso' : 'box', press: saved.press2 === true, smooth: ci(saved.smooth, 0, 2, 1), chime: saved.chime !== false, ruler: null, timer: null, timerAt: null
      };
      function dockXY(v) { return v && typeof v.x === 'number' && typeof v.y === 'number' && v.x >= 0 && v.x <= 1 && v.y >= 0 && v.y <= 1 ? { x: v.x, y: v.y } : null; }
      function dockOk(v) {
        if (!v || typeof v !== 'object' || ['bottom', 'top', 'free', 'left', 'right'].indexOf(v.m) < 0) return { m: 'bottom' };
        var xy = dockXY(v) || { x: 0.5, y: 0.5 }; return { m: v.m, x: xy.x, y: xy.y };
      }
      var pages = {}, root = null, board, cvI, cvV, cvL, objsEl, cardEl, sideEl, topEl, dockEl, insEl, popEl, selEl, marqEl, chipEl, toastEl, fileEl, picsEl;
      var trayEl, zoomEl, miniEl, zonesEl, calcEl;
      var dpr = 1, W = 0, H = 0, cur = null, isDown = false, pend = null, trail = [], lg = 0, hover = null, sm = null, tgt = null, raf = 0, drag = null, oid = 0;
      function keep() { lsSet(KW, { theme: st.theme, pat: st.pat, col: st.col, size: st.size, side: st.side, cardS: st.card.s, cols: st.cols, hlc: st.hlc, shape: st.shape, dock: st.dock, calcAt: st.calcAt, calcZ: st.calcZ, selMode: st.selMode, press2: st.press, smooth: st.smooth, chime: st.chime }); }
      /* PEN SLOTS (round 4, Aadam: "pick any colours but have defaults", "they can change any of the colours", "a reset
         button"): six in the dock, each board starts with the first six of its eight (every one at least 4.4:1 on its board) */
      var NSLOT = 6;
      function slotHex(k, t) { t = t || th(); var c = st.cols[t.id]; return (c && c[k]) || t.pal[k]; }
      function slotOwn(k, t) { t = t || th(); var c = st.cols[t.id]; return !!(c && c[k]); }
      function slotName(k, t) { t = t || th(); return slotOwn(k, t) ? 'Your colour' : t.pln[k]; }
      /* a stroke keeps its slot; a changed slot's colour is written on the stroke, so a later change or a reset never repaints it */
      function inkHex(s, t) { return s.h || t.pal[s.c] || t.pens[s.c] || t.ink; }
      function th() { return THEMES[st.theme]; }
      function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
      function fmt(n) { var v = Math.round(n * 100) / 100; return (v < 0 ? MINUS : '') + Math.abs(v); }
      function order() { return st.from === 'teach' ? teachOrder() : S.set.map(function (x, k) { return k; }); }
      /* BLANK BOARD (round 4, Aadam: "standalone whiteboard mode from main page - just click into it so you don't have any
         questions"): pages of plain board, opened from the library; each page is an item of its own with no skill */
      var blankIts = {};
      function blankIt(id) { return blankIts[id] || (blankIts[id] = { blank: true, id: id, skill: null, level: 0, q: { html: '', text: '', key: id }, state: 'blank' }); }
      function newBlankId() { return 'b' + Date.now().toString(36) + (++oid); }
      function item() { return st.saved || (st.blank ? blankIt(st.blank.ids[st.blank.at]) : S.set[st.i]); }
      function keyOf(it) { return !it ? '' : it.blank ? 'blank|' + it.id : it.skill.id + '|' + it.level + '|' + (it.q.key || it.q.text); }
      /* SAVING (round 4, Aadam: "don't need to save boards unless you choose for it to be saved"): a board is kept on the
         device only once Save board is pressed (p.keep); everything else lasts while the page is open */
      function pageOf(it) {
        var k = keyOf(it); if (pages[k]) return pages[k];
        var e = store[k];
        var vw = e && e.view, okv = vw && isFinite(vw.x) && isFinite(vw.y) && vw.z >= ZMIN && vw.z <= ZMAX;
        return (pages[k] = { ink: e ? dec(e.ink) : [], objs: e && Array.isArray(e.objs) ? JSON.parse(JSON.stringify(e.objs)) : [], imgs: e && e.imgs && typeof e.imgs === 'object' ? e.imgs : {}, hist: [], fut: [], keep: !!e, view: okv ? { x: +vw.x, y: +vw.y, z: +vw.z } : { x: 0, y: 0, z: 1 } });
      }
      function page() { return pageOf(item()); }
      function hasWork(it) { var k = keyOf(it), p = pages[k]; return p ? !!(p.ink.length || p.objs.length) : !!store[k]; }
      function kept(it) { var k = keyOf(it), p = pages[k]; return p ? p.keep : !!store[k]; }
      function snapOf(p) { return { ink: p.ink.slice(), objs: JSON.stringify(p.objs) }; }
      function snap(p) { p = p || page(); p.hist.push(snapOf(p)); if (p.hist.length > 80) p.hist.shift(); p.fut = []; }

      /* ---------- boards kept on the device ---------- */
      var KB = 'shlc_sl_wb_boards', MAXB = 60, saveT = 0, saveIts = [];
      var store = (function () { try { var v = JSON.parse(localStorage.getItem(KB) || '{}'); return v && typeof v === 'object' && !Array.isArray(v) ? v : {}; } catch (e) { return {}; } })();
      function enc(ink) { return ink.map(function (s) { var a = []; s.pts.forEach(function (q) { a.push(Math.round(q.x), Math.round(q.y)); }); var o = { k: s.k, c: s.c, w: s.w, p: a }; if (s.h) o.h = s.h; if (s.st) o.st = 1; if (s.hc !== undefined) o.hc = s.hc; if (s.ra) o.ra = 1; if (s.pr) { o.pr = 1; o.pp = s.pts.map(function (q) { return Math.round((q.p || 0.5) * 100); }); } return o; }); }
      function dec(a) { return (Array.isArray(a) ? a : []).map(function (s) { var pts = []; for (var i = 0; i + 1 < (s.p || []).length; i += 2) pts.push({ x: s.p[i], y: s.p[i + 1] }); var o = { k: s.k, c: s.c | 0, w: s.w || 6, pts: pts }; if (typeof s.h === 'string' && /^#[0-9a-f]{6}$/i.test(s.h)) o.h = s.h; if (s.st) o.st = 1; if (s.hc >= 0 && s.hc <= 4) o.hc = s.hc | 0; if (s.ra) o.ra = 1; if (s.pr && Array.isArray(s.pp) && s.pp.length === pts.length) { o.pr = 1; pts.forEach(function (q, i) { q.p = clamp(Number(s.pp[i]) / 100 || 0.5, 0, 1); }); } return o; }); }
      function newest() { return Object.keys(store).sort(function (a, b) { return (store[b].t || 0) - (store[a].t || 0); }); }
      function writeStore() {
        newest().slice(MAXB).forEach(function (k) { delete store[k]; });
        for (var tries = 0; tries < 6; tries++) {
          try { localStorage.setItem(KB, JSON.stringify(store)); return true; } catch (e) {
            var ks = newest(); if (ks.length <= 1) return false;
            ks.slice(Math.ceil(ks.length / 2)).forEach(function (k) { delete store[k]; });   /* full: the older half goes */
          }
        }
        return false;
      }
      function dirty(it) { it = it || item(); if (it && saveIts.indexOf(it) < 0) saveIts.push(it); clearTimeout(saveT); saveT = setTimeout(flush, 500); }
      function flush() {
        clearTimeout(saveT); var list = saveIts; saveIts = [];
        list.forEach(function (it) {
          var k = keyOf(it), p = pages[k]; if (!p || !p.keep) return;
          var used = {}; p.objs.forEach(function (o) { if (o.type === 'img' && p.imgs[o.ref]) used[o.ref] = p.imgs[o.ref]; });
          store[k] = it.blank ? { t: Date.now(), blank: 1, sk: null, lv: 0, qh: '', ah: '', qt: '', ink: enc(p.ink), objs: p.objs, imgs: used, view: p.view }
            : { t: Date.now(), sk: it.skill.id, lv: it.level, qh: it.q.html, ah: it.q.ansHTML || '', qt: String(it.q.text || ''), ink: enc(p.ink), objs: p.objs, imgs: used };
        });
        if (list.length) writeStore();
      }
      window.addEventListener('pagehide', flush);
      /* round 12: a blank board with work on it that was never saved asks before a reload or a closed tab throws it away */
      window.addEventListener('beforeunload', function (e) {
        var lose = Object.keys(pages).some(function (k) { var p = pages[k]; return k.indexOf('blank|') === 0 && p && !p.keep && (p.ink.length || p.objs.length); });
        if (lose) { e.preventDefault(); e.returnValue = ''; }
      });
      function savedItem(k) {
        var e = store[k];
        if (e && e.blank) { var b = blankIt(k.slice(6)); return { blank: true, id: b.id, skill: null, level: 0, q: b.q, state: 'saved', saved: true }; }
        var sk = e && SL.get(e.sk); if (!sk) return null;
        return { skill: sk, level: e.lv, q: { html: e.qh, ansHTML: e.ah, text: e.qt, key: k.split('|').slice(2).join('|') }, state: 'saved', saved: true };
      }
      function when(t) {
        var d = new Date(t), now = new Date(), hm = ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
        if (d.toDateString() === now.toDateString()) return 'Today ' + hm;
        var y = new Date(now); y.setDate(now.getDate() - 1);
        if (d.toDateString() === y.toDateString()) return 'Yesterday ' + hm;
        return d.getDate() + ' ' + ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][d.getMonth()] + ' ' + hm;
      }
      function openSaved(k) {
        flush();
        if (store[k] && store[k].blank) { if (!st.blank) { st.blank = { ids: [], at: 0 }; root.classList.add('is-blank'); } var bid = k.slice(6), at = st.blank.ids.indexOf(bid); if (at < 0) { st.blank.ids.push(bid); at = st.blank.ids.length - 1; } st.blank.at = at; st.saved = null; st.menu = null; st.sel = null; st.pick = null; drawAll(); redraw(); return; }
        if (!st.blank) for (var i = 0; i < S.set.length; i++) if (keyOf(S.set[i]) === k) { st.saved = null; st.menu = null; st.i = i; st.sel = null; drawAll(); redraw(); return; }
        var it = savedItem(k); if (!it) return;
        st.saved = it; st.menu = null; st.sel = null; st.peek = false; drawAll(); redraw();
      }

      /* ---------- the frame ---------- */
      function build() {
        root = el('div', 'sl-wb');
        root.setAttribute('role', 'dialog'); root.setAttribute('aria-label', 'Whiteboard'); root.tabIndex = -1;
        root.innerHTML = '<div class="wb-top"></div><div class="wb-body"><div class="wb-side"></div><div class="wb-wrap"><div class="wb-board">' +
          '<div class="wb-pics"></div><canvas class="wb-ink"></canvas><div class="wb-objs"></div><div class="wb-card"></div><canvas class="wb-inkv" aria-hidden="true"></canvas><canvas class="wb-lz"></canvas>' +
          '<div class="wb-selbox" hidden></div><div class="wb-marq" hidden><span></span></div><div class="wb-chip" hidden></div><div class="wb-toast" hidden role="status"></div>' +
          '<button type="button" class="wb-b wb-bareb" data-wb="bare" aria-label="Show the tools" data-tip="Show the tools" data-tipsub="Key: Tab">' + I.show + '</button>' +
          '<input type="file" class="wb-file" accept="image/*" hidden>' +
          '<canvas class="wb-mini" hidden aria-hidden="true"></canvas><div class="wb-zoom" hidden></div>' +
          '<div class="wb-calc" hidden role="dialog" aria-label="Calculator"><div class="wb-calch" data-wbcalc="1"><span class="wb-calcg">' + I.grip + '</span><b>Calculator</b><span class="wb-calcs">fx-83GTX keys</span><span class="wb-sp"></span>' +
            '<button type="button" class="wb-b wb-calcput" data-wb="calcput" data-tip="Put the sum and answer on the board">Put on board</button>' +
            '<button type="button" class="wb-oc" data-wb="calc" aria-label="Close the calculator" data-tip="Close">' + ICON.cross + '</button></div><div class="wb-calcb"></div>' +
            '<button type="button" class="wb-calcsz" data-calcsz="1" aria-label="Make the calculator bigger or smaller" data-tip="Pull to resize">' + I.nub + '</button></div>' +
          '<div class="wb-zones" aria-hidden="true"><span data-z="top"></span><span data-z="bottom"></span><span data-z="left"></span><span data-z="right"></span></div>' +
          '<div class="wb-ins" hidden></div><div class="wb-tray" hidden></div><div class="wb-dock"></div></div></div></div><div class="wb-pop" hidden></div>';
        shell.appendChild(root);
        topEl = root.querySelector('.wb-top'); sideEl = root.querySelector('.wb-side'); board = root.querySelector('.wb-board');
        cvI = root.querySelector('.wb-ink'); cvV = root.querySelector('.wb-inkv'); cvL = root.querySelector('.wb-lz'); objsEl = root.querySelector('.wb-objs');
        cardEl = root.querySelector('.wb-card'); dockEl = root.querySelector('.wb-dock'); insEl = root.querySelector('.wb-ins'); popEl = root.querySelector('.wb-pop');
        trayEl = root.querySelector('.wb-tray'); zoomEl = root.querySelector('.wb-zoom'); miniEl = root.querySelector('.wb-mini'); zonesEl = root.querySelector('.wb-zones'); calcEl = root.querySelector('.wb-calc');
        dockEl.addEventListener('pointerdown', dockDown);
        /* hold Undo: the replay slider */
        dockEl.addEventListener('pointerdown', function (e) { if (!(e.target.closest && e.target.closest('[data-wb="undo"]'))) return; clearTimeout(undoHold); undoHold = setTimeout(function () { undoHold = -1; replayOpen(); drawTop(); }, 550); });
        ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { dockEl.addEventListener(ev, function () { if (undoHold > 0) { clearTimeout(undoHold); undoHold = 0; } }); }); dockEl.addEventListener('pointermove', dockMove); dockEl.addEventListener('pointerup', dockUp); dockEl.addEventListener('pointercancel', dockUp);
        dockEl.addEventListener('dblclick', function (e) { if (e.target.closest && e.target.closest('[data-wbdock]')) { st.dock = { m: 'bottom' }; keep(); applyDock(); placeMenus(); } });
        /* ROUND 10 (Aadam: "issue with selecting stuff when I had the calc on"): the calculator held the keys after any press
           on it, Put on board or a move, so V, Delete, the arrows and Ctrl Z went to it, not the pick. A press anywhere else
           now hands the keys back to the board (Chrome only did that by chance, Safari never) */
        root.addEventListener('pointerdown', function (e) {
          if (st.calc && calcEl.contains(document.activeElement) && !(e.target.closest && e.target.closest('.wb-calc'))) { try { root.focus({ preventScroll: true }); } catch (er) {} }
        }, true);
        calcEl.addEventListener('pointerdown', calcDown); calcEl.addEventListener('pointermove', calcMove); calcEl.addEventListener('pointerup', calcUp); calcEl.addEventListener('pointercancel', calcUp);
        miniEl.addEventListener('pointerdown', miniDown); miniEl.addEventListener('pointermove', miniMove); miniEl.addEventListener('pointerup', miniUp); miniEl.addEventListener('pointercancel', miniUp);
        board.addEventListener('wheel', onWheel, { passive: false });
        board.addEventListener('pointermove', function (e) { if (!st.open || !endless() || e.pointerType === 'touch') return; var q = ptS(e); var mu = miniEl && parseInt(miniEl.style.bottom, 10) || 0; if ((q.y > H - 170 && q.x > W - 300) || (q.y > H - 190 - mu && q.y < H - mu + 20 && q.x < 280) || (q.y > H - 170 && q.x < 240)) showNav(); });
        picsEl = root.querySelector('.wb-pics'); selEl = root.querySelector('.wb-selbox'); marqEl = root.querySelector('.wb-marq'); chipEl = root.querySelector('.wb-chip'); toastEl = root.querySelector('.wb-toast'); fileEl = root.querySelector('.wb-file');
        fileEl.addEventListener('change', function () { var f = fileEl.files && fileEl.files[0]; fileEl.value = ''; if (f) addImageFile(f); });
        /* a picture: pasted (Ctrl V), dropped on the board, or picked with the picture button */
        document.addEventListener('paste', onPaste);
        /* round 12: files from the computer (several at once) and pictures dragged from another page; a drop that misses
           the board (on the bar, the map) still lands on it, and never opens the picture in place of the Lab */
        var dropOK = function (e) { return st.open && e.dataTransfer && Array.prototype.some.call(e.dataTransfer.types || [], function (x) { return x === 'Files' || x === 'text/uri-list' || x === 'text/html'; }); };
        root.addEventListener('dragover', function (e) { if (!dropOK(e)) return; e.preventDefault(); try { e.dataTransfer.dropEffect = 'copy'; } catch (er) {} board.classList.add('is-drop'); });
        root.addEventListener('dragleave', function (e) { if (!e.relatedTarget || !root.contains(e.relatedTarget)) board.classList.remove('is-drop'); });
        root.addEventListener('drop', function (e) {
          board.classList.remove('is-drop');
          if (!dropOK(e)) return;
          var t = e.target, typing = t && t.closest && t.closest('input,textarea,[contenteditable="true"]');
          if (typing) return;
          e.preventDefault();
          var v0 = view(), at = board.contains(t) ? pt(e) : { x: v0.x + W / 2 / v0.z, y: v0.y + H / 2 / v0.z }, dt = e.dataTransfer;
          var fs = Array.prototype.filter.call(dt.files || [], function (f) { return /^image\//.test(f.type); });
          if (fs.length) { fs.slice(0, 8).forEach(function (f, n) { addImageFile(f, { x: at.x + n * 36 / v0.z, y: at.y + n * 36 / v0.z }); }); if (fs.length > 8) toast('8 pictures at a time'); return; }
          if (dt.files && dt.files.length) { toast('Only pictures can go on the board'); return; }
          var u = '', h = dt.getData('text/html') || '', m = /<img[^>]+src="([^"]+)"/i.exec(h);
          if (m) u = m[1].replace(/&amp;/g, '&'); else u = (dt.getData('text/uri-list') || '').split(/\r?\n/).filter(function (x) { return x && x[0] !== '#'; })[0] || '';
          if (u) addImageUrl(u, at);
        });
        cvI.addEventListener('contextmenu', function (e) { e.preventDefault(); });
        root.addEventListener('contextmenu', function (e) { var sw = e.target.closest ? e.target.closest('[data-slot]') : null; if (!sw) return; e.preventDefault(); openCol(Number(sw.getAttribute('data-slot'))); });
        popEl.addEventListener('pointerdown', cpDown); popEl.addEventListener('pointermove', cpMove); popEl.addEventListener('pointerup', cpUp); popEl.addEventListener('pointercancel', cpUp);
        selEl.addEventListener('pointerdown', selBarDown);
        if (window.ResizeObserver) new ResizeObserver(function () { fit(); }).observe(board);
        /* the board never scrolls: a box or field focused near its edge must not slide everything up (round 7) */
        board.addEventListener('scroll', function () { if (board.scrollTop || board.scrollLeft) { board.scrollTop = 0; board.scrollLeft = 0; } });
        cvI.addEventListener('pointerdown', inkDown); cvI.addEventListener('pointermove', inkMove);
        cvI.addEventListener('dblclick', function (e) { var o = txtHit(pt(e)); if (o) editText(o); });
        root.addEventListener('keydown', function (e) {
          var t = e.target; if (e.key !== 'Enter' || !t || !t.classList || !t.classList.contains('wb-gin')) return;
          e.preventDefault(); e.stopPropagation();
          var box = t.closest('.wb-obj'), o = box && findObj(box.getAttribute('data-id')), v = String(t.value || '').replace(/^\s*y\s*=\s*/i, '').trim();
          if (!o || !v) return;
          if (!fnOf(v)) { t.classList.remove('is-bad'); void t.offsetWidth; t.classList.add('is-bad'); toast('That line could not be read. Try something like 2x + 1'); return; }
          snap(); o.fns = (o.fns || []).concat([v]).slice(0, 4); o.hide = false; drawObjs(); dirty();
          var ni = objsEl.querySelector('[data-id="' + o.id + '"] .wb-gin'); if (ni) { try { ni.focus({ preventScroll: true }); } catch (er) {} }
        }, true);
        cvI.addEventListener('pointerup', inkUp); cvI.addEventListener('pointercancel', inkUp);
        cvI.addEventListener('pointerleave', function () { if (!isDown) { hover = null; sm = null; tgt = null; loop(); } });
        root.addEventListener('click', onClick);
        root.addEventListener('pointerdown', onHandleDown);
        root.addEventListener('pointermove', onHandleMove);
        root.addEventListener('pointerup', onHandleUp); root.addEventListener('pointercancel', onHandleUp);
        root.addEventListener('input', onInput);
        root.addEventListener('focusin', function (e) { var t = e.target; if (t && t.hasAttribute && t.hasAttribute('data-in')) snap(); });
        root.addEventListener('pointerdown', function (e) {
          var b = e.target.closest ? e.target.closest('[data-wbpeek]') : null; if (!b || e.button > 0) return;
          e.preventDefault(); peekPtr = e.pointerId; try { b.setPointerCapture(e.pointerId); } catch (er) {} hideTip(); peekDown();
        });
        var pkUp = function (e) { if (peekPtr === null || e.pointerId !== peekPtr) return; peekPtr = null; peekUp(); };
        root.addEventListener('pointerup', pkUp); root.addEventListener('pointercancel', pkUp); root.addEventListener('lostpointercapture', pkUp, true);
        root.addEventListener('contextmenu', function (e) { if (e.target.closest && e.target.closest('[data-wbpeek],.wb-card')) e.preventDefault(); });
        /* the diagrams let the pen through, so their grip and corner show when the pointer is near one */
        root.addEventListener('pointermove', function (e) {
          if (drag || isDown || e.pointerType === 'touch' || !objsEl) return;
          var p = pt(e), hit = null;
          Array.prototype.forEach.call(objsEl.children, function (bx) { var x = bx.offsetLeft, y = bx.offsetTop; if (p.x > x - 30 && p.x < x + bx.offsetWidth + 30 && p.y > y - 40 && p.y < y + bx.offsetHeight + 30) hit = bx; });
          Array.prototype.forEach.call(objsEl.children, function (bx) { bx.classList.toggle('is-hov', bx === hit); });
        });
      }
      function open(from, i) {
        if (from !== 'blank' && !S.set.length) return;
        if (!root) build();
        if (from === 'blank') { if (!st.blank) st.blank = { ids: [newBlankId()], at: 0 }; }
        else { st.blank = null; st.i = clamp(i || 0, 0, S.set.length - 1); }
        st.from = from; st.saved = null; st.open = true; st.menu = null; st.sel = null; st.peek = false; st.pick = null; st.colFor = -1;
        root.classList.toggle('is-blank', from === 'blank'); setBare(false);
        clearTimeout(outT); root.classList.remove('is-out'); st.fresh = false; peekLock = false; peekT0 = 0;
        hideTip(); root.classList.add('is-on'); shell.classList.add('wb-on');
        drawAll(); fit();
        try { root.focus({ preventScroll: true }); } catch (e) {}
        track('whiteboard_open', { from: from, skill: from === 'blank' ? 'blank' : item().skill.id });
      }
      var outT = 0;
      function close(quiet) {
        if (!st.open) return;
        flush(); st.saved = null; st.pick = null; drawPick(); hideToast(); hideChip(); if (st.calc) toggleCalc(false);
        st.open = false; st.menu = null; hover = null; sm = null; trail = []; loop(); setPeek(false);
        shell.classList.remove('wb-on'); hideTip();
        if (reduceMotion) root.classList.remove('is-on');
        else { root.classList.add('is-out'); clearTimeout(outT); outT = setTimeout(function () { root.classList.remove('is-on', 'is-out'); }, 190); }
        var fresh = st.fresh; st.fresh = false;
        if (quiet || st.from === 'blank') return;
        if (st.from === 'teach') { if (S.screen === 'teach' && (S.teach.i !== st.i || fresh)) teachGo(st.i); }
        else if (S.screen === 'practise') { if (S.prOne >= 0) openCard(st.i); else { renderPractise(); renderTop(); } }
      }
      /* NEW QUESTION (round 3, Aadam: "the whiteboard area needs refreshable questions"): swaps the one on the board for
         another at the same skill and level, as Teach and Practise do; the work on the old one stays saved with it */
      function freshHere(at) {
        if (st.saved || !st.open || st.blank) return;
        var i = typeof at === 'number' ? at : st.i, it = S.set[i]; if (!it) return;
        flush();
        var ctx = { seen: {}, shapeSeen: {}, last: null };
        S.set.forEach(function (x, n) { if (n !== i && x.skill === it.skill && x.q && x.q.key) ctx.seen[x.q.key] = 1; });
        ctx.slot = slotIn(S.set, i);
        S.set[i] = makeItem(it.skill, it.level, ctx);
        st.fresh = true; st.sel = null; st.menu = null;
        var b = sideEl.querySelector('[data-wbfresh="' + i + '"]'); if (b) { b.classList.remove('is-spin'); void b.offsetWidth; b.classList.add('is-spin'); }
        /* another question in the list, not the one on the board: only its row changes */
        if (i !== st.i) { drawSide(); var b2 = sideEl.querySelector('[data-wbfresh="' + i + '"]'); if (b2) b2.classList.add('is-spin'); return; }
        if (reduceMotion) { setPeek(false); drawAll(); redraw(); return; }
        cardEl.classList.remove('is-in'); cardEl.classList.add('is-out');
        setTimeout(function () { if (!st.open) return; st.peek = false; peekLock = false; drawAll(); redraw(); }, 170);
        track('whiteboard_fresh', { skill: it.skill.id, level: it.level });
      }
      /* NEW SET (round 4, Aadam: "refresh next to 'QUESTIONS' will refresh all"): ten new questions at the same skills and
         levels, the way a new set is dealt; Undo puts the old ten back, with their working (it is kept per question) */
      function freshAll() {
        if (st.saved || !st.open || st.blank || !S.set.length) return;
        flush();
        var old = S.set.slice(), oldI = st.i, p = order().indexOf(st.i);
        buildSet(); if (!S.set.length) { S.set = old; return; }
        st.i = order()[clamp(p, 0, order().length - 1)] || 0; st.fresh = true; st.sel = null; st.menu = null; st.pick = null; st.peek = false; peekLock = false;
        drawAll(); redraw();
        var b = sideEl.querySelector('[data-wb="freshall"]'); if (b) b.classList.add('is-spin');
        toast(S.set.length + ' new questions', function () { S.set = old; st.i = oldI; st.fresh = true; drawAll(); redraw(); });
        track('whiteboard_fresh_all', { n: S.set.length });
      }
      /* TEACH THIS (round 3, "one button linkage to teach mode"): Teach on the same skill, level and question */
      function toTeach() {
        if (st.saved || st.blank) return;
        var i = st.i;
        if (st.from === 'teach') { close(); return; }
        close(true);
        S.teach.i = i; S.teach.back = 'practise'; show('teach');
      }
      function go(i) { if (i < 0 || i >= S.set.length || (i === st.i && !st.saved)) return; flush(); st.saved = null; st.i = i; st.sel = null; st.pick = null; st.peek = false; peekLock = false; st.menu = null; drawAll(); redraw(); }
      function goPage(at) { if (!st.blank) return; at = clamp(at, 0, st.blank.ids.length - 1); if (at === st.blank.at && !st.saved) return; flush(); st.saved = null; st.blank.at = at; st.sel = null; st.pick = null; st.menu = null; drawAll(); redraw(); }
      function newPage() { if (!st.blank) return; flush(); st.saved = null; st.blank.ids.push(newBlankId()); st.blank.at = st.blank.ids.length - 1; st.sel = null; st.pick = null; st.menu = null; drawAll(); redraw(); }
      function step(d) {
        if (st.blank) { if (st.saved) { goPage(st.blank.at); return; } goPage(st.blank.at + d); return; }
        if (st.saved) { go(st.i); return; } var o = order(), p = o.indexOf(st.i); go(o[clamp(p + d, 0, o.length - 1)]);
      }

      /* ---------- drawing the parts ---------- */
      function drawAll() { if (rp) { rpStop(); rp = null; replayDraw(); } paintBoard(); drawTop(); drawSide(); drawCard(); drawObjs(); drawDock(); drawIns(); drawPop(); applyView(); }
      /* the paper moves and scales with an endless board's view (v), so ink stays on its squares */
      function patCss(t, p, v) {
        var z = v ? v.z : 1, ox = v ? -v.x * z : 0, oy = v ? -v.y * z : 0;
        function at(n) { var g = n * z; return ((ox % g) + g) % g + 'px ' + ((oy % g) + g) % g + 'px / '; }
        var d = 34 * z, q = 40 * z, l = 44 * z, dot = Math.max(1, 2.2 * Math.min(1, z * 1.2));
        if (z < 0.3) p = 'plain';   /* far out, paper lines would only be noise */
        return p === 'dots' ? 'radial-gradient(' + t.pat + ' ' + dot + 'px, transparent ' + (dot + 0.4) + 'px) ' + at(34) + d + 'px ' + d + 'px'
          : p === 'squares' ? 'linear-gradient(' + t.pat + ' 1px, transparent 1px) ' + at(40) + q + 'px ' + q + 'px, linear-gradient(90deg, ' + t.pat + ' 1px, transparent 1px) ' + at(40) + q + 'px ' + q + 'px'
          : p === 'lines' ? 'linear-gradient(' + t.pat + ' 1px, transparent 1px) 0 ' + (((oy % l) + l) % l) + 'px / 100% ' + l + 'px' : 'none';
      }
      function paintBoard() {
        var t = th(), s = board.style, pc = patCss(t, st.pat, endless() ? view() : null);
        s.background = pc === 'none' ? t.bg : pc + ', ' + t.bg;
        if (root) root.classList.toggle('is-endless', endless());
        s.setProperty('--wb-ink', t.ink); s.setProperty('--wb-acc', t.pens[1]); s.setProperty('--wb-fill', t.fill);
        s.setProperty('--wb-pat', t.pat); s.setProperty('--wb-sub', t.sub); s.setProperty('--wb-card', t.card); s.setProperty('--wb-cline', t.line);
        board.setAttribute('data-dark', t.dark ? '1' : '0');
        board.setAttribute('data-tool', st.tool);
      }
      function btn(act, label, icon, cls, key, extra) {
        return '<button type="button" class="wb-b' + (cls ? ' ' + cls : '') + '" data-wb="' + act + '" aria-label="' + label + '" data-tip="' + label + '"' + (key ? ' data-tipsub="Key: ' + key + '"' : '') + (extra || '') + '>' + icon + '</button>';
      }
      function shareBtn() { var sh = shareNow(); return '<button type="button" class="wb-b wb-shbtn' + (st.menu === 'share' || sh ? ' is-on' : '') + '" data-wb="share" aria-label="Share with a student" data-tip="Share with a student" data-tipsub="A link and a QR code to look at the board">' + I.share + '<span>' + (sh ? 'Shared' : 'Share') + '</span></button>'; }
      function keepBtn() {
        var on = kept(item());
        return '<button type="button" class="wb-b wb-keep' + (on ? ' is-kept' : '') + '" data-wb="keep" aria-pressed="' + (on ? 'true' : 'false') + '" data-tip="' + (on ? 'Saved on this device' : 'Save this board') + '" data-tipsub="' + (on ? 'Tap to stop keeping it' : 'Find it again in the boards menu') + '">' + I.keep + '<span>' + (on ? 'Saved' : 'Save board') + '</span></button>';
      }
      function drawTop() {
        var it = item();
        if (st.blank) {
          var n = st.blank.ids.length, at = st.blank.at;
          topEl.innerHTML = btn('close', 'Close the whiteboard', ICON.cross, '', 'W or Esc') +
            '<span class="wb-skill wb-blankname"><span class="wb-skico wb-blankico">' + I.pen + '</span><span class="wb-skname"><b>Whiteboard</b><span>' + (st.saved ? 'Saved board' : 'Blank board') + '</span></span></span>' +
            '<span class="wb-nav">' + btn('prev', 'Previous page', ICON.chevL, '', '←', at > 0 || st.saved ? '' : ' disabled') +
              '<span class="wb-pos num">' + (st.saved ? '<b>Saved</b>' : 'Page <b>' + (at + 1) + '</b> of ' + n) + '</span>' +
              btn('next', 'Next page', ICON.chevR, '', '→', at < n - 1 || st.saved ? '' : ' disabled') +
              '<button type="button" class="wb-b wb-newpg" data-wb="newpage" aria-label="New page" data-tip="New page">' + ICON.plus + '<span>New page</span></button></span>' +
            '<span class="wb-fold"><button type="button" class="wb-b wb-addq' + (st.menu === 'addq' ? ' is-on' : '') + '" data-wb="addq" aria-label="Add a question from any skill" data-tip="Add a question from any skill">' + ICON.plus + '<span>Add a question</span></button></span>' +
            '<span class="wb-sp"></span>' + topRest();
          return;
        }
        var sk = it.skill, o = order(), p = o.indexOf(st.i), pr = st.from === 'practise' && !st.saved, done = it.state === 'ok' || it.state === 'miss';
        topEl.innerHTML =
          btn('close', 'Close the whiteboard', ICON.cross, '', 'W or Esc') +
          '<span class="wb-fold">' + btn('side', st.side ? 'Hide the questions' : 'Show the questions', I.panel, st.side ? 'is-on' : '') + '</span>' +
          '<button type="button" class="wb-skill' + (st.menu === 'skills' ? ' is-on' : '') + '" data-wb="skills" aria-label="Change skill or level" data-tip="Change skill or level">' +
            '<span class="wb-skico" style="color:' + colourOf(sk).col + ';background:' + colourOf(sk).tint + '">' + skIcon(sk) + '</span>' +
            '<span class="wb-skname"><b>' + esc(sk.name) + '</b><span>Level ' + it.level + ': ' + esc(levelName(sk, it.level)) + '</span></span>' + ICON.chevD + '</button>' +
          '<span class="wb-nav">' + btn('prev', 'Previous question', ICON.chevL, '', '←', p > 0 || st.saved ? '' : ' disabled') +
            '<span class="wb-pos num">' + (st.saved ? '<b>Saved</b>' : '<b>' + (p + 1) + '</b> of ' + o.length) + '</span>' +
            btn('next', 'Next question', ICON.chevR, '', '→', p < o.length - 1 || st.saved ? '' : ' disabled') + '</span>' +
          '<span class="wb-sp"></span>' +
          (pr ? '<span class="wb-mark">' + btn('ok', done ? (it.state === 'ok' ? 'Marked right' : 'Marked') : 'Got it', ICON.tick, 'wb-ok' + (it.state === 'ok' ? ' is-on' : ''), 'C', done ? ' disabled' : '') +
                btn('miss', done ? (it.state === 'miss' ? 'Marked missed' : 'Marked') : 'Missed it', ICON.cross, 'wb-miss' + (it.state === 'miss' ? ' is-on' : ''), 'X', done ? ' disabled' : '') + '</span>' : '') +
          '<button type="button" class="wb-b' + (st.peek ? ' is-on' : '') + '" data-wbpeek="1" aria-pressed="' + (st.peek ? 'true' : 'false') + '" aria-label="Hold to see the answer, tap to keep it" data-tip="Hold to see the answer" data-tipsub="Tap to keep it · Space">' + ICON.eye + '</button>' +
          (st.saved ? '' : '<span class="wb-fold"><button type="button" class="wb-b wb-teach" data-wb="teach" aria-label="Teach this question" data-tip="Teach this question" data-tipsub="Key: T">' + ICON.steps + '<span>Teach</span></button></span>') +
          topRest();
      }
      /* ROUND 8 (Aadam: "improve how it works on mobile"): on a phone the top bar keeps only what is used all the time;
         Share, Save, Replay, Boards, Colours, Full screen (and Add a question, Teach) sit in one More menu */
      function topRest() {
        return '<span class="wb-fold">' + shareBtn() + keepBtn() +
          btn('replay', 'Replay the working', I.clock, rp ? 'is-on' : '', '', ' data-tipsub="Or hold Undo"') + btn('boards', 'Saved boards and downloads', I.boards, st.menu === 'boards' ? 'is-on' : '') +
          btn('theme', 'Board colour and paper', I.palette, st.menu === 'theme' ? 'is-on' : '') +
          btn('full', 'Full screen', I.full, '', 'F') + '</span>' +
          btn('more', 'More', I.more, 'wb-more' + (st.menu === 'more' ? ' is-on' : ''));
      }
      function moreHTML() {
        var it = item(), rows = [];
        if (st.blank) rows.push(['addq', 'Add a question', ICON.plus]);
        if (!st.blank) rows.push(['side', st.side ? 'Hide the question list' : 'Show the question list', I.panel]);
        if (!st.blank && !st.saved) rows.push(['teach', 'Teach this question', ICON.steps]);
        rows.push(['share', shareNow() ? 'Shared with a student' : 'Share with a student', I.share], ['keep', kept(it) ? 'Saved on this device' : 'Save this board', I.keep],
          ['replay', 'Replay the working', I.clock], ['boards', 'Saved boards and downloads', I.boards], ['theme', 'Board colour and paper', I.palette], ['full', 'Full screen', I.full]);
        return rows.map(function (r) { return '<button type="button" class="wb-morer" data-wb="' + r[0] + '">' + r[2] + '<span>' + r[1] + '</span></button>'; }).join('');
      }
      /* NEW QUESTIONS (round 4, Aadam: "move the refresh functionality next to the questions - hide unless hovered over"):
         each row's own refresh shows on hover; the one by QUESTIONS deals a new set */
      function drawSide() {
        root.classList.toggle('is-side', st.side && !st.blank);
        if (!st.side || st.blank) { sideEl.innerHTML = ''; return; }
        var o = order(), sv = !!st.saved;
        sideEl.innerHTML = '<div class="wb-sidehead"><span>Questions</span>' + (sv ? '' : '<button type="button" class="wb-rf wb-rfall" data-wb="freshall" aria-label="New set of questions" data-tip="New set of questions" data-tipsub="Same skills and levels. Key: Shift N">' + ICON.refresh + '</button>') + '</div>' + o.map(function (k, p) {
          var x = S.set[k], s = x.state;
          return '<div class="wb-rw"><button type="button" class="wb-row' + (k === st.i && !st.saved ? ' is-now' : '') + '" data-wbq="' + k + '"' + (k === st.i && !st.saved ? ' aria-current="true"' : '') + '>' +
            '<span class="wb-rn num">' + (p + 1) + '</span><span class="wb-rq sl-expr">' + (x.off ? '<i>Hidden</i>' : x.q.html) + '</span>' +
            (s === 'ok' ? '<span class="wb-rm ok">' + ICON.tick + '</span>' : s === 'miss' ? '<span class="wb-rm bad">' + ICON.cross + '</span>' : '') +
            (hasWork(x) ? '<span class="wb-rdot" title="Has working"></span>' : '') + '</button>' +
            (sv ? '' : '<button type="button" class="wb-rf" data-wbfresh="' + k + '" aria-label="New question ' + (p + 1) + ', same level" data-tip="New question, same level"' + (k === st.i ? ' data-tipsub="Key: N"' : '') + '>' + ICON.refresh + '</button>') + '</div>';
        }).join('');
        fitSide();
        var now = sideEl.querySelector('.is-now'); if (now && now.scrollIntoView) { try { now.scrollIntoView({ block: 'nearest' }); } catch (e) {} }
      }
      /* every question whole in its row (Aadam 2026-10-22: equations with fractions ran out of both sides):
         a row too wide or too tall steps its type down a pixel at a time to 12px (no words under 10px); past that it wraps and grows */
      function fitSide() {
        [].forEach.call(sideEl.querySelectorAll('.wb-rq'), function (q) {
          q.style.fontSize = ''; q.classList.remove('is-long');
          var px = parseFloat(getComputedStyle(q).fontSize), n = 0;
          function over() {
            var b = q.getBoundingClientRect(), o = Math.max(q.scrollWidth - q.clientWidth, q.scrollHeight - q.clientHeight);
            if (!b.width) return 0;
            [].forEach.call(q.querySelectorAll('*'), function (e) { var c = e.getBoundingClientRect(); if (c.width) o = Math.max(o, b.left - c.left, c.right - b.right); });
            return o;
          }
          function small() {   /* the smallest words in the row, so a caption at .6em never drops under 10px */
            var m = 99; [].forEach.call(q.querySelectorAll('*'), function (e) { if (!e.childElementCount && (e.textContent || '').trim()) m = Math.min(m, parseFloat(getComputedStyle(e).fontSize)); });
            return m;
          }
          while (over() > 1 && px > 12 && n++ < 12) { px -= 1; q.style.fontSize = px + 'px'; if (small() < 10) { px += 1; q.style.fontSize = px + 'px'; break; } }
          if (over() > 1) q.classList.add('is-long');
        });
      }
      function drawCard() {
        var it = item(), t = th();
        cardEl.hidden = !!it.blank;
        if (it.blank) { cardEl.innerHTML = ''; cardKey = ''; return; }
        var len = String(it.q.text || '').length, sk = it.skill;
        var fs = len > 90 ? 26 : len > 50 ? 34 : len > 28 ? 44 : 54;
        /* a phone or a small window: the question shrinks with the board (the corner handle still makes it bigger) */
        fs = Math.round(fs * clamp((board.clientWidth || 1000) / 1000, 0.55, 1));
        var ck = keyOf(it); if (ck !== cardKey) { cardKey = ck; cardInT = Date.now() + 560; }
        cardEl.className = 'wb-card' + (st.peek ? ' is-peek' : '') + (Date.now() < cardInT ? ' is-in' : '');
        cardEl.style.left = st.card.x + 'px'; cardEl.style.top = st.card.y + 'px'; cardEl.style.setProperty('--s', st.card.s); cardView();
        /* the question's own colours (operators, side notes) read the lab's --fg and --muted: on the board they are the board's */
        /* WHITEBOARD ROUND 3 (2026-10-18, Aadam: "don't need question showing", "can be tightened up", "the drag to move
           and resize can be better positioned and hidden"): no Q label, the whole card drags (ink never went on it: it sits
           over the ink), a grip line and a corner nub show only on hover; the answer is always in the card, folded, so
           showing it is a class (it opens smoothly) and never a redraw */
        cardEl.innerHTML = '<div class="wb-cardin" data-grip="card" style="font-size:' + fs + 'px">' +
          '<span class="wb-gl" aria-hidden="true"></span>' +
          '<div class="wb-q sl-expr">' + it.q.html + '</div>' +
          '<div class="wb-answ"><div><div class="wb-ans sl-expr">' + (it.q.ansHTML || '') + '</div></div></div>' +
          '<button type="button" class="wb-size wb-nub" data-size="card" aria-label="Make the question bigger or smaller" data-tip="Pull to resize">' + I.nub + '</button></div>';
        var cin = cardEl.firstChild; cin.style.setProperty('--fg', t.ink); cin.style.setProperty('--muted', t.sub); cin.style.setProperty('--dim', t.sub);
        /* round 3: the card never runs off the board (a phone, or a long question): it wraps to the board's width and
           is moved back on if a resize left it hanging off the edge */
        var bw0 = board.clientWidth || 1000; cin.style.maxWidth = Math.max(220, Math.min(1100, (bw0 - 32) / st.card.s)) + 'px';
        sizeBox(cardEl, cardEl.firstChild, st.card.s);
        if (st.card.x + cardEl.offsetWidth > bw0) { st.card.x = Math.max(0, Math.round(bw0 - cardEl.offsetWidth - 16)); cardEl.style.left = st.card.x + 'px'; }
        cardClear();
      }
      var cardKey = '', cardInT = 0, pkT = 0, peekT0 = 0, peekLock = false, peekPtr = null;
      /* HOLD FOR THE ANSWER (round 3, Aadam: "doesn't work all the time smoothly"): the old hold let go whenever the
         pointer crossed from the button onto its own icon (pointerout), and redrew the card each time. Now: hold the eye
         (or Space) and the answer opens; let go and it folds away; a quick tap keeps it open until the next tap. */
      function setPeek(on) {
        on = !!on; if (st.peek === on) return;
        st.peek = on; if (!on) peekLock = false;
        if (cardEl) cardEl.classList.toggle('is-peek', on);
        var b = topEl && topEl.querySelector('[data-wbpeek]'); if (b) { b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }
        clearTimeout(pkT); pkT = setTimeout(function () { if (cardEl && cardEl.firstChild) sizeBox(cardEl, cardEl.firstChild, st.card.s); }, 480);
      }
      function peekDown() { if (peekLock) { setPeek(false); peekT0 = 0; return; } peekT0 = Date.now(); setPeek(true); }
      function peekUp() { if (!peekT0) return; var quick = Date.now() - peekT0 < 260; peekT0 = 0; if (quick && st.peek) peekLock = true; else setPeek(false); }
      /* ROUND 11 (Aadam: "be able to rotate shapes and images"): a turned diagram or picture (rt, degrees) keeps its box round
         the turned shape, so x and y stay the top left of what is seen; the inside turns about the middle of the box */
      function sizeBox(box, inner, s, rt) {
        var w = inner.offsetWidth * s, h = inner.offsetHeight * s;
        if (rt === undefined) rt = Number(box.getAttribute('data-rt')) || 0;
        if (!rt) { box.removeAttribute('data-rt'); inner.style.transform = ''; box.style.width = Math.ceil(w) + 'px'; box.style.height = Math.ceil(h) + 'px'; return; }
        var d = turned(w, h, rt);
        box.setAttribute('data-rt', rt); box.style.width = Math.ceil(d.W) + 'px'; box.style.height = Math.ceil(d.H) + 'px';
        inner.style.transform = 'translate(' + (d.W / 2) + 'px,' + (d.H / 2) + 'px) rotate(' + rt + 'deg) translate(' + (-w / 2) + 'px,' + (-h / 2) + 'px) scale(' + s + ')';
      }
      function turned(w, h, rt) { var a = rt * Math.PI / 180, c = Math.abs(Math.cos(a)), sn = Math.abs(Math.sin(a)); return { W: w * c + h * sn, H: w * sn + h * c }; }
      /* THE BAR (round 5, Aadam: "simplify the bar - atm too long and complicated", design option A): the tools, then one dot
         for the colour and size (tap it, or the tool in use again, and they open above the bar), Add (+) with pictures and the
         diagrams, the calculator, undo and redo; Clear moved into the boards menu. Twelve buttons where there were 21. */
      var DTOOLS = [['select', 'Select', 'V'], ['pen', 'Pen', 'P'], ['hl', 'Highlighter', 'H'], ['shape', 'Line and arrow', 'L or A'], ['text', 'Type on the board', ''], ['eraser', 'Rubber', 'E'], ['laser', 'Laser pointer', 'K']];
      function styled(t) { return t === 'pen' || t === 'hl' || t === 'line' || t === 'arrow' || t === 'text'; }
      function isShape(t) { return t === 'line' || t === 'arrow'; }
      function drawDock() {
        var t = th(), tl = st.tool, sy = styled(tl);
        var dot = !sy ? '<span class="wb-doti is-off"></span>'
          : tl === 'hl' ? '<span class="wb-dotb" style="background:' + hlSolid(st.hlc, t) + ';height:' + [8, 12, 16][st.size] + 'px"></span>'
          : '<span class="wb-doti" style="background:' + slotHex(st.col, t) + ';width:' + [8, 12, 17][st.size] + 'px;height:' + [8, 12, 17][st.size] + 'px"></span>';
        dockEl.innerHTML = '<span class="wb-dg"><button type="button" class="wb-b wb-dgrip" data-wbdock="1" aria-label="Move the tools" data-tip="Drag to move the tools" data-tipsub="Double-click to put them back">' + I.grip + '</button>' + DTOOLS.map(function (x) {
            var on = x[0] === 'shape' ? isShape(tl) : tl === x[0], ic = x[0] === 'shape' ? I[st.shape] : x[0] === 'select' && st.selMode === 'lasso' ? I.lasso : I[x[0]];
            return btn('tool:' + x[0], x[0] === 'select' && st.selMode === 'lasso' ? 'Lasso select' : x[1], ic, 'wb-t' + (on ? ' is-on' : ''), x[2], on && styled(x[0] === 'shape' ? st.shape : x[0]) ? ' data-tipsub="Tap again for colours and sizes"' : x[0] === 'select' ? ' data-tipsub="Tap again for ' + (st.selMode === 'lasso' ? 'the box' : 'the lasso') + '"' : '');
          }).join('') + '</span>' +
          '<span class="wb-dg"><button type="button" class="wb-b wb-t wb-dot' + (st.menu === 'tray' ? ' is-on' : '') + '" data-wb="tray" aria-label="Colour and size" aria-expanded="' + (st.menu === 'tray' ? 'true' : 'false') + '" data-tip="Colour and size"' + (sy ? '' : ' disabled') + '><span class="wb-dotr">' + dot + '</span></button></span>' +
          '<span class="wb-dg">' + btn('ins', 'Add a picture, number line, bar model, grid, table or axes', ICON.plus, 'wb-t' + (st.menu === 'ins' ? ' is-on' : '')) +
            btn('calc', 'Calculator', I.calc, 'wb-t' + (st.calc ? ' is-on' : '')) + '</span>' +
          '<span class="wb-dg">' + btn('undo', 'Undo', I.undo, 'wb-t', 'Ctrl Z') + btn('redo', 'Redo', I.redo, 'wb-t', 'Ctrl Y') +
            /* ROUND 11 (Aadam: "easier button for clearing the board"): Clear sits on the bar again, one press, Undo brings it back */
            btn('clear', 'Clear the board', I.trash, 'wb-t', '', ' data-tipsub="Undo brings it back"') + '</span>';
        applyDock(); drawTray();
      }
      /* colours and sizes for the tool in use, beside the bar wherever it is */
      function drawTray() {
        if (!trayEl) return;
        var tl = st.tool, on = st.menu === 'tray' && styled(tl);
        trayEl.hidden = !on; if (!on) { trayEl.innerHTML = ''; return; }
        var t = th(), h = '', k;
        if (isShape(tl)) h += '<span class="wb-trg">' + btn('shp:line', 'Straight line', I.line, 'wb-t' + (tl === 'line' ? ' is-on' : ''), 'L') + btn('shp:arrow', 'Arrow', I.arrow, 'wb-t' + (tl === 'arrow' ? ' is-on' : ''), 'A') + '</span>';
        h += '<span class="wb-trg wb-sws">';
        if (tl === 'hl') for (k = 0; k < 5; k++) h += '<button type="button" class="wb-sw' + (k === st.hlc ? ' is-on' : '') + '" data-wb="hlc:' + k + '" style="background:' + hlSolid(k, t) + '" aria-label="' + HLN[k] + ' highlighter" data-tip="' + HLN[k] + '" data-tipsub="Key: ' + (k + 1) + '"></button>';
        else for (k = 0; k < NSLOT; k++) {
          var cn = k === st.col, nm = slotName(k, t);
          h += '<button type="button" class="wb-sw' + (cn ? ' is-on' : '') + '" data-wb="col:' + k + '" data-slot="' + k + '" style="background:' + slotHex(k, t) + '" aria-label="' + nm + (cn ? ', tap again to change it' : '') + '" data-tip="' + nm + '" data-tipsub="' + (cn ? 'Tap again to change it. ' : 'Right-click to change it. ') + 'Key: ' + (k + 1) + '"></button>';
        }
        h += '</span><span class="wb-trg">' + SIZES.map(function (w, j) { return '<button type="button" class="wb-b wb-t wb-sz' + (j === st.size ? ' is-on' : '') + '" data-wb="size:' + j + '" aria-label="' + ['Thin', 'Medium', 'Thick'][j] + '" data-tip="' + ['Thin', 'Medium', 'Thick'][j] + '" data-tipsub="Keys: [ and ]"><span style="width:' + (w + 5) + 'px;height:' + (tl === 'hl' ? Math.round((w + 5) * 0.7) : w + 5) + 'px' + (tl === 'hl' ? ';border-radius:3px' : '') + '"></span></button>'; }).join('') + '</span>';
        if (tl === 'pen') h += '<span class="wb-trg wb-feel"><button type="button" class="wb-b wb-tog' + (st.press ? ' is-on' : '') + '" data-wb="press" aria-pressed="' + (st.press ? 'true' : 'false') + '" data-tip="Pressure" data-tipsub="A stylus draws thicker where it presses harder"><span class="wb-togk"></span>Pressure</button>' +
          '<span class="wb-seg" role="group" aria-label="Smoothing"><span class="wb-segl">Smoothing</span>' + ['Off', 'Some', 'More'].map(function (n, k) { return '<button type="button" class="wb-segb' + (k === st.smooth ? ' is-on' : '') + '" data-wb="smooth:' + k + '" aria-pressed="' + (k === st.smooth ? 'true' : 'false') + '">' + n + '</button>'; }).join('') + '</span></span>';
        trayEl.innerHTML = h; trayEl.setAttribute('data-tool', tl);
        placeNear(trayEl);
      }
      /* MOVE THE BAR (round 5, Aadam: "be able to drag the toolbar around and move to where you want"): the dots at its
         start drag it; let go anywhere and it stays; near the left or right side it stands up along that side; near the
         bottom it goes back to the middle; a double-click on the dots puts it back. The spot is kept on the device. */
      function applyDock() {
        if (!dockEl) return;
        var d = st.dock, m = d.m, cs = dockEl.classList, s = dockEl.style;
        cs.toggle('is-vert', m === 'left' || m === 'right'); cs.toggle('is-free', m === 'free'); cs.toggle('is-left', m === 'left'); cs.toggle('is-right', m === 'right'); cs.toggle('is-top', m === 'top');
        s.left = s.top = s.right = s.bottom = '';
        if (m !== 'bottom' && m !== 'top' && W && H) {
          var dw = dockEl.offsetWidth, dh = dockEl.offsetHeight;
          if (m === 'free') { s.left = Math.round(clamp(d.x * W, 8, Math.max(8, W - dw - 8))) + 'px'; s.top = Math.round(clamp(d.y * H, 8, Math.max(8, H - dh - 8))) + 'px'; }
          else s.top = Math.round(clamp(d.y * H - dh / 2, 8, Math.max(8, H - dh - 8))) + 'px';
        }
        root.classList.toggle('is-dockb', m === 'bottom'); root.classList.toggle('is-dockt', m === 'top'); root.classList.toggle('is-dockl', m === 'left'); root.classList.toggle('is-dockr', m === 'right');
        cardClear();
        dockFit();
      }
      /* DRAGGING THE BAR (round 6, Aadam: "improve the dragging the toolbar"): it can be picked up by the dots or by any
         empty part of the bar (its edges, the lines between groups); it follows the pointer frame by frame from the exact
         spot it was held; near a side it stands up there and then, near the bottom it goes home there and then, so where it
         will land is never a surprise; when let go it settles with a short ease */
      /* ROUND 7 (Aadam: "toolbar snapping still isn't smooth - should show exactly where it's gonna snap to", "should be
         able to snap to top too"): the bar keeps its own shape under the hand the whole way; near an edge a dashed outline
         of the bar shows exactly where, and how, it will sit (flat at the top or bottom, standing at a side); let go and it
         glides from the hand into that outline */
      var dockDrag = null, dockRaf = 0, dockGhost = null;
      function dockZone(q) { return q.x < 64 ? 'left' : q.x > W - 64 ? 'right' : q.y > H - 64 ? 'bottom' : q.y < 64 ? 'top' : ''; }
      function dockGrab(t) {
        if (!t || !t.closest) return false;
        if (t.closest('[data-wbdock]')) return true;
        return !t.closest('button,input,a') && !!t.closest('.wb-dock');
      }
      /* the bar's size flat and standing, measured once on a hidden copy */
      function dockSizes() {
        var c = dockEl.cloneNode(true), out = {};
        c.style.cssText = 'visibility:hidden;left:0;top:0;right:auto;bottom:auto;margin:0;transform:none;transition:none';
        board.appendChild(c);
        c.className = 'wb-dock is-free'; out.h = { w: c.offsetWidth, h: c.offsetHeight };
        c.className = 'wb-dock is-vert is-left'; out.v = { w: c.offsetWidth, h: c.offsetHeight };
        board.removeChild(c);
        return out;
      }
      function landRect(z, q, sz) {
        if (z === 'bottom' || z === 'top') { var w = Math.min(sz.h.w, W - 24); return { x: (W - w) / 2, y: z === 'top' ? 12 : H - sz.h.h - 16, w: w, h: sz.h.h }; }
        if (z === 'left' || z === 'right') { var hh = Math.min(sz.v.h, H - 16); return { x: z === 'left' ? 12 : W - sz.v.w - 12, y: clamp(q.y - hh / 2, 8, Math.max(8, H - hh - 8)), w: sz.v.w, h: hh }; }
        return null;
      }
      function dockDown(e) {
        if (!dockGrab(e.target) || e.button > 0) return;
        e.preventDefault(); hideTip();
        var br = board.getBoundingClientRect(), bk = board.clientWidth / (br.width || 1), r = dockEl.getBoundingClientRect(), q = ptS(e);
        dockDrag = { ox: q.x - (r.left - br.left) * bk, oy: q.y - (r.top - br.top) * bk, x0: q.x, y0: q.y, moved: false, id: e.pointerId, zone: null, q: q };
        try { dockEl.setPointerCapture(e.pointerId); } catch (er) {}
        dockEl.classList.add('is-held');
      }
      function dockMove(e) {
        if (!dockDrag || e.pointerId !== dockDrag.id) return;
        dockDrag.q = ptS(e);
        if (!dockDrag.moved) {
          if (Math.abs(dockDrag.q.x - dockDrag.x0) + Math.abs(dockDrag.q.y - dockDrag.y0) < 4) return;
          dockDrag.moved = true; st.menu = st.menu === 'tray' || st.menu === 'ins' || st.menu === 'col' ? null : st.menu; drawIns(); drawTray(); drawPop();
          dockDrag.sz = dockSizes();
          /* from here the bar is placed by left/top, in the shape it had when picked up */
          var r = dockEl.getBoundingClientRect(), br = board.getBoundingClientRect(), bk = board.clientWidth / (br.width || 1);
          dockDrag.vert = dockEl.classList.contains('is-vert');
          dockEl.classList.add('is-moving'); dockEl.style.right = 'auto'; dockEl.style.bottom = 'auto'; dockEl.style.margin = '0';
          dockEl.style.left = (r.left - br.left) * bk + 'px'; dockEl.style.top = (r.top - br.top) * bk + 'px';
          if (!dockGhost) { dockGhost = el('div', 'wb-dghost'); dockGhost.innerHTML = '<span></span>'; board.appendChild(dockGhost); }
        }
        if (!dockRaf) dockRaf = requestAnimationFrame(dockFrame);
      }
      function dockFrame() {
        dockRaf = 0; var dd = dockDrag; if (!dd || !dd.moved) return;
        var q = dd.q, dw = dockEl.offsetWidth, dh = dockEl.offsetHeight;
        dockEl.style.left = Math.round(clamp(q.x - dd.ox, 4 - dw / 2, W - dw / 2)) + 'px'; dockEl.style.top = Math.round(clamp(q.y - dd.oy, 4 - dh / 2, H - dh / 2)) + 'px';
        var z = dockZone(q), lr = landRect(z, q, dd.sz); dd.zone = z;
        dockGhost.classList.toggle('is-on', !!lr); dockGhost.classList.toggle('is-vert', z === 'left' || z === 'right');
        if (lr) { var g = dockGhost.style; g.left = Math.round(lr.x) + 'px'; g.top = Math.round(lr.y) + 'px'; g.width = Math.round(lr.w) + 'px'; g.height = Math.round(lr.h) + 'px'; }
      }
      function dockUp(e) {
        var dd = dockDrag; dockDrag = null; if (!dd) return;
        cancelAnimationFrame(dockRaf); dockRaf = 0;
        dockEl.classList.remove('is-held'); if (dockGhost) dockGhost.classList.remove('is-on');
        if (!dd.moved) { dockEl.classList.remove('is-moving'); return; }
        dd.q = ptS(e);
        var z = dockZone(dd.q), from = dockEl.getBoundingClientRect(), dw = dockEl.offsetWidth, dh = dockEl.offsetHeight;
        if (z === 'bottom' || z === 'top') st.dock = { m: z };
        else if (z) st.dock = { m: z, x: z === 'left' ? 0 : 1, y: clamp(dd.q.y / (H || 1), 0, 1) };
        else st.dock = { m: 'free', x: clamp(dd.q.x - dd.ox, 8, W - dw - 8) / (W || 1), y: clamp(dd.q.y - dd.oy, 8, H - dh - 8) / (H || 1) };
        dockEl.classList.remove('is-moving'); dockEl.style.margin = '';
        keep(); applyDock();
        /* glide: from where the hand let go to its place, fading through any change of shape */
        if (!reduceMotion && dockEl.animate) {
          var to = dockEl.getBoundingClientRect();
          dockEl.animate([{ transform: 'translate(' + (from.left - to.left) + 'px,' + (from.top - to.top) + 'px)', opacity: z === 'left' || z === 'right' || dd.vert ? 0.4 : 1 }, { transform: 'none', opacity: 1 }], { duration: 220, easing: 'cubic-bezier(.2,.9,.3,1.1)' });
        }
        placeMenus(); placeCalc();
      }
      /* a menu of the bar's opens on the side of it facing the middle of the board */
      function placeNear(elm) {
        if (!elm || elm.hidden || !dockEl || !board) return;
        var s = elm.style; s.left = s.top = ''; s.right = s.bottom = 'auto'; s.transform = 'none'; s.margin = '0';
        var br = board.getBoundingClientRect(), k = board.clientWidth / (br.width || 1), d = dockEl.getBoundingClientRect();
        var pr = (elm.offsetParent || board).getBoundingClientRect(), w = elm.offsetWidth, h = elm.offsetHeight, m = st.dock.m, gap = 12, x, y;
        var dl = (d.left - br.left) * k, dt = (d.top - br.top) * k, dW = d.width * k, dH = d.height * k;
        if (m === 'left' || m === 'right') { y = dt + dH / 2 - h / 2; x = m === 'left' ? dl + dW + gap : dl - gap - w; }
        else { x = dl + dW / 2 - w / 2; y = dt + dH / 2 > H / 2 ? dt - gap - h : dt + dH + gap; }
        var PW = (elm.offsetParent || board).clientWidth || W, PH = (elm.offsetParent || board).clientHeight || H;
        s.left = Math.round(clamp(x + (br.left - pr.left) * k, 8, Math.max(8, PW - w - 8))) + 'px';
        s.top = Math.round(clamp(y + (br.top - pr.top) * k, 8, Math.max(8, PH - h - 8))) + 'px';
      }
      /* the question card keeps clear of a bar standing on the left or right */
      function cardClear() {
        if (!cardEl || cardEl.hidden || !dockEl) return;
        var m = st.dock.m, x = st.card.x, cw = cardEl.offsetWidth;
        if (m === 'left') x = Math.max(x, dockEl.offsetLeft + dockEl.offsetWidth + 12);
        if (m === 'right') x = Math.min(x, Math.max(0, dockEl.offsetLeft - 12 - cw));
        cardEl.style.left = Math.round(x) + 'px';
        cardEl.style.top = Math.round(m === 'top' ? Math.max(st.card.y, dockEl.offsetTop + dockEl.offsetHeight + 12) : st.card.y) + 'px';
      }
      function placeMenus() { placeNear(trayEl); placeNear(insEl); if (st.menu === 'col') placeNear(popEl); }
      function dockFit() {
        if (!dockEl) return;
        var prev = null;
        Array.prototype.forEach.call(dockEl.children, function (g) { g.classList.toggle('is-lead', !!prev && g.offsetTop > prev.offsetTop + 4 && !dockEl.classList.contains('is-vert')); prev = g; });
        root.style.setProperty('--dockh', (st.dock.m === 'bottom' ? dockEl.offsetHeight : 0) + 'px');
      }
      /* ---------- the endless board's view: drag, zoom, the map and Show all ---------- */
      function setView(x, y, z) {
        if (!endless()) return;
        var v = view(); v.z = clamp(z, ZMIN, ZMAX); v.x = x; v.y = y; applyView();
      }
      var viewT = 0;
      function viewDone() { clearTimeout(viewT); viewT = setTimeout(function () { if (endless() && page().keep) dirty(); }, 400); }
      function applyView() {
        var on = endless(), v = view(), tf = on && (v.x || v.y || v.z !== 1) ? 'translate(' + (-v.x * v.z) + 'px,' + (-v.y * v.z) + 'px) scale(' + v.z + ')' : '';
        if (objsEl) objsEl.style.transform = tf;
        if (picsEl) picsEl.style.transform = tf;
        cardView();
        paintBoard(); redraw(); drawPick(); drawZoom(); drawRuler(); timerPlace(); if (on) showNav();
      }
      /* ROUND 6 (Aadam: "hide the zooming features after a few seconds if you're not moving around or zooming in and out"):
         the zoom buttons and the map fade out 2.5s after the board last moved; they come back while it moves, when the
         pointer comes near their corner, or while one of them is held or has the keyboard */
      var navT = 0;
      function showNav() {
        if (!root) return;
        root.classList.add('is-navon'); clearTimeout(navT);
        navT = setTimeout(function () {
          var busy = miniDrag || pinch || panDrag || (zoomEl && (zoomEl.matches(':hover') || zoomEl.contains(document.activeElement))) || (miniEl && miniEl.matches(':hover'));
          if (busy) showNav(); else root.classList.remove('is-navon');
        }, 2500);
      }
      function zoomAt(z, cx, cy) { var v = view(), nz = clamp(z, ZMIN, ZMAX), wx = v.x + cx / v.z, wy = v.y + cy / v.z; setView(wx - cx / nz, wy - cy / nz, nz); viewDone(); }
      var ZSTEPS = [0.1, 0.25, 0.5, 0.75, 1, 1.5, 2, 3, 4];
      function zoomBy(k) {
        if (!endless()) return;
        var v = view();
        if (k === 'all') { showAll(); return; }
        var nz = k === 'in' ? ZSTEPS.filter(function (z) { return z > v.z + 0.001; })[0] || ZMAX : ZSTEPS.filter(function (z) { return z < v.z - 0.001; }).pop() || ZMIN;
        zoomAt(nz, W / 2, H / 2);
      }
      function worldBox() {
        var b = { x0: 1e9, y0: 1e9, x1: -1e9, y1: -1e9 }, any = false, pg = page();
        pg.ink.forEach(function (s) { var q = strokeBox(s); b.x0 = Math.min(b.x0, q.x0); b.y0 = Math.min(b.y0, q.y0); b.x1 = Math.max(b.x1, q.x1); b.y1 = Math.max(b.y1, q.y1); any = true; });
        objBoxes().forEach(function (o) { var ob = findObj(o.id); if (!ob) return; b.x0 = Math.min(b.x0, ob.x); b.y0 = Math.min(b.y0, ob.y); b.x1 = Math.max(b.x1, ob.x + o.w); b.y1 = Math.max(b.y1, ob.y + o.h); any = true; });
        var cb = cardBox(); if (cb) { b.x0 = Math.min(b.x0, cb.x0); b.y0 = Math.min(b.y0, cb.y0); b.x1 = Math.max(b.x1, cb.x1); b.y1 = Math.max(b.y1, cb.y1); any = true; }
        return any ? b : null;
      }
      /* the question card's place in world units (a question board only) */
      function cardBox() {
        if (isBlankIt() || !cardEl || cardEl.hidden || !cardEl.offsetWidth) return null;
        var L = parseFloat(cardEl.style.left) || 0, T = parseFloat(cardEl.style.top) || 0;
        return { x0: L, y0: T, x1: L + cardEl.offsetWidth, y1: T + cardEl.offsetHeight };
      }
      /* Show all: every bit of ink and every diagram on the screen at once, clear of the bar */
      function showAll() {
        var b = worldBox(); if (!b) { setView(0, 0, 1); viewDone(); return; }
        var m = 48, bh = st.dock.m === 'bottom' && dockEl ? dockEl.offsetHeight + 24 : 0, aw = W - 2 * m, ah = H - 2 * m - bh;
        var z = clamp(Math.min(aw / Math.max(1, b.x1 - b.x0), ah / Math.max(1, b.y1 - b.y0), 2), ZMIN, ZMAX);
        setView((b.x0 + b.x1) / 2 - W / 2 / z, (b.y0 + b.y1) / 2 - (H - bh) / 2 / z, z); viewDone();
      }
      function onWheel(e) {
        if (!st.open || !endless()) return;
        if (e.target.closest && e.target.closest('.wb-dock,.wb-tray,.wb-ins,.wb-calc,.wb-pkbar,.wb-zoom,.wb-mini')) return;
        e.preventDefault();
        var q = ptS(e), v = view(), dz = e.deltaMode === 1 ? 16 : 1;
        /* a trackpad pinch arrives as a wheel with Ctrl held; so does Ctrl and the mouse wheel */
        if (e.ctrlKey || e.metaKey) zoomAt(v.z * Math.exp(-clamp(e.deltaY * dz, -60, 60) * 0.008), q.x, q.y);
        else { setView(v.x + e.deltaX * dz / v.z, v.y + e.deltaY * dz / v.z, v.z); viewDone(); }
      }
      function drawZoom() {
        if (!zoomEl) return;
        var on = st.open && endless(); zoomEl.hidden = !on; if (miniEl) miniEl.hidden = !on || W < 700;
        if (!on) return;
        var z = view().z;
        zoomEl.innerHTML = '<button type="button" class="wb-b wb-zall" data-wb="zoom:all" aria-label="Show all the work" data-tip="Show all the work" data-tipsub="Key: 0">' + I.fitall + '<span>Show all</span></button>' +
          btn('zoom:out', 'Zoom out', ICON.minus, 'wb-zb', '−') + '<span class="wb-zv num">' + Math.round(z * 100) + '%</span>' + btn('zoom:in', 'Zoom in', ICON.plus, 'wb-zb', '+');
        miniSoon();
      }
      /* the map: the whole page small, the screen's part outlined; drag in it to go somewhere else */
      var miniRaf = 0, miniK = null, miniDrag = false, MW = 224, MH = 144;
      function miniSoon() { if (!miniEl || miniEl.hidden || miniRaf) return; miniRaf = requestAnimationFrame(function () { miniRaf = 0; drawMini(); }); }
      function drawMini() {
        if (!miniEl || miniEl.hidden || !endless()) return;
        var mw = MW, mh = MH, d = Math.min(2, window.devicePixelRatio || 1);
        if (miniEl.width !== mw * d) { miniEl.width = mw * d; miniEl.height = mh * d; miniEl.style.width = mw + 'px'; miniEl.style.height = mh + 'px'; }
        /* the bar along the foot of a narrower screen would sit over the map: the map steps up above it */
        var up = 0;
        if (st.dock.m === 'bottom' && dockEl && dockEl.offsetWidth) { var dr = dockEl.getBoundingClientRect(), mr = miniEl.getBoundingClientRect(); if (dr.left < mr.left + mw + 8 && dr.right > mr.left) up = Math.round(miniEl.offsetParent.getBoundingClientRect().bottom - dr.top) + 10; }
        var ub = up ? up + 'px' : ''; if (miniEl.style.bottom !== ub) miniEl.style.bottom = ub;
        var c = miniEl.getContext('2d'), t = th(), v = view(), b = worldBox() || { x0: v.x, y0: v.y, x1: v.x + W / v.z, y1: v.y + H / v.z };
        var vx1 = v.x + W / v.z, vy1 = v.y + H / v.z, x0 = Math.min(b.x0, v.x), y0 = Math.min(b.y0, v.y), x1 = Math.max(b.x1, vx1), y1 = Math.max(b.y1, vy1);
        /* while the map is dragged its scale holds still, or the outline would run away from the pointer */
        if (!(miniDrag && miniK)) { var k0 = Math.min((mw - 16) / Math.max(1, x1 - x0), (mh - 16) / Math.max(1, y1 - y0)); miniK = { k: k0, ox: (mw - (x1 - x0) * k0) / 2 - x0 * k0, oy: (mh - (y1 - y0) * k0) / 2 - y0 * k0 }; }
        var k = miniK.k, ox = miniK.ox, oy = miniK.oy;
        c.setTransform(d, 0, 0, d, 0, 0); c.clearRect(0, 0, mw, mh); c.fillStyle = t.bg; c.fillRect(0, 0, mw, mh);
        c.save(); c.translate(ox, oy); c.scale(k, k);
        /* round 12: the board as it really is, pictures and diagrams drawn, not grey boxes; pictures under the ink as on the board */
        var pg = page();
        pg.objs.forEach(function (o) { if (o.type === 'img') { try { drawObjC(c, o, t, pg); } catch (er) { c.restore(); } } });
        var cb = cardBox(); if (cb) { c.fillStyle = t.card; c.strokeStyle = t.line; c.lineWidth = 1.5 / k; c.fillRect(cb.x0, cb.y0, cb.x1 - cb.x0, cb.y1 - cb.y0); c.strokeRect(cb.x0, cb.y0, cb.x1 - cb.x0, cb.y1 - cb.y0); }
        pg.ink.forEach(function (s) { var o = { k: s.k, c: s.c, w: Math.max(s.w, 2.4 / k), pts: s.pts, hc: s.hc }; if (s.h) o.h = s.h; if (s.st) o.st = 1; drawS(c, o, t); });
        pg.objs.forEach(function (o) { if (o.type !== 'img') { try { drawObjC(c, o, t, pg); } catch (er) { c.restore(); } } });
        c.restore();
        c.strokeStyle = t.dark ? '#FFFFFF' : '#1F5FBF'; c.lineWidth = 1.6;
        c.strokeRect(ox + v.x * k + 0.5, oy + v.y * k + 0.5, (W / v.z) * k - 1, (H / v.z) * k - 1);
      }
      function miniGo(e) { if (!miniK) return; var r = miniEl.getBoundingClientRect(), mx = (e.clientX - r.left) * (MW / (r.width || MW)), my = (e.clientY - r.top) * (MH / (r.height || MH)), v = view(); setView((mx - miniK.ox) / miniK.k - W / 2 / v.z, (my - miniK.oy) / miniK.k - H / 2 / v.z, v.z); }
      function miniDown(e) { e.preventDefault(); miniDrag = true; try { miniEl.setPointerCapture(e.pointerId); } catch (er) {} miniGo(e); }
      function miniMove(e) { if (miniDrag) miniGo(e); }
      function miniUp() { if (!miniDrag) return; miniDrag = false; viewDone(); drawMini(); }

      function drawIns() {
        insEl.hidden = st.menu !== 'ins';
        if (st.menu !== 'ins') return;
        /* ROUND 7: three rows: things for the board, the ruler and timer, and the stamps */
        var tile = function (act, label, inner, on) { return '<button type="button" class="wb-insb' + (on ? ' is-on' : '') + '" data-wb="' + act + '" aria-label="' + label + '" data-tip="' + label + '">' + inner + '</button>'; };
        var sv = function (k) { var S0 = STAMPS[k]; return '<svg viewBox="0 0 ' + S0.vb + ' ' + (S0.vbh || S0.vb) + '" aria-hidden="true"><path d="' + S0.d + '"/></svg>'; };
        insEl.innerHTML = '<div class="wb-insh">Put on the board</div><div class="wb-insr">' +
            '<button type="button" class="wb-insb" data-wb="img" aria-label="Add a picture" data-tip="Add a picture" data-tipsub="Or paste one with Ctrl V, or drop it on the board">' + I.image + '</button>' +
            INS.map(function (x) { return tile('add:' + x[0], x[1], x[2]); }).join('') +
            tile('ruler', st.ruler ? 'Put the ruler away' : 'Ruler', I.ruler, !!st.ruler) + tile('timer', 'Timer', I.timer, !!st.timer) + '</div>' +
          '<div class="wb-insh">Stamps</div><div class="wb-insr wb-stamps">' + Object.keys(STAMPS).map(function (k) { return tile('stamp:' + k, STAMPS[k].n, sv(k)); }).join('') + '</div>';
        placeNear(insEl);
      }
      function drawPop() {
        popEl.hidden = !(st.menu === 'skills' || st.menu === 'theme' || st.menu === 'boards' || st.menu === 'col' || st.menu === 'addq' || st.menu === 'timer' || st.menu === 'share' || st.menu === 'more');
        popEl.className = 'wb-pop' + (st.menu ? ' is-' + st.menu : '');
        if (st.menu === 'col') { popEl.innerHTML = colPopHTML(); placeNear(popEl); return; }
        popEl.style.left = popEl.style.top = popEl.style.right = popEl.style.bottom = popEl.style.transform = popEl.style.margin = '';
        if (st.menu === 'theme') {
          popEl.innerHTML = '<div class="wb-ths">' + THEMES.map(function (t, k) {
            return '<button type="button" class="wb-th' + (k === st.theme ? ' is-on' : '') + '" data-wb="th:' + k + '" style="background:' + (patCss(t, st.pat) === 'none' ? t.bg : patCss(t, st.pat) + ', ' + t.bg) + '" aria-label="' + t.name + '" data-tip="' + t.name + '"><span>' +
              t.pens.map(function (c) { return '<i style="background:' + c + '"></i>'; }).join('') + '</span></button>';
          }).join('') + '</div><div class="wb-pats">' + PATS.map(function (p) {
            var nm = { dots: 'Dots', squares: 'Squares', lines: 'Lines', plain: 'Plain' }[p], t = th();
            return '<button type="button" class="wb-pt' + (p === st.pat ? ' is-on' : '') + '" data-wb="pat:' + p + '" style="background:' + (patCss(t, p) === 'none' ? t.bg : patCss(t, p) + ', ' + t.bg) + '" aria-label="' + nm + '" data-tip="' + nm + '"></button>';
          }).join('') + '</div><div class="wb-pophint">Key G changes the paper</div>';
          return;
        }
        if (st.menu === 'boards') {
          flush();
          var ks = newest();
          popEl.innerHTML = '<div class="wb-bxact">' +
              '<button type="button" class="wb-bxb" data-wb="png">' + I.image + '<span><b>This board as a picture</b><span>' + (st.blank ? 'A PNG of everything on this page' : 'A PNG of the question and everything on the board') + '</span></span></button>' +
              '<button type="button" class="wb-bxb" data-wb="pdf">' + I.file + '<span><b>' + (st.blank ? 'These pages as a PDF' : 'This set as a PDF') + '</b><span>' + (st.blank ? 'A page for each page with something on it' : 'A page for each question with working on it') + '</span></span></button>' +
              '<button type="button" class="wb-bxb" data-wb="clear"' + (page().ink.length || page().objs.length ? '' : ' disabled') + '>' + I.trash + '<span><b>Clear this board</b><span>Undo brings it back</span></span></button></div>' +
            '<div class="wb-skg">Saved on this device' + (ks.length ? ' (' + ks.length + ')' : '') + '</div>' +
            '<div class="wb-bxlist">' + (ks.length ? ks.map(function (k) {
              var e = store[k], on = keyOf(item()) === k;
              if (e.blank) return '<div class="wb-sv' + (on ? ' is-on' : '') + '"><button type="button" class="wb-svb" data-wbsv="' + esc(k) + '"><span class="wb-skico wb-blankico">' + I.pen + '</span>' +
                '<span class="wb-svt"><span class="wb-svq">Blank board</span><span class="wb-svm">' + when(e.t) + '</span></span></button>' +
                '<button type="button" class="wb-oc" data-wbdel="' + esc(k) + '" aria-label="Delete this saved board" data-tip="Delete">' + I.trash + '</button></div>';
              var sk = SL.get(e.sk); if (!sk) return '';
              var c = colourOf(sk);
              return '<div class="wb-sv' + (on ? ' is-on' : '') + '"><button type="button" class="wb-svb" data-wbsv="' + esc(k) + '"><span class="wb-skico" style="color:' + c.col + ';background:' + c.tint + '">' + skIcon(sk) + '</span>' +
                '<span class="wb-svt"><span class="wb-svq sl-expr">' + e.qh + '</span><span class="wb-svm">' + esc(sk.name) + ' · Level ' + e.lv + ' · ' + when(e.t) + '</span></span></button>' +
                '<button type="button" class="wb-oc" data-wbdel="' + esc(k) + '" aria-label="Delete this saved board" data-tip="Delete">' + I.trash + '</button></div>';
            }).join('') : '<div class="wb-svnone">Nothing saved yet. Press Save board on any board to keep it here, so you can open it again after the page is closed.</div>') + '</div>' +
            (ks.length ? '<button type="button" class="wb-b wb-delall" data-wb="delall">' + I.trash + 'Delete all saved boards</button>' : '');
          return;
        }
        if (st.menu === 'addq') { popEl.innerHTML = addqHTML(); return; }
        if (st.menu === 'timer') { popEl.innerHTML = timerPopHTML(); placeNear(popEl); return; }
        if (st.menu === 'share') { popEl.innerHTML = shareHTML(); return; }
        if (st.menu === 'more') { popEl.innerHTML = moreHTML(); return; }
        if (st.menu !== 'skills') { popEl.innerHTML = ''; return; }
        var q = st.skQ.trim().toLowerCase(), pick = SL.get(st.skPick || item().skill.id) || item().skill;
        var all = SL.skills().filter(function (sk) { return sk && sk.levels && sk.levels.length; });
        var groups = q
          ? [{ name: 'Found', list: all.filter(function (sk) { return matches(q, sk.name + ' ' + (sk.short || ''), sk.aliases); }) }]
          : STRANDS[S.stage].map(function (sd) {
            return { name: sd.name, list: all.filter(function (sk) { return (!sk.stage || sk.stage === 'both' || sk.stage === S.stage) && strandOf(sk, S.stage) === sd.id; }) };
          });
        var list = groups.filter(function (g) { return g.list.length; }).map(function (g) {
          return '<div class="wb-skg">' + esc(g.name) + '</div>' + g.list.map(function (sk) {
            var c = colourOf(sk);
            return '<button type="button" class="wb-skrow' + (sk.id === pick.id ? ' is-on' : '') + '" data-wbsk="' + sk.id + '"><span class="wb-skico" style="color:' + c.col + ';background:' + c.tint + '">' + skIcon(sk) + '</span><span>' + esc(sk.name) + '</span></button>';
          }).join('');
        }).join('') || '<div class="wb-skg">No skill by that name yet</div>';
        var cur = item();
        var lv = pick.levels.map(function (L, k) {
          var on = pick.id === cur.skill.id && k + 1 === cur.level;
          /* Teach never teaches the mixed level (core's isMixLevel), so the board does not offer it there */
          if (st.from === 'teach' && isMixLevel(pick, k + 1)) return '';
          return '<button type="button" class="wb-lv' + (on ? ' is-on' : '') + '" data-wblv="' + (k + 1) + '"><span class="num">' + (k + 1) + '</span><span>' + esc(L.name) + '</span></button>';
        }).join('');
        popEl.innerHTML = '<div class="wb-skl"><input type="search" class="wb-skq" placeholder="Find a skill" aria-label="Find a skill" value="' + esc(st.skQ) + '"><div class="wb-sklist">' + list + '</div></div>' +
          '<div class="wb-lvls"><div class="wb-skg">' + esc(pick.name) + '</div>' + lv + '</div>';
        var sel = popEl.querySelector('.wb-skrow.is-on'); if (sel && sel.scrollIntoView && !q) { try { sel.scrollIntoView({ block: 'center' }); } catch (e) {} }
      }

      /* ---------- ADD A QUESTION (round 7, Aadam: "on blank whiteboard - be able to pick a question to add from any skill,
         can add more than one if you want") ----------
         Any skill, any level, as many as you like: each lands on the board as a question card (an object of type 'q') that
         drags, sizes, shows its answer and swaps for another at the same level, like the card on a question board */
      var aq = { sk: null, lv: 1, n: 1, prev: null, q: '' };
      function aqCtx() { return { seen: {}, shapeSeen: {}, last: null }; }
      function aqPreview() { var sk = SL.get(aq.sk); aq.prev = null; if (!sk || !SL.ready(sk.id)) return; try { aq.prev = makeItem(sk, aq.lv, aqCtx()); } catch (e) { aq.prev = null; } }
      function addqHTML() {
        var q = aq.q.trim().toLowerCase(), all = SL.skills().filter(function (sk) { return sk && sk.levels && sk.levels.length; });
        var groups = q ? [{ name: 'Found', list: all.filter(function (sk) { return matches(q, sk.name + ' ' + (sk.short || ''), sk.aliases); }) }]
          : STRANDS[S.stage].map(function (sd) { return { name: sd.name, list: all.filter(function (sk) { return (!sk.stage || sk.stage === 'both' || sk.stage === S.stage) && strandOf(sk, S.stage) === sd.id; }) }; });
        var list = groups.filter(function (g) { return g.list.length; }).map(function (g) {
          return '<div class="wb-skg">' + esc(g.name) + '</div>' + g.list.map(function (sk) {
            var c = colourOf(sk);
            return '<button type="button" class="wb-skrow' + (sk.id === aq.sk ? ' is-on' : '') + '" data-wbaq="sk:' + sk.id + '"><span class="wb-skico" style="color:' + c.col + ';background:' + c.tint + '">' + skIcon(sk) + '</span><span>' + esc(sk.name) + '</span></button>';
          }).join('');
        }).join('') || '<div class="wb-skg">No skill by that name yet</div>';
        var sk = SL.get(aq.sk), right;
        if (!sk) right = '<div class="wb-aqnone">Pick a skill, then a level. You can add as many questions as you like, from any skills.</div>';
        else {
          right = '<div class="wb-skg">' + esc(sk.name) + '</div><div class="wb-aqlvs">' + sk.levels.map(function (L, k) {
            return '<button type="button" class="wb-lv' + (k + 1 === aq.lv ? ' is-on' : '') + '" data-wbaq="lv:' + (k + 1) + '"><span class="num">' + (k + 1) + '</span><span>' + esc(L.name) + '</span></button>';
          }).join('') + '</div>' +
            '<div class="wb-aqprev"><div class="wb-aqq sl-expr">' + (aq.prev ? aq.prev.q.html : '<span class="wb-aqwait">Getting a question ready</span>') + '</div>' +
              '<button type="button" class="wb-oc" data-wbaq="next" aria-label="Another question" data-tip="Another question">' + ICON.refresh + '</button></div>' +
            '<div class="wb-aqfoot"><span>How many</span><span class="wb-aqn"><button type="button" class="wb-oc" data-wbaq="minus" aria-label="One fewer"' + (aq.n <= 1 ? ' disabled' : '') + '>' + ICON.minus + '</button><b class="num">' + aq.n + '</b><button type="button" class="wb-oc" data-wbaq="plus" aria-label="One more"' + (aq.n >= 6 ? ' disabled' : '') + '>' + ICON.plus + '</button></span>' +
              '<button type="button" class="wb-b wb-aqadd" data-wbaq="add"' + (aq.prev ? '' : ' disabled') + '>' + (aq.n === 1 ? 'Add it to the board' : 'Add ' + aq.n + ' to the board') + '</button></div>';
        }
        return '<div class="wb-skl"><input type="search" class="wb-skq wb-aqsearch" placeholder="Find a skill" aria-label="Find a skill" value="' + esc(aq.q) + '"><div class="wb-sklist">' + list + '</div></div><div class="wb-lvls wb-aqr">' + right + '</div>';
      }
      function aqAct(a) {
        var c = a.indexOf(':'), n = c >= 0 ? a.slice(0, c) : a, k = c >= 0 ? a.slice(c + 1) : '';
        if (n === 'sk') { var id = k; aq.sk = id; aq.lv = 1; aq.prev = null; drawPop(); withSkills([id], null, function () { if (aq.sk !== id || st.menu !== 'addq') return; aqPreview(); drawPop(); }); return; }
        if (n === 'lv') { aq.lv = Number(k) || 1; aqPreview(); drawPop(); return; }
        if (n === 'next') { aqPreview(); drawPop(); return; }
        if (n === 'minus' || n === 'plus') { aq.n = clamp(aq.n + (n === 'plus' ? 1 : -1), 1, 6); drawPop(); return; }
        if (n === 'add') {
          var sk = SL.get(aq.sk); if (!sk || !aq.prev) return;
          var pg = page(), v = view(), ctx = aqCtx(), have = pg.objs.filter(function (o) { return o.type === 'q'; }).length, its = [aq.prev];
          if (aq.prev.q.key) ctx.seen[aq.prev.q.key] = 1;
          for (var j = 1; j < aq.n; j++) its.push(makeItem(sk, aq.lv, ctx));
          snap(pg);
          var top0 = st.dock.m === 'top' && dockEl ? dockEl.offsetTop + dockEl.offsetHeight + 16 : 40, left0 = st.dock.m === 'left' && dockEl ? dockEl.offsetLeft + dockEl.offsetWidth + 16 : 40;
          its.forEach(function (it, j) {
            var row = (have + j) % 5, col = Math.floor((have + j) / 5);
            pg.objs.push({ id: 'w' + Date.now().toString(36) + (++oid), type: 'q', x: Math.round(v.x + (left0 + col * 420) / v.z), y: Math.round(v.y + (top0 + row * 120) / v.z), s: Math.round(100 / v.z) / 100,
              sk: sk.id, lv: aq.lv, qh: it.q.html, ah: it.q.ansHTML || '', qt: String(it.q.text || ''), key: String(it.q.key || ''), peek: false });
          });
          st.menu = null; aqPreview();
          drawTop(); drawPop(); drawObjs(); drawSide(); dirty();
          toast(its.length === 1 ? 'Question added' : its.length + ' questions added', function () { undo(); });
          track('whiteboard_add_question', { skill: sk.id, level: aq.lv, n: its.length });
        }
      }
      function qFresh(o, done) {
        var sk = SL.get(o.sk); if (!sk) return;
        var go = function () { var ctx = aqCtx(); if (o.key) ctx.seen[o.key] = 1; var it = makeItem(sk, o.lv, ctx); snap(); o.qh = it.q.html; o.ah = it.q.ansHTML || ''; o.qt = String(it.q.text || ''); o.key = String(it.q.key || ''); o.peek = false; done(); };
        if (SL.ready(sk.id)) go(); else withSkills([sk.id], null, go);
      }

      /* ---------- the colour picker: the board's eight, any colour, and back to the board's own ---------- */
      function hexRgb(h) { var n = parseInt(h.slice(1), 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; }
      function rgbHex(r, g, b) { return '#' + [r, g, b].map(function (v) { return ('0' + Math.round(clamp(v, 0, 255)).toString(16)).slice(-2); }).join('').toUpperCase(); }
      function hexHsv(h) {
        var c = hexRgb(h), r = c[0] / 255, g = c[1] / 255, b = c[2] / 255, mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn, hu = 0;
        if (d) hu = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4;
        return { h: (hu * 60 + 360) % 360, s: mx ? d / mx : 0, v: mx };
      }
      function hsvHex(o) {
        var c = o.v * o.s, x = c * (1 - Math.abs((o.h / 60) % 2 - 1)), m = o.v - c, k = Math.floor(o.h / 60) % 6;
        var rgb = [[c, x, 0], [x, c, 0], [0, c, x], [0, x, c], [x, 0, c], [c, 0, x]][k];
        return rgbHex((rgb[0] + m) * 255, (rgb[1] + m) * 255, (rgb[2] + m) * 255);
      }
      var hsv = { h: 0, s: 0, v: 1 }, cpDrag = null;
      function openCol(k) { st.colFor = k; st.col = k; st.menu = 'col'; hsv = hexHsv(slotHex(k)); keep(); drawTop(); drawDock(); drawIns(); drawPop(); }
      function setSlot(k, hex) {
        var t = th(), a = (st.cols[t.id] || []).slice(0, NSLOT);
        while (a.length < NSLOT) a.push(null);
        a[k] = hex.toUpperCase() === t.pal[k].toUpperCase() ? null : hex.toUpperCase();
        if (a.some(Boolean)) st.cols[t.id] = a; else delete st.cols[t.id];
        st.col = k; if (st.tool !== 'pen' && st.tool !== 'line' && st.tool !== 'arrow') st.tool = 'pen';
        keep(); paintBoard(); drawDock();
      }
      function colPopHTML() {
        var t = th(), k = st.colFor, cur = slotHex(k, t), hue = hsvHex({ h: hsv.h, s: 1, v: 1 });
        return '<div class="wb-cph"><b>Change colour ' + (k + 1) + '</b><kbd class="sl-tipkey">' + (k + 1) + '</kbd></div>' +
          '<div class="wb-skg">' + esc(t.name) + ' colours</div><div class="wb-cpal">' + t.pal.map(function (c, j) {
            return '<button type="button" class="wb-cp' + (c.toUpperCase() === cur.toUpperCase() ? ' is-on' : '') + '" data-wbc="' + c + '" style="background:' + c + '" aria-label="' + t.pln[j] + '" data-tip="' + t.pln[j] + '"></button>';
          }).join('') + '</div>' +
          '<div class="wb-skg">Any colour</div>' +
          '<div class="wb-cpsv" data-cp="sv" style="background:linear-gradient(0deg,#000,rgba(0,0,0,0)),linear-gradient(90deg,#fff,' + hue + ')"><span class="wb-cpk" style="left:' + (hsv.s * 100) + '%;top:' + ((1 - hsv.v) * 100) + '%"></span></div>' +
          '<div class="wb-cphue" data-cp="hue"><span class="wb-cpk" style="left:' + (hsv.h / 3.6) + '%;background:' + hue + '"></span></div>' +
          '<div class="wb-cprow"><span class="wb-cpnow" style="background:' + cur + '"></span><label class="wb-cphex">Hex<input class="wb-hexin" value="' + cur + '" maxlength="7" spellcheck="false" autocomplete="off" aria-label="Hex colour"></label></div>' +
          '<div class="wb-cpf"><button type="button" class="wb-b wb-reset" data-wb="colreset"' + (st.cols[t.id] ? '' : ' disabled') + '>' + I.reset + '<span>Reset colours</span></button><span>Back to the six ' + esc(t.name) + ' colours</span></div>';
      }
      /* the shade box and the hue strip move their knob and the slot live; the pop is redrawn only when the drag ends */
      function cpPaint() {
        var hex = hsvHex(hsv), hue = hsvHex({ h: hsv.h, s: 1, v: 1 }), sv = popEl.querySelector('.wb-cpsv'), hu = popEl.querySelector('.wb-cphue');
        if (sv) { sv.style.background = 'linear-gradient(0deg,#000,rgba(0,0,0,0)),linear-gradient(90deg,#fff,' + hue + ')'; sv.firstChild.style.left = hsv.s * 100 + '%'; sv.firstChild.style.top = (1 - hsv.v) * 100 + '%'; }
        if (hu) { hu.firstChild.style.left = hsv.h / 3.6 + '%'; hu.firstChild.style.background = hue; }
        var nw = popEl.querySelector('.wb-cpnow'); if (nw) nw.style.background = hex;
        var hx = popEl.querySelector('.wb-hexin'); if (hx && document.activeElement !== hx) hx.value = hex;
        setSlot(st.colFor, hex);
      }
      function cpAt(e) {
        var r = cpDrag.el.getBoundingClientRect(), x = clamp((e.clientX - r.left) / (r.width || 1), 0, 1), y = clamp((e.clientY - r.top) / (r.height || 1), 0, 1);
        if (cpDrag.k === 'sv') { hsv.s = x; hsv.v = 1 - y; } else hsv.h = Math.min(359.9, x * 360);
        cpPaint();
      }
      function cpDown(e) {
        var t = e.target.closest ? e.target.closest('[data-cp]') : null; if (!t || e.button > 0) return;
        e.preventDefault(); cpDrag = { el: t, k: t.getAttribute('data-cp') }; try { t.setPointerCapture(e.pointerId); } catch (er) {} cpAt(e);
      }
      function cpMove(e) { if (cpDrag) cpAt(e); }
      function cpUp() { if (!cpDrag) return; cpDrag = null; drawPop(); }

      /* ---------- TEXT (round 7, Aadam's pick 1: type on the board) ----------
         T, tap the board, type. The words are an object of type 'txt' (t = what was typed, hx = its colour, fs = its size)
         drawn as maths: a/b stacks, ^ raises, * is ×, sqrt or √ draws a root, <= is ≤, a lone - is −, one letter is italic */
      function mathHTML(src) {
        var s = String(src || '').replace(/\*/g, '×').replace(/<=/g, '≤').replace(/>=/g, '≥').replace(/!=/g, '≠').replace(/\bsqrt\b/g, '√').replace(/\bpi\b/g, 'π')
          .replace(/(^|[\s(=,])-(?=[\s\d(a-zA-Zπ√])/g, '$1−').replace(/ - /g, ' − ').replace(/(\w|\))-(?=[\w(√])/g, '$1−');
        function parse(str) {
          var i = 0, out = '';
          function atom() {
            var c = str.charAt(i);
            if (c === '(') {
              var d = 0, j = i;
              for (; j < str.length; j++) { if (str.charAt(j) === '(') d++; else if (str.charAt(j) === ')') { d--; if (!d) break; } }
              var inner = str.slice(i + 1, j); i = Math.min(str.length, j + 1);
              return { h: '(' + parse(inner) + ')', bare: parse(inner) };
            }
            if (c === '√') { i++; var a = atom(); var r = a ? '<span class="wt-rt"><span class="wt-rs">√</span><span class="wt-rad">' + a.bare + '</span></span>' : '√'; return { h: r, bare: r }; }
            var m = /^(\d+(?:\.\d+)?|[A-Za-zπθ]+)/.exec(str.slice(i));
            if (!m) return null;
            i += m[0].length;
            var w = m[0], h = /^\d/.test(w) ? esc(w) : w.length === 1 || w === 'π' ? '<i>' + esc(w) + '</i>' : esc(w);
            return { h: h, bare: h };
          }
          function powered(a) {
            while (str.charAt(i) === '^') { i++; var e = atom(); a = { h: a.h + '<sup>' + (e ? e.bare : '') + '</sup>', bare: a.h + '<sup>' + (e ? e.bare : '') + '</sup>' }; }
            return a;
          }
          while (i < str.length) {
            var at = i, a = atom();
            if (!a) { var ch = str.charAt(i); out += ch === ' ' ? ' ' : esc(ch); i++; continue; }
            a = powered(a);
            if (str.charAt(i) === '/' && i > at) {
              var save = i; i++;
              var b = atom();
              if (b) { b = powered(b); out += '<span class="wt-fr"><span>' + a.bare + '</span><span>' + b.bare + '</span></span>'; continue; }
              i = save;
            }
            out += a.h;
          }
          return out;
        }
        return s.split('\n').map(function (ln) { return parse(ln) || '&nbsp;'; }).join('<br>');
      }
      var edit = null, txEl = null;
      var TXKEYS = [['A−', 'small'], ['A+', 'big'], ['▫/▫', '/'], ['x²', '^'], ['√', '√('], ['×', '×'], ['÷', '÷'], ['π', 'π'], ['°', '°'], ['≤', '≤'], ['≥', '≥']];
      function txtHit(p) {
        var hitId = null;
        objBoxes().forEach(function (o) { var ob = findObj(o.id); if (ob && ob.type === 'txt' && p.x >= o.x && p.x <= o.x + o.w && p.y >= o.y && p.y <= o.y + o.h) hitId = o.id; });
        return hitId ? findObj(hitId) : null;
      }
      function newText(p) {
        var o = { id: 'w' + Date.now().toString(36) + (++oid), type: 'txt', x: Math.round(p.x), y: Math.round(p.y - 20), s: Math.round(100 / view().z) / 100, t: '', hx: slotHex(st.col), fs: [26, 34, 46][st.size] };
        snap(); page().objs.push(o); drawObjs(); editText(o, true);
      }
      function editText(o, fresh) {
        if (!txEl) {
          txEl = el('div', 'wb-txed'); txEl.hidden = true;
          txEl.innerHTML = '<div class="wb-txkeys">' + TXKEYS.map(function (k) { return '<button type="button" class="wb-txk" data-wbtx="' + esc(k[1]) + '" aria-label="' + esc(k[0]) + '">' + k[0] + '</button>'; }).join('') + '</div><textarea class="wb-txin" rows="1" spellcheck="false" aria-label="Type on the board"></textarea>';
          board.appendChild(txEl);
          var ta = txEl.querySelector('textarea');
          ta.addEventListener('input', function () { if (edit) { edit.o.t = ta.value; txFit(); } });
          ta.addEventListener('blur', function () { setTimeout(function () { if (edit && document.activeElement !== ta && !txEl.contains(document.activeElement)) endText(); }, 120); });
          txEl.addEventListener('pointerdown', function (e) { var b = e.target.closest && e.target.closest('[data-wbtx]'); if (b) { e.preventDefault(); txKey(b.getAttribute('data-wbtx')); } });
        }
        if (edit && edit.o !== o) endText();
        if (!fresh) snap();
        edit = { o: o }; var bx = objsEl.querySelector('[data-id="' + o.id + '"]'); if (bx) bx.classList.add('is-editing');
        var ta2 = txEl.querySelector('textarea'); ta2.value = o.t || ''; ta2.style.color = o.hx;
        txEl.hidden = false; txFit();
        try { ta2.focus({ preventScroll: true }); ta2.setSelectionRange(ta2.value.length, ta2.value.length); } catch (er) {}
      }
      function txFit() {
        if (!edit || !txEl) return;
        var o = edit.o, q = toScr(o), z = view().z, ta = txEl.querySelector('textarea'), fs = o.fs * (o.s || 1) * z;
        ta.style.fontSize = fs + 'px'; ta.style.height = 'auto'; ta.style.width = 'auto';
        ta.style.width = Math.max(160, Math.min(W - q.x - 16, ta.scrollWidth + fs)) + 'px'; ta.style.height = ta.scrollHeight + 'px';
        txEl.style.left = Math.round(q.x - 10) + 'px'; txEl.style.top = Math.round(q.y - 10 - 52) + 'px';
      }
      function txKey(k) {
        if (!edit) return;
        var o = edit.o, ta = txEl.querySelector('textarea');
        if (k === 'small' || k === 'big') { o.fs = clamp(o.fs + (k === 'big' ? 6 : -6), 16, 120); txFit(); return; }
        var a = ta.selectionStart, b = ta.selectionEnd, v = ta.value, ins = k, back = 0;
        if (k === '√(') { ins = '√()'; back = 1; }
        ta.value = v.slice(0, a) + ins + v.slice(b); ta.setSelectionRange(a + ins.length - back, a + ins.length - back);
        o.t = ta.value; txFit(); ta.focus();
      }
      function endText() {
        if (!edit) return;
        var o = edit.o; edit = null; if (txEl) txEl.hidden = true;
        var pg = page();
        if (!String(o.t || '').trim()) { pg.objs = pg.objs.filter(function (x) { return x !== o; }); if (pg.hist.length) pg.hist.pop(); }
        drawObjs(); drawSide(); dirty();
        var g = /^\s*y\s*=\s*(.+)$/.exec(String(o.t || '').replace(/\n/g, ' '));
        if (g && fnOf(g[1])) graphAsk(o, g[1].trim());
      }

      /* ---------- GRAPHS (round 7, Aadam's pick 6, "if you type other text e.g. y= something it gives you a prompt to draw
         the graph"): y = ... typed, or Add (+) then Graph, puts an object of type 'graph' on the board: axes, every line in
         fns drawn over its x range, where two lines cross marked, and the table of values when asked for ---------- */
      function fnOf(src) {
        var s = String(src || '').replace(/[−–]/g, '-').replace(/×/g, '*').replace(/÷/g, '/').replace(/²/g, '^2').replace(/³/g, '^3').replace(/π/g, 'pi').replace(/√/g, 'sqrt').replace(/\s+/g, '').toLowerCase();
        if (!s || s.length > 80 || !/^[0-9x+\-*/^().a-z]+$/.test(s)) return null;
        var i = 0, used = false;
        function peek() { return s.charAt(i); }
        function num() { var m = /^\d*\.?\d+/.exec(s.slice(i)); if (!m) return null; i += m[0].length; var v = parseFloat(m[0]); return function () { return v; }; }
        function prim() {
          var c = peek(), f;
          if (c === '(') { i++; f = sum(); if (peek() !== ')') throw 0; i++; return f; }
          if (c === 'x') { i++; used = true; return function (x) { return x; }; }
          if (/[0-9.]/.test(c)) return num();
          var m = /^(sqrt|sin|cos|tan|pi)/.exec(s.slice(i));
          if (m) {
            i += m[0].length;
            if (m[1] === 'pi') return function () { return Math.PI; };
            var a = factor(), fn = { sqrt: Math.sqrt, sin: function (v) { return Math.sin(v * Math.PI / 180); }, cos: function (v) { return Math.cos(v * Math.PI / 180); }, tan: function (v) { return Math.tan(v * Math.PI / 180); } }[m[1]];
            return function (x) { return fn(a(x)); };
          }
          throw 0;
        }
        function power() { var b = prim(); if (peek() === '^') { i++; var e = unary(); return function (x) { return Math.pow(b(x), e(x)); }; } return b; }
        function unary() { if (peek() === '-') { i++; var u = unary(); return function (x) { return -u(x); }; } if (peek() === '+') { i++; return unary(); } return power(); }
        function factor() { return unary(); }
        function term() {
          var f = factor();
          for (;;) {
            var c = peek();
            if (c === '*' || c === '/') { i++; var g = factor(), h = f; f = c === '*' ? function (x) { return h(x) * g(x); } : function (x) { return h(x) / g(x); }; }
            else if (c && /[0-9x(a-z.]/.test(c)) { var g2 = power(), h2 = f; f = function (x) { return h2(x) * g2(x); }; }
            else return f;
          }
        }
        function sum() {
          var f = term();
          for (;;) { var c = peek(); if (c !== '+' && c !== '-') return f; i++; var g = term(), h = f; f = c === '+' ? function (x) { return h(x) + g(x); } : function (x) { return h(x) - g(x); }; }
        }
        try { var f = sum(); if (i !== s.length || !used) return null; return f; } catch (e) { return null; }
      }
      function graphAsk(o, expr) {
        toastAct('Draw the graph of y = ' + expr + '?', [['Draw it', function () { addGraph(expr, o, false); }], ['Table of values', function () { addGraph(expr, o, true); }]]);
      }
      function addGraph(expr, near, table) {
        var pg = page(), v = view(), bx = near && objsEl.querySelector('[data-id="' + near.id + '"]');
        var x = near ? near.x + (bx ? bx.offsetWidth : 200) + 40 / v.z : v.x + 120 / v.z, y = near ? near.y : v.y + 60 / v.z;
        var o = { id: 'w' + Date.now().toString(36) + (++oid), type: 'graph', x: Math.round(x), y: Math.round(y), s: Math.round(100 / v.z) / 100, fns: expr ? [expr] : [], x0: -5, x1: 5, table: !!table, hide: !!table };
        snap(pg); pg.objs.push(o); st.sel = o.id; drawObjs(); drawSide(); dirty();
        track('whiteboard_graph', { table: !!table });
      }
      var GCOL = ['#C0392B', '#1D4E9E', '#13804A', '#6A3FA0'];
      function graphData(o) {
        var fs = (o.fns || []).map(fnOf).filter(Boolean), lo = 1e9, hi = -1e9, n = 160, k, j;
        fs.forEach(function (f) { for (k = 0; k <= n; k++) { var y = f(o.x0 + (o.x1 - o.x0) * k / n); if (isFinite(y) && Math.abs(y) < 1e4) { lo = Math.min(lo, y); hi = Math.max(hi, y); } } });
        if (lo > hi) { lo = -5; hi = 5; }
        lo = Math.max(lo, -40); hi = Math.min(hi, 40); lo = Math.min(lo, 0); hi = Math.max(hi, 0);
        if (hi - lo < 4) { hi += 2; lo -= 2; }
        var stepOf = function (sp) { return sp <= 12 ? 1 : sp <= 24 ? 2 : sp <= 60 ? 5 : 10; }, step = stepOf(hi - lo), xs = stepOf(o.x1 - o.x0);
        lo = Math.floor(lo / step) * step; hi = Math.ceil(hi / step) * step;
        var cross = [];
        for (j = 1; j < fs.length; j++) for (var a = 0; a < j; a++) {
          var d = function (x) { return fs[a](x) - fs[j](x); }, px = o.x0, pv = d(px);
          for (k = 1; k <= 400; k++) { var cx = o.x0 + (o.x1 - o.x0) * k / 400, cv = d(cx); if (isFinite(pv) && isFinite(cv) && (pv === 0 || pv * cv < 0)) { var l = px, r = cx; for (var it = 0; it < 40; it++) { var m = (l + r) / 2; if (d(l) * d(m) <= 0) r = m; else l = m; } var xr = (l + r) / 2; cross.push([xr, fs[a](xr)]); } px = cx; pv = cv; }
        }
        return { fs: fs, y0: lo, y1: hi, step: step, xs: xs, cross: cross };
      }
      function nice(v) { var r = Math.round(v * 100) / 100; return (r < 0 ? MINUS : '') + Math.abs(r); }
      function graphBody(o) {
        var D = graphData(o), W0 = 440, H0 = Math.round(Math.min(520, Math.max(260, W0 * (D.y1 - D.y0) / Math.max(1, o.x1 - o.x0)))), k;
        var X = function (x) { return 30 + (x - o.x0) / (o.x1 - o.x0) * W0; }, Y = function (y) { return 20 + (D.y1 - y) / (D.y1 - D.y0) * H0; };
        var h = '<svg class="wbo-gsv" width="' + (W0 + 60) + '" height="' + (H0 + 50) + '" viewBox="0 0 ' + (W0 + 60) + ' ' + (H0 + 50) + '" aria-hidden="true"><g class="g-grid">';
        for (k = Math.ceil(o.x0 / D.xs) * D.xs; k <= o.x1; k += D.xs) h += '<path d="M' + X(k) + ' 20V' + (20 + H0) + '"/>';
        for (k = D.y0; k <= D.y1; k += D.step) h += '<path d="M30 ' + Y(k) + 'H' + (30 + W0) + '"/>';
        h += '</g><path class="g-ax" d="M30 ' + Y(0) + 'H' + (30 + W0) + 'M' + X(0) + ' 20V' + (20 + H0) + '"/>';
        for (k = Math.ceil(o.x0 / D.xs) * D.xs; k <= o.x1; k += D.xs) if (k) h += '<text class="g-n" x="' + X(k) + '" y="' + (Y(0) + 16) + '">' + nice(k) + '</text>';
        for (k = D.y0; k <= D.y1; k += D.step) if (k) h += '<text class="g-n" x="' + (X(0) - 8) + '" y="' + (Y(k) + 4) + '" text-anchor="end">' + nice(k) + '</text>';
        h += '<text class="g-l" x="' + (34 + W0) + '" y="' + (Y(0) + 5) + '">x</text><text class="g-l" x="' + (X(0) + 6) + '" y="16">y</text>';
        if (!o.hide) D.fs.forEach(function (f, n) {
          var d = '', pen = false;
          for (var s2 = 0; s2 <= 240; s2++) { var x = o.x0 + (o.x1 - o.x0) * s2 / 240, y = f(x); if (!isFinite(y) || y < D.y0 - 1 || y > D.y1 + 1) { pen = false; continue; } d += (pen ? 'L' : 'M') + X(x).toFixed(1) + ' ' + Y(y).toFixed(1); pen = true; }
          h += '<path class="g-fn" stroke="' + GCOL[n % 4] + '" d="' + d + '"/>';
        });
        if (!o.hide) D.cross.forEach(function (c) { h += '<circle cx="' + X(c[0]) + '" cy="' + Y(c[1]) + '" r="6" class="g-x"/><text class="g-xl" x="' + (X(c[0]) + 10) + '" y="' + (Y(c[1]) - 10) + '">(' + nice(c[0]) + ', ' + nice(c[1]) + ')</text>'; });
        h += '<clipPath id="gc' + o.id + '"><rect x="30" y="20" width="' + W0 + '" height="' + H0 + '"/></clipPath></svg>';
        var key = (o.fns || []).map(function (e, n) { return '<span class="wbo-gk" style="color:' + GCOL[n % 4] + '">' + mathHTML('y = ' + e) + '</span>'; }).join('');
        var tbl = '';
        if (o.table && D.fs.length) {
          var xs = []; for (k = Math.ceil(o.x0); k <= o.x1; k++) xs.push(k);
          tbl = '<table class="wbo-gt"><tr><th><i>x</i></th>' + xs.map(function (x) { return '<td>' + nice(x) + '</td>'; }).join('') + '</tr>' +
            D.fs.map(function (f, n) { return '<tr><th style="color:' + GCOL[n % 4] + '"><i>y</i></th>' + xs.map(function (x) { var y = f(x); return '<td>' + (isFinite(y) ? nice(y) : '') + '</td>'; }).join('') + '</tr>'; }).join('') + '</table>';
        }
        return '<div class="wbo-graph"><div class="wbo-gks">' + (key || '<span class="wbo-gk">Type a line below, like y = 2x + 1</span>') + '</div>' + h + tbl + '</div>';
      }

      /* ---------- RIGHT ANGLES BY THEMSELVES (round 7, Aadam: "right angle should draw automatically if you draw line like
         it") ----------
         A straight line that meets another at a corner (or ends on it) within 6° of square gets the little square mark,
         drawn as ink of its own (ra) so the rubber, Select and Undo treat it like anything else. A snapped triangle and an
         L drawn in one go are checked too; a box is not, four marks would only be clutter. */
      function segsOf(s) {
        var q = s.pts, out = [], i;
        if (s.ra || q.length < 2) return out;
        if (s.k === 'line' || s.k === 'arrow' || (s.st && q.length === 2)) return [[q[0], q[q.length - 1]]];
        if (s.st && q.length <= 5) { for (i = 1; i < q.length; i++) out.push([q[i - 1], q[i]]); return out; }
        if (s.k !== 'pen' || q.length > 400) return out;
        var a = q[0], b = q[q.length - 1], L = Math.hypot(b.x - a.x, b.y - a.y), len = 0;
        for (i = 1; i < q.length; i++) len += Math.hypot(q[i].x - q[i - 1].x, q[i].y - q[i - 1].y);
        if (L > 30 && len < L * 1.06) { var dev = 0; for (i = 1; i < q.length - 1; i++) dev = Math.max(dev, segD(q[i], a, b)); if (dev < Math.max(5, L * 0.04)) return [[a, b]]; }
        return out;
      }
      function lOf(s) {
        /* an L in one stroke: two straight parts and one corner */
        if (s.k !== 'pen' || s.st || s.pts.length < 6) return null;
        var D = 0, q = s.pts; q.forEach(function (p) { D = Math.max(D, Math.hypot(p.x - q[0].x, p.y - q[0].y)); });
        var r = rdp(q, Math.max(5, D * 0.06)); return r.length === 3 ? r : null;
      }
      function sq(u, v) { var d = (u.x * v.x + u.y * v.y) / ((Math.hypot(u.x, u.y) * Math.hypot(v.x, v.y)) || 1); return Math.abs(d) < Math.sin(6 * Math.PI / 180); }
      function unit(v) { var n = Math.hypot(v.x, v.y) || 1; return { x: v.x / n, y: v.y / n }; }
      function vlen(v) { return Math.hypot(v.x, v.y); }
      /* square to w, on the side of u, as long as u */
      function perpOf(w, u) { var n = unit({ x: -w.y, y: w.x }), sg = n.x * u.x + n.y * u.y < 0 ? -1 : 1, L = vlen(u); return { x: n.x * sg * L, y: n.y * sg * L }; }
      /* within 5° of level or upright: exactly level or upright */
      function levelOf(u) { var a = Math.atan2(u.y, u.x), g = Math.round(a / (Math.PI / 2)) * (Math.PI / 2), L = vlen(u); return Math.abs(a - g) < 5 * Math.PI / 180 ? { x: Math.cos(g) * L, y: Math.sin(g) * L } : u; }
      function raMark(C, u, v, w, hex, c) {
        var m = Math.max(12, w * 3.2), a = { x: C.x + u.x * m, y: C.y + u.y * m }, b = { x: a.x + v.x * m, y: a.y + v.y * m }, d = { x: C.x + v.x * m, y: C.y + v.y * m };
        var o = { k: 'pen', c: c, w: Math.max(1.5, w * 0.6), st: 1, ra: 1, pts: [a, b, d] }; if (hex) o.h = hex; return o;
      }
      /* ROUND 9 (10-24, Aadam: "too repetitive and too responsive when writing ... make a min size"; "if drawing a right
         angle - the lines should become straight"): every arm has to be at least RA_MIN screen px long, so letters and
         numbers (L, T, 4, 7, +) never get a mark; when a mark goes on, the freehand lines that make it turn into straight
         ones, exactly square; no toast (Undo takes it back) */
      var RA_MIN = 64;
      function rightAngles(s) {
        var pg = page(), z = view().z, tol = 18 / z, minA = RA_MIN / z, marks = [], swap = [], i, j;
        var near = function (C) { return pg.ink.concat(marks).some(function (x) { return x.ra && Math.hypot(x.pts[1].x - C.x, x.pts[1].y - C.y) < tol * 2; }); };
        var add = function (C, u, v) { if (near(C)) return false; marks.push(raMark(C, unit(u), unit(v), s.w, s.h, s.c)); return true; };
        var free = function (x) { return x.k === 'pen' && !x.st; };
        var straight = function (x, pts) { var o = JSON.parse(JSON.stringify(x)); o.pts = pts; o.st = 1; delete o.pr; swap.push([x, o]); return o; };
        var L = lOf(s);
        if (L) {
          var a1 = { x: L[0].x - L[1].x, y: L[0].y - L[1].y }, b1 = { x: L[2].x - L[1].x, y: L[2].y - L[1].y };
          if (vlen(a1) >= minA && vlen(b1) >= minA && sq(a1, b1)) {
            a1 = levelOf(a1); b1 = perpOf(a1, b1);
            if (add(L[1], a1, b1)) straight(s, [{ x: L[1].x + a1.x, y: L[1].y + a1.y }, { x: L[1].x, y: L[1].y }, { x: L[1].x + b1.x, y: L[1].y + b1.y }]);
          }
        }
        if (s.st && s.pts.length === 4) for (i = 0; i < 3; i++) {
          var P = s.pts[i], A = s.pts[(i + 2) % 3], B = s.pts[(i + 1) % 3], u = { x: A.x - P.x, y: A.y - P.y }, v = { x: B.x - P.x, y: B.y - P.y };
          if (vlen(u) >= minA && vlen(v) >= minA && sq(u, v)) add(P, u, v);
        }
        var segs = swap.length ? [] : segsOf(s).filter(function (sg) { return Math.hypot(sg[1].x - sg[0].x, sg[1].y - sg[0].y) >= minA; });
        var others = pg.ink.slice(-80).filter(function (x) { return x !== s && !x.ra; }), joins = [];
        segs.forEach(function (sg) {
          [0, 1].forEach(function (end) {
            var C = sg[end], F = sg[1 - end], u = { x: F.x - C.x, y: F.y - C.y };
            others.forEach(function (x) {
              segsOf(x).forEach(function (og) {
                var w0 = { x: og[1].x - og[0].x, y: og[1].y - og[0].y };
                if (vlen(w0) < minA) return;
                for (j = 0; j < 2; j++) {
                  var D2 = og[j], E = og[1 - j];
                  if (Math.hypot(D2.x - C.x, D2.y - C.y) < tol) { var v = { x: E.x - D2.x, y: E.y - D2.y }; if (sq(u, v) && add(D2, u, v)) joins.push({ sg: sg, end: end, C: D2, w: v, x: x, og: og, m: marks.length - 1 }); return; }
                }
                /* a line ending on the middle of another: the mark goes on the side it comes from */
                if (segD(C, og[0], og[1]) < tol * 0.7 && sq(u, w0)) {
                  var t2 = ((C.x - og[0].x) * w0.x + (C.y - og[0].y) * w0.y) / ((w0.x * w0.x + w0.y * w0.y) || 1), foot = { x: og[0].x + w0.x * t2, y: og[0].y + w0.y * t2 };
                  if (add(foot, u, w0)) joins.push({ sg: sg, end: end, C: foot, w: w0, x: x, og: og, m: marks.length - 1 });
                }
              });
            });
          });
        });
        /* straighten: a freehand line the other meets becomes its own straight chord; the new line runs from the corner,
           exactly square to it (met at both ends: corner to corner) */
        joins.forEach(function (J) { if (free(J.x) && !swap.some(function (w) { return w[0] === J.x; })) straight(J.x, [J.og[0], J.og[1]]); });
        if (joins.length && (free(s) || s.k === 'line' || s.k === 'arrow') && segsOf(s).length === 1) {
          var J0 = joins[0], J1 = joins.filter(function (J) { return J.end !== J0.end; })[0], F0 = J0.sg[1 - J0.end], pts;
          if (J1) pts = [J0.C, J1.C];
          else { var pu = perpOf(J0.w, { x: F0.x - J0.C.x, y: F0.y - J0.C.y }); pts = [{ x: J0.C.x, y: J0.C.y }, { x: J0.C.x + pu.x, y: J0.C.y + pu.y }]; marks[J0.m] = raMark(J0.C, unit(pu), unit(J0.w), s.w, s.h, s.c); }
          if (J0.end === 1) pts.reverse();
          straight(s, pts);
        }
        if (!marks.length) return;
        snap(pg);
        swap.forEach(function (w) { var k = pg.ink.indexOf(w[0]); if (k >= 0) pg.ink[k] = w[1]; });
        marks.forEach(function (m) { pg.ink.push(m); }); redraw(); dirty();
      }

      /* ---------- STAMPS (round 7, Aadam's pick 2) ----------
         Marks, tools and shapes from Add (+): each an object of type 'stamp' (k = which, r = turn in degrees, hx = colour)
         drawn from one path, so the board and the PNG draw it the same way; it moves, sizes, turns and takes ink over it */
      var STAMPS = {
        ra: { n: 'Right angle', vb: 40, px: 60, d: 'M4 36V4M4 36H36M4 22H18V36', g: 'mark' },
        arc: { n: 'Angle arc', vb: 40, px: 70, d: 'M4 36H38M4 36L30 10M24 36A20 20 0 0 0 18.1 21.9', g: 'mark' },
        arc2: { n: 'Two arcs', vb: 40, px: 70, d: 'M4 36H38M4 36L30 10M24 36A20 20 0 0 0 18.1 21.9M29 36A25 25 0 0 0 21.7 18.3', g: 'mark' },
        par1: { n: 'Parallel', vb: 40, px: 40, d: 'M14 8L26 20L14 32', g: 'mark' },
        par2: { n: 'Parallel, two', vb: 40, px: 40, d: 'M8 8L20 20L8 32M20 8L32 20L20 32', g: 'mark' },
        eq1: { n: 'Equal sides', vb: 40, px: 34, d: 'M20 6V34', g: 'mark' },
        eq2: { n: 'Equal, two', vb: 40, px: 34, d: 'M15 6V34M25 6V34', g: 'mark' },
        pt: { n: 'Point', vb: 40, px: 30, d: 'M10 10L30 30M30 10L10 30', g: 'mark' },
        prot: { n: 'Protractor', vb: 100, px: 380, h: 0.56, d: '', g: 'tool' },
        grid: { n: 'Squared grid', vb: 100, px: 320, d: 'M2 2H98V98H2Z M2 18H98M2 34H98M2 50H98M2 66H98M2 82H98M18 2V98M34 2V98M50 2V98M66 2V98M82 2V98', g: 'tool' },
        tri: { n: 'Triangle', vb: 100, px: 220, d: 'M8 90H92L50 12Z', g: 'shape' },
        circ: { n: 'Circle', vb: 100, px: 200, d: 'M92 50A42 42 0 1 1 8 50A42 42 0 1 1 92 50ZM50 50H92', g: 'shape' },
        cub: { n: 'Cuboid', vb: 100, px: 220, d: 'M8 36H66V92H8Z M8 36L34 10H92L66 36 M92 10V66L66 92', g: 'shape' },
        cyl: { n: 'Cylinder', vb: 100, px: 180, d: 'M18 18A32 10 0 1 0 82 18A32 10 0 1 0 18 18 M18 18V82A32 10 0 0 0 82 82V18', g: 'shape' }
      };
      (function () {
        /* the protractor: a half circle, a line every 10° and a longer one every 30°, numbered both ways */
        var d = 'M2 54H98M2 54A48 48 0 0 1 98 54M50 54V48', a;
        for (a = 0; a <= 180; a += 10) {
          var r0 = a % 30 ? 42 : 38, c = Math.cos(a * Math.PI / 180), s = Math.sin(a * Math.PI / 180);
          d += 'M' + (50 - 48 * c).toFixed(1) + ' ' + (54 - 48 * s).toFixed(1) + 'L' + (50 - r0 * c).toFixed(1) + ' ' + (54 - r0 * s).toFixed(1);
        }
        STAMPS.prot.d = d; STAMPS.prot.vbh = 56;
      })();
      function stampBody(o) {
        var S0 = STAMPS[o.k]; if (!S0) return '';
        var w = Math.round(S0.px), h = Math.round(S0.px * (S0.vbh || S0.vb) / S0.vb), hx = /^#[0-9a-f]{6}$/i.test(o.hx) ? o.hx : 'currentColor';
        var nums = '';
        if (o.k === 'prot') for (var a = 0; a <= 180; a += 30) {
          var c = Math.cos(a * Math.PI / 180), s = Math.sin(a * Math.PI / 180);
          nums += '<text x="' + (50 - 33 * c).toFixed(1) + '" y="' + (55 - 33 * s).toFixed(1) + '">' + a + '</text>';
        }
        return '<svg class="wbo-st' + (o.k === 'prot' ? ' is-prot' : '') + '" width="' + w + '" height="' + h + '" viewBox="0 0 ' + S0.vb + ' ' + (S0.vbh || S0.vb) + '" style="transform:rotate(' + (o.r | 0) + 'deg)" aria-hidden="true">' +
          '<path d="' + S0.d + '" stroke="' + hx + '"/>' + (nums ? '<g class="st-n">' + nums + '</g>' : '') + '</svg>';
      }
      function addStamp(k) {
        var S0 = STAMPS[k]; if (!S0) return;
        var pg = page(), v = view(), z = v.z;
        var o = { id: 'w' + Date.now().toString(36) + (++oid), type: 'stamp', k: k, r: 0, hx: k === 'prot' || k === 'grid' ? '' : slotHex(st.col), s: Math.round(100 / z) / 100 };
        o.x = Math.round(v.x + (W / 2 - S0.px / 2) / z); o.y = Math.round(v.y + (H / 2 - S0.px / 2 - 40) / z);
        snap(pg); pg.objs.push(o); st.sel = o.id; st.menu = null; drawObjs(); drawIns(); drawDock(); drawSide(); dirty();
        track('whiteboard_stamp', { k: k });
      }
      function stampC(x, o, t) {
        var S0 = STAMPS[o.k]; if (!S0 || !window.Path2D) return;
        var k = S0.px / S0.vb, h = S0.px * (S0.vbh || S0.vb) / S0.vb;
        x.save(); x.translate(S0.px / 2, h / 2); x.rotate((o.r || 0) * Math.PI / 180); x.translate(-S0.px / 2, -h / 2); x.scale(k, k);
        x.strokeStyle = /^#[0-9a-f]{6}$/i.test(o.hx) ? o.hx : t.ink; x.lineWidth = 3 / k * (S0.vb === 40 ? 1 : 0.9); x.lineCap = 'round'; x.lineJoin = 'round';
        x.stroke(new Path2D(S0.d));
        if (o.k === 'prot') for (var a = 0; a <= 180; a += 30) { var c = Math.cos(a * Math.PI / 180), s = Math.sin(a * Math.PI / 180); ctext(x, String(a), 5, 700, t.ink, 50 - 33 * c, 55 - 33 * s); }
        x.restore();
      }

      /* ---------- THE RULER (round 7, Aadam's pick 5) ----------
         Add (+) then Ruler lays a see-through ruler on the board (st.ruler: o = the start of its edge in board units, a =
         its turn in degrees, L = its length). Drag it to move, the round handle to turn it (it clicks every 5°). A pen
         stroke begun just under its edge runs along that edge, dead straight, and says how long it is in squares. */
      var rulerEl = null, rulDrag = null;
      function toggleRuler() {
        if (st.ruler) { st.ruler = null; }
        else { var v = view(); st.ruler = { o: { x: v.x + (W * 0.2) / v.z, y: v.y + (H * 0.6) / v.z }, a: 0, L: Math.min(W * 0.6, 760) / v.z }; }
        st.menu = null; drawIns(); drawDock(); drawRuler();
      }
      function drawRuler() {
        if (!board) return;
        if (!st.ruler) { if (rulerEl) rulerEl.hidden = true; return; }
        if (!rulerEl) {
          rulerEl = el('div', 'wb-ruler');
          rulerEl.innerHTML = '<div class="wb-rbody"><span></span></div><span class="wb-rang num"></span><button type="button" class="wb-rrot" aria-label="Turn the ruler" data-tip="Turn it"></button>';
          board.insertBefore(rulerEl, dockEl);
          rulerEl.addEventListener('pointerdown', rulDown); rulerEl.addEventListener('pointermove', rulMove); rulerEl.addEventListener('pointerup', rulUp); rulerEl.addEventListener('pointercancel', rulUp);
        }
        var r = st.ruler, z = view().z, q = toScr(r.o), sqpx = (st.pat === 'dots' ? 34 : st.pat === 'lines' ? 44 : 40) * z;
        rulerEl.hidden = false;
        rulerEl.style.left = Math.round(q.x) + 'px'; rulerEl.style.top = Math.round(q.y - 70) + 'px'; rulerEl.style.width = Math.round(r.L * z) + 'px';
        rulerEl.style.transform = 'rotate(' + r.a + 'deg)'; rulerEl.style.setProperty('--sq', sqpx + 'px');
        var deg = ((-r.a % 360) + 360) % 360; rulerEl.querySelector('.wb-rang').textContent = Math.round(deg > 180 ? 360 - deg : deg) + '°';
      }
      function rulDir() { var a = st.ruler.a * Math.PI / 180; return { x: Math.cos(a), y: Math.sin(a) }; }
      function rulDown(e) {
        if (e.button > 0) return; e.preventDefault(); e.stopPropagation(); hideTip();
        var p = pt(e), rot = !!(e.target.closest && e.target.closest('.wb-rrot'));
        rulDrag = { rot: rot, p: p, o: { x: st.ruler.o.x, y: st.ruler.o.y }, id: e.pointerId };
        try { rulerEl.setPointerCapture(e.pointerId); } catch (er) {}
      }
      function rulMove(e) {
        if (!rulDrag || e.pointerId !== rulDrag.id) return;
        var p = pt(e), r = st.ruler;
        if (rulDrag.rot) { var a = Math.atan2(p.y - r.o.y, p.x - r.o.x) * 180 / Math.PI; r.a = Math.round(a / 5) * 5; }
        else { r.o = { x: rulDrag.o.x + p.x - rulDrag.p.x, y: rulDrag.o.y + p.y - rulDrag.p.y }; }
        drawRuler();
      }
      function rulUp() { rulDrag = null; }
      /* the point on the ruler's edge nearest p, and whether p is close under it (the side away from the body) */
      function rulEdge(p) {
        if (!st.ruler) return null;
        var r = st.ruler, d = rulDir(), t2 = (p.x - r.o.x) * d.x + (p.y - r.o.y) * d.y, off = -(p.x - r.o.x) * d.y + (p.y - r.o.y) * d.x;
        return { t: t2, off: off, p: { x: r.o.x + d.x * t2, y: r.o.y + d.y * t2 } };
      }
      function rulerChip(a, b) {
        var sqw = st.pat === 'dots' ? 34 : st.pat === 'lines' ? 44 : 40, n = Math.hypot(b.x - a.x, b.y - a.y) / sqw, q = toScr(b);
        chipEl.innerHTML = '<span>Along the ruler</span><b class="num">' + (Math.round(n * 10) / 10) + ' squares</b>';
        chipEl.hidden = false; chipEl.style.left = Math.round(Math.min(q.x + 22, W - chipEl.offsetWidth - 8)) + 'px'; chipEl.style.top = Math.round(Math.max(8, q.y - 58)) + 'px';
      }

      /* ---------- LASSO (round 7, Aadam's pick 8) ----------
         Tap Select again to switch between the box and the lasso (st.selMode). The lasso is drawn by hand; a line is picked
         when most of it is inside the loop, a diagram or picture when its middle is. The loop closes itself. */
      var lassoEl = null;
      function lassoPath(pts) {
        if (!lassoEl) { lassoEl = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); lassoEl.setAttribute('class', 'wb-lasso'); lassoEl.innerHTML = '<path/>'; board.insertBefore(lassoEl, dockEl); }
        if (!pts) { lassoEl.style.display = 'none'; return; }
        lassoEl.style.display = 'block'; lassoEl.setAttribute('width', W); lassoEl.setAttribute('height', H);
        lassoEl.firstChild.setAttribute('d', pts.map(function (p, i) { var q = toScr(p); return (i ? 'L' : 'M') + q.x.toFixed(1) + ' ' + q.y.toFixed(1); }).join('') + 'Z');
      }
      function inPoly(poly, x, y) {
        var c = false;
        for (var i = 0, j = poly.length - 1; i < poly.length; j = i++) {
          var a = poly[i], b = poly[j];
          if ((a.y > y) !== (b.y > y) && x < (b.x - a.x) * (y - a.y) / ((b.y - a.y) || 1e-9) + a.x) c = !c;
        }
        return c;
      }
      function lassoPick(m) {
        var poly = m.pts, pk = m.add ? { ink: m.add.ink.slice(), objs: m.add.objs.slice() } : { ink: [], objs: [] };
        if (poly.length < 3) return pk;
        page().ink.forEach(function (s) { if (pk.ink.indexOf(s) >= 0) return; var n = 0; s.pts.forEach(function (q) { if (inPoly(poly, q.x, q.y)) n++; }); if (n && n >= s.pts.length * 0.5) pk.ink.push(s); });
        objBoxes().forEach(function (o) { if (pk.objs.indexOf(o.id) < 0 && inPoly(poly, o.x + o.w / 2, o.y + o.h / 2)) pk.objs.push(o.id); });
        return pk;
      }

      /* ---------- TIMER (round 7, Aadam's pick 7) ----------
         Add (+) then Timer: 1, 2, 3, 5, 10 or 15 minutes, or a time typed in. It sits in the board's top corner, big
         enough for the back of a room, keeps running across questions, pages and boards, turns orange in its last 30
         seconds and plays a soft chime at the end (st.timer = { end, total, left (while paused), chime }). */
      var timerEl = null, timerT = 0, timerDrag = null;
      function timerPopHTML() {
        return '<div class="wb-cph"><b>Timer</b></div><div class="wb-tmps">' + [1, 2, 3, 5, 10, 15].map(function (m) { return '<button type="button" class="wb-b wb-tmp" data-wbtm="go:' + (m * 60) + '">' + m + ' min</button>'; }).join('') + '</div>' +
          '<div class="wb-tmown"><label class="wb-cphex">Own time<input class="wb-tmin" placeholder="4:30" maxlength="5" inputmode="numeric" aria-label="Own time, minutes and seconds"></label><button type="button" class="wb-b wb-tmgo" data-wbtm="own">Start</button></div>' +
          '<label class="wb-tmch"><input type="checkbox" class="wb-tmchk"' + (st.chime !== false ? ' checked' : '') + '> Soft chime at the end</label>';
      }
      function timerStart(sec) {
        sec = clamp(Math.round(sec), 5, 99 * 60);
        st.timer = { end: Date.now() + sec * 1000, total: sec, left: null, done: false };
        st.menu = null; drawPop(); drawIns(); drawDock(); timerDraw(); timerTick();
        track('whiteboard_timer', { s: sec });
      }
      function timerLeft() { var t = st.timer; return !t ? 0 : t.left !== null ? t.left : Math.max(0, (t.end - Date.now()) / 1000); }
      function timerTick() {
        clearTimeout(timerT); if (!st.timer) return;
        var t = st.timer, left = timerLeft();
        if (left <= 0 && !t.done && t.left === null) { t.done = true; if (st.chime !== false) chime(); }
        timerDraw();
        if (!t.done && t.left === null) timerT = setTimeout(timerTick, 250);
      }
      function chime() {
        try {
          var A = window.AudioContext || window.webkitAudioContext; if (!A) return;
          var ac = chime.ac || (chime.ac = new A()), now = ac.currentTime;
          [[880, 0], [1318.5, 0.18], [1760, 0.36]].forEach(function (n) {
            var o = ac.createOscillator(), g = ac.createGain(); o.type = 'sine'; o.frequency.value = n[0];
            g.gain.setValueAtTime(0, now + n[1]); g.gain.linearRampToValueAtTime(0.18, now + n[1] + 0.02); g.gain.exponentialRampToValueAtTime(0.001, now + n[1] + 0.9);
            o.connect(g); g.connect(ac.destination); o.start(now + n[1]); o.stop(now + n[1] + 1);
          });
        } catch (e) {}
      }
      function timerDraw() {
        if (!board) return;
        if (!st.timer) { if (timerEl) timerEl.hidden = true; return; }
        if (!timerEl) {
          timerEl = el('div', 'wb-timer'); board.insertBefore(timerEl, dockEl);
          timerEl.addEventListener('pointerdown', function (e) { if (e.target.closest && e.target.closest('button')) return; e.preventDefault(); var q = ptS(e); timerDrag = { dx: q.x - timerEl.offsetLeft, dy: q.y - timerEl.offsetTop, moved: false, id: e.pointerId }; try { timerEl.setPointerCapture(e.pointerId); } catch (er) {} });
          timerEl.addEventListener('pointermove', function (e) { if (!timerDrag || e.pointerId !== timerDrag.id) return; var q = ptS(e); timerDrag.moved = true; st.timerAt = { x: clamp((q.x - timerDrag.dx) / W, 0, 1), y: clamp((q.y - timerDrag.dy) / H, 0, 1) }; timerPlace(); });
          timerEl.addEventListener('pointerup', function () { var d = timerDrag; timerDrag = null; if (d && !d.moved) timerPause(); });
        }
        var t = st.timer, left = timerLeft(), m = Math.floor(Math.ceil(left) / 60), s = Math.ceil(left) % 60, f = t.total ? left / t.total : 0;
        var col = t.done ? '#FFFFFF' : left <= 30 ? '#FF8054' : '#3DD68C', C = 2 * Math.PI * 27;
        timerEl.hidden = false; timerEl.classList.toggle('is-done', !!t.done); timerEl.classList.toggle('is-paused', t.left !== null && !t.done);
        timerEl.innerHTML = t.done
          ? '<span class="wb-tmv num">0:00</span><span class="wb-tms">Time is up</span><button type="button" class="wb-oc" data-wbtm="more">+1 min</button><button type="button" class="wb-oc" data-wbtm="stop" aria-label="Close the timer">' + ICON.cross + '</button>'
          : '<svg class="wb-tmr" width="56" height="56" viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="27" class="bg"/><circle cx="32" cy="32" r="27" stroke="' + col + '" stroke-dasharray="' + (C * f).toFixed(1) + ' ' + C.toFixed(1) + '" transform="rotate(-90 32 32)"/></svg>' +
            '<span class="wb-tmw"><span class="wb-tmv num">' + m + ':' + ('0' + s).slice(-2) + '</span><span class="wb-tms">' + (t.left !== null ? 'Paused · tap to go on' : 'Tap to pause') + '</span></span>' +
            '<button type="button" class="wb-oc" data-wbtm="stop" aria-label="Close the timer">' + ICON.cross + '</button>';
        timerPlace();
      }
      function timerPlace() {
        if (!timerEl || timerEl.hidden) return;
        var a = st.timerAt, w = timerEl.offsetWidth, h = timerEl.offsetHeight;
        timerEl.style.left = Math.round(a ? clamp(a.x * W, 8, W - w - 8) : W - w - 16) + 'px';
        timerEl.style.top = Math.round(a ? clamp(a.y * H, 8, H - h - 8) : 16) + 'px';
      }
      function timerPause() {
        var t = st.timer; if (!t || t.done) return;
        if (t.left === null) { t.left = timerLeft(); } else { t.end = Date.now() + t.left * 1000; t.left = null; }
        timerTick();
      }
      function timerAct(a) {
        var c = a.indexOf(':'), n = c >= 0 ? a.slice(0, c) : a, k = c >= 0 ? a.slice(c + 1) : '';
        if (n === 'go') { timerStart(Number(k)); return; }
        if (n === 'own') {
          var v = String((popEl.querySelector('.wb-tmin') || {}).value || '').trim(), mm = /^(\d{1,2})(?::(\d{1,2}))?$/.exec(v);
          if (!mm) { toast('Type a time like 4:30, or 7 for seven minutes'); return; }
          timerStart(Number(mm[1]) * 60 + Number(mm[2] || 0)); return;
        }
        if (n === 'more') { st.timer = { end: Date.now() + 60000, total: 60, left: null, done: false }; timerTick(); return; }
        if (n === 'stop') { clearTimeout(timerT); st.timer = null; timerDraw(); }
      }

      /* ---------- PEN FEEL (round 7, Aadam's pick 9) ----------
         Pressure: a stylus that reports how hard it presses (an iPad pencil, a smartboard pen) draws thicker where it
         presses harder and thin at the ends (each point keeps its p). Smoothing: the pen point eases towards the real one,
         Some or More, so a shaky line comes out clean. A mouse has no pressure; smoothing still works for it. */
      var SMOOTH = [1, 0.45, 0.25];
      function pressOf(e) { return e.pointerType === 'pen' && e.pressure > 0 ? Math.round(e.pressure * 100) / 100 : null; }
      function drawP(c, s, t) {
        /* a stroke with pressure: each piece its own width, round ends, so the joins never show */
        var q = s.pts, hex = inkHex(s, t);
        c.strokeStyle = hex; c.lineCap = 'round'; c.lineJoin = 'round';
        for (var i = 1; i < q.length; i++) {
          /* round 15 (Aadam: "sometimes the pen changes thickness whilst writing"): pressure moves the width 0.7x to 1.3x, not 0.35x to 1.75x */
          var pr = ((q[i - 1].p || 0.5) + (q[i].p || 0.5)) / 2;
          c.lineWidth = s.w * (0.7 + pr * 0.6); c.beginPath(); c.moveTo(q[i - 1].x, q[i - 1].y); c.lineTo(q[i].x, q[i].y); c.stroke();
        }
        if (q.length === 1) { c.fillStyle = hex; c.beginPath(); c.arc(q[0].x, q[0].y, s.w * 0.6, 0, 7); c.fill(); }
      }

      /* ---------- REPLAY (round 7, Aadam's pick 10) ----------
         Hold Undo, or the clock in the top bar: a slider over every step this page has been through (its undo history and
         now). Lines still to come show faintly; Play goes through them at an even pace; drawing while looking back carries
         on from that step, as Undo would; Back to now leaves it as it was. */
      var replayEl = null, rp = null, rpT = 0, undoHold = 0;
      function replayOpen() {
        var pg = page(); if (!pg.hist.length) { toast('Nothing to replay on this page yet'); return; }
        rp = { steps: pg.hist.map(function (h) { return h.ink; }).concat([pg.ink.slice()]), k: pg.hist.length, play: false };
        st.menu = null; drawPop(); replayDraw(); redraw();
      }
      function replayDraw() {
        if (!board) return;
        if (!rp) { if (replayEl) replayEl.hidden = true; return; }
        if (!replayEl) {
          replayEl = el('div', 'wb-replay'); board.insertBefore(replayEl, dockEl);
          replayEl.addEventListener('input', function (e) { if (e.target.classList.contains('wb-rpr')) { rpStop(); rp.k = Number(e.target.value); replayDraw(); redraw(); } });
        }
        var n = rp.steps.length - 1;
        replayEl.hidden = false;
        replayEl.innerHTML = '<button type="button" class="wb-b wb-rpplay" data-wbrp="' + (rp.play ? 'pause' : 'play') + '" aria-label="' + (rp.play ? 'Pause' : 'Play') + '">' + (rp.play ? '<svg class="ico" viewBox="0 0 24 24"><path d="M8 5v14M16 5v14"/></svg>' : '<svg class="ico" viewBox="0 0 24 24"><path d="M7 4l13 8-13 8z" fill="currentColor"/></svg>') + '</button>' +
          '<input type="range" class="wb-rpr" min="0" max="' + n + '" step="1" value="' + rp.k + '" aria-label="Step">' +
          '<span class="wb-rpn num">Step ' + rp.k + ' of ' + n + '</span><button type="button" class="wb-b wb-rpnow" data-wbrp="now">Back to now</button>';
        placeNear(replayEl);
      }
      function rpStop() { rp && (rp.play = false); clearTimeout(rpT); }
      function replayAct(a) {
        if (!rp) return;
        if (a === 'now') { rpStop(); rp = null; replayDraw(); redraw(); return; }
        if (a === 'pause') { rpStop(); replayDraw(); return; }
        if (a === 'play') {
          if (rp.k >= rp.steps.length - 1) rp.k = 0;
          rp.play = true; replayDraw();
          var tick = function () { if (!rp || !rp.play) return; if (rp.k >= rp.steps.length - 1) { rpStop(); replayDraw(); return; } rp.k++; replayDraw(); redraw(); rpT = setTimeout(tick, 650); };
          rpT = setTimeout(tick, 400);
        }
      }
      /* drawing while looking back: the board becomes that step, and the steps after it are gone, as with Undo */
      function replayCommit() {
        if (!rp) return;
        var pg = page(), k = rp.k, n = rp.steps.length - 1;
        rpStop();
        if (k < n) { pg.hist = pg.hist.slice(0, k + 1); var h = pg.hist.pop(); pg.ink = h.ink; pg.objs = JSON.parse(h.objs); pg.fut = []; }
        rp = null; replayDraw(); drawObjs(); redraw(); dirty();
      }

      /* ---------- things put on the board ---------- */
      function mkObj(type) {
        var n = page().objs.length, v = view(), o = { id: 'w' + Date.now().toString(36) + (++oid), type: type, x: Math.round(v.x + (120 + (n % 5) * 40) / v.z), y: Math.round(v.y + (200 + (n % 5) * 40) / v.z), s: Math.round(100 / v.z) / 100 };
        if (type === 'nl') { o.n = 11; o.step = 1; o.start = 0; o.f = 0; o.d = 1; o.jumps = 2; o.js = 1; }
        if (type === 'bar') { o.rows = [['', '', '']]; o.total = ''; }
        if (type === 'grid') { o.R = 2; o.C = 2; o.cells = {}; }
        if (type === 'tbl') { o.R = 3; o.C = 3; o.cells = {}; }
        if (type === 'ax') { o.r = 5; }
        return o;
      }
      function nlFit(o) {
        var end = o.f + o.d * o.jumps * o.js;
        if (end > o.n - 1) o.n = end + 1;
        if (end < 0) { o.start -= -end * o.step; o.f += -end; o.n += -end; }
        if (o.n > 41) { o.n = 41; while (o.jumps > 0 && (o.f + o.d * o.jumps * o.js > o.n - 1 || o.f + o.d * o.jumps * o.js < 0)) o.jumps--; }
        return o;
      }
      function ctl(act, label, inner) { return '<button type="button" class="wb-oc" data-oc="' + act + '" aria-label="' + label + '" data-tip="' + label + '">' + inner + '</button>'; }
      function grp(icon, tip, body) { return '<span class="wb-og" data-tip="' + tip + '">' + icon + body + '</span>'; }
      function inBox(k, v) { return '<input class="wb-in" data-in="' + k + '" value="' + esc(v || '') + '" aria-label="Type here" autocomplete="off" spellcheck="false">'; }
      function objBody(o) {
        var h = '', k, j;
        if (o.type === 'nl') {
          var g = Math.min(64, Math.floor(1100 / (o.n - 1))), Wd = (o.n - 1) * g, small = g < 44;
          h = '<div class="wbo-nl" style="width:' + (Wd + 40) + 'px">';
          for (j = 0; j < o.jumps; j++) {
            var a = o.f + o.d * j * o.js, b = o.f + o.d * (j + 1) * o.js, L = 20 + Math.min(a, b) * g, w = o.js * g;
            h += '<span class="wbo-arc" style="left:' + L + 'px;width:' + w + 'px"></span><span class="wbo-jl" style="left:' + L + 'px;width:' + w + 'px">' + (o.d > 0 ? '+' : MINUS) + fmt(o.js * o.step).replace(MINUS, '') + '</span>';
          }
          h += '<span class="wbo-line" style="width:' + Wd + 'px"></span>';
          for (k = 0; k < o.n; k++) h += '<span class="wbo-tk" style="left:' + (20 + k * g - 1.5) + 'px"></span><span class="wbo-tl' + (small ? ' sm' : '') + '" style="left:' + (20 + k * g - 32) + 'px">' + fmt(o.start + k * o.step) + '</span>';
          return h + '</div>';
        }
        if (o.type === 'bar') {
          h = '<div class="wbo-bar">' + o.rows.map(function (parts, r) {
            return '<div class="wbo-brow"><div class="wbo-bparts">' + parts.map(function (v, p) { return '<span class="wbo-bp">' + inBox('b' + r + ',' + p, v) + '</span>'; }).join('') + '</div>' +
              (st.sel === o.id ? '<span class="wbo-rowctl">' + ctl('pminus:' + r, 'One less part', ICON.minus) + ctl('pplus:' + r, 'One more part', ICON.plus) + '</span>' : '') + '</div>';
          }).join('');
          return h + '<span class="wbo-brace"></span><span class="wbo-total">' + inBox('t', o.total) + '</span></div>';
        }
        if (o.type === 'grid' || o.type === 'tbl') {
          var tb = o.type === 'tbl', R = o.R + (tb ? 0 : 1), C = o.C + (tb ? 0 : 1);
          h = '<div class="wbo-grid' + (tb ? ' is-tbl' : '') + '" style="grid-template-columns:repeat(' + C + ',112px)">';
          for (var r = 0; r < R; r++) for (var c = 0; c < C; c++) {
            var head = tb ? r === 0 : (r === 0 || c === 0);
            h += '<span class="wbo-cell' + (head ? ' is-head' : '') + '">' + (!tb && !r && !c ? '<b class="wbo-x">×</b>' : inBox('c' + r + ',' + c, (o.cells || {})[r + ',' + c])) + '</span>';
          }
          return h + '</div>';
        }
        if (o.type === 'img') {
          /* round 5: never an empty div, or the theme's div:empty rule folds the picture's frame to nothing and Select
             cannot find it (Aadam: "should be able to select images and drag them") */
          return '<div class="wbo-imgw" style="width:' + o.w + 'px;height:' + o.h + 'px"><span></span></div>';
        }
        if (o.type === 'txt') return '<div class="wbo-txt" style="font-size:' + (o.fs | 0) + 'px;color:' + (/^#[0-9a-f]{6}$/i.test(o.hx) ? o.hx : 'var(--wb-ink)') + '">' + mathHTML(o.t) + '</div>';
        if (o.type === 'graph') return graphBody(o);
        if (o.type === 'stamp') return stampBody(o);
        if (o.type === 'q') {
          var qsk = SL.get(o.sk);
          return '<div class="wbo-q"><div class="wbo-ql">' + esc(qsk ? qsk.name : 'Question') + ' · Level ' + (o.lv | 0) + '</div><div class="wbo-qq sl-expr">' + (o.qh || '') + '</div>' +
            (o.peek ? '<div class="wbo-qa sl-expr">' + (o.ah || '') + '</div>' : '') + '</div>';
        }
        if (o.type === 'calc') return '<div class="wbo-calc sl-expr">' + calcNodes(o.ex, 0) + '<span class="wbo-ceq">=</span>' + calcNodes(o.res, 0) + '</div>';
        if (o.type === 'ax') {
          var cell = Math.min(34, Math.floor(560 / (2 * o.r))), Sz = 2 * o.r * cell;
          h = '<div class="wbo-ax" style="width:' + Sz + 'px;height:' + Sz + 'px;background-size:' + cell + 'px ' + cell + 'px">' +
            '<span class="wbo-xa" style="top:' + (Sz / 2 - 1.5) + 'px"></span><span class="wbo-ya" style="left:' + (Sz / 2 - 1.5) + 'px"></span>';
          for (k = -o.r; k <= o.r; k++) {
            if (!k || Math.abs(k) === o.r) continue;
            h += '<span class="wbo-al" style="left:' + ((k + o.r) * cell - 15) + 'px;top:' + (Sz / 2 + 6) + 'px">' + fmt(k) + '</span>' +
                 '<span class="wbo-al" style="left:' + (Sz / 2 - 36) + 'px;top:' + ((o.r - k) * cell - 9) + 'px">' + fmt(k) + '</span>';
          }
          return h + '<span class="wbo-al wbo-an" style="left:' + (Sz - 26) + 'px;top:' + (Sz / 2 - 30) + 'px">x</span><span class="wbo-al wbo-an" style="left:' + (Sz / 2 + 8) + 'px;top:0">y</span></div>';
        }
        return '';
      }
      function objCtl(o) {
        var h = '';
        if (o.type === 'nl') h = grp(I.jumps, 'Jumps', ctl('jminus', 'One less jump', ICON.minus) + '<span class="wb-val num">' + o.jumps + '</span>' + ctl('jplus', 'One more jump', ICON.plus)) +
          grp(I.jsize, 'Size of each jump', ctl('sminus', 'Smaller jumps', ICON.minus) + '<span class="wb-val num">' + fmt(o.js * o.step) + '</span>' + ctl('splus', 'Bigger jumps', ICON.plus)) +
          ctl('flip', 'Jump the other way', I.flip) +
          grp('<span class="wb-dotj"></span>', 'Where the jumps start', ctl('fl', 'Start the jumps further left', ICON.chevL) + ctl('fr', 'Start the jumps further right', ICON.chevR)) +
          grp('', 'Numbers on the line', ctl('nl', 'Numbers down', ICON.chevL) + '<span class="wb-val num">' + fmt(o.start) + '</span>' + ctl('nr', 'Numbers up', ICON.chevR)) +
          ctl('gap', 'Gap between the numbers', '<span class="num">' + fmt(o.step) + '</span>') +
          grp(I.len, 'Length of the line', ctl('lminus', 'Shorter line', ICON.minus) + ctl('lplus', 'Longer line', ICON.plus));
        if (o.type === 'bar') h = grp(I.bars, 'Bars', ctl('rminus', 'One less bar', ICON.minus) + ctl('rplus', 'One more bar', ICON.plus));
        if (o.type === 'grid' || o.type === 'tbl') h = grp(I.cols, 'Columns', ctl('cminus', 'One less column', ICON.minus) + ctl('cplus', 'One more column', ICON.plus)) +
          grp(I.rows, 'Rows', ctl('rminus', 'One less row', ICON.minus) + ctl('rplus', 'One more row', ICON.plus));
        if (o.type === 'img') h = ctl('fit', 'Fit it to the board', I.fitb) + ctl('lock', o.lock ? 'Unlock it' : 'Lock it in place', o.lock ? I.unlock : I.lock);
        if (o.type === 'calc') return '<div class="wb-ctl">' + ctl('dup', 'Copy it', I.copy) + ctl('del', 'Take it off the board', I.trash) + '</div>';
        if (o.type === 'txt') h = ctl('edit', 'Change the words', I.text);
        if (o.type === 'stamp') h = ctl('sm', 'Smaller', ICON.minus) + ctl('sp', 'Bigger', ICON.plus) + '<span class="wb-dv"></span>' + ctl('rl', 'Turn it left', '<svg class="ico" viewBox="0 0 24 24"><path d="M4 11a8 8 0 1 1 2.3 5.7"/><path d="M4 5v6h6"/></svg>') + '<span class="wb-val num">' + (o.r | 0) + '°</span>' + ctl('rr', 'Turn it right', '<svg class="ico" viewBox="0 0 24 24"><path d="M20 11a8 8 0 1 0-2.3 5.7"/><path d="M20 5v6h-6"/></svg>');
        if (o.type === 'graph') h = grp('<span class="wb-val num">x</span>', 'How much of x', ctl('gxm', 'Less of x', ICON.minus) + '<span class="wb-val num">' + nice(o.x0) + ' to ' + nice(o.x1) + '</span>' + ctl('gxp', 'More of x', ICON.plus)) +
          ctl('table', o.table ? 'Hide the table' : 'Table of values', I.rows) + (o.hide ? ctl('show', 'Draw the lines', I.line) : '') +
          '<input class="wb-in wb-gin" placeholder="Add a line: y = ..." aria-label="Add a line" autocomplete="off" spellcheck="false">';
        if (o.type === 'q') h = ctl('peek', o.peek ? 'Hide the answer' : 'Show the answer', ICON.eye) + ctl('fresh', 'New question, same level', ICON.refresh);
        if (o.type === 'ax') h = grp(I.axes, 'Size of the axes', ctl('aminus', 'Smaller', ICON.minus) + '<span class="wb-val num">' + o.r + '</span>' + ctl('aplus', 'Bigger', ICON.plus));
        return '<div class="wb-ctl">' + h + '<span class="wb-dv"></span>' + ctl('turn', 'Turn it 90°', I.turn) + ctl('dup', 'Copy it', I.copy) + ctl('del', 'Take it off the board', I.trash) + '</div>';
      }
      function objHTML(o) {
        return '<div class="wb-obj' + (st.sel === o.id ? ' is-sel' : '') + (o.lock ? ' is-lock' : '') + (o.type === 'img' ? ' is-img' : '') + '" data-id="' + o.id + '"' + (o.rt ? ' data-rt="' + o.rt + '"' : '') + ' style="left:' + o.x + 'px;top:' + o.y + 'px;--s:' + o.s + '">' +
          '<div class="wb-objin">' + objBody(o) + '</div>' +
          /* round 13: a picture that is picked moves from anywhere on it, not only by its tab; a tap on it puts it down */
          (o.type === 'img' && st.sel === o.id && !o.lock ? '<div class="wb-pmove" data-grip="' + o.id + '" aria-hidden="true" style="display:block;position:absolute;inset:0;z-index:1;pointer-events:auto;touch-action:none;cursor:move"></div>' : '') +
          '<button type="button" class="wb-grip" data-grip="' + o.id + '" aria-label="Move, or tap to change it" data-tip="Move, or tap to change it"><span></span></button>' +
          '<button type="button" class="wb-size wb-nub" data-size="' + o.id + '" aria-label="Make it bigger or smaller" data-tip="Pull to resize">' + I.nub + '</button>' +
          (st.sel === o.id ? objCtl(o) : '') + '</div>';
      }
      /* PICTURES (round 4, Aadam: "be able to paste in images"): the picture sits UNDER the ink so the pen writes on it;
         its frame, tab and corner sit with the diagrams above, and the picture follows its frame */
      function drawObjs() {
        var pg = page();
        objsEl.innerHTML = pg.objs.map(objHTML).join('');
        Array.prototype.forEach.call(objsEl.children, function (box) { var o = findObj(box.getAttribute('data-id')); if (o) sizeBox(box, box.firstChild, o.s, o.rt || 0); });
        if (picsEl) picsEl.innerHTML = pg.objs.filter(function (o) { return o.type === 'img'; }).map(function (o) {
          var src = pg.imgs[o.ref] || '';
          return '<div class="wb-pic" data-pic="' + o.id + '" style="left:' + o.x + 'px;top:' + o.y + 'px;width:' + Math.round(o.w * o.s) + 'px;height:' + Math.round(o.h * o.s) + 'px">' + (/^data:image\/[a-z+]+;base64,[A-Za-z0-9+\/=]+$/.test(src) ? '<img src="' + src + '" alt="" draggable="false">' : '') + '</div>';
        }).join('');
        if (picsEl) Array.prototype.forEach.call(objsEl.children, function (box) { if (box.hasAttribute('data-rt')) picFollow(box); });
        miniSoon();
      }
      function picFollow(box) {
        if (!picsEl || !box || !box.classList.contains('is-img')) return;
        var pc = picsEl.querySelector('[data-pic="' + box.getAttribute('data-id') + '"]'); if (!pc) return;
        var rt = Number(box.getAttribute('data-rt')) || 0;
        if (!rt) { pc.style.left = box.style.left; pc.style.top = box.style.top; pc.style.width = box.offsetWidth + 'px'; pc.style.height = box.offsetHeight + 'px'; pc.style.rotate = ''; }
        else {
          /* a turned picture: its own size, centred in the turned box, turned the same way */
          var s = parseFloat(box.style.getPropertyValue('--s')) || 1, w = box.firstChild.offsetWidth * s, h = box.firstChild.offsetHeight * s;
          pc.style.width = w + 'px'; pc.style.height = h + 'px'; pc.style.left = (box.offsetLeft + (box.offsetWidth - w) / 2) + 'px'; pc.style.top = (box.offsetTop + (box.offsetHeight - h) / 2) + 'px'; pc.style.rotate = rt + 'deg';
        }
        pc.classList.toggle('is-spring', box.classList.contains('is-spring'));
      }
      function findObj(id) { var a = page().objs; for (var k = 0; k < a.length; k++) if (a[k].id === id) return a[k]; return null; }
      function opObj(o, act) {
        var ix = act.indexOf(':'), arg = ix >= 0 ? Number(act.slice(ix + 1)) : 0; act = ix >= 0 ? act.slice(0, ix) : act;
        var p = page();
        if (act === 'del') { snap(); p.objs = p.objs.filter(function (x) { return x !== o; }); st.sel = null; return true; }
        if (act === 'turn') {
          /* round 11: a quarter turn about its own middle */
          var tbx = objsEl.querySelector('[data-id="' + o.id + '"]'); if (!tbx) return false;
          snap(); var np = objPlace(o, tbx, { dx: 0, dy: 0, f: 1, ox: 0, oy: 0, a: Math.PI / 2, cx: o.x + tbx.offsetWidth / 2, cy: o.y + tbx.offsetHeight / 2 });
          o.x = Math.round(np.x); o.y = Math.round(np.y); if (np.rt) o.rt = np.rt; else delete o.rt; return true;
        }
        if (act === 'dup') { snap(); var c = JSON.parse(JSON.stringify(o)); c.id = 'w' + Date.now().toString(36) + (++oid); c.x += 40; c.y += 40; p.objs.push(c); st.sel = c.id; return true; }
        if (o.type === 'txt') { if (act === 'edit') { st.sel = null; editText(o); } return false; }
        if (o.type === 'stamp' && (act === 'sm' || act === 'sp')) { snap(); o.s = Math.round(clamp(o.s * (act === 'sp' ? 1.25 : 0.8), 0.2, 12) * 100) / 100; return true; }
        if (o.type === 'stamp') { snap(); o.r = (((o.r || 0) + (act === 'rr' ? 15 : act === 'rl' ? -15 : 0)) % 360 + 360) % 360; if (o.r > 180) o.r -= 360; return true; }
        if (o.type === 'graph') {
          snap();
          if (act === 'gxm' && o.x1 - o.x0 > 2) { o.x0 += 1; o.x1 -= 1; }
          else if (act === 'gxp' && o.x1 - o.x0 < 60) { o.x0 -= 1; o.x1 += 1; }
          else if (act === 'table') o.table = !o.table;
          else if (act === 'show') o.hide = false;
          return true;
        }
        if (o.type === 'q') {
          if (act === 'peek') { snap(); o.peek = !o.peek; return true; }
          if (act === 'fresh') { qFresh(o, function () { drawObjs(); drawPick(); dirty(); }); return false; }
          return false;
        }
        snap();
        if (o.type === 'img') {
          if (act === 'lock') o.lock = !o.lock;
          else if (act === 'fit') { var fv = view(), fs = Math.min((W - 60) / o.w, (H - (dockEl ? dockEl.offsetHeight + 60 : 140)) / o.h) / fv.z; o.s = Math.round(clamp(fs, 0.05, 40) * 100) / 100; o.x = Math.round(fv.x + Math.max(0, (W / fv.z - o.w * o.s) / 2)); o.y = Math.round(fv.y + 20 / fv.z); }
          return true;
        }
        if (o.type === 'nl') {
          if (act === 'jplus') o.jumps++;
          else if (act === 'jminus') o.jumps = Math.max(0, o.jumps - 1);
          else if (act === 'splus') o.js++;
          else if (act === 'sminus') o.js = Math.max(1, o.js - 1);
          else if (act === 'flip') o.d = -o.d;
          else if (act === 'fl') o.f = Math.max(0, o.f - 1);
          else if (act === 'fr') o.f = Math.min(o.n - 1, o.f + 1);
          else if (act === 'nl') o.start -= o.step;
          else if (act === 'nr') o.start += o.step;
          else if (act === 'gap') { var a0 = o.start / o.step; o.step = STEPS[(STEPS.indexOf(o.step) + 1) % STEPS.length]; o.start = Math.round(a0) * o.step; }
          else if (act === 'lplus') o.n = Math.min(41, o.n + 1);
          else if (act === 'lminus') { o.n = Math.max(3, o.n - 1); o.f = Math.min(o.f, o.n - 1); while (o.jumps > 0) { var e = o.f + o.d * o.jumps * o.js; if (e >= 0 && e <= o.n - 1) break; o.jumps--; } }
          nlFit(o);
        } else if (o.type === 'bar') {
          if (act === 'pplus' && o.rows[arg].length < 12) o.rows[arg].push('');
          else if (act === 'pminus' && o.rows[arg].length > 1) o.rows[arg].pop();
          else if (act === 'rplus' && o.rows.length < 5) o.rows.push(['', '']);
          else if (act === 'rminus' && o.rows.length > 1) o.rows.pop();
        } else if (o.type === 'grid' || o.type === 'tbl') {
          if (act === 'cplus') o.C = Math.min(8, o.C + 1);
          else if (act === 'cminus') o.C = Math.max(1, o.C - 1);
          else if (act === 'rplus') o.R = Math.min(8, o.R + 1);
          else if (act === 'rminus') o.R = Math.max(1, o.R - 1);
        } else if (o.type === 'ax') {
          if (act === 'aplus') o.r = Math.min(12, o.r + 1);
          else if (act === 'aminus') o.r = Math.max(2, o.r - 1);
        }
        return true;
      }
      function onInput(e) {
        var t = e.target, k = t && t.getAttribute && t.getAttribute('data-in');
        if (t && t.classList && t.classList.contains('wb-hexin')) {
          var hv = t.value.trim(); if (hv.charAt(0) !== '#') hv = '#' + hv;
          if (/^#[0-9a-f]{6}$/i.test(hv)) { hsv = hexHsv(hv); cpPaint(); }
          return;
        }
        if (t && t.classList && t.classList.contains('wb-tmchk')) { st.chime = !!t.checked; keep(); return; }
        if (t && t.classList && t.classList.contains('wb-aqsearch')) { aq.q = t.value; var ap = t.selectionStart; drawPop(); var an = popEl.querySelector('.wb-aqsearch'); if (an) { an.focus(); try { an.setSelectionRange(ap, ap); } catch (er) {} } return; }
        if (t && t.classList && t.classList.contains('wb-skq')) { st.skQ = t.value; var pos = t.selectionStart; drawPop(); var n = popEl.querySelector('.wb-skq'); if (n) { n.focus(); try { n.setSelectionRange(pos, pos); } catch (er) {} } return; }
        if (!k) return;
        var box = t.closest('.wb-obj'), o = box && findObj(box.getAttribute('data-id')); if (!o) return;
        var v = t.value;
        if (k === 't') o.total = v;
        else if (k.charAt(0) === 'b') { var rp = k.slice(1).split(','); o.rows[+rp[0]][+rp[1]] = v; }
        else if (k.charAt(0) === 'c') { o.cells = o.cells || {}; o.cells[k.slice(1)] = v; }
        sizeBox(box, box.firstChild, o.s); dirty();
      }

      /* ---------- ink ---------- */
      function fit() {
        if (!root || !st.open) return;
        var w = board.clientWidth, h = board.clientHeight; if (!w || !h) return;
        dpr = Math.min(2, window.devicePixelRatio || 1);
        [cvI, cvV, cvL].forEach(function (c) { var cw = Math.round(w * dpr), ch = Math.round(h * dpr); if (c.width !== cw || c.height !== ch) { c.width = cw; c.height = ch; } });
        var grew = Math.abs(w - W) > 40; W = w; H = h; redraw(); if (grew) drawCard(); applyDock(); placeMenus(); placeCalc(); drawZoom(); drawPick();
      }
      /* ENDLESS BOARD (round 5, Aadam: "in plain whiteboard mode make the board infinite so you can scroll around"): a blank
         board's page has a view (x, y = the world point at the board's top left, z = zoom). Ink, diagrams and pictures live in
         world units; pt() turns a pointer into world units, ptS() keeps it on the screen. A question board's view never moves. */
      var ZMIN = 0.1, ZMAX = 4, V1 = { x: 0, y: 0, z: 1 };
      /* round 15 (Aadam, 2026-11-03: "infinite whiteboard for all questions so you can scroll around and zoom out if you
         wanna"): every board is endless now, a question board too; the question card lives in world units like a diagram */
      function endless() { return !!item(); }
      function isBlankIt() { var it = item(); return !!(it && it.blank); }
      function viewHome() { var v = view(); return !v.x && !v.y && v.z === 1; }
      function cardView() {
        if (!cardEl) return;
        var v = view(), on = !viewHome(), L = parseFloat(cardEl.style.left) || 0, T = parseFloat(cardEl.style.top) || 0;
        cardEl.style.translate = on ? ((L - v.x) * v.z - L) + 'px ' + ((T - v.y) * v.z - T) + 'px' : '';
        cardEl.style.scale = on ? String(v.z) : '';
        cardEl.style.transformOrigin = on ? '0 0' : '';
      }
      function view() { if (!endless()) return V1; var p = page(); return p.view || (p.view = { x: 0, y: 0, z: 1 }); }
      function ptS(ev) { var r = board.getBoundingClientRect(), k = board.clientWidth / (r.width || 1); return { x: (ev.clientX - r.left) * k, y: (ev.clientY - r.top) * k }; }
      function pt(ev) { var q = ptS(ev), v = view(); return { x: q.x / v.z + v.x, y: q.y / v.z + v.y }; }
      function toScr(q) { var v = view(); return { x: (q.x - v.x) * v.z, y: (q.y - v.y) * v.z }; }
      function drawS(c, s, t) {
        var p = s.pts; if (!p.length) return;
        if (s.pr && s.k === 'pen' && !s.st) { drawP(c, s, t); return; }
        c.strokeStyle = s.k === 'hl' ? (s.hc !== undefined ? hlRgba(s.hc, t) : t.hl) : inkHex(s, t); c.lineWidth = s.k === 'hl' ? s.w * 2.5 + 14 : s.w;
        c.lineCap = 'round'; c.lineJoin = 'round'; c.beginPath(); c.moveTo(p[0].x, p[0].y);
        var q = p[p.length - 1];
        if (s.k === 'line' || s.k === 'arrow' || (s.st && p.length === 2) || p.length < 3) c.lineTo(q.x + 0.01, q.y + 0.01);
        else if (s.st) { for (var j = 1; j < p.length; j++) c.lineTo(p[j].x, p[j].y); }
        else { for (var i = 1; i < p.length - 1; i++) c.quadraticCurveTo(p[i].x, p[i].y, (p[i].x + p[i + 1].x) / 2, (p[i].y + p[i + 1].y) / 2); c.lineTo(q.x, q.y); }
        c.stroke();
        if (s.k === 'arrow' && p.length > 1) {
          var a = p[0], g = Math.atan2(q.y - a.y, q.x - a.x), L = 16 + s.w * 2.2;
          if (Math.hypot(q.x - a.x, q.y - a.y) > 4) { c.beginPath(); c.moveTo(q.x - L * Math.cos(g - 0.45), q.y - L * Math.sin(g - 0.45)); c.lineTo(q.x, q.y); c.lineTo(q.x - L * Math.cos(g + 0.45), q.y - L * Math.sin(g + 0.45)); c.stroke(); }
        }
      }
      function redraw() {
        if (!root || !W) return;
        /* round 15 (Aadam: "be able to write on the actual question"): cvI takes the pointer, cvV (over the card) shows the ink */
        var c = cvV.getContext('2d'), t = th(), pd = pickDrag, pk = st.pick, v = view(), hot = hotSet();
        c.setTransform(dpr, 0, 0, dpr, 0, 0); c.clearRect(0, 0, W, H);
        c.setTransform(dpr * v.z, 0, 0, dpr * v.z, -v.x * v.z * dpr, -v.y * v.z * dpr);
        /* what a select box is touching, and what is picked, sits on a soft halo so it is plain what will move */
        if (hot.length) { c.save(); c.globalAlpha = 0.5; hot.forEach(function (s) { if (!(pd && pk && pk.ink.indexOf(s) >= 0)) halo(c, s); }); c.restore(); }
        if (rp) {
          c.save(); c.globalAlpha = 0.14; page().ink.forEach(function (s) { drawS(c, s, t); }); c.restore();
          (rp.steps[rp.k] || []).forEach(function (s) { drawS(c, s, t); }); if (cur) drawS(c, cur, t); miniSoon(); return;
        }
        var vic = cur && cur.vic;
        page().ink.forEach(function (s) {
          if (vic && vic.indexOf(s) >= 0) { c.save(); c.globalAlpha = 0.28; drawS(c, s, t); c.restore(); return; }
          if (pd && pk && pk.ink.indexOf(s) >= 0) {
            if (pd.dup) drawS(c, s, t);
            c.save(); c.translate(pd.ox + pd.dx, pd.oy + pd.dy); c.scale(pd.f, pd.f); c.translate(-pd.ox, -pd.oy); drawS(c, s, t); c.restore();
          } else drawS(c, s, t);
        });
        if (cur) drawS(c, cur, t);
        miniSoon();
      }
      function halo(c, s) {
        var o = { k: s.k === 'hl' ? 'pen' : s.k, c: s.c, w: (s.k === 'hl' ? s.w * 2.5 + 14 : s.w) + 10 / view().z, pts: s.pts, h: '#5BAFD6' }; if (s.st) o.st = 1;
        drawS(c, o, th());
      }
      function hotSet() { return marqHot ? marqHot.ink : st.pick && !pickDrag ? st.pick.ink : []; }
      function segD(p, a, b) { var dx = b.x - a.x, dy = b.y - a.y, L = dx * dx + dy * dy, t = L ? clamp(((p.x - a.x) * dx + (p.y - a.y) * dy) / L, 0, 1) : 0; return Math.hypot(p.x - a.x - t * dx, p.y - a.y - t * dy); }
      function hit(s, p, pad) {
        var r = (pad === undefined ? 14 : pad) + (s.k === 'hl' ? s.w * 1.25 + 7 : s.w), q = s.pts;
        if (q.length === 1) return Math.hypot(p.x - q[0].x, p.y - q[0].y) < r;
        if (s.k === 'line' || s.k === 'arrow') return segD(p, q[0], q[q.length - 1]) < r;
        for (var i = 1; i < q.length; i++) if (segD(p, q[i - 1], q[i]) < r) return true;
        return false;
      }
      function eraseAt(p) {
        var pg = page(), pad = 14 / view().z, keepI = pg.ink.filter(function (s) { return !hit(s, p, pad); }), tx = txtHit(p);
        if (keepI.length === pg.ink.length && !tx) return;
        if (pend) { pg.hist.push(pend); pg.fut = []; pend = null; }
        pg.ink = keepI; if (tx) { pg.objs = pg.objs.filter(function (o) { return o !== tx; }); drawObjs(); } redraw();
      }
      function evs(e) { var l = e.getCoalescedEvents ? e.getCoalescedEvents() : null; return l && l.length ? l : [e]; }

      /* STRAIGHT (round 4, Aadam: "shift and draw - draws a straight line"): Shift with the pen, the highlighter, the line or
         the arrow draws a straight line from where it started, snapped every 15 degrees; a chip by the pen says the angle */
      var STEP15 = Math.PI / 12;
      function snapTo(a, p) { var dx = p.x - a.x, dy = p.y - a.y, g = Math.round(Math.atan2(dy, dx) / STEP15) * STEP15, L = Math.hypot(dx, dy); return { x: a.x + L * Math.cos(g), y: a.y + L * Math.sin(g), deg: Math.round(Math.abs(g * 180 / Math.PI)) }; }
      function showChip(p, deg) {
        if (!chipEl) return;
        var a = deg > 90 ? 180 - deg : deg, q = toScr(p);
        chipEl.innerHTML = '<b class="num">' + a + '°</b>';
        chipEl.hidden = false; chipEl.style.left = Math.round(Math.min(q.x + 22, W - chipEl.offsetWidth - 8)) + 'px'; chipEl.style.top = Math.round(Math.max(8, q.y - 58)) + 'px';
      }
      function hideChip() { if (chipEl) chipEl.hidden = true; }

      /* SNAP A SHAPE (round 4): draw a rough line, circle, triangle or four-sided shape and hold the pen still; it turns into
         a neat one. Read from the stroke: an open stroke close to its chord is a line; a closed one whose points sit at a
         nearly even distance from the middle is a circle (an ellipse if it is long), else its corners are found by
         Douglas-Peucker and three make a triangle, four a quadrilateral (a rectangle when its sides are near level) */
      var holdT = 0, holdAt = null;
      function rdp(pts, eps) {
        if (pts.length < 3) return pts.slice();
        var a = pts[0], b = pts[pts.length - 1], best = 0, at = 0;
        for (var i = 1; i < pts.length - 1; i++) { var d = segD(pts[i], a, b); if (d > best) { best = d; at = i; } }
        if (best <= eps) return [a, b];
        var l = rdp(pts.slice(0, at + 1), eps), r = rdp(pts.slice(at), eps);
        return l.slice(0, -1).concat(r);
      }
      function shapeOf(pts) {
        if (pts.length < 8) return null;
        var len = 0, i, minx = 1e9, miny = 1e9, maxx = -1e9, maxy = -1e9;
        for (i = 0; i < pts.length; i++) { var q = pts[i]; if (i) len += Math.hypot(q.x - pts[i - 1].x, q.y - pts[i - 1].y); minx = Math.min(minx, q.x); maxx = Math.max(maxx, q.x); miny = Math.min(miny, q.y); maxy = Math.max(maxy, q.y); }
        var D = Math.hypot(maxx - minx, maxy - miny); if (D < 30) return null;
        var a = pts[0], b = pts[pts.length - 1], gap = Math.hypot(b.x - a.x, b.y - a.y);
        if (gap > D * 0.3) {
          /* a line: the stroke barely longer than its chord and never far off it */
          var dev = 0; for (i = 1; i < pts.length - 1; i++) dev = Math.max(dev, segD(pts[i], a, b));
          if (len < gap * 1.08 && dev < Math.max(6, gap * 0.05)) return [a, b];
          /* ROUND 10: a circle left a little open (most of the way round) is still read as a closed shape */
          if (!(len > D * 2.2 && gap < D * 0.55)) return fitCurve(pts, D);
        }
        var cx = 0, cy = 0; pts.forEach(function (q) { cx += q.x; cy += q.y; }); cx /= pts.length; cy /= pts.length;
        var ds = pts.map(function (q) { return Math.hypot(q.x - cx, q.y - cy); }), mean = ds.reduce(function (s, v) { return s + v; }, 0) / ds.length;
        var sd = Math.sqrt(ds.reduce(function (s, v) { return s + (v - mean) * (v - mean); }, 0) / ds.length);
        var ring = pts.concat([a]), poly = rdp(ring, D * 0.07);
        if (poly.length > 2 && Math.hypot(poly[0].x - poly[poly.length - 1].x, poly[0].y - poly[poly.length - 1].y) < D * 0.12) poly.pop();
        /* corners closer together than a sixth of the shape are one corner */
        var cs = []; poly.forEach(function (q) { if (!cs.length || Math.hypot(q.x - cs[cs.length - 1].x, q.y - cs[cs.length - 1].y) > D / 6) cs.push(q); });
        if (cs.length > 3 && Math.hypot(cs[0].x - cs[cs.length - 1].x, cs[0].y - cs[cs.length - 1].y) < D / 6) cs.pop();
        /* ROUND 9 (10-24, Aadam: "doesn't recognise shapes enough like rectangles drawing a box around something"): a box
           fills nearly all of its tightest rectangle (a circle fills 79%, a triangle half), so that test comes first; a
           square used to read as a circle, its corners sit only ~11% further out than its sides */
        var hp = hull(ring).map(function (h) { return { x: h[0], y: h[1] }; });
        if (hp.length >= 3) {
          var ha = areaOf(hp), mr = rectOf(hp);
          var ov = mr && ovalOf(pts, mr, ha / mr.a); if (ov) return ov;
          if (mr && ha / mr.a > 0.86) return mr.level ? [{ x: minx, y: miny }, { x: maxx, y: miny }, { x: maxx, y: maxy }, { x: minx, y: maxy }, { x: minx, y: miny }] : mr.pts.concat([mr.pts[0]]);
          if (mr && ha / mr.a < 0.72 && hp.length <= 90) {
            var tb = 0, tp = null, i2, j2, k2;
            for (i2 = 0; i2 < hp.length; i2++) for (j2 = i2 + 1; j2 < hp.length; j2++) for (k2 = j2 + 1; k2 < hp.length; k2++) { var ta = areaOf([hp[i2], hp[j2], hp[k2]]); if (ta > tb) { tb = ta; tp = [hp[i2], hp[j2], hp[k2]]; } }
            if (tp && tb / ha > 0.8) return tidyTri(tp);
          }
        }
        if (sd / mean < 0.13 || cs.length > 5) {
          if (sd / mean > 0.2) return null;
          var rx = (maxx - minx) / 2, ry = (maxy - miny) / 2, ex = (minx + maxx) / 2, ey = (miny + maxy) / 2, out = [];
          if (Math.abs(rx - ry) < Math.max(rx, ry) * 0.18) rx = ry = (rx + ry) / 2;
          for (i = 0; i <= 72; i++) { var g = i / 72 * Math.PI * 2; out.push({ x: ex + rx * Math.cos(g), y: ey + ry * Math.sin(g) }); }
          return out;
        }
        if (cs.length === 3) return tidyTri(cs);
        if (cs.length === 4) {
          var lvl = true;
          for (i = 0; i < 4; i++) { var u = cs[i], v = cs[(i + 1) % 4], ang = Math.abs(Math.atan2(v.y - u.y, v.x - u.x)) % (Math.PI / 2); if (Math.min(ang, Math.PI / 2 - ang) > 0.2) lvl = false; }
          if (lvl) return [{ x: minx, y: miny }, { x: maxx, y: miny }, { x: maxx, y: maxy }, { x: minx, y: maxy }, { x: minx, y: miny }];
          return cs.concat([cs[0]]);
        }
        return null;
      }
      /* A curved line (Aadam 2026-11-02): an open stroke that bends smoothly becomes one
         clean curve, a cubic Bezier through its two ends, fitted by least squares over
         how far along the stroke each point sits. A sharp corner stays as drawn, and so
         does anything one curve cannot follow, like a wave or a zigzag. Under 80 units
         across it stays as drawn too, so a pause on a handwritten S or 2 never snaps. */
      function fitCurve(pts, D) {
        var n = pts.length, s = [0], i, j, L = 0;
        if (D < 80) return null;
        for (i = 1; i < n; i++) { L += Math.hypot(pts[i].x - pts[i - 1].x, pts[i].y - pts[i - 1].y); s.push(L); }
        if (!L) return null;
        /* a corner: the way the stroke heads turns sharply over a short stretch */
        var w = Math.max(14, L * .03), lo = 0, hi = 0;
        for (i = 0; i < n; i++) {
          while (s[i] - s[lo] > w) lo++;
          while (hi < n - 1 && s[hi] - s[i] < w) hi++;
          if (lo === i || hi === i) continue;
          var ax = pts[i].x - pts[lo].x, ay = pts[i].y - pts[lo].y, bx = pts[hi].x - pts[i].x, by = pts[hi].y - pts[i].y;
          if (Math.abs(Math.atan2(ax * by - ay * bx, ax * bx + ay * by)) > 1.1) return null;
        }
        var a = pts[0], b = pts[n - 1], t = s.map(function (v) { return v / L; }), P1, P2, fine, dev, r;
        /* each round places every point by the last curve, which tightens the fit */
        for (r = 0; r < 4; r++) {
          var c11 = 0, c12 = 0, c22 = 0, x1 = 0, x2 = 0, y1 = 0, y2 = 0;
          for (i = 0; i < n; i++) {
            var u = t[i], m = 1 - u, b0 = m * m * m, b1 = 3 * u * m * m, b2 = 3 * u * u * m, b3 = u * u * u;
            var rx = pts[i].x - b0 * a.x - b3 * b.x, ry = pts[i].y - b0 * a.y - b3 * b.y;
            c11 += b1 * b1; c12 += b1 * b2; c22 += b2 * b2; x1 += b1 * rx; x2 += b2 * rx; y1 += b1 * ry; y2 += b2 * ry;
          }
          var det = c11 * c22 - c12 * c12;
          if (Math.abs(det) < 1e-9) return null;
          P1 = { x: (x1 * c22 - x2 * c12) / det, y: (y1 * c22 - y2 * c12) / det };
          P2 = { x: (c11 * x2 - c12 * x1) / det, y: (c11 * y2 - c12 * y1) / det };
          fine = [];
          for (i = 0; i <= 192; i++) {
            var q = i / 192, g = 1 - q, e0 = g * g * g, e1 = 3 * q * g * g, e2 = 3 * q * q * g, e3 = q * q * q;
            fine.push({ x: e0 * a.x + e1 * P1.x + e2 * P2.x + e3 * b.x, y: e0 * a.y + e1 * P1.y + e2 * P2.y + e3 * b.y });
          }
          dev = 0;
          for (i = 0; i < n; i++) {
            var best = 1e9, at = 0;
            for (j = 0; j <= 192; j++) { var d = Math.hypot(pts[i].x - fine[j].x, pts[i].y - fine[j].y); if (d < best) { best = d; at = j; } }
            t[i] = at / 192; if (best > dev) dev = best;
          }
        }
        if (dev > Math.max(8, D * .03)) return null;
        var out = fine.filter(function (v, k) { return k % 4 === 0; });
        out.curve = true;
        return out;
      }
      /* ROUND 10 (Aadam: "doesn't recognise drawing ovals or circles easily"): an oval is read against the oval that fits its
         tightest rectangle, not by its distance from the middle (a long oval's points sit at very different distances, so
         only near-round circles ever snapped). It fills about 79% of that rectangle (a box nearer all of it, a triangle
         half), its points sit close to the fitted oval, and the stroke goes all the way round. Near round = a circle;
         within 12° of level = level. */
      function ovalOf(pts, mr, fill) {
        if (fill < 0.68 || fill > 0.87) return null;
        var r = mr.r, A = (r[1] - r[0]) / 2, B = (r[3] - r[2]) / 2, ca = (r[0] + r[1]) / 2, cb = (r[2] + r[3]) / 2;
        if (Math.min(A, B) < 8) return null;
        var dev = 0, bins = {}, i;
        for (i = 0; i < pts.length; i++) {
          var q = pts[i], pa = (q.x * mr.c + q.y * mr.s - ca) / A, pb = (-q.x * mr.s + q.y * mr.c - cb) / B;
          dev += Math.abs(Math.hypot(pa, pb) - 1); bins[Math.floor((Math.atan2(pb, pa) + Math.PI) / (Math.PI / 6)) % 12] = 1;
        }
        if (dev / pts.length > 0.1 || Object.keys(bins).length < 11) return null;
        var g = mr.g, m = ((g % (Math.PI / 2)) + Math.PI / 2) % (Math.PI / 2), out = [];
        if (A < B) { var t0 = A; A = B; B = t0; g += Math.PI / 2; }
        if (B > A * 0.84) A = B = (A + B) / 2;
        var cx = ca * mr.c - cb * mr.s, cy = ca * mr.s + cb * mr.c;
        if (A === B || Math.min(m, Math.PI / 2 - m) < 12 * Math.PI / 180) g = Math.round(g / (Math.PI / 2)) * (Math.PI / 2);
        var cg = Math.cos(g), sg = Math.sin(g);
        for (i = 0; i <= 72; i++) { var u = i / 72 * Math.PI * 2, ex = A * Math.cos(u), ey = B * Math.sin(u); out.push({ x: cx + ex * cg - ey * sg, y: cy + ex * sg + ey * cg }); }
        return out;
      }
      /* ROUND 10 (Aadam: "when drawing triangles make them flat on the bottom and right angled unless clearly not a right
         angled triangle"): the lowest side within 30° of level becomes level (the triangle turns about its middle), and a
         corner within 20° of square becomes exactly square. A square corner on the flat side stands its other side
         upright; a square top corner moves round the half circle on the flat side, so the flat side stays as drawn. */
      function tidyTri(t) {
        var p = t.map(function (q) { return { x: q.x, y: q.y }; }), i, cx = (p[0].x + p[1].x + p[2].x) / 3, cy = (p[0].y + p[1].y + p[2].y) / 3;
        var base = -1, low = -1e9, tilt = 0, lim = 30 * Math.PI / 180;
        for (i = 0; i < 3; i++) {
          var u = p[i], v = p[(i + 1) % 3], g = Math.atan2(v.y - u.y, v.x - u.x);
          if (g > Math.PI / 2) g -= Math.PI; else if (g < -Math.PI / 2) g += Math.PI;
          if (Math.abs(g) < lim && (u.y + v.y) / 2 > low) { low = (u.y + v.y) / 2; base = i; tilt = g; }
        }
        if (base >= 0) {
          var c = Math.cos(-tilt), s = Math.sin(-tilt);
          p = p.map(function (q) { var dx = q.x - cx, dy = q.y - cy; return { x: cx + dx * c - dy * s, y: cy + dx * s + dy * c }; });
          var by = (p[base].y + p[(base + 1) % 3].y) / 2; p[base].y = by; p[(base + 1) % 3].y = by;
        }
        var ang = function (k) { var o = p[k], a = p[(k + 1) % 3], b = p[(k + 2) % 3]; return Math.abs(Math.atan2((a.x - o.x) * (b.y - o.y) - (a.y - o.y) * (b.x - o.x), (a.x - o.x) * (b.x - o.x) + (a.y - o.y) * (b.y - o.y))); };
        var rk = -1, rd = 20 * Math.PI / 180;
        for (i = 0; i < 3; i++) { var d = Math.abs(ang(i) - Math.PI / 2); if (d < rd) { rd = d; rk = i; } }
        if (rk >= 0) {
          var o = p[rk], n1 = (rk + 1) % 3, n2 = (rk + 2) % 3, keep = n1, mv = n2;
          if (base >= 0 && rk !== base && rk !== (base + 1) % 3) {
            /* the square corner is the top one: on the half circle whose diameter is the flat side */
            var A = p[base], B = p[(base + 1) % 3], mx = (A.x + B.x) / 2, my = A.y, R = Math.abs(B.x - A.x) / 2, dd = Math.hypot(o.x - mx, o.y - my) || 1;
            o.x = mx + (o.x - mx) * R / dd; o.y = my + (o.y - my) * R / dd;
          } else {
            /* keep the side along the flat side (or the longer one) and turn the other side square to it */
            if (base >= 0) keep = (rk === base) ? (base + 1) % 3 : base;
            else if (Math.hypot(p[n2].x - o.x, p[n2].y - o.y) > Math.hypot(p[n1].x - o.x, p[n1].y - o.y)) { keep = n2; mv = n1; }
            mv = 3 - rk - keep;
            /* the moved corner keeps its height above the kept side */
            var kx = p[keep].x - o.x, ky = p[keep].y - o.y, kl = Math.hypot(kx, ky) || 1, nx = -ky / kl, ny = kx / kl, L = nx * (p[mv].x - o.x) + ny * (p[mv].y - o.y);
            if (L < 0) { nx = -nx; ny = -ny; L = -L; }
            p[mv] = { x: o.x + nx * L, y: o.y + ny * L };
          }
        }
        return p.concat([{ x: p[0].x, y: p[0].y }]);
      }
      function areaOf(q) { var A = 0; for (var i = 0; i < q.length; i++) { var u = q[i], v = q[(i + 1) % q.length]; A += u.x * v.y - v.x * u.y; } return Math.abs(A) / 2; }
      /* the tightest rectangle round a convex outline: one of its sides lies along one of the outline's edges */
      function rectOf(hp) {
        var best = null;
        for (var i = 0; i < hp.length; i++) {
          var u = hp[i], v = hp[(i + 1) % hp.length], g = Math.atan2(v.y - u.y, v.x - u.x), c = Math.cos(g), sn = Math.sin(g), a0 = 1e9, a1 = -1e9, b0 = 1e9, b1 = -1e9;
          if (Math.hypot(v.x - u.x, v.y - u.y) < 1) continue;
          hp.forEach(function (q) { var pa = q.x * c + q.y * sn, pb = -q.x * sn + q.y * c; a0 = Math.min(a0, pa); a1 = Math.max(a1, pa); b0 = Math.min(b0, pb); b1 = Math.max(b1, pb); });
          var A = (a1 - a0) * (b1 - b0);
          if (!best || A < best.a) best = { a: A, g: g, c: c, s: sn, r: [a0, a1, b0, b1] };
        }
        if (!best || best.a <= 0) return null;
        var bk = function (pa, pb) { return { x: pa * best.c - pb * best.s, y: pa * best.s + pb * best.c }; }, r = best.r, m = ((best.g % (Math.PI / 2)) + Math.PI / 2) % (Math.PI / 2);
        best.pts = [bk(r[0], r[2]), bk(r[1], r[2]), bk(r[1], r[3]), bk(r[0], r[3])];
        best.level = Math.min(m, Math.PI / 2 - m) < 9 * Math.PI / 180;
        return best;
      }
      function trySnapShape() {
        holdT = 0;
        if (!isDown || !cur || cur.k !== 'pen' || cur.st || cur.shaped) return;
        var sh = shapeOf(cur.pts); if (!sh) return;
        var raw = cur.pts.slice();
        cur.pts = sh; cur.shaped = true; cur.st = sh.length <= 5 ? 1 : 0; cur.vic = null;
        /* HOLD, THEN SIZE IT (round 5, Aadam: "increase, decrease size of shapes after drawing - not the final size - like in
           goodnotes"): with the pen still down the snapped shape stays live. A line's far end follows the pen; a box is
           drawn from its far corner to the pen; a circle or a triangle grows and shrinks round its middle or far corner. */
        var P0 = holdAt ? { x: holdAt.x, y: holdAt.y } : sh[sh.length - 1], A, kind;
        var far = function () { var b = sh[0], bd = -1; sh.forEach(function (q) { var d = Math.hypot(q.x - P0.x, q.y - P0.y); if (d > bd) { bd = d; b = q; } }); return { x: b.x, y: b.y }; };
        if (sh.curve) {
          var last = sh[sh.length - 1], atEnd = Math.hypot(last.x - P0.x, last.y - P0.y) <= Math.hypot(sh[0].x - P0.x, sh[0].y - P0.y);
          kind = 'curve'; A = atEnd ? sh[0] : last; P0 = atEnd ? last : sh[0];
        }
        else if (sh.length === 2) { kind = 'line'; A = Math.hypot(sh[0].x - P0.x, sh[0].y - P0.y) > Math.hypot(sh[1].x - P0.x, sh[1].y - P0.y) ? sh[0] : sh[1]; }
        else if (sh.length > 5) { kind = 'oval'; var cx = 0, cy = 0; sh.forEach(function (q) { cx += q.x; cy += q.y; }); A = { x: cx / sh.length, y: cy / sh.length }; }
        else if (sh.length === 5 && sh[0].y === sh[1].y && sh[1].x === sh[2].x) { kind = 'rect'; A = far(); }
        else { kind = 'poly'; A = far(); }
        cur.sz = { kind: kind, A: { x: A.x, y: A.y }, P0: P0, base: sh.map(function (q) { return { x: q.x, y: q.y }; }), raw: kind === 'line' || kind === 'curve' ? raw : null, n0: raw.length };
        redraw(); sizeChip(P0, 1);
        board.classList.remove('is-snap'); void board.offsetWidth; board.classList.add('is-snap');
      }
      /* round 15 (Aadam: "improve the curved lines holding"): a pause halfway along a curve snapped the half drawn so far,
         and the rest of the stroke only turned and stretched that half (a semicircle came out a shallow arc). Now the pen
         carries on: while the whole stroke as drawn is still one line or one smooth curve, that is what shows; a hook or a
         sharp turn after the pause falls back to turning and stretching the snapped shape. */
      function headsOn(r, n0, p) {
        var e = r[n0 - 1], k = n0 - 1, d = 0;
        while (k > 0 && d < 30) { d += Math.hypot(r[k].x - r[k - 1].x, r[k].y - r[k - 1].y); k--; }
        var ux = e.x - r[k].x, uy = e.y - r[k].y, vx = p.x - e.x, vy = p.y - e.y, m = Math.hypot(ux, uy) * Math.hypot(vx, vy);
        return m > 0 && (ux * vx + uy * vy) / m > 0.766;
      }
      function goOn(z, p) {
        if (z.go === false) return null;
        z.raw.push({ x: p.x, y: p.y });
        if (Math.hypot(p.x - z.P0.x, p.y - z.P0.y) < 12 / view().z) return null;
        /* carry on only if the pen leaves the pause the way the stroke was heading; a drag off to the side sizes it */
        if (z.go === undefined) z.go = headsOn(z.raw, z.n0, p);
        if (!z.go) return null;
        var r = z.raw, a = r[0], len = 0, dev = 0, i, x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9;
        for (i = 0; i < r.length; i++) { if (i) len += Math.hypot(r[i].x - r[i - 1].x, r[i].y - r[i - 1].y); x0 = Math.min(x0, r[i].x); x1 = Math.max(x1, r[i].x); y0 = Math.min(y0, r[i].y); y1 = Math.max(y1, r[i].y); }
        var gap = Math.hypot(p.x - a.x, p.y - a.y), D = Math.hypot(x1 - x0, y1 - y0);
        for (i = 1; i < r.length - 1; i++) dev = Math.max(dev, segD(r[i], a, p));
        if (len < gap * 1.08 && dev < Math.max(6, gap * 0.05)) return [{ x: a.x, y: a.y }, { x: p.x, y: p.y }];
        return gap > D * 0.3 ? fitCurve(r, D) : null;
      }
      function sizeShape(p) {
        var z = cur.sz, A = z.A, P0 = z.P0;
        if (z.raw) { var g = goOn(z, p); if (g) { cur.pts = g; cur.st = g.length <= 2 ? 1 : 0; hideChip(); return; } }
        if (z.kind === 'line') { cur.pts = [{ x: A.x, y: A.y }, p]; sizeChip(p, Math.hypot(p.x - A.x, p.y - A.y) / Math.max(1, Math.hypot(P0.x - A.x, P0.y - A.y))); return; }
        /* a curve turns and stretches from its far end to reach the pen */
        if (z.kind === 'curve') {
          var ux = P0.x - A.x, uy = P0.y - A.y, vx = p.x - A.x, vy = p.y - A.y, dd = ux * ux + uy * uy || 1, re = (ux * vx + uy * vy) / dd, im = (ux * vy - uy * vx) / dd;
          cur.pts = z.base.map(function (q) { var dx = q.x - A.x, dy = q.y - A.y; return { x: A.x + dx * re - dy * im, y: A.y + dx * im + dy * re }; });
          return;
        }
        if (z.kind === 'rect') {
          cur.pts = [{ x: A.x, y: A.y }, { x: p.x, y: A.y }, { x: p.x, y: p.y }, { x: A.x, y: p.y }, { x: A.x, y: A.y }];
          sizeChip(p, Math.hypot(p.x - A.x, p.y - A.y) / Math.max(1, Math.hypot(P0.x - A.x, P0.y - A.y))); return;
        }
        var f = clamp(Math.hypot(p.x - A.x, p.y - A.y) / Math.max(1, Math.hypot(P0.x - A.x, P0.y - A.y)), 0.15, 8);
        cur.pts = z.base.map(function (q) { return { x: A.x + (q.x - A.x) * f, y: A.y + (q.y - A.y) * f }; });
        sizeChip(p, f);
      }
      /* round 9 (Aadam: "don't need the messages like - move it to size it"): the shape sizing under the pen says it all */
      function sizeChip() { hideChip(); }

      /* FINGERS (round 4): on a touch screen a quick two-finger tap undoes and a three-finger tap redoes. ROUND 5: on an
         endless board two fingers that move drag the board and pinch it bigger or smaller */
      var touches = {}, tap = null, pinch = null;
      function touchDown(e) {
        touches[e.pointerId] = { x: e.clientX, y: e.clientY, x0: e.clientX, y0: e.clientY };
        var n = Object.keys(touches).length, now = Date.now();
        if (n === 1) { tap = { t: now, n: 1, moved: false }; return false; }
        if (n === 2 && endless()) {
          /* a stroke the first finger had just begun was the start of the gesture; a longer one is kept */
          if (cur) { if (cur.pts.length >= 12 && !rubbing) { var pg = page(); snap(pg); delete cur.shaped; delete cur.sz; delete cur.vic; pg.ink.push(cur); dirty(); } cur = null; isDown = false; clearTimeout(holdT); hideChip(); redraw(); }
          if (marq || pickDrag) { marq = null; marqHot = null; pickDrag = null; marqEl.hidden = true; drawObjs(); redraw(); drawPick(); }
          isDown = false; pend = null;
          pinch = pinchState();
        }
        if (tap && now - tap.t < 260) {
          tap.n = Math.max(tap.n, n);
          /* the first finger's dot of ink was the start of a tap, not a stroke */
          if (cur && cur.pts.length < 12) { cur = null; isDown = false; redraw(); }
          if (pend) pend = null;
          return true;
        }
        return !!pinch;
      }
      function pinchState() {
        var ids = Object.keys(touches); if (ids.length < 2) return null;
        var a = touches[ids[0]], b = touches[ids[1]], v = view(), br = board.getBoundingClientRect(), k = board.clientWidth / (br.width || 1);
        var c = { x: ((a.x + b.x) / 2 - br.left) * k, y: ((a.y + b.y) / 2 - br.top) * k };
        return { ids: ids.slice(0, 2), d: Math.max(10, Math.hypot(a.x - b.x, a.y - b.y)), z: v.z, w: { x: v.x + c.x / v.z, y: v.y + c.y / v.z } };
      }
      function touchMove(e) {
        var p = touches[e.pointerId]; if (!p) return false;
        p.x = e.clientX; p.y = e.clientY;
        if (tap && Math.hypot(p.x - p.x0, p.y - p.y0) > 14) tap.moved = true;
        if (!pinch || pinch.ids.indexOf(String(e.pointerId)) < 0) return !!pinch;
        var a = touches[pinch.ids[0]], b = touches[pinch.ids[1]]; if (!a || !b) return true;
        var br = board.getBoundingClientRect(), k = board.clientWidth / (br.width || 1);
        var c = { x: ((a.x + b.x) / 2 - br.left) * k, y: ((a.y + b.y) / 2 - br.top) * k };
        var z = clamp(pinch.z * Math.hypot(a.x - b.x, a.y - b.y) / pinch.d, ZMIN, ZMAX);
        setView(pinch.w.x - c.x / z, pinch.w.y - c.y / z, z);
        return true;
      }
      function touchUp(e) {
        if (!touches[e.pointerId]) return;
        delete touches[e.pointerId];
        if (pinch && Object.keys(touches).length < 2) { pinch = null; viewDone(); }
        if (Object.keys(touches).length || !tap) return;
        var tp = tap; tap = null;
        if (tp.n >= 2 && !tp.moved && Date.now() - tp.t < 450) undo(tp.n >= 3);
      }

      /* SELECT (round 4, Aadam: "select drag on whiteboard mode"): drag a box round ink and diagrams, then drag them; a tap
         on a line picks just that line, Shift adds to the pick; Alt as the drag starts leaves the original and moves a copy;
         the corner makes the pick bigger or smaller */
      var marq = null, marqHot = null, pickDrag = null, nudgeT = 0, clip = null;
      function objBoxes() { var out = []; if (objsEl) Array.prototype.forEach.call(objsEl.children, function (bx) { out.push({ id: bx.getAttribute('data-id'), x: bx.offsetLeft, y: bx.offsetTop, w: bx.offsetWidth, h: bx.offsetHeight, el: bx }); }); return out; }
      function strokeBox(s) {
        var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9, r = (s.k === 'hl' ? s.w * 1.25 + 7 : s.w / 2) + 2;
        s.pts.forEach(function (q) { x0 = Math.min(x0, q.x); y0 = Math.min(y0, q.y); x1 = Math.max(x1, q.x); y1 = Math.max(y1, q.y); });
        if (s.k === 'arrow') r += 12 + s.w;
        return { x0: x0 - r, y0: y0 - r, x1: x1 + r, y1: y1 + r };
      }
      function pickBox() {
        var pk = st.pick; if (!pk) return null;
        var b = { x0: 1e9, y0: 1e9, x1: -1e9, y1: -1e9 }, any = false;
        pk.ink.forEach(function (s) { var q = strokeBox(s); b.x0 = Math.min(b.x0, q.x0); b.y0 = Math.min(b.y0, q.y0); b.x1 = Math.max(b.x1, q.x1); b.y1 = Math.max(b.y1, q.y1); any = true; });
        objBoxes().forEach(function (o) { if (pk.objs.indexOf(o.id) >= 0) { b.x0 = Math.min(b.x0, o.x); b.y0 = Math.min(b.y0, o.y); b.x1 = Math.max(b.x1, o.x + o.w); b.y1 = Math.max(b.y1, o.y + o.h); any = true; } });
        return any ? b : null;
      }
      function inStroke(s, r) {
        var q = s.pts, k;
        for (k = 0; k < q.length; k++) if (q[k].x >= r.x0 && q[k].x <= r.x1 && q[k].y >= r.y0 && q[k].y <= r.y1) return true;
        for (k = 1; k < q.length; k++) for (var u = 0.1; u < 1; u += 0.1) { var x = q[k - 1].x + (q[k].x - q[k - 1].x) * u, y = q[k - 1].y + (q[k].y - q[k - 1].y) * u; if (x >= r.x0 && x <= r.x1 && y >= r.y0 && y <= r.y1) return true; }
        return false;
      }
      function setPick(pk) {
        if (pk && !pk.ink.length && !pk.objs.length) pk = null;
        st.pick = pk; drawPick(); if (W) redraw();
      }
      function pickCount() { var pk = st.pick; return pk ? pk.ink.length + pk.objs.length : 0; }
      function drawPick() {
        if (!selEl) return;
        var b = pickDrag && pickDrag.b || pickBox(), pko = st.pick ? st.pick.objs : [], hob = marqHot ? marqHot.objs : [];
        objBoxes().forEach(function (o) { o.el.classList.toggle('is-pick', pko.indexOf(o.id) >= 0 || hob.indexOf(o.id) >= 0); });
        if (!b || !st.open) { selEl.hidden = true; selEl.innerHTML = ''; return; }
        var pd = pickDrag, f = pd ? pd.f : 1, dx = pd ? pd.dx : 0, dy = pd ? pd.dy : 0, ox = pd ? pd.ox : b.x0, oy = pd ? pd.oy : b.y0;
        /* the frame and its bar are drawn on the screen, so they stay the same size at any zoom */
        var vz = view().z, tl = toScr({ x: ox + (b.x0 - ox) * f + dx, y: oy + (b.y0 - oy) * f + dy });
        var x0 = tl.x, y0 = tl.y, w = (b.x1 - b.x0) * f * vz, h = (b.y1 - b.y0) * f * vz;
        selEl.hidden = false; selEl.className = 'wb-selbox' + (pd ? ' is-drag' : '');
        selEl.style.left = Math.round(x0 - 10) + 'px'; selEl.style.top = Math.round(y0 - 10) + 'px'; selEl.style.width = Math.round(w + 20) + 'px'; selEl.style.height = Math.round(h + 20) + 'px';
        /* round 10: a pick under the open calculator keeps its frame, corner and bar in front of it (the bar sits ~50px above) */
        var ov = st.calc && calcEl && !calcEl.hidden && x0 - 10 < calcEl.offsetLeft + calcEl.offsetWidth && x0 + w + 10 > calcEl.offsetLeft && y0 - 64 < calcEl.offsetTop + calcEl.offsetHeight && y0 + h + 64 > calcEl.offsetTop;
        selEl.style.zIndex = ov ? '8' : '';
        selEl.style.rotate = pd && pd.a ? (pd.a * 180 / Math.PI) + 'deg' : '';
        if (pd) return;
        var n = pickCount(), t = th(), sw = '';
        for (var k = 0; k < NSLOT; k++) sw += '<button type="button" class="wb-pksw" data-wb="pickcol:' + k + '" style="background:' + slotHex(k, t) + '" aria-label="Make it ' + slotName(k, t) + '" data-tip="' + slotName(k, t) + '"></button>';
        selEl.innerHTML = '<span class="wb-pkh"></span><span class="wb-pkh"></span><span class="wb-pkh"></span>' +
          '<button type="button" class="wb-pkh wb-pksz" data-picksize="1" aria-label="Make it bigger or smaller" data-tip="Pull to resize"></button>' +
          /* ROUND 11: the round knob under the pick turns it (snaps to every 15° when near one); styled here, so no css push */
          '<button type="button" class="wb-pkh wb-pkturn" data-pickturn="1" aria-label="Turn it" data-tip="Drag to turn it" data-tipsub="Key: R for a quarter turn" style="' + (y0 < 70 ? 'right:-48px;top:calc(50% - 13px);left:auto;bottom:auto' : 'left:calc(50% - 13px);bottom:-48px;top:auto;right:auto') + ';width:26px;height:26px;border-radius:50%;pointer-events:auto;cursor:grab;touch-action:none;display:grid;place-items:center;color:var(--brand-lite)">' + I.turn + '</button>' +
          '<div class="wb-pkbar' + (y0 < 70 ? ' is-below' : '') + '"><span class="wb-pkn">' + n + ' picked</span>' +
            '<button type="button" class="wb-oc" data-wb="pickdup" aria-label="Copy" data-tip="Copy" data-tipsub="Ctrl D, or Alt and drag">' + I.copy + '</button>' +
            '<button type="button" class="wb-oc" data-wb="pickturn" aria-label="Turn a quarter turn" data-tip="Turn 90°" data-tipsub="Key: R (Shift R the other way)">' + I.turn + '</button>' +
            (st.pick.ink.length ? '<span class="wb-pksws">' + sw + '</span>' : '') +
            '<button type="button" class="wb-oc" data-wb="pickdel" aria-label="Delete" data-tip="Delete" data-tipsub="Key: Delete">' + I.trash + '</button></div>';
        /* round 11: the bar slides left to stay on the board when the pick is near the right edge */
        var pbar = selEl.querySelector('.wb-pkbar'), over = pbar ? (x0 - 10) + pbar.offsetWidth - (W - 8) : 0;
        if (over > 0) pbar.style.left = -Math.min(over, Math.max(0, x0 - 18)) + 'px';
        var knob = selEl.querySelector('.wb-pkturn'); if (knob) knob.querySelector('svg').style.cssText = 'width:16px;height:16px';
      }
      function selBarDown(e) {
        var tk = e.target.closest ? e.target.closest('[data-pickturn]') : null;
        if (tk) {
          e.preventDefault(); e.stopPropagation(); hideTip();
          var tb = pickBox(); if (!tb) return;
          try { tk.setPointerCapture(e.pointerId); } catch (er) {}
          var c = { x: (tb.x0 + tb.x1) / 2, y: (tb.y0 + tb.y1) / 2 }, p0 = pt(e);
          pickDrag = { dx: 0, dy: 0, f: 1, ox: tb.x0, oy: tb.y0, a: 0, cx: c.x, cy: c.y, a0: Math.atan2(p0.y - c.y, p0.x - c.x), turn: true, moved: false, b: tb };
          tk.addEventListener('pointermove', pickTurnMove); tk.addEventListener('pointerup', pickTurnUp); tk.addEventListener('pointercancel', pickTurnUp);
          return;
        }
        var t = e.target.closest ? e.target.closest('[data-picksize]') : null;
        if (!t) { e.stopPropagation(); return; }
        e.preventDefault(); e.stopPropagation();
        var b = pickBox(); if (!b) return;
        try { t.setPointerCapture(e.pointerId); } catch (er) {}
        pickDrag = { p: pt(e), dx: 0, dy: 0, f: 1, ox: b.x0, oy: b.y0, w: Math.max(20, b.x1 - b.x0), h: Math.max(20, b.y1 - b.y0), size: true, moved: false };
        t.addEventListener('pointermove', pickSizeMove); t.addEventListener('pointerup', pickSizeUp); t.addEventListener('pointercancel', pickSizeUp);
      }
      function pickTurnMove(e) {
        var pd = pickDrag; if (!pd || !pd.turn) return;
        var p = pt(e), a = Math.atan2(p.y - pd.cy, p.x - pd.cx) - pd.a0, st15 = Math.PI / 12;
        a = Math.atan2(Math.sin(a), Math.cos(a));
        if (e.shiftKey || Math.abs(a - Math.round(a / st15) * st15) < 3 * Math.PI / 180) a = Math.round(a / st15) * st15;
        pd.a = a; pd.moved = Math.abs(a) > 0.001; pickLive();
      }
      function pickTurnUp(e) {
        var t = e.currentTarget; t.removeEventListener('pointermove', pickTurnMove); t.removeEventListener('pointerup', pickTurnUp); t.removeEventListener('pointercancel', pickTurnUp);
        endPickDrag();
      }
      function pickSizeMove(e) { if (!pickDrag) return; var p = pt(e); pickDrag.f = clamp((pickDrag.w + Math.max(p.x - pickDrag.p.x, (p.y - pickDrag.p.y) * pickDrag.w / pickDrag.h)) / pickDrag.w, 0.2, 6); pickDrag.moved = true; pickLive(); }
      function pickSizeUp(e) {
        var t = e.currentTarget; t.removeEventListener('pointermove', pickSizeMove); t.removeEventListener('pointerup', pickSizeUp); t.removeEventListener('pointercancel', pickSizeUp);
        endPickDrag();
      }
      /* while a pick is dragged the ink is drawn moved and the diagrams' boxes are moved; nothing is written until it lets go */
      function pickLive() {
        var pd = pickDrag, pk = st.pick; if (!pd || !pk) return;
        objBoxes().forEach(function (o) {
          if (pk.objs.indexOf(o.id) < 0) return;
          var ob = findObj(o.id); if (!ob) return;
          var np = objPlace(ob, o.el, pd);
          o.el.style.left = Math.round(np.x) + 'px'; o.el.style.top = Math.round(np.y) + 'px';
          if (pd.f !== 1 || pd.a) { o.el.style.setProperty('--s', np.s); sizeBox(o.el, o.el.firstChild, np.s, np.rt); }
          picFollow(o.el);
        });
        redraw(); drawPick();
      }
      /* a point of the pick as it is moved, sized about (ox, oy), and (round 11) turned by a about (cx, cy) */
      function xfPt(q, pd) {
        var x = pd.ox + (q.x - pd.ox) * pd.f + pd.dx, y = pd.oy + (q.y - pd.oy) * pd.f + pd.dy;
        if (!pd.a) return { x: x, y: y };
        var c = Math.cos(pd.a), sn = Math.sin(pd.a), u = x - pd.cx, v = y - pd.cy;
        return { x: pd.cx + u * c - v * sn, y: pd.cy + u * sn + v * c };
      }
      /* where a diagram or picture lands: its middle follows the pick, its box is round its turned shape */
      function objPlace(ob, box, pd) {
        var s0 = ob.s || 1, w = box.firstChild.offsetWidth * s0, h = box.firstChild.offsetHeight * s0, d0 = turned(w, h, ob.rt || 0);
        var c = xfPt({ x: ob.x + d0.W / 2, y: ob.y + d0.H / 2 }, pd), rt = ob.rt || 0;
        if (pd.a) { rt = Math.round(((rt + pd.a * 180 / Math.PI) % 360 + 360) % 360 * 10) / 10; if (rt > 180) rt -= 360; if (Math.abs(rt) < 0.05) rt = 0; }
        var d1 = turned(w * pd.f, h * pd.f, rt);
        return { x: c.x - d1.W / 2, y: c.y - d1.H / 2, s: s0 * pd.f, rt: rt };
      }
      function movedStroke(s, pd) {
        var o = { k: s.k, c: s.c, w: Math.max(1, Math.round(s.w * (pd.f > 1 ? Math.min(pd.f, 2) : pd.f) * 10) / 10), pts: s.pts.map(function (q) { var n = xfPt(q, pd); if (q.p !== undefined) n.p = q.p; return n; }) };
        if (s.h) o.h = s.h; if (s.st) o.st = 1; if (s.hc !== undefined) o.hc = s.hc; if (s.pr) o.pr = 1; if (s.ra) o.ra = 1; return o;
      }
      function endPickDrag() {
        var pd = pickDrag; pickDrag = null; if (!pd) return;
        var pk = st.pick, pg = page();
        if (!pk || !pd.moved || (!pd.dx && !pd.dy && pd.f === 1 && !pd.a)) { drawObjs(); redraw(); drawPick(); return; }
        var bxOf = function (id) { return objsEl.querySelector('[data-id="' + id + '"]'); };
        snap(pg);
        var nInk = [], nObjs = [];
        if (pd.dup) {
          pk.ink.forEach(function (s) { var m = movedStroke(s, pd); pg.ink.push(m); nInk.push(m); });
          pk.objs.forEach(function (id) { var ob = findObj(id); if (!ob) return; var c = JSON.parse(JSON.stringify(ob)); c.id = 'w' + Date.now().toString(36) + (++oid); var bx = bxOf(id), np = bx ? objPlace(ob, bx, pd) : { x: xfPt(ob, pd).x, y: xfPt(ob, pd).y, s: ob.s * pd.f, rt: ob.rt || 0 }; c.x = Math.round(np.x); c.y = Math.round(np.y); c.s = Math.round(np.s * 100) / 100; if (np.rt) c.rt = np.rt; else delete c.rt; pg.objs.push(c); nObjs.push(c.id); });
        } else {
          pg.ink = pg.ink.map(function (s) { if (pk.ink.indexOf(s) < 0) return s; var m = movedStroke(s, pd); nInk.push(m); return m; });
          pk.objs.forEach(function (id) { var ob = findObj(id); if (!ob) return; var bx = bxOf(id), np = bx ? objPlace(ob, bx, pd) : { x: xfPt(ob, pd).x, y: xfPt(ob, pd).y, s: ob.s * pd.f, rt: ob.rt || 0 }; ob.x = Math.round(np.x); ob.y = Math.round(np.y); ob.s = Math.round(np.s * 100) / 100; if (np.rt) ob.rt = np.rt; else delete ob.rt; nObjs.push(id); });
        }
        st.pick = { ink: nInk, objs: nObjs };
        drawObjs(); redraw(); drawPick(); drawSide(); dirty();
      }
      function pickOp(op, arg) {
        var pk = st.pick, pg = page(); if (!pk) return;
        if (op === 'del') { snap(pg); pg.ink = pg.ink.filter(function (s) { return pk.ink.indexOf(s) < 0; }); pg.objs = pg.objs.filter(function (o) { return pk.objs.indexOf(o.id) < 0; }); st.pick = null; if (st.sel && !findObj(st.sel)) st.sel = null; }
        else if (op === 'dup') { pickDrag = { dx: 24, dy: 24, f: 1, ox: 0, oy: 0, dup: true, moved: true }; endPickDrag(); return; }
        else if (op === 'turn') { var tb = pickBox(); if (!tb) return; pickDrag = { dx: 0, dy: 0, f: 1, ox: 0, oy: 0, a: (arg || 90) * Math.PI / 180, cx: (tb.x0 + tb.x1) / 2, cy: (tb.y0 + tb.y1) / 2, moved: true }; endPickDrag(); return; }
        else if (op === 'col') {
          var k = Number(arg), own = slotOwn(k), hex = slotHex(k); snap(pg);
          var nInk = [];
          pg.ink = pg.ink.map(function (s) { if (pk.ink.indexOf(s) < 0 || s.k === 'hl') { if (pk.ink.indexOf(s) >= 0) nInk.push(s); return s; } var m = { k: s.k, c: k, w: s.w, pts: s.pts }; if (own) m.h = hex; if (s.st) m.st = 1; nInk.push(m); return m; });
          st.pick = { ink: nInk, objs: pk.objs };
        } else if (op === 'nudge') {
          var now = Date.now(); if (now - nudgeT > 700) snap(pg); nudgeT = now;
          var pd = { dx: arg.x, dy: arg.y, f: 1, ox: 0, oy: 0 }, ni = [];
          pg.ink = pg.ink.map(function (s) { if (pk.ink.indexOf(s) < 0) return s; var m = movedStroke(s, pd); ni.push(m); return m; });
          pk.objs.forEach(function (id) { var ob = findObj(id); if (ob) { ob.x += arg.x; ob.y += arg.y; } });
          st.pick = { ink: ni, objs: pk.objs };
        }
        drawObjs(); redraw(); drawPick(); drawSide(); dirty();
      }
      function copyPick() {
        var pk = st.pick, pg = page(); if (!pk) return false;
        var imgs = {}, objs = pk.objs.map(function (id) { var o = findObj(id); if (o && o.type === 'img') imgs[o.ref] = pg.imgs[o.ref]; return o && JSON.parse(JSON.stringify(o)); }).filter(Boolean);
        clip = { ink: pk.ink.map(function (s) { return movedStroke(s, { dx: 0, dy: 0, f: 1, ox: 0, oy: 0 }); }), objs: objs, imgs: imgs };
        toast('Copied. Paste it with Ctrl V'); return true;
      }
      function pasteClip() {
        if (!clip) return false;
        var pg = page(); snap(pg);
        var d = { dx: 30, dy: 30, f: 1, ox: 0, oy: 0 }, ni = [], no = [];
        clip.ink.forEach(function (s) { var m = movedStroke(s, d); pg.ink.push(m); ni.push(m); });
        clip.objs.forEach(function (o) { var c = JSON.parse(JSON.stringify(o)); c.id = 'w' + Date.now().toString(36) + (++oid); c.x += 30; c.y += 30; if (c.type === 'img' && clip.imgs[c.ref]) pg.imgs[c.ref] = clip.imgs[c.ref]; pg.objs.push(c); no.push(c.id); });
        clip = { ink: ni.map(function (s) { return movedStroke(s, { dx: 0, dy: 0, f: 1, ox: 0, oy: 0 }); }), objs: clip.objs.map(function (o) { var c = JSON.parse(JSON.stringify(o)); c.x += 30; c.y += 30; return c; }), imgs: clip.imgs };
        setTool('select'); st.pick = { ink: ni, objs: no };
        drawObjs(); redraw(); drawPick(); drawSide(); dirty(); return true;
      }
      function selDown(e, p) {
        var b = pickBox(), m10 = 10 / view().z;
        if (b && !e.shiftKey && p.x >= b.x0 - m10 && p.x <= b.x1 + m10 && p.y >= b.y0 - m10 && p.y <= b.y1 + m10) {
          pickDrag = { p: p, dx: 0, dy: 0, f: 1, ox: b.x0, oy: b.y0, dup: e.altKey, moved: false };
          return;
        }
        /* a tap on a line picks it (Shift: adds it, or takes it out); a tap on a diagram's box picks the diagram */
        var ink = page().ink, hitS = null, hitO = null;
        for (var i = ink.length - 1; i >= 0; i--) if (hit(ink[i], p, 6 / view().z)) { hitS = ink[i]; break; }
        if (!hitS) objBoxes().forEach(function (o) { if (p.x >= o.x && p.x <= o.x + o.w && p.y >= o.y && p.y <= o.y + o.h) hitO = o.id; });
        if (hitS || hitO) {
          var pk = e.shiftKey && st.pick ? { ink: st.pick.ink.slice(), objs: st.pick.objs.slice() } : { ink: [], objs: [] };
          if (hitS) { var a = pk.ink.indexOf(hitS); if (a >= 0 && e.shiftKey) pk.ink.splice(a, 1); else if (a < 0) pk.ink.push(hitS); }
          if (hitO) { var c = pk.objs.indexOf(hitO); if (c >= 0 && e.shiftKey) pk.objs.splice(c, 1); else if (c < 0) pk.objs.push(hitO); }
          setPick(pk);
          var nb = pickBox(); if (nb && !e.shiftKey) pickDrag = { p: p, dx: 0, dy: 0, f: 1, ox: nb.x0, oy: nb.y0, dup: e.altKey, moved: false };
          return;
        }
        marq = { a: p, b: p, add: e.shiftKey && st.pick ? st.pick : null, lasso: st.selMode === 'lasso', pts: [p] };
        if (!e.shiftKey) setPick(null);
      }
      function selMove(e, p) {
        if (pickDrag) { var dx = p.x - pickDrag.p.x, dy = p.y - pickDrag.p.y; if (!pickDrag.moved && Math.abs(dx) + Math.abs(dy) < 4) return; pickDrag.moved = true; pickDrag.dx = dx; pickDrag.dy = dy; pickLive(); return; }
        if (!marq) {
          var b = pickBox();
          cvI.style.cursor = b && p.x >= b.x0 - 10 && p.x <= b.x1 + 10 && p.y >= b.y0 - 10 && p.y <= b.y1 + 10 ? 'move' : '';
          return;
        }
        marq.b = p;
        if (marq.lasso) {
          var lp = marq.pts[marq.pts.length - 1]; if (Math.hypot(p.x - lp.x, p.y - lp.y) * view().z > 3) marq.pts.push(p);
          lassoPath(marq.pts);
          var ln = Date.now(); if (ln - (marq.t || 0) > 60) { marq.t = ln; marqHot = lassoPick(marq); redraw(); drawPick(); }
          return;
        }
        var a = toScr(marq.a), q = toScr(p);
        marqEl.hidden = false; marqEl.style.left = Math.min(a.x, q.x) + 'px'; marqEl.style.top = Math.min(a.y, q.y) + 'px'; marqEl.style.width = Math.abs(q.x - a.x) + 'px'; marqEl.style.height = Math.abs(q.y - a.y) + 'px';
        /* ROUND 5 (Aadam: "select - can see what's being selected"): everything the box touches lights up as it is dragged */
        var now = Date.now(); if (now - (marq.t || 0) > 50) { marq.t = now; marqHot = marqPick(marq); redraw(); drawPick(); }
      }
      function marqPick(m) {
        var r = { x0: Math.min(m.a.x, m.b.x), y0: Math.min(m.a.y, m.b.y), x1: Math.max(m.a.x, m.b.x), y1: Math.max(m.a.y, m.b.y) };
        var pk = m.add ? { ink: m.add.ink.slice(), objs: m.add.objs.slice() } : { ink: [], objs: [] };
        page().ink.forEach(function (s) { if (pk.ink.indexOf(s) < 0 && inStroke(s, r)) pk.ink.push(s); });
        objBoxes().forEach(function (o) { if (pk.objs.indexOf(o.id) < 0 && o.x < r.x1 && o.x + o.w > r.x0 && o.y < r.y1 && o.y + o.h > r.y0) pk.objs.push(o.id); });
        return pk;
      }
      function selUp() {
        if (pickDrag) { endPickDrag(); return; }
        if (!marq) return;
        var m = marq; marq = null; marqHot = null; marqEl.hidden = true;
        var vz = view().z;
        if (m.lasso) { lassoPath(null); if (m.pts.length < 4) { if (!m.add) setPick(null); redraw(); drawPick(); return; } setPick(lassoPick(m)); redraw(); return; }
        if (Math.abs(m.a.x - m.b.x) * vz < 4 && Math.abs(m.a.y - m.b.y) * vz < 4) { if (!m.add) setPick(null); redraw(); drawPick(); return; }
        setPick(marqPick(m)); redraw();
      }

      var rubbing = false, inkId = null, panKey = false, panDrag = null;
      /* ROUND 8: once a stylus has been used, a finger never draws (a resting hand leaves no marks): on an endless board
         one finger drags the board; on a question board it does nothing. Two-finger taps and pinches still work. */
      var penSeen = false, palmTold = false;
      function inkDown(e) {
        if (e.pointerType === 'pen') penSeen = true;
        if (e.pointerType === 'touch' && touchDown(e)) return;
        if (isDown || panDrag) return;
        if (penSeen && e.pointerType === 'touch') {
          if (!palmTold) { palmTold = true; toast(endless() ? 'Pen found: the pen draws, a finger moves the board' : 'Pen found: the pen draws, fingers are ignored'); }
          if (endless()) { var v0 = view(); panDrag = { id: e.pointerId, s: ptS(e), x: v0.x, y: v0.y }; try { cvI.setPointerCapture(e.pointerId); } catch (er) {} }
          return;
        }
        /* an endless board: Space held, or the middle button, drags the board */
        if (endless() && (panKey || e.button === 1)) {
          e.preventDefault(); try { cvI.setPointerCapture(e.pointerId); } catch (er) {}
          var v0 = view(); panDrag = { id: e.pointerId, s: ptS(e), x: v0.x, y: v0.y }; board.classList.add('is-panning'); return;
        }
        /* the right button, or a pen's side button or its rubber end, rubs out without changing tool */
        var rub = e.button === 2 || e.button === 5 || (e.pointerType === 'pen' && (e.buttons & 32));
        if (e.button > 0 && !rub) return;
        hideTip();
        /* a tap while a menu or a diagram's buttons are open only closes them: no stray dot of ink. The colours and sizes
           (round 5) close and the stroke goes on, so picking a colour never costs a stroke */
        if (st.menu === 'tray' && !st.sel) { st.menu = null; drawDock(); }
        else if (st.sel || st.menu) { st.sel = null; st.menu = null; st.colFor = -1; drawObjs(); drawDock(); drawIns(); drawPop(); drawTop(); return; }
        var p = pt(e), z = view().z, w = SIZES[st.size] / z;
        /* a tap away from the words being typed finishes them; with the text tool it starts new words there */
        if (edit) { var was = edit.o; endText(); if (st.tool === 'text' && !rub) { e.preventDefault(); var tx0 = txtHit(p); if (tx0 && tx0 !== was) editText(tx0); else if (!tx0) newText(p); return; } }
        else if (st.tool === 'text' && !rub) { e.preventDefault(); var tx = txtHit(p); if (tx) editText(tx); else newText(p); return; }
        try { cvI.setPointerCapture(e.pointerId); } catch (er) {}
        isDown = true; inkId = e.pointerId; rubbing = !!rub && st.tool !== 'eraser';
        if (rubbing || st.tool === 'eraser') { pend = snapOf(page()); eraseAt(p); return; }
        if (st.tool === 'select') { selDown(e, p); return; }
        var own = slotOwn(st.col);
        if (rp) replayCommit();
        if (st.tool === 'pen' || st.tool === 'hl') {
          cur = { k: st.tool, c: st.col, w: w, pts: [p] }; if (own && st.tool === 'pen') cur.h = slotHex(st.col); if (st.tool === 'hl') cur.hc = st.hlc; holdAt = { x: p.x, y: p.y };
          var pr0 = pressOf(e); if (st.press && pr0 !== null && st.tool === 'pen') { cur.pr = 1; p.p = pr0; }
          /* begun just under the ruler's edge: the line runs along it */
          if (st.ruler) { var re = rulEdge(p); if (re.off > -6 / z && re.off < 30 / z && re.t > -20 / z && re.t < st.ruler.L + 20 / z) { var d0 = rulDir(), t0 = clamp(re.t, 0, st.ruler.L), e0 = { x: st.ruler.o.x + d0.x * t0, y: st.ruler.o.y + d0.y * t0 }; cur.rul = 1; cur.st = 1; delete cur.pr; cur.pts = [e0, { x: e0.x, y: e0.y }]; holdAt = null; } }
        }
        else if (st.tool === 'line' || st.tool === 'arrow') { cur = { k: st.tool, c: st.col, w: w, pts: [p, p] }; if (own) cur.h = slotHex(st.col); }
        else if (st.tool === 'laser') { var ps = ptS(e); sm = { x: ps.x, y: ps.y }; tgt = ps; lg++; trail.push({ x: ps.x, y: ps.y, t: performance.now(), g: lg }); hover = sm; loop(); }
        redraw();
      }
      function inkMove(e) {
        if (e.pointerType === 'touch' && touchMove(e)) return;
        if (panDrag) { if (e.pointerId === panDrag.id) { var q0 = ptS(e), v = view(); setView(panDrag.x - (q0.x - panDrag.s.x) / v.z, panDrag.y - (q0.y - panDrag.s.y) / v.z, v.z); } return; }
        if (isDown && e.pointerId !== inkId) return;
        var p = pt(e);
        if (st.tool === 'laser' && !rubbing) {
          /* eased: every raw point (coalesced too) pulls the pointer part of the way, so a shaky hand or a
             smartboard's jittery touch reads as one smooth stroke; trail points sit at least 1.5px apart. On the screen,
             not the board, so it looks the same at any zoom */
          var n = performance.now();
          evs(e).forEach(function (v) {
            var q = ptS(v); tgt = q;
            sm = sm ? { x: sm.x + (q.x - sm.x) * 0.5, y: sm.y + (q.y - sm.y) * 0.5 } : q;
            var last = trail[trail.length - 1];
            if (isDown && (!last || last.g !== lg || Math.hypot(sm.x - last.x, sm.y - last.y) > 1.5)) trail.push({ x: sm.x, y: sm.y, t: n, g: lg });
          });
          hover = sm; loop(); return;
        }
        if (st.tool === 'select' && !rubbing) { if (isDown || !e.buttons) selMove(e, p); return; }
        if (!isDown) return;
        if (rubbing || st.tool === 'eraser') { evs(e).forEach(function (v) { eraseAt(pt(v)); }); return; }
        if (!cur) return;
        if (cur.shaped) { if (cur.sz) { sizeShape(p); redraw(); } return; }
        if (cur.rul) { var r2 = rulEdge(p), d2 = rulDir(), t2 = clamp(r2.t, 0, st.ruler.L); cur.pts[1] = { x: st.ruler.o.x + d2.x * t2, y: st.ruler.o.y + d2.y * t2 }; rulerChip(cur.pts[0], cur.pts[1]); redraw(); return; }
        if (cur.k === 'line' || cur.k === 'arrow') {
          if (e.shiftKey) { var sn = snapTo(cur.pts[0], p); p = { x: sn.x, y: sn.y }; showChip(p, sn.deg); } else hideChip();
          cur.pts[1] = p;
        } else if (e.shiftKey || cur.st) {
          /* Shift with the pen or the highlighter: from here on the stroke is one straight line from where it began */
          if (!cur.st) { cur.st = 1; cur.pts = [cur.pts[0], p]; cur.vic = null; }
          if (e.shiftKey) { var s2 = snapTo(cur.pts[0], p); cur.pts[1] = { x: s2.x, y: s2.y }; showChip(cur.pts[1], s2.deg); } else { cur.pts[1] = p; hideChip(); }
        } else {
          /* smoothing: the line eases towards the pen (Some, More); pressure: each point keeps how hard the pen pressed */
          var f = cur.k === 'pen' ? SMOOTH[st.smooth] || 1 : 1;
          evs(e).forEach(function (v) {
            var q = pt(v), L0 = cur.pts[cur.pts.length - 1];
            if (f < 1 && L0) q = { x: L0.x + (q.x - L0.x) * f, y: L0.y + (q.y - L0.y) * f };
            /* a reading of 0 or none keeps the last one, and each reading eases in, so a jumpy stylus never jumps the width */
            if (cur.pr) { var pv = pressOf(v), pl = L0 && L0.p != null ? L0.p : 0.5; q.p = pv === null ? pl : Math.round((pl + (pv - pl) * 0.3) * 100) / 100; }
            cur.pts.push(q);
          });
          /* hold the pen still (6px for 0.55s) at the end of a rough shape and it snaps to a neat one */
          if (cur.k === 'pen' && (!holdAt || Math.hypot(p.x - holdAt.x, p.y - holdAt.y) > 6 / view().z)) { holdAt = { x: p.x, y: p.y }; clearTimeout(holdT); holdT = setTimeout(trySnapShape, 550); }
          /* a scribble: the lines it would rub out fade while it is drawn */
          if (cur.k === 'pen') { var tn = Date.now(); if (!cur.vt || tn - cur.vt > 90) { cur.vt = tn; cur.vic = scribbleHits(cur); } }
        }
        redraw();
      }
      function inkUp(e) {
        if (e && e.pointerType === 'touch') touchUp(e);
        if (panDrag && e && e.pointerId === panDrag.id) { panDrag = null; board.classList.remove('is-panning'); viewDone(); return; }
        if (e && isDown && e.pointerId !== inkId) return;
        clearTimeout(holdT); holdT = 0; holdAt = null; hideChip();
        if (!isDown) return; isDown = false; pend = null;
        if (st.tool === 'select' && !rubbing) { selUp(); return; }
        if (rubbing || st.tool === 'eraser') { rubbing = false; drawSide(); dirty(); return; }
        if (cur) {
          if (e && cur.k === 'pen' && !cur.st && !cur.shaped && st.smooth) { var lq = pt(e); if (cur.pr) lq.p = cur.pts[cur.pts.length - 1].p; cur.pts.push(lq); }
          var s = cur, pg = page(), had = hasWork(item()), vic = !s.shaped && !s.st && s.k === 'pen' ? scribbleHits(s) : null;
          delete s.shaped; delete s.sz; delete s.vic; delete s.vt; delete s.rul; cur = null; snap(pg);
          /* SCRIBBLE TO RUB OUT (round 5, Aadam: "scribble over - erase"): the scribble and the lines it covers both go */
          if (vic && vic.length) {
            pg.ink = pg.ink.filter(function (x) { return vic.indexOf(x) < 0; });
            redraw(); drawSide(); dirty(); toast('Rubbed out ' + vic.length + (vic.length === 1 ? ' line' : ' lines'), function () { undo(); });
            track('whiteboard_scribble', { n: vic.length }); return;
          }
          pg.ink.push(s); redraw(); if (!had) drawSide(); dirty();
          if (s.k !== 'hl') rightAngles(s);
        }
      }
      /* a scribble is a pen stroke that goes back and forth at least four times along one way (a zigzag across a word, or
         rubbing to and fro over it) and is long for the space it covers; what it rubs out is any line with most of its
         length inside the scribble's outline. Nothing under it: it stays as ink. */
      function scribbleOf(pts) {
        if (pts.length < 14) return false;
        var n = pts.length, mx = 0, my = 0, i, len = 0;
        for (i = 0; i < n; i++) { mx += pts[i].x; my += pts[i].y; if (i) len += Math.hypot(pts[i].x - pts[i - 1].x, pts[i].y - pts[i - 1].y); }
        mx /= n; my /= n;
        var sxx = 0, syy = 0, sxy = 0;
        for (i = 0; i < n; i++) { var dx = pts[i].x - mx, dy = pts[i].y - my; sxx += dx * dx; syy += dy * dy; sxy += dx * dy; }
        var g = 0.5 * Math.atan2(2 * sxy, sxx - syy), best = 0;
        [g, g + Math.PI / 2].forEach(function (a) {
          var c = Math.cos(a), sn = Math.sin(a), us = pts.map(function (q) { return (q.x - mx) * c + (q.y - my) * sn; });
          var lo = Math.min.apply(null, us), hi = Math.max.apply(null, us), span = hi - lo, hy = Math.max(6, span * 0.35), dir = 0, ext = us[0], rev = 0;
          if (span < 12) return;
          us.forEach(function (u) {
            if (dir >= 0 && u < ext - hy) { if (dir > 0) rev++; dir = -1; ext = u; }
            else if (dir <= 0 && u > ext + hy) { if (dir < 0) rev++; dir = 1; ext = u; }
            else if ((dir > 0 && u > ext) || (dir < 0 && u < ext)) ext = u;
          });
          if (rev >= 4 && len > span * 4) best = Math.max(best, rev);
        });
        return best >= 4;
      }
      function hull(pts) {
        var q = pts.map(function (p) { return [p.x, p.y]; }).sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; });
        var cr = function (o, a, b) { return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]); }, lo = [], up = [], i;
        for (i = 0; i < q.length; i++) { while (lo.length > 1 && cr(lo[lo.length - 2], lo[lo.length - 1], q[i]) <= 0) lo.pop(); lo.push(q[i]); }
        for (i = q.length - 1; i >= 0; i--) { while (up.length > 1 && cr(up[up.length - 2], up[up.length - 1], q[i]) <= 0) up.pop(); up.push(q[i]); }
        return lo.slice(0, -1).concat(up.slice(0, -1));
      }
      function inHull(h, x, y) {
        if (h.length < 3) return false;
        var pos = false, neg = false;
        for (var i = 0; i < h.length; i++) { var a = h[i], b = h[(i + 1) % h.length], c = (b[0] - a[0]) * (y - a[1]) - (b[1] - a[1]) * (x - a[0]); if (c > 0) pos = true; else if (c < 0) neg = true; if (pos && neg) return false; }
        return true;
      }
      function scribbleHits(s) {
        if (!scribbleOf(s.pts)) return null;
        var h = hull(s.pts), out = [];
        page().ink.forEach(function (x) {
          var q = x.pts, n = 0, k = 0, j, u;
          if (q.length < 3 || x.k === 'line' || x.k === 'arrow' || x.st) { for (j = 1; j < q.length; j++) for (u = 0; u <= 1; u += 0.125) { n++; if (inHull(h, q[j - 1].x + (q[j].x - q[j - 1].x) * u, q[j - 1].y + (q[j].y - q[j - 1].y) * u)) k++; } if (q.length === 1) { n = 1; k = inHull(h, q[0].x, q[0].y) ? 1 : 0; } }
          else for (j = 0; j < q.length; j++) { n++; if (inHull(h, q[j].x, q[j].y)) k++; }
          if (n && k / n >= 0.6) out.push(x);
        });
        return out.length ? out : null;
      }

      /* the laser: one ribbon, thick at the pointer and thinning to nothing along a smoothed curve through the last
         ~0.7s, under a soft glow, then a bright dot with a white core. One filled shape per frame, so no beads where
         segments overlap; the curve is Catmull-Rom through the eased points. */
      var LIFE = 700;
      function curve(pts) {
        var out = [], i, k;
        for (i = 0; i < pts.length - 1; i++) {
          var p0 = pts[i - 1] || pts[i], p1 = pts[i], p2 = pts[i + 1], p3 = pts[i + 2] || p2;
          for (k = 0; k < 4; k++) {
            var u = k / 4, u2 = u * u, u3 = u2 * u;
            out.push({
              x: 0.5 * (2 * p1.x + (-p0.x + p2.x) * u + (2 * p0.x - 5 * p1.x + 4 * p2.x - p3.x) * u2 + (-p0.x + 3 * p1.x - 3 * p2.x + p3.x) * u3),
              y: 0.5 * (2 * p1.y + (-p0.y + p2.y) * u + (2 * p0.y - 5 * p1.y + 4 * p2.y - p3.y) * u2 + (-p0.y + 3 * p1.y - 3 * p2.y + p3.y) * u3),
              t: p1.t + (p2.t - p1.t) * u
            });
          }
        }
        out.push(pts[pts.length - 1]);
        return out;
      }
      function ribbon(c, pts, now, wmax) {
        var L = [], R = [], n = pts.length, i;
        for (i = 0; i < n; i++) {
          var a = pts[Math.max(0, i - 1)], b = pts[Math.min(n - 1, i + 1)], dx = b.x - a.x, dy = b.y - a.y, d = Math.hypot(dx, dy) || 1;
          var f = clamp(1 - (now - pts[i].t) / LIFE, 0, 1), w = wmax * Math.pow(f, 0.7) * (0.35 + 0.65 * i / Math.max(1, n - 1)) / 2;
          L.push([pts[i].x - dy / d * w, pts[i].y + dx / d * w]); R.push([pts[i].x + dy / d * w, pts[i].y - dx / d * w]);
        }
        c.beginPath(); c.moveTo(L[0][0], L[0][1]);
        for (i = 1; i < n; i++) c.lineTo(L[i][0], L[i][1]);
        for (i = n - 1; i >= 0; i--) c.lineTo(R[i][0], R[i][1]);
        c.closePath(); c.fill();
      }
      function loop() {
        if (raf) return;
        var frame = function () {
          raf = 0; if (!root || !W) return;
          var c = cvL.getContext('2d'), t = th(), now = performance.now(), live = st.tool === 'laser' && st.open;
          c.setTransform(dpr, 0, 0, dpr, 0, 0); c.clearRect(0, 0, W, H);
          /* the eased pointer keeps closing on the real one between events, so it never stops short */
          var chase = false;
          if (sm && tgt && live) {
            var gx = tgt.x - sm.x, gy = tgt.y - sm.y;
            if (Math.abs(gx) + Math.abs(gy) > 0.4) { chase = true; sm = { x: sm.x + gx * 0.45, y: sm.y + gy * 0.45 }; hover = sm; var lt = trail[trail.length - 1]; if (isDown && (!lt || lt.g !== lg || Math.hypot(sm.x - lt.x, sm.y - lt.y) > 1.5)) trail.push({ x: sm.x, y: sm.y, t: now, g: lg }); }
          }
          trail = trail.filter(function (p) { return now - p.t < LIFE; });
          /* each press of the pointer is its own ribbon: two strokes drawn close together never join up (10-24 fix) */
          var runs = [], rn = null;
          trail.forEach(function (p) { if (!rn || p.g !== rn[0].g) runs.push(rn = []); rn.push(p); });
          runs.forEach(function (r) {
            if (r.length < 2) return;
            var pts = curve(r);
            c.fillStyle = 'rgba(' + t.laser + ',.22)'; ribbon(c, pts, now, 26);
            c.fillStyle = 'rgba(' + t.laser + ',.95)'; ribbon(c, pts, now, 9);
            c.fillStyle = 'rgba(255,255,255,.55)'; ribbon(c, pts, now, 2.6);
          });
          if (hover && live) {
            c.shadowColor = 'rgba(' + t.laser + ',.9)'; c.shadowBlur = 22; c.fillStyle = 'rgb(' + t.laser + ')';
            c.beginPath(); c.arc(hover.x, hover.y, 10, 0, 7); c.fill(); c.shadowBlur = 0;
            c.fillStyle = 'rgba(255,255,255,.92)'; c.beginPath(); c.arc(hover.x, hover.y, 3.8, 0, 7); c.fill();
          }
          if (trail.length || chase || (hover && live)) raf = requestAnimationFrame(frame);
        };
        raf = requestAnimationFrame(frame);
      }

      /* ---------- handles: move and resize the question card and anything put on the board ---------- */
      function onHandleDown(e) {
        var t = e.target.closest ? e.target.closest('[data-grip],[data-size]') : null; if (!t || e.button > 0) return;
        if (t.getAttribute('data-grip') === 'card' && st.tool !== 'select' && !(e.target.closest && e.target.closest('.wb-gl,button,a,input'))) { inkDown(e); return; }
        e.preventDefault();
        var id = t.getAttribute('data-grip') || t.getAttribute('data-size'), rs = t.hasAttribute('data-size');
        var o = id === 'card' ? st.card : findObj(id); if (!o) return;
        if (o.lock && rs) return;
        var box = id === 'card' ? cardEl : t.closest('.wb-obj');
        try { t.setPointerCapture(e.pointerId); } catch (er) {}
        var p = pt(e);
        drag = { id: id, rs: rs, o: o, box: box, p: p, x: o.x, y: o.y, s: o.s, w: box.offsetWidth, moved: false, snapped: false, near: -1 };
        box.classList.remove('is-spring');
        /* round 13: writing that sits wholly on a picture goes with it when the picture moves */
        if (o.type === 'img' && !rs) {
          var fx0 = o.x - 6, fy0 = o.y - 6, fx1 = o.x + box.offsetWidth + 6, fy1 = o.y + box.offsetHeight + 6;
          drag.ink = page().ink.filter(function (sk) { var q = strokeBox(sk); return q.x0 >= fx0 && q.y0 >= fy0 && q.x1 <= fx1 && q.y1 <= fy1; }).map(function (sk) { return { s0: sk, cur: sk }; });
          if (!drag.ink.length) drag.ink = null;
        }
      }
      /* nine places: the corners, the middle of each edge and the centre; the bottom row clears the tool dock */
      function spots(box) {
        var w = box.offsetWidth, h = box.offsetHeight, m = 20, bot = H - h - (dockEl ? dockEl.offsetHeight + 30 : 100);
        var xs = [m, (W - w) / 2, W - w - m], ys = [m, Math.max(m, (H - h) / 2 - 30), Math.max(m, bot)], out = [];
        /* a card nearly as wide as the board: places closer than 40px are one place */
        function thin(a) { var r = [a[0]]; for (var q = 1; q < a.length; q++) if (a[q] - r[r.length - 1] >= 40) r.push(a[q]); return r; }
        xs = thin(xs); ys = thin(ys);
        ys.forEach(function (y) { xs.forEach(function (x) { out.push({ x: Math.round(Math.max(0, x)), y: Math.round(y) }); }); });
        return out;
      }
      var ghostsEl = null;
      function ghosts(box, near) {
        if (!ghostsEl) { ghostsEl = el('div', 'wb-snaps'); board.insertBefore(ghostsEl, cardEl); }
        if (!box) { ghostsEl.classList.remove('is-on'); return; }
        var sp = spots(box), w = box.offsetWidth, h = box.offsetHeight;
        if (ghostsEl.children.length !== sp.length) ghostsEl.innerHTML = sp.map(function () { return '<span></span>'; }).join('');
        /* every place is a dot; the one it will land in opens out to the card's own outline */
        sp.forEach(function (s, k) {
          var g = ghostsEl.children[k], on = k === near;
          g.style.cssText = on ? 'left:' + s.x + 'px;top:' + s.y + 'px;width:' + w + 'px;height:' + h + 'px'
            : 'left:' + (s.x + w / 2 - 8) + 'px;top:' + (s.y + h / 2 - 8) + 'px;width:16px;height:16px';
          g.classList.toggle('is-near', on);
        });
        ghostsEl.classList.add('is-on');
      }
      function onHandleMove(e) {
        if (!drag) return;
        var p = pt(e), dx = p.x - drag.p.x, dy = p.y - drag.p.y;
        if (!drag.moved && Math.abs(dx) + Math.abs(dy) < 4) return;
        if (drag.o.lock) return;
        drag.moved = true;
        if (drag.id !== 'card' && !drag.snapped) { snap(); drag.snapped = true; }
        if (drag.rs) {
          var big = drag.o.type === 'stamp', s = clamp(drag.s * (drag.w + Math.max(dx, dy * drag.w / Math.max(1, drag.box.offsetHeight))) / drag.w, big ? 0.2 : Math.min(0.4, drag.s), big ? 12 : Math.max(3.5, drag.s));
          drag.o.s = Math.round(s * 100) / 100; drag.box.style.setProperty('--s', drag.o.s); sizeBox(drag.box, drag.box.firstChild, drag.o.s); picFollow(drag.box);
        } else {
          /* round 3: kept wholly on the board (it used to go up to 40px past the left and most of the way off the right) */
          var bw = drag.box.offsetWidth, bh = drag.box.offsetHeight, inf = endless() && (drag.id !== 'card' || !viewHome());
          /* an endless board has no edges and no nine places to land in */
          drag.o.x = Math.round(inf ? drag.x + dx : clamp(drag.x + dx, 0, Math.max(0, W - bw))); drag.o.y = Math.round(inf ? drag.y + dy : clamp(drag.y + dy, 0, Math.max(0, H - bh)));
          drag.box.style.left = drag.o.x + 'px'; drag.box.style.top = drag.o.y + 'px'; picFollow(drag.box); if (drag.id === 'card') cardView();
          if (drag.ink) inkFollow(drag);
          drag.box.classList.add('is-drag');
          var near = -1, best = Math.max(130, Math.min(W, H) * 0.2);
          if (!e.altKey && !inf && drag.o.type !== 'img') spots(drag.box).forEach(function (s, k) { var d = Math.hypot(s.x - drag.o.x, s.y - drag.o.y); if (d < best) { best = d; near = k; } });
          drag.near = near; ghosts(drag.box, near);
        }
        if (drag.rs) { drag.box.classList.add('is-drag'); var pc = drag.box.querySelector('.wb-pct'); if (!pc) { pc = el('span', 'wb-pct num'); drag.box.appendChild(pc); } pc.textContent = Math.round(drag.o.s * 100) + '%'; }
      }
      /* strokes are never changed in place (undo keeps them), so each move swaps in a moved copy */
      function inkFollow(d) {
        var pg = page(), pd = { dx: d.o.x - d.x, dy: d.o.y - d.y, f: 1, ox: 0, oy: 0 };
        d.ink.forEach(function (m) { var n = movedStroke(m.s0, pd), k = pg.ink.indexOf(m.cur); if (k < 0) return; pg.ink[k] = n; m.cur = n; });
        redraw();
      }
      function onHandleUp() {
        var d = drag; drag = null; if (!d) return;
        d.box.classList.remove('is-drag'); ghosts(null);
        var pc = d.box.querySelector('.wb-pct'); if (pc) pc.parentNode.removeChild(pc);
        if (d.moved && !d.rs && d.near >= 0) {
          var s = spots(d.box)[d.near];
          if (!reduceMotion) { d.box.classList.add('is-spring'); var bx = d.box; setTimeout(function () { bx.classList.remove('is-spring'); picFollow(bx); }, 700); }
          d.o.x = s.x; d.o.y = s.y; d.box.style.left = s.x + 'px'; d.box.style.top = s.y + 'px'; picFollow(d.box);
          if (d.ink) inkFollow(d);
        }
        if (d.id === 'card') { cardClear(); if (d.rs) keep(); return; }
        if (!d.moved && !d.rs) { st.sel = st.sel === d.id ? null : d.id; st.menu = null; drawObjs(); drawIns(); drawPop(); drawDock(); return; }
        if (d.moved) { st.sel = d.id; drawObjs(); dirty(); }
      }

      /* ---------- a board drawn onto a canvas: the picture and the PDF ---------- */
      function ctext(x, str, px, wt, col, cx, cy, align) {
        x.font = wt + ' ' + px + 'px Lexend, "Plus Jakarta Sans", system-ui, sans-serif'; x.fillStyle = col;
        x.textAlign = align || 'center'; x.textBaseline = 'middle'; x.fillText(str, cx, cy);
      }
      var imgC = {};
      function imgOf(src) { if (!imgC[src]) { var m = new Image(); m.onload = function () { miniSoon(); }; m.src = src; imgC[src] = m; } return imgC[src]; }
      function drawObjC(x, o, t, pg) {
        var ink = t.ink, acc = t.pens[1], k, j;
        x.save();
        var bx0 = o.rt && objsEl && objsEl.querySelector('[data-id="' + o.id + '"]'), ow = o.type === 'img' ? o.w : bx0 ? bx0.firstChild.offsetWidth : 0, oh = o.type === 'img' ? o.h : bx0 ? bx0.firstChild.offsetHeight : 0;
        if (o.rt && ow && oh) { var tw = turned(ow * (o.s || 1), oh * (o.s || 1), o.rt); x.translate(o.x + tw.W / 2, o.y + tw.H / 2); x.rotate(o.rt * Math.PI / 180); x.translate(-ow * (o.s || 1) / 2, -oh * (o.s || 1) / 2); }
        else x.translate(o.x, o.y);
        x.scale(o.s || 1, o.s || 1); x.lineCap = 'butt'; x.lineJoin = 'miter';
        if (o.type === 'img') { var src = pg && pg.imgs[o.ref], im = src && imgOf(src); if (im && im.complete && im.naturalWidth) x.drawImage(im, 0, 0, o.w, o.h); }
        else if (o.type === 'stamp') stampC(x, o, t);
        else if (o.type === 'txt') {
          var tfs = o.fs || 34, thx = /^#[0-9a-f]{6}$/i.test(o.hx) ? o.hx : ink;
          String(o.t || '').split('\n').forEach(function (ln, n) { drawWords(x, qWords(x, ln.replace(/\*/g, '×').replace(/\bsqrt\b/g, '√').replace(/\bpi\b/g, 'π').replace(/\^2/g, '²').replace(/\^3/g, '³').replace(/<=/g, '≤').replace(/>=/g, '≥'), tfs), tfs, thx, 0, tfs * 0.75 + n * tfs * 1.5); });
        }
        else if (o.type === 'graph') {
          var GD = graphData(o), gw = 440, gh = Math.round(Math.min(520, Math.max(260, gw * (GD.y1 - GD.y0) / Math.max(1, o.x1 - o.x0)))), gk;
          var GX = function (v) { return 30 + (v - o.x0) / (o.x1 - o.x0) * gw; }, GY = function (v) { return 54 + (GD.y1 - v) / (GD.y1 - GD.y0) * gh; };
          x.strokeStyle = t.pat; x.lineWidth = 1;
          for (gk = Math.ceil(o.x0 / GD.xs) * GD.xs; gk <= o.x1; gk += GD.xs) { x.beginPath(); x.moveTo(GX(gk), 54); x.lineTo(GX(gk), 54 + gh); x.stroke(); }
          for (gk = GD.y0; gk <= GD.y1; gk += GD.step) { x.beginPath(); x.moveTo(30, GY(gk)); x.lineTo(30 + gw, GY(gk)); x.stroke(); }
          x.strokeStyle = ink; x.lineWidth = 2.5; x.beginPath(); x.moveTo(30, GY(0)); x.lineTo(30 + gw, GY(0)); x.moveTo(GX(0), 54); x.lineTo(GX(0), 54 + gh); x.stroke();
          for (gk = Math.ceil(o.x0 / GD.xs) * GD.xs; gk <= o.x1; gk += GD.xs) if (gk) ctext(x, nice(gk), 12, 600, t.sub, GX(gk), GY(0) + 12);
          for (gk = GD.y0; gk <= GD.y1; gk += GD.step) if (gk) ctext(x, nice(gk), 12, 600, t.sub, GX(0) - 12, GY(gk));
          if (!o.hide) GD.fs.forEach(function (f, n) {
            x.strokeStyle = GCOL[n % 4]; x.lineWidth = 3.5; x.beginPath(); var pen = false;
            for (var s2 = 0; s2 <= 240; s2++) { var gx = o.x0 + (o.x1 - o.x0) * s2 / 240, gy = f(gx); if (!isFinite(gy) || gy < GD.y0 - 1 || gy > GD.y1 + 1) { pen = false; continue; } if (pen) x.lineTo(GX(gx), GY(gy)); else x.moveTo(GX(gx), GY(gy)); pen = true; }
            x.stroke();
            ctext(x, 'y = ' + o.fns[n], 16, 700, GCOL[n % 4], 30 + n * 170, 24, 'left');
          });
        }
        else if (o.type === 'q') {
          var qsk2 = SL.get(o.sk), qt = o.qt || el('div', null, o.qh || '').textContent.replace(/\s+/g, ' ').trim();
          ctext(x, (qsk2 ? qsk2.name : 'Question') + ' · Level ' + (o.lv | 0), 13, 600, t.sub, 14, 14, 'left');
          drawWords(x, qWords(x, qt, 34), 34, ink, 14, 56);
        }
        else if (o.type === 'calc') { var cws = qWords(x, calcText(o.ex) + ' = ' + calcText(o.res), 34); drawWords(x, cws, 34, ink, 8, 34); }
        else if (o.type === 'nl') {
          var g = Math.min(64, Math.floor(1100 / (o.n - 1))), Wd = (o.n - 1) * g, small = g < 44;
          x.fillStyle = ink; x.fillRect(20, 79, Wd, 3);
          for (k = 0; k < o.n; k++) { x.fillStyle = ink; x.fillRect(20 + k * g - 1.5, 70, 3, 21); ctext(x, fmt(o.start + k * o.step), small ? 15 : 21, 700, ink, 20 + k * g, 110); }
          x.strokeStyle = acc; x.lineWidth = 3;
          for (j = 0; j < o.jumps; j++) {
            var a = o.f + o.d * j * o.js, b = o.f + o.d * (j + 1) * o.js, L = 20 + Math.min(a, b) * g, w = o.js * g;
            x.beginPath(); x.ellipse(L + w / 2, 80, w / 2 - 1.5, 44.5, 0, Math.PI, 2 * Math.PI); x.stroke();
            ctext(x, (o.d > 0 ? '+' : MINUS) + fmt(o.js * o.step).replace(MINUS, ''), 20, 800, acc, L + w / 2, 16);
          }
        } else if (o.type === 'bar') {
          x.lineWidth = 3; x.strokeStyle = ink;
          o.rows.forEach(function (parts, r) {
            var y = r * 80, pw = 620 / parts.length;
            x.fillStyle = t.fill; x.fillRect(0, y, 620, 68); x.strokeRect(1.5, y + 1.5, 617, 65);
            parts.forEach(function (v, i) { if (i) { x.beginPath(); x.moveTo(i * pw, y); x.lineTo(i * pw, y + 68); x.stroke(); } if (v) ctext(x, v, 26, 700, ink, i * pw + pw / 2, y + 34); });
          });
          var by = o.rows.length * 80 - 4;
          x.beginPath(); x.moveTo(1.5, by); x.lineTo(1.5, by + 14.5); x.lineTo(618.5, by + 14.5); x.lineTo(618.5, by); x.stroke();
          if (o.total) ctext(x, o.total, 26, 700, ink, 310, by + 16 + 12 + 22);
        } else if (o.type === 'grid' || o.type === 'tbl') {
          var tb = o.type === 'tbl', R = o.R + (tb ? 0 : 1), C = o.C + (tb ? 0 : 1);
          x.lineWidth = 3; x.strokeStyle = ink;
          for (var r = 0; r < R; r++) for (var c = 0; c < C; c++) {
            var head = tb ? r === 0 : (r === 0 || c === 0), v = (o.cells || {})[r + ',' + c];
            if (head) { x.fillStyle = t.fill; x.fillRect(c * 112, r * 70, 112, 70); }
            x.strokeRect(c * 112 + 1.5, r * 70 + 1.5, 112, 70);
            if (!tb && !r && !c) ctext(x, '×', 30, 800, acc, 56 + 1.5, 35 + 1.5);
            else if (v) ctext(x, v, 26, 700, head ? acc : ink, c * 112 + 57.5, r * 70 + 36.5);
          }
        } else if (o.type === 'ax') {
          var cell = Math.min(34, Math.floor(560 / (2 * o.r))), Sz = 2 * o.r * cell;
          x.strokeStyle = t.pat; x.lineWidth = 1;
          for (k = 0; k <= 2 * o.r; k++) { x.beginPath(); x.moveTo(k * cell + 0.5, 0); x.lineTo(k * cell + 0.5, Sz); x.moveTo(0, k * cell + 0.5); x.lineTo(Sz, k * cell + 0.5); x.stroke(); }
          x.fillStyle = ink; x.fillRect(0, Sz / 2 - 1.5, Sz, 3); x.fillRect(Sz / 2 - 1.5, 0, 3, Sz);
          for (k = -o.r; k <= o.r; k++) {
            if (!k || Math.abs(k) === o.r) continue;
            ctext(x, fmt(k), 14, 700, t.sub, (k + o.r) * cell, Sz / 2 + 15);
            ctext(x, fmt(k), 14, 700, t.sub, Sz / 2 - 21, (o.r - k) * cell);
          }
          ctext(x, 'x', 21, 'italic 700', ink, Sz - 11, Sz / 2 - 18); ctext(x, 'y', 21, 'italic 700', ink, Sz / 2 + 23, 12);
        }
        x.restore();
      }
      /* the question as text, every a/b drawn stacked (the lab never shows a fraction with a slash) */
      function qWords(x, txt, fs) {
        return txt.split(' ').map(function (wd) {
          var parts = wd.split(/(\d+\/\d+)/).filter(Boolean).map(function (p) {
            var m = /^(\d+)\/(\d+)$/.exec(p);
            if (!m) { x.font = '700 ' + fs + 'px Lexend, system-ui, sans-serif'; return { s: p, w: x.measureText(p).width }; }
            x.font = '700 ' + (fs * 0.62) + 'px Lexend, system-ui, sans-serif';
            return { n: m[1], d: m[2], w: Math.max(x.measureText(m[1]).width, x.measureText(m[2]).width) + fs * 0.18 };
          });
          return { parts: parts, w: parts.reduce(function (a, p) { return a + p.w; }, 0) };
        });
      }
      function drawWords(x, ws, fs, col, x0, cy) {
        x.fillStyle = col; x.strokeStyle = col; x.textBaseline = 'middle';
        var sp = fs * 0.28, cx = x0;
        ws.forEach(function (wd, i) {
          if (i) cx += sp;
          wd.parts.forEach(function (p) {
            if (p.s !== undefined) { x.font = '700 ' + fs + 'px Lexend, system-ui, sans-serif'; x.textAlign = 'left'; x.fillText(p.s, cx, cy); }
            else {
              var mid = cx + p.w / 2;
              x.font = '700 ' + (fs * 0.62) + 'px Lexend, system-ui, sans-serif'; x.textAlign = 'center';
              x.fillText(p.n, mid, cy - fs * 0.34); x.fillText(p.d, mid, cy + fs * 0.36);
              x.lineWidth = Math.max(2, fs * 0.055); x.beginPath(); x.moveTo(cx + fs * 0.04, cy); x.lineTo(cx + p.w - fs * 0.04, cy); x.stroke();
            }
            cx += p.w;
          });
        });
      }
      function drawCardC(x, it, t, n) {
        var s = st.card.s, len = String(it.q.text || '').length, fs = (len > 90 ? 26 : len > 50 ? 34 : len > 28 ? 44 : 54) * clamp(W / 1000, 0.55, 1);
        var ws = qWords(x, spPlain(it.q), fs), lab = n ? 'Q' + n : 'Saved board', sp = fs * 0.28, lines = [], ln = [], lw = 0;
        ws.forEach(function (wd) { var add = (ln.length ? sp : 0) + wd.w; if (lw + add > 1040 && ln.length) { lines.push({ ws: ln, w: lw }); ln = [wd]; lw = wd.w; } else { ln.push(wd); lw += add; } });
        if (ln.length) lines.push({ ws: ln, w: lw });
        var frac = ws.some(function (wd) { return wd.parts.some(function (p) { return p.s === undefined; }); });
        var tw = Math.max.apply(null, lines.map(function (l) { return l.w; })), lh = fs * (frac ? 1.6 : 1.15), bw = tw + 52, bh = 16 + 21 + lines.length * lh + 20;
        x.save(); x.translate(st.card.x, st.card.y); x.scale(s, s);
        x.fillStyle = t.card; x.strokeStyle = t.line; x.lineWidth = 1;
        x.beginPath(); if (x.roundRect) x.roundRect(0.5, 0.5, bw, bh, 20); else x.rect(0.5, 0.5, bw, bh); x.fill(); x.stroke();
        ctext(x, lab, 15, 800, t.dark ? colourOf(it.skill).col : t.pens[1], 26, 16 + 9, 'left');
        lines.forEach(function (l, i) { drawWords(x, l.ws, fs, t.ink, 26, 16 + 21 + lh * i + lh / 2); });
        x.restore();
      }
      function paintPaper(x, t, w, h) {
        x.fillStyle = t.bg; x.fillRect(0, 0, w, h);
        var i, j;
        if (st.pat === 'dots') { x.fillStyle = t.pat; for (j = 17; j < h; j += 34) for (i = 17; i < w; i += 34) { x.beginPath(); x.arc(i, j, 2.2, 0, 7); x.fill(); } }
        if (st.pat === 'squares') { x.strokeStyle = t.pat; x.lineWidth = 1; x.beginPath(); for (i = 0; i < w; i += 40) { x.moveTo(i + 0.5, 0); x.lineTo(i + 0.5, h); } for (j = 0; j < h; j += 40) { x.moveTo(0, j + 0.5); x.lineTo(w, j + 0.5); } x.stroke(); }
        if (st.pat === 'lines') { x.strokeStyle = t.pat; x.lineWidth = 1; x.beginPath(); for (j = 0; j < h; j += 44) { x.moveTo(0, j + 0.5); x.lineTo(w, j + 0.5); } x.stroke(); }
      }
      function boardCanvas(it, k) {
        var w = W || 1280, h = H || 720, t = th(), pg = pageOf(it), n = it.saved ? 0 : it.blank ? (st.blank ? st.blank.ids.indexOf(it.id) + 1 : 0) : order().indexOf(S.set.indexOf(it)) + 1;
        /* an endless page: the picture frames all its work (round 5), never just the corner it started in */
        var fb = it.blank ? pageBox(pg) : null, ox = 0, oy = 0;
        if (fb) { w = Math.max(320, fb.x1 - fb.x0 + 96); h = Math.max(240, fb.y1 - fb.y0 + 96 + 24); ox = fb.x0 - 48; oy = fb.y0 - 48; k = Math.min(k, 4000 / Math.max(w, h)); }
        var c = document.createElement('canvas'); c.width = Math.round(w * k); c.height = Math.round(h * k);
        var x = c.getContext('2d'); x.scale(k, k);
        paintPaper(x, t, w, h);
        x.save(); x.translate(-ox, -oy);
        /* pictures go under the ink, as on the board */
        pg.objs.forEach(function (o) { if (o.type === 'img') drawObjC(x, o, t, pg); });
        pg.ink.forEach(function (s) { drawS(x, s, t); });
        pg.objs.forEach(function (o) { if (o.type !== 'img') drawObjC(x, o, t, pg); });
        x.restore();
        if (!it.blank) drawCardC(x, it, t, n);
        ctext(x, (it.blank ? 'Whiteboard' + (n ? ' · Page ' + n : '') : it.skill.name + ' · Level ' + it.level + (n ? ' · Question ' + n : '')) + ' · SHLC Maths Skills Lab', 13, 600, t.sub, 16, h - 16, 'left');
        return c;
      }
      function pageBox(pg) {
        var b = { x0: 1e9, y0: 1e9, x1: -1e9, y1: -1e9 }, any = false, here = pg === page();
        pg.ink.forEach(function (s) { var q = strokeBox(s); b.x0 = Math.min(b.x0, q.x0); b.y0 = Math.min(b.y0, q.y0); b.x1 = Math.max(b.x1, q.x1); b.y1 = Math.max(b.y1, q.y1); any = true; });
        pg.objs.forEach(function (o) {
          var bx = here && objsEl ? objsEl.querySelector('[data-id="' + o.id + '"]') : null, s = o.s || 1;
          var ow = bx ? bx.offsetWidth : o.type === 'img' ? o.w * s : 620 * s, oh = bx ? bx.offsetHeight : o.type === 'img' ? o.h * s : 220 * s;
          b.x0 = Math.min(b.x0, o.x); b.y0 = Math.min(b.y0, o.y); b.x1 = Math.max(b.x1, o.x + ow); b.y1 = Math.max(b.y1, o.y + oh); any = true;
        });
        return any ? b : null;
      }
      function download(blob, name) {
        var a = document.createElement('a'), u = URL.createObjectURL(blob); a.href = u; a.download = name;
        document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(u); a.remove(); }, 4000);
      }
      function slug(it) { return it.blank ? 'skills-lab-whiteboard' : 'skills-lab-' + it.skill.id + '-level-' + it.level; }
      function savePNG() {
        var it = item(), n = it.saved ? 0 : it.blank ? st.blank.at + 1 : order().indexOf(st.i) + 1;
        boardCanvas(it, 2).toBlob(function (b) { if (b) download(b, slug(it) + (n ? (it.blank ? '-page' : '-q') + n : '-saved') + '.png'); }, 'image/png');
        track('whiteboard_save', { kind: 'png', skill: it.blank ? 'blank' : it.skill.id });
        st.menu = null; drawTop(); drawPop();
      }
      function jpegBytes(c) { var b = atob(c.toDataURL('image/jpeg', 0.9).split(',')[1]), u = new Uint8Array(b.length); for (var i = 0; i < b.length; i++) u[i] = b.charCodeAt(i); return u; }
      /* a PDF with one JPEG per page, written by hand: A4, turned to suit the board */
      function pdfOf(imgs) {
        var te = new TextEncoder(), parts = [], len = 0, offs = [], kids = [], n = imgs.length;
        function put(v) { var b = typeof v === 'string' ? te.encode(v) : v; parts.push(b); len += b.length; }
        function obj(id, body, stream) { offs[id] = len; put(id + ' 0 obj\n' + body); if (stream) { put('\nstream\n'); put(stream); put('\nendstream'); } put('\nendobj\n'); }
        put('%PDF-1.4\n');
        obj(1, '<< /Type /Catalog /Pages 2 0 R >>');
        for (var i = 0; i < n; i++) kids.push((3 + i * 3) + ' 0 R');
        obj(2, '<< /Type /Pages /Kids [' + kids.join(' ') + '] /Count ' + n + ' >>');
        imgs.forEach(function (im, i) {
          var po = 3 + i * 3, land = im.w >= im.h, PW = land ? 842 : 595, PH = land ? 595 : 842, m = 18;
          var sc = Math.min((PW - 2 * m) / im.w, (PH - 2 * m) / im.h), dw = im.w * sc, dh = im.h * sc;
          var cs = 'q ' + dw.toFixed(2) + ' 0 0 ' + dh.toFixed(2) + ' ' + ((PW - dw) / 2).toFixed(2) + ' ' + ((PH - dh) / 2).toFixed(2) + ' cm /Im' + i + ' Do Q';
          obj(po, '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + PW + ' ' + PH + '] /Resources << /XObject << /Im' + i + ' ' + (po + 2) + ' 0 R >> >> /Contents ' + (po + 1) + ' 0 R >>');
          obj(po + 1, '<< /Length ' + cs.length + ' >>', te.encode(cs));
          obj(po + 2, '<< /Type /XObject /Subtype /Image /Width ' + im.w + ' /Height ' + im.h + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + im.jpg.length + ' >>', im.jpg);
        });
        var size = 3 + n * 3, xr = len, tab = 'xref\n0 ' + size + '\n0000000000 65535 f \n';
        for (var k = 1; k < size; k++) tab += ('000000000' + offs[k]).slice(-10) + ' 00000 n \n';
        put(tab + 'trailer\n<< /Size ' + size + ' /Root 1 0 R >>\nstartxref\n' + xr + '\n%%EOF\n');
        return new Blob(parts, { type: 'application/pdf' });
      }
      function savePDF() {
        flush();
        var its = st.saved ? [st.saved] : st.blank ? st.blank.ids.map(blankIt).filter(hasWork) : order().map(function (k) { return S.set[k]; }).filter(hasWork);
        if (!its.length) its = [item()];
        var imgs = its.map(function (it) { var c = boardCanvas(it, 1.6); return { jpg: jpegBytes(c), w: c.width, h: c.height }; });
        download(pdfOf(imgs), slug(its[0]) + (its[0].blank ? '.pdf' : '-whiteboard.pdf'));
        track('whiteboard_save', { kind: 'pdf', skill: its[0].blank ? 'blank' : its[0].skill.id, pages: imgs.length });
        st.menu = null; drawTop(); drawPop();
      }

      /* ---------- the calculator (round 5, Aadam: "add scientific calc in - use code from calc already made in tools") ----------
         The fx-83GTX calculator from /pages/scientific-calculator, in a panel over the board: its maths is the theme asset
         shlc-calc-core.js and its keys and screen shlc-calc-panel.js (built by scientific-calculator/panel/build.js), both
         loaded from beside this file the first time the button is pressed. It drags by its top bar; Put on board writes the
         last sum and its answer on the board, fractions stacked as on its screen. */
      var calcApi = null, calcLoading = false, calcDrag = null;
      function calcNodes(list, d) {
        if (!Array.isArray(list) || d > 6) return '';
        return list.map(function (n) {
          if (!n || typeof n !== 'object') return '';
          if (n.ch) return '<span class="' + String(n.c || '').split(/\s+/).filter(function (c) { return /^[a-z0-9]{1,12}$/.test(c); }).map(function (c) { return 'wc-' + c; }).join(' ') + '">' + esc(String(n.t)) + '</span>';
          if (n.fr) return '<span class="wc-fr"><span class="wc-fn">' + calcNodes(n.num, d + 1) + '</span><span class="wc-fd">' + calcNodes(n.den, d + 1) + '</span></span>';
          if (n.sq) return '<span class="wc-sq"><span class="wc-rs">√</span><span class="wc-sqr">' + calcNodes(n.kids, d + 1) + '</span></span>';
          if (n.rt) return '<span class="wc-sq"><sup class="wc-ri">' + calcNodes(n.idx, d + 1) + '</sup><span class="wc-rs">√</span><span class="wc-sqr">' + calcNodes(n.kids, d + 1) + '</span></span>';
          if (n.pw) return '<sup class="wc-pw">' + calcNodes(n.kids, d + 1) + '</sup>';
          return '';
        }).join('');
      }
      function calcText(list) {
        return (Array.isArray(list) ? list : []).map(function (n) {
          if (!n || typeof n !== 'object') return '';
          var w = function (l) { var t = calcText(l); return /^[\w.√π]+$/.test(t) ? t : '(' + t + ')'; };
          if (n.ch) return String(n.t);
          if (n.fr) return w(n.num) + '/' + w(n.den);
          if (n.sq) return '√' + w(n.kids);
          if (n.rt) return w(n.idx) + '√' + w(n.kids);
          if (n.pw) return '^' + w(n.kids);
          return '';
        }).join('').replace(/\s+/g, ' ').trim();
      }
      function toggleCalc(on) {
        if (!calcEl) return;
        st.calc = on === undefined ? !st.calc : !!on;
        calcEl.hidden = !st.calc; drawDock();
        if (!st.calc) { if (calcEl.contains(document.activeElement)) { try { root.focus({ preventScroll: true }); } catch (er) {} } return; }
        placeCalc();
        if (calcApi) { calcApi.focus(); return; }
        loadCalc(function (ok) {
          if (!ok || !window.SHLCCalcPanel) { st.calc = false; calcEl.hidden = true; drawDock(); toast('The calculator did not load. Check the connection and try again.'); return; }
          if (!calcApi) calcApi = window.SHLCCalcPanel.mount(calcEl.querySelector('.wb-calcb'));
          placeCalc(); if (st.calc && calcApi) calcApi.focus();
        });
        track('whiteboard_calc', {});
      }
      function loadCalc(cb) {
        if (window.SHLCCalcPanel && window.SHLCCalcCore) { cb(true); return; }
        if (calcLoading) return;
        calcLoading = true;
        var sc = document.querySelector('script[src*="skills-lab-core"]'), m = /^(.*\/)skills-lab-core[^\/?]*(\?.*)?$/.exec(sc ? sc.getAttribute('src') : '');
        var base = m ? m[1] : 'assets/', qs = m && m[2] ? m[2] : '';
        function add(name, next) { var x = document.createElement('script'); x.src = base + name + qs; x.onload = next; x.onerror = function () { calcLoading = false; cb(false); }; document.head.appendChild(x); }
        var panel = function () { add('shlc-calc-panel.js', function () { calcLoading = false; cb(!!window.SHLCCalcPanel); }); };
        if (window.SHLCCalcCore) panel(); else add('shlc-calc-core.js', panel);
      }
      function placeCalc() {
        if (!calcEl || calcEl.hidden || !W) return;
        /* a short board: the keys shrink so the whole calculator sits clear of the bar */
        var cp = calcEl.querySelector('.shlc-cp');
        if (cp) {
          cp.style.zoom = ''; cp.style.margin = ''; cp.style.width = ''; calcEl.style.width = '';
          /* ROUND 8 (Aadam: "need to be able to resize calc"): the corner sets its size (calcZ); never taller than the room
             there is, and on a phone it starts small enough to leave half the board free. The keys sit in the middle;
             a small one drops its title so the top bar fits */
          var room = H - 16 - (st.dock.m === 'bottom' && dockEl ? dockEl.offsetHeight + 28 : 0) - 48, ch0 = cp.offsetHeight || room;
          var fitK = Math.min(room / ch0, (W - 16) / 340), want = st.calcZ !== null ? st.calcZ : W < 640 ? 0.72 : 1;
          var k = clamp(Math.min(want, fitK), 0.45, 1.5);
          cp.style.zoom = k; cp.style.margin = '0 auto'; cp.style.width = '340px';
          calcEl.style.width = Math.round(Math.max(340 * k < 300 ? 200 : 304, 340 * k)) + 'px';
          calcEl.classList.toggle('is-small', 340 * k < 300);
        }
        var cw = calcEl.offsetWidth || 340, ch = calcEl.offsetHeight || 560, a = st.calcAt;
        var x = a ? a.x * W : W - cw - 16, y = a ? a.y * H : 16;
        calcEl.style.left = Math.round(clamp(x, 8, Math.max(8, W - cw - 8))) + 'px'; calcEl.style.top = Math.round(clamp(y, 8, Math.max(8, H - ch - 8))) + 'px';
      }
      var calcSz = null;
      function calcDown(e) {
        var nb = e.target.closest ? e.target.closest('[data-calcsz]') : null;
        if (nb && e.button <= 0) {
          e.preventDefault(); e.stopPropagation(); hideTip();
          var cp = calcEl.querySelector('.shlc-cp'); calcSz = { id: e.pointerId, p: ptS(e), k: cp ? parseFloat(cp.style.zoom) || 1 : 1 };
          try { calcEl.setPointerCapture(e.pointerId); } catch (er) {}
          return;
        }
        var h = e.target.closest ? e.target.closest('[data-wbcalc]') : null;
        if (!h || e.button > 0 || (e.target.closest && e.target.closest('button'))) return;
        e.preventDefault(); hideTip();
        var q = ptS(e); calcDrag = { id: e.pointerId, dx: q.x - calcEl.offsetLeft, dy: q.y - calcEl.offsetTop };
        try { calcEl.setPointerCapture(e.pointerId); } catch (er) {}
        calcEl.classList.add('is-moving');
      }
      function calcMove(e) {
        if (calcSz && e.pointerId === calcSz.id) {
          var q0 = ptS(e), dx = Math.max(q0.x - calcSz.p.x, (q0.y - calcSz.p.y) * 0.55);
          st.calcZ = clamp(calcSz.k + dx / 340, 0.45, 1.5); placeCalc(); return;
        }
        if (!calcDrag || e.pointerId !== calcDrag.id) return;
        var q = ptS(e), cw = calcEl.offsetWidth, ch = calcEl.offsetHeight;
        calcEl.style.left = Math.round(clamp(q.x - calcDrag.dx, 8, Math.max(8, W - cw - 8))) + 'px'; calcEl.style.top = Math.round(clamp(q.y - calcDrag.dy, 8, Math.max(8, H - ch - 8))) + 'px';
      }
      function calcUp() {
        if (calcSz) { calcSz = null; keep(); return; }
        if (!calcDrag) return; calcDrag = null; calcEl.classList.remove('is-moving');
        st.calcAt = { x: clamp(calcEl.offsetLeft / (W || 1), 0, 1), y: clamp(calcEl.offsetTop / (H || 1), 0, 1) }; keep();
        if (calcApi) calcApi.focus();
      }
      function calcPut() {
        var a = calcApi && calcApi.answer();
        if (!a) { toast('Press = on the calculator first'); return; }
        var pg = page(), v = view(), sx = clamp(calcEl.offsetLeft - 380, 16, Math.max(16, W - 300)), sy = clamp(calcEl.offsetTop + 60, 16, Math.max(16, H - 160));
        if (sx + 300 > calcEl.offsetLeft && calcEl.offsetLeft < W / 2) sx = Math.min(W - 300, calcEl.offsetLeft + calcEl.offsetWidth + 24);
        var o = { id: 'w' + Date.now().toString(36) + (++oid), type: 'calc', ex: a.ex, res: a.res, x: Math.round(v.x + sx / v.z), y: Math.round(v.y + sy / v.z), s: Math.round(100 / v.z) / 100 };
        snap(pg); pg.objs.push(o); st.sel = null;
        drawObjs(); drawSide(); dirty();
        toast('Sum put on the board', function () { undo(); });
        track('whiteboard_calc_put', {});
        /* round 10: the keys go back to the board, ready to move or delete the sum; a press on a calculator key takes them again */
        try { root.focus({ preventScroll: true }); } catch (er) {}
      }

      /* ---------- SHARE (round 7, Aadam's pick 4: share a board with a student) ----------
         A picture of each page goes to shlc-boards (a Cloudflare worker, skill-lab/whiteboard-r4-2026-10-22/share-worker)
         and comes back as a link and a QR code; the student can look and zoom, never draw. It lasts 1, 7 or 30 days, and
         this device keeps the link's key so it can be turned off early. */
      var SHARE = 'https://shlc-boards.techbwoi.workers.dev', KSH = 'shlc_sl_wb_shares';
      var shares = (function () { try { var v = JSON.parse(localStorage.getItem(KSH) || '{}'); return v && typeof v === 'object' && !Array.isArray(v) ? v : {}; } catch (e) { return {}; } })();
      var shOpt = { all: true, days: 7, busy: false };
      function shareKey() { return st.blank ? 'blank|' + st.blank.ids[0] : st.saved ? keyOf(st.saved) : 'set|' + order().map(function (k) { return keyOf(S.set[k]); }).join('~').slice(0, 300); }
      function shareNow() { var sh = shares[shareKey()]; if (sh && sh.ends < Date.now()) { delete shares[shareKey()]; lsSet(KSH, shares); sh = null; } return sh || null; }
      function shareItems(all) {
        if (!all || st.saved) return [item()];
        var its = st.blank ? st.blank.ids.map(blankIt).filter(hasWork) : order().map(function (k) { return S.set[k]; }).filter(hasWork);
        return its.length ? its : [item()];
      }
      function shareHTML() {
        var sh = shareNow(), n = shareItems(true).length;
        if (sh) {
          var ends = new Date(sh.ends).toLocaleDateString('en-GB', { day: 'numeric', month: 'long' });
          return '<div class="wb-cph"><b>Shared</b></div><div class="wb-shrow"><img class="wb-shqr" src="' + SHARE + '/qr/' + esc(sh.id) + '.svg" alt="QR code for the link" width="150" height="150">' +
            '<div class="wb-shtxt"><span>A student points their phone camera at this, or you send them the link.</span><span>They can look and zoom, not draw or change anything. Until ' + esc(ends) + '.</span></div></div>' +
            '<div class="wb-shlink"><input class="wb-shurl" readonly value="' + esc(SHARE + '/b/' + sh.id) + '" aria-label="The link"><button type="button" class="wb-b wb-shcopy" data-wbsh="copy">Copy link</button></div>' +
            '<div class="wb-shfoot"><button type="button" class="wb-b" data-wbsh="again">Share it again with today\'s working</button><button type="button" class="wb-b wb-shoff" data-wbsh="off">Turn the link off</button></div>';
        }
        return '<div class="wb-cph"><b>Share this board</b></div>' +
          '<p class="wb-shp">Students get a link (and a QR code) to look at the board on their own device. They can look and zoom, not draw or change anything.</p>' +
          (n > 1 ? '<div class="wb-seg wb-shseg"><button type="button" class="wb-segb' + (shOpt.all ? ' is-on' : '') + '" data-wbsh="all:1">' + (st.blank ? 'All ' + n + ' pages' : 'All ' + n + ' with working') + '</button><button type="button" class="wb-segb' + (shOpt.all ? '' : ' is-on') + '" data-wbsh="all:0">Just this one</button></div>' : '') +
          '<div class="wb-seg wb-shseg"><span class="wb-segl">Keep the link for</span>' + [1, 7, 30].map(function (d) { return '<button type="button" class="wb-segb' + (shOpt.days === d ? ' is-on' : '') + '" data-wbsh="days:' + d + '">' + d + (d === 1 ? ' day' : ' days') + '</button>'; }).join('') + '</div>' +
          '<button type="button" class="wb-b wb-shgo" data-wbsh="make"' + (shOpt.busy ? ' disabled' : '') + '>' + (shOpt.busy ? 'Making the link' : 'Make the link') + '</button>';
      }
      function jpegOf(it) {
        var c = boardCanvas(it, it.blank ? 2 : 1.25), u = c.toDataURL('image/jpeg', 0.82);
        if (u.length > 1500000) u = boardCanvas(it, 0.9).toDataURL('image/jpeg', 0.7);
        return u;
      }
      function shareAct(a) {
        var c = a.indexOf(':'), n = c >= 0 ? a.slice(0, c) : a, k = c >= 0 ? a.slice(c + 1) : '';
        if (n === 'all') { shOpt.all = k === '1'; drawPop(); return; }
        if (n === 'days') { shOpt.days = Number(k) || 7; drawPop(); return; }
        if (n === 'copy') { var u = popEl.querySelector('.wb-shurl'); try { navigator.clipboard.writeText(u.value).then(function () { toast('Link copied'); }, function () { u.select(); }); } catch (e) { u.select(); } return; }
        if (n === 'again') { var old = shareNow(); if (old) { delete shares[shareKey()]; lsSet(KSH, shares); shareOff(old, true); } drawPop(); return; }
        if (n === 'off') { var sh = shareNow(); if (!sh) return; delete shares[shareKey()]; lsSet(KSH, shares); shareOff(sh); drawPop(); return; }
        if (n === 'make' && !shOpt.busy) {
          flush(); shOpt.busy = true; drawPop();
          var key = shareKey(), its = shareItems(shOpt.all), pages = its.map(jpegOf), it0 = item();
          var title = it0.blank ? 'Whiteboard' : it0.skill.name + ' · Level ' + it0.level;
          fetch(SHARE + '/api/b', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ title: title, days: shOpt.days, pages: pages }) })
            .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
            .then(function (j) { shOpt.busy = false; shares[key] = { id: j.id, token: j.token, ends: j.ends }; lsSet(KSH, shares); drawTop(); if (st.menu === 'share') drawPop(); track('whiteboard_share', { pages: pages.length, days: shOpt.days }); })
            .catch(function () { shOpt.busy = false; if (st.menu === 'share') drawPop(); toast('The link could not be made. Check the connection and try again.'); });
        }
      }
      function shareOff(sh, quiet) {
        fetch(SHARE + '/api/b/' + sh.id, { method: 'DELETE', headers: { 'X-Edit-Token': sh.token } }).then(function () { if (!quiet) toast('The link is off. It no longer opens.'); }, function () { if (!quiet) toast('Could not reach the server; the link ends on its own date.'); });
      }

      /* ---------- pictures in: a file, a paste, a drop ---------- */
      /* a picture dragged from another web page: fetched, so it is a copy kept with the board; most sites let it be read */
      function addImageUrl(u, at) {
        if (/^data:image\//.test(u)) { fetch(u).then(function (r) { return r.blob(); }).then(function (b) { addImageFile(new File([b], 'p', { type: b.type }), at); }, function () {}); return; }
        if (!/^https?:\/\//i.test(u)) return;
        var bad = function () { toast('That website will not share its picture. Save it to your computer, then drag the file in.'); };
        fetch(u, { mode: 'cors', credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.blob(); }).then(function (b) {
          if (!/^image\//.test(b.type)) return bad();
          addImageFile(new File([b], 'p', { type: b.type }), at);
        }).catch(bad);
      }
      function addImageFile(f, at) {
        if (!f || !/^image\//.test(f.type) || !st.open) return;
        var rd = new FileReader();
        rd.onload = function () {
          var im = new Image();
          im.onload = function () {
            /* kept to 1600px on its long side, so a phone photo does not fill the device's storage */
            var nw = im.naturalWidth, nh = im.naturalHeight, k = Math.min(1, 1600 / Math.max(nw, nh)), c = document.createElement('canvas');
            c.width = Math.max(1, Math.round(nw * k)); c.height = Math.max(1, Math.round(nh * k));
            var x = c.getContext('2d'); x.drawImage(im, 0, 0, c.width, c.height);
            var url = f.type === 'image/png' || f.type === 'image/gif' || f.type === 'image/svg+xml' ? c.toDataURL('image/png') : c.toDataURL('image/jpeg', 0.88);
            if (url.length > 2600000) url = c.toDataURL('image/jpeg', 0.8);
            addImage(url, c.width, c.height, at);
          };
          im.onerror = function () { toast('That picture could not be opened'); };
          im.src = rd.result;
        };
        rd.readAsDataURL(f);
      }
      function addImage(url, w, h, at) {
        var pg = page(), v = view(), room = Math.min(1, (Math.max(W, 320) * 0.6) / w, (Math.max(H, 240) * 0.6) / h), dw = Math.round(w * room), dh = Math.round(h * room);
        var ref = 'i' + Date.now().toString(36) + (++oid), o = { id: 'w' + Date.now().toString(36) + (++oid), type: 'img', ref: ref, w: dw, h: dh, s: Math.round(100 / v.z) / 100, lock: false };
        var cw = dw * o.s, chh = dh * o.s, vx0 = v.x, vy0 = v.y, vw = W / v.z, vh = H / v.z;
        o.x = Math.round(clamp((at ? at.x : vx0 + vw / 2) - cw / 2, vx0, Math.max(vx0, vx0 + vw - cw))); o.y = Math.round(clamp((at ? at.y : vy0 + vh / 2 - 40 / v.z) - chh / 2, vy0, Math.max(vy0, vy0 + vh - chh)));
        snap(pg); pg.imgs[ref] = url; pg.objs.push(o); st.sel = o.id; st.menu = null; st.pick = null;
        if (st.tool === 'select' || st.tool === 'eraser' || st.tool === 'laser') setTool('pen');
        drawObjs(); drawIns(); drawDock(); drawSide(); drawPick(); dirty();
        toast('Drag the picture to move it. Tap off it to draw.', function () { undo(); });
        track('whiteboard_image', {});
      }
      function onPaste(e) {
        if (!st.open) return;
        var t = e.target, typing = t && /^(INPUT|TEXTAREA)$/.test(t.tagName), items = (e.clipboardData && e.clipboardData.items) || [];
        for (var i = 0; i < items.length; i++) if (items[i].kind === 'file' && /^image\//.test(items[i].type)) { var f = items[i].getAsFile(); if (f) { e.preventDefault(); addImageFile(f); return; } }
        if (!typing && clip) { e.preventDefault(); pasteClip(); }
      }
      /* Ctrl C with nothing picked: the board as a picture on the clipboard, ready for slides */
      function copyBoard() {
        var it = item();
        if (!navigator.clipboard || !window.ClipboardItem) { toast('This browser cannot copy pictures. Use the boards menu to download one.'); return; }
        try {
          var pr = new Promise(function (res) { boardCanvas(it, 2).toBlob(function (b) { res(b); }, 'image/png'); });
          navigator.clipboard.write([new ClipboardItem({ 'image/png': pr })]).then(function () { toast('Board copied as a picture'); }, function () { toast('Copy did not work here. Use the boards menu to download it.'); });
        } catch (er) { toast('Copy did not work here. Use the boards menu to download it.'); }
      }

      /* ---------- a short message at the foot of the board, with Undo where it can be undone ---------- */
      var toastT = 0, toastUndo = null;
      function toast(msg, undoFn) {
        if (!toastEl) return;
        toastUndo = undoFn || null;
        toastEl.innerHTML = '<span>' + esc(msg) + '</span>' + (undoFn ? '<button type="button" class="wb-oc wb-tundo" data-wb="toastundo">Undo</button>' : '');
        toastEl.hidden = false; toastEl.classList.remove('is-in'); void toastEl.offsetWidth; toastEl.classList.add('is-in');
        clearTimeout(toastT); toastT = setTimeout(hideToast, undoFn ? 6000 : 3200);
      }
      /* a message with its own buttons (the graph offer): each button does its thing and closes the message */
      var toastFns = [];
      function toastAct(msg, acts) {
        if (!toastEl) return;
        toastUndo = null; toastFns = acts.map(function (a) { return a[1]; });
        toastEl.innerHTML = '<span>' + esc(msg) + '</span>' + acts.map(function (a, k) { return '<button type="button" class="wb-oc wb-tundo' + (k ? '' : ' is-go') + '" data-wb="toastgo:' + k + '">' + esc(a[0]) + '</button>'; }).join('') +
          '<button type="button" class="wb-oc wb-tundo" data-wb="toastno">No</button>';
        toastEl.hidden = false; toastEl.classList.remove('is-in'); void toastEl.offsetWidth; toastEl.classList.add('is-in');
        clearTimeout(toastT); toastT = setTimeout(hideToast, 12000);
      }
      function hideToast() { clearTimeout(toastT); toastUndo = null; if (toastEl) { toastEl.hidden = true; toastEl.classList.remove('is-in'); } }

      /* TAB (round 4): the tools hide for a clean board at the front of the room; Tab, or the eye in the corner, brings them back */
      function setBare(on) { st.bare = !!on; if (root) root.classList.toggle('is-bare', st.bare); if (st.bare) { st.menu = null; drawPop(); drawIns(); } hideTip(); }

      /* ---------- clicks ---------- */
      function setTool(t) {
        st.tool = t; if (isShape(t) && st.shape !== t) { st.shape = t; keep(); }
        if (t !== 'laser') { hover = null; loop(); } if (t !== 'select' && st.pick) setPick(null); if (cvI) cvI.style.cursor = '';
        if (st.menu === 'tray' && !styled(t)) st.menu = null;
        paintBoard(); drawDock();
      }
      function applySkill(id, lv) {
        var sk = SL.get(id); if (!sk) return;
        var from = st.from; flush();
        S.skill = sk.id; S.from = 'skills'; setSel(sk, [lv]);
        if (!SL.ready(sk.id) && cardEl) cardEl.classList.add('is-wait');
        withSkills([sk.id], null, function () {
          buildSet(); S.teach.i = 0; S.prOne = -1;
          if (S.screen === from) show(from);
          st.i = from === 'teach' ? (teachOrder()[0] || 0) : 0; st.menu = null; st.sel = null; st.skQ = ''; st.skPick = null;
          st.saved = null; drawAll(); redraw();
          if (from === 'teach' && S.screen === 'teach') shell.classList.add('wb-on');
        });
      }
      function markIt(got) { var it = item(); if (st.blank || st.saved || st.from !== 'practise' || it.state === 'ok' || it.state === 'miss') return; mark(it, got); drawTop(); drawSide(); }
      function act(a) {
        hideTip();
        var c = a.indexOf(':'), k = c >= 0 ? a.slice(c + 1) : '', n = c >= 0 ? a.slice(0, c) : a;
        if (n === 'close') { close(); return; }
        if (n === 'side') { st.side = !st.side; keep(); drawSide(); return; }
        if (n === 'keep') {
          var it = item(), pg = page(), kk = keyOf(it);
          pg.keep = !pg.keep;
          if (pg.keep) { dirty(it); flush(); toast('Board saved on this device. Find it in the boards menu.'); }
          else { delete store[kk]; writeStore(); toast('This board is no longer saved'); }
          drawTop(); if (st.menu === 'boards') drawPop(); return;
        }
        if (n === 'newpage') { newPage(); return; }
        if (n === 'freshall') { freshAll(); return; }
        if (n === 'bare') { setBare(!st.bare); return; }
        if (n === 'img') { st.menu = null; drawIns(); drawPop(); drawDock(); fileEl.click(); return; }
        if (n === 'toastgo') { var tf = toastFns[Number(k)]; toastFns = []; hideToast(); if (tf) tf(); return; }
        if (n === 'toastno') { toastFns = []; hideToast(); return; }
        if (n === 'toastundo') { var fn = toastUndo; hideToast(); if (fn) fn(); return; }
        if (n === 'colreset') { delete st.cols[th().id]; keep(); hsv = hexHsv(slotHex(st.colFor)); paintBoard(); drawDock(); drawPop(); drawPick(); return; }
        if (n === 'pickdel') { pickOp('del'); return; }
        if (n === 'pickdup') { pickOp('dup'); return; }
        if (n === 'pickturn') { pickOp('turn', 90); return; }
        if (n === 'pickcol') { pickOp('col', k); return; }
        if (n === 'more') { st.menu = st.menu === 'more' ? null : 'more'; drawTop(); drawDock(); drawIns(); drawPop(); return; }
        if (n === 'stamp') { addStamp(k); return; }
        if (n === 'share') { st.menu = st.menu === 'share' ? null : 'share'; drawTop(); drawDock(); drawIns(); drawPop(); return; }
        if (n === 'ruler') { toggleRuler(); return; }
        if (n === 'timer') { st.menu = st.menu === 'timer' ? null : 'timer'; drawIns(); drawDock(); drawPop(); return; }
        if (n === 'replay') { if (rp) replayAct('now'); else replayOpen(); drawTop(); return; }
        if (n === 'press') { st.press = !st.press; keep(); drawTray(); return; }
        if (n === 'smooth') { st.smooth = clamp(Number(k), 0, 2); keep(); drawTray(); return; }
        if (n === 'tray') { st.menu = st.menu === 'tray' ? null : 'tray'; drawTop(); drawDock(); drawIns(); drawPop(); return; }
        if (n === 'hlc') { st.hlc = clamp(Number(k), 0, 4); if (st.tool !== 'hl') setTool('hl'); keep(); drawDock(); return; }
        if (n === 'shp') { setTool(k === 'arrow' ? 'arrow' : 'line'); return; }
        if (n === 'calc') { toggleCalc(); return; }
        if (n === 'calcput') { calcPut(); return; }
        if (n === 'zoom') { zoomBy(k); return; }
        if (n === 'addq') { st.menu = st.menu === 'addq' ? null : 'addq'; drawTop(); drawDock(); drawIns(); drawPop(); if (st.menu === 'addq') { if (aq.sk && !aq.prev) aqPreview(); drawPop(); var aqs = popEl.querySelector('.wb-aqsearch'); if (aqs && !('ontouchstart' in window)) aqs.focus(); } return; }
        if (n === 'skills' || n === 'theme' || n === 'ins' || n === 'boards') { st.menu = st.menu === n ? null : n; st.skPick = null; drawTop(); drawDock(); drawIns(); drawPop(); if (st.menu === 'skills') { var q = popEl.querySelector('.wb-skq'); if (q && !('ontouchstart' in window)) q.focus(); } return; }
        if (n === 'prev') { step(-1); return; }
        if (n === 'next') { step(1); return; }
        if (n === 'ok' || n === 'miss') { markIt(n === 'ok'); return; }
        if (n === 'full') { toggleFull(); return; }
        if (n === 'fresh') { freshHere(); return; }
        if (n === 'teach') { toTeach(); return; }
        if (n === 'tool') {
          /* the tool in use, tapped again: its colours and sizes */
          var tk = k === 'shape' ? st.shape : k, same = k === 'shape' ? isShape(st.tool) : st.tool === k;
          if (same && styled(tk)) { st.menu = st.menu === 'tray' ? null : 'tray'; drawDock(); drawIns(); drawPop(); return; }
          if (same && tk === 'select') { st.selMode = st.selMode === 'lasso' ? 'box' : 'lasso'; keep(); drawDock(); toast(st.selMode === 'lasso' ? 'Lasso: draw round what you want' : 'Box select'); return; }
          setTool(tk); return;
        }
        if (n === 'col') {
          var ck = Number(k);
          /* tap the colour in use again (or right-click any colour) to change it */
          if (ck === st.col && st.menu !== 'col' && st.tool !== 'eraser' && st.tool !== 'laser' && st.tool !== 'select') { openCol(ck); return; }
          if (st.menu === 'col') { if (ck === st.colFor) { st.menu = null; st.colFor = -1; drawPop(); drawDock(); return; } openCol(ck); return; }
          st.col = ck; if (st.tool !== 'pen' && st.tool !== 'line' && st.tool !== 'arrow') st.tool = 'pen'; keep(); paintBoard(); drawDock(); return;
        }
        if (n === 'size') { st.size = Number(k); keep(); drawDock(); return; }
        if (n === 'th') { st.theme = Number(k); keep(); paintBoard(); drawCard(); drawDock(); drawPop(); redraw(); drawPick(); return; }
        if (n === 'pat') { st.pat = k; keep(); paintBoard(); drawPop(); return; }
        if (n === 'add' && k === 'graph') { st.menu = null; drawIns(); drawDock(); addGraph('', null, false); return; }
        if (n === 'add') { var o = mkObj(k), pg = page(); snap(pg); pg.objs.push(o); st.sel = o.id; st.menu = null; drawObjs(); drawIns(); drawDock(); drawSide(); dirty(); return; }
        if (n === 'undo' || n === 'redo') { if (n === 'undo' && undoHold === -1) { undoHold = 0; return; } if (rp) replayAct('now'); undo(n === 'redo'); return; }
        if (n === 'png') { savePNG(); return; }
        if (n === 'pdf') { savePDF(); return; }
        if (n === 'delall') {
          if (!window.confirm('Delete every saved board on this device?')) return;
          store = {}; writeStore(); Object.keys(pages).forEach(function (pk) { pages[pk].keep = false; });
          if (st.saved) { delete pages[keyOf(st.saved)]; st.saved = null; } st.sel = null; st.pick = null; st.menu = null; drawAll(); redraw(); return;
        }
        if (n === 'clear') { var p = page(); if (!p.ink.length && !p.objs.length) return; st.menu = null; drawTop(); drawPop(); snap(p); p.ink = []; p.objs = []; st.sel = null; st.pick = null; redraw(); drawObjs(); drawSide(); drawPick(); dirty(); toast('Board cleared', function () { undo(); }); return; }
      }
      function undo(re) {
        var p = page(), from = re ? p.fut : p.hist, to = re ? p.hist : p.fut;
        if (!from.length) return;
        to.push(snapOf(p)); var h = from.pop(); p.ink = h.ink; p.objs = JSON.parse(h.objs);
        if (st.sel && !findObj(st.sel)) st.sel = null;
        st.pick = null;
        redraw(); drawObjs(); drawSide(); drawPick(); dirty();
      }
      function onClick(e) {
        var t = e.target.closest ? e.target.closest('button') : null; if (!t || t.disabled) return;
        if (t.hasAttribute('data-wb')) {
          if (t.classList.contains('wb-morer')) { st.menu = null; drawPop(); drawTop(); }
          act(t.getAttribute('data-wb')); return;
        }
        if (t.hasAttribute('data-wbsv')) { openSaved(t.getAttribute('data-wbsv')); return; }
        if (t.hasAttribute('data-wbaq')) { aqAct(t.getAttribute('data-wbaq')); return; }
        if (t.hasAttribute('data-wbsh')) { shareAct(t.getAttribute('data-wbsh')); drawTop(); return; }
        if (t.hasAttribute('data-wbtm')) { timerAct(t.getAttribute('data-wbtm')); return; }
        if (t.hasAttribute('data-wbrp')) { replayAct(t.getAttribute('data-wbrp')); drawTop(); return; }
        if (t.hasAttribute('data-wbdel')) {
          /* deleting the saved copy keeps any working still open on the page; it just stops being kept */
          var dk = t.getAttribute('data-wbdel'); delete store[dk]; writeStore(); if (pages[dk]) pages[dk].keep = false;
          if (st.saved && keyOf(st.saved) === dk) { delete pages[dk]; st.saved = null; st.sel = null; st.pick = null; drawAll(); }
          else { drawPop(); drawSide(); drawObjs(); drawTop(); }
          redraw(); return;
        }
        if (t.hasAttribute('data-wbq')) { go(Number(t.getAttribute('data-wbq'))); if (narrow()) { st.side = false; drawSide(); } return; }
        if (t.hasAttribute('data-wbfresh')) { freshHere(Number(t.getAttribute('data-wbfresh'))); return; }
        if (t.hasAttribute('data-wbc')) { var hx = t.getAttribute('data-wbc'); hsv = hexHsv(hx); setSlot(st.colFor, hx); drawPop(); drawPick(); return; }
        if (t.hasAttribute('data-wbsk')) { var sk = SL.get(t.getAttribute('data-wbsk')); st.skPick = sk.id; if (sk.levels && sk.levels.length === 1) { applySkill(sk.id, 1); return; } drawPop(); return; }
        if (t.hasAttribute('data-wblv')) { applySkill(st.skPick || item().skill.id, Number(t.getAttribute('data-wblv'))); return; }
        if (t.hasAttribute('data-oc')) { var box = t.closest('.wb-obj'), o = box && findObj(box.getAttribute('data-id')); if (o && opObj(o, t.getAttribute('data-oc'))) { drawObjs(); drawSide(); dirty(); } return; }
      }

      /* ---------- keys, while the board is open (the lab's own keys wait) ---------- */
      /* KEYS (round 4 adds): V select; Shift N a new set; 1 to 6 the pen slots; G the paper; Tab hides the tools; held E or
         K rub out or point only while held; with a pick, Delete, Ctrl D, Ctrl C and the arrows work on the pick; Ctrl C with
         nothing picked copies the board as a picture; Ctrl V pastes a copied pick (a picture paste is the paste event) */
      var spring = null;
      function key(e) {
        var k = e.key || '', t = e.target, typing = t && /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName), mod = e.metaKey || e.ctrlKey;
        /* the calculator in front takes the typing; Escape hands the keys back to the board */
        if (calcEl && st.calc && t && calcEl.contains(t)) {
          if (k === 'Escape') { e.preventDefault(); try { root.focus({ preventScroll: true }); } catch (er) {} }
          return;
        }
        if (k === 'Escape') {
          e.preventDefault(); if (typing) { t.blur(); return; }
          if (st.bare) { setBare(false); return; }
          if (st.menu || st.sel || st.pick) { st.menu = null; st.sel = null; st.pick = null; st.colFor = -1; drawAll(); return; }
          close(); return;
        }
        if (typing) return;
        if (k === 'Tab') { e.preventDefault(); setBare(!st.bare); return; }
        if (mod && (k === 'z' || k === 'Z')) { e.preventDefault(); undo(e.shiftKey); return; }
        if (mod && (k === 'y' || k === 'Y')) { e.preventDefault(); undo(true); return; }
        if (mod && (k === 'c' || k === 'C')) { e.preventDefault(); if (!copyPick()) copyBoard(); return; }
        if (mod && (k === 'd' || k === 'D')) { e.preventDefault(); if (st.pick) pickOp('dup'); return; }
        if (mod || e.altKey) return;
        var low = k.toLowerCase();
        if (st.pick && (k === 'Delete' || k === 'Backspace')) { e.preventDefault(); pickOp('del'); return; }
        if (st.pick && (k === 'r' || k === 'R')) { e.preventDefault(); pickOp('turn', e.shiftKey ? -90 : 90); return; }
        if (st.pick && /^Arrow/.test(k)) {
          e.preventDefault(); var d = e.shiftKey ? 20 : 2;
          pickOp('nudge', { x: k === 'ArrowLeft' ? -d : k === 'ArrowRight' ? d : 0, y: k === 'ArrowUp' ? -d : k === 'ArrowDown' ? d : 0 }); return;
        }
        var tool = { v: 'select', p: 'pen', h: 'hl', l: 'line', a: 'arrow', k: 'laser', e: 'eraser' }[low];
        if (tool) {
          e.preventDefault(); if (e.repeat) return;
          /* E and K held: back to the tool before once the key is let go (a quick tap still just switches) */
          if ((low === 'e' || low === 'k') && st.tool !== tool) spring = { key: low, from: st.tool, t: Date.now() }; else spring = null;
          setTool(tool); return;
        }
        if (st.tool === 'hl' && /^[1-5]$/.test(k)) { e.preventDefault(); act('hlc:' + (Number(k) - 1)); return; }
        if (/^[1-6]$/.test(k)) {
          e.preventDefault(); var sk6 = Number(k) - 1;
          if (st.menu === 'col') { openCol(sk6); return; }
          st.col = sk6; if (st.tool !== 'pen' && st.tool !== 'line' && st.tool !== 'arrow') setTool('pen'); keep(); paintBoard(); drawDock(); return;
        }
        if (k === 'ArrowRight' || k === 'ArrowDown') { e.preventDefault(); step(1); return; }
        if (k === 'ArrowLeft' || k === 'ArrowUp') { e.preventDefault(); step(-1); return; }
        if (low === 'w') { e.preventDefault(); close(); return; }
        if (low === 'f') { e.preventDefault(); toggleFull(); return; }
        if (low === 'n') { e.preventDefault(); if (st.blank) newPage(); else if (e.shiftKey) freshAll(); else freshHere(); return; }
        if (low === 'g') { e.preventDefault(); st.pat = PATS[(PATS.indexOf(st.pat) + 1) % PATS.length]; keep(); paintBoard(); if (st.menu === 'theme') drawPop(); toast({ dots: 'Dots', squares: 'Squares', lines: 'Lines', plain: 'Plain' }[st.pat] + ' paper'); return; }
        if (low === 't') { e.preventDefault(); toTeach(); return; }
        if (low === 'c' || low === 'x') { e.preventDefault(); markIt(low === 'c'); return; }
        if (k === '[' || k === ']') { e.preventDefault(); act('size:' + clamp(st.size + (k === ']' ? 1 : -1), 0, 2)); return; }
        if (k === ' ') { e.preventDefault(); if (isBlankIt()) { if (!panKey) { panKey = true; board.classList.add('is-pan'); } return; } if (!e.repeat && !st.blank) peekDown(); return; }
        if (endless() && (k === '-' || k === '_' || k === '=' || k === '+' || k === '0')) { e.preventDefault(); zoomBy(k === '0' ? 'all' : k === '-' || k === '_' ? 'out' : 'in'); }
      }
      document.addEventListener('keyup', function (e) {
        if (!st.open) return;
        if (e.key === ' ') { peekUp(); if (panKey) { panKey = false; board.classList.remove('is-pan'); } }
        var low = (e.key || '').toLowerCase();
        if (spring && low === spring.key) { var sp = spring; spring = null; if (Date.now() - sp.t > 280) setTool(sp.from); }
      });
      return {
        pen: I.pen,
        isOpen: function () { return st.open; },
        open: open, close: close, key: key,
        openBlank: function () { open('blank'); },
        openHere: function () { if (S.screen === 'teach') open('teach', S.teach.i); else if (S.screen === 'practise') open('practise', S.prOne >= 0 ? S.prOne : 0); }
      };
    })();


    /* CHECKLIST DATA (2026-10-16): the GCSE & 11+ topic checklist at /pages/maths-topic-checklist, grade by grade.
       [grade, blurb, [[strand, [[topic, in 11+ (1/0), "skill ids in the lab"]]]]]. Built by checklist-2026-10-16/gen_data.mjs. */
    var CL_DATA = [["1","The absolute starting point. Every topic at this level also appears in 11+ preparation.",[["number",[["Place value up to ten million",1,"place-value,reading-writing-numbers"],["Sort and order numbers",1,"comparing-ordering-numbers"],["Addition and subtraction",1],["12×12 times table fluency (25 questions in 90 seconds)",1,"times-tables"],["Short division with 2-digit numbers",1,"short-division"],["Factor pairs",1],["Use >, <, =",1],["Negative numbers (recognition and basic use)",1,"negative-numbers"],["Listing factors and multiples",1],["Writing, simplifying and ordering fractions",1,"equivalent-fractions"]]],["geometry",[["Right angles and full turns",1],["Acute, obtuse and reflex angles",1],["Recognise 2D and 3D shapes (up to decagon)",1],["Simple line symmetry",1],["Simple translation",1],["Perimeter (basic)",1],["Area of rectangles and squares",1],["Use 12 and 24-hour time",1],["Convert units of time",1],["Metric conversions",1]]],["statistics",[["Pictograms and tally charts",1],["Single-step word problems",1]]]]],["2","Decimals, fractions, shapes and basic data. Every topic at this level also appears in 11+ preparation.",[["number",[["Decimal place value",1],["Round to whole numbers, powers of 10 and decimals",1],["Long multiplication",1,"column-multiplication,grid-multiplication"],["Mental addition and subtraction methods (3-digit)",1],["Using a calculator",1],["Fractions of amounts",1,"fraction-of-amount"],["Recognise % as 'parts per hundred'",1],["Finding simple percentages (10%, 25%, 50% etc.)",1],["Simple FDP equivalents",1],["Money problems",1],["Know squares to 15² and cubes to 5³",1,"squares-cubes-roots"],["Multiplication tricks (using factors, nearest to)",1],["Truncation",0]]],["algebra",[["Order of operations (BIDMAS)",1],["Function machines",1],["Algebraic notation (reading and writing basic expressions)",1],["Collecting like terms",1],["Solving one-step equations",1,"solving-equations"],["Sum-product problems: find two numbers with a given sum and product",1],["Systematic listing strategies",1]]],["geometry",[["Properties of 2D and 3D shapes",1],["Identify and match nets of 3D shapes",1],["Angles at a point and on a straight line",1],["Line symmetry",1],["Translation on a coordinate grid",1],["Reflection in axes",1],["Rotation (basic)",1],["Coordinates in all four quadrants",1],["Perimeter of compound shapes",1],["Reading scales",1],["Area of triangles and parallelograms",1],["Radius and diameter of a circle",1]]],["statistics",[["Bar charts",1],["Pie charts (reading)",1],["Frequency polygons",1],["Stem and leaf",1],["Mean, median, mode and range",1],["Basic probability and probability scale",1]]]]],["3","Core 11+ curriculum. Fractions in full, key algebra and geometry. All Number, Algebra and Geometry topics here also appear in 11+.",[["number",[["Short division with decimal answers",1,"mult-div-decimals"],["Converting between fractions, decimals and percentages (FDP)",1],["Round to significant figures",1],["Order positive and negative integers and decimals",1],["All four operations with fractions",1,"add-sub-fractions,mult-div-fractions"],["Converting between mixed numbers and improper fractions",1,"improper-mixed"],["Increase and decrease by a fraction",1],["Finding any whole number percentage",1],["Estimating",1],["Error intervals",1],["Multiply and divide by 10, 100 and 1,000",1,"multiply-divide-by-10-100-1000"],["Square roots up to √225 and cube roots up to ∛125",1]]],["algebra",[["Substitution (basic)",1],["Solving equations (two-step and multi-step)",1,"solving-equations"],["Sequences: linear and geometric patterns (recognition)",1],["Drawing linear graphs",1,"plotting-linear"]]],["geometry",[["Draw and measure angles",1],["Find missing angles at a point, straight line and vertically opposite",1],["Rotational symmetry",1],["Rotations",1],["Reflections",1],["Enlargements",1],["Translations",1],["Area of trapezia",1],["Volume of prisms",1],["Identify 3D shapes",1],["Calculate time durations, timetables and elapsed time",1],["Coordinates: vertical and horizontal lines on graphs",1],["Area and circumference of circles",1],["Area of compound shapes",1]]],["statistics",[["Mean from frequency tables",0],["Time series graphs",1],["Sorting into sets (Venn diagrams: introduction)",1],["Compare distributions",0],["Frequency trees",0],["Two-way tables and reading data",1]]],["ratio",[["Proportion ingredients questions",1],["Writing and simplifying ratio",1],["Exchange rates",1],["Bills, change and best value",1],["Percentage increase and decrease",1],["Scale drawings and maps",1]]]]],["4","Introduces Pythagoras, sequences, probability, percentages and indices.",[["number",[["One amount as a percentage of another",1],["Multiples, factors and prime numbers",1],["Identify primes to 150",1],["LCM and HCF (including worded problems)",1],["Product of prime factors and prime factor trees",1],["Converting imperial units",1],["Understanding recurring decimals",1],["Reverse fractions of amounts",1]]],["algebra",[["Expanding brackets",0,"expanding-single-brackets"],["Factorisation (simple)",0],["Form expressions and solve 3-step equations",1],["Solve equations with unknowns on both sides",1,"solving-equations"],["Linear sequences (generate, recognise and nth term)",1,"linear-nth-term"],["Is a number in the sequence?",1],["Algebraic vocabulary",1],["Substitution in formulae",1],["Missing angles with algebra (form equations from angle facts)",1],["Solve inequalities and plot on a number line",0],["Real life and distance-time graphs",1]]],["geometry",[["Angles in polygons",1],["Angles in parallel lines",0],["Pythagorean theorem",0],["Plans and elevations",0],["Surface area of cuboids",1],["Volume and surface area of cylinders",0],["Bearings",0],["Loci and constructions",0],["Symmetry on coordinate grids",1],["Midpoints and patterns on graphs",1]]],["statistics",[["Averages from frequency tables",0],["Reverse mean",1],["Sample space diagrams",0],["Experimental probability and probability sum to one",0],["Calculate probabilities",1],["Pie charts (constructing)",0],["Two-set Venn diagrams",1],["Multi-step word problems",1]]],["ratio",[["Share in a given ratio",1],["Equivalent ratios and unitary ratios",1],["Part to part and part to whole",1],["Compound interest and depreciation",0],["Speed, distance and time",1],["Scale factors",1]]]]],["5","Simultaneous equations, trigonometry, quadratics and proportion.",[["number",[["Standard form (including converting to and from)",1,"standard-form"],["Multiply and divide in index form",0,"laws-of-indices"],["Calculate with numbers in standard form",0]]],["algebra",[["Rearrange formulae",0,"rearranging-formulae"],["Gradient and equation of a line",0,"gradient-equation-of-line"],["Equation of a line from two points",0],["Real-life and distance-time graphs",0],["Linear graphs",0],["Simultaneous equations (graphically and algebraically)",1,"simultaneous-equations"],["Expand two or more brackets",0,"expanding-double-brackets"],["Expanding and factorising quadratics",0,"factorising-quadratics"],["Solving quadratics",0,"solving-quadratics-factorising,equations-with-squares"],["Draw quadratic graphs",0],["Drawing other graphs: cubic and reciprocal",0]]],["geometry",[["Surface area and volume of prisms",0],["Surface area and volume of spheres and cones",0],["Sector areas and arc lengths",0],["Area and perimeter of composite shapes",0],["Trigonometry in right-angled triangles (SOHCAHTOA)",0],["Exact trigonometric values",0],["Identify parts of the circle: arc, sector and more",0],["Column vectors (basic)",0]]],["statistics",[["Estimated mean from grouped frequency tables",0],["Venn diagrams (including three-set)",1],["Multiple event probability",1],["Conditional probability",0],["Probability trees",0],["Mixed topic word problems",1]]],["ratio",[["Direct and inverse proportion (basic)",0],["Ratios, fractions and equations",0],["Writing a ratio as a fraction",0],["Reverse percentages",1],["Compound and repeated percentages",1],["Compound units (speed, density, pressure)",0],["Similar shapes (lengths)",0]]]]],["6","Surds, recurring decimals to fractions, circle theorems and quadratic sequences.",[["number",[["Recurring decimals to fractions",0,"recurring-decimals"],["Fractional and negative indices",0,"negative-fractional-indices"],["Capture-recapture",0],["Product rule for counting",0],["Estimate powers and roots",0]]],["algebra",[["Solve fractional equations",0],["Form and solve simultaneous equations (elimination and substitution)",0],["Expand triple brackets",0,"expanding-triple-brackets"],["Parallel and perpendicular lines",0],["Inequalities on graphs (regions)",0]]],["geometry",[["Surface area and volume of pyramids",0],["Fractional and negative enlargements",0],["Circle theorems",0],["Intersecting Chords Theorem",0],["Secants Theorem",0],["Invariance",0]]],["statistics",[["Cumulative frequency diagrams",0],["Box plots and quartiles",0],["Histograms",0],["Sampling",0]]],["ratio",[["Repeated percentage change",0],["Similar shapes (area and volume scale factors)",0]]]]],["7","Bounds, sine and cosine rules, trigonometric graphs and algebraic functions.",[["number",[["Upper and lower bounds",0],["Surds",0,"simplifying-surds,expanding-surd-brackets"]]],["algebra",[["Iteration",0],["Simplify and work with algebraic fractions",0,"simplifying-algebraic-fractions,mult-div-algebraic-fractions"],["Change the subject of more complex formulae",0],["Rearrange harder formulae",0],["Inverse and composite functions",0],["Functions – domain and range",0],["Factorise harder quadratics",0],["Quadratic formula",0,"quadratic-formula"],["Sketch graphs from key points",0],["Trigonometric and exponential graphs",0],["Geometric Sequences nth term",0],["Quadratic nth term",0,"quadratic-sequences"]]],["geometry",[["Sine rule",0],["Cosine rule",0],["Area of any triangle (sine formula)",0],["Pythagoras and trigonometry in 3D",0],["Calculations with vectors",0],["Vectors - modulus",0],["Congruent triangles",0]]],["statistics",[["Histograms (interpreting and drawing)",0]]],["ratio",[["Direct and inverse proportion (graphical and harder)",0],["Gradient as a rate of change",0],["Scale factors with length, area and volume",0]]]]],["8","Completing the square, quadratic formula, proof and graph transformations.",[["number",[["Rationalise surds",0,"rationalising"],["Equations involving fractional and negative indices",0]]],["algebra",[["Simultaneous equations with a quadratic",0,"simultaneous-nonlinear"],["Sketch quadratics (all key features)",0],["Gradient of a curve and gradient of a tangent",0],["Basic Differentiation",0],["Max and Min using Differentiation",0],["Optimisation using Differentiation",0],["Area under graphs",0],["Geometric proof",0],["Equation of Circle",0],["Solve equations with algebraic fractions",0,"algebraic-fraction-equations"]]],["geometry",[["Proof of circle theorems",0],["Tangents to circles",0],["Vectors (proof questions)",0]]],["ratio",[["Growth and decay",0]]]]],["9","The hardest GCSE content. Advanced proof, complex algebra and circle geometry.",[["algebra",[["Quadratic simultaneous equations",0],["Algebraic fractions (complex)",0,"add-sub-algebraic-fractions"],["Completing the square",0,"completing-the-square"],["Quadratic inequalities",0],["Algebraic proof",0,"algebraic-proof"],["Transformations of functions y = f(x)",0],["Velocity-time graphs",0],["Sum of N Terms in Arithmetic Sequence",0]]],["geometry",[["Full proofs of circle theorems",0],["Find equation of tangent to a circle",0],["Vectors (full proof questions)",0]]],["statistics",[["Probability equation questions",0],["Estimate median from a histogram",0]]]]]];
    /* ============================================================
       CHECKLIST (2026-10-16): the GCSE & 11+ topic checklist as a third
       library tab. View it by grade or by strand; the checklist itself (tick
       boxes, "secure" counts) switches off and leaves a plain map from topic to
       skill. A topic with a skill in the lab carries a chip; a chip picks the
       skill for the side panel (Teach, Practise, Board), or on a phone opens
       the skill screen. Ticks stay on this device: shlc_sl_checklist_v1.
       ============================================================ */
    var elCl = $('slChecklist');
    var CL_KEY = 'shlc_sl_checklist_v1';
    var CL_STRANDS = [
      ['number', 'Number', 'var(--t2)', 'Place value in Grade 1 through to surds and bounds in Grade 8.'],
      ['algebra', 'Algebra', 'var(--t4)', 'Notation and one-step equations in Grade 2 through to proof in Grade 9.'],
      ['geometry', 'Geometry & measures', 'var(--t3)', 'Angles and shapes in Grade 1 through to circle theorem proofs in Grade 9.'],
      ['statistics', 'Statistics', 'var(--t5)', 'Tally charts in Grade 1 through to histograms in Grade 9.'],
      ['ratio', 'Ratio & proportion', 'var(--t6)', 'Simplifying ratio in Grade 3 through to growth and decay in Grade 8.']
    ];
    var CL = (function () {
      var d = lsGet(CL_KEY, {}) || {};
      return {
        view: d.view === 'strand' ? 'strand' : 'grade', g: /^[1-9]$/.test(d.g) ? d.g : '1',
        strand: CL_STRANDS.some(function (s) { return s[0] === d.strand; }) ? d.strand : 'number',
        on: d.on !== false, lab: !!d.lab, sel: d.sel || '', ticks: (d.ticks && typeof d.ticks === 'object') ? d.ticks : {}
      };
    })();
    function clSave() { lsSet(CL_KEY, CL); }
    /* a skill opened from the checklist goes back to the checklist (Back, Esc, Change skill) */
    var clFrom = false;
    function libHome() { return clFrom ? 'checklist' : 'library'; }
    var CL_ALL = [];
    CL_DATA.forEach(function (G) {
      G[2].forEach(function (S2) {
        S2[1].forEach(function (T) {
          CL_ALL.push({ g: G[0], s: S2[0], t: T[0], e: !!T[1], key: G[0] + '|' + T[0], ids: String(T[2] || '').split(',').filter(function (id) { return id && SL.get(id); }) });
        });
      });
    });
    function clStrand(id) { return CL_STRANDS.filter(function (s) { return s[0] === id; })[0]; }
    function clTally(list) {
      var t = { n: list.length, done: 0, lab: 0 };
      list.forEach(function (x) { if (CL.ticks[x.key]) t.done++; if (x.ids.length) t.lab++; });
      return t;
    }
    function clCount(t) { return CL.on ? t.done + ' of ' + t.n + ' secure' : t.lab + ' of ' + t.n + ' in the lab'; }
    function clNow() { return CL_ALL.filter(function (x) { return CL.view === 'strand' ? x.s === CL.strand : x.g === CL.g; }); }
    function clNarrow() { try { return window.matchMedia('(max-width: 860px)').matches; } catch (e) { return false; } }

    function clRowHTML(x, no11) {
      var done = !!CL.ticks[x.key];
      var tick = CL.on ? '<button type="button" class="cl-tick' + (done ? ' is-on' : '') + '" role="checkbox" aria-checked="' + done + '" aria-label="Secure: ' + esc(x.t) + '" data-cltick="' + esc(x.key) + '">' + ICON.tick + '</button>' : '';
      /* the topic line IS the button for its skill (Aadam 2026-10-16: a chip under the
         topic said the same thing twice). A topic's other skills are in the side panel only. */
      var chip = function (id, cls, inner) {
        var sk = SL.get(id), c = colourOf(sk);
        return '<button type="button" class="' + cls + (x.ids.indexOf(CL.sel) >= 0 ? ' is-sel' : '') + '" data-clsk="' + id + '" style="--c:' + c.col + ';--ct:' + c.tint + '" aria-label="' + esc(sk.name) + '">' + skIcon(sk) + '<span>' + inner + '</span></button>';
      };
      var head = x.ids.length ? chip(x.ids[0], 'cl-tb', esc(x.t)) : '<span class="cl-t">' + esc(x.t) + '</span>';
      return '<li class="cl-row' + (done && CL.on ? ' is-done' : '') + (x.ids.length ? '' : ' is-none') + '">' +
        '<div class="cl-rt">' + tick + head + (x.e && !no11 ? '<span class="cl-11">11+</span>' : '') + '</div>' +
        '</li>';
    }
    function clGroupsHTML(now) {
      var keys = CL.view === 'strand' ? CL_DATA.map(function (G) { return G[0]; }) : CL_STRANDS.map(function (s) { return s[0]; });
      /* two columns read in order: the cards up to half the height on the left,
         the rest on the right (CSS columns would not split a card, so they
         stacked the long ones and left a column empty) */
      var cards = [], total = 0, run = 0, col = [[], []];
      keys.forEach(function (k) {
        var list = now.filter(function (x) { return CL.view === 'strand' ? x.g === k : x.s === k; });
        var shown = CL.lab ? list.filter(function (x) { return x.ids.length; }) : list;
        if (!shown.length) return;
        var w = 2 + shown.length + shown.filter(function (x) { return x.ids.length; }).length * .7;
        cards.push([w, clCardHTML(k, list, shown)]); total += w;
      });
      if (!cards.length) return '';
      cards.forEach(function (c, i) { col[i > 0 && run + c[0] / 2 > total / 2 ? 1 : 0].push(c[1]); if (!col[1].length) run += c[0]; });
      return '<div class="cl-col">' + col[0].join('') + '</div><div class="cl-col">' + col[1].join('') + '</div>';
    }
    function clCardHTML(k, list, shown) {
      /* every topic in the card in 11+: say so once in the header, not on each row */
      var all11 = shown.every(function (x) { return x.e; });
      var mark = CL.view === 'strand' ? '<span class="cl-gn num">' + k + '</span>' : '<span class="cl-dot" style="background:' + clStrand(k)[2] + '"></span>';
      return '<div class="cl-card"><div class="cl-ch">' + mark + '<h3>' + esc(CL.view === 'strand' ? 'Grade ' + k : clStrand(k)[1]) + '</h3>' + (all11 ? '<span class="cl-11" title="Every topic here is in 11+">11+</span>' : '') + '<span class="cl-cc">' + clCount(clTally(list)) + '</span></div>' +
        '<ul class="cl-list">' + shown.map(function (x) { return clRowHTML(x, all11); }).join('') + '</ul></div>';
    }
    function clTabsHTML() {
      var keys = CL.view === 'strand' ? CL_STRANDS.map(function (s) { return s[0]; }) : CL_DATA.map(function (G) { return G[0]; });
      return '<div class="cl-tabs" role="tablist" aria-label="' + (CL.view === 'strand' ? 'Strand' : 'Grade') + '">' + keys.map(function (k) {
        var on = CL.view === 'strand' ? CL.strand === k : CL.g === k;
        var t = clTally(CL_ALL.filter(function (x) { return CL.view === 'strand' ? x.s === k : x.g === k; }));
        var label = CL.view === 'strand' ? '<span class="cl-dot" style="background:' + clStrand(k)[2] + '"></span>' + esc(clStrand(k)[1]) : 'Grade ' + k;
        return '<button type="button" role="tab" class="cl-tab' + (on ? ' is-on' : '') + '" aria-selected="' + on + '" data-cltab="' + k + '"><b>' + label + '</b>' +
          (CL.on ? '<span class="cl-bar"><i style="width:' + Math.round(100 * t.done / t.n) + '%"></i></span>' : '') + '<span class="cl-tn">' + clCount(t) + '</span></button>';
      }).join('') + '</div>';
    }
    function clPanelHTML(now) {
      var sk = CL.sel && SL.get(CL.sel);
      if (!sk) return '<aside class="cl-panel is-empty"><p>Pick a skill under any topic to teach it, practise it or put it on the board.</p></aside>';
      var home = now.filter(function (x) { return x.ids.indexOf(sk.id) >= 0; })[0] || CL_ALL.filter(function (x) { return x.ids.indexOf(sk.id) >= 0; })[0];
      var lv = sk.levels || [];
      return '<aside class="cl-panel" aria-label="Chosen skill"><div class="cl-pk">' + skIcon(sk) + (home ? '<span class="cl-dot" style="background:' + clStrand(home.s)[2] + '"></span><span>' + esc(clStrand(home.s)[1]) + '</span>' : '') + '</div>' +
        '<h3 class="cl-pn">' + esc(sk.name) + '</h3>' +
        '<div class="cl-peg"><span class="sl-expr">' + oneEg(sk.eg) + '</span></div>' +
        (home ? '<p class="cl-pon">On the checklist as <b>' + esc(home.t) + '</b>, Grade ' + home.g + '</p>' : '') +
        (home && home.ids.length > 1 ? '<p class="cl-pon">Also for this topic: ' + home.ids.filter(function (id) { return id !== sk.id; }).map(function (id) { return '<button type="button" class="cl-also" data-clsk="' + id + '">' + esc(SL.get(id).name) + '</button>'; }).join(', ') + '</p>' : '') +
        '<div class="cl-pact"><button type="button" class="sl-btn sl-btn--cta" data-clgo="teach">' + ICON.steps + 'Teach</button>' +
        '<button type="button" class="sl-btn" data-clgo="practise">' + ICON.list + 'Practise</button>' +
        '<button type="button" class="sl-btn" data-clgo="board">' + ICON.board + 'Board</button></div>' +
        '<button type="button" class="sl-btn sl-btn--sm sl-btn--ghost cl-pmore" data-clgo="skill">Choose levels' + ICON.chevR + '</button>' +
        '<div class="cl-plh">' + lv.length + ' levels</div><ol class="cl-lv">' + lv.map(function (L, i) { return '<li><span class="num">' + (i + 1) + '</span>' + esc(L.name) + '</li>'; }).join('') + '</ol>' +
        (CL.on ? '<p class="cl-note">Ticks stay on this device.</p>' : '') + '</aside>';
    }
    function clHTML() {
      var now = clNow();
      /* the panel shows a skill from what is on screen: a pick from another grade or strand gives way */
      if (!CL.sel || !SL.get(CL.sel) || !now.some(function (x) { return x.ids.indexOf(CL.sel) >= 0; })) { var f = now.filter(function (x) { return x.ids.length; })[0]; CL.sel = f ? f.ids[0] : ''; }
      var t = clTally(now), st = CL.view === 'strand' ? clStrand(CL.strand) : null;
      var G = CL_DATA.filter(function (x) { return x[0] === CL.g; })[0];
      var seg = function (v, txt) { return '<button type="button" class="sl-seg' + (CL.view === v ? ' is-on' : '') + '" aria-pressed="' + (CL.view === v) + '" data-clview="' + v + '">' + txt + '</button>'; };
      var stat = function (n, w) { return '<div class="cl-stat"><b class="num">' + n + '</b><span>' + w + '</span></div>'; };
      return '<div class="sl-scroll cl-scroll"><div class="cl-wrap">' +
        '<div class="cl-head"><h2 class="cl-h">' + (CL.on ? 'Work through the checklist' : 'Skills by checklist topic') + '</h2>' +
          '<div class="cl-ctrls"><div class="sl-segwrap" role="group" aria-label="View" data-mo-group="clview">' + seg('grade', 'By grade') + seg('strand', 'By strand') + '</div>' +
          '<button type="button" class="cl-switch' + (CL.on ? ' is-on' : '') + '" role="switch" aria-checked="' + CL.on + '" data-cltoggle="on"><span class="cl-sw"><i></i></span>Checklist</button>' +
          '<button type="button" class="cl-switch cl-switch--box' + (CL.lab ? ' is-on' : '') + '" role="switch" aria-checked="' + CL.lab + '" data-cltoggle="lab"><span class="cl-box">' + ICON.tick + '</span>Only topics in the lab</button></div></div>' +
        clTabsHTML() +
        '<div class="cl-grid"><section class="cl-main">' +
          '<div class="cl-band"><div class="cl-bt"><h3>' + esc(st ? st[1] : 'Grade ' + CL.g) + '</h3><p>' + esc(st ? st[3] : G[1]) + '</p></div>' +
            '<div class="cl-stats">' + (CL.on ? stat(t.done, 'secure') : '') + stat(t.lab, 'in the lab') + stat(t.n, 'topics') + '</div></div>' +
          '<div class="cl-cols">' + (clGroupsHTML(now) || '<p class="cl-empty">No topic here has a skill in the lab yet.</p>') + '</div>' +
        '</section>' + clPanelHTML(now) + '</div>' +
      '</div></div>';
    }
    /* a tick, a chip or a switch repaints the whole screen: keep the reader where they were */
    function renderChecklist(keep) {
      var sc = elCl.querySelector('.sl-scroll'), top = keep && sc ? sc.scrollTop : 0;
      paint(elCl, clHTML());
      if (top) { sc = elCl.querySelector('.sl-scroll'); if (sc) sc.scrollTop = top; }
    }
    function clOpen(id, go) {
      var sk = SL.get(id); if (!sk) return;
      S.skill = sk.id; S.from = 'skills'; save();
      if (go === 'skill') { show('skill'); return; }
      location.hash = '#' + go + '/' + sk.id;
    }
    elCl.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null;
      if (!t) return;
      var v, keep = true;
      if ((v = t.getAttribute('data-clview'))) { CL.view = v; keep = false; }
      else if ((v = t.getAttribute('data-cltoggle'))) { CL[v] = !CL[v]; }
      else if ((v = t.getAttribute('data-cltab'))) { if (CL.view === 'strand') CL.strand = v; else CL.g = v; CL.sel = ''; keep = false; }
      else if ((v = t.getAttribute('data-cltick'))) { if (CL.ticks[v]) delete CL.ticks[v]; else CL.ticks[v] = 1; }
      else if ((v = t.getAttribute('data-clsk'))) { if (clNarrow()) { clSave(); clOpen(v, 'skill'); return; } CL.sel = v; }
      else if ((v = t.getAttribute('data-clgo'))) { clSave(); clOpen(CL.sel, v); return; }
      else return;
      clSave(); renderChecklist(keep);
    });

    applyTheme();
    fromHash();
    window.addEventListener('hashchange', fromHash);
    /* pushState and replaceState do not fire hashchange, so Back and Forward
       come through popstate instead */
    window.addEventListener('popstate', function () { if (!location.hash) { if (shell.classList.contains('is-on')) closeShell(); return; } fromHash(); });
    if (window.__SL_DEBUG) window.__sl = { S: S, SP: SP, spStart: spStart, spInput: spInput, spAnswer: spAnswer, buildSet: buildSet, buildBoard: buildBoard, show: show, openShell: openShell, closeShell: closeShell, mark: mark, setLevel: setLevel, setSel: setSel, selLevels: selLevels, skillLevel: skillLevel, teachGo: teachGo, withSkills: withSkills, lastPaint: function () { return lastPaint; } };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
